/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Base StructureDefinition for base64Binary Type: A stream of bytes */
  Base64Binary: { input: any; output: any };
  /** A date string, such as 1980-08-21 */
  Date: { input: any; output: any };
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: any; output: any };
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any };
  /** serialization of date time string */
  GraphQLDateTime: { input: any; output: any };
  /** A custom scalar representing a hex color code */
  HexColor: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164 */
  PhoneNumber: { input: any; output: any };
  /** A field whose value is a Semantic Version as specified:  https://semver.org`, */
  SemVer: { input: any; output: any };
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any };
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any };
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any };
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type AcceptOnboardingInviteInput = {
  invitationId: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  updatedInformation?: InputMaybe<CynergyProfileUpdateInput>;
};

export type AccessGroupBulkDeleteInput = {
  groups: Array<AccessGroupIdentifierInput>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccessGroupCreateInput = {
  /** What the group covers */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the group in the API */
  developerName?: InputMaybe<Scalars["String"]["input"]>;
  /** Email address for the group */
  email?: InputMaybe<Scalars["String"]["input"]>;
  members?: InputMaybe<Array<AccessGroupMemberInput>>;
  /** Human friendly label */
  name: Scalars["String"]["input"];
  /** Only Regular may be created — the remaining types are reserved */
  type: AccessGroupType;
};

export type AccessGroupDeleteInput = {
  groupId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccessGroupIdentifierInput = {
  groupId: Scalars["ID"]["input"];
};

export type AccessGroupMemberActionInput = {
  add?: InputMaybe<Array<AccessGroupMemberInput>>;
  remove?: InputMaybe<AccessGroupMemberBulkDeleteInput>;
};

export type AccessGroupMemberBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  members: Array<AccessGroupMemberIdentifierInput>;
};

export type AccessGroupMemberIdentifierInput = {
  memberId: Scalars["ID"]["input"];
};

export type AccessGroupMemberInput = {
  /** Account being added to the group */
  accountId: Scalars["ID"]["input"];
  /** Name of the account being added */
  name: Scalars["String"]["input"];
};

export type AccessGroupMemberManageInput = {
  action: AccessGroupMemberActionInput;
  groupId: Scalars["ID"]["input"];
};

export type AccessGroupMembers = {
  __typename?: "AccessGroupMembers";
  account_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  group: AccessGroups;
  group_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  member_id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AccessGroupPaginatedResults = {
  __typename?: "AccessGroupPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<AccessGroups>;
  totalPages: Scalars["Float"]["output"];
};

/** List of available access group types */
export enum AccessGroupType {
  Location = "LOCATION",
  Manager = "MANAGER",
  Organization = "ORGANIZATION",
  Regular = "REGULAR",
  Role = "ROLE",
}

export type AccessGroupUpdateInput = {
  /** What the group covers */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the group in the API */
  developerName?: InputMaybe<Scalars["String"]["input"]>;
  /** Email address for the group */
  email?: InputMaybe<Scalars["String"]["input"]>;
  groupId: Scalars["ID"]["input"];
  members?: InputMaybe<AccessGroupMemberActionInput>;
  /** Human friendly label */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccessGroups = {
  __typename?: "AccessGroups";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** What the group covers */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Name of the group in the API */
  developer_name?: Maybe<Scalars["String"]["output"]>;
  /** Email address for the group */
  email?: Maybe<Scalars["EmailAddress"]["output"]>;
  group_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  members?: Maybe<Array<AccessGroupMembers>>;
  /** Human friendly label */
  name: Scalars["String"]["output"];
  owner_account_id?: Maybe<Scalars["ID"]["output"]>;
  owner_organization?: Maybe<Organizations>;
  /** Organization the group belongs to */
  owner_organization_id?: Maybe<Scalars["ID"]["output"]>;
  related_id?: Maybe<Scalars["ID"]["output"]>;
  type: AccessGroupType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AccountBalanceSnapshots = {
  __typename?: "AccountBalanceSnapshots";
  /** Account target of snapshot */
  account: BillingAccounts;
  /** Outstanding balance */
  balance: Scalars["USCurrency"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  /** Date snapshot was ran */
  snapshot_date: Scalars["DateTime"]["output"];
  snapshot_id: Scalars["ID"]["output"];
  /** Total amount of unapplied payments on this account */
  unapplied_payment_amount?: Maybe<Scalars["USCurrency"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** The uniquely identifying registration method. (Must provide email OR phone #) */
export type AccountRegistrationMethodInput = {
  method: IdentityRegistrationMethods;
  value: Scalars["String"]["input"];
};

export type AccountVerification = AppLinkEntity & {
  __typename?: "AccountVerification";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  expires_at: Scalars["DateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  sent_at: Scalars["DateTime"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  validation_id: Scalars["String"]["output"];
};

/** All possible FHIR ActPriority codes. */
export enum ActPriority {
  /** As soon as possible, next highest priority after stat. */
  A = "A",
  /** Filler should contact the placer as soon as results are available, even for preliminary results. (Was "C" in HL7 version 2.3's reporting priority.) */
  Cr = "CR",
  /** Beneficial to the patient but not essential for survival. */
  El = "EL",
  /** An unforeseen combination of circumstances or the resulting state that calls for immediate action. */
  Em = "EM",
  /** Used to indicate that a service is to be performed prior to a scheduled surgery. When ordering a service and using the pre-op priority, a check is done to see the amount of time that must be allowed for performance of the service. When the order is placed, a message can be generated indicating the time needed for the service so that it is not ordered in conflict with a scheduled operation. */
  P = "P",
  /** An "as needed" order should be accompanied by a description of what constitutes a need. This description is represented by an observation service predicate as a precondition. */
  Prn = "PRN",
  /** Routine service, do at usual work hours. */
  R = "R",
  /** A report should be prepared and sent as quickly as possible. */
  Rr = "RR",
  /** With highest priority (e.g., emergency). */
  S = "S",
  /** It is critical to come as close as possible to the requested time (e.g., for a through antimicrobial level). */
  T = "T",
  /** Drug is to be used as directed by the prescriber. */
  Ud = "UD",
  /** Calls for prompt action. */
  Ur = "UR",
}

/** All possible FHIR action cardinality behavior codes. */
export enum ActionCardinalityBehavior {
  /** The action may be selected multiple times. */
  Multiple = "MULTIPLE",
  /** The action may only be selected one time. */
  Single = "SINGLE",
}

/** All possible FHIR action codes */
export enum ActionCode {
  /** The action indicates that information should be collected from a participant in the process. */
  CollectionInformation = "COLLECTION_INFORMATION",
  /** The action indicates that a particular service should be provided. */
  OrderService = "ORDER_SERVICE",
  /** The action indicates that a particular medication should be prescribed to the patient. */
  PrescribeMedication = "PRESCRIBE_MEDICATION",
  /** The action indicates that a particular diagnosis should be proposed. */
  ProposeDiagnosis = "PROPOSE_DIAGNOSIS",
  /** The action indicates that a particular immunization should be performed. */
  RecommendImmunization = "RECOMMEND_IMMUNIZATION",
  /** The action indicates that a particular detected issue should be recorded. */
  RecordDetectedIssue = "RECORD_DETECTED_ISSUE",
  /** The action indicates that a particular inference should be recorded. */
  RecordInference = "RECORD_INFERENCE",
  /** The action indicates that a particular flag should be reported. */
  ReportFlag = "REPORT_FLAG",
  /** The action indicates that a particular message should be sent to a participant in the process. */
  SendMessage = "SEND_MESSAGE",
}

/** All possible FHIR action condition kind codes. */
export enum ActionConditionKind {
  /** The condition describes whether or not a given action is applicable. */
  Applicability = "APPLICABILITY",
  /** The condition is a starting condition for the action. */
  Start = "START",
  /** The condition is a stop, or exit condition for the action. */
  Stop = "STOP",
}

/** All possible FHIR action grouping behavior codes. */
export enum ActionGroupingBehavior {
  /** A group with this behavior logically groups its sub-elements, and may be shown as a visual group to the end user, but it is not required to do so. */
  LogicalGroup = "LOGICAL_GROUP",
  /** A group of related alternative actions is a sentence group if the target referenced by the action is the same in all the actions and each action simply constitutes a different variation on how to specify the details for the target. For example, two actions that could be in a SentenceGroup are "aspirin, 500 mg, 2 times per day" and "aspirin, 300 mg, 3 times per day". In both cases, aspirin is the target referenced by the action, and the two actions represent different options for how aspirin might be ordered for the patient. Note that a SentenceGroup would almost always have an associated selection behavior of "AtMostOne", unless it's a required action, in which case, it would be "ExactlyOne". */
  SentenceGroup = "SENTENCE_GROUP",
  /** Any group marked with this behavior should be displayed as a visual group to the end user. */
  VisualGroup = "VISUAL_GROUP",
}

/** All possible FHIR action participant function codes. */
export enum ActionParticipantFunction {
  /** The participant is the author of the result of the action. */
  Author = "AUTHOR",
  /** The participant is the performer of the action. */
  Performer = "PERFORMER",
  /** The participant is reviewing the result of the action. */
  Reviewer = "REVIEWER",
  /** The participant is a witness to the action being performed. */
  Witness = "WITNESS",
}

/** All possible FHIR action precheck behavior codes */
export enum ActionPrecheckBehavior {
  /** An action with this behavior is one of the less frequent actions included by the end user, for the particular context in which the action occurs. The system displaying the actions to the end user would typically not "pre-check" such an action. */
  No = "NO",
  /** An action with this behavior is one of the most frequent action that is, or should be, included by an end user, for the particular context in which the action occurs. The system displaying the action to the end user should consider "pre-checking" such an action as a convenience for the user. */
  Yes = "YES",
}

/** All possible FHIR action reason codes. */
export enum ActionReasonCode {
  /** The action should be performed to address a detected care gap. */
  CareGap = "CARE_GAP",
  /** The action should be performed to address a detected potential drug-drug interaction. */
  DrugDrugInteraction = "DRUG_DRUG_INTERACTION",
  /** The action should be performed because the patient was determined to be off pathway. */
  OffPathway = "OFF_PATHWAY",
  /** The action should be performed to bring the patient's care in line with a quality measure. */
  QualityMeasure = "QUALITY_MEASURE",
  /** The action should be performed based on a particular risk assessment. */
  RiskAssessment = "RISK_ASSESSMENT",
}

/** All possible FHIR action relationship type codes. */
export enum ActionRelationshipType {
  /** The action must be performed after the related action. */
  After = "AFTER",
  /** The action must be performed after the end of the related action. */
  AfterEnd = "AFTER_END",
  /** The action must be performed after the start of the related action. */
  AfterStart = "AFTER_START",
  /** The action must be performed before the related action. */
  Before = "BEFORE",
  /** The action must be performed before the end of the related action. */
  BeforeEnd = "BEFORE_END",
  /** The action must be performed before the start of the related action. */
  BeforeStart = "BEFORE_START",
  /** The action must be performed concurrent with the related action. */
  Concurrent = "CONCURRENT",
  /** The action must be performed concurrent with the end of the related action. */
  ConcurrentWithEnd = "CONCURRENT_WITH_END",
  /** The action must be performed concurrent with the start of the related action. */
  ConcurrentWithStart = "CONCURRENT_WITH_START",
}

/** All possible FHIR action required behavior codes. */
export enum ActionRequiredBehavior {
  /** An action with this behavior may be included in the set of actions processed by the end user. */
  Could = "COULD",
  /** An action with this behavior must be included in the actions processed by the end user; the end user SHALL NOT choose not to include this action. */
  Must = "MUST",
  /** An action with this behavior must be included in the set of actions processed by the end user, unless the end user provides documentation as to why the action was not included. */
  MustUnlessDocumented = "MUST_UNLESS_DOCUMENTED",
}

/** All possible FHIR action selection behavior codes. */
export enum ActionSelectionBehavior {
  /** All the actions in the group must be selected as a single unit. */
  All = "ALL",
  /** All the actions in the group are meant to be chosen as a single unit: either all must be selected by the end user, or none may be selected. */
  AllOrNone = "ALL_OR_NONE",
  /** Any number of the actions in the group may be chosen, from zero to all. */
  Any = "ANY",
  /** The end user may choose zero or at most one of the actions in the group */
  AtMostOne = "AT_MOST_ONE",
  /** The end user must choose one and only one of the selectable actions in the group. The user SHALL NOT choose none of the actions in the group. */
  ExactlyOne = "EXACTLY_ONE",
  /** The end user must choose a minimum of one, and as many additional as desired. */
  OneOrMore = "ONE_OR_MORE",
}

/** All possible FHIR action type codes. */
export enum ActionType {
  /** The action is to create a new resource. */
  Create = "CREATE",
  /** The action is to fire a specific event. */
  FireEvent = "FIRE_EVENT",
  /** The action is to remove an existing resource. */
  Remove = "REMOVE",
  /** The action is to update an existing resource. */
  Update = "UPDATE",
}

export type ActiveIngredients = {
  __typename?: "ActiveIngredients";
  name: Scalars["String"]["output"];
  strength: Scalars["String"]["output"];
};

export type ActivityDefinitionCreateInput = {
  /** Determines if the activity should be performed on an as-needed basis */
  asNeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  description: Scalars["String"]["input"];
  /** True if the activity should not be performed */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When the activity definition is expected to be used */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** Is this activity experimental? (Not for real usage) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  intent?: InputMaybe<TaskIntent>;
  /** Intended jurisdiction for activity definition. */
  jurisdiction?: InputMaybe<Scalars["String"]["input"]>;
  /** A description of the kind of resource the activity definition is representing. For example, a MedicationRequest, a ServiceRequest, or a CommunicationRequest. */
  kind: RequestResourceType;
  /** Where it should happen */
  locationId: Scalars["ID"]["input"];
  /** Who's participating in action performance */
  participants?: InputMaybe<Array<ActivityDefinitionParticipantInput>>;
  priority?: InputMaybe<RequestPriority>;
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["input"];
  /** Why this activity definition is defined */
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  /** What requirements are needed to perform this action */
  requirements?: InputMaybe<ActivityDefinitionRequirementsInput>;
  status?: InputMaybe<PublicationStatus>;
  /** Subject of the activity being defined */
  subject: ParticipantResourceType;
  /** Subordinate title of the activity definition */
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  /** Human-friendly name */
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
  /** Describes the clinical usage of the activity definition */
  usage?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActivityDefinitionDeleteInput = {
  activityDefinitionId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ActivityDefinitionObservationInput = {
  observationDefinitionId: Scalars["ID"]["input"];
};

export type ActivityDefinitionParticipantInput = {
  function: ActionParticipantFunction;
  role: PractitionerRole;
  type: ParticipantResourceType;
};

export type ActivityDefinitionParticipants = {
  __typename?: "ActivityDefinitionParticipants";
  activity: ActivityDefinitions;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  function: ActionParticipantFunction;
  is_archived: Scalars["Boolean"]["output"];
  participant_id: Scalars["String"]["output"];
  role: PractitionerRole;
  type: ParticipantResourceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityDefinitionRequirementCreateInput = {
  activityDefinitionId: Scalars["ID"]["input"];
  requirements: ActivityDefinitionRequirementsInput;
};

export type ActivityDefinitionRequirementDeleteInput = {
  activityDefinitionId: Scalars["ID"]["input"];
  requirements: ActivityDefinitionRequirementsInput;
};

export type ActivityDefinitionRequirementsInput = {
  /** What observations must be produced by this action */
  observationResults?: InputMaybe<Array<ActivityDefinitionObservationInput>>;
  /** What observations are required to perform this action */
  observations?: InputMaybe<Array<ActivityDefinitionObservationInput>>;
  /** What specimens are required to perform this action */
  specimens?: InputMaybe<Array<ActivityDefinitionSpecimenInput>>;
};

export type ActivityDefinitionSpecimenInput = {
  specimenDefinitionId: Scalars["ID"]["input"];
};

export type ActivityDefinitionUpdateInput = {
  activityDefinitionId: Scalars["ID"]["input"];
  /** Determines if the activity should be performed on an as-needed basis */
  asNeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** True if the activity should not be performed */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When the activity definition is expected to be used */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** Is this activity experimental? (Not for real usage) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  intent?: InputMaybe<TaskIntent>;
  /** Intended jurisdiction for activity definition. */
  jurisdiction?: InputMaybe<Scalars["String"]["input"]>;
  /** A description of the kind of resource the activity definition is representing. For example, a MedicationRequest, a ServiceRequest, or a CommunicationRequest. */
  kind?: InputMaybe<RequestResourceType>;
  /** Computer-friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  priority?: InputMaybe<RequestPriority>;
  /** Name of the publisher/steward (organization or individual) */
  publisher?: InputMaybe<Scalars["String"]["input"]>;
  /** Why this activity definition is defined */
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  /** Subject of the activity being defined */
  subject?: InputMaybe<ParticipantResourceType>;
  /** Subordinate title of the activity definition */
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  /** Human-friendly name */
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  /** Describes the clinical usage of the activity definition */
  usage?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActivityDefinitions = {
  __typename?: "ActivityDefinitions";
  approval_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Determines if activity should be performed on an as-needed basis */
  as_needed: Scalars["Boolean"]["output"];
  /** Use and/or publishing restrictions */
  copyright?: Maybe<Scalars["String"]["output"]>;
  /** Copyright holder and year(s) */
  copyright_label?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  /** True if the activity should not be performed */
  do_not_perform: Scalars["Boolean"]["output"];
  /** When the activity definition is expected to be used */
  effective_period?: Maybe<Periods>;
  experimental: Scalars["Boolean"]["output"];
  intent?: Maybe<TaskIntent>;
  is_archived: Scalars["Boolean"]["output"];
  /** Intended jurisdiction for activity definition (if applicable) */
  jurisdiction?: Maybe<Scalars["String"]["output"]>;
  kind: RequestResourceType;
  last_reviewed?: Maybe<Scalars["DateTime"]["output"]>;
  location: Locations;
  location_id: Scalars["ID"]["output"];
  /** Name for this activity definition (computer friendly) */
  name: Scalars["String"]["output"];
  /** What observations are required to perform this action */
  observation_requirement?: Maybe<Array<ObservationDefinitions>>;
  /** What observations must be produced by this action */
  observation_result_requirement?: Maybe<Array<ObservationDefinitions>>;
  /** Who's participating in performing the action */
  participants: Array<ActivityDefinitionParticipants>;
  priority?: Maybe<RequestPriority>;
  /** History of definition through time */
  provenance?: Maybe<Array<Provenances>>;
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["output"];
  /** Why this activity definition is defined */
  purpose?: Maybe<Scalars["String"]["output"]>;
  /** What specimens are required to perform this action */
  specimen_requirement?: Maybe<Array<SpecimenDefinitions>>;
  status: PublicationStatus;
  subject_type: ParticipantResourceType;
  /** Subordinate title of the activity definition */
  subtitle?: Maybe<Scalars["String"]["output"]>;
  /** Name for this activity definition (human friendly) */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  /** Describes the clinical usage of the activity definition */
  usage?: Maybe<Scalars["String"]["output"]>;
  /** Business version of the plan definition. */
  version: Scalars["String"]["output"];
};

export type AddPatientMedicationInput = {
  carePlanID?: InputMaybe<Scalars["String"]["input"]>;
  criteriaResultID?: InputMaybe<Scalars["String"]["input"]>;
  medications: Array<MedicationCreateInput>;
  patientId: Scalars["String"]["input"];
};

export type AddToCollectionInput = {
  collection: UserCollectionIdentifier;
  entry: CollectionEntryInput;
};

/** All possible FHIR additional instruction codes. */
export enum AdditionalInstructions {
  ContainsAspirin = "CONTAINS_ASPIRIN",
  ContainsAspirinLikeMedicine = "CONTAINS_ASPIRIN_LIKE_MEDICINE",
  DissolveOrMixWithWaterBeforeTaking = "DISSOLVE_OR_MIX_WITH_WATER_BEFORE_TAKING",
  HalfToOneHourBeforeFood = "HALF_TO_ONE_HOUR_BEFORE_FOOD",
  MayCauseDrowsiness = "MAY_CAUSE_DROWSINESS",
  MayColorUrine = "MAY_COLOR_URINE",
  SuckedOrChewed = "SUCKED_OR_CHEWED",
  SwallowedWhole = "SWALLOWED_WHOLE",
  TakeAtRegularIntervals = "TAKE_AT_REGULAR_INTERVALS",
  Times = "TIMES",
  WithOrAfterFood = "WITH_OR_AFTER_FOOD",
  WithWater = "WITH_WATER",
}

export type AddressAutocompleteInput = {
  components?: InputMaybe<Scalars["String"]["input"]>;
  input: Scalars["String"]["input"];
  language?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  radius?: InputMaybe<Scalars["Float"]["input"]>;
  sessionToken?: InputMaybe<Scalars["String"]["input"]>;
  types?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AddressCreateInput = {
  addressLines: Array<AddressLineInput>;
  city: Scalars["String"]["input"];
  coordinates?: InputMaybe<PositionInput>;
  cynergyId: Scalars["String"]["input"];
  district?: InputMaybe<Scalars["String"]["input"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  postalCode: Scalars["String"]["input"];
  room?: InputMaybe<Scalars["String"]["input"]>;
  state: UsStates;
  type: AddressType;
  use: AddressUse;
};

export type AddressInput = {
  addressLines: Array<AddressLineInput>;
  city: Scalars["String"]["input"];
  coordinates?: InputMaybe<PositionInput>;
  district?: InputMaybe<Scalars["String"]["input"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  postalCode: Scalars["String"]["input"];
  room?: InputMaybe<Scalars["String"]["input"]>;
  state: UsStates;
  type: AddressType;
  use: AddressUse;
};

export type AddressLineInput = {
  /** Street name, number, direction & P.O. Box etc. */
  addressLine: Scalars["String"]["input"];
  /** The order in which lines should appear in the address. */
  order?: InputMaybe<Scalars["Float"]["input"]>;
};

export type AddressLineUpdateInput = {
  /** Street name, number, direction & P.O. Box etc. */
  addressLine?: InputMaybe<Scalars["String"]["input"]>;
  /** Existing line_id when updating a known line. Omit to upsert: `updateAddressLinesTransaction` treats entries without a lineId as new lines and bulk-creates them, so a single `addressLines` array can mix updates and creates (e.g. update order=1, create order=2). */
  lineId?: InputMaybe<Scalars["String"]["input"]>;
  /** The order in which lines should appear in the address. */
  order?: InputMaybe<Scalars["Float"]["input"]>;
};

export type AddressLines = {
  __typename?: "AddressLines";
  address: Addresses;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Street name, number, direction & P.O. Box etc. */
  line: Scalars["String"]["output"];
  line_id: Scalars["String"]["output"];
  /** The order in which lines should appear in an address label */
  order: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Address type codes. */
export enum AddressType {
  Both = "BOTH",
  Physical = "PHYSICAL",
  Postal = "POSTAL",
}

export type AddressUpdateInput = {
  addressId: Scalars["String"]["input"];
  addressLines?: InputMaybe<Array<AddressLineUpdateInput>>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  coordinate_id?: InputMaybe<Scalars["String"]["input"]>;
  coordinates?: InputMaybe<CoordinateInput>;
  district?: InputMaybe<Scalars["String"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  room?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<UsStates>;
  type?: InputMaybe<AddressType>;
  use?: InputMaybe<AddressUse>;
};

/** All possible FHIR Address use codes. */
export enum AddressUse {
  Billing = "BILLING",
  Home = "HOME",
  Old = "OLD",
  Temp = "TEMP",
  Work = "WORK",
}

export type Addresses = {
  __typename?: "Addresses";
  address_id: Scalars["ID"]["output"];
  city: Scalars["String"]["output"];
  coordinates: Coordinates;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** User this address belongs to */
  cynergy_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Human friendly address as it should be displayed to the user. */
  display: Scalars["String"]["output"];
  district?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Address lines representing: street name, number, direction, P.O. Box, etc. */
  lines: Array<AddressLines>;
  /** Human friendly name for the address. Ex:  New Home, Old Home */
  nickname?: Maybe<Scalars["String"]["output"]>;
  postal_code?: Maybe<Scalars["String"]["output"]>;
  /** Room # or name for the location of the patient. */
  room?: Maybe<Scalars["String"]["output"]>;
  state: UsStates;
  /** Distinguishes between physical addresses (those you can visit) and mailing addresses (e.g. PO Boxes and care-of addresses). Most addresses are both. */
  type: AddressType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** The purpose of this address. */
  use: AddressUse;
  user: CynergyUsers;
};

export type AdminChanges = ChangesEntity & {
  __typename?: "AdminChanges";
  admin_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR administration method codes. */
export enum AdministrationMethods {
  Administer = "ADMINISTER",
  Apply = "APPLY",
  Bathe = "BATHE",
  Chew = "CHEW",
  Gargle = "GARGLE",
  Implant = "IMPLANT",
  Infuse = "INFUSE",
  Inhale = "INHALE",
  Inject = "INJECT",
  Insert = "INSERT",
  Instill = "INSTILL",
  Insufflate = "INSUFFLATE",
  Orodisperse = "ORODISPERSE",
  Rinse = "RINSE",
  RinseOrWash = "RINSE_OR_WASH",
  Spray = "SPRAY",
  Suck = "SUCK",
  Swallow = "SWALLOW",
}

/** All possible drug administration FHIR route codes. */
export enum AdministrationRouteCodes {
  IntraArticular = "INTRA_ARTICULAR",
  Oral = "ORAL",
  Otic = "OTIC",
  PerVagina = "PER_VAGINA",
  Topical = "TOPICAL",
}

/** All possible administrative gender fhir codes */
export enum AdministrativeGender {
  Female = "FEMALE",
  Male = "MALE",
  Other = "OTHER",
  Unknown = "UNKNOWN",
}

export type Admins = AdminsEntity & {
  __typename?: "Admins";
  admin_id: Scalars["String"]["output"];
  changes?: Maybe<Array<AdminChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  first_login: Scalars["String"]["output"];
  first_name: Scalars["String"]["output"];
  isReissued?: Maybe<Scalars["Boolean"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  last_name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  reissueToken?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
  username?: Maybe<Scalars["String"]["output"]>;
  validated: Scalars["String"]["output"];
  validated_on?: Maybe<Scalars["String"]["output"]>;
};

export type AdminsEntity = {
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  first_login: Scalars["String"]["output"];
  first_name: Scalars["String"]["output"];
  isReissued?: Maybe<Scalars["Boolean"]["output"]>;
  last_name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  reissueToken?: Maybe<Scalars["String"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  username?: Maybe<Scalars["String"]["output"]>;
  validated: Scalars["String"]["output"];
  validated_on?: Maybe<Scalars["String"]["output"]>;
};

export type AffiliationContactActionInput = {
  add?: InputMaybe<Array<AffiliationContactInput>>;
  remove?: InputMaybe<AffiliationContactBulkDeleteInput>;
  update?: InputMaybe<ContactDetailsUpdateInput>;
};

export type AffiliationContactBulkDeleteInput = {
  affiliationId: Scalars["ID"]["input"];
  contacts: Array<AffiliationContactIdentifier>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AffiliationContactIdentifier = {
  contactDetailId: Scalars["ID"]["input"];
};

export type AffiliationContactInput = {
  contact: ContactDetailsCreateInput;
};

export type AffiliationCreateInput = {
  affiliateOrganizationId: Scalars["ID"]["input"];
  /** Official contact details at the participating organization relevant to this affiliation */
  contacts?: InputMaybe<Array<AffiliationContactInput>>;
  /** Business identifiers that are specific to this role */
  identifiers?: InputMaybe<Array<AffiliationIdentifierInput>>;
  /** Default: true */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The location(s) at which the role occurs */
  locations?: InputMaybe<Array<AffiliationLocationInput>>;
  /** The network in which the participatingOrganization provides the role's services (if defined) at the indicated locations (if defined) */
  network?: InputMaybe<Array<AffiliationNetworkInput>>;
  organizationId: Scalars["ID"]["input"];
  /** The period during which the participating organization is affiliated with the primary organization */
  period?: InputMaybe<PeriodCreateInput>;
  /** Role of participating organization */
  role: OrganizationRoles;
  /** Healthcare services provided through the role */
  services?: InputMaybe<Array<AffiliationServiceInput>>;
  /** Specific speciality of the participating organization in the context of the role */
  speciality?: InputMaybe<CodeableConceptCreateInput>;
};

export type AffiliationDeleteInput = {
  affiliationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AffiliationIdentifier = {
  identifierId: Scalars["ID"]["input"];
};

export type AffiliationIdentifierActionInput = {
  add?: InputMaybe<Array<AffiliationIdentifierInput>>;
  remove?: InputMaybe<AffiliationIdentifierBulkDeleteInput>;
  update?: InputMaybe<IdentifierUpdateInput>;
};

export type AffiliationIdentifierBulkDeleteInput = {
  affiliationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  identifiers: Array<AffiliationIdentifier>;
};

export type AffiliationIdentifierInput = {
  identifier: IdentifierCreateInput;
};

export type AffiliationLocationActionInput = {
  add?: InputMaybe<Array<AffiliationLocationInput>>;
  remove?: InputMaybe<AffiliationLocationBulkDeleteInput>;
};

export type AffiliationLocationBulkDeleteInput = {
  affiliationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  locations: Array<AffiliationLocationInput>;
};

export type AffiliationLocationInput = {
  locationId: Scalars["ID"]["input"];
};

export type AffiliationNetworkActionInput = {
  add?: InputMaybe<Array<AffiliationNetworkInput>>;
  remove?: InputMaybe<AffiliationNetworkBulkDeleteInput>;
};

export type AffiliationNetworkBulkDeleteInput = {
  affiliationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizations: Array<AffiliationNetworkInput>;
};

export type AffiliationNetworkInput = {
  organizationId: Scalars["ID"]["input"];
};

export type AffiliationServiceActionInput = {
  add?: InputMaybe<Array<AffiliationServiceInput>>;
  remove?: InputMaybe<AffiliationServiceBulkDeleteInput>;
};

export type AffiliationServiceBulkDeleteInput = {
  affiliationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  services: Array<AffiliationServiceInput>;
};

export type AffiliationServiceInput = {
  serviceId: Scalars["ID"]["input"];
};

export type AffiliationUpdateInput = {
  affiliationId: Scalars["ID"]["input"];
  contacts?: InputMaybe<AffiliationContactActionInput>;
  identifiers?: InputMaybe<AffiliationIdentifierActionInput>;
  /** Default: true */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  locations?: InputMaybe<AffiliationLocationActionInput>;
  network?: InputMaybe<AffiliationNetworkActionInput>;
  /** The period during which the participating organization is affiliated with the primary organization */
  period?: InputMaybe<PeriodCreateInput>;
  /** Role of participating organization */
  role?: InputMaybe<OrganizationRoles>;
  services?: InputMaybe<AffiliationServiceActionInput>;
  /** Specific speciality of the participating organization in the context of the role */
  speciality?: InputMaybe<CodeableConceptCreateInput>;
};

export type AgentAlternatives = {
  __typename?: "AgentAlternatives";
  agent: Agents;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  gene: Genotypes;
  is_archived: Scalars["Boolean"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  /** Where available but not in the US */
  nus: Scalars["Boolean"]["output"];
  suitability: AntibioticSuitabilityRating;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AgentClassResistance = {
  __typename?: "AgentClassResistance";
  class_resistance_id: Scalars["String"]["output"];
  classification: AgentClassifications;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Agents that are exceptions to the resistance. */
  exceptions?: Maybe<Array<Agents>>;
  genotype: Genotypes;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AgentClassifications = {
  __typename?: "AgentClassifications";
  agents: Array<Agents>;
  classification_number: Scalars["Float"]["output"];
  code: AntibioticClassificationCodes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  /** Genotypes which are resistant to this antibiotic classification. */
  resistance?: Maybe<Array<AgentClassResistance>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Agents = {
  __typename?: "Agents";
  agent_id: Scalars["String"]["output"];
  classification: AgentClassifications;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  fda_product_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  /** Genotypes resistant to the antibiotic. */
  resistance?: Maybe<Array<Genotypes>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AlertPreferences = {
  __typename?: "AlertPreferences";
  alert_type: NotificationTypes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Indicates if alerts/notifications can be delivered via alert type method. */
  enabled: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Enumerable values representing alert priorities. */
export enum AlertPriority {
  High = "HIGH",
  Low = "LOW",
  Max = "MAX",
  Normal = "NORMAL",
}

export type AlertTypes = {
  __typename?: "AlertTypes";
  alert_type_id: Scalars["String"]["output"];
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user_alert_settings?: Maybe<Array<UserAlertSettings>>;
};

export type AllowedDaysRule = {
  __typename?: "AllowedDaysRule";
  days: Array<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export type AnnotationCreateInput = {
  authorUserId: Scalars["String"]["input"];
  /** The annotation (text content) */
  text: Scalars["String"]["input"];
};

export type AnnotationUpdateInput = {
  annotationId: Scalars["String"]["input"];
  authorUserId: Scalars["String"]["input"];
  /** The annotation (text content) */
  text: Scalars["String"]["input"];
};

export type Annotations = {
  __typename?: "Annotations";
  annotation_id: Scalars["String"]["output"];
  author: Users;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The annotation - text content (as markdown) */
  text: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user_id: Scalars["String"]["output"];
};

export type AnswerOptionsUpdateInput = {
  answerOptionID: Scalars["String"]["input"];
  booleanOption?: InputMaybe<Scalars["Boolean"]["input"]>;
  codingOption?: InputMaybe<Scalars["String"]["input"]>;
  dateOption?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Minio url path */
  icon?: InputMaybe<Scalars["String"]["input"]>;
  integerOption?: InputMaybe<Scalars["Float"]["input"]>;
  /** Whether option is selected by default */
  isInitiallySelected?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Text display for this option */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** True if option is part of question that allows multiple answers */
  multiOption?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The order in which to display this option. */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  rangeOption?: InputMaybe<RangeCreateInput>;
  stringOption?: InputMaybe<Scalars["String"]["input"]>;
  timeOption?: InputMaybe<Scalars["String"]["input"]>;
};

/** The classification code of an antibiotic */
export enum AntibioticClassificationCodes {
  Aminoglycosides = "Aminoglycosides",
  Carbapenems = "Carbapenems",
  Cephalosporins = "Cephalosporins",
  Fluroquinolones = "Fluroquinolones",
  Glycopeptides = "Glycopeptides",
  Lincosamides = "Lincosamides",
  Lipoglycopeptides = "Lipoglycopeptides",
  Macrolides = "Macrolides",
  Monobactams = "Monobactams",
  Other = "Other",
  Oxazolidinones = "Oxazolidinones",
  Penicillins = "Penicillins",
  Pleuromutilins = "Pleuromutilins",
  Polymyxins = "Polymyxins",
  Quinolones = "Quinolones",
  Sulfonamides = "Sulfonamides",
  Tetracyclines = "Tetracyclines",
}

/** The suitability rating of an antibiotic for a given pathogens gene resistance profile */
export enum AntibioticSuitabilityRating {
  /** Agent is a potential alternative agent (active in vitro, possesses class activity comparable to known effective agents or a therapeutically interchangeable agents and hence likely to be clinically effective, but second line due to overly broad spectrum, toxicity, limited clinical experience, or paucity of direct evidence of effectiveness). */
  Active = "ACTIVE",
  /** Agent is a poor alternative to other agents because resistance to likely to be present or occur, due to poor drug penetration to site of infection or an unfavorable toxicity profile, or there is insufficient clinical data to support effectiveness. */
  NotRecommended = "NOT_RECOMMENDED",
  /** Agent is a first line therapy: reliably active in vitro, clinically effective, guideline recommended, recommended as a first-line agent or acceptable alternative agent in the Sanford Guide */
  Recommended = "RECOMMENDED",
  Unknown = "UNKNOWN",
  /** Variable activity such that the agent, although clinically effective in some settings or types of infections is not reliably effective in others, or should be used in combination with another agent, and/or its efficacy is limited by resistance which has been associated with treatment failure. */
  Variable = "VARIABLE",
}

/** All Application API actions. */
export enum AppActions {
  Create = "Create",
  Delete = "Delete",
  Read = "Read",
  Restore = "Restore",
  Update = "Update",
}

export type AppLinkEntity = {
  cynergy_id: Scalars["String"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  sent_at: Scalars["DateTime"]["output"];
};

/** Complete list of all roles available within the application. */
export enum ApplicationRoles {
  Admin = "ADMIN",
  AdmissionsClerk = "ADMISSIONS_CLERK",
  BillingSpecialist = "BILLING_SPECIALIST",
  ClinicalNurseSpecialist = "CLINICAL_NURSE_SPECIALIST",
  Dentist = "DENTIST",
  GeneralPractitioner = "GENERAL_PRACTITIONER",
  LabTechnician = "LAB_TECHNICIAN",
  MedicalAssistant = "MEDICAL_ASSISTANT",
  MedicalRecordsClerk = "MEDICAL_RECORDS_CLERK",
  NurseAnesthetist = "NURSE_ANESTHETIST",
  NursePractitioner = "NURSE_PRACTITIONER",
  NursingAssistant = "NURSING_ASSISTANT",
  OccupationalTherapist = "OCCUPATIONAL_THERAPIST",
  Patient = "PATIENT",
  PatientServiceCoordinator = "PATIENT_SERVICE_COORDINATOR",
  Pharmacist = "PHARMACIST",
  Phlebotomist = "PHLEBOTOMIST",
  Physician = "PHYSICIAN",
  PhysicianAssistant = "PHYSICIAN_ASSISTANT",
  Psychiatrist = "PSYCHIATRIST",
  Receptionist = "RECEPTIONIST",
  RegisteredNurse = "REGISTERED_NURSE",
  Supervisor = "SUPERVISOR",
  Surgeon = "SURGEON",
  User = "USER",
}

export type AppointmentAvailabilityHorizon = {
  end: Scalars["DateTime"]["input"];
  start: Scalars["DateTime"]["input"];
};

export type AppointmentBasedOnInput = {
  carePlanId?: InputMaybe<Scalars["ID"]["input"]>;
  deviceRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  serviceRequestId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AppointmentBookResult = {
  __typename?: "AppointmentBookResult";
  appointment: Appointments;
  /** True only if this call moved the appointment from Proposed to Booked. */
  transitioned: Scalars["Boolean"]["output"];
};

export type AppointmentCancelInput = {
  appointmentId: Scalars["ID"]["input"];
  /** Reason for appointment being cancelled */
  cancellationReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Set when this cancellation is a client-side cleanup of a booking-fee checkout the patient never confirmed, instead of a patient-initiated cancellation */
  cancellationReasonCode?: InputMaybe<AppointmentUnconfirmedCheckoutCancellationCode>;
};

export type AppointmentCounterProposalActionInput = {
  add?: InputMaybe<AppointmentCounterProposalInput>;
  remove?: InputMaybe<AppointmentCounterProposalDeleteInput>;
  update?: InputMaybe<AppointmentCounterProposalUpdateInput>;
};

export type AppointmentCounterProposalDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  proposalId: Scalars["ID"]["input"];
};

export type AppointmentCounterProposalInput = {
  appointmentId: Scalars["ID"]["input"];
  participantId: Scalars["ID"]["input"];
  /** Proposed end time */
  proposedEndTime: Scalars["GraphQLDateTime"]["input"];
  /** Proposed start time */
  proposedStartTime: Scalars["GraphQLDateTime"]["input"];
  /** Reason for proposed change */
  reason: Scalars["String"]["input"];
};

export type AppointmentCounterProposalReplies = {
  __typename?: "AppointmentCounterProposalReplies";
  /** Reply comment */
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  participant: AppointmentParticipants;
  /** Reason for status */
  reason?: Maybe<Scalars["String"]["output"]>;
  reply_id: Scalars["ID"]["output"];
  responds_to: AppointmentCounterProposals;
  status: AppointmentCounterProposalReplyStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AppointmentCounterProposalReplyActionInput = {
  add?: InputMaybe<Array<AppointmentCounterProposalReplyInput>>;
  remove?: InputMaybe<AppointmentCounterProposalReplyDeleteInput>;
  update?: InputMaybe<AppointmentCounterProposalReplyUpdateInput>;
};

export type AppointmentCounterProposalReplyDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  replyId: Scalars["ID"]["input"];
};

export type AppointmentCounterProposalReplyInput = {
  /** Reply comment */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  participantId: Scalars["ID"]["input"];
  /** Reason for status */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  status: AppointmentCounterProposalReplyStatus;
};

/** Appointment counter proposal reply status */
export enum AppointmentCounterProposalReplyStatus {
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  NeedsAction = "NEEDS_ACTION",
}

export type AppointmentCounterProposalReplyUpdateInput = {
  /** Reply comment */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Reason for status */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  replyId: Scalars["ID"]["input"];
  status?: InputMaybe<AppointmentCounterProposalReplyStatus>;
};

/** Appointment counter proposal status codes */
export enum AppointmentCounterProposalStatus {
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Declined = "DECLINED",
  Proposed = "PROPOSED",
}

export type AppointmentCounterProposalUpdateInput = {
  proposalId: Scalars["ID"]["input"];
  /** Reason for proposed change */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  replies?: InputMaybe<AppointmentCounterProposalReplyActionInput>;
};

export type AppointmentCounterProposals = {
  __typename?: "AppointmentCounterProposals";
  appointment: Appointments;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** The accompanying appointment response requesting proposed changes */
  from: AppointmentResponses;
  is_archived: Scalars["Boolean"]["output"];
  proposal_id: Scalars["ID"]["output"];
  /** Who made the proposal */
  proposed_by: AppointmentParticipants;
  /** Proposed end time */
  proposed_end: Scalars["GraphQLDateTime"]["output"];
  /** Proposed start time */
  proposed_start: Scalars["GraphQLDateTime"]["output"];
  /** Reason for proposed change */
  reason: Scalars["String"]["output"];
  /** Replies to proposed changes */
  replies?: Maybe<Array<AppointmentCounterProposalReplies>>;
  status: AppointmentCounterProposalStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AppointmentCreateInput = {
  basedOn?: InputMaybe<AppointmentBasedOnInput>;
  /** The brief description of the appointment as would be shown on a subject line. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  locationId: Scalars["ID"]["input"];
  /** Reference to the order this appointment acts on */
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Participants involved in the appointment */
  participants?: InputMaybe<Array<AppointmentParticipantInput>>;
  patientId: Scalars["ID"]["input"];
  /** Detailed information and instructions for patient */
  patientInstruction?: InputMaybe<CodeableReferenceCreateInput>;
  /** Priority of the appointment */
  priority?: InputMaybe<ActPriority>;
  /** Reason this appointment is scheduled */
  reason?: InputMaybe<CodeableReferenceCreateInput>;
  /** Link the existing recurrence series this appointment belongs to or, setup new recurring schedule */
  recurrence?: InputMaybe<AppointmentRecurrenceSeriesLinkOrCreate>;
  /** Appointment replaced by this one */
  replacedAppointmentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The actual services to be performed on this appointment */
  serviceTypes: Array<AppointmentServiceTypeInput>;
  slotId: Scalars["ID"]["input"];
  /** The speciality of a practitioner that would be required to perform the service requested in the appointment */
  specialityRequirements?: InputMaybe<Array<Scalars["String"]["input"]>>;
  status?: InputMaybe<AppointmentStatus>;
  /** Short phrase describing the appointment. (E.g. "Specimen Collection") */
  subject?: InputMaybe<Scalars["String"]["input"]>;
  /** The style of appointment or patient that has been booked in the slot */
  type?: InputMaybe<AppointmentType>;
};

/** Code option for appointment instance type */
export enum AppointmentInstanceTypeCode {
  NotRecurring = "NOT_RECURRING",
  RecurringException = "RECURRING_EXCEPTION",
  RecurringFutureException = "RECURRING_FUTURE_EXCEPTION",
  RecurringInstance = "RECURRING_INSTANCE",
  RecurringOrigin = "RECURRING_ORIGIN",
}

export type AppointmentPaginatedResults = {
  __typename?: "AppointmentPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Appointments>;
  totalPages: Scalars["Float"]["output"];
};

export type AppointmentParticipant = {
  /** Participating actor in the appointment (Union) */
  actor?: InputMaybe<AppointmentParticipantActorsInput>;
  /** Role of participant in the appointment */
  role?: InputMaybe<ParticipantType>;
};

export type AppointmentParticipantActionInput = {
  add?: InputMaybe<Array<AppointmentParticipantInput>>;
  remove?: InputMaybe<AppointmentParticipantDeleteInput>;
  update?: InputMaybe<AppointmentParticipantUpdateInput>;
};

export type AppointmentParticipantActorsInput = {
  careTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  healthcareServiceId?: InputMaybe<Scalars["ID"]["input"]>;
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
  practitionerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AppointmentParticipantDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  participants: Array<ParticipantIdentifier>;
};

export type AppointmentParticipantInput = {
  /** MUST specify at least a role or an actor */
  participant: AppointmentParticipant;
  /** Participant is required to attend? (Default: false) */
  participationRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AppointmentParticipantManageInput = {
  action: AppointmentParticipantActionInput;
  appointmentId: Scalars["ID"]["input"];
};

export type AppointmentParticipantUpdateInput = {
  /** The participating actor/role in the appointment. */
  participant?: InputMaybe<AppointmentParticipant>;
  participantId: Scalars["ID"]["input"];
  /** Participant is required to attend? (Default: false) */
  participationRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AppointmentParticipants = {
  __typename?: "AppointmentParticipants";
  actor_care_team_id?: Maybe<Scalars["ID"]["output"]>;
  actor_cynergy_id?: Maybe<Scalars["ID"]["output"]>;
  actor_device_id?: Maybe<Scalars["ID"]["output"]>;
  actor_group_id?: Maybe<Scalars["ID"]["output"]>;
  actor_location_id?: Maybe<Scalars["ID"]["output"]>;
  actor_patient_id?: Maybe<Scalars["ID"]["output"]>;
  actor_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  actor_service_id?: Maybe<Scalars["ID"]["output"]>;
  appointment: Appointments;
  /** Changes to appointment proposed by this participant */
  counter_proposals?: Maybe<AppointmentCounterProposals>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  participant_id: Scalars["ID"]["output"];
  /** Participant is required to attend */
  required: Scalars["Boolean"]["output"];
  /** Participation response for indicated appointment */
  responses?: Maybe<Array<AppointmentResponses>>;
  status: ParticipationStatus;
  /** Role of participant in the appointment */
  type?: Maybe<ParticipantType>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Code options for appointment recurrence exception type */
export enum AppointmentRecurrenceExceptionType {
  Cancelled = "CANCELLED",
  Deleted = "DELETED",
  Excluded = "EXCLUDED",
}

export type AppointmentRecurrenceExceptions = {
  __typename?: "AppointmentRecurrenceExceptions";
  /** Comment about this exception */
  comment: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  exception_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Appointment response exception derives from */
  reason: AppointmentResponses;
  /** Indicates the type of recurrence exception */
  type: AppointmentRecurrenceExceptionType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AppointmentRecurrenceSeries = {
  __typename?: "AppointmentRecurrenceSeries";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  entries: Array<AppointmentRecurrences>;
  /** List of recurrence exceptions in the series (cancelled, rescheduled, etc) */
  exceptions?: Maybe<Array<AppointmentRecurrenceExceptions>>;
  /** Is recurring series active? */
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Originating appointment in a recurring set of appointments */
  originator: Appointments;
  patient_id: Scalars["ID"]["output"];
  pattern: RecurrencePatterns;
  series_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AppointmentRecurrenceSeriesCreateInput = {
  originatingAppointmentId: Scalars["ID"]["input"];
  patientId: Scalars["ID"]["input"];
  recurrencePattern: RecurrencePatternCreateInput;
};

export type AppointmentRecurrenceSeriesLinkOrCreate = {
  /** Setup appointment recurrence */
  recurrence?: InputMaybe<RecurrencePatternCreateInput>;
  /** Existing appointment recurrence series */
  seriesId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AppointmentRecurrences = {
  __typename?: "AppointmentRecurrences";
  appointment?: Maybe<Appointments>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Reason the occurrence deviated from defined recurrence pattern. */
  deviation_reason?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Indicates that this occurrence deviates from the recurring pattern. */
  pattern_deviation: Scalars["Boolean"]["output"];
  recurrence_id: Scalars["ID"]["output"];
  /** The sequence number in the recurrence */
  sequence: Scalars["Float"]["output"];
  /** Recurrence series this occurrence is sequenced in */
  series: AppointmentRecurrenceSeries;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AppointmentRescheduleInput = {
  appointmentId: Scalars["ID"]["input"];
  locationId: Scalars["ID"]["input"];
  /** The actual services to be performed on this appointment */
  serviceTypes: Array<AppointmentServiceTypeInput>;
  slotId: Scalars["ID"]["input"];
};

export type AppointmentResourceAvailability = {
  locationId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type AppointmentResponseActionInput = {
  add?: InputMaybe<Array<AppointmentResponseInput>>;
  remove?: InputMaybe<AppointmentResponseDeleteInput>;
  update?: InputMaybe<AppointmentResponseUpdateInput>;
};

export type AppointmentResponseDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  responses: Array<AppointmentResponseIdentifier>;
};

export type AppointmentResponseIdentifier = {
  responseId: Scalars["ID"]["input"];
};

export type AppointmentResponseInput = {
  /** Comment about the response */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Proposed change to appointment */
  counterProposal?: InputMaybe<AppointmentCounterProposalInput>;
  participantId: Scalars["ID"]["input"];
  /** Recurrence response information. (If applicable) */
  recurrence?: InputMaybe<AppointmentResponseRecurrenceInput>;
  status: AppointmentResponseStatus;
  /** Reason for response status */
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
};

export type AppointmentResponseManageInput = {
  action: AppointmentResponseActionInput;
  appointmentId: Scalars["ID"]["input"];
};

export type AppointmentResponseRecurrenceInput = {
  /** Indicates that this response applies to all recurring appointments requested */
  allOccurrences: Scalars["Boolean"]["input"];
  /** Specific date within a recurrence this response is for */
  occurrenceDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** This specific recurrence this response is for */
  recurrenceId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** All fhir appointment response status codes. */
export enum AppointmentResponseStatus {
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  EnteredInError = "ENTERED_IN_ERROR",
  NeedsAction = "NEEDS_ACTION",
  Tentative = "TENTATIVE",
}

export type AppointmentResponseUpdateInput = {
  /** Comment about the response */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  counterProposal?: InputMaybe<AppointmentCounterProposalActionInput>;
  /** Recurrence response information. (If applicable) */
  recurrence?: InputMaybe<AppointmentResponseRecurrenceInput>;
  responseId: Scalars["ID"]["input"];
  status?: InputMaybe<AppointmentResponseStatus>;
  /** Reason for response status */
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
};

export type AppointmentResponses = {
  __typename?: "AppointmentResponses";
  appointment: Appointments;
  /** Additional comments */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** Proposed changes to appointment time requested by this response */
  counter_proposals?: Maybe<Array<AppointmentCounterProposals>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Response to a specific date within a recurring request */
  occurrence_date?: Maybe<Scalars["DateTime"]["output"]>;
  participant: AppointmentParticipants;
  /** Indicator for a counter proposal */
  proposed_new_time: Scalars["Boolean"]["output"];
  /** The recurrence of the specific recurring request */
  recurrence?: Maybe<AppointmentRecurrences>;
  /** Indicates that this response applies to all recurring appointments requested */
  recurring: Scalars["Boolean"]["output"];
  response_id: Scalars["ID"]["output"];
  /** Status of the response by the participant */
  status: AppointmentResponseStatus;
  /** Reason for status */
  status_reason?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AppointmentSeriesPaginatedResults = {
  __typename?: "AppointmentSeriesPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<AppointmentRecurrenceSeries>;
  totalPages: Scalars["Float"]["output"];
};

export type AppointmentServiceTypeActionInput = {
  add?: InputMaybe<Array<AppointmentServiceTypeInput>>;
  remove?: InputMaybe<Array<AppointmentServiceTypeDeleteInput>>;
};

export type AppointmentServiceTypeDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceTypeId: Scalars["ID"]["input"];
};

export type AppointmentServiceTypeInput = {
  healthcareServiceId: Scalars["ID"]["input"];
};

export type AppointmentServiceTypes = {
  __typename?: "AppointmentServiceTypes";
  appointment: Appointments;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Service name */
  name: Scalars["String"]["output"];
  service: HealthcareServices;
  service_id: Scalars["ID"]["output"];
  type_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible appointment statuses */
export enum AppointmentStatus {
  Arrived = "ARRIVED",
  Booked = "BOOKED",
  Cancelled = "CANCELLED",
  CheckedIn = "CHECKED_IN",
  EnteredInError = "ENTERED_IN_ERROR",
  Fulfilled = "FULFILLED",
  NoShow = "NO_SHOW",
  Proposed = "PROPOSED",
  Waitlist = "WAITLIST",
}

/** All possible appointment types */
export enum AppointmentType {
  /** A routine check-up, such as an annual physical */
  Checkup = "CHECKUP",
  /** Emergency appointment */
  Emergency = "EMERGENCY",
  /** A follow up visit from a previous appointment */
  Followup = "FOLLOWUP",
  /** Routine appointment - default if not valued */
  Routine = "ROUTINE",
  /** A previously unscheduled walk-in visit */
  WalkIn = "WALK_IN",
}

/** Reason a client cancelled a booking-fee checkout the patient never confirmed */
export enum AppointmentUnconfirmedCheckoutCancellationCode {
  /** The checkout WebView was explicitly closed */
  CheckoutAbandoned = "CHECKOUT_ABANDONED",
  /** The app was killed and a background cleanup found the appointment orphaned on next launch */
  CheckoutInterrupted = "CHECKOUT_INTERRUPTED",
}

export type AppointmentUpdateInput = {
  appointmentId: Scalars["ID"]["input"];
  basedOn?: InputMaybe<AppointmentBasedOnInput>;
  /** The brief description of the appointment as would be shown on a subject line. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference to the order this appointment acts on */
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Participants involved in the appointment */
  participants?: InputMaybe<AppointmentParticipantManageInput>;
  /** Detailed information and instructions for patient */
  patientInstruction?: InputMaybe<CodeableReferenceUpsertInput>;
  /** Priority of the appointment */
  priority?: InputMaybe<ActPriority>;
  /** Reason this appointment is scheduled */
  reason?: InputMaybe<CodeableReferenceUpsertInput>;
  /** Appointment replaced by this one */
  replacedAppointmentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Participant responses to this appointment */
  responses?: InputMaybe<AppointmentResponseManageInput>;
  /** Service type actions for this appointment (e.g. services to add or remove when updating) */
  serviceTypesAction?: InputMaybe<AppointmentServiceTypeActionInput>;
  /** The speciality of a practitioner that would be required to perform the service requested in the appointment */
  specialityRequirements?: InputMaybe<Array<Scalars["String"]["input"]>>;
  status?: InputMaybe<AppointmentStatus>;
  /** Short phrase describing the appointment. (E.g. "Specimen Collection") */
  subject?: InputMaybe<Scalars["String"]["input"]>;
  /** The style of appointment or patient that has been booked in the slot */
  type?: InputMaybe<AppointmentType>;
};

export type Appointments = {
  __typename?: "Appointments";
  appointment_id: Scalars["ID"]["output"];
  based_on_care_plan_id?: Maybe<Scalars["ID"]["output"]>;
  based_on_device_request_id?: Maybe<Scalars["ID"]["output"]>;
  based_on_service_request_id?: Maybe<Scalars["ID"]["output"]>;
  /** Reason for appointment being cancelled */
  cancellation_reason?: Maybe<Scalars["String"]["output"]>;
  /** Date/time the appointment was cancelled */
  cancelled_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Broad categorization of the service that is to be performed during this appointment */
  category: ServiceRequestCategory;
  channel_id?: Maybe<Scalars["ID"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** The brief description of the appointment as would be shown on a subject line in a meeting request, or appointment list. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Estimated time to complete appointment */
  estimated_duration?: Maybe<Durations>;
  /** External ids for this appointment */
  identifiers?: Maybe<Array<Identifiers>>;
  /** Type of recurrence for this instance */
  instance_type: AppointmentInstanceTypeCode;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  location_id: Scalars["ID"]["output"];
  /** Notes about the appointment */
  notes?: Maybe<Array<Annotations>>;
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars["ID"]["output"]>;
  /** Participants involved in appointment */
  participants?: Maybe<Array<AppointmentParticipants>>;
  patient: Patients;
  patient_id: Scalars["ID"]["output"];
  /** Detailed information and instructions for the patient */
  patient_instruction?: Maybe<CodeableReferences>;
  patient_name: Scalars["String"]["output"];
  /** Priority of the appointment */
  priority: ActPriority;
  /** Proposed changes to appointment start/end time */
  proposed_changes?: Maybe<Array<AppointmentCounterProposals>>;
  /** Reason this appointment is scheduled */
  reason?: Maybe<CodeableReferences>;
  /** Recurrence information for this appointment */
  recurrence?: Maybe<AppointmentRecurrences>;
  /** Appointment replaced by this one. */
  replaces?: Maybe<Appointments>;
  responses?: Maybe<Array<AppointmentResponses>>;
  /** When appointment is to conclude */
  scheduled_end?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** When appointment is to take place */
  scheduled_start?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** The service(s) performed during this appointment */
  service_types: Array<AppointmentServiceTypes>;
  /** Slot this appointment is filling */
  slot?: Maybe<Slots>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment */
  speciality?: Maybe<Array<Scalars["String"]["output"]>>;
  status: AppointmentStatus;
  /** Short phrase describing the appointment. */
  subject?: Maybe<Scalars["String"]["output"]>;
  /** Appointment title */
  title: Scalars["String"]["output"];
  /** The style of appointment or patient that has been booked in the slot */
  type: AppointmentType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AssignLocation = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  routeLocationId: Scalars["String"]["input"];
};

export type AssignLocationInput = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  routeAssignmentId: Scalars["String"]["input"];
  routeLocationId: Scalars["String"]["input"];
};

export type AssignLocationsBulkInput = {
  assignLocations: Array<AssignLocation>;
  routeAssignmentId: Scalars["String"]["input"];
};

export type AssignPatientRoomInput = {
  /** Should be true if the patient would like portal access. */
  patientId: Scalars["ID"]["input"];
  room: Scalars["String"]["input"];
};

export type AssignedWaypoints = {
  __typename?: "AssignedWaypoints";
  assigned_waypoint_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  incomingLeg?: Maybe<RouteLegs>;
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  outgoingLeg?: Maybe<RouteLegs>;
  routeAssignment: RouteAssignments;
  routeLocation: RouteLocations;
  /** Specifies the sequence in which the staff must complete the legs. A lower value indicates an earlier stop, ensuring an optimized and structured route. */
  sequence: Scalars["Float"]["output"];
  status: VisitState;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AssignmentLocationType = {
  __typename?: "AssignmentLocationType";
  alias: Scalars["String"]["output"];
};

export type AssignmentType = {
  __typename?: "AssignmentType";
  assignment_id: Scalars["String"]["output"];
  location?: Maybe<AssignmentLocationType>;
  location_id: Scalars["String"]["output"];
  organization_id: Scalars["String"]["output"];
};

export type AttachmentCreateInput = {
  /** Data inline, base64ed */
  base64?: InputMaybe<Scalars["Base64Binary"]["input"]>;
  /** Mime type of the content */
  contentType: MimeTypes;
  /** Length in seconds (audio/video) */
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  /** Number of frames if > 1 (photo) */
  frames?: InputMaybe<Scalars["Float"]["input"]>;
  hash?: InputMaybe<Scalars["String"]["input"]>;
  /** In pixels */
  height?: InputMaybe<Scalars["Float"]["input"]>;
  /** Human language of content */
  language?: InputMaybe<Scalars["String"]["input"]>;
  pages?: InputMaybe<Scalars["Float"]["input"]>;
  /** In bytes */
  size?: InputMaybe<Scalars["Float"]["input"]>;
  /** Attachment label */
  title: Scalars["String"]["input"];
  /** Uri where the data can be found */
  url?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
  /** In pixels */
  width?: InputMaybe<Scalars["Float"]["input"]>;
};

export type AttachmentLinkOrCreateInput = {
  attachment?: InputMaybe<AttachmentCreateInput>;
  attachmentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AttachmentUpdateInput = {
  attachmentId: Scalars["ID"]["input"];
  /** Data inline, base64ed */
  base64?: InputMaybe<Scalars["Base64Binary"]["input"]>;
  /** Mime type of the content */
  contentType?: InputMaybe<MimeTypes>;
  /** Length in seconds (audio/video) */
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  /** Number of frames if > 1 (photo) */
  frames?: InputMaybe<Scalars["Float"]["input"]>;
  hash?: InputMaybe<Scalars["String"]["input"]>;
  /** In pixels */
  height?: InputMaybe<Scalars["Float"]["input"]>;
  /** Human language of content */
  language?: InputMaybe<Scalars["String"]["input"]>;
  pages?: InputMaybe<Scalars["Float"]["input"]>;
  /** In bytes */
  size?: InputMaybe<Scalars["Float"]["input"]>;
  /** Attachment label */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Uri where the data can be found */
  url?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
  /** In pixels */
  width?: InputMaybe<Scalars["Float"]["input"]>;
};

export type AttachmentUpsertInput = {
  attachmentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Data inline, base64ed */
  base64?: InputMaybe<Scalars["Base64Binary"]["input"]>;
  /** Mime type of the content */
  contentType?: InputMaybe<MimeTypes>;
  /** Length in seconds (audio/video) */
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  /** Number of frames if > 1 (photo) */
  frames?: InputMaybe<Scalars["Float"]["input"]>;
  hash?: InputMaybe<Scalars["String"]["input"]>;
  /** In pixels */
  height?: InputMaybe<Scalars["Float"]["input"]>;
  /** Human language of content */
  language?: InputMaybe<Scalars["String"]["input"]>;
  pages?: InputMaybe<Scalars["Float"]["input"]>;
  /** In bytes */
  size?: InputMaybe<Scalars["Float"]["input"]>;
  /** Attachment label */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Uri where the data can be found */
  url?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
  /** In pixels */
  width?: InputMaybe<Scalars["Float"]["input"]>;
};

export type Attachments = {
  __typename?: "Attachments";
  attachment_id: Scalars["String"]["output"];
  /** Mime type of the content */
  content_type: MimeTypes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Data inline, base64ed */
  data?: Maybe<Scalars["Base64Binary"]["output"]>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Length in seconds (audio / video) */
  duration?: Maybe<Scalars["Float"]["output"]>;
  /** Number of frames if > 1 (photo) */
  frames?: Maybe<Scalars["Float"]["output"]>;
  /** Hash of the data (sha-1, base64ed) */
  hash?: Maybe<Scalars["String"]["output"]>;
  /** Height of the image in pixels (photo/video) */
  height?: Maybe<Scalars["Float"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human language of the content */
  language: Scalars["String"]["output"];
  /** Number of printed pages. */
  pages?: Maybe<Scalars["Float"]["output"]>;
  /** Number of bytes of content (if url provided) */
  size?: Maybe<Scalars["Float"]["output"]>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Uri where the data can be found. */
  url?: Maybe<Scalars["String"]["output"]>;
  /** Width of the image in pixels (photo/video) */
  width?: Maybe<Scalars["Float"]["output"]>;
};

export type AttributeCreateInput = {
  attribute: Scalars["String"]["input"];
  /** Restrict updates to attribute? */
  isLocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Human friendly name */
  name: Scalars["String"]["input"];
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** Specifies data type of attribute values. */
  valueDataType?: InputMaybe<SearchParamType>;
  values?: InputMaybe<Array<AttributeValueInput>>;
};

export type AttributeDeleteInput = {
  attributes: Array<AttributeIdentifier>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AttributeIdentifier = {
  attributeId: Scalars["ID"]["input"];
};

export type AttributeLinkOrCreateInput = {
  attribute?: InputMaybe<AttributeCreateInput>;
  attributeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AttributeUpdateInput = {
  attribute?: InputMaybe<Scalars["String"]["input"]>;
  attributeId: Scalars["ID"]["input"];
  /** Restrict updates to attribute? */
  isLocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Bypass lock (if present) */
  lockOverride?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Human friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** Specifies data type of attribute values. */
  valueDataType?: InputMaybe<SearchParamType>;
  values?: InputMaybe<AttributeValueActionInput>;
};

export type AttributeValueActionInput = {
  add?: InputMaybe<Array<AttributeValueInput>>;
  remove?: InputMaybe<AttributeValueDeleteInput>;
  update?: InputMaybe<AttributeValueUpdateInput>;
};

export type AttributeValueDeleteInput = {
  attributeId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  values: Array<AttributeValueIdentifier>;
};

export type AttributeValueIdentifier = {
  valueId: Scalars["ID"]["input"];
};

export type AttributeValueInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  value: Scalars["String"]["input"];
};

export type AttributeValueUpdateInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
  valueId: Scalars["ID"]["input"];
};

export type AttributeValues = {
  __typename?: "AttributeValues";
  attribute: Attributes;
  color?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
  value_id: Scalars["ID"]["output"];
};

export type Attributes = {
  __typename?: "Attributes";
  attribute: Scalars["String"]["output"];
  attribute_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly name */
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  values?: Maybe<Array<AttributeValues>>;
};

/** List of authentication protocol types */
export enum AuthenticationProtocolType {
  Awssv4 = "AWSSV4",
  Custom = "CUSTOM",
  Jwt = "JWT",
  JwtExchange = "JWT_EXCHANGE",
  None = "None",
  Oauth = "OAUTH",
  Password = "PASSWORD",
}

export type AvailableTest = {
  __typename?: "AvailableTest";
  category?: Maybe<Scalars["String"]["output"]>;
  interpretation_history_latest_first?: Maybe<Array<ObservationInterpretation>>;
  last_result_date?: Maybe<Scalars["DateTime"]["output"]>;
  test_code: Scalars["String"]["output"];
  test_name: Scalars["String"]["output"];
};

export type AvailableTestsPaginatedResults = {
  __typename?: "AvailableTestsPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<AvailableTest>;
  totalPages: Scalars["Float"]["output"];
};

/** List of bank account types */
export enum BankAccountTypes {
  Checking = "Checking",
  Savings = "Savings",
}

export type BaseAnswerOptionsInput = {
  /** For items that have a defined set of allowed answers (via answerOption), indicates whether values other than those specified can be selected. */
  answerConstraint: QuestionnaireAnswerConstraint;
  options: Array<QuestionnaireAnswerOptionsInput>;
};

export type BaseEnableWhenInput = {
  answer: QuestionnaireEnableWhenAnswers;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  disabledDisplay?: InputMaybe<QuestionnaireDisabledDisplay>;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  enableBehavior: QuestionnaireEnableBehavior;
  linkId?: InputMaybe<Scalars["String"]["input"]>;
  operator: QuestionnaireEnableOperator;
};

export type BasicSearch = {
  booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  columnName: Scalars["String"]["input"];
  numberValues?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  stringValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Patient bill responsibility keys */
export enum BillToTypes {
  Guarantor = "GUARANTOR",
  Insurance = "INSURANCE",
  Other = "OTHER",
  Self = "SELF",
}

export type BillingAccountCreateInput = {
  accountHolderName: Scalars["String"]["input"];
};

/** List of billings accounts flags */
export enum BillingAccountFlags {
  Delinquent = "DELINQUENT",
  Dispute = "DISPUTE",
  Fraudulent = "FRAUDULENT",
  HighRisk = "HIGH_RISK",
  Suspicious = "SUSPICIOUS",
}

export type BillingAccountPaginatedResults = {
  __typename?: "BillingAccountPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<BillingAccounts>;
  totalPages: Scalars["Float"]["output"];
};

/** List of billing account standing status codes */
export enum BillingAccountStanding {
  Balance = "BALANCE",
  Current = "CURRENT",
  Overdue = "OVERDUE",
}

/** List of billing account status codes */
export enum BillingAccountStatus {
  Closed = "CLOSED",
  Collections = "COLLECTIONS",
  Open = "OPEN",
  Pending = "PENDING",
  Restricted = "RESTRICTED",
  Suspended = "SUSPENDED",
  UnderReview = "UNDER_REVIEW",
}

export type BillingAccountUpdateInput = {
  accountHolderName?: InputMaybe<Scalars["String"]["input"]>;
  accountId: Scalars["ID"]["input"];
};

export type BillingAccounts = {
  __typename?: "BillingAccounts";
  account_id: Scalars["ID"]["output"];
  account_number: Scalars["String"]["output"];
  /** Account balance */
  balance: Scalars["USCurrency"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Reference to the user account */
  cynergy_account_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  flags?: Maybe<Array<BillingAccountFlags>>;
  /** Account invoices */
  invoices?: Maybe<Array<Invoices>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name of account holder */
  name: Scalars["String"]["output"];
  owner: CynergyAccounts;
  /** Accounts saved payment methods */
  payment_methods?: Maybe<Array<SavedPaymentMethods>>;
  /** Account payments */
  payments?: Maybe<Array<Payments>>;
  /** AR sub-ledger entries for this account */
  receivable_ledger_entries?: Maybe<Array<ReceivableLedgerEntries>>;
  /** Account refunds */
  refunds?: Maybe<Array<Refunds>>;
  /** Account snapshots */
  snapshots?: Maybe<Array<AccountBalanceSnapshots>>;
  /** Accounts financial standing */
  standing: BillingAccountStanding;
  status: BillingAccountStatus;
  /** Stripe customer id billed for this account (e.g. cus_…). Null until the account has been registered with the Stripe gateway. */
  stripe_customer_id?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type BillingAddressDetailsType = {
  addressLine1: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  formattedAddress?: InputMaybe<Scalars["String"]["input"]>;
  state: Scalars["String"]["input"];
  zip: Scalars["String"]["input"];
};

export type BillingAddressType = {
  address: BillingAddressDetailsType;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

/** List of patient blood types */
export enum BloodTypes {
  AbMinus = "AB_MINUS",
  AbPlus = "AB_PLUS",
  AMinus = "A_MINUS",
  APlus = "A_PLUS",
  BMinus = "B_MINUS",
  BPlus = "B_PLUS",
  OMinus = "O_MINUS",
  OPlus = "O_PLUS",
}

export type BookingConfirmations = AppLinkEntity & {
  __typename?: "BookingConfirmations";
  confirmation_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  sent_at: Scalars["DateTime"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Bucket = {
  __typename?: "Bucket";
  files: Array<BucketItem>;
  folder: Scalars["String"]["output"];
};

export type BucketItem = {
  __typename?: "BucketItem";
  etag?: Maybe<Scalars["String"]["output"]>;
  lastModified?: Maybe<Scalars["DateTime"]["output"]>;
  metadata?: Maybe<BucketMetaData>;
  name?: Maybe<Scalars["String"]["output"]>;
  prefix?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<Scalars["Float"]["output"]>;
};

export type BucketMetaData = {
  __typename?: "BucketMetaData";
  Fileextension?: Maybe<Scalars["String"]["output"]>;
  Filename?: Maybe<Scalars["String"]["output"]>;
  Folder?: Maybe<Scalars["String"]["output"]>;
  Isstarred?: Maybe<Scalars["Boolean"]["output"]>;
  Istrashed?: Maybe<Scalars["Boolean"]["output"]>;
  Label?: Maybe<Scalars["String"]["output"]>;
  Lastaccessed?: Maybe<Scalars["String"]["output"]>;
};

export type BulkOrderResultsDateRangeInput = {
  /** Inclusive upper bound on Order.fulfilled_at */
  end: Scalars["GraphQLDateTime"]["input"];
  /** Inclusive lower bound on Order.fulfilled_at */
  start: Scalars["GraphQLDateTime"]["input"];
};

export type BulkOrderResultsExportInput = {
  /** At least one filter is required. */
  filters: BulkOrderResultsFiltersInput;
};

export type BulkOrderResultsFiltersInput = {
  dateRange?: InputMaybe<BulkOrderResultsDateRangeInput>;
  /** Limit to these patients (Order.patient_id). */
  patientIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BulkRegisterLocationPatientsError = {
  __typename?: "BulkRegisterLocationPatientsError";
  message: Scalars["String"]["output"];
  patientId?: Maybe<Scalars["String"]["output"]>;
};

export type BulkRegisterLocationPatientsInput = {
  /** JSON file. Body must be an array of patient records. Required per record: FirstName, LastName, DOB, PatientID. Optional: Prefix/MiddleName/Suffix, Gender, Address/City/State/Zip (all four needed to store an address), RoomNumber/Unit, an "Allergies" array of substance names, "Diagnoses" and "AdmittingDiagnoses" arrays of { Code, Description, OnsetDate, Rank, Classification }, and an "insurance" array of { "Insurance Plan Name", "Insurance Priority", "Policy #", "Relationship" }. Blank strings are treated as absent. */
  file: Scalars["Upload"]["input"];
  locationId: Scalars["String"]["input"];
};

export type BulkRegisterLocationPatientsResult = {
  __typename?: "BulkRegisterLocationPatientsResult";
  /** Allergies written across all rows. Excludes allergens a patient already had on file. */
  allergiesRecorded: Scalars["Float"]["output"];
  /** Patients newly registered (did not exist before). */
  created: Scalars["Float"]["output"];
  /** ICD-10 diagnoses written as conditions across all rows. Excludes codes a patient already carried. */
  diagnosesRecorded: Scalars["Float"]["output"];
  errors: Array<BulkRegisterLocationPatientsError>;
  /** Patients that already existed and were linked to the location. */
  linked: Scalars["Float"]["output"];
  /** Rows skipped (invalid input, or already associated with the location). */
  skipped: Scalars["Float"]["output"];
};

export type BulkRouteLocationInput = {
  items: Array<RouteLocationInput>;
};

/** All possible event types for calendar */
export enum CalendarEventTypes {
  Appointments = "APPOINTMENTS",
  Business = "BUSINESS",
  Etc = "ETC",
  Personal = "PERSONAL",
}

export type CardPaymentDetails = {
  cardNumber: Scalars["String"]["input"];
  cvv: Scalars["String"]["input"];
  /** Two-digit expiration month */
  expiryMonth: Scalars["String"]["input"];
  /** Four-digit expiration year */
  expiryYear: Scalars["String"]["input"];
};

/** All possible FHIR group type codes */
export enum CareGroupTypes {
  /** Group contains "animal" Patient resources */
  Animal = "ANIMAL",
  /** Group contains CareTeam resources. */
  CareTeam = "CARE_TEAM",
  /** Group container Device resources. */
  Device = "DEVICE",
  /** Group contains HealthcareService resources */
  HealthcareService = "HEALTHCARE_SERVICE",
  /** Group contains Location resources. */
  Location = "LOCATION",
  /** Group contains Organization resources. */
  Organization = "ORGANIZATION",
  /** Group contains "person" Patient resources */
  Person = "PERSON",
  /** Group contains healthcare practitioner resources (Practitioner or PractitionerRoles) */
  Practitioner = "PRACTITIONER",
  /** Group contains RelatedPerson resources. */
  RelatedPerson = "RELATED_PERSON",
  /** Group contains Specimen Resources */
  Specimen = "SPECIMEN",
}

export type CarePeriodInput = {
  end: Scalars["DateTime"]["input"];
  start: Scalars["DateTime"]["input"];
};

export type CarePlanChanges = ChangesEntity & {
  __typename?: "CarePlanChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  plan: CarePlans;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CarePlanCreateInput = {
  /** Type of plan */
  category: Scalars["String"]["input"];
  /** Summary of the nature of the plan. */
  description: Scalars["String"]["input"];
  /** Concluding diagnosis icd10 code. */
  diagnosisCode?: InputMaybe<Scalars["String"]["input"]>;
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  intent?: InputMaybe<ServiceIntentStatus>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** The care plan this plan is created from */
  parentCarePlanId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Time period plan covers */
  period?: InputMaybe<PeriodUpsertInput>;
  /** Reference to relating care plan this care plan replaces. */
  replacedCarePlanId?: InputMaybe<Scalars["ID"]["input"]>;
  serviceRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  status: ServiceRequestStatus;
  subject: CarePlanSubjectInput;
  /** Human friendly name for the care plan. */
  title: Scalars["String"]["input"];
};

export type CarePlanPaginatedResponse = {
  __typename?: "CarePlanPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<CarePlans>;
  totalPages: Scalars["Float"]["output"];
};

export type CarePlanSubjectInput = {
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CarePlanSubjectResults = Groups | Patients;

export type CarePlans = {
  __typename?: "CarePlans";
  addresses?: Maybe<Array<Conditions>>;
  author_account_id: Scalars["ID"]["output"];
  based_on?: Maybe<ServiceRequests>;
  care_plan_id: Scalars["ID"]["output"];
  care_team?: Maybe<CareTeams>;
  category: Scalars["String"]["output"];
  changes?: Maybe<Array<CarePlanChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  custodian_account_id?: Maybe<Scalars["ID"]["output"]>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Summary of the nature of the plan. */
  description: Scalars["String"]["output"];
  /** The concluding diagnosis code */
  diagnosis?: Maybe<Icd10>;
  encounter?: Maybe<Encounters>;
  goal?: Maybe<Goals>;
  intent: ServiceIntentStatus;
  is_archived: Scalars["Boolean"]["output"];
  note?: Maybe<Annotations>;
  part_of?: Maybe<CarePlans>;
  /** Time period plan covers */
  period?: Maybe<Periods>;
  questionnaire_responses?: Maybe<Array<QuestionnaireResponses>>;
  replaces?: Maybe<CarePlans>;
  status: ServiceRequestStatus;
  subject: CarePlanSubjectResults;
  /** Human friendly name for the care plan. */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Care team category codes. */
export enum CareTeamCategory {
  Encounter = "ENCOUNTER",
  EpisodeOfCare = "EPISODE_OF_CARE",
  Event = "EVENT",
  Hcbs = "HCBS",
  Longitudinal = "LONGITUDINAL",
  PublicHealth = "PUBLIC_HEALTH",
  Research = "RESEARCH",
}

export type CareTeamCreateInput = {
  carePlanId: Scalars["String"]["input"];
  category: CareTeamCategory;
  /** Condition the care team is/was assembled for. */
  conditionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** A Contact detail for the care team (applies to all members). If not provided defaults to contact of the user who created the team */
  contactId?: InputMaybe<Scalars["ID"]["input"]>;
  members?: InputMaybe<Array<CareTeamMemberInput>>;
  /** Name of the team. */
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Time period team covers. */
  period?: InputMaybe<PeriodUpsertInput>;
  status?: InputMaybe<CareTeamStatus>;
  subject: CareTeamSubjectInput;
};

export type CareTeamInput = {
  category: CareTeamCategory;
  /** Condition the care team is/was assembled for. */
  conditionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** A Contact detail for the care team (applies to all members). If not provided defaults to contact of the user who created the team */
  contactId?: InputMaybe<Scalars["ID"]["input"]>;
  members?: InputMaybe<Array<CareTeamMemberInput>>;
  /** Name of the team. */
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Time period team covers. */
  period?: InputMaybe<PeriodUpsertInput>;
  status?: InputMaybe<CareTeamStatus>;
  subject: CareTeamSubjectInput;
};

export type CareTeamMemberBulkCreateInput = {
  /** Care team this member is part of. */
  careTeamId: Scalars["ID"]["input"];
  members: Array<CareTeamMemberInput>;
};

export type CareTeamMemberInput = {
  /** The Cynergy AccountId of the member. */
  memberAccountId: Scalars["ID"]["input"];
  /** Text representation of members full name. */
  name: Scalars["String"]["input"];
  /**  The organization the practitioner is working on the behalf of. */
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  role: ParticipantRole;
  /** "Timing" resource. When the member is generally available within this care team */
  timingId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CareTeamMembers = {
  __typename?: "CareTeamMembers";
  account_id: Scalars["ID"]["output"];
  /** When the member is generally available within this care team. */
  coverage?: Maybe<Timings>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  member_id: Scalars["ID"]["output"];
  /** Text representation of members full name */
  name: Scalars["String"]["output"];
  /** The organization of the practitioner. */
  on_behalf_of?: Maybe<Organizations>;
  /** Indicates specific responsibility of an individual within the care team, such as "Primary care physician", "Trained social worker counselor", "Caregiver", etc. */
  role: ParticipantRole;
  team: CareTeams;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Care team status codes */
export enum CareTeamStatus {
  Active = "ACTIVE",
  EnteredInError = "ENTERED_IN_ERROR",
  Inactive = "INACTIVE",
  Proposed = "PROPOSED",
  Suspended = "SUSPENDED",
}

export type CareTeamSubjectInput = {
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CareTeams = {
  __typename?: "CareTeams";
  care_team_id: Scalars["ID"]["output"];
  category: CareTeamCategory;
  /** A Contact detail for the care team (applies to all members) */
  contact: Contacts;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Organization responsible for the care team */
  managing_organization?: Maybe<Organizations>;
  members?: Maybe<Array<CareTeamMembers>>;
  /** Name of the team */
  name: Scalars["String"]["output"];
  note?: Maybe<Annotations>;
  /** Time period team covers. */
  period?: Maybe<Periods>;
  plan: CarePlans;
  reason?: Maybe<Conditions>;
  status: CareTeamStatus;
  subject: CarePlanSubjectResults;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CartCheckoutInput = {
  onBehalfOfAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  paymentMethod: CheckoutPaymentMethodInput;
};

export type CatalogProductPaginatedResults = {
  __typename?: "CatalogProductPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<CatalogProductResult>;
  totalPages: Scalars["Float"]["output"];
};

export type CatalogProductResult = {
  __typename?: "CatalogProductResult";
  id: Scalars["ID"]["output"];
  is_starred: Scalars["Boolean"]["output"];
  price: PriceBookEntries;
  product: Products;
  store: WebStores;
};

export type CatalogProductSearchBy = {
  category?: InputMaybe<SearchByArgs>;
  price?: InputMaybe<SearchByArgs>;
  product?: InputMaybe<SearchByArgs>;
  store?: InputMaybe<SearchByArgs>;
};

export type ChallengeCreateInput = {
  expirationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  hiddenDetails?: InputMaybe<Scalars["JSONObject"]["input"]>;
  push?: InputMaybe<ChallengePushCreateInput>;
  totp?: InputMaybe<ChallengeTotpCreateInput>;
};

export type ChallengePushCreateInput = {
  details: ChallengePushDetailsInput;
};

export type ChallengePushDetailsInput = {
  fields?: InputMaybe<Array<ChallengePushField>>;
  message: Scalars["String"]["input"];
};

export type ChallengePushField = {
  label: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type ChallengeTotpCreateInput = {
  code: Scalars["String"]["input"];
};

export type ChangeUserPasswordInput = {
  /** New password */
  newPassword: Scalars["String"]["input"];
  /** Old password */
  password: Scalars["String"]["input"];
};

export type ChangesEntity = {
  created_by: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type ChannelAlertEmails = {
  __typename?: "ChannelAlertEmails";
  channel_alert_email_id: Scalars["String"]["output"];
  channel_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ChannelCreateInput = {
  /** When to automatically delete the channel. */
  closesAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  members?: InputMaybe<Array<ChannelMemberInput>>;
  name: Scalars["String"]["input"];
  status?: InputMaybe<SubscriptionStatus>;
  topicId: Scalars["ID"]["input"];
  type: SubscriptionChannelType;
};

export type ChannelDeleteInput = {
  channelId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ChannelDestinationResponse = {
  __typename?: "ChannelDestinationResponse";
  /** Channel destination UUID */
  channelDestinationId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type ChannelMember = {
  memberId: Scalars["ID"]["input"];
};

export type ChannelMemberActionInput = {
  add?: InputMaybe<Array<ChannelMemberInput>>;
  remove?: InputMaybe<ChannelMemberBulkDeleteInput>;
  update?: InputMaybe<ChannelMemberUpdateInput>;
};

export type ChannelMemberBulkCreateInput = {
  channelId: Scalars["ID"]["input"];
  members: Array<ChannelMemberInput>;
};

export type ChannelMemberBulkDeleteInput = {
  channelId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  members: Array<ChannelMember>;
};

export type ChannelMemberInput = {
  cynergyId: Scalars["ID"]["input"];
  /** If member is no longer in channel */
  inactive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Period member belongs to channel. */
  period?: InputMaybe<PeriodCreateInput>;
};

export type ChannelMemberUpdateInput = {
  /** If member is no longer in channel */
  inactive?: InputMaybe<Scalars["Boolean"]["input"]>;
  memberId: Scalars["ID"]["input"];
  /** Period member belongs to channel. */
  period?: InputMaybe<PeriodCreateInput>;
};

export type ChannelMembers = {
  __typename?: "ChannelMembers";
  channel: SubscriptionChannels;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** If member is no longer in channel */
  inactive: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  member_id: Scalars["String"]["output"];
  /** Period member belongs to channel. */
  period?: Maybe<Periods>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ChannelPublishInput = {
  channelId: Scalars["String"]["input"];
  event: Scalars["String"]["input"];
  /** Only publish to these memberIds */
  members?: InputMaybe<Array<Scalars["String"]["input"]>>;
  message: Scalars["String"]["input"];
  payload: Scalars["JSONObject"]["input"];
};

export type ChannelSubscriberMessage = {
  __typename?: "ChannelSubscriberMessage";
  event: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  payload: Scalars["JSONObject"]["output"];
  status?: Maybe<Scalars["Float"]["output"]>;
};

export type ChannelTemplateResponse = {
  __typename?: "ChannelTemplateResponse";
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
  /** Template UUID */
  templateId?: Maybe<Scalars["String"]["output"]>;
};

export type ChannelUpdateInput = {
  channelId: Scalars["ID"]["input"];
  /** When to automatically delete the channel. */
  closesAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  members?: InputMaybe<ChannelMemberActionInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<SubscriptionStatus>;
  topicId?: InputMaybe<Scalars["ID"]["input"]>;
  type?: InputMaybe<SubscriptionChannelType>;
};

export type CheckoutPaymentMethodInput = {
  method: CheckoutPaymentMethodPick;
  savePaymentMethod?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CheckoutPaymentMethodPick = {
  cardPayment?: InputMaybe<CardPaymentDetails>;
  savedPaymentMethodId?: InputMaybe<Scalars["ID"]["input"]>;
  token?: InputMaybe<PaymentToken>;
};

export type ClinicalImpressionChanges = ChangesEntity & {
  __typename?: "ClinicalImpressionChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  impression: ClinicalImpressions;
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ClinicalImpressionCreateInput = {
  assessmentDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  changePattern: ImpressionChangePatternCodes;
  /** Clinical parameter is numeric value that represents specific vital signs and measurements in medicine, such as blood sugar level, oxygen saturation, heart rate, and temperature, providing essential information about a patient's physiological condition */
  clinicalParameter?: InputMaybe<Scalars["Float"]["input"]>;
  conditionID: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  encounterID?: InputMaybe<Scalars["String"]["input"]>;
  /** It is required when numericRating is empty and clinicalParameter has value. clinicalParameter is converted into the numericRating by the specific logic which is specified by ICD 10 Code */
  icd10Code?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Pain Scale in relation to condition; on scale of 1-10 */
  numericRating?: InputMaybe<Scalars["Float"]["input"]>;
  protocol?: InputMaybe<Scalars["String"]["input"]>;
  status: EventStatuses;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  summary: Scalars["String"]["input"];
};

export type ClinicalImpressionUpdateInput = {
  assessmentDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  changePattern?: InputMaybe<ImpressionChangePatternCodes>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  encounterID?: InputMaybe<Scalars["String"]["input"]>;
  impressionID: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  protocol?: InputMaybe<Scalars["String"]["input"]>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClinicalImpressions = {
  __typename?: "ClinicalImpressions";
  /** Time of assessment */
  assessment_date_time: Scalars["DateTime"]["output"];
  change_pattern: ImpressionChangePatternCodes;
  changes?: Maybe<Array<ClinicalImpressionChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  encounter?: Maybe<Encounters>;
  impression_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  /** On a scale from 1-10 */
  numeric_rating: Scalars["Float"]["output"];
  performer: StaffAssignments;
  problem: Conditions;
  /** Clinical Protocol followed */
  protocol?: Maybe<Scalars["String"]["output"]>;
  status: EventStatuses;
  status_reason?: Maybe<Scalars["String"]["output"]>;
  subject: Patients;
  summary: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ClinicalNoteCreateInput = {
  authoredAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  encounterID?: InputMaybe<Scalars["String"]["input"]>;
  patientId: Scalars["String"]["input"];
  subject: Scalars["String"]["input"];
  /** Body of note. */
  text: Scalars["String"]["input"];
};

export type ClinicalNoteUpdateInput = {
  authoredAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  noteID: Scalars["String"]["input"];
  subject?: InputMaybe<Scalars["String"]["input"]>;
  /** Body of note. */
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClinicalNotes = {
  __typename?: "ClinicalNotes";
  author: StaffAssignments;
  /** Date note was published */
  authored: Scalars["DateTime"]["output"];
  based_on?: Maybe<Encounters>;
  changes?: Maybe<Array<ClinicalNotesChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  note_id: Scalars["String"]["output"];
  patient: Patients;
  subject: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ClinicalNotesChanges = ChangesEntity & {
  __typename?: "ClinicalNotesChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  note: ClinicalNotes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CodeableConceptCreateInput = {
  /** FHIR enum binding reference (if applicable) */
  binding?: InputMaybe<Scalars["JSONObject"]["input"]>;
  coding?: InputMaybe<CodingCreateInput>;
  /** Plain text representation of the concept */
  text: Scalars["String"]["input"];
};

export type CodeableConceptPayloadInput = {
  /** FHIR enum binding reference (if applicable) */
  binding?: InputMaybe<Scalars["JSONObject"]["input"]>;
  /** A coding representing the concept */
  coding?: InputMaybe<CodingCreateInput>;
  /** Plain text representation of the concept */
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type CodeableConceptUpdateInput = {
  /** FHIR enum binding reference (if applicable) */
  binding?: InputMaybe<Scalars["JSONObject"]["input"]>;
  coding?: InputMaybe<CodingCreateInput>;
  conceptId: Scalars["ID"]["input"];
  /** Plain text representation of the concept */
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type CodeableConcepts = {
  __typename?: "CodeableConcepts";
  coding?: Maybe<Codings>;
  concept_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Plain text representation of the concept */
  text: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CodeableReferenceCreateInput = {
  /** Reference to a concept (CodeableConcept) */
  concept?: InputMaybe<CodeableConceptCreateInput>;
  /** Reference to a resource (Reference) */
  reference?: InputMaybe<ReferenceCreateInput>;
};

export type CodeableReferenceUpsertInput = {
  /** Optional ID of an existing CodeableReference. If provided, its components will be resolved. */
  codeableReferenceId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Reference to a concept (CodeableConcept) */
  concept?: InputMaybe<CodeableConceptPayloadInput>;
  /** Reference to a resource (Reference) */
  reference?: InputMaybe<ReferencePayloadInput>;
};

export type CodeableReferences = {
  __typename?: "CodeableReferences";
  /** Reference to a concept (by class) */
  concept?: Maybe<CodeableConcepts>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Reference to a resource (by instance) */
  reference?: Maybe<References>;
  reference_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CodingCreateInput = {
  /** A symbol in syntax defined by the system */
  code: Scalars["String"]["input"];
  /** A representation of the meaning of the code in the system, following the rules of the system */
  display: Scalars["String"]["input"];
  system?: InputMaybe<Scalars["String"]["input"]>;
  /** If the coding was chosen directly by the user */
  userSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type Codings = {
  __typename?: "Codings";
  /** A symbol in syntax defined by the system. The symbol may be a predefined code or an expression in a syntax defined by the coding system (e.g. post-coordination). */
  code: Scalars["String"]["output"];
  coding_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** A representation of the meaning of the code in the system, following the rules of the system. */
  display: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  system?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** If this coding was chosen directly by the user */
  user_selected: Scalars["Boolean"]["output"];
  version?: Maybe<Scalars["String"]["output"]>;
};

export type CollectionCreateInput = {
  color?: InputMaybe<Scalars["HexColor"]["input"]>;
  entries?: InputMaybe<Array<CollectionEntryInput>>;
  /** User-friendly name */
  name: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollectionDeleteInput = {
  collectionId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionEntries = {
  __typename?: "CollectionEntries";
  collection: Collections;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** The record or content of entry */
  entity: References;
  entry_id: Scalars["String"]["output"];
  /** Icon representing entry object */
  icon?: Maybe<Attachments>;
  is_archived: Scalars["Boolean"]["output"];
  /** The name of entry */
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** URL link */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type CollectionEntryActionInput = {
  add?: InputMaybe<Array<CollectionEntryInput>>;
  remove?: InputMaybe<Array<CollectionEntryDeleteInput>>;
  update?: InputMaybe<CollectionEntryUpdateInput>;
};

export type CollectionEntryBulkDeleteInput = {
  collectionId: Scalars["ID"]["input"];
  entries: Array<CollectionEntryDeleteInput>;
};

export type CollectionEntryDeleteInput = {
  entryId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionEntryIdentifierInput = {
  entryId?: InputMaybe<Scalars["ID"]["input"]>;
  recordId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollectionEntryInput = {
  /** Entity being referenced by entry */
  entity: ReferenceCreateInput;
  icon?: InputMaybe<AttachmentCreateInput>;
  /** Human-friendly entry name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollectionEntryManageInput = {
  action: CollectionEntryActionInput;
  collectionId: Scalars["ID"]["input"];
};

export type CollectionEntryUpdateInput = {
  entryId: Scalars["ID"]["input"];
  icon?: InputMaybe<AttachmentUpsertInput>;
  /** Human-friendly entry name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type Collections = {
  __typename?: "Collections";
  account_id: Scalars["ID"]["output"];
  collection_id: Scalars["String"]["output"];
  color?: Maybe<Scalars["HexColor"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  entries?: Maybe<Array<CollectionEntries>>;
  is_archived: Scalars["Boolean"]["output"];
  is_default: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** URL link */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** List of available product family categories */
export enum CommerceProductFamily {
  Physical = "PHYSICAL",
  Service = "SERVICE",
  Subscription = "SUBSCRIPTION",
}

/** List of available commerce store types. */
export enum CommerceStoreType {
  B2B = "B2B",
  B2C = "B2C",
}

/** All Possible FHIR common tag codes */
export enum CommonMetaTags {
  /** This request is intended to be acted upon, not merely stored */
  Actionable = "ACTIONABLE",
  /** Metadata observation used to indicate that some information has been removed from the source object when the view this object contains was constructed because of configuration options when the view was created. The content may not be suitable for use as the basis of a record update */
  Subsetted = "SUBSETTED",
}

export type CommunicationBasedOnInput = {
  carePlanId?: InputMaybe<Scalars["ID"]["input"]>;
  communicationRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  serviceRequestId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** All possible FHIR communication category codes */
export enum CommunicationCategory {
  Alert = "ALERT",
  Instruction = "INSTRUCTION",
  Notification = "NOTIFICATION",
  Reminder = "REMINDER",
}

export type CommunicationCreateInput = {
  basedOn?: InputMaybe<CommunicationBasedOnInput>;
  category: CommunicationCategory;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  medium: ParticipationMode;
  payload?: InputMaybe<Array<CommunicationPayloadInput>>;
  priority: RequestPriority;
  receivedTimestamp?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  recipients: Array<CommunicationRecipientLinkOrCreateInput>;
  /** Prior communication that this communication is in response to */
  respondsTo?: InputMaybe<Array<CommunicationReplyInput>>;
  /** Who shares the information */
  senderReference: ReferenceCreateInput;
  sentTimestamp?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status: EventStatuses;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  subject: CommunicationSubjectInput;
  topic?: InputMaybe<CommunicationTopic>;
};

export type CommunicationDeleteInput = {
  communicationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CommunicationPaginatedResults = {
  __typename?: "CommunicationPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Communications>;
  totalPages: Scalars["Float"]["output"];
};

export type CommunicationPayload = {
  __typename?: "CommunicationPayload";
  communication?: Maybe<Communications>;
  /** Payload content */
  content: CommunicationPayloadContent;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  payload_id: Scalars["ID"]["output"];
  request?: Maybe<CommunicationRequests>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationPayloadActionInput = {
  add?: InputMaybe<Array<CommunicationPayloadContentInput>>;
  remove?: InputMaybe<CommunicationPayloadBulkDeleteInput>;
  update?: InputMaybe<CommunicationPayloadUpdateInput>;
};

export type CommunicationPayloadBulkDeleteInput = {
  for: CommunicationPayloadForInput;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  payload: Array<CommunicationPayloadIdentifier>;
};

export type CommunicationPayloadContent = Attachments | CodeableConcepts | References;

export type CommunicationPayloadContentInput = {
  attachment?: InputMaybe<AttachmentCreateInput>;
  concept?: InputMaybe<CodeableConceptCreateInput>;
  reference?: InputMaybe<ReferenceCreateInput>;
};

export type CommunicationPayloadForInput = {
  communicationId?: InputMaybe<Scalars["ID"]["input"]>;
  communicationRequestId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CommunicationPayloadIdentifier = {
  communicationPayloadId: Scalars["ID"]["input"];
};

export type CommunicationPayloadInput = {
  content: CommunicationPayloadContentInput;
};

export type CommunicationPayloadUpdateInput = {
  attachment?: InputMaybe<AttachmentUpdateInput>;
  communicationPayloadId: Scalars["ID"]["input"];
  concept?: InputMaybe<CodeableConceptUpdateInput>;
  reference?: InputMaybe<ReferenceUpdateInput>;
};

export type CommunicationRecipient = {
  recipientReferenceId: Scalars["ID"]["input"];
};

export type CommunicationRecipientActionInput = {
  add?: InputMaybe<Array<CommunicationRecipientLinkOrCreateInput>>;
  remove?: InputMaybe<CommunicationRecipientBulkDeleteInput>;
  update?: InputMaybe<ReferenceUpdateInput>;
};

export type CommunicationRecipientBulkDeleteInput = {
  communicationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  recipients: Array<CommunicationRecipient>;
};

export type CommunicationRecipientLinkOrCreateInput = {
  recipient?: InputMaybe<ReferenceCreateInput>;
  recipientReferenceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CommunicationReplyActionInput = {
  add?: InputMaybe<Array<CommunicationReplyInput>>;
  remove?: InputMaybe<CommunicationReplyBulkDeleteInput>;
};

export type CommunicationReplyBulkDeleteInput = {
  communicationId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  replies: Array<CommunicationReplyInput>;
};

export type CommunicationReplyInput = {
  replyToCommunicationId: Scalars["ID"]["input"];
};

export type CommunicationRequestCreateInput = {
  /** A plan or proposal that is fulfilled in whole or in part by this request. */
  basedOnReference?: InputMaybe<ReferenceCreateInput>;
  category: CommunicationCategory;
  /** Comments made about the communication request */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** If true indicates that the CommunicationRequest is asking for the specified action to not occur. */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The Encounter during which this CommunicationRequest was created */
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Composite request identifier this is part of */
  groupIdentifier?: InputMaybe<IdentifierCreateInput>;
  /** Who should share the information */
  informationProviderReference?: InputMaybe<ReferenceCreateInput>;
  /** Indicates the level of authority/intentionality associated with the CommunicationRequest and where the request fits into the workflow chain. */
  intent: RequestIntent;
  medium: ParticipationMode;
  /** When this communication is to occur */
  occurrence?: InputMaybe<RequestOccurrenceInput>;
  /** Message payload */
  payload?: InputMaybe<Array<CommunicationPayloadInput>>;
  /** Characterizes how quickly the proposed act must be initiated. Includes concepts such as stat, urgent, routine. */
  priority: RequestPriority;
  /** Who to share the information with */
  recipients: Array<CommunicationRecipientLinkOrCreateInput>;
  /** Communication request replaced by this request */
  replacedRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Who asked for the information to be shared */
  requesterReference: ReferenceCreateInput;
  status: RequestStatus;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  /** The patient or group that is the focus of this communication request. */
  subject?: InputMaybe<RequestSubjectInput>;
};

export type CommunicationRequestDeleteInput = {
  communicationRequestId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CommunicationRequestPaginatedResults = {
  __typename?: "CommunicationRequestPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<CommunicationRequests>;
  totalPages: Scalars["Float"]["output"];
};

export type CommunicationRequestRecipientActionInput = {
  add?: InputMaybe<Array<CommunicationRecipientLinkOrCreateInput>>;
  remove?: InputMaybe<CommunicationRequestRecipientBulkDeleteInput>;
  update?: InputMaybe<ReferenceUpdateInput>;
};

export type CommunicationRequestRecipientBulkDeleteInput = {
  communicationRequestId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  recipients: Array<RequestRecipient>;
};

export type CommunicationRequestUpdateInput = {
  /** A plan or proposal that is fulfilled in whole or in part by this request. */
  basedOnReference?: InputMaybe<ReferenceCreateInput>;
  category?: InputMaybe<CommunicationCategory>;
  /** Comments made about the communication request */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  communicationRequestId: Scalars["ID"]["input"];
  /** If true indicates that the CommunicationRequest is asking for the specified action to not occur. */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The Encounter during which this CommunicationRequest was created */
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Composite request identifier this is part of */
  groupIdentifier?: InputMaybe<IdentifierCreateInput>;
  /** Who should share the information */
  informationProviderReference?: InputMaybe<ReferenceCreateInput>;
  intent?: InputMaybe<RequestIntent>;
  medium?: InputMaybe<ParticipationMode>;
  /** When this communication is to occur */
  occurrence?: InputMaybe<RequestOccurrenceInput>;
  payload?: InputMaybe<CommunicationPayloadActionInput>;
  recipients?: InputMaybe<CommunicationRequestRecipientActionInput>;
  /** Communication request replaced by this request */
  replacedRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<RequestStatus>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  /** The patient or group that is the focus of this communication request. */
  subject?: InputMaybe<RequestSubjectInput>;
};

export type CommunicationRequests = {
  __typename?: "CommunicationRequests";
  /** A plan or proposal that is fulfilled in whole or in part by this request. */
  based_on?: Maybe<References>;
  /** Message category */
  category: CommunicationCategory;
  /** Comments made about the communication request */
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** If true indicates that the CommunicationRequest is asking for the specified action to not occur. */
  do_not_perform?: Maybe<Scalars["Boolean"]["output"]>;
  encounter_id?: Maybe<Scalars["ID"]["output"]>;
  /** Composite request identifier this is part of */
  group_identifier?: Maybe<Identifiers>;
  /** Who should share the information */
  information_provider?: Maybe<References>;
  /** Indicates the level of authority/intentionality associated with the CommunicationRequest and where the request fits into the workflow chain */
  intent: RequestIntent;
  is_archived: Scalars["Boolean"]["output"];
  /** A channel of communication */
  medium: ParticipationMode;
  /** Date/time when this communication is to occur */
  occurrence_datetime?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** The period for which this communication should occur. */
  occurrence_period?: Maybe<Periods>;
  /** Message payload */
  payload?: Maybe<Array<CommunicationPayload>>;
  /** Characterizes how quickly the proposed act must be initiated. */
  priority: RequestPriority;
  /** Who to share the information with */
  recipients: Array<References>;
  /** Communication request replaced by this request */
  replaces?: Maybe<CommunicationRequests>;
  request_id: Scalars["ID"]["output"];
  /** Who asked for the information to be shared */
  requester: References;
  /** The status of the proposal or order. */
  status: RequestStatus;
  /** Reason for current status */
  status_reason?: Maybe<Scalars["String"]["output"]>;
  subject_group_id?: Maybe<Scalars["ID"]["output"]>;
  subject_patient_id?: Maybe<Scalars["ID"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationSubjectInput = {
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** All possible FHIR communication topic codes */
export enum CommunicationTopic {
  AppointmentReminder = "APPOINTMENT_REMINDER",
  PhoneConsult = "PHONE_CONSULT",
  ProgressUpdate = "PROGRESS_UPDATE",
  ReportLabs = "REPORT_LABS",
  RxRefillRequest = "RX_REFILL_REQUEST",
  SummaryReport = "SUMMARY_REPORT",
}

export type CommunicationUpdateInput = {
  basedOn?: InputMaybe<CommunicationBasedOnInput>;
  category?: InputMaybe<CommunicationCategory>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  communicationId: Scalars["ID"]["input"];
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  medium?: InputMaybe<ParticipationMode>;
  payload?: InputMaybe<CommunicationPayloadActionInput>;
  priority?: InputMaybe<RequestPriority>;
  receivedTimestamp?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  recipients?: InputMaybe<CommunicationRecipientActionInput>;
  respondsTo?: InputMaybe<CommunicationReplyActionInput>;
  sentTimestamp?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status?: InputMaybe<EventStatuses>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  topic?: InputMaybe<CommunicationTopic>;
};

export type Communications = {
  __typename?: "Communications";
  /** An order, proposal or plan fulfilled in whole or in part by this Communication. */
  based_on?: Maybe<CommunicationsBasedOn>;
  /** Message category */
  category: CommunicationCategory;
  /** Comments made about the communication */
  comment?: Maybe<Scalars["String"]["output"]>;
  communication_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encounter_id?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** A channel of communication */
  medium: ParticipationMode;
  /** Message payload */
  payload?: Maybe<Array<CommunicationPayload>>;
  /** Characterizes how quickly the planned or in progress communication must be addressed. */
  priority: RequestPriority;
  /** When received */
  received?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Who the information is shared with */
  recipients: Array<References>;
  /** Communications that are in response to this communication */
  replies?: Maybe<Array<Communications>>;
  /** Prior communication that this communication is in response to. */
  responds_to?: Maybe<Array<Communications>>;
  /** Who shares the information */
  sender: References;
  /** When sent */
  sent?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Status of the transmission. */
  status: EventStatuses;
  /** Reason for current status */
  status_reason?: Maybe<Scalars["String"]["output"]>;
  subject_group_id?: Maybe<Scalars["String"]["output"]>;
  subject_patient_id?: Maybe<Scalars["String"]["output"]>;
  /** Description of the purpose/content */
  topic?: Maybe<CommunicationTopic>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationsBasedOn = CarePlans | Communications | ServiceRequests;

export type ComponentLayoutConfiguration = {
  __typename?: "ComponentLayoutConfiguration";
  column: GridLayoutProperties;
  /** Name or reference to the component. */
  component: Scalars["String"]["output"];
  /** Unique identifier for the widget */
  id: Scalars["String"]["output"];
  /** Position on the dashboard grid */
  position: LayoutPosition;
  /** Any component specific props to pass. */
  props?: Maybe<Scalars["JSONObject"]["output"]>;
};

/** All possible FHIR composition attestation mode codes */
export enum CompositionAttestationMode {
  Legal = "LEGAL",
  Official = "OFFICIAL",
  Personal = "PERSONAL",
  Professional = "PROFESSIONAL",
}

export type CompositionAttesterPartyUnion = Organizations | Patients | StaffAssignments;

export enum CompositionStatus {
  Amended = "AMENDED",
  Appended = "APPENDED",
  Cancelled = "CANCELLED",
  Corrected = "CORRECTED",
  Deprecated = "DEPRECATED",
  EnteredInError = "ENTERED_IN_ERROR",
  Final = "FINAL",
  Partial = "PARTIAL",
  Preliminary = "PRELIMINARY",
  Registered = "REGISTERED",
  Unknown = "UNKNOWN",
}

export type ConditionAbatementInput = {
  abatementDateString?: InputMaybe<Scalars["String"]["input"]>;
  abatementDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ConditionAsserterInput = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ConditionAssessmentsPaginatedResponse = {
  __typename?: "ConditionAssessmentsPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<ClinicalImpressions>;
  totalPages: Scalars["Float"]["output"];
};

/** All available FHIR condition category codes. */
export enum ConditionCategoryCodes {
  /** A point in time diagnosis (e.g. from a physician or nurse) in context of an encounter. */
  EncounterDiagnosis = "ENCOUNTER_DIAGNOSIS",
  /** An item on a problem list that can be managed over time and can be expressed by a practitioner (e.g. physician, nurse), patient, or related person. */
  ProblemListItem = "PROBLEM_LIST_ITEM",
}

export type ConditionChanges = ChangesEntity & {
  __typename?: "ConditionChanges";
  condition: Conditions;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All available FHIR condition clinical statuses */
export enum ConditionClinicalStatus {
  /** The subject is currently experiencing the condition or situation, there is evidence of the condition or situation, or considered to be a significant risk. */
  Active = "ACTIVE",
  /** The subject is no longer experiencing the condition or situation and there is no longer evidence or appreciable risk of the condition or situation. */
  Inactive = "INACTIVE",
  /** The subject is experiencing a reoccurence or repeating of a previously resolved condition or situation, e.g. urinary tract infection, food insecurity. */
  Recurrence = "RECURRENCE",
  /** The subject is experiencing a return of a condition or situation after a period of improvement or remission, e.g. relapse of cancer, alcoholism. */
  Relapse = "RELAPSE",
  /** The subject is not presently experiencing the condition or situation, but there is a risk of the condition or situation returning. */
  Remission = "REMISSION",
  /** The subject is not presently experiencing the condition or situation and there is a negligible perceived risk of the condition or situation returning. */
  Resolved = "RESOLVED",
  /** The authoring/source system does not know which of the status values currently applies for this condition. Note: This concept is not to be used for "other" - one of the listed statuses is presumed to apply, but the authoring/source system does not know which. */
  Unknown = "UNKNOWN",
}

/** All possible FHIR condition codes. */
export enum ConditionCodes {
  AnxietyDisorder = "ANXIETY_DISORDER",
  ChoroidalHemorrhage = "CHOROIDAL_HEMORRHAGE",
  ClinicalFinding = "CLINICAL_FINDING",
}

export type ConditionCreateInput = {
  conditions: Array<ConditionInput>;
  /** The criteria assessment result this set of conditions derive from. */
  derivingCriteriaResultId?: InputMaybe<Scalars["String"]["input"]>;
  patientId: Scalars["String"]["input"];
};

export type ConditionInput = {
  abatement?: InputMaybe<ConditionAbatementInput>;
  /** The person or device that asserted the condition. */
  asserter?: InputMaybe<ConditionAsserterInput>;
  bodySite?: InputMaybe<Scalars["String"]["input"]>;
  /** The care plan this condition is part of. */
  carePlanID?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<ConditionCategoryCodes>;
  clinicalStatus: ConditionClinicalStatus;
  conditionCode?: InputMaybe<ConditionCodes>;
  encounterID?: InputMaybe<Scalars["String"]["input"]>;
  icd10Code: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  onset?: InputMaybe<ConditionOnsetInput>;
  recordedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  severity?: InputMaybe<ConditionSeverityCodes>;
  typeOfParticipantInvolvement: ParticipantRoleType;
  verificationStatus?: InputMaybe<ConditionVerificationStatus>;
};

export type ConditionOnsetInput = {
  onsetDateString?: InputMaybe<Scalars["String"]["input"]>;
  onsetDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** All available FHIR condition severity codes. */
export enum ConditionSeverityCodes {
  Mild = "MILD",
  Moderate = "MODERATE",
  Severe = "SEVERE",
  Unknown = "UNKNOWN",
}

export type ConditionUpdateInput = {
  abatement?: InputMaybe<ConditionAbatementInput>;
  asserter?: InputMaybe<ConditionAsserterInput>;
  /** The care plan this condition is part of. */
  carePlanID?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<ConditionCategoryCodes>;
  clinicalStatus?: InputMaybe<ConditionClinicalStatus>;
  conditionCode?: InputMaybe<ConditionCodes>;
  conditionID: Scalars["String"]["input"];
  encounterID?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  onset?: InputMaybe<ConditionOnsetInput>;
  severity?: InputMaybe<ConditionSeverityCodes>;
  symptom?: InputMaybe<SymptomCodes>;
  typeOfParticipantInvolvement?: InputMaybe<ParticipantRoleType>;
  verificationStatus?: InputMaybe<ConditionVerificationStatus>;
};

/** All available FHIR condition verification status codes. */
export enum ConditionVerificationStatus {
  /** There is sufficient diagnostic and/or clinical evidence to treat this as a confirmed condition. */
  Confirmed = "CONFIRMED",
  /** One of a set of potential (and typically mutually exclusive) diagnoses asserted to further guide the diagnostic process and preliminary treatment. */
  Differential = "DIFFERENTIAL",
  /** The statement was entered in error and is not valid. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** This is a tentative diagnosis - still a candidate that is under consideration. */
  Provisional = "PROVISIONAL",
  /** This condition has been ruled out by subsequent diagnostic and clinical evidence. */
  Refuted = "REFUTED",
  /** There is not sufficient diagnostic and/or clinical evidence to treat this as a confirmed condition. */
  Unconfirmed = "UNCONFIRMED",
}

export type Conditions = {
  __typename?: "Conditions";
  /** When in resolution/remission */
  abatement_date_string?: Maybe<Scalars["String"]["output"]>;
  /** When in resolution/remission */
  abatement_date_time?: Maybe<Scalars["DateTime"]["output"]>;
  /** Cynergy account ID of user who asserted the condition. */
  asserter_account_id?: Maybe<Scalars["ID"]["output"]>;
  /** ID of medical device that asserted the condition. */
  asserter_device_id?: Maybe<Scalars["ID"]["output"]>;
  assessments?: Maybe<Array<ClinicalImpressions>>;
  body_site?: Maybe<Scalars["String"]["output"]>;
  category: ConditionCategoryCodes;
  changes?: Maybe<Array<ConditionChanges>>;
  classification: Icd10;
  clinical_status: ConditionClinicalStatus;
  code?: Maybe<ConditionCodes>;
  condition_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  derived_from?: Maybe<CriteriaFormResults>;
  encounter?: Maybe<Encounters>;
  episode?: Maybe<EpisodeOfCare>;
  goal?: Maybe<Goals>;
  is_archived: Scalars["Boolean"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  /** Estimated or actual date, date-time, or age */
  onset_date_string?: Maybe<Scalars["String"]["output"]>;
  /** Estimated or actual date, date-time, or age */
  onset_date_time?: Maybe<Scalars["DateTime"]["output"]>;
  /** Type of involvement */
  participant_involvement: ParticipantRoleType;
  /** Date condition was first recorded. */
  recorded_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Cynergy account ID of user who recorded the condition. */
  recorder_account_id?: Maybe<Scalars["ID"]["output"]>;
  severity: ConditionSeverityCodes;
  subject: Patients;
  treatment_medications?: Maybe<Array<MedicationUsages>>;
  treatment_plan?: Maybe<CarePlans>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  verification_status: ConditionVerificationStatus;
};

/** All possible FHIR conformance expectation codes. */
export enum ConformanceExpectation {
  /** Support for the specified capability is not necessary to be considered conformant, and the requirement should be considered strictly optional. */
  May = "MAY",
  /** Support for the specified capability is required to be considered conformant. */
  Shall = "SHALL",
  /** Support for the specified capability is strongly encouraged, and failure to support it should only occur after careful consideration. */
  Should = "SHOULD",
  /** Support for the specified capability is strongly discouraged and should occur only after careful consideration. */
  ShouldNot = "SHOULD_NOT",
}

export type ContactDetailDeleteInput = {
  contactDetailId: Scalars["String"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContactDetails = {
  __typename?: "ContactDetails";
  contact_detail_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name of an individual to contact. */
  name: Scalars["String"]["output"];
  /** The organization this contact detail is handled/monitored by */
  organization?: Maybe<Organizations>;
  organization_id: Scalars["ID"]["output"];
  /** Purpose/type of contact */
  purpose?: Maybe<ContactEntityType>;
  /** Contact details for individual or organization. */
  telecom: Array<ContactPoints>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ContactDetailsCreateInput = {
  /** Name for contact */
  name: Scalars["String"]["input"];
  /** Purpose/type of contact */
  purpose?: InputMaybe<ContactEntityType>;
  /** Contact information */
  telecom: Array<ContactPointInput>;
};

export type ContactDetailsUpdateInput = {
  contactDetailId: Scalars["ID"]["input"];
  /** Name for contact */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Purpose/type of contact */
  purpose?: InputMaybe<ContactEntityType>;
  telecom?: InputMaybe<ContactPointActionInput>;
};

/** All possible FHIR contact entity type codes */
export enum ContactEntityType {
  Admin = "ADMIN",
  Agent = "AGENT",
  Bill = "BILL",
  Hr = "HR",
  Patient = "PATIENT",
  Payor = "PAYOR",
  Press = "PRESS",
}

export type ContactPointActionInput = {
  add?: InputMaybe<Array<ContactPointInput>>;
  remove?: InputMaybe<Array<ContactPointDeleteInput>>;
  update?: InputMaybe<Array<ContactPointUpdateInput>>;
};

export type ContactPointDeleteInput = {
  contactPointId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContactPointInput = {
  /** Time period when the contact point was/in use. */
  period?: InputMaybe<PeriodCreateInput>;
  /** Specify preferred order of use (1 = highest) */
  rank?: InputMaybe<Scalars["Float"]["input"]>;
  system: ContactPointSystem;
  use: ContactPointUse;
  /** The actual contact point details */
  value: Scalars["String"]["input"];
};

/** All possible FHIR contact point system codes. */
export enum ContactPointSystem {
  /** The value is an email address. */
  Email = "EMAIL",
  /** The value is a fax machine. Use of full international numbers starting with + is recommended to enable automatic dialing support but not required. */
  Fax = "FAX",
  /** A contact that is not a phone, fax, page or email address and is not expressible as a URL. E.g. Internal mail address. This SHOULD NOT be used for contacts that are expressible as a URL (e.g. Skype, Twitter, Facebook, etc.) Extensions may be used to distinguish "other" contact types. */
  Other = "OTHER",
  /** The value is a pager number. These may be local pager numbers that are only usable on a particular pager system. */
  Pager = "PAGER",
  /** The value is a telephone number used for voice calls. Use of full international numbers starting with + is recommended to enable automatic dialing support but not required. */
  Phone = "PHONE",
  /** A contact that can be used for sending a sms message (e.g. mobile phones, some landlines). */
  Sms = "SMS",
  /** A contact that is not a phone, fax, pager or email address and is expressed as a URL. This is intended for various institutional or personal contacts including web sites, blogs, Skype, Twitter, Facebook, etc. Do not use for email addresses. */
  Url = "URL",
}

export type ContactPointUpdateInput = {
  contactPointId: Scalars["ID"]["input"];
  /** Time period when the contact point was/in use. */
  period?: InputMaybe<PeriodCreateInput>;
  /** Specify preferred order of use (1 = highest) */
  rank?: InputMaybe<Scalars["Float"]["input"]>;
  system?: InputMaybe<ContactPointSystem>;
  use?: InputMaybe<ContactPointUse>;
  /** The actual contact point details */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR contact point use codes. */
export enum ContactPointUse {
  /** A communication contact point at a home; attempted contacts for business purposes might intrude privacy and chances are one will contact family or other household members instead of the person one wishes to call. Typically used with urgent cases, or if no other contacts are available. */
  Home = "HOME",
  /** A telecommunication device that moves and stays with its owner. May have characteristics of all other use codes, suitable for urgent matters, not the first choice for routine business. */
  Mobile = "MOBILE",
  /** This contact point is no longer in use (or was never correct, but retained for records). */
  Old = "OLD",
  /** A temporary contact point. The period can provide more detailed information. */
  Temp = "TEMP",
  /** An office contact point. First choice for business related contacts during business hours. */
  Work = "WORK",
}

export type ContactPoints = {
  __typename?: "ContactPoints";
  contact?: Maybe<ContactDetails>;
  contact_point_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Time period when the contact point was/is in use. */
  period?: Maybe<Periods>;
  /** Specify preferred order of use (1 = highest) */
  rank: Scalars["Float"]["output"];
  system: ContactPointSystem;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  use: ContactPointUse;
  /** The actual contact point details */
  value: Scalars["String"]["output"];
};

export type Contacts = {
  __typename?: "Contacts";
  /** Indicates whether or not this contact has access to view patients medical reports */
  authorized_access: Scalars["String"]["output"];
  contact_id: Scalars["String"]["output"];
  contact_relation_type: RelatedPersonTypes;
  contact_type: PatientContactCodes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  is_primary?: Maybe<Scalars["Boolean"]["output"]>;
  last_name: Scalars["String"]["output"];
  nickname: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
};

export type ContainerCapLinkOrCreateInput = {
  cap?: InputMaybe<SpecimenDefinitionContainerCapInput>;
  capId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** All possible FHIR container material codes */
export enum ContainerMaterial {
  Glass = "GLASS",
  Metal = "METAL",
  Plastic = "PLASTIC",
}

export type CoordinateInput = {
  altitude?: InputMaybe<Scalars["Float"]["input"]>;
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

export type CoordinateType = {
  __typename?: "CoordinateType";
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
};

export type Coordinates = {
  __typename?: "Coordinates";
  altitude?: Maybe<Scalars["Float"]["output"]>;
  coordinate_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  latitude: Scalars["Float"]["output"];
  longitude: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CoordinatesInput = {
  altitude?: InputMaybe<Scalars["Float"]["input"]>;
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

/** Copy a source location's staff roster onto a target location, preserving each staff member's title. */
export type CopyLocationStaffInput = {
  /** Hire date applied to every copied assignment. Defaults to now. */
  hireDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Location whose staff assignments are read from. */
  sourceLocationId: Scalars["ID"]["input"];
  /** Subset of source staff to copy. Omit (or leave empty) to copy the entire source roster. */
  staffIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Location the staff assignments are copied onto. */
  targetLocationId: Scalars["ID"]["input"];
};

export type CoverageArchiveInput = {
  coverageId: Scalars["ID"]["input"];
  /** Reason for the deletion (audited). */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  /** Replacement coverage to move open orders onto before archiving. */
  replacementCoverageId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Elect self-pay on the open orders (clear their snapshot) before archiving. */
  selfPay?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CoverageAudits = {
  __typename?: "CoverageAudits";
  actor_cynergy_id?: Maybe<Scalars["ID"]["output"]>;
  audit_id: Scalars["ID"]["output"];
  coverage_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  organization_id?: Maybe<Scalars["ID"]["output"]>;
  patient_id?: Maybe<Scalars["ID"]["output"]>;
  payor_name?: Maybe<Scalars["String"]["output"]>;
  policy_number?: Maybe<Scalars["String"]["output"]>;
  /** Reason the event was performed. */
  reason?: Maybe<Scalars["String"]["output"]>;
  type: CoverageEventType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CoverageClassInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  type: FhirCoverageClassType;
  value: Scalars["String"]["input"];
};

export type CoverageClasses = {
  __typename?: "CoverageClasses";
  coverage: Coverages;
  coverage_class_id: Scalars["ID"]["output"];
  coverage_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human-readable name for the grouping */
  name?: Maybe<Scalars["String"]["output"]>;
  type: FhirCoverageClassType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Identifier value for this grouping (e.g. group number) */
  value: Scalars["String"]["output"];
};

/** Lifecycle event options recorded on the coverage audit trail */
export enum CoverageEventType {
  Create = "CREATE",
  Delete = "DELETE",
  Restore = "RESTORE",
  Update = "UPDATE",
}

export type CoveragePaginatedResults = {
  __typename?: "CoveragePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Coverages>;
  totalPages: Scalars["Float"]["output"];
};

export type CoverageRestoreInput = {
  coverageId: Scalars["ID"]["input"];
  /** Reason for the restore (audited). */
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type CoverageUpsertInput = {
  classes?: InputMaybe<Array<CoverageClassInput>>;
  coverage_id?: InputMaybe<Scalars["ID"]["input"]>;
  /** Coordination-of-benefits rank (1 = primary, 2 = secondary, …). Defaults to 1. */
  coverage_order?: InputMaybe<Scalars["Int"]["input"]>;
  kind?: InputMaybe<FhirCoverageKind>;
  /** mycynergy Organizations.organization_id */
  organization_id: Scalars["ID"]["input"];
  /** mycynergy Patients.patient_id */
  patient_id: Scalars["ID"]["input"];
  payor_address_city?: InputMaybe<Scalars["String"]["input"]>;
  payor_address_line1?: InputMaybe<Scalars["String"]["input"]>;
  payor_address_line2?: InputMaybe<Scalars["String"]["input"]>;
  payor_address_state?: InputMaybe<Scalars["String"]["input"]>;
  payor_address_zip?: InputMaybe<Scalars["String"]["input"]>;
  payor_external_id?: InputMaybe<Scalars["String"]["input"]>;
  payor_name: Scalars["String"]["input"];
  plan_type?: InputMaybe<Scalars["String"]["input"]>;
  /** Policy / member ID */
  policy_number: Scalars["String"]["input"];
  /** Originating mycynergy Orders.order_id */
  source_order_id?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<FhirCoverageStatus>;
  subscriber_address_city?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_address_line1?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_address_line2?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_address_state?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_address_zip?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_dob?: InputMaybe<Scalars["DateTime"]["input"]>;
  subscriber_first_name?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_last_name?: InputMaybe<Scalars["String"]["input"]>;
  subscriber_relationship_to_patient?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type Coverages = {
  __typename?: "Coverages";
  /** Group/plan/subplan classifications */
  classes: Array<CoverageClasses>;
  coverage_id: Scalars["ID"]["output"];
  /** Coordination-of-benefits rank (1 = primary, 2 = secondary, …) */
  coverage_order: Scalars["Int"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Broad category of coverage */
  kind: FhirCoverageKind;
  /** Organization that recorded the coverage */
  organization_id: Scalars["ID"]["output"];
  /** Beneficiary patient receiving care */
  patient_id: Scalars["ID"]["output"];
  payor_address_city?: Maybe<Scalars["String"]["output"]>;
  payor_address_line1?: Maybe<Scalars["String"]["output"]>;
  payor_address_line2?: Maybe<Scalars["String"]["output"]>;
  payor_address_state?: Maybe<Scalars["String"]["output"]>;
  payor_address_zip?: Maybe<Scalars["String"]["output"]>;
  /** IN1.insuranceCompanyID — sender-supplied payor identifier */
  payor_external_id?: Maybe<Scalars["String"]["output"]>;
  /** IN1.insuranceCompanyName */
  payor_name: Scalars["String"]["output"];
  /** Plan type from IN1.insurancePlanType */
  plan_type?: Maybe<Scalars["String"]["output"]>;
  /** IN1.policyNumber — the subscriber policy/member ID */
  policy_number: Scalars["String"]["output"];
  /** Order that first registered this coverage (audit only) */
  source_order_id?: Maybe<Scalars["ID"]["output"]>;
  status: FhirCoverageStatus;
  subscriber_address_city?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_line1?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_line2?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_state?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_zip?: Maybe<Scalars["String"]["output"]>;
  subscriber_dob?: Maybe<Scalars["DateTime"]["output"]>;
  subscriber_first_name?: Maybe<Scalars["String"]["output"]>;
  subscriber_last_name?: Maybe<Scalars["String"]["output"]>;
  /** IN1.insuredsRelationshipToPatient — free text (Self, Spouse, Child, …) */
  subscriber_relationship_to_patient?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CreateChallengeResponse = {
  __typename?: "CreateChallengeResponse";
  /** Challenge identifier */
  sid: Scalars["String"]["output"];
  status: TwilioChallengeStatus;
};

/** Credential parameter type of an endpoint parameter  */
export enum CredentialEndpointParameterType {
  Authentication = "Authentication",
  ClientCertificate = "ClientCertificate",
  HttpHeader = "HttpHeader",
  Url = "Url",
}

export type CreditCardDetailsType = {
  cardNumber: Scalars["String"]["input"];
  cvv: Scalars["String"]["input"];
  expirationDate: Scalars["String"]["input"];
};

/** List of credit card issuers */
export enum CreditCardIssuerCodes {
  AmericanExpress = "AmericanExpress",
  BankOfAmerica = "BankOfAmerica",
  CapitalOne = "CapitalOne",
  Chase = "Chase",
  Citi = "Citi",
  Discover = "Discover",
  Usaa = "USAA",
  WellsFargo = "WellsFargo",
}

/** List of credit card networks */
export enum CreditCardNetworkCodes {
  AmericanExpress = "AmericanExpress",
  Discover = "Discover",
  MasterCard = "MasterCard",
  Visa = "Visa",
}

export type Criteria = {
  __typename?: "Criteria";
  citations?: Maybe<Array<Scalars["String"]["output"]>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  criteria_number: Scalars["Float"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  items: Array<CriteriaItems>;
  publisher: Scalars["String"]["output"];
  reference_url?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaDefinitionPaginatedResults = {
  __typename?: "CriteriaDefinitionPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<CriteriaDefinitions>;
  totalPages: Scalars["Float"]["output"];
};

export type CriteriaDefinitions = {
  __typename?: "CriteriaDefinitions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Additional meta information to store. */
  parameters?: Maybe<Array<Parameters>>;
  publisher: Scalars["String"]["output"];
  /** A human-friendly identifier that is unique within the criteria. */
  slug: Scalars["String"]["output"];
  /** Criteria title. */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Link to criteria source */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaFormFlaggedQuestionInput = {
  /** In some cases a question may appear in more than one criteria sub-sections; List of illnesses this question appears in. */
  appliesTo: Array<Scalars["String"]["input"]>;
  /** ICD-10 codes relating to question. */
  icd10Codes: Array<Scalars["String"]["input"]>;
  /** Criteria question item text */
  label: Scalars["String"]["input"];
};

export type CriteriaFormPaginatedResults = {
  __typename?: "CriteriaFormPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<CriteriaFormResults>;
  totalPages: Scalars["Float"]["output"];
};

export type CriteriaFormPerformerUnion = Practitioners | StaffAssignments;

export type CriteriaFormResultFlagItems = {
  __typename?: "CriteriaFormResultFlagItems";
  /** List of specific illness(s) this item relates to from the overall criteria set */
  applies_to: Array<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** ICD-10 codes relating to criteria item */
  icd10_codes: Array<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Criteria item question text */
  label: Scalars["String"]["output"];
  result: CriteriaFormResultFlags;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaFormResultFlags = {
  __typename?: "CriteriaFormResultFlags";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** List of specific identifying ICD-10 diagnostic codes for flag */
  diagnoses: Array<Icd10>;
  flag_id: Scalars["String"]["output"];
  flags: Array<CriteriaFormResultFlagItems>;
  is_archived: Scalars["Boolean"]["output"];
  result: CriteriaFormResults;
  /** The name of the symptom or illness  */
  syndrome: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaFormResultFlagsInput = {
  /** List of specific identifying ICD-10 diagnostic codes for flag */
  diagnoses: Array<Scalars["String"]["input"]>;
  flags: Array<CriteriaFormFlaggedQuestionInput>;
  /** Name of illness (I.E. Common cold/pharyngitis) */
  syndrome: Scalars["String"]["input"];
};

export type CriteriaFormResults = {
  __typename?: "CriteriaFormResults";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  criteria: CriteriaDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  flagged_by?: Maybe<Array<CriteriaFormResultFlags>>;
  is_archived: Scalars["Boolean"]["output"];
  location?: Maybe<Locations>;
  note?: Maybe<Annotations>;
  passed: Scalars["Boolean"]["output"];
  patient: Patients;
  performer?: Maybe<CriteriaFormPerformerUnion>;
  practitioner_id?: Maybe<Scalars["String"]["output"]>;
  /** Medication(s) prescribed in response to the result. */
  prescriptions?: Maybe<Array<MedicationUsages>>;
  result_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaItems = {
  __typename?: "CriteriaItems";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  criteria: Criteria;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  icd10: Icd10;
  is_archived: Scalars["Boolean"]["output"];
  item_id: Scalars["String"]["output"];
  link_id: Scalars["String"]["output"];
  rules: CriteriaRules;
  syndrome: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export enum CriteriaPatientRequirementType {
  /** The type of criteria requirement is in relation to patient demographic information */
  Demographic = "DEMOGRAPHIC",
  /** The type of criteria requirement is in relation to patient vitals information */
  Vitals = "VITALS",
}

export type CriteriaPatientRequirements = {
  __typename?: "CriteriaPatientRequirements";
  conformance: ConformanceExpectation;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  type: CriteriaPatientRequirementType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaRuleSelections = {
  __typename?: "CriteriaRuleSelections";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  icd10?: Maybe<Icd10>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  rule: CriteriaRules;
  score: Scalars["Float"]["output"];
  selection_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type CriteriaRules = {
  __typename?: "CriteriaRules";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition: CriteriaItems;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  patient_requirements?: Maybe<Array<CriteriaPatientRequirements>>;
  required_behavior?: Maybe<ActionRequiredBehavior>;
  rule_id: Scalars["String"]["output"];
  rule_requirements?: Maybe<Array<RuleRequirements>>;
  selections: Array<CriteriaRuleSelections>;
  statement: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Cynergy account status types. */
export enum CynergyAccountStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Restricted = "RESTRICTED",
  Suspended = "SUSPENDED",
  UnderReview = "UNDER_REVIEW",
}

export type CynergyAccountUpdateInput = {
  accountId: Scalars["String"]["input"];
  userType: UserTypes;
};

export type CynergyAccounts = {
  __typename?: "CynergyAccounts";
  account_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** External IDs for a core account. */
  external_ids?: Maybe<Array<Identifiers>>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: CynergyUsers;
  user_type: UserTypes;
};

export type CynergyIdentityUnion = CynergyUsers | Demographics;

export type CynergyProfileUpdateInput = {
  account?: InputMaybe<CynergyUserUpdateInput>;
  address?: InputMaybe<AddressUpdateInput>;
  demographics?: InputMaybe<DemographicsUpdateInput>;
};

export type CynergyRelationEntity = {
  cynergy_id: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  user_type: UserTypes;
};

export type CynergyUserCreateInput = {
  /** Override for passing from higher service */
  cynergyId?: InputMaybe<Scalars["String"]["input"]>;
  identifiers?: InputMaybe<Array<PatientExternalIdInput>>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** User must provide either an email OR phone number. */
  methods: Array<CynergyUserRegisterMethodInput>;
  userType: UserTypes;
  username: Scalars["String"]["input"];
};

export type CynergyUserProfileCreateInput = {
  account: CynergyUserCreateInput;
  address?: InputMaybe<AddressInput>;
  demographics: DemographicsCreateInput;
  isPortalEnabled: Scalars["Boolean"]["input"];
};

export type CynergyUserRegisterMethodInput = {
  method: IdentityRegistrationMethods;
  value: Scalars["String"]["input"];
};

export type CynergyUserUpdateInput = {
  accounts?: InputMaybe<Array<CynergyAccountUpdateInput>>;
  /** Pass only if updating another user, will check against permissions. */
  cynergyId?: InputMaybe<Scalars["String"]["input"]>;
  identifiers?: InputMaybe<Array<PatientExternalIdInput>>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  updatedUsername?: InputMaybe<Scalars["String"]["input"]>;
};

export type CynergyUsers = {
  __typename?: "CynergyUsers";
  account?: Maybe<CynergyAccounts>;
  account_activated: Scalars["Boolean"]["output"];
  account_verification?: Maybe<AccountVerification>;
  accounts: Array<CynergyAccounts>;
  addresses?: Maybe<Array<Addresses>>;
  changes?: Maybe<Array<UsersChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  demographics?: Maybe<Demographics>;
  duplicate_flags: Array<DuplicateRecordEntries>;
  email?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_default?: Maybe<Scalars["Boolean"]["output"]>;
  old_cynergy_id?: Maybe<Scalars["String"]["output"]>;
  passwords?: Maybe<Array<Passwords>>;
  phone?: Maybe<Scalars["String"]["output"]>;
  potential_duplicates?: Maybe<Array<DuplicateRecordEntries>>;
  preferences?: Maybe<UserPreferences>;
  status: CynergyAccountStatus;
  twoFactor?: Maybe<TwoFactorAuthentication>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
  user_id: Scalars["String"]["output"];
  username: Scalars["String"]["output"];
  validated: Scalars["Boolean"]["output"];
  validated_on?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CynergyUsersAccountArgs = {
  userType: Scalars["String"]["input"];
};

export type CynergyUsersType = {
  __typename?: "CynergyUsersType";
  account?: Maybe<CynergyAccounts>;
  account_activated: Scalars["Boolean"]["output"];
  account_verification?: Maybe<AccountVerification>;
  accounts: Array<CynergyAccounts>;
  addresses?: Maybe<Array<Addresses>>;
  changes?: Maybe<Array<UsersChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  demographics?: Maybe<Demographics>;
  duplicate_flags: Array<DuplicateRecordEntries>;
  email?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_default?: Maybe<Scalars["Boolean"]["output"]>;
  old_cynergy_id?: Maybe<Scalars["String"]["output"]>;
  passwords?: Maybe<Array<Passwords>>;
  phone?: Maybe<Scalars["String"]["output"]>;
  potential_duplicates?: Maybe<Array<DuplicateRecordEntries>>;
  preferences?: Maybe<UserPreferences>;
  status: CynergyAccountStatus;
  twoFactor?: Maybe<TwoFactorAuthentication>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  username: Scalars["String"]["output"];
  validated: Scalars["Boolean"]["output"];
  validated_on?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CynergyUsersTypeAccountArgs = {
  userType: Scalars["String"]["input"];
};

export type DailyAvailabilities = {
  __typename?: "DailyAvailabilities";
  /** Always available? i.e. 24-Hour service */
  all_day: Scalars["Boolean"]["output"];
  availability_id: Scalars["ID"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Days available during the week */
  days?: Maybe<Array<Scalars["String"]["output"]>>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** End time of availability. (18:00:00) */
  end_time?: Maybe<Scalars["Timestamp"]["output"]>;
  /** Available every day? (Monday - Sunday) */
  every_day: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Start time of availability. (08:00:00) */
  start_time?: Maybe<Scalars["Timestamp"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Data absent reason codes. */
export enum DataAbsentReason {
  AskedDeclined = "ASKED_DECLINED",
  AskedUnknown = "ASKED_UNKNOWN",
  AsText = "AS_TEXT",
  Error = "ERROR",
  Masked = "MASKED",
  NegativeInfinity = "NEGATIVE_INFINITY",
  NotApplicable = "NOT_APPLICABLE",
  NotAsked = "NOT_ASKED",
  NotANumber = "NOT_A_NUMBER",
  NotPerformed = "NOT_PERFORMED",
  NotPermitted = "NOT_PERMITTED",
  PositiveInfinity = "POSITIVE_INFINITY",
  TempUnknown = "TEMP_UNKNOWN",
  Unknown = "UNKNOWN",
  Unsupported = "UNSUPPORTED",
}

export type DataRequirementCodeFilterInput = {
  /** What code is expected */
  code?: InputMaybe<CodingCreateInput>;
  /** The parameter name (variable) this filter applies to. */
  parameterBinding?: InputMaybe<Scalars["String"]["input"]>;
  /** A code-valued attribute to filter on */
  path: Scalars["String"]["input"];
  /** A coded (token) parameter to search on */
  searchToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type DataRequirementCodeFilters = {
  __typename?: "DataRequirementCodeFilters";
  /** What code is expected */
  code?: Maybe<Codings>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  filter_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The parameter name (variable) this filter applies to. */
  parameter_binding?: Maybe<Scalars["String"]["output"]>;
  /** A code-valued attribute to filter on */
  path: Scalars["String"]["output"];
  /** A coded (token) parameter to search on */
  search?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DataRequirementCreateInput = {
  /** What codes are expected */
  codeFilters?: InputMaybe<Array<DataRequirementCodeFilterInput>>;
  /** Indicates specific structure elements that are referenced by the knowledge module */
  mustSupport?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the required data, specified as the type name of a resource. */
  resourceType: Scalars["String"]["input"];
  /** Specifies a maximum number of results that are required */
  resultLimit?: InputMaybe<Scalars["Float"]["input"]>;
};

export type DataRequirements = {
  __typename?: "DataRequirements";
  /** What codes are expected */
  code_filter?: Maybe<Array<DataRequirementCodeFilters>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Number of results */
  limit?: Maybe<Scalars["Float"]["output"]>;
  /** Indicates specific structure elements that are referenced by the knowledge module */
  must_support?: Maybe<Scalars["String"]["output"]>;
  requirement_id: Scalars["String"]["output"];
  /** The resource type. (E.g. Patients, Locations, Devices, etc) */
  type: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR days of week codes */
export enum DaysOfWeek {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

/** All possible FHIR definition topic codes. */
export enum DefinitionTopic {
  /** The definition is related to assessment of the patient. */
  Assessment = "ASSESSMENT",
  /** The definition is related to education of the patient. */
  Education = "EDUCATION",
  /** The definition is related to treatment of the patient. */
  Treatment = "TREATMENT",
}

/** All possible FHIR Degree/License/Certificate codes. */
export enum DegreeLicenseCertificate {
  Aa = "AA",
  Aas = "AAS",
  Aba = "ABA",
  Ae = "AE",
  As = "AS",
  Ba = "BA",
  Bba = "BBA",
  Be = "BE",
  Bfa = "BFA",
  Bn = "BN",
  Bs = "BS",
  Bsl = "BSL",
  Bsn = "BSN",
  Bt = "BT",
  Canp = "CANP",
  Cer = "CER",
  Cma = "CMA",
  Cnm = "CNM",
  Cnp = "CNP",
  Cns = "CNS",
  Cpnp = "CPNP",
  Crn = "CRN",
  Ctr = "CTR",
  Dba = "DBA",
  Dds = "DDS",
  Ded = "DED",
  Dip = "DIP",
  Dmd = "DMD",
  Do = "DO",
  Dpm = "DPM",
  Dvm = "DVM",
  Emt = "EMT",
  Emtp = "EMTP",
  Fpnp = "FPNP",
  Hs = "HS",
  Jd = "JD",
  Ma = "MA",
  Mba = "MBA",
  Mce = "MCE",
  Md = "MD",
  Mda = "MDA",
  Mdi = "MDI",
  Me = "ME",
  Med = "MED",
  Mee = "MEE",
  Mfa = "MFA",
  Mme = "MME",
  Ms = "MS",
  Msl = "MSL",
  Msn = "MSN",
  Mt = "MT",
  Mth = "MTH",
  Ng = "NG",
  Np = "NP",
  Od = "OD",
  Pa = "PA",
  Pharmd = "PHARMD",
  Phd = "PHD",
  Phe = "PHE",
  Phs = "PHS",
  Pn = "PN",
  Rma = "RMA",
  Rn = "RN",
  Rph = "RPH",
  Sec = "SEC",
  Ts = "TS",
  Vmd = "VMD",
}

export type DeleteAssignedWaypoint = {
  assignedWaypointId: Scalars["String"]["input"];
  routeAssignmentId: Scalars["String"]["input"];
};

export type DeleteAssignedWaypointsBulk = {
  assignedWaypointIds: Array<Scalars["String"]["input"]>;
  routeAssignmentId: Scalars["String"]["input"];
};

export type Demographics = {
  __typename?: "Demographics";
  age: Scalars["Float"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deceased: Scalars["Boolean"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dob?: Maybe<Scalars["String"]["output"]>;
  ethnicity?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  full_name?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  last_name?: Maybe<Scalars["String"]["output"]>;
  marital_status?: Maybe<MaritalStatus>;
  middle_name?: Maybe<Scalars["String"]["output"]>;
  prefix?: Maybe<Scalars["String"]["output"]>;
  race?: Maybe<Scalars["String"]["output"]>;
  sex: Scalars["String"]["output"];
  suffix?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DemographicsCreateInput = {
  /** Override for passing from higher service */
  cynergyId?: InputMaybe<Scalars["String"]["input"]>;
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>;
  dob: Scalars["DateTime"]["input"];
  ethnicity?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  maritalStatus?: InputMaybe<MaritalStatus>;
  race?: InputMaybe<Scalars["String"]["input"]>;
  sex: Scalars["String"]["input"];
};

export type DemographicsUpdateInput = {
  cynergyId: Scalars["String"]["input"];
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>;
  dob?: InputMaybe<Scalars["DateTime"]["input"]>;
  ethnicity?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  race?: InputMaybe<Scalars["String"]["input"]>;
  sex?: InputMaybe<Scalars["String"]["input"]>;
  suffix?: InputMaybe<Scalars["String"]["input"]>;
};

export type DepartmentTeams = {
  __typename?: "DepartmentTeams";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  department: Departments;
  is_archived: Scalars["Boolean"]["output"];
  team: Teams;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Departments = {
  __typename?: "Departments";
  contact?: Maybe<Contacts>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  department_head: StaffAssignments;
  department_id: Scalars["String"]["output"];
  department_number: Scalars["Float"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  teams?: Maybe<Array<DepartmentTeams>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DependentChanges = ChangesEntity & {
  __typename?: "DependentChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  patient_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Dependents = {
  __typename?: "Dependents";
  changes?: Maybe<Array<DependentChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dependant_id: Scalars["String"]["output"];
  dependent: Patients;
  is_archived: Scalars["Boolean"]["output"];
  parent: Patients;
  parent_patient_id: Scalars["String"]["output"];
  patient_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All available FHIR DetectedIssue category codes. */
export enum DetectedIssueCategory {
  Abuse = "ABUSE",
  Adalrt = "ADALRT",
  Age = "AGE",
  Algy = "ALGY",
  Alldone = "ALLDONE",
  Comply = "COMPLY",
  Cond = "COND",
  Creact = "CREACT",
  Dact = "DACT",
  Dose = "DOSE",
  Dosecond = "DOSECOND",
  Dosedur = "DOSEDUR",
  Dosedurh = "DOSEDURH",
  Dosedurhind = "DOSEDURHIND",
  Dosedurl = "DOSEDURL",
  Dosedurlind = "DOSEDURLIND",
  Doseh = "DOSEH",
  Dosehind = "DOSEHIND",
  Dosehinda = "DOSEHINDA",
  Dosehindsa = "DOSEHINDSA",
  Dosehindw = "DOSEHINDW",
  Doseivl = "DOSEIVL",
  Doseivlind = "DOSEIVLIND",
  Dosel = "DOSEL",
  Doselind = "DOSELIND",
  Doselinda = "DOSELINDA",
  Doselindsa = "DOSELINDSA",
  Doselindw = "DOSELINDW",
  Drg = "DRG",
  Dupthpcls = "DUPTHPCLS",
  Dupthpgen = "DUPTHPGEN",
  Dupthpy = "DUPTHPY",
  Endlate = "ENDLATE",
  Food = "FOOD",
  Fraud = "FRAUD",
  Fulfil = "FULFIL",
  Gealrt = "GEALRT",
  Gen = "GEN",
  Held = "HELD",
  Historic = "HISTORIC",
  Int = "INT",
  Interval = "INTERVAL",
  Lact = "LACT",
  Mdose = "MDOSE",
  Minfreq = "MINFREQ",
  Nhp = "NHP",
  Nonrx = "NONRX",
  Notactn = "NOTACTN",
  Notequiv = "NOTEQUIV",
  Notequivgen = "NOTEQUIVGEN",
  Notequivther = "NOTEQUIVTHER",
  Obsa = "OBSA",
  Patpref = "PATPREF",
  Patprefalt = "PATPREFALT",
  Pealrt = "PEALRT",
  Plydoc = "PLYDOC",
  Plyphrm = "PLYPHRM",
  Preg = "PREG",
  Previnef = "PREVINEF",
  Ralg = "RALG",
  Rar = "RAR",
  Rint = "RINT",
  Rreact = "RREACT",
  Strtlate = "STRTLATE",
  Time = "TIME",
  Timing = "TIMING",
  Toolate = "TOOLATE",
  Toosoon = "TOOSOON",
  Tprod = "TPROD",
}

/** All available FHIR Detected Issue Severity codes. */
export enum DetectedIssueSeverity {
  /** Indicates the issue may be life-threatening or has the potential to cause permanent injury. */
  High = "HIGH",
  /** Indicates the issue may result in some adverse consequences but is unlikely to substantially affect the situation of the subject. */
  Low = "LOW",
  /** Indicates the issue may result in noticeable adverse consequences but is unlikely to be life-threatening or cause permanent injury. */
  Moderate = "MODERATE",
  Unknown = "UNKNOWN",
}

/** All available FHIR detected issue status codes. */
export enum DetectedIssueStatus {
  /** The observation has been withdrawn following previous final release. This electronic record should never have existed, though it is possible that real-world decisions were based on it. (If real-world activity has occurred, the status should be "cancelled" rather than "entered-in-error".). */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The observation is complete and there are no further actions needed. Additional information such "released", "signed", etc would be represented using [Provenance](provenance.html) which provides not only the act but also the actors and dates and other related data. These act states would be associated with an observation status of "preliminary" until they are all completed and then a status of "final" would be applied. */
  Final = "FINAL",
  /** Indicates the detected issue has been mitigated */
  Mitigated = "MITIGATED",
  /** This is an initial or interim observation: data may be incomplete or unverified. */
  Preliminary = "PRELIMINARY",
}

export type DetectedIssues = {
  __typename?: "DetectedIssues";
  category: DetectedIssueCategory;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  detail?: Maybe<Scalars["String"]["output"]>;
  identified_at: Scalars["DateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  issue_id: Scalars["String"]["output"];
  mitigation_action?: Maybe<Scalars["String"]["output"]>;
  mitigation_date?: Maybe<Scalars["DateTime"]["output"]>;
  note?: Maybe<Annotations>;
  reference_uri?: Maybe<Scalars["String"]["output"]>;
  severity: DetectedIssueSeverity;
  status: DetectedIssueStatus;
  subject: Medications;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DeviceResponse = {
  __typename?: "DeviceResponse";
  /** Device UUID */
  deviceId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type Devices = {
  __typename?: "Devices";
  device_id?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosisCodeGroupObject = {
  __typename?: "DiagnosisCodeGroupObject";
  codes: Array<Icd10>;
  count: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  type: DiagnosisCodeGroupType;
};

/** Valid group types for ICD10 codes. */
export enum DiagnosisCodeGroupType {
  Favorites = "Favorites",
  FrequentlyUsed = "FrequentlyUsed",
  RecentDiagnoses = "RecentDiagnoses",
  Recents = "Recents",
  Recommended = "Recommended",
}

/** All possible FHIR Diagnosis role codes. */
export enum DiagnosisRoleCodes {
  Ad = "AD",
  Billing = "BILLING",
  Cc = "CC",
  Cm = "CM",
  Dd = "DD",
  Na = "NA",
  PostOp = "POST_OP",
  PreOp = "PRE_OP",
}

/** All possible FHIR Diagnosis type codes */
export enum DiagnosisType {
  /** The diagnosis given as the reason why the patient was admitted to the hospital. */
  Admitting = "ADMITTING",
  /** A diagnosis made on the basis of medical signs and patient-reported symptoms, rather than diagnostic tests. */
  Clinical = "CLINICAL",
  /** One of a set of the possible diagnoses that could be connected to the signs, symptoms, and lab findings. */
  Differential = "DIFFERENTIAL",
  /** The diagnosis given when the patient is discharged from the hospital. */
  Discharge = "DISCHARGE",
  /** A diagnosis based significantly on laboratory reports or test results, rather than the physical examination of the patient. */
  Laboratory = "LABORATORY",
  /** A diagnosis which identifies people's responses to situations in their lives, such as a readiness to change or a willingness to accept assistance. */
  Nursing = "NURSING",
  /** A diagnosis determined prior to birth. */
  Prenatal = "PRENATAL",
  /** The single medical diagnosis that is most relevant to the patient's chief complaint or need for treatment. */
  Principal = "PRINCIPAL",
  /** A diagnosis based primarily on the results from medical imaging studies. */
  Radiology = "RADIOLOGY",
  /** A diagnosis determined using telemedicine techniques. */
  Remote = "REMOTE",
  /** The labeling of an illness in a specific historical event using modern knowledge, methods and disease classifications. */
  Retrospective = "RETROSPECTIVE",
  /** A diagnosis determined by the patient. */
  Self = "SELF",
}

export type DiagnosticActionProcedure = {
  procedure?: InputMaybe<DiagnosticServiceProcedureInput>;
  procedureId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DiagnosticBillingCodeInput = {
  /** Billing code value */
  code: Scalars["String"]["input"];
  /** Notes/comments about this billing code */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Human friendly representation of billing code. */
  display: Scalars["String"]["input"];
  system: DiagnosticBillingSystem;
};

export type DiagnosticBillingCodes = {
  __typename?: "DiagnosticBillingCodes";
  billing: DiagnosticServiceBilling;
  code: Scalars["String"]["output"];
  code_id: Scalars["String"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Human friendly representation of system */
  display: Scalars["String"]["output"];
  /** Billing code history. */
  history?: Maybe<Array<Provenances>>;
  is_archived: Scalars["Boolean"]["output"];
  system: DiagnosticBillingSystem;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Diagnostic service billing system types to use to help determine meaning of its associated code value */
export enum DiagnosticBillingSystem {
  Cpt = "CPT",
  Icd10 = "ICD10",
}

export type DiagnosticCatalogAttester = {
  __typename?: "DiagnosticCatalogAttester";
  assignment_id: Scalars["ID"]["output"];
  catalog: DiagnosticServiceCatalog;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The way in which a person authenticated a composition */
  mode: CompositionAttestationMode;
  organization_id?: Maybe<Scalars["ID"]["output"]>;
  /** Who attested the composition */
  party: CompositionAttesterPartyUnion;
  patient_id?: Maybe<Scalars["ID"]["output"]>;
  /** When the composition was attested */
  time: Scalars["GraphQLDateTime"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticCatalogCreateInput = {
  /** Note/comment about the catalog */
  annotation?: InputMaybe<AnnotationCreateInput>;
  /** Organization maintaining the catalog content */
  custodianOrganizationId: Scalars["ID"]["input"];
  /** Plan or set of dispositions subject of the catalog */
  subject?: InputMaybe<ReferenceCreateInput>;
  title: Scalars["String"]["input"];
  /** Period for which this catalog is valid */
  validityPeriod?: InputMaybe<PeriodCreateInput>;
};

export type DiagnosticCatalogDeleteInput = {
  catalogId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DiagnosticCatalogUpdateInput = {
  /** Note/comment about the catalog */
  annotation?: InputMaybe<AnnotationCreateInput>;
  catalogId: Scalars["ID"]["input"];
  /** Computer-friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<CompositionStatus>;
  /** Plan or set of dispositions subject of the catalog */
  subject?: InputMaybe<ReferenceCreateInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Period for which this catalog is valid */
  validityPeriod?: InputMaybe<PeriodCreateInput>;
};

export type DiagnosticObservationResultInput = {
  observationId: Scalars["String"]["input"];
};

export type DiagnosticProcedures = {
  __typename?: "DiagnosticProcedures";
  action: DiagnosticServiceActions;
  activity: ActivityDefinitions;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  procedure_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticReportBasedOn = CarePlans | ServiceRequests;

export type DiagnosticReportBasedOnInput = {
  /** [External] CarePlans -> planId */
  carePlanId?: InputMaybe<Scalars["String"]["input"]>;
  /** [External] ServiceRequests -> requestId */
  requestId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiagnosticReportCreateInput = {
  attachment: AttachmentLinkOrCreateInput;
  /** Existing attachment identifier */
  attachmentId?: InputMaybe<Scalars["String"]["input"]>;
  /** Originating service requested this report is based on */
  basedOn?: InputMaybe<DiagnosticReportBasedOnInput>;
  category: DiagnosticServiceSection;
  /** Name/code for this diagnostic report */
  code: Scalars["String"]["input"];
  /** Codes for the clinical conclusion of test results */
  conclusionCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Clinically relevant time for report */
  effectiveDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Clinically relevant time-period for report */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** [External] Encounters -> encounterId */
  encounterId?: InputMaybe<Scalars["String"]["input"]>;
  /** Report flags that are part of this diagnostic report */
  flags?: InputMaybe<Array<DiagnosticReportFlagInput>>;
  /** The practitioner or organization that is responsible for the report's conclusions and interpretations */
  interpreter?: InputMaybe<DiagnosticReportInterpreterInput>;
  /** The date and time this version of the report was made available to providers. (Typically after the report was reviewed and verified) */
  issuedDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Key images or data associated with this report */
  media?: InputMaybe<Array<DiagnosticReportMediaInput>>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Observations that are part of this diagnostic report */
  observationResults?: InputMaybe<Array<DiagnosticObservationResultInput>>;
  /** Subject of the report */
  patientId: Scalars["String"]["input"];
  performer: DiagnosticReportPerformerInput;
  requester: DiagnosticReportRequesterInput;
  status: DiagnosticReportStatus;
  /** Name of user that is the subject of this report. Not always but usually a patient */
  subjectName?: InputMaybe<Scalars["String"]["input"]>;
  /** Additional information supporting the diagnostic report */
  supportingInformation?: InputMaybe<Array<DiagnosticReportInformationInput>>;
};

export type DiagnosticReportFlagInput = {
  /** Description of flag code */
  display: Scalars["String"]["input"];
  /** Flag code used in hl7 message */
  hl7Code: Scalars["String"]["input"];
  observationId: Scalars["String"]["input"];
};

export type DiagnosticReportInformation = {
  __typename?: "DiagnosticReportInformation";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  information_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The reference for the supporting information in the diagnostic report. */
  reference: DiagnosticReportSupportReference;
  report: DiagnosticReports;
  /** The code value for the role of the supporting information in the diagnostic report. */
  type: ObservationType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticReportInformationBulkCreateInput = {
  reportId: Scalars["String"]["input"];
  supportingInformation: Array<DiagnosticReportInformationInput>;
};

export type DiagnosticReportInformationInput = {
  reference: ReportInformationReferenceInput;
  type: ObservationType;
};

export type DiagnosticReportInterpreter = Organizations | StaffAssignments;

export type DiagnosticReportInterpreterInput = {
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiagnosticReportMedia = {
  __typename?: "DiagnosticReportMedia";
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  link: DocumentReferences;
  media_id: Scalars["String"]["output"];
  report: DiagnosticReports;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticReportMediaBulkCreateInput = {
  media: Array<DiagnosticReportMediaInput>;
  reportId: Scalars["String"]["input"];
};

export type DiagnosticReportMediaInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  documentReferenceId: Scalars["String"]["input"];
};

export type DiagnosticReportPaginatedResults = {
  __typename?: "DiagnosticReportPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<DiagnosticReports>;
  totalPages: Scalars["Float"]["output"];
};

export type DiagnosticReportPerformer = Organizations | StaffAssignments;

export type DiagnosticReportPerformerInput = {
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiagnosticReportRequester = Locations | Organizations | Patients | Practitioners | StaffAssignments;

export type DiagnosticReportRequesterInput = {
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  practitionerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiagnosticReportSettings = {
  __typename?: "DiagnosticReportSettings";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  setting_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticReportSettingsCreateInput = {
  /** Description of the diagnostic report settings */
  description: Scalars["String"]["input"];
  /** Associated lab ID */
  labId: Scalars["String"]["input"];
  /** URL for the lab logo */
  logoUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /** Whether to show out of range summary */
  showOutOfRangeSummary?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Title for the diagnostic report settings */
  title: Scalars["String"]["input"];
};

/** All possible diagnostic report statuses */
export enum DiagnosticReportStatus {
  Amended = "AMENDED",
  Appended = "APPENDED",
  Cancelled = "CANCELLED",
  Corrected = "CORRECTED",
  EnteredInError = "ENTERED_IN_ERROR",
  Final = "FINAL",
  Modified = "MODIFIED",
  Partial = "PARTIAL",
  Preliminary = "PRELIMINARY",
  Registered = "REGISTERED",
  Unknown = "UNKNOWN",
}

export type DiagnosticReportSupportReference = DiagnosticReports | Observations;

export type DiagnosticReportUpdateInput = {
  attachment: AttachmentLinkOrCreateInput;
  /** Existing attachment identifier */
  attachmentId?: InputMaybe<Scalars["String"]["input"]>;
  /** Originating service requested this report is based on */
  basedOn?: InputMaybe<DiagnosticReportBasedOnInput>;
  category?: InputMaybe<DiagnosticServiceSection>;
  /** Name/code for this diagnostic report */
  code?: InputMaybe<Scalars["String"]["input"]>;
  /** Codes for the clinical conclusion of test results */
  conclusionCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Clinically relevant time for report */
  effectiveDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Clinically relevant time-period for report */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** [External] Encounters -> encounterId */
  encounterId?: InputMaybe<Scalars["String"]["input"]>;
  /** The practitioner or organization that is responsible for the report's conclusions and interpretations */
  interpreter?: InputMaybe<DiagnosticReportInterpreterInput>;
  /** The date and time this version of the report was made available to providers. (Typically after the report was reviewed and verified) */
  issuedDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Subject of the report */
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  performer?: InputMaybe<DiagnosticReportPerformerInput>;
  reportId: Scalars["String"]["input"];
  requester?: InputMaybe<DiagnosticReportRequesterInput>;
  status?: InputMaybe<DiagnosticReportStatus>;
  /** Name of user that is the subject of this report. Not always but usually a patient */
  subjectName?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiagnosticReports = {
  __typename?: "DiagnosticReports";
  based_on?: Maybe<DiagnosticReportBasedOn>;
  care_plan_id?: Maybe<Scalars["ID"]["output"]>;
  category: DiagnosticServiceSection;
  /** Name/code for this diagnostic report */
  code: Scalars["String"]["output"];
  /** Codes for the clinical conclusion of test results */
  conclusion_code?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Clinically relevant time-period for report */
  effective_period?: Maybe<Periods>;
  /** Clinically relevant time for report */
  effective_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  encounter?: Maybe<Encounters>;
  encounter_id?: Maybe<Scalars["ID"]["output"]>;
  flags?: Maybe<Array<ObservationFlags>>;
  /** The practitioner or organization that is responsible for the report's conclusions and interpretations. */
  interpreter?: Maybe<DiagnosticReportInterpreter>;
  interpreter_assignment_id?: Maybe<Scalars["ID"]["output"]>;
  interpreter_organization_id?: Maybe<Scalars["ID"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The date and time that this version of the report was made available to providers, typically after the report was reviewed and verified. */
  issued?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Key images or data associated with this report */
  media?: Maybe<Array<DiagnosticReportMedia>>;
  /** Comments about the diagnostic report */
  note?: Maybe<Annotations>;
  patient_id: Scalars["ID"]["output"];
  performer: DiagnosticReportPerformer;
  performer_assignment_id?: Maybe<Scalars["ID"]["output"]>;
  performer_organization_id?: Maybe<Scalars["ID"]["output"]>;
  /** "Prettified" representation of the entire result as issued by the diagnostic service */
  presented_form?: Maybe<Attachments>;
  report_id: Scalars["ID"]["output"];
  request_id?: Maybe<Scalars["ID"]["output"]>;
  /** Who requested the test that produced this report. */
  requester: Array<DiagnosticReportRequester>;
  requester_assignment_id?: Maybe<Scalars["ID"]["output"]>;
  requester_location_id?: Maybe<Scalars["ID"]["output"]>;
  requester_organization_id?: Maybe<Scalars["ID"]["output"]>;
  requester_patient_id?: Maybe<Scalars["ID"]["output"]>;
  requester_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  /** Observations that are part of this diagnostic report */
  result?: Maybe<Array<Observations>>;
  status: DiagnosticReportStatus;
  subject: Patients;
  subject_name: Scalars["String"]["output"];
  /** Additional information supporting the diagnostic report */
  supporting_information?: Maybe<Array<DiagnosticReportInformation>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticResultBulkCreateInput = {
  observations: Array<DiagnosticObservationResultInput>;
  reportId: Scalars["String"]["input"];
};

export type DiagnosticServiceActionInput = {
  /** Brief description of the laboratory service and its method */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** How long it takes to complete action */
  duration?: InputMaybe<DurationCreateInput>;
  /** Loinc code of laboratory service. Required if DiagnosticServices.type = "test" */
  loincCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Level of importance to be assigned when actioning the request */
  priority?: InputMaybe<RequestPriority>;
  procedure?: InputMaybe<DiagnosticActionProcedure>;
  /** Reflex laboratory procedures */
  reflex?: InputMaybe<Array<ServiceReflexInput>>;
  /** Specimens required for this action */
  specimens?: InputMaybe<Array<ServiceActionSpecimenInput>>;
  /** Sub-actions contained within this action. */
  subActions?: InputMaybe<Array<ServiceSubActionInput>>;
  /** User-visible title */
  title: Scalars["String"]["input"];
};

export type DiagnosticServiceActions = {
  __typename?: "DiagnosticServiceActions";
  /** Sub actions contained within this action */
  action?: Maybe<Array<DiagnosticServiceActions>>;
  action_id: Scalars["String"]["output"];
  /** Defines whether the action can be selected multiple times. */
  cardinality_behavior?: Maybe<ActionCardinalityBehavior>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Brief description of the laboratory service and its method */
  description?: Maybe<Scalars["String"]["output"]>;
  /** How long it takes to complete action */
  duration?: Maybe<Durations>;
  /** Defines the grouping behavior for the action and its children. */
  grouping_behavior?: Maybe<ActionGroupingBehavior>;
  is_archived: Scalars["Boolean"]["output"];
  /** Code of the laboratory service */
  loinc?: Maybe<LoincCodes>;
  /** Defines whether the action should usually be preselected. */
  precheck_behavior?: Maybe<ActionPrecheckBehavior>;
  /** Identifies the level of importance to be assigned to actioning the request */
  priority: RequestPriority;
  /** Description of the activity to be performed */
  procedure?: Maybe<DiagnosticProcedures>;
  /** Defines the required behavior for the action. */
  required_behavior?: Maybe<ActionRequiredBehavior>;
  /** Defines the selection behavior for the action and its children. */
  selection_behavior?: Maybe<ActionSelectionBehavior>;
  service: DiagnosticServices;
  /** Specimens required for this action */
  specimens?: Maybe<Array<SpecimenDefinitions>>;
  /** User-visible title */
  title: Scalars["String"]["output"];
  /** Reflex laboratory procedure(s) */
  trigger?: Maybe<Array<TriggerDefinitions>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticServiceBilling = {
  __typename?: "DiagnosticServiceBilling";
  /** Billing codes associated with service */
  billing_codes?: Maybe<Array<DiagnosticBillingCodes>>;
  billing_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Reimbursement dispositions for a laboratory service */
  reimbursability: LaboratoryServiceReimbursability;
  service: DiagnosticServices;
  /** Billing textual summary */
  summary: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticServiceBillingInput = {
  codes?: InputMaybe<Array<DiagnosticBillingCodeInput>>;
  /** Reimbursement dispositions for a laboratory service */
  reimbursable: LaboratoryServiceReimbursability;
  /** Billing textual summary */
  summary: Scalars["String"]["input"];
};

export type DiagnosticServiceCatalog = {
  __typename?: "DiagnosticServiceCatalog";
  /** Attests to accuracy of composition */
  attester?: Maybe<DiagnosticCatalogAttester>;
  author_organization_id: Scalars["ID"]["output"];
  catalog_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  custodian_organization_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  note?: Maybe<Annotations>;
  services?: Maybe<Array<DiagnosticServices>>;
  status: CompositionStatus;
  /** Plan or set of dispositions subject of the catalog */
  subject?: Maybe<References>;
  /** Human friendly name */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  validity_period?: Maybe<Periods>;
};

export type DiagnosticServiceContexts = {
  __typename?: "DiagnosticServiceContexts";
  /** Patient age range applicable for this service */
  age_range?: Maybe<Range>;
  context_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Service gender restrictions (if applicable) */
  gender_restriction: GenderRestrictions;
  is_archived: Scalars["Boolean"]["output"];
  /** Is service orderable? */
  orderable: Scalars["Boolean"]["output"];
  service: DiagnosticServices;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DiagnosticServiceCreateInput = {
  /** The concrete action or group of actions conveyed by this laboratory diagnostic service */
  action?: InputMaybe<DiagnosticServiceActionInput>;
  actors?: InputMaybe<Array<PlanDefinitionActorInput>>;
  /** Billing associated with this service */
  billing?: InputMaybe<DiagnosticServiceBillingInput>;
  catalogId: Scalars["ID"]["input"];
  /** Natural language description of the lab service definition */
  description: Scalars["String"]["input"];
  /** Is this service experimental? (Not for real usage) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Additional identifiers for this service */
  identifiers?: InputMaybe<Array<ServiceIdentifierLinkOrCreateInput>>;
  /** Textual summary of limitations associated with service */
  limitationSummary?: InputMaybe<Scalars["String"]["input"]>;
  /** Locations this service is offered at. (Default to "ALL" if empty) */
  locations?: InputMaybe<ServiceLocationLinkInput>;
  /** Reference to panel(s) or test(s) included in current one */
  members?: InputMaybe<Array<DiagnosticServiceMemberInput>>;
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["input"];
  /** Textual summary of regulations applicable to this service */
  regulatorySummary?: InputMaybe<Scalars["String"]["input"]>;
  /** Markdown summary of result interpretation guidance for this service */
  resultInterpretationSummary?: InputMaybe<Scalars["String"]["input"]>;
  /** Textual summary of the schedule of the service */
  scheduleSummary?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  /** Subordinate title of the laboratory service definition */
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  type: LaboratoryServiceType;
  /** Url endpoint for this service */
  url?: InputMaybe<Scalars["URL"]["input"]>;
  /** Describes the clinical usage of the laboratory diagnostic service */
  usage?: InputMaybe<Scalars["String"]["input"]>;
  /** The usage context this service is intended to support */
  usageContext: ServiceUsageContextInput;
};

export type DiagnosticServiceDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type DiagnosticServiceIdentifierActionInput = {
  add?: InputMaybe<Array<ServiceIdentifierLinkOrCreateInput>>;
  remove?: InputMaybe<DiagnosticServiceIdentifierBulkDeleteInput>;
  update?: InputMaybe<IdentifierUpdateInput>;
};

export type DiagnosticServiceIdentifierBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  identifiers: Array<DiagnosticServiceIdentifierInput>;
  serviceId: Scalars["ID"]["input"];
};

export type DiagnosticServiceIdentifierInput = {
  identifierId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DiagnosticServiceLabInput = {
  labId: Scalars["ID"]["input"];
};

export type DiagnosticServiceLocationSet = {
  action: InstanceSetActionKeys;
  link: ServiceLocationLinkInput;
  organizationId: Scalars["ID"]["input"];
};

export type DiagnosticServiceMemberInput = {
  memberServiceId: Scalars["ID"]["input"];
};

export type DiagnosticServiceProcedureInput = {
  /** Determines if the activity should be performed on an as-needed basis */
  asNeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** True if the activity should not be performed */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When the activity definition is expected to be used */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** Is this activity experimental? (Not for real usage) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  intent?: InputMaybe<TaskIntent>;
  /** Intended jurisdiction for activity definition. */
  jurisdiction?: InputMaybe<Scalars["String"]["input"]>;
  /** Where it should happen */
  locationId: Scalars["ID"]["input"];
  /** Who's participating in action performance */
  participants?: InputMaybe<Array<ActivityDefinitionParticipantInput>>;
  priority?: InputMaybe<RequestPriority>;
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["input"];
  /** Why this activity definition is defined */
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  /** What requirements are needed to perform this action */
  requirements?: InputMaybe<ActivityDefinitionRequirementsInput>;
  status?: InputMaybe<PublicationStatus>;
  /** Subordinate title of the activity definition */
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  /** Human-friendly name */
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  /** Describes the clinical usage of the activity definition */
  usage?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR diagnostic service section codes. */
export enum DiagnosticServiceSection {
  Au = "AU",
  Bg = "BG",
  Blb = "BLB",
  Cg = "CG",
  Ch = "CH",
  Cp = "CP",
  Ct = "CT",
  Cth = "CTH",
  Cus = "CUS",
  Ec = "EC",
  En = "EN",
  Ge = "GE",
  Hm = "HM",
  Icu = "ICU",
  Imm = "IMM",
  Lab = "LAB",
  Mb = "MB",
  Mcb = "MCB",
  Myc = "MYC",
  Nmr = "NMR",
  Nms = "NMS",
  Nrs = "NRS",
  Osl = "OSL",
  Ot = "OT",
  Oth = "OTH",
  Ous = "OUS",
  Pf = "PF",
  Phr = "PHR",
  Phy = "PHY",
  Pt = "PT",
  Rad = "RAD",
  Rc = "RC",
  Rt = "RT",
  Rus = "RUS",
  Rx = "RX",
  Sp = "SP",
  Sr = "SR",
  Tx = "TX",
  Vr = "VR",
  Vus = "VUS",
  Xrc = "XRC",
}

export type DiagnosticServiceUpdateInput = {
  /** Natural language description of the lab service definition */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Is this service experimental? (Not for real usage) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  identifiers?: InputMaybe<DiagnosticServiceIdentifierActionInput>;
  /** Textual summary of limitations associated with service */
  limitationSummary?: InputMaybe<Scalars["String"]["input"]>;
  /** Set locations the service is offered */
  locations?: InputMaybe<DiagnosticServiceLocationSet>;
  /** Computer-friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the publisher/steward (organization or individual) */
  publisher?: InputMaybe<Scalars["String"]["input"]>;
  /** Textual summary of regulations applicable to this service */
  regulatorySummary?: InputMaybe<Scalars["String"]["input"]>;
  /** Markdown summary of result interpretation guidance for this service */
  resultInterpretationSummary?: InputMaybe<Scalars["String"]["input"]>;
  /** Textual summary of the schedule of the service */
  scheduleSummary?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
  /** Subordinate title of the laboratory service definition */
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<LaboratoryServiceType>;
  /** Url endpoint for this service */
  url?: InputMaybe<Scalars["URL"]["input"]>;
  /** Describes the clinical usage of the laboratory diagnostic service */
  usage?: InputMaybe<Scalars["String"]["input"]>;
  /** The usage context this service is intended to support */
  usageContext?: InputMaybe<ServiceUsageContextUpdate>;
};

export type DiagnosticServices = {
  __typename?: "DiagnosticServices";
  /** The concrete action or group of actions conveyed by this laboratory diagnostic service */
  action: DiagnosticServiceActions;
  /** Actors within the plan */
  actors?: Maybe<Array<PlanDefinitionActors>>;
  /** Billing information associated with this service */
  billing?: Maybe<DiagnosticServiceBilling>;
  biomarkers?: Maybe<Array<ObservationDefinitions>>;
  catalog: DiagnosticServiceCatalog;
  /** Contact details for the publisher */
  contact?: Maybe<Array<ContactDetails>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Natural language description of the lab service definition */
  description: Scalars["String"]["output"];
  /** For testing purposes, not real usage */
  experimental: Scalars["Boolean"]["output"];
  /** History of record changes through time */
  history?: Maybe<Array<Provenances>>;
  /** Additional service identifiers */
  identifiers?: Maybe<Array<Identifiers>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Labs this service is offered at */
  labs?: Maybe<Array<Labs>>;
  /** Textual summary of limitations associated with service */
  limitation_summary?: Maybe<Scalars["String"]["output"]>;
  /** Reference to panel(s) or test(s) include in current one */
  members?: Maybe<Array<DiagnosticServices>>;
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["output"];
  /** Textual summary of regulations applicable to this service */
  regulatory_summary?: Maybe<Scalars["String"]["output"]>;
  /** 	markdown summary of result interpretation guidance for this service */
  result_interpretation_summary?: Maybe<Scalars["String"]["output"]>;
  /** Textual summary of the schedule of the service */
  schedule_summary?: Maybe<Scalars["String"]["output"]>;
  service_id: Scalars["ID"]["output"];
  status: PublicationStatus;
  /** Type of individual the plan definition is focused on. */
  subject_type: ParticipantResourceType;
  /** Subordinate title of the laboratory service definition */
  subtitle?: Maybe<Scalars["String"]["output"]>;
  /** Human friendly name for this definition */
  title: Scalars["String"]["output"];
  type: LaboratoryServiceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Canonical identifier for this lab service */
  url?: Maybe<Scalars["String"]["output"]>;
  /** Describes the clinical usage of the laboratory diagnostic service */
  usage?: Maybe<Scalars["String"]["output"]>;
  /** The usage context this service is intended to support */
  usage_context: DiagnosticServiceContexts;
  /** Business version of the plan definition. */
  version: Scalars["String"]["output"];
};

/** All posisible FHIR discharge disposition codes. */
export enum DischargeDisposition {
  /** The patient self discharged against medical advice. */
  Aadvice = "AADVICE",
  /** The patient was discharged and has indicated that they are going to return home afterwards, but not the patient's home - e.g. a family member's home. */
  AltHome = "ALT_HOME",
  /** The patient has deceased during this encounter. */
  Exp = "EXP",
  /** The patient was dicharged and has indicated that they are going to return home afterwards. */
  Home = "HOME",
  /** The patient has been discharged into palliative care. */
  Hosp = "HOSP",
  /** The patient has been discharged into long-term care where is likely to be monitored through an ongoing episode-of-care. */
  Long = "LONG",
  /** The discharge disposition has not otherwise defined. */
  Oth = "OTH",
  /** The patient was transferred to another healthcare facility. */
  OtherHcf = "OTHER_HCF",
  /** The patient has been transferred to a psychiatric facility. */
  Psy = "PSY",
  /** The patient was discharged and is to receive post acute care rehabilitation services. */
  Rehab = "REHAB",
  /** The patient has been discharged to a skilled nursing facility for the patient to receive additional care. */
  Snf = "SNF",
}

export type DistanceInput = {
  altitude?: InputMaybe<Scalars["Float"]["input"]>;
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
  /** In miles */
  radius: Scalars["Float"]["input"];
};

export type DocumentReferenceCreateInput = {
  attachment: AttachmentLinkOrCreateInput;
  contentType: MimeTypes;
  description?: InputMaybe<Scalars["String"]["input"]>;
  documentStatus: CompositionStatus;
  securityTag?: InputMaybe<SecurityLabel>;
  status: DocumentReferenceStatus;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type DocumentReferenceDeleteInput = {
  documentReferenceId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum DocumentReferenceStatus {
  /** This is the current reference for this document. */
  Current = "CURRENT",
  /** This reference was created in error. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** This reference has been superseded by another reference. */
  Superseded = "SUPERSEDED",
}

export type DocumentReferenceUpdateInput = {
  attachment?: InputMaybe<AttachmentUpdateInput>;
  attachmentId?: InputMaybe<Scalars["String"]["input"]>;
  contentType?: InputMaybe<MimeTypes>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  documentReferenceId: Scalars["ID"]["input"];
  documentStatus?: InputMaybe<CompositionStatus>;
  securityTag?: InputMaybe<SecurityLabel>;
  status?: InputMaybe<DocumentReferenceStatus>;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type DocumentReferences = {
  __typename?: "DocumentReferences";
  /** Referenced document */
  content: Attachments;
  content_type: MimeTypes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  document_status: CompositionStatus;
  is_archived: Scalars["Boolean"]["output"];
  /** Referenced data to link files */
  reference: References;
  reference_id: Scalars["String"]["output"];
  /** Document security tags */
  security_tag?: Maybe<SecurityLabel>;
  status: DocumentReferenceStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["String"]["output"];
};

export type Dosage = {
  __typename?: "Dosage";
  /** Supplemental instruction or warnings to the patient - e.g. "with meals", "may cause drowsiness */
  additional_instruction?: Maybe<AdditionalInstructions>;
  /** Take "as needed" */
  as_needed: Scalars["Boolean"]["output"];
  /** Take as needed for X */
  as_needed_for: ConditionCodes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dosage_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Upper limit on medication per administration. */
  max_dose_per_administration?: Maybe<Ratio>;
  /** Upper limit on medication per lifetime of patient. */
  max_dose_per_lifetime?: Maybe<Ratio>;
  /** Upper limit on medication per unit of time. */
  max_dose_per_period?: Maybe<Ratio>;
  /** Technique for administering medication */
  method: AdministrationMethods;
  /** Patient or consumer oriented instructions. */
  patient_instruction: Scalars["String"]["output"];
  /** How the drug should enter body. */
  route: AdministrationRouteCodes;
  /** The order of the dosage instructions. */
  sequence: Scalars["Float"]["output"];
  /** Body site to administer to. */
  site?: Maybe<Scalars["String"]["output"]>;
  /** Free text dosage instructions e.g. SIG */
  text?: Maybe<Scalars["String"]["output"]>;
  /** When medication should be administered */
  timing: Timings;
  /** The kind of dose or rate applied */
  type: RecommendationStrength;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DownloadLocationPatientsReportResults = {
  __typename?: "DownloadLocationPatientsReportResults";
  url: Scalars["String"]["output"];
};

export type DownloadMedicalReportResults = {
  __typename?: "DownloadMedicalReportResults";
  url: Scalars["String"]["output"];
};

export type DownloadOrdersReportResults = {
  __typename?: "DownloadOrdersReportResults";
  url: Scalars["String"]["output"];
};

export type DownloadPractitionersReportResults = {
  __typename?: "DownloadPractitionersReportResults";
  url: Scalars["String"]["output"];
};

export type DownloadReportResults = {
  __typename?: "DownloadReportResults";
  url: Scalars["URL"]["output"];
};

export type DriverLicenseAddress = {
  __typename?: "DriverLicenseAddress";
  city: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  street: Scalars["String"]["output"];
  zip_code: Scalars["String"]["output"];
};

export type DriverLicenseData = {
  __typename?: "DriverLicenseData";
  address?: Maybe<DriverLicenseAddress>;
  class?: Maybe<Scalars["String"]["output"]>;
  date_of_birth: Scalars["String"]["output"];
  endorsements?: Maybe<Scalars["String"]["output"]>;
  expiration_date: Scalars["String"]["output"];
  eye_color?: Maybe<Scalars["String"]["output"]>;
  first_name: Scalars["String"]["output"];
  hair_color?: Maybe<Scalars["String"]["output"]>;
  height?: Maybe<Scalars["String"]["output"]>;
  issue_date?: Maybe<Scalars["String"]["output"]>;
  last_name: Scalars["String"]["output"];
  license_number: Scalars["String"]["output"];
  middle_name?: Maybe<Scalars["String"]["output"]>;
  restrictions?: Maybe<Scalars["String"]["output"]>;
  sex?: Maybe<Scalars["String"]["output"]>;
  state_issued: Scalars["String"]["output"];
  weight?: Maybe<Scalars["String"]["output"]>;
};

export type DriverLicenseResult = {
  __typename?: "DriverLicenseResult";
  confidence?: Maybe<Scalars["Float"]["output"]>;
  data?: Maybe<DriverLicenseData>;
  error?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type DrugNdc = {
  __typename?: "DrugNDC";
  active_ingredients: Array<ActiveIngredients>;
  appl_no?: Maybe<Scalars["String"]["output"]>;
  brand_name: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dosage_form: Scalars["String"]["output"];
  drug_id: Scalars["String"]["output"];
  generic_name: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  labeler_name?: Maybe<Scalars["String"]["output"]>;
  pharmaceutical_class: Array<Scalars["String"]["output"]>;
  product_ndc: Scalars["String"]["output"];
  product_type?: Maybe<Scalars["String"]["output"]>;
  route: Array<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DrugProducts = {
  __typename?: "DrugProducts";
  active_ingredient?: Maybe<Scalars["String"]["output"]>;
  appl_no: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  drug_name?: Maybe<Scalars["String"]["output"]>;
  form?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  ndc: DrugNdc;
  product_id: Scalars["Float"]["output"];
  product_no: Scalars["String"]["output"];
  reference_drug?: Maybe<Scalars["Float"]["output"]>;
  reference_standard?: Maybe<Scalars["Float"]["output"]>;
  resistant_genotypes?: Maybe<Array<Genotypes>>;
  status: MarketingStatus;
  strength?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DuplicateJobDefinitionCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  matchRules?: InputMaybe<Array<DuplicateJobMatchingRuleDefinitionInput>>;
  name: Scalars["String"]["input"];
  objectType: RecordMatchEntityType;
  parentObjectType?: InputMaybe<RecordMatchEntityType>;
  version?: InputMaybe<Scalars["SemVer"]["input"]>;
  versionStatus?: InputMaybe<RecordVersionStatus>;
};

export type DuplicateJobDefinitionDeleteInput = {
  definitionId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DuplicateJobDefinitionPaginatedResults = {
  __typename?: "DuplicateJobDefinitionPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<DuplicateJobDefinitions>;
  totalPages: Scalars["Float"]["output"];
};

export type DuplicateJobDefinitionUpdateInput = {
  definitionId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  matchRules?: InputMaybe<DuplicateJobMatchingRuleDefinitionActionInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  objectType?: InputMaybe<RecordMatchEntityType>;
  version?: InputMaybe<Scalars["SemVer"]["input"]>;
  versionStatus?: InputMaybe<RecordVersionStatus>;
};

export type DuplicateJobDefinitions = {
  __typename?: "DuplicateJobDefinitions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  match_rules?: Maybe<Array<RecordMatchingRules>>;
  name: Scalars["String"]["output"];
  object_type: RecordMatchEntityType;
  parent_object_type?: Maybe<RecordMatchEntityType>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["SemVer"]["output"];
  version_status: RecordVersionStatus;
};

export type DuplicateJobMatchingRuleDefinitionActionInput = {
  add?: InputMaybe<Array<DuplicateJobMatchingRuleDefinitionInput>>;
  remove?: InputMaybe<Array<DuplicateJobMatchingRuleDefinitionDeleteInput>>;
};

export type DuplicateJobMatchingRuleDefinitionDeleteInput = {
  matchRuleId: Scalars["ID"]["input"];
};

export type DuplicateJobMatchingRuleDefinitionInput = {
  matchRuleId: Scalars["ID"]["input"];
};

export type DuplicateMatchingRuleActionInput = {
  add?: InputMaybe<Array<DuplicateMatchingRuleInput>>;
  remove?: InputMaybe<Array<DuplicateMatchingRuleDeleteInput>>;
};

export type DuplicateMatchingRuleDeleteInput = {
  matchRuleId: Scalars["ID"]["input"];
};

export type DuplicateMatchingRuleInput = {
  matchRuleId: Scalars["ID"]["input"];
};

export type DuplicateRecordEntries = {
  __typename?: "DuplicateRecordEntries";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  entry_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  list: DuplicateRecordSets;
  record?: Maybe<DuplicateRecordEntryRecordUnion>;
  record_id: Scalars["ID"]["output"];
  reference: References;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DuplicateRecordEntryRecordUnion = Addresses | CynergyUsers | Demographics;

export type DuplicateRecordJobs = {
  __typename?: "DuplicateRecordJobs";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  duplicate_record_count: Scalars["Float"]["output"];
  duplicate_set_count: Scalars["Float"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  job_id: Scalars["ID"]["output"];
  scanned_count: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Available behavior actions on duplicate records */
export enum DuplicateRecordRuleAction {
  Allow = "Allow",
  Block = "Block",
}

export type DuplicateRecordRuleCreateInput = {
  actionOnInsert?: InputMaybe<DuplicateRecordRuleAction>;
  actionOnUpdate?: InputMaybe<DuplicateRecordRuleAction>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether this rule is active */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Display name for rule */
  label: Scalars["String"]["input"];
  matchRules?: InputMaybe<Array<DuplicateMatchingRuleInput>>;
  objectType: RecordMatchEntityType;
  operationOnInsert?: InputMaybe<Array<DuplicateRecordRuleOperation>>;
  operationOnUpdate?: InputMaybe<Array<DuplicateRecordRuleOperation>>;
  order?: InputMaybe<Scalars["Float"]["input"]>;
  parentObjectType?: InputMaybe<RecordMatchEntityType>;
};

export type DuplicateRecordRuleDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Available operations to perform on duplicate records */
export enum DuplicateRecordRuleOperation {
  Alert = "Alert",
  Report = "Report",
}

export type DuplicateRecordRulePaginatedResults = {
  __typename?: "DuplicateRecordRulePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<DuplicateRecordRules>;
  totalPages: Scalars["Float"]["output"];
};

export type DuplicateRecordRuleUpdateInput = {
  actionOnInsert?: InputMaybe<DuplicateRecordRuleAction>;
  actionOnUpdate?: InputMaybe<DuplicateRecordRuleAction>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether this rule is active */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Display name for rule */
  label?: InputMaybe<Scalars["String"]["input"]>;
  matchRules?: InputMaybe<DuplicateMatchingRuleActionInput>;
  operationOnInsert?: InputMaybe<Array<DuplicateRecordRuleOperation>>;
  operationOnUpdate?: InputMaybe<Array<DuplicateRecordRuleOperation>>;
  order?: InputMaybe<Scalars["Float"]["input"]>;
  ruleId: Scalars["ID"]["input"];
};

export type DuplicateRecordRules = {
  __typename?: "DuplicateRecordRules";
  active: Scalars["Boolean"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  match_rules?: Maybe<Array<RecordMatchingRules>>;
  object_type: RecordMatchEntityType;
  parent_object_type: RecordMatchEntityType;
  rule_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DuplicateRecordSetPaginatedResults = {
  __typename?: "DuplicateRecordSetPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<DuplicateRecordSets>;
  totalPages: Scalars["Float"]["output"];
};

export type DuplicateRecordSetParentUnion = DuplicateRecordJobs | DuplicateRecordRules;

export type DuplicateRecordSets = {
  __typename?: "DuplicateRecordSets";
  count: Scalars["Float"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  entries?: Maybe<Array<DuplicateRecordEntries>>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  object_type: RecordMatchEntityType;
  parent?: Maybe<DuplicateRecordSetParentUnion>;
  set_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type DurationCreateInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  maxDuration?: InputMaybe<Scalars["Float"]["input"]>;
  unit: UnitsOfTime;
};

export type DurationUpdateInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  durationId: Scalars["ID"]["input"];
  maxDuration?: InputMaybe<Scalars["Float"]["input"]>;
  unit?: InputMaybe<UnitsOfTime>;
};

export type DurationUpsertInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  durationId?: InputMaybe<Scalars["ID"]["input"]>;
  maxDuration?: InputMaybe<Scalars["Float"]["input"]>;
  unit?: InputMaybe<UnitsOfTime>;
};

export type Durations = {
  __typename?: "Durations";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  duration: Scalars["Float"]["output"];
  duration_id: Scalars["ID"]["output"];
  duration_max?: Maybe<Scalars["Float"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  unit: UnitsOfTime;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EmployeeAssignmentReleaseInput = {
  /** Remove all assignments associated with employee within this organization? */
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Specify assignments to be removed */
  assignments?: InputMaybe<Array<StaffAssignmentDeleteInput>>;
  staffId: Scalars["ID"]["input"];
};

export type EmployeePaginatedResults = {
  __typename?: "EmployeePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<StaffAssignments>;
  totalPages: Scalars["Float"]["output"];
};

/** List of employment status codes. */
export enum EmploymentStatus {
  Active = "ACTIVE",
  Affiliate = "AFFILIATE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Restricted = "RESTRICTED",
  Suspended = "SUSPENDED",
  UnderReview = "UNDER_REVIEW",
}

export type EncounterAdmissionSource = Locations | Organizations;

export type EncounterAdmissions = {
  __typename?: "EncounterAdmissions";
  /** From where patient was admitted (physician referral, transfer) */
  admit_source: EncounterAdmitSource;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Location/organization to which the patient is discharged */
  destination: EncounterAdmissionSource;
  /** Category or kind of location after discharge */
  discharge_disposition?: Maybe<DischargeDisposition>;
  is_archived: Scalars["Boolean"]["output"];
  /** Details about the admission to a healthcare service */
  origin: EncounterAdmissionSource;
  pre_admission_identifier?: Maybe<Identifiers>;
  /** Indicates that the patient is being re-admitted */
  readmission: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR encounter admit source codes. */
export enum EncounterAdmitSource {
  /** The patient is a newborn and the encounter will track the baby related activities (as opposed to the Mothers encounter - that may be associated using the newborn encounters partof property) */
  Born = "BORN",
  /** The patient has been transferred from the emergency department within the hospital. This is typically used in the transition to an inpatient encounter */
  Emd = "EMD",
  /** The patient has been admitted due to a referred from a General Practitioner. */
  Gp = "GP",
  /** The Patient has been transferred from another hospital for this encounter. */
  HospTrans = "HOSP_TRANS",
  /** The patient has been admitted due to a referred from a Specialist (as opposed to a General Practitioner). */
  Mp = "MP",
  /** The patient has been transferred from a nursing home. */
  Nursing = "NURSING",
  /** The patient has been admitted from a source otherwise not specified here. */
  Other = "OTHER",
  /** The patient has been transferred from an outpatient department within the hospital. */
  Outp = "OUTP",
  /** The patient has been transferred from a psychiatric facility. */
  Psych = "PSYCH",
  /** The patient has been transferred from a rehabilitation facility or clinic. */
  Rehab = "REHAB",
}

export type EncounterBasedOn = CarePlans | ServiceRequests;

/** All possible FHIR encounter class codes. */
export enum EncounterClass {
  /** A comprehensive term for health care provided in a healthcare facility (e.g. a practitioneraTMs office, clinic setting, or hospital) on a nonresident basis. The term ambulatory usually implies that the patient has come to the location and is not assigned to a bed. Sometimes referred to as an outpatient encounter. */
  Amb = "AMB",
  /** A patient encounter that takes place at a dedicated healthcare service delivery location where the patient receives immediate evaluation and treatment, provided until the patient can be discharged or responsibility for the patient's care is transferred elsewhere (for example, the patient could be admitted as an inpatient or transferred to another facility.) */
  Emer = "EMER",
  /** Healthcare encounter that takes place in the residence of the patient or a designee */
  Hh = "HH",
  /** A patient encounter where a patient is admitted by a hospital or equivalent facility, assigned to a location where patients generally stay at least overnight and provided with room, board, and continuous nursing service. */
  Imp = "IMP",
  /** An encounter where the patient usually will start in different encounter, such as one in the emergency department (EMER) but then transition to this type of encounter because they require a significant period of treatment and monitoring to determine whether or not their condition warrants an inpatient admission or discharge. In the majority of cases the decision about admission or discharge will occur within a time period determined by local, regional or national regulation, often between 24 and 48 hours. */
  Obsenc = "OBSENC",
  /** A patient encounter where the patient and the practitioner(s) are not in the same physical location. Examples include telephone conference, email exchange, robotic surgery, and televideo conference. */
  Vr = "VR",
}

export type EncounterDiagnosis = {
  __typename?: "EncounterDiagnosis";
  /** Diagnosis relevant to the encounter. */
  condition: EncounterDiagnosisCondition;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EncounterDiagnosisCondition = Conditions | Icd10;

/** All possible FHIR encounter diet codes. */
export enum EncounterDiet {
  /** Excludes dairy products. */
  DairyFree = "DAIRY_FREE",
  /** Excludes ingredients containing gluten. */
  GlutenFree = "GLUTEN_FREE",
  /** Foods that conform to Islamic law. */
  Halal = "HALAL",
  /** Foods that conform to Jewish dietary law. */
  Kosher = "KOSHER",
  /** Excludes ingredients containing nuts. */
  NutFree = "NUT_FREE",
  /** Food without meat, poultry, seafood, eggs, dairy products and other animal-derived substances. */
  Vegan = "VEGAN",
  /** Food without meat, poultry or seafood. */
  Vegetarian = "VEGETARIAN",
}

/** All possible FHIR encounter location status codes. */
export enum EncounterLocationStatus {
  /** The patient is currently at this location, or was between the period specified. A system may update these records when the patient leaves the location to either reserved, or completed. */
  Active = "ACTIVE",
  /**
   * The patient was at this location during the period specified.
   *
   * Not to be used when the patient is currently at the location.
   */
  Completed = "COMPLETED",
  /** The patient is planned to be moved to this location at some point in the future. */
  Planned = "PLANNED",
  /** This location is held empty for this patient. */
  Reserved = "RESERVED",
}

export type EncounterLocations = {
  __typename?: "EncounterLocations";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  form: LocationPhysicalType;
  is_archived: Scalars["Boolean"]["output"];
  /** Location the encounter takes place */
  location: Locations;
  /** Time period during which the patient was present at the location */
  period?: Maybe<Periods>;
  status: EncounterLocationStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EncounterPaginatedResponse = {
  __typename?: "EncounterPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<EncounterResults>;
  totalPages: Scalars["Float"]["output"];
};

export type EncounterParticipants = {
  __typename?: "EncounterParticipants";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encounter: Encounters;
  is_archived: Scalars["Boolean"]["output"];
  /** Period of time during the encounter that the participant participated */
  period?: Maybe<Periods>;
  /** Practitioner participating in the encounter. */
  practitioner: StaffAssignments;
  /** Role of participant in encounter */
  type: ParticipantType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EncounterReasonReference = Conditions | Observations | Procedures;

/** All possible FHIR encounter reason use codes. */
export enum EncounterReasonUse {
  Ad = "AD",
  Cc = "CC",
  Hc = "HC",
  Hm = "HM",
  Rv = "RV",
}

export type EncounterReasons = {
  __typename?: "EncounterReasons";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Reason the encounter takes place (coding) */
  reason_code: Scalars["String"]["output"];
  /** Reason the encounter takes place (if reference) */
  reason_reference?: Maybe<EncounterReasonReference>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  use: EncounterReasonUse;
};

export type EncounterResults = EncounterAdmissions | EncounterDiagnosis | EncounterLocations | EncounterParticipants | EncounterReasons | Encounters;

/** All possible FHIR encounter special arrangement codes */
export enum EncounterSpecialArrangements {
  /** An additional bed made available for a person accompanying the patient, for example a parent accompanying a child. */
  AddBed = "ADD_BED",
  /** A person who accompanies a patient to provide assistive services necessary for the patient's care during the encounter. */
  Att = "ATT",
  /** The patient has a guide dog and the location used for the encounter should be able to support the presence of the service animal. */
  Dog = "DOG",
  /** The patient is not fluent in the local language and requires an interpreter to be available. Refer to the Patient.Language property for the type of interpreter required. */
  Int = "INT",
  /** The patient requires a wheelchair to be made available for the encounter. */
  Wheel = "WHEEL",
}

/** All possible FHIR encounter special courtesy codes. */
export enum EncounterSpecialCourtesy {
  Ext = "EXT",
  Nrm = "NRM",
  Prf = "PRF",
  Stf = "STF",
  Vip = "VIP",
}

/** All possible encounter statuses */
export enum EncounterStatus {
  /** The Encounter has ended before it has begun. */
  Cancelled = "CANCELLED",
  /** The Encounter has ended. */
  Completed = "COMPLETED",
  /** The Encounter has been clinically completed, the patient has been discharged from the facility or the visit has ended, and the patient may have departed (refer to subjectStatus). While the encounter is in this status, administrative activities are usually performed, collating all required documentation and charge information before being released for billing, at which point the status will move to completed. */
  Discharged = "DISCHARGED",
  /** The Encounter has started, but was not able to be completed. Further action may need to be performed, such as rescheduling appointments related to this encounter. */
  Discontinued = "DISCONTINUED",
  /** This instance should not have been part of this patient's medical record. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The Encounter has begun and the patient is present / the practitioner and the patient are meeting. */
  InProgress = "IN_PROGRESS",
  /** The Encounter has begun, but is currently on hold, e.g. because the patient is temporarily on leave. */
  OnHold = "ON_HOLD",
  /** The Encounter has not yet started. */
  Planned = "PLANNED",
  /** The encounter status is unknown. Note that "unknown" is a value of last resort and every attempt should be made to provide a meaningful value other than "unknown". */
  Unknown = "UNKNOWN",
}

export type EncounterSubject = Groups | Patients;

/** All possible FHIR encounter subject status codes */
export enum EncounterSubjectStatus {
  /** The subject has arrived at the physical or virtual location and is ready to receive care. */
  Arrived = "ARRIVED",
  /** The subject has left the physical or virtual location, and is not expected to return as part of this encounter. */
  Departed = "DEPARTED",
  /** The subject has left the physical or virtual location, but is expected to return and resume care as part of this encounter. */
  OnLeave = "ON_LEAVE",
  /** The subject is present and commenced receiving care. This can include periods of waiting between care. */
  ReceivingCare = "RECEIVING_CARE",
  /** The subject has been seen triaged by staff and is waiting for further care. */
  Triaged = "TRIAGED",
}

export type Encounters = {
  __typename?: "Encounters";
  /** The actual start and end time of the encounter */
  actual_period?: Maybe<Periods>;
  /** Details about the admission to a healthcare service. */
  admission?: Maybe<EncounterAdmissions>;
  appointment_id?: Maybe<Scalars["ID"]["output"]>;
  based_on?: Maybe<EncounterBasedOn>;
  /** The group(s) of individuals, organizations that are allocated to participate in this encounter. The participants backbone will record the actuals of when these individuals participated during the encounter. */
  care_team?: Maybe<CareTeams>;
  /** Classification of patient encounter context - e.g. Inpatient, outpatient */
  class: EncounterClass;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  diagnosis?: Maybe<Array<EncounterDiagnosis>>;
  /** Diet preferences reported by the patient. */
  diet_preference?: Maybe<EncounterDiet>;
  encounter_id: Scalars["String"]["output"];
  /** Episode(s) of care that this encounter should be recorded against */
  episode_of_care?: Maybe<EpisodeOfCare>;
  /** Key events in history of the Encounter */
  history?: Maybe<Array<Provenances>>;
  is_archived: Scalars["Boolean"]["output"];
  /** List of locations where the patient has been. */
  locations?: Maybe<Array<EncounterLocations>>;
  observations?: Maybe<Array<Observations>>;
  part_of?: Maybe<Encounters>;
  /** List of participants involved in the encounter */
  participants: Array<EncounterParticipants>;
  /** The planned start date/time (or admission date) of the encounter */
  planned_end_date?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** The planned start date/time (or admission date) of the encounter */
  planned_start_date: Scalars["GraphQLDateTime"]["output"];
  /** Indicates the urgency of the encounter */
  priority: ActPriority;
  reasons: Array<EncounterReasons>;
  /** The organization (facility) responsible for this encounter */
  service_provider: Organizations;
  /** Broad categorization of the service that is to be provided (e.g. cardiology). */
  service_type: Scalars["String"]["output"];
  /** Any special requests that have been made for this encounter, such as the provision of specific equipment or other things. */
  special_arrangement?: Maybe<EncounterSpecialArrangements>;
  /** Special courtesies that may be provided to the patient during the encounter (VIP, board member, professional courtesy). */
  special_courtesy?: Maybe<EncounterSpecialCourtesy>;
  status: EncounterStatus;
  subject: EncounterSubject;
  /** The current status of the subject in relation to the Encounter */
  subject_status: EncounterSubjectStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Connection details of a virtual service (e.g. conference call). */
  virtual_service?: Maybe<VirtualServiceDetails>;
};

export type EndpointConfigResponse = {
  __typename?: "EndpointConfigResponse";
  /** Endpoint config UUID */
  endpointConfigId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type EndpointCredentialCreateInput = {
  /** Should an authorization header be automatically generated on each callout? */
  autoGenerateAuthorizationHeader?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Definition this instance conforms to */
  credentialDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Human friendly label for endpoint credential */
  label: Scalars["String"]["input"];
  /** Indicates if request fields should be merged with context data */
  mergeRequestFields?: InputMaybe<Scalars["Boolean"]["input"]>;
  parameters: Array<EndpointCredentialParameterInput>;
};

export type EndpointCredentialDefinitionCreateInput = {
  parameters: Array<EndpointCredentialParameterDefinitionInput>;
};

export type EndpointCredentialDefinitions = {
  __typename?: "EndpointCredentialDefinitions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly name */
  label?: Maybe<Scalars["String"]["output"]>;
  parameters: Array<EndpointCredentialParameterDefinitions>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Definition version */
  version: Scalars["String"]["output"];
  version_status: RecordVersionStatus;
};

export type EndpointCredentialParameterActionInput = {
  add?: InputMaybe<Array<EndpointCredentialParameterInput>>;
  remove?: InputMaybe<EndpointCredentialParameterBulkDeleteInput>;
  update?: InputMaybe<EndpointCredentialParameterUpdateInput>;
};

export type EndpointCredentialParameterBulkDeleteInput = {
  endpointCredentialId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  parameters: Array<EndpointParameterIdentifierInput>;
};

export type EndpointCredentialParameterDefinitionInput = {
  apiName: Scalars["String"]["input"];
  /** When "type" is "Authentication", this field must be provided. Authentication details to an external system */
  authenticationCredential?: InputMaybe<ExternalCredentialCreateInput>;
  /** Brief description of credential parameter */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates if this is a required parameter (Default: true) */
  isRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Linking mechanism conforming parameter instances use */
  linkId?: InputMaybe<Scalars["String"]["input"]>;
  /** Human friendly parameter name */
  name: Scalars["String"]["input"];
  /** Sort order of credential parameter */
  sequence?: InputMaybe<Scalars["Float"]["input"]>;
  /** Type of credential parameter */
  type: CredentialEndpointParameterType;
};

export type EndpointCredentialParameterDefinitions = {
  __typename?: "EndpointCredentialParameterDefinitions";
  api_name: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Brief description of credential parameter */
  description?: Maybe<Scalars["String"]["output"]>;
  external_credential?: Maybe<ExternalCredentials>;
  is_archived: Scalars["Boolean"]["output"];
  link_id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  parameter_definition_id: Scalars["ID"]["output"];
  required: Scalars["Boolean"]["output"];
  /** Order of parameter in http header */
  sequence?: Maybe<Scalars["Float"]["output"]>;
  /** Type of credential parameter */
  type: CredentialEndpointParameterType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EndpointCredentialParameterInput = {
  /** Brief description of credential parameter (IAM Endpoint, AWS Auth, Cert, etc) */
  description?: InputMaybe<Scalars["String"]["input"]>;
  externalCredential?: InputMaybe<ExternalCredentialCreateInput>;
  /** Links conforming parameter instance to its parameter definition */
  linkId?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of credential parameter (parameter key) */
  parameterKey: Scalars["String"]["input"];
  /** Value of parameter (if applicable) */
  parameterValue?: InputMaybe<Scalars["String"]["input"]>;
  /** Order of parameter */
  sequence?: InputMaybe<Scalars["Float"]["input"]>;
  type: CredentialEndpointParameterType;
};

export type EndpointCredentialParameterUpdateInput = {
  /** Brief description of credential parameter (IAM Endpoint, AWS Auth, Cert, etc) */
  description?: InputMaybe<Scalars["String"]["input"]>;
  externalCredential?: InputMaybe<ExternalCredentialUpdateInput>;
  /** Links conforming parameter instance to its parameter definition */
  linkId?: InputMaybe<Scalars["String"]["input"]>;
  parameterId: Scalars["ID"]["input"];
  /** Name of credential (parameter key) */
  parameterKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Value of parameter (if applicable) */
  parameterValue?: InputMaybe<Scalars["String"]["input"]>;
  /** Order of parameter */
  sequence?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<CredentialEndpointParameterType>;
};

export type EndpointCredentialParameters = {
  __typename?: "EndpointCredentialParameters";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Brief description of credential parameter */
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  link_id?: Maybe<Scalars["String"]["output"]>;
  /** Name of credential parameter */
  name: Scalars["String"]["output"];
  /** Order of parameter in http header */
  sequence?: Maybe<Scalars["Float"]["output"]>;
  /** Type of credential parameter */
  type: CredentialEndpointParameterType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Value of parameter (if applicable) */
  value?: Maybe<Scalars["String"]["output"]>;
};

export type EndpointCredentialUpdateInput = {
  /** Should an authorization header be automatically generated on each callout? */
  autoGenerateAuthorizationHeader?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Definition this instance conforms to */
  credentialDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
  credentialId: Scalars["ID"]["input"];
  /** Human friendly label for endpoint credential */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates if request fields should be merged with context data */
  mergeRequestFields?: InputMaybe<Scalars["Boolean"]["input"]>;
  parameters?: InputMaybe<EndpointCredentialParameterActionInput>;
};

export type EndpointCredentials = {
  __typename?: "EndpointCredentials";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  credential_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Definition this instance conforms to */
  instantiates?: Maybe<EndpointCredentialDefinitions>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly label for endpoint credential */
  label: Scalars["String"]["output"];
  /** Endpoint parameter(s) used to configure endpoint credentials */
  parameters?: Maybe<Array<EndpointCredentialParameters>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EndpointParameterIdentifierInput = {
  parameterId: Scalars["ID"]["input"];
};

export type EndpointResponse = {
  __typename?: "EndpointResponse";
  /** Endpoint UUID */
  endpointId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type EpisodeOfCare = {
  __typename?: "EpisodeOfCare";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  diagnosis?: Maybe<Array<Conditions>>;
  diagnosis_role: DiagnosisRoleCodes;
  episode_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  managing_organization: Organizations;
  patient: Patients;
  period?: Maybe<Periods>;
  referral_request?: Maybe<ServiceRequests>;
  status: EpisodeOfCareStatus;
  type: EpisodeOfCareType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EpisodeOfCareCreateInput = {
  carePeriod?: InputMaybe<CarePeriodInput>;
  diagnosisRole?: InputMaybe<DiagnosisRoleCodes>;
  patientId: Scalars["String"]["input"];
  serviceRequestID?: InputMaybe<Scalars["String"]["input"]>;
  status: EpisodeOfCareStatus;
  type: EpisodeOfCareType;
};

/** All possible FHIR Episode of care status codes */
export enum EpisodeOfCareStatus {
  /** This episode of care is current. */
  Active = "ACTIVE",
  /** The episode of care was cancelled, or withdrawn from service, often selected during the planned stage as the patient may have gone elsewhere, or the circumstances have changed and the organization is unable to provide the care. It indicates that services terminated outside the planned/expected workflow. */
  Cancelled = "CANCELLED",
  /** This instance should not have been part of this patient's medical record. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** This episode of care is finished and the organization is not expecting to be providing further care to the patient. Can also be known as "closed", "completed" or other similar terms. */
  Finished = "FINISHED",
  /** This episode of care is on hold; the organization has limited responsibility for the patient (such as while on respite). */
  OnHold = "ON_HOLD",
  /** This episode of care is planned to start at the date specified in the period.start. During this status, an organization may perform assessments to determine if the patient is eligible to receive services, or be organizing to make resources available to provide care services. */
  Planned = "PLANNED",
  /** This episode has been placed on a waitlist, pending the episode being made active (or cancelled). */
  Waitlist = "WAITLIST",
}

/** All possible FHIR Episode of care types */
export enum EpisodeOfCareType {
  Cacp = "CACP",
  Da = "DA",
  Diab = "DIAB",
  Hacc = "HACC",
  Pac = "PAC",
}

export type EpisodeOfCareUpdateInput = {
  carePeriod?: InputMaybe<CarePeriodInput>;
  diagnosisRole?: InputMaybe<DiagnosisRoleCodes>;
  episodeID: Scalars["String"]["input"];
  serviceRequestID?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<EpisodeOfCareStatus>;
  type?: InputMaybe<EpisodeOfCareType>;
};

/** List of error severity types */
export enum ErrorSeverityType {
  Error = "ERROR",
  Info = "INFO",
  Warning = "WARNING",
}

export type EventCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Date and time the event is to conclude */
  endDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  eventDate: Scalars["GraphQLDateTime"]["input"];
  eventType: Scalars["String"]["input"];
  isAllDayEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Where the event is to occur */
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  series?: InputMaybe<EventSeriesInput>;
  /** Date and time the event is to occur */
  startDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  what?: InputMaybe<ReferenceCreateInput>;
  who: ReferenceCreateInput;
};

export type EventMeta = {
  address: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  location: Scalars["String"]["input"];
  participants?: InputMaybe<Array<EventParticipantsInput>>;
  phone: Scalars["String"]["input"];
  type: CalendarEventTypes;
};

export type EventMetaType = {
  __typename?: "EventMetaType";
  address: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  location: Scalars["String"]["output"];
  participants?: Maybe<Array<EventParticipantsType>>;
  phone: Scalars["String"]["output"];
  type: CalendarEventTypes;
};

export type EventPaginatedResults = {
  __typename?: "EventPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Events>;
  totalPages: Scalars["Float"]["output"];
};

export type EventParticipantsInput = {
  label: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type EventParticipantsType = {
  __typename?: "EventParticipantsType";
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type EventSeries = {
  __typename?: "EventSeries";
  account_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Event end time */
  end_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The pattern by which events in this series should occur */
  pattern: RecurrencePatterns;
  series_id: Scalars["ID"]["output"];
  /** Event start time */
  start_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  status: EventSeriesStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type EventSeriesBulkDeactivateInput = {
  /** Indicates whether future occurrences should be removed. By default, future occurrences are converted to standalone events. */
  disposePlannedOccurrences?: InputMaybe<Scalars["Boolean"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  seriesIds: Array<Scalars["ID"]["input"]>;
};

export type EventSeriesBulkDeactivateResult = {
  __typename?: "EventSeriesBulkDeactivateResult";
  /** Number of series successfully deactivated */
  deactivatedCount: Scalars["Int"]["output"];
  /** Series that could not be deactivated (already deleted, or not authorized) */
  failedSeriesIds: Array<Scalars["ID"]["output"]>;
};

export type EventSeriesDeactivateInput = {
  /** Indicates whether future occurrences should be removed. By default, future occurrences are converted to standalone events. */
  disposePlannedOccurrences?: InputMaybe<Scalars["Boolean"]["input"]>;
  seriesId: Scalars["ID"]["input"];
};

export type EventSeriesInput = {
  /** Event end time */
  endTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  recurrence: RecurrencePatternCreateInput;
  /** Event start time */
  startTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status?: InputMaybe<EventSeriesStatus>;
};

/** Code options for status of event series */
export enum EventSeriesStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
}

export type EventSeriesUpdateInput = {
  /** Event end time */
  endTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  recurrence?: InputMaybe<RecurrencePatternCreateInput>;
  seriesId: Scalars["ID"]["input"];
  /** Event start time */
  startTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status?: InputMaybe<EventSeriesStatus>;
};

/** All possible FHIR event status codes. */
export enum EventStatuses {
  /** The event has concluded */
  Completed = "COMPLETED",
  /** This electronic record should never have existed, though it is possible that real-world decisions were based on it. (If real-world activity has occurred, the status should be "stopped" rather than "entered-in-error".). */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The event is currently occuring. */
  InProgress = "IN_PROGRESS",
  /** The event was terminated prior to any activity beyond preparation. I.e. The "main" activity has not yet begun. The boundary between preparatory and the "main" activity is context-specific. */
  NotDone = "NOT_DONE",
  /** The event has been temporarily stopped but is expected to resume in the future. */
  OnHold = "ON_HOLD",
  /** The core event has not started yet, but some staging activities have begun (e.g. surgical suite preparation). Preparation stages may be tracked for billing purposes. */
  Preparation = "PREPARATION",
  /** The event was terminated prior to the full completion of the intended activity but after at least some of the "main" activity (beyond preparation) has occurred. */
  Stopped = "STOPPED",
  /** The authoring/source system does not know which of the status values currently applies for this event. Note: This concept is not to be used for "other" - one of the listed statuses is presumed to apply, but the authoring/source system does not know which. */
  Unknown = "UNKNOWN",
}

export type EventTime = {
  day: Scalars["DateTime"]["input"];
  end: Scalars["DateTime"]["input"];
  start: Scalars["DateTime"]["input"];
};

/** All possible FHIR event timing codes. */
export enum EventTimings {
  Ac = "AC",
  Acd = "ACD",
  Acm = "ACM",
  Acv = "ACV",
  Aft = "AFT",
  AftEarly = "AFT_early",
  AftLate = "AFT_late",
  C = "C",
  Cd = "CD",
  Cm = "CM",
  Cv = "CV",
  Eve = "EVE",
  EveEarly = "EVE_early",
  EveLate = "EVE_late",
  Hs = "HS",
  Imd = "IMD",
  Morn = "MORN",
  MornEarly = "MORN_early",
  MornLate = "MORN_late",
  Night = "NIGHT",
  Noon = "NOON",
  Pc = "PC",
  Pcd = "PCD",
  Pcm = "PCM",
  Pcv = "PCV",
  Phs = "PHS",
  Wake = "WAKE",
}

export type EventUpdateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Date and time the event is to conclude */
  endDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  eventDate?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  eventId: Scalars["ID"]["input"];
  isAllDayEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Where the event is to occur */
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  series?: InputMaybe<EventSeriesInput>;
  /** Date and time the event is to occur */
  startDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  what?: InputMaybe<ReferenceUpsertInput>;
  who?: InputMaybe<ReferenceUpdateInput>;
};

export type Events = {
  __typename?: "Events";
  account_id: Scalars["ID"]["output"];
  /** Indicates whether this event spans the whole day */
  all_day_event: Scalars["Boolean"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Description of event */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Date and time the event ends */
  end_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Date the event is to occur */
  event_date: Scalars["DateTime"]["output"];
  event_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  location_id?: Maybe<Scalars["ID"]["output"]>;
  /** Name of event */
  name: Scalars["String"]["output"];
  /** Indicates whether this event repeats itself */
  repeats: Scalars["Boolean"]["output"];
  /** Date and time the event is to start */
  start_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  type: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  what?: Maybe<References>;
  who: References;
};

export type ExploreFilesResponse = {
  __typename?: "ExploreFilesResponse";
  errors?: Maybe<Array<FieldError>>;
  message: Scalars["String"]["output"];
  paths?: Maybe<Array<Bucket>>;
  status: Scalars["Float"]["output"];
};

export type ExpoNotificationReceipts = {
  __typename?: "ExpoNotificationReceipts";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  error_code: ExpoPushReceiptErrors;
  expo_notification_ticket?: Maybe<ExpoNotificationTickets>;
  expo_receipt_id: Scalars["String"]["output"];
  failure_reason: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  status: NotificationStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  used: Scalars["Boolean"]["output"];
};

export type ExpoNotificationTickets = {
  __typename?: "ExpoNotificationTickets";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  creation_failed: Scalars["Boolean"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  error_code?: Maybe<ExpoPushTicketErrors>;
  expo_notification_receipt: ExpoNotificationReceipts;
  expo_notification_token?: Maybe<ExpoNotificationTokens>;
  expo_receipt_id: Scalars["String"]["output"];
  expo_token_id: Scalars["String"]["output"];
  failure_reason?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  notification: Notifications;
  notification_id: Scalars["String"]["output"];
  processed: Scalars["Boolean"]["output"];
  status: NotificationStatus;
  ticket_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ExpoNotificationTokenInput = {
  expoPushToken: Scalars["String"]["input"];
  /** Indicate MyCynegy with null or specify MyCYnergy Hub with a fixed ID. */
  mobileSoftwareId?: InputMaybe<Scalars["String"]["input"]>;
  /** Device type of the Token Generation. */
  tokenGenerationDevice: MobileDeviceType;
};

export type ExpoNotificationTokens = {
  __typename?: "ExpoNotificationTokens";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  expo_notification_tickets?: Maybe<Array<ExpoNotificationTickets>>;
  expo_push_token: Scalars["String"]["output"];
  expo_token_id: Scalars["String"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Indicate MyCynegy with null or specify MyCYnergy Hub with a fixed ID. */
  mobile_software_id?: Maybe<Scalars["String"]["output"]>;
  /** Device type of the Token Generation. */
  token_generation_device: MobileDeviceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Push Receipt Error */
export enum ExpoPushReceiptErrors {
  DeveloperError = "DEVELOPER_ERROR",
  DeviceNotRegistered = "DEVICE_NOT_REGISTERED",
  ExpoError = "EXPO_ERROR",
  InvalidCredentials = "INVALID_CREDENTIALS",
  MessageRateExceeded = "MESSAGE_RATE_EXCEEDED",
  MessageTooBig = "MESSAGE_TOO_BIG",
  MismatchSenderId = "MISMATCH_SENDER_ID",
  ProviderError = "PROVIDER_ERROR",
}

/** Push Ticket Error */
export enum ExpoPushTicketErrors {
  DeviceNotRegistered = "DEVICE_NOT_REGISTERED",
}

export type ExpressionCreateInput = {
  /** Text based condition for which the the expression is valid. */
  condition?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Expression in specified language */
  expression: Scalars["String"]["input"];
  language: ExpressionLanguage;
  /** Short name assigned to expression for reuse */
  name: Scalars["String"]["input"];
  /** Where the expression is found */
  referenceUri?: InputMaybe<Scalars["String"]["input"]>;
  /** Defined data requirements needed to resolve this expression */
  requirements?: InputMaybe<Array<DataRequirementCreateInput>>;
};

/** All possible FHIR expression language codes. */
export enum ExpressionLanguage {
  /** Clinical Quality Language */
  Cql = "CQL",
  /** A Clinical Quality Language expression */
  CqlExpression = "CQL_EXPRESSION",
  /** A Clinical Quality Language identifier, typically the name of a top-level definition within a library */
  CqlIdentifier = "CQL_IDENTIFIER",
  /** FHIRPath */
  FhirPath = "FHIR_PATH",
  /** FHIR's RESTful query syntax - typically independent of base URL */
  FhirQuery = "FHIR_QUERY",
  IcalendarExpression = "ICALENDAR_EXPRESSION",
}

export type Expressions = {
  __typename?: "Expressions";
  /** Text based condition for which the the expression is valid. */
  condition?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** Expression in specified language */
  expression: Scalars["String"]["output"];
  expression_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  language: ExpressionLanguage;
  /** Short name assigned to expression for reuse */
  name: Scalars["String"]["output"];
  /** Where the expression is found (uri) */
  reference?: Maybe<Scalars["String"]["output"]>;
  /** Defined data requirements needed to resolve this expression */
  requirements?: Maybe<Array<DataRequirements>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalCodeMappingResponse = {
  __typename?: "ExternalCodeMappingResponse";
  /** External code mapping UUID */
  externalCodeMappingId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalCredentialCreateInput = {
  /** Human friendly label for credential */
  label: Scalars["String"]["input"];
  parameters?: InputMaybe<Array<ExternalCredentialParameterInput>>;
  /** Authentication protocol required for connection to external system */
  protocol: AuthenticationProtocolType;
};

export type ExternalCredentialParameterActionInput = {
  add?: InputMaybe<Array<ExternalCredentialParameterInput>>;
  remove?: InputMaybe<ExternalCredentialParameterBulkDeleteInput>;
  update?: InputMaybe<ExternalCredentialParameterUpdateInput>;
};

export type ExternalCredentialParameterBulkDeleteInput = {
  externalCredentialId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  parameters: Array<ExternalParameterIdentifierInput>;
};

export type ExternalCredentialParameterInput = {
  /** Brief description of credential parameter (IAM Endpoint, AWS Auth, Cert, etc) */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of credential parameter (parameter key) */
  parameterKey: Scalars["String"]["input"];
  /** Value of parameter (if applicable) */
  parameterValue?: InputMaybe<Scalars["String"]["input"]>;
  /** Order of parameter */
  sequence?: InputMaybe<Scalars["Float"]["input"]>;
  type: ExternalEndpointCredentialsParameters;
};

export type ExternalCredentialParameterUpdateInput = {
  /** Brief description of credential parameter (IAM Endpoint, AWS Auth, Cert, etc) */
  description?: InputMaybe<Scalars["String"]["input"]>;
  parameterId: Scalars["ID"]["input"];
  /** Name of credential parameter (parameter key) */
  parameterKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Value of parameter (if applicable) */
  parameterValue?: InputMaybe<Scalars["String"]["input"]>;
  /** Order of parameter */
  sequence?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<ExternalEndpointCredentialsParameters>;
};

export type ExternalCredentialParameters = {
  __typename?: "ExternalCredentialParameters";
  /** Third-party authenticator provider such as Apple, Google, Github */
  authentication_provider?: Maybe<Scalars["String"]["output"]>;
  /** Credential certificate */
  certificate?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  credential: ExternalCredentials;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Brief description of credential parameter */
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name of credential parameter */
  name: Scalars["String"]["output"];
  /** Permission set pointer, this determines the users who are allowed to use credentials provided by the provider. */
  principal?: Maybe<Scalars["String"]["output"]>;
  /** Order of principals. */
  sequence: Scalars["Float"]["output"];
  /** Type of credential parameter */
  type: ExternalEndpointCredentialsParameters;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Parameter value */
  value?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalCredentialUpdateInput = {
  credentialId: Scalars["ID"]["input"];
  /** Human friendly label for credential */
  label?: InputMaybe<Scalars["String"]["input"]>;
  parameters?: InputMaybe<ExternalCredentialParameterActionInput>;
  /** Authentication protocol required for connection to external system */
  protocol?: InputMaybe<AuthenticationProtocolType>;
};

export type ExternalCredentials = {
  __typename?: "ExternalCredentials";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  credential_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly label for external credential */
  label: Scalars["String"]["output"];
  /** Parameter(s) that further configure the external credential */
  parameters?: Maybe<Array<ExternalCredentialParameters>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalDiagnosticResultResponse = {
  __typename?: "ExternalDiagnosticResultResponse";
  /** File location of the uploaded patient result */
  attachmentURLs?: Maybe<Array<Scalars["String"]["output"]>>;
  /** UUID of the operation outcome */
  outcomeId?: Maybe<Scalars["String"]["output"]>;
  /** Status of file upload */
  response?: Maybe<Scalars["String"]["output"]>;
};

/** Credential parameter types of an external endpoint parameter */
export enum ExternalEndpointCredentialsParameters {
  AuthEndpointUrl = "AuthEndpointUrl",
  AuthHeader = "AuthHeader",
  AuthParameter = "AuthParameter",
  AuthProtocolVariant = "AuthProtocolVariant",
  AuthProvider = "AuthProvider",
  AuthProviderUrlQueryParams = "AuthProviderUrlQueryParams",
  AwsStsPrincipal = "AwsStsPrincipal",
  JwtBodyClaim = "JwtBodyClaim",
  JwtHeaderClaim = "JwtHeaderClaim",
  NamedPrincipal = "NamedPrincipal",
  PerUserPrincipal = "PerUserPrincipal",
  SigningCertificate = "SigningCertificate",
}

export type ExternalOrderResponse = {
  __typename?: "ExternalOrderResponse";
  /** UUID of the operation outcome */
  outcomeId?: Maybe<Scalars["String"]["output"]>;
  /** Status of file upload */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalParameterIdentifierInput = {
  parameterId: Scalars["ID"]["input"];
};

export type ExternalServiceRequestResponse = {
  __typename?: "ExternalServiceRequestResponse";
  /** File location of the uploaded patient result */
  attachmentURLs?: Maybe<Array<Scalars["String"]["output"]>>;
  /** UUID of the operation outcome */
  outcomeId?: Maybe<Scalars["String"]["output"]>;
  /** Status of file upload */
  response?: Maybe<Scalars["String"]["output"]>;
};

/** FHIR Coverage.class.type — classification of coverage groupings */
export enum FhirCoverageClassType {
  Class = "CLASS",
  Group = "GROUP",
  Plan = "PLAN",
  RxBin = "RX_BIN",
  RxGroup = "RX_GROUP",
  RxId = "RX_ID",
  RxPcn = "RX_PCN",
  Sequence = "SEQUENCE",
  Subclass = "SUBCLASS",
  Subgroup = "SUBGROUP",
  Subplan = "SUBPLAN",
}

/** FHIR Coverage.kind — broad category of coverage */
export enum FhirCoverageKind {
  Insurance = "INSURANCE",
  Other = "OTHER",
  SelfPay = "SELF_PAY",
}

/** FHIR Coverage.status — financial status of the coverage */
export enum FhirCoverageStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
  EnteredInError = "ENTERED_IN_ERROR",
}

export type FactorCreateInput = {
  overwriteExisting?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** TwoFactor authentication profile Id */
  twoFactorId: Scalars["String"]["input"];
  type: TwilioFactorTypes;
};

export type FactorDeleteInput = {
  factorId: Scalars["String"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FactorInstanceConfig = {
  __typename?: "FactorInstanceConfig";
  alg: Scalars["String"]["output"];
  code_length: Scalars["Float"]["output"];
  skew: Scalars["Float"]["output"];
  time_step: Scalars["Float"]["output"];
};

export type FactorInstanceResponse = {
  __typename?: "FactorInstanceResponse";
  accountSid: Scalars["String"]["output"];
  config: FactorInstanceConfig;
  dateCreated: Scalars["DateTime"]["output"];
  dateUpdated: Scalars["DateTime"]["output"];
  entitySid: Scalars["String"]["output"];
  factorType: Scalars["String"]["output"];
  friendlyName: Scalars["String"]["output"];
  identity: Scalars["String"]["output"];
  serviceSid: Scalars["String"]["output"];
  sid: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type FactorVerifyInput = {
  code: Scalars["String"]["input"];
  type: TwilioFactorTypes;
};

/** All possible FHIR fasting codes */
export enum FastingStatus {
  F = "F",
  Fna = "FNA",
  Nf = "NF",
  Ng = "NG",
}

export type FeedActorObject = {
  __typename?: "FeedActorObject";
  actor?: Maybe<CynergyAccounts>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  type: FeedActorType;
  url?: Maybe<Scalars["URL"]["output"]>;
};

/** List of different actor types of feed element */
export enum FeedActorType {
  File = "File",
  Group = "Group",
  RecordType = "RecordType",
  User = "User",
}

export type FeedBundleCapabilityObject = {
  __typename?: "FeedBundleCapabilityObject";
  bundleType: FeedBundleType;
  collection?: Maybe<FeedElementCollectionObject>;
  totalElements: Scalars["Float"]["output"];
};

/** List of feed bundle type codes */
export enum FeedBundleType {
  Generic = "Generic",
  TrackedChanges = "TrackedChanges",
}

export type FeedElementCapabilitiesObject = {
  __typename?: "FeedElementCapabilitiesObject";
  bundle?: Maybe<FeedElementCapabilityBundleUnion>;
  link?: Maybe<LinkCapabilityObject>;
  status?: Maybe<PublicationStatus>;
  trackedChanges?: Maybe<TrackedChangesCapabilityObject>;
};

export type FeedElementCapabilityBundleUnion = FeedBundleCapabilityObject | TrackedChangeBundleCapabilityObject;

export type FeedElementCollectionObject = {
  __typename?: "FeedElementCollectionObject";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  elements: Array<FeedItemObject>;
  totalPages: Scalars["Float"]["output"];
};

export type FeedElementSearchArgs = {
  feedElementId?: InputMaybe<Scalars["ID"]["input"]>;
  feedType: FeedType;
  subjectId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** List of feed element type codes */
export enum FeedElementType {
  Bundle = "Bundle",
  FeedElement = "FeedElement",
  Recommendation = "Recommendation",
}

export type FeedItemObject = {
  __typename?: "FeedItemObject";
  actor?: Maybe<FeedActorObject>;
  body?: Maybe<MessageBodyObject>;
  capabilities?: Maybe<FeedElementCapabilitiesObject>;
  elementType: FeedElementType;
  header: MessageBodyObject;
  id: Scalars["ID"]["output"];
  publishDate: Scalars["GraphQLDateTime"]["output"];
  relativePublishedDate: Scalars["String"]["output"];
};

/** List of feed types */
export enum FeedType {
  Groups = "Groups",
  News = "News",
  People = "People",
  Record = "Record",
  Streams = "Streams",
  To = "To",
  Topics = "Topics",
  TrackedChange = "TrackedChange",
}

export type FeedbackPaginatedResponse = {
  __typename?: "FeedbackPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<FeedbackUnion>;
  totalPages: Scalars["Float"]["output"];
};

export type FeedbackUnion =
  QuestionnaireAnswerOptions | QuestionnaireAnswers | QuestionnaireEnableWhen | QuestionnaireItems | QuestionnaireResponses | Questionnaires;

export type FelligiSunterMatchProbability = {
  /** The probability that two matched record should have the same value */
  matchProbability: Scalars["Float"]["input"];
  unmatchProbability: Scalars["Float"]["input"];
};

export type FieldError = {
  __typename?: "FieldError";
  code?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
};

export type FileUploadResponse = {
  __typename?: "FileUploadResponse";
  errors?: Maybe<Array<FieldError>>;
  message: Scalars["String"]["output"];
  paths: Array<Scalars["String"]["output"]>;
  status: Scalars["Float"]["output"];
};

/** All possible FHIR FilterOperator codes */
export enum FilterOperator {
  ChildOf = "CHILD_OF",
  DescendentLeaf = "DESCENDENT_LEAF",
  DescendentOf = "DESCENDENT_OF",
  Equals = "EQUALS",
  Exists = "EXISTS",
  Generalizes = "GENERALIZES",
  In = "IN",
  IsA = "IS_A",
  IsNotA = "IS_NOT_A",
  NotIn = "NOT_IN",
  Regex = "REGEX",
}

/** All possible FHIR Flag category codes. */
export enum FlagCategory {
  /** Flags related to administrative and financial processes. */
  Admin = "ADMIN",
  /** Flags related to subject's advance directives. */
  AdvanceDirective = "ADVANCE_DIRECTIVE",
  /** Flags related to behavior. */
  Behavioral = "BEHAVIORAL",
  /** Flags related to the subject's clinical data. */
  Clinical = "CLINICAL",
  /** Flags related to coming into contact with the patient. */
  Contact = "CONTACT",
  /** Flags related to the subject's dietary needs. */
  Diet = "DIET",
  /** Flags related to the subject's medications. */
  Drug = "DRUG",
  /** Flags related to performing laboratory tests and related processes (e.g. phlebotomy). */
  Lab = "LAB",
  /** Flags related to research. */
  Research = "RESEARCH",
  /** Flags related to safety precautions. */
  Safety = "SAFETY",
}

/** Defines the possible type of grouped form inputs. */
export enum FormInputGroupType {
  Checkbox = "CHECKBOX",
  CreatableSelect = "CREATABLE_SELECT",
  Date = "DATE",
  Datetime = "DATETIME",
  MultiSelect = "MULTI_SELECT",
  Radio = "RADIO",
  RadioRange = "RADIO_RANGE",
  Range = "RANGE",
  Select = "SELECT",
  Switch = "SWITCH",
  Text = "TEXT",
  Textarea = "TEXTAREA",
}

export type FrequencyCreateInput = {
  unit: Scalars["String"]["input"];
  value: Scalars["Float"]["input"];
};

/** Patterns of frequency, typically in the context of events */
export enum FrequencyPattern {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export type GatewayWebhookEventErrors = {
  __typename?: "GatewayWebhookEventErrors";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  error_id: Scalars["ID"]["output"];
  event: GatewayWebhookEvents;
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  severity: ErrorSeverityType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type GatewayWebhookEvents = {
  __typename?: "GatewayWebhookEvents";
  account?: Maybe<BillingAccounts>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Processing failures recorded against this event (one row per attempt) */
  errors?: Maybe<Array<GatewayWebhookEventErrors>>;
  event_id: Scalars["ID"]["output"];
  event_type: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  payload: Scalars["JSONObject"]["output"];
  processor: PaymentGatewayProcessorType;
  status: WebhookProcessingStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Restrictions applied by gender */
export enum GenderRestrictions {
  Female = "FEMALE",
  Male = "MALE",
  None = "NONE",
}

export type Genotypes = {
  __typename?: "Genotypes";
  /** Effective antibiotic alternatives. */
  agent_alternatives?: Maybe<Array<AgentAlternatives>>;
  /** Antibiotic classifications to which the genotype is susceptible. */
  agent_class_alternatives?: Maybe<Array<AgentClassifications>>;
  /** Antibiotic classifications to which the genotype is resistant. */
  agent_class_resistance?: Maybe<Array<AgentClassResistance>>;
  classification?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encoding?: Maybe<Scalars["String"]["output"]>;
  gene: Scalars["String"]["output"];
  genotype_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  mechanism?: Maybe<Scalars["String"]["output"]>;
  /** Antibiotics to which the genotype is resistant. */
  resistant_to?: Maybe<Array<Agents>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export enum GeocodingStatusCodes {
  Error = "ERROR",
  InvalidRequest = "INVALID_REQUEST",
  Ok = "OK",
  OverQueryLimit = "OVER_QUERY_LIMIT",
  RequestDenied = "REQUEST_DENIED",
  UnknownError = "UNKNOWN_ERROR",
  ZeroResults = "ZERO_RESULTS",
}

/** All possible FHIR Goal Achievement status codes. */
export enum GoalAchievementStatus {
  /** The goal has been met. */
  Achieved = "ACHIEVED",
  /** The goal is being sought, and is progressing. */
  Improving = "IMPROVING",
  /** The goal is being sought but has not yet been reached. (Also applies if the goal was reached in the past but there has been regression and the goal is again being sought). */
  InProgress = "IN_PROGRESS",
  /** The goal has not been met and there might or might not have been progress towards target. */
  NotAchieved = "NOT_ACHIEVED",
  /** The goal is not possible to be met. */
  NotAttainable = "NOT_ATTAINABLE",
  /** The goal is being sought, but the trend is flat. */
  NoChange = "NO_CHANGE",
  /** The goal has not been met and little to no progress towards target. */
  NoProgress = "NO_PROGRESS",
  /** The goal has been met, but ongoing activity is needed to sustain the goal objective. */
  Sustaining = "SUSTAINING",
  /** The goal is being sought, but is regressing. */
  Worsening = "WORSENING",
}

export type GoalAddressesResults = Conditions | MedicationUsages | ServiceRequests;

/** All possible FHIR Goal category codes. */
export enum GoalCategory {
  /** Goals related to the manner in which the subject acts. */
  Behavioral = "BEHAVIORAL",
  /** Goals related to the consumption of food and/or beverages. */
  Dietary = "DIETARY",
  /** Goals related to the practice of nursing or established by nurses. */
  Nursing = "NURSING",
  /** Goals related to the mobility and/or motor capability of the subject. */
  Physiotherapy = "PHYSIOTHERAPY",
  /** Goals related to the personal protection of the subject. */
  Safety = "SAFETY",
}

/** All possible FHIR Goal priority codes */
export enum GoalPriority {
  /** Indicates that the goal is of considerable importance and should be a primary focus of care delivery. */
  HighPriority = "HIGH_PRIORITY",
  /** The goal is desirable but is not sufficiently important to devote significant resources to. Achievement of the goal may be sought when incidental to achieving other goals. */
  LowPriority = "LOW_PRIORITY",
  /** Indicates that the goal has a reasonable degree of importance and that concrete action should be taken towards the goal. Attainment is not as critical as high-priority goals. */
  MediumPriority = "MEDIUM_PRIORITY",
}

/** All possible FHIR goal start event codes. */
export enum GoalStartEvent {
  Admission = "ADMISSION",
  Childbirth = "CHILDBIRTH",
  Completion = "COMPLETION",
  Discharge = "DISCHARGE",
}

/** All possible FHIR Goal status codes. */
export enum GoalStatus {
  /** A proposed goal was accepted or acknowledged. */
  Accepted = "ACCEPTED",
  /** The goal is being sought actively. */
  Active = "ACTIVE",
  /** The goal has been abandoned. */
  Cancelled = "CANCELLED",
  /** The goal is no longer being sought. */
  Completed = "COMPLETED",
  /** The goal was entered in error and voided. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The goal remains a long term objective but is no longer being actively pursued for a temporary period of time. */
  OnHold = "ON_HOLD",
  /** A goal is planned for this patient. */
  Planned = "PLANNED",
  /** A goal is proposed for this patient. */
  Proposed = "PROPOSED",
  /** A proposed goal was rejected. */
  Rejected = "REJECTED",
}

export type GoalTargetInput = {
  targetBoolean?: InputMaybe<Scalars["Boolean"]["input"]>;
  targetInteger?: InputMaybe<Scalars["Float"]["input"]>;
  targetQuantity?: InputMaybe<QuantityCreateInput>;
  targetRange?: InputMaybe<RangeCreateInput>;
  targetRatio?: InputMaybe<RatioCreateInput>;
  targetString?: InputMaybe<Scalars["String"]["input"]>;
};

export type GoalTargets = {
  __typename?: "GoalTargets";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  goal: Goals;
  goal_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The parameter whose value is being tracked. */
  measure?: Maybe<CodeableConcepts>;
  target_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  target_integer?: Maybe<Scalars["Float"]["output"]>;
  target_quantity?: Maybe<Quantity>;
  target_range?: Maybe<Range>;
  target_ratio?: Maybe<Ratio>;
  target_string?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Goals = {
  __typename?: "Goals";
  /** Cynergy accountId of user who created the goal. */
  account_id: Scalars["ID"]["output"];
  achievement_status: GoalAchievementStatus;
  addresses: GoalAddressesResults;
  category: GoalCategory;
  /** After meeting the goal, ongoing activity is needed to sustain the goal objective */
  continuous: Scalars["Boolean"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  due_date?: Maybe<Scalars["DateTime"]["output"]>;
  goal_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  lifecycle_status: GoalStatus;
  note?: Maybe<Scalars["String"]["output"]>;
  priority: GoalPriority;
  start_date: Scalars["DateTime"]["output"];
  status_date?: Maybe<Scalars["DateTime"]["output"]>;
  status_reason?: Maybe<Scalars["String"]["output"]>;
  subject: Patients;
  target: GoalTargets;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type GoogleAddressComponentType = {
  __typename?: "GoogleAddressComponentType";
  long_name: Scalars["String"]["output"];
  short_name: Scalars["String"]["output"];
  types: Array<Scalars["String"]["output"]>;
};

export type GoogleBoundsType = {
  __typename?: "GoogleBoundsType";
  northeast: CoordinateType;
  southwest: CoordinateType;
};

export type GoogleGeocodingResponseType = {
  __typename?: "GoogleGeocodingResponseType";
  error_message?: Maybe<Scalars["String"]["output"]>;
  results: Array<GoogleGeocodingResultType>;
  status: GeocodingStatusCodes;
};

export type GoogleGeocodingResultType = {
  __typename?: "GoogleGeocodingResultType";
  address_components: Array<GoogleAddressComponentType>;
  formatted_address: Scalars["String"]["output"];
  geometry: GoogleGeometryType;
  partial_match?: Maybe<Scalars["Boolean"]["output"]>;
  place_id: Scalars["String"]["output"];
  types: Array<Scalars["String"]["output"]>;
};

export type GoogleGeometryType = {
  __typename?: "GoogleGeometryType";
  bounds: GoogleBoundsType;
  location: CoordinateType;
  location_type: Scalars["String"]["output"];
  viewport: GoogleBoundsType;
};

export type GooglePlacesAutocompletePredictionType = {
  __typename?: "GooglePlacesAutocompletePredictionType";
  description: Scalars["String"]["output"];
  matched_substrings: Array<PlaceMatchedSubstringType>;
  place_id: Scalars["String"]["output"];
  reference: Scalars["String"]["output"];
  terms: Array<PlaceTermType>;
  types: Array<Scalars["String"]["output"]>;
};

export type GooglePlacesAutocompleteResponseType = {
  __typename?: "GooglePlacesAutocompleteResponseType";
  error_message?: Maybe<Scalars["String"]["output"]>;
  predictions: Array<GooglePlacesAutocompletePredictionType>;
  status: PlacesAutocompleteStatusCodes;
};

export type GridLayoutProperties = {
  __typename?: "GridLayoutProperties";
  lg?: Maybe<Scalars["Float"]["output"]>;
  md?: Maybe<Scalars["Float"]["output"]>;
  sm?: Maybe<Scalars["Float"]["output"]>;
  xl?: Maybe<Scalars["Float"]["output"]>;
  xs?: Maybe<Scalars["Float"]["output"]>;
  xxl?: Maybe<Scalars["Float"]["output"]>;
};

export type GridLayoutPropertiesInput = {
  lg?: InputMaybe<Scalars["Float"]["input"]>;
  md?: InputMaybe<Scalars["Float"]["input"]>;
  sm?: InputMaybe<Scalars["Float"]["input"]>;
  xl?: InputMaybe<Scalars["Float"]["input"]>;
  xs?: InputMaybe<Scalars["Float"]["input"]>;
  xxl?: InputMaybe<Scalars["Float"]["input"]>;
};

export type GroupCharacteristics = {
  __typename?: "GroupCharacteristics";
  /** A code that identifies the kind of trait being asserted. */
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** If true, indicates the characteristic is one that is NOT held by members of the group. */
  exclude: Scalars["Boolean"]["output"];
  group_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The period over which the characteristic is tested; e.g. the patient had an operation during the month of June. */
  period?: Maybe<Periods>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** The value of the trait that holds (or does not hold - see "exclude") for members of the group. */
  valueBoolean?: Maybe<Scalars["Boolean"]["output"]>;
  /** The value of the trait that holds (or does not hold - see "exclude") for members of the group. */
  valueQuantity?: Maybe<Quantity>;
  /** The value of the trait that holds (or does not hold - see "exclude") for members of the group. */
  valueRange?: Maybe<Range>;
  /** The value of the trait that holds (or does not hold - see "exclude") for members of the group. */
  valueString?: Maybe<Scalars["String"]["output"]>;
};

export type GroupManagingEntityResults = Organizations | StaffAssignments;

export type GroupMemberEntityResults = HealthcareServices | Locations | Organizations | Patients | Specimens | StaffAssignments;

export type GroupMembers = {
  __typename?: "GroupMembers";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** If member is no longer in group. */
  inactive: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Who or what is in the group. */
  member: GroupMemberEntityResults;
  member_id: Scalars["String"]["output"];
  organization_id: Scalars["ID"]["output"];
  patient_id?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Group membership basis codes. */
export enum GroupMembershipBasis {
  /** The Group.characteristics specified are both necessary and sufficient to determine membership. All entities that meet the criteria are considered to be members of the group, whether referenced by the group or not. If members are present, they are individuals that happen to be known as meeting the Group.characteristics. The list cannot be presumed to be complete. */
  Definitional = "DEFINITIONAL",
  /** The Group.characteristics are necessary but not sufficient to determine membership. Membership is determined by being listed as one of the Group.member. */
  Enumerated = "ENUMERATED",
}

export type GroupedIcd10CodesResult = {
  __typename?: "GroupedICD10CodesResult";
  favorites: DiagnosisCodeGroupObject;
  recentDiagnosis: DiagnosisCodeGroupObject;
};

export type Groups = {
  __typename?: "Groups";
  active: Scalars["Boolean"]["output"];
  characteristics: Array<GroupCharacteristics>;
  /** KIND of group members. */
  code?: Maybe<Scalars["Float"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Name of user group */
  description: Scalars["String"]["output"];
  group_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  managing_entity: GroupManagingEntityResults;
  members?: Maybe<Array<GroupMembers>>;
  /** Basis for membership in group. */
  membership: GroupMembershipBasis;
  /** Name of user group */
  name: Scalars["String"]["output"];
  type: CareGroupTypes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR handling condition codes */
export enum HandlingConditionSet {
  Frozen = "FROZEN",
  Refrigerated = "REFRIGERATED",
  Room = "ROOM",
}

export type HealthcareServiceAttributeActionInput = {
  add?: InputMaybe<Array<ServiceAttributeLinkOrCreateInput>>;
  remove?: InputMaybe<HealthcareServiceAttributeBulkDeleteInput>;
  update?: InputMaybe<AttributeUpdateInput>;
};

export type HealthcareServiceAttributeBulkDeleteInput = {
  attributes: Array<HealthcareServiceAttributeInput>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type HealthcareServiceAttributeInput = {
  attributeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type HealthcareServiceCreateInput = {
  /** Additional business identifiers */
  additionalIdentifiers?: InputMaybe<Array<ServiceIdentifierLinkOrCreateInput>>;
  /** Attributes to help describe service */
  attributes?: InputMaybe<Array<ServiceAttributeLinkOrCreateInput>>;
  /** Broad category of service being performed or delivered (I.e. "Laboratory", "Hospital") */
  category: ServiceRequestCategory;
  /** Description of service */
  description: Scalars["String"]["input"];
  /** Default: true */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Publicly viewable/orderable (Default: true) */
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Location(s) service is intended for/available to */
  locations?: InputMaybe<Array<HealthcareServiceLocationInput>>;
  /** Name of service */
  name: Scalars["String"]["input"];
  /** Organization that provides this service */
  organizationId: Scalars["ID"]["input"];
  /** Identifier of the service definition this offering acts upon */
  serviceIdentifier: IdentifierCreateInput;
  /** Collection of specialties handled by the Healthcare service. */
  specialities?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Tags associated with service */
  tags?: InputMaybe<Array<ServiceTagLinkOrCreateInput>>;
  /** Type of service that may be delivered or performed (I.e. "Heart Health") */
  type: Scalars["String"]["input"];
};

export type HealthcareServiceDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type HealthcareServiceIdentifierActionInput = {
  add?: InputMaybe<Array<ServiceIdentifierLinkOrCreateInput>>;
  remove?: InputMaybe<HealthcareServiceIdentifierBulkDeleteInput>;
  update?: InputMaybe<IdentifierUpdateInput>;
};

export type HealthcareServiceIdentifierBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  identifiers: Array<HealthcareServiceIdentifierInput>;
  serviceId: Scalars["ID"]["input"];
};

export type HealthcareServiceIdentifierInput = {
  identifierId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type HealthcareServiceLocationActionInput = {
  add?: InputMaybe<Array<HealthcareServiceLocationInput>>;
  remove?: InputMaybe<HealthcareServiceLocationBulkDeleteInput>;
};

export type HealthcareServiceLocationBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  locations: Array<HealthcareServiceLocationInput>;
  serviceId: Scalars["ID"]["input"];
};

export type HealthcareServiceLocationInput = {
  locationId: Scalars["ID"]["input"];
};

export type HealthcareServiceLocationPaginatedResults = {
  __typename?: "HealthcareServiceLocationPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<HealthcareServiceLocations>;
  totalPages: Scalars["Float"]["output"];
};

export type HealthcareServiceLocations = {
  __typename?: "HealthcareServiceLocations";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  distance?: Maybe<Scalars["Float"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  service: HealthcareServices;
  service_location_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type HealthcareServicePaginatedResults = {
  __typename?: "HealthcareServicePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<HealthcareServices>;
  totalPages: Scalars["Float"]["output"];
};

export type HealthcareServiceTagActionInput = {
  add?: InputMaybe<Array<ServiceTagLinkOrCreateInput>>;
  remove?: InputMaybe<HealthcareServiceTagBulkDeleteInput>;
  update?: InputMaybe<TagUpdateInput>;
};

export type HealthcareServiceTagBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tags: Array<HealthcareServiceTagInput>;
};

export type HealthcareServiceTagInput = {
  tagId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type HealthcareServiceUpdateInput = {
  additionalIdentifiers?: InputMaybe<HealthcareServiceIdentifierActionInput>;
  attributes?: InputMaybe<HealthcareServiceAttributeActionInput>;
  /** Broad category of service being performed or delivered (I.e. "Laboratory", "Hospital") */
  category?: InputMaybe<ServiceRequestCategory>;
  /** Description of service */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Default: true */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Publicly viewable/orderable (Default: true) */
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  locations?: InputMaybe<HealthcareServiceLocationActionInput>;
  /** Name of service */
  name?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  serviceIdentifier?: InputMaybe<IdentifierUpdateInput>;
  /** Collection of specialties handled by the Healthcare service. */
  specialities?: InputMaybe<Array<Scalars["String"]["input"]>>;
  tags?: InputMaybe<HealthcareServiceTagActionInput>;
  /** Type of service that may be delivered or performed (I.e. "Heart Health") */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type HealthcareServices = {
  __typename?: "HealthcareServices";
  /** In active use */
  active: Scalars["Boolean"]["output"];
  /** Properties that describe the service and provide users with information they can use to find, compare, and, ultimately, select appropriate service. */
  attributes?: Maybe<Array<Attributes>>;
  /** Broad category of service being performed or delivered */
  category: ServiceRequestCategory;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Description of service */
  description: Scalars["String"]["output"];
  identifiers?: Maybe<Array<Identifiers>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Location(s) where service may be provided */
  locations?: Maybe<Array<HealthcareServiceLocations>>;
  metadata?: Maybe<Metadata>;
  name: Scalars["String"]["output"];
  organization: Organizations;
  parameters?: Maybe<Array<Parameters>>;
  /** Publicly viewable/orderable */
  public: Scalars["Boolean"]["output"];
  /** Lab diagnostic service */
  service?: Maybe<DiagnosticServices>;
  service_id: Scalars["ID"]["output"];
  /** Identifier of the service definition this offering acts upon */
  service_identifier: Identifiers;
  /** Specialties handled by the HealthcareService */
  speciality?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Service tags to improve searchability and categorization */
  tags?: Maybe<Array<Tags>>;
  /** Type of service that may be delivered or performed */
  type: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** List of patient heart rhythm types */
export enum HeartyRhythms {
  /** Atrial fibrillation is an abnormal heart rhythm characterized by rapid and irregular beating of the atrial chambers of the heart. It often begins as short periods of abnormal beating, which become longer or continuous over time. */
  AtrialFibrillation = "ATRIAL_FIBRILLATION",
  /** Atrial tachycardia is a type of heart rhythm problem in which the heart's electrical impulse comes from an ectopic pacemaker in the upper chambers of the heart, rather than from the sinoatrial node, the normal origin of the heart's electrical activity. */
  AtrialTachycardia = "ATRIAL_TACHYCARDIA",
  /** Atrial flutter is a common abnormal heart rhythm that starts in the atrial chambers of the heart. When it first occurs, it is usually associated with a fast heart rate and is classified as a type of supraventricular tachycardia. */
  AtriaFlutter = "ATRIA_FLUTTER",
  /** Bradycardia is a slow resting heart rate, commonly under 60 beats per minute as determined by an electrocardiogram. It is considered to be a normal heart rate during sleep, in young and healthy or elderly adults, and in athletes */
  Bradycardia = "BRADYCARDIA",
  /** Third-degree atrioventricular block is a medical condition in which the electrical impulse generated in the sinoatrial node in the atrium of the heart can not propagate to the ventricles. Because the impulse is blocked, an accessory pacemaker in the lower chambers will typically activate the ventricles. */
  CompleteHeartBlock = "COMPLETE_HEART_BLOCK",
  /** Supraventricular tachycardia is an umbrella term for fast heart rhythms arising from the upper part of the heart. This is in contrast to the other group of fast heart rhythms – ventricular tachycardia, which start within the lower chambers of the heart. */
  SupraventricularTachycardia = "SUPRAVENTRICULAR_TACHYCARDIA",
  /** Tachycardia, also called tachyarrhythmia, is a heart rate that exceeds the normal resting rate. In general, a resting heart rate over 100 beats per minute is accepted as tachycardia in adults. Heart rates above the resting rate may be normal or abnormal. */
  Tachycardia = "TACHYCARDIA",
  /** A Ventricular arrhythmia is a condition which originates in the lower chambers of the heart (ventricles). We usually find the problem when we hear three or more beats in succession coming from one of the ventricles. We consider the arrhythmia to be sustained if it lasts more than 30 seconds. Sustained ventricular arrhythmia keeps the lower heart chambers from being able to maintain proper blood flow throughout your body. The condition can lower your blood pressure and cause heart failure. */
  VentricularArrhythmias = "VENTRICULAR_ARRHYTHMIAS",
  /** Ventricular tachycardia is a fast heart rate arising from the lower chambers of the heart. Although a few seconds of VT may not result in permanent problems, longer periods are dangerous; and multiple episodes over a short period of time are referred to as an electrical storm. */
  VentricularTachycardia = "VENTRICULAR_TACHYCARDIA",
}

export type Icd10 = {
  __typename?: "ICD10";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  criteria?: Maybe<Array<IcdCriterion>>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  hex?: Maybe<Scalars["String"]["output"]>;
  icd10_code: Scalars["String"]["output"];
  icd11_code?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_starred: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  rules?: Maybe<IcdRules>;
  type?: Maybe<DiagnosisType>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Icd10CodePaginatedResults = {
  __typename?: "ICD10CodePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Icd10>;
  totalPages: Scalars["Float"]["output"];
};

export type IcdCriterion = {
  __typename?: "ICDCriterion";
  operator: QuantityComparator;
  result: Scalars["Float"]["output"];
  value: Scalars["Float"]["output"];
};

export type IcdRules = {
  __typename?: "ICDRules";
  type: RuleType;
  value: RuleValue;
};

/** ISO 4217 list of standardized currency codes */
export enum IsoCurrencyCodes {
  Usd = "USD",
  Usn = "USN",
}

export type IdentifierCreateInput = {
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  /** Establishes the namespace for the value - that is, a uri or absolute URL that describes a set values that are unique. */
  system?: InputMaybe<Scalars["String"]["input"]>;
  type: IdentifierType;
  use: IdentifierUse;
  /** Time period when id is/was valid for use */
  validPeriod?: InputMaybe<PeriodCreateInput>;
  /** Unique identifier value (Resource UUID) */
  value: Scalars["String"]["input"];
};

/** All possible FHIR identifier type codes. */
export enum IdentifierType {
  /** Accession Identifier */
  Acsn = "ACSN",
  /** Breed Registry Number */
  Brn = "BRN",
  /** Driver's license number */
  Dl = "DL",
  /** Donor Registration Number */
  Dr = "DR",
  /** Employer number */
  En = "EN",
  /** An identifier for a request where the identifier is issued by the person, or service, that produces the observations or fulfills the request. */
  Fill = "FILL",
  /** Jurisdictional health number */
  Jhn = "JHN",
  /** An identifier that is unique to a lab service. */
  Lsid = "LSID",
  /** Microchip Number */
  Mcn = "MCN",
  /** An identifier that is unique to a medical doctor within the jurisdiction of a licensing board. */
  Md = "MD",
  /** An identifier that is unique to a patient within a set of medical records, not necessarily unique within an application. */
  Mr = "MR",
  /** National Insurance Payor Identifier (Payor) */
  Niip = "NIIP",
  /**  Insurance In the US, the Assigning Authority for this value is typically CMS, but it may be used by all providers and insurance companies in HIPAA related transactions. */
  Npi = "NPI",
  /** Patient identifier */
  Pid = "PID",
  /** An identifier for a request where the identifier is issued by the person or service making the request. */
  Plac = "PLAC",
  /** A unique number assigned to the document affirming that a person is a citizen of the country. */
  Ppn = "PPN",
  /** A number that is unique to an individual provider, a provider group or an organization within an Assigning Authority. */
  Prn = "PRN",
  Rep = "REP",
  Req = "REQ",
  /** An identifier issued by a governmental organization to a person to identify the person should they apply for or receive social services and/or benefits */
  Sb = "SB",
  /** An identifier affixed to an item by the manufacturer when it is first made, where each item has a different identifier. */
  Sno = "SNO",
  /** The accession number generated by the Sequence Read Archive (SRA) at the National Center for Biotechnology Information (NCBI) when sequence data are uploaded to NCBI. */
  Srx = "SRX",
  /** Tax ID number */
  Tax = "TAX",
  /** An identifier assigned to a device using the Unique Device Identification framework as defined by IMDRF (http://imdrf.org). */
  Udi = "UDI",
}

export type IdentifierUpdateInput = {
  identifierId: Scalars["ID"]["input"];
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  /** Establishes the namespace for the value - that is, a uri or absolute URL that describes a set values that are unique. */
  system?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<IdentifierType>;
  use?: InputMaybe<IdentifierUse>;
  /** Time period when id is/was valid for use */
  validPeriod?: InputMaybe<PeriodCreateInput>;
  /** Unique identifier value (Resource UUID) */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR resource identifier use codes. */
export enum IdentifierUse {
  /** The identifier considered to be most trusted for the identification of this item. Sometimes also known as "primary" and "main". The determination of "official" is subjective and implementation guides often provide additional guidelines for use. */
  Official = "OFFICIAL",
  /** The identifier id no longer considered valid, but may be relevant for search purposes. E.g. Changes to identifier schemes, account merges, etc. */
  Old = "OLD",
  /** An identifier that was assigned in secondary use - it serves to identify the object in a relative context, but cannot be consistently assigned to the same object again in a different context. */
  Secondary = "SECONDARY",
  /** A temporary identifier. */
  Temp = "TEMP",
  /** The identifier recommended for display and use in real-world interactions. */
  Usual = "USUAL",
}

export type Identifiers = {
  __typename?: "Identifiers";
  /** Account relation to the identifier. */
  accounts?: Maybe<Array<CynergyAccounts>>;
  /** Organization that issued the id */
  assigner?: Maybe<Organizations>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  identifier_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Reference to the service requested to be performed */
  organization_id?: Maybe<Scalars["ID"]["output"]>;
  /** Time period when id is/was valid for use */
  period?: Maybe<Periods>;
  /** Establishes the namespace for the value - that is, a uri or absolute URL that describes a set values that are unique. */
  system?: Maybe<Scalars["String"]["output"]>;
  type: IdentifierType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  use: IdentifierUse;
  /** The value that is unique. */
  value: Scalars["String"]["output"];
};

/** List of available methods for user identity creation. */
export enum IdentityRegistrationMethods {
  Email = "EMAIL",
  Phone = "PHONE",
  Username = "USERNAME",
}

/** All possible FHIR Clinical impression change-pattern codes */
export enum ImpressionChangePatternCodes {
  Improving = "IMPROVING",
  NoChange = "NO_CHANGE",
  Unknown = "UNKNOWN",
  Worsening = "WORSENING",
}

export type Indicator = {
  __typename?: "Indicator";
  icd10Code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type IngestGatewayMessageResponse = {
  __typename?: "IngestGatewayMessageResponse";
  /** ACK code: AA (accepted), AE (error), AR (rejected) */
  ackCode?: Maybe<Scalars["String"]["output"]>;
  /** Error text if ingest failed */
  errorText?: Maybe<Scalars["String"]["output"]>;
  /** UUID of the persisted gateway message */
  messageId?: Maybe<Scalars["String"]["output"]>;
  /** Detected message type */
  messageType?: Maybe<Scalars["String"]["output"]>;
  /** Processing duration in milliseconds */
  processingTimeMs?: Maybe<Scalars["Float"]["output"]>;
  /** Whether the ingest was successful */
  success: Scalars["Boolean"]["output"];
};

export enum InstanceSetActionKeys {
  Remove = "REMOVE",
  Set = "SET",
}

export type InstrumentRoutingResponse = {
  __typename?: "InstrumentRoutingResponse";
  /** Instrument code */
  instrumentCode?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type IntegrationChannelFilterResponse = {
  __typename?: "IntegrationChannelFilterResponse";
  /** Filter UUID */
  filterId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type IntegrationChannelResponse = {
  __typename?: "IntegrationChannelResponse";
  /** Channel UUID */
  channelId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type InvoiceBalances = {
  __typename?: "InvoiceBalances";
  /** Outstanding amount still owed */
  balance: Scalars["USCurrency"]["output"];
  /** Invoice total (tax included) */
  gross_total?: Maybe<Scalars["USCurrency"]["output"]>;
  invoice_id: Scalars["ID"]["output"];
  /** Net APPLIED − UNAPPLIED allocations */
  net_payments_applied: Scalars["USCurrency"]["output"];
  /** Settlement status derived from allocations */
  settlement_status: InvoiceSettlementStatus;
};

/** List of invoice line types */
export enum InvoiceLineTypeCodes {
  Adjustment = "ADJUSTMENT",
  Charge = "CHARGE",
  Tax = "TAX",
}

export type InvoiceLines = {
  __typename?: "InvoiceLines";
  /** The billed order item's type */
  charge_type?: Maybe<OrderItemType>;
  /** The billed order item's type category */
  charge_type_code?: Maybe<OrderItemTypeCode>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Total credits */
  credits?: Maybe<Scalars["USCurrency"]["output"]>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Additional information about the invoice */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Total amount after taxes */
  gross_total: Scalars["USCurrency"]["output"];
  invoice: Invoices;
  is_archived: Scalars["Boolean"]["output"];
  line_id: Scalars["ID"]["output"];
  /** Total amount before taxes */
  net_total: Scalars["USCurrency"]["output"];
  order_item?: Maybe<OrderLineItems>;
  /** Reference to the order item that created this invoice */
  order_item_id: Scalars["ID"]["output"];
  /** Number of units */
  quantity: Scalars["Float"]["output"];
  /** Total tax amount */
  tax?: Maybe<Scalars["USCurrency"]["output"]>;
  type: InvoiceLineTypeCodes;
  /** Price for one referenced chargeable item on line */
  unit_price?: Maybe<Scalars["USCurrency"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** List of invoice settlement status codes */
export enum InvoiceSettlementStatus {
  Na = "NA",
  PartiallySettled = "PARTIALLY_SETTLED",
  Settled = "SETTLED",
  Unsettled = "UNSETTLED",
}

/** List of invoice status codes */
export enum InvoiceStatusCodes {
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
  PendingVoid = "PENDING_VOID",
  Posted = "POSTED",
  Voided = "VOIDED",
}

export type Invoices = {
  __typename?: "Invoices";
  /** Customer billing account to use for this invoice */
  account: BillingAccounts;
  /** Allocations made against invoice */
  allocations: Array<PaymentAllocations>;
  /** Derived applied payments, outstanding balance, and settlement status */
  balances?: Maybe<InvoiceBalances>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Total invoice credits */
  credits_total?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Reference to the user that owns the invoice record */
  cynergy_account_id: Scalars["ID"]["output"];
  /** Number of days the invoice the invoice has been open */
  days_open: Scalars["Float"]["output"];
  /** Number of days since the due date the invoice remained unsettled */
  days_overdue: Scalars["Float"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Additional information about the invoice */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Date the invoice is due. */
  due_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Gateway invoice id (e.g. Stripe in_…) */
  external_invoice_id?: Maybe<Scalars["String"]["output"]>;
  /** Hosted invoice URL from the gateway */
  external_invoice_url?: Maybe<Scalars["String"]["output"]>;
  /** Total invoice amount after taxes */
  gross_total: Scalars["USCurrency"]["output"];
  invoice_id: Scalars["ID"]["output"];
  invoice_number: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  issuer?: Maybe<Organizations>;
  lines?: Maybe<Array<InvoiceLines>>;
  /** Total invoice amount before taxes */
  net_total?: Maybe<Scalars["USCurrency"]["output"]>;
  order?: Maybe<Orders>;
  /** Reference to the order that created this invoice */
  order_id: Scalars["ID"]["output"];
  /** Reference to the organization issuing the invoice */
  organization_id: Scalars["ID"]["output"];
  payment_group?: Maybe<PaymentGroups>;
  /** Payment term used by invoice */
  payment_term?: Maybe<PaymentTerms>;
  /** Date the invoice was posted */
  posted_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Date the invoice was paid */
  settled_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Invoice settlement status */
  settlement_status: InvoiceSettlementStatus;
  status: InvoiceStatusCodes;
  /** Total tax amount */
  tax_total?: Maybe<Scalars["USCurrency"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type KeywordSearch = {
  columnName: Scalars["String"]["input"];
  exactMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
  keyword: Scalars["String"]["input"];
};

export type LabCreateInput = {
  locationId: Scalars["ID"]["input"];
  organizationId: Scalars["ID"]["input"];
};

export type LabDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  labId: Scalars["ID"]["input"];
};

export type LabObservationStats = {
  __typename?: "LabObservationStats";
  code: Scalars["String"]["output"];
  count: Scalars["Int"]["output"];
  target_type: ObservationTargetType;
};

export type LabOrderResponse = {
  __typename?: "LabOrderResponse";
  /** Lab order UUID */
  labOrderId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

/** Approved Lab Result FileTypes, meant to accept completed service requests, not for individual observations */
export enum LabResultFileTypes {
  Astm = "ASTM",
  Csv = "CSV",
  Hl7 = "HL7",
  Json = "JSON",
  Xlsx = "XLSX",
}

/** All possible FHIR profile defined lab service reimbursement codes */
export enum LaboratoryServiceReimbursability {
  /** The service reimbursement is conditioned by the clinical context of the order */
  Conditional = "CONDITIONAL",
  /** The service is composed of a part that is reimbursable depending on the clinical context, and of a part that is non-reimbursable */
  ConditionalPartial = "CONDITIONAL_PARTIAL",
  /** The service is usually not covered by insurance plans, and charged to the paying party */
  None = "NONE",
  /** The service is usually reimbursed (partially or totally) under general dispositions defined in insurance plans, independently of the service */
  Normal = "NORMAL",
  /** The service is composed of a part that is usually reimbursed under general dispositions defined in insurance plans, and of a part that is non-reimbursable */
  Partial = "PARTIAL",
}

/** Service types applicable to a laboratory defined service */
export enum LaboratoryServiceType {
  /** laboratory service comprising two or more tests and/or panels */
  Panel = "PANEL",
  /** laboratory service performing a single measurement */
  Test = "TEST",
}

export type Labs = {
  __typename?: "Labs";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  lab_id: Scalars["ID"]["output"];
  location_id: Scalars["ID"]["output"];
  organization_id: Scalars["ID"]["output"];
  /** Diagnostic services offered by this lab */
  services?: Maybe<Array<DiagnosticServices>>;
  specimen_caps?: Maybe<Array<SpecimenDefinitionContainerCaps>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Supported language codes for legal document translations */
export enum LanguageCode {
  En = "EN",
  Es = "ES",
}

export type LayoutConfiguration = {
  __typename?: "LayoutConfiguration";
  column: GridLayoutProperties;
};

export type LayoutConfigurationInput = {
  column: GridLayoutPropertiesInput;
};

export type LayoutPosition = {
  __typename?: "LayoutPosition";
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type LayoutPreferences = {
  __typename?: "LayoutPreferences";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  layout: Array<ComponentLayoutConfiguration>;
  /** Application page to apply layout preference to. */
  page: SharedApplicationPages;
  preference_id: Scalars["String"]["output"];
  setting: LayoutSettings;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type LayoutSettings = {
  __typename?: "LayoutSettings";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  layout_setting_id: Scalars["String"]["output"];
  layouts: Array<LayoutPreferences>;
  settings: Settings;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Direction of a ledger entry relative to account balance */
export enum LedgerEntryType {
  Credit = "CREDIT",
  Debit = "DEBIT",
}

/** It represents the progress and outcome of a scheduled leg */
export enum LegStatus {
  Completed = "COMPLETED",
  InProgress = "IN_PROGRESS",
  Scheduled = "SCHEDULED",
}

export type LegalDocumentTranslation = {
  __typename?: "LegalDocumentTranslation";
  languageCode: LanguageCode;
  url: Scalars["URL"]["output"];
};

export type LineItemIdentifierInput = {
  lineItemId: Scalars["ID"]["input"];
};

export type LinkCapabilityObject = {
  __typename?: "LinkCapabilityObject";
  url: Scalars["URL"]["output"];
  urlName?: Maybe<Scalars["String"]["output"]>;
};

export type LocationAffiliationDetailsInput = {
  locationId: Scalars["String"]["input"];
  /** Functional role of practitioner for this location. */
  role: Scalars["String"]["input"];
};

export type LocationChanges = ChangesEntity & {
  __typename?: "LocationChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  location_id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type LocationCreateInput = {
  address: UserAddressInput;
  alias: Scalars["String"]["input"];
  coordinates?: InputMaybe<CoordinatesInput>;
  description: Scalars["String"]["input"];
  locationCode?: InputMaybe<Scalars["String"]["input"]>;
  locationRole: Scalars["String"]["input"];
  locationStatus: Scalars["String"]["input"];
  metadata?: InputMaybe<Scalars["JSONObject"]["input"]>;
  mode: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  phone?: InputMaybe<Scalars["PhoneNumber"]["input"]>;
  physicalType: Scalars["String"]["input"];
  preferredTimeslots?: InputMaybe<Scalars["JSONObject"]["input"]>;
  /** The User ID of the location supervisor. */
  supervisorId: Scalars["ID"]["input"];
  timezone?: InputMaybe<Scalars["TimeZone"]["input"]>;
};

export type LocationDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  locationId: Scalars["ID"]["input"];
};

export type LocationPaginatedResults = {
  __typename?: "LocationPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Locations>;
  totalPages: Scalars["Float"]["output"];
};

export type LocationPatientCreateInput = {
  addresses?: InputMaybe<Array<AddressInput>>;
  /** Should only be passed when isPortalEnabled true, application requesting registration. */
  applicationId?: InputMaybe<Scalars["String"]["input"]>;
  contacts?: InputMaybe<Array<PatientContactRequiredInput>>;
  /** Current location of the patient. Locations can be granular to rooms or even beds depending on the configuration. */
  currentLocationId?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional field to pass cynergyId from higher services. */
  cynergyId?: InputMaybe<Scalars["String"]["input"]>;
  demographics: PatientDemographicInput;
  /** Onboarding documents (face sheets, intake paperwork) to upload for the patient. Stored best-effort after the patient is created — a document failure will not block registration. */
  documents?: InputMaybe<Array<PatientDocumentInput>>;
  /** External Identifier of the patient. Patient can have x number of IDs. but may only be passed up one at a time */
  identifiers?: InputMaybe<Array<PatientRegisterExternalIdInput>>;
  /** Insurance coverages to record for the patient. Dispatched to billingcynergy best-effort after the patient is created, so a coverage failure won't block registration. */
  insurances?: InputMaybe<Array<PatientInsuranceInput>>;
  /** Should be true if the patient would like portal access. */
  isPortalEnabled: Scalars["Boolean"]["input"];
  /** Should only be passed when isPortalEnabled true, method of contact for registration. */
  method?: InputMaybe<PatientRegisterMethodInput>;
  /** Primary practitioner for the patient. Intended for sharing records and results with primary practitioner. */
  primaryProviderId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LocationPatientPaginatedResults = {
  __typename?: "LocationPatientPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<LocationPatients>;
  totalPages: Scalars["Float"]["output"];
};

export type LocationPatients = {
  __typename?: "LocationPatients";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  last_contact?: Maybe<Scalars["DateTime"]["output"]>;
  location: Locations;
  location_id: Scalars["String"]["output"];
  patient: Patients;
  patient_id: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR location physical type codes */
export enum LocationPhysicalType {
  /** A defined physical boundary of something, such as a flood risk zone, region, postcode */
  Area = "AREA",
  /** A space that is allocated for sleeping/laying on. This is not the physical bed/trolley that may be moved about, but the space it may occupy. */
  Bd = "BD",
  /** Any Building or structure. This may contain rooms, corridors, wings, etc. It might not have walls, or a roof, but is considered a defined/allocated space. */
  Bu = "BU",
  /** A container that can store goods, equipment, medications or other items. */
  Ca = "CA",
  /** Any corridor within a Building, that may connect rooms. */
  Co = "CO",
  /** A residential dwelling. Usually used to reference a location that a person/patient may reside. */
  Ho = "HO",
  /** A wide scope that covers a conceptual domain, such as a Nation (Country wide community or Federal Government - e.g. Ministry of Health), Province or State (community or Government), Business (throughout the enterprise), Nation with a business scope of an agency (e.g. CDC, FDA etc.) or a Business segment (UK Pharmacy), not just an physical boundary */
  Jdn = "JDN",
  /** A Level in a multi-level Building/Structure. */
  Lvl = "LVL",
  /** A defined path to travel between 2 points that has a known name. */
  Rd = "RD",
  /** A space that is allocated as a room, it may have walls/roof etc., but does not require these. */
  Ro = "RO",
  /** A collection of buildings or other locations such as a site or a campus. */
  Si = "SI",
  /** A means of transportation. */
  Ve = "VE",
  /** A location that is virtual in nature, such as a conference call or virtual meeting space */
  Vi = "VI",
  /** A Ward is a section of a medical facility that may contain rooms and other types of location. */
  Wa = "WA",
  /** A Wing within a Building, this often contains levels, rooms and corridors. */
  Wi = "WI",
}

export type LocationStaffCreateInput = {
  addresses?: InputMaybe<Array<AddressInput>>;
  /** Should only be passed when isPortalEnabled true, application requesting registration. */
  applicationId: Scalars["String"]["input"];
  contacts?: InputMaybe<Array<StaffContactRequiredInput>>;
  /** Optional field to pass cynergyId from higher services. */
  cynergyId?: InputMaybe<Scalars["String"]["input"]>;
  /** Default location assignment for staff to act as when logged in. Locations can be granular to rooms or even beds depending on the configuration. */
  defaultLocationId: Scalars["String"]["input"];
  /** Default organization for staff to act as when logged in. Organization are owners of one or more sub-organizations/locations. */
  defaultOrganizationId: Scalars["String"]["input"];
  demographics: StaffDemographicInput;
  /** The date thee staff user started work at the location. */
  hireDate: Scalars["String"]["input"];
  /** External Identifier of the staff. Staff can have x number of IDs. but may only be passed up one at a time */
  identifiers?: InputMaybe<Array<StaffRegisterExternalIdInput>>;
  /** Should only be passed when isPortalEnabled true, method of contact for registration. */
  method: StaffRegisterMethodInput;
  /** Role of user in site. */
  role: ApplicationRoles;
  /** Job title of the staff within the organization. This is just for descriptive reasons. This is not tied to anything permission related */
  title: Scalars["String"]["input"];
};

export type LocationUpdateInput = {
  address?: InputMaybe<UserAddressInput>;
  alias?: InputMaybe<Scalars["String"]["input"]>;
  coordinates?: InputMaybe<CoordinatesInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  locationCode?: InputMaybe<Scalars["String"]["input"]>;
  locationId: Scalars["ID"]["input"];
  locationRole?: InputMaybe<Scalars["String"]["input"]>;
  locationStatus?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSONObject"]["input"]>;
  mode?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["PhoneNumber"]["input"]>;
  physicalType?: InputMaybe<Scalars["String"]["input"]>;
  preferredTimeslots?: InputMaybe<Scalars["JSONObject"]["input"]>;
  supervisorId?: InputMaybe<Scalars["ID"]["input"]>;
  timezone?: InputMaybe<Scalars["TimeZone"]["input"]>;
};

export type Locations = {
  __typename?: "Locations";
  address: WebCynergyAddresses;
  alias?: Maybe<Scalars["String"]["output"]>;
  changes?: Maybe<Array<LocationChanges>>;
  contacts: Array<OrganizationContacts>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  departments?: Maybe<Array<Departments>>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Unique location code */
  location_code: Scalars["String"]["output"];
  location_distance?: Maybe<Scalars["Float"]["output"]>;
  location_id: Scalars["String"]["output"];
  location_role: Scalars["String"]["output"];
  location_status: Scalars["String"]["output"];
  managing_organization?: Maybe<Organizations>;
  meta_data?: Maybe<MetaDataType>;
  mode: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  open_now: Scalars["Boolean"]["output"];
  organization_id: Scalars["String"]["output"];
  patients?: Maybe<Array<Patients>>;
  phone?: Maybe<Scalars["String"]["output"]>;
  physical_type: Scalars["String"]["output"];
  position?: Maybe<Coordinates>;
  /** Indicates if the location has preferred status. Only able to be true if the managing organization is a preferred member.  */
  preferred_member: Scalars["Boolean"]["output"];
  preferred_timeslots?: Maybe<PreferredTimeSlotsType>;
  routes_from_here?: Maybe<Array<RouteLegs>>;
  routes_to_here?: Maybe<Array<RouteLegs>>;
  service_requests?: Maybe<Array<ServiceRequests>>;
  services_offered: Array<HealthcareServices>;
  staffs?: Maybe<Array<Staffs>>;
  sub_locations?: Maybe<Array<Locations>>;
  supervisor: Users;
  /** Primary time zones in the United States */
  time_zone?: Maybe<Scalars["String"]["output"]>;
  todays_operating_hours: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type LoginRequest = {
  appId: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
  userType: UserTypes;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type LoginResponse = {
  __typename?: "LoginResponse";
  errors?: Maybe<Array<FieldError>>;
  permissions?: Maybe<Scalars["String"]["output"]>;
  session?: Maybe<UserSessionData>;
  token?: Maybe<TokenTypes>;
};

/** All possible LOINC class type codes. */
export enum LoincClassTypes {
  Claims = "CLAIMS",
  Clinical = "CLINICAL",
  Laboratory = "LABORATORY",
  Survey = "SURVEY",
}

export type LoincCodes = {
  __typename?: "LoincCodes";
  class_type?: Maybe<LoincClassTypes>;
  /** An arbitrary classification of the terms for grouping related observations together */
  classification?: Maybe<Scalars["String"]["output"]>;
  code: Scalars["String"]["output"];
  /** First major axis-component or analyte */
  component: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** Short name */
  display: Scalars["String"]["output"];
  /** A value in this field means that the content should be delivered in the named field/subfield of the HL7 message. When NULL, the data for this data element should be sent in an OBX segment with this LOINC code stored in OBX-3 and with the value in the OBX-5. */
  hl7_field?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Sixth major axis-method of measurement */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Long name */
  name: Scalars["String"]["output"];
  /** Defines term as order only, observation only, or both. */
  order_observation?: Maybe<LoincOrderObservation>;
  /** Fifth major axis-scale of measurement (e.g., qualitative vs. quantitative) */
  scale: Scalars["String"]["output"];
  status: LoincStatusCodes;
  /** Fourth major axis-type of specimen or system (e.g., serum vs urine) */
  system: Scalars["String"]["output"];
  /** Indicates that units are required when this LOINC is included as an OBX segment in a HIPAA attachment */
  units_required: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Defines term as order only, observation only, or both. A fourth category, Subset, is used for terms that are subsets of a panel but do not represent a package that is known to be orderable. We have defined them only to make it easier to maintain panels or other sets within the LOINC construct. This field reflects our best approximation of the terms intended use; it is not to be considered normative or a binding resolution. */
export enum LoincOrderObservation {
  Both = "BOTH",
  Observation = "OBSERVATION",
  Order = "ORDER",
  Subset = "SUBSET",
}

/** All possible LOINC status codes */
export enum LoincStatusCodes {
  Active = "ACTIVE",
  Deprecated = "DEPRECATED",
  Discouraged = "DISCOURAGED",
  Trial = "TRIAL",
}

/** All marital status type codes */
export enum MaritalStatus {
  /** Marriage contract has been declared null and to not have existed */
  Annulled = "ANNULLED",
  /** Marriage contract has been declared dissolved and inactive */
  Divorced = "DIVORCED",
  /** Person declares that a domestic partner relationship exists */
  DomesticPartner = "DOMESTIC_PARTNER",
  /** Subject to an Interlocutory Decree. */
  Interlocutory = "INTERLOCUTORY",
  /** Legally Seperated */
  LegallySeperated = "LEGALLY_SEPERATED",
  /** A current marriage contract is active */
  Married = "MARRIED",
  /** No marriage contract has ever been entered */
  NeverMarried = "NEVER_MARRIED",
  /** More than one current spouse */
  Polygamous = "POLYGAMOUS",
  /** Unknown */
  Unknown = "UNKNOWN",
  /** Currently not in a marriage contract */
  Unmarried = "UNMARRIED",
  /** The spouse is deceased */
  Widowed = "WIDOWED",
}

export type MarketingStatus = {
  __typename?: "MarketingStatus";
  appl_no: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  marketing_status_id: Scalars["Float"]["output"];
  product_no: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MatchProbabilityDefinitionPaginatedResults = {
  __typename?: "MatchProbabilityDefinitionPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<RecordFieldMatchProbabilityDefinitions>;
  totalPages: Scalars["Float"]["output"];
};

export type MedicationAdministrations = {
  __typename?: "MedicationAdministrations";
  administration_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MedicationBatch = {
  __typename?: "MedicationBatch";
  batch_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  expiration_date: Scalars["DateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  lot_number: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MedicationChanges = ChangesEntity & {
  __typename?: "MedicationChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  medication: Medications;
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR medication codes. */
export enum MedicationCodes {
  HypotensiveAgent = "HYPOTENSIVE_AGENT",
  MedicinalProduct = "MEDICINAL_PRODUCT",
  TherapeuticRadioisotope = "THERAPEUTIC_RADIOISOTOPE",
}

export type MedicationCreateInput = {
  brandName: Scalars["String"]["input"];
  conditionIDs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  dosage: MedicationDosageInput;
  /** Details of how medication is/was taken or should be taken. */
  dosageInstruction: Scalars["String"]["input"];
  effectivePeriod: PeriodCreateInput;
  /**
   * A code that specifies this medication or a textual description if no code is available.
   *         See: https://build.fhir.org/valueset-medication-codes.html
   */
  medicationCode: MedicationCodes;
  /** Optional: existing medicationID to attach usage to. */
  medicationID?: InputMaybe<Scalars["String"]["input"]>;
  method: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** PractitionerId of prescriber. */
  prescriberId: Scalars["String"]["input"];
};

export type MedicationData = {
  __typename?: "MedicationData";
  active_ingredients?: Maybe<Array<Scalars["String"]["output"]>>;
  brand_name?: Maybe<Scalars["String"]["output"]>;
  date_prescribed?: Maybe<Scalars["String"]["output"]>;
  dosage?: Maybe<Scalars["String"]["output"]>;
  form?: Maybe<Scalars["String"]["output"]>;
  frequency?: Maybe<Scalars["String"]["output"]>;
  generic_name?: Maybe<Scalars["String"]["output"]>;
  instructions?: Maybe<Scalars["String"]["output"]>;
  medication_name: Scalars["String"]["output"];
  ndc_code?: Maybe<Scalars["String"]["output"]>;
  pharmacy?: Maybe<Scalars["String"]["output"]>;
  prescriber?: Maybe<Scalars["String"]["output"]>;
  prescription_number?: Maybe<Scalars["String"]["output"]>;
  quantity?: Maybe<Scalars["Int"]["output"]>;
  refills?: Maybe<Scalars["Int"]["output"]>;
  route?: Maybe<Scalars["String"]["output"]>;
  side_effects?: Maybe<Array<Scalars["String"]["output"]>>;
  strength?: Maybe<Scalars["String"]["output"]>;
  warnings?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type MedicationDispenses = {
  __typename?: "MedicationDispenses";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dispense_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MedicationDosageInput = {
  frequency: MedicationFrequencyInput;
  strength: MedicationStrengthInput;
  timing: TimingAbbreviations;
};

export type MedicationDosageUpdateInput = {
  frequency: MedicationFrequencyInput;
  strength: MedicationStrengthInput;
};

export type MedicationFrequencyInput = {
  form: Scalars["String"]["input"];
  /** Amount to take per timing. */
  quantity: Scalars["Float"]["input"];
};

export type MedicationIngredients = {
  __typename?: "MedicationIngredients";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  ingredient_id: Scalars["String"]["output"];
  /** Indication of whether this ingredient affects the therapeutic action of the drug. */
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  medication: Medications;
  strength: Ratio;
  substance: Substances;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible medication request administration location codes. */
export enum MedicationRequestAdministrativeLocation {
  /** Includes requests for medications to be administered or consumed by the patient in their home (this would include long term care or nursing homes, hospices, etc.) */
  Community = "COMMUNITY",
  /** Includes requests for medications to be administered or consumed in an inpatient or acute care setting */
  Inpatient = "INPATIENT",
  /** Includes requests for medications to be administered or consumed in an outpatient setting (for example, Emergency Department, Outpatient Clinic, Outpatient Surgery, Doctors office) */
  Outpatient = "OUTPATIENT",
}

export type MedicationResult = {
  __typename?: "MedicationResult";
  confidence?: Maybe<Scalars["Float"]["output"]>;
  data?: Maybe<MedicationData>;
  error?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type MedicationResults =
  Dosage | MedicationAdministrations | MedicationBatch | MedicationDispenses | MedicationIngredients | MedicationUsages | Medications;

export type MedicationStrengthInput = {
  unit: Scalars["String"]["input"];
  value: Scalars["Float"]["input"];
};

export type MedicationUpdateInput = {
  brandName?: InputMaybe<Scalars["String"]["input"]>;
  dosage?: InputMaybe<MedicationDosageUpdateInput>;
  form?: InputMaybe<Scalars["String"]["input"]>;
  manufacturer?: InputMaybe<Scalars["String"]["input"]>;
  medicationCode?: InputMaybe<MedicationCodes>;
  medicationID: Scalars["String"]["input"];
  /** Organization that has authorization to market medication */
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<MedicationsStatus>;
};

/** All possible FHIR medication usage adherence codes. */
export enum MedicationUsageAdherence {
  /** The medication is not being taken. */
  NotTaking = "NOT_TAKING",
  /** The medication is being taken. */
  Taking = "TAKING",
  /** The medication is being taken as directed. */
  TakingAsDirected = "TAKING_AS_DIRECTED",
  /** The medication is not being taken as directed. */
  TakingNotAsDirected = "TAKING_NOT_AS_DIRECTED",
  /** Whether the medication is being taken or not is not currently known. */
  Unknown = "UNKNOWN",
}

export type MedicationUsageChanges = ChangesEntity & {
  __typename?: "MedicationUsageChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  usage: MedicationUsages;
};

/** All possible medication usage FHIR status codes. */
export enum MedicationUsageStatus {
  /** The medication usage is draft or preliminary */
  Draft = "DRAFT",
  /** Some of the actions that are implied by the medication usage may have occurred. For example, the patient may have taken some of the medication. Clinical decision support systems should take this status into account. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The action of recording the medication statement is finished. */
  Recorded = "RECORDED",
}

export type MedicationUsageUpdateInput = {
  /** Indicates if the medication is being consumed or administered as instructed. */
  adherence?: InputMaybe<MedicationUsageAdherence>;
  allFeedbackRequestsSent?: InputMaybe<Scalars["Boolean"]["input"]>;
  category?: InputMaybe<MedicationRequestAdministrativeLocation>;
  conditionIDs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** When the usage was asserted */
  dateAsserted?: InputMaybe<Scalars["DateTime"]["input"]>;
  dosageInstruction?: InputMaybe<Scalars["String"]["input"]>;
  /** The date/time or interval when the medication is/was/will be taken */
  effectiveDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  feedbackRequested?: InputMaybe<Scalars["Boolean"]["input"]>;
  method?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Notification reference for relating task */
  notificationID?: InputMaybe<Scalars["String"]["input"]>;
  /** PractitionerId of prescriber. */
  prescriberId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<MedicationUsageStatus>;
  timing?: InputMaybe<TimingAbbreviations>;
  usageID: Scalars["String"]["input"];
};

export type MedicationUsages = {
  __typename?: "MedicationUsages";
  /** Indicates if the medication is being consumed or administered as instructed. */
  adherence: MedicationUsageAdherence;
  administration_method: Scalars["String"]["output"];
  administration_timing: TimingAbbreviations;
  based_on?: Maybe<CarePlans>;
  /** Type of medication usage */
  category: MedicationRequestAdministrativeLocation;
  changes?: Maybe<Array<MedicationUsageChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** When the usage was asserted? */
  date_asserted: Scalars["DateTime"]["output"];
  days_left: Scalars["Float"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  derived_from?: Maybe<CriteriaFormResults>;
  /** Details of how medication is/was taken or should be taken */
  dosage_instruction: Scalars["String"]["output"];
  /** The date/time or interval when the medication is/was/will be taken */
  effective: Scalars["DateTime"]["output"];
  effective_period: Periods;
  expired: Scalars["Boolean"]["output"];
  /** Have  notification(s) been sent out to applicable parties after usage has stopped? */
  feedback_requests_complete: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  medication: Medications;
  notes?: Maybe<Scalars["String"]["output"]>;
  notifications?: Maybe<Array<Notifications>>;
  participant?: Maybe<StaffAssignments>;
  patient: Patients;
  /** Prescribing practitioner id. */
  practitioner_id: Scalars["String"]["output"];
  prescriber?: Maybe<Practitioners>;
  reason?: Maybe<Array<Conditions>>;
  status: MedicationUsageStatus;
  timing_display?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  usage_id: Scalars["String"]["output"];
};

export type Medications = {
  __typename?: "Medications";
  brand_name: Scalars["String"]["output"];
  changes?: Maybe<Array<MedicationChanges>>;
  /** A code that specifies this medication or a textual description if no code is available. See: https://build.fhir.org/valueset-medication-codes.html */
  code: MedicationCodes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  detected_issues?: Maybe<Array<DetectedIssues>>;
  dose_form: Scalars["String"]["output"];
  ingredients?: Maybe<MedicationIngredients>;
  is_archived: Scalars["Boolean"]["output"];
  manufacturer?: Maybe<Scalars["String"]["output"]>;
  /** Organization that has authorization to market medication */
  marketing_authorization_holder?: Maybe<Organizations>;
  medication_id: Scalars["String"]["output"];
  ndc_information?: Maybe<DrugProducts>;
  /** A code to indicate if the medication is in active use. */
  status: MedicationsStatus;
  /** When the specified product code does not infer a package size, this is the specific amount of drug in the product. */
  total_volume: Ratio;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible medication FHIR status codes */
export enum MedicationsStatus {
  /** The medication record is current and is appropriate for reference in new instances. */
  Active = "ACTIVE",
  /** The medication record was created erroneously and is not appropriated for reference in new instances. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The medication record is not current and is not is appropriate for reference in new instances. */
  Inactive = "INACTIVE",
}

export type MerchantAccountCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant name */
  name: Scalars["String"]["input"];
  /** List of payment methods supported by merchant */
  supportedPaymentMethods: MerchantAccountPaymentMethodListInput;
};

/** List of merchant account event types */
export enum MerchantAccountEventType {
  Create = "CREATE",
  Disable = "DISABLE",
  PaymentEnable = "PAYMENT_ENABLE",
  PayoutEnable = "PAYOUT_ENABLE",
  Update = "UPDATE",
}

export type MerchantAccountEvents = {
  __typename?: "MerchantAccountEvents";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  event_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  merchant: MerchantAccounts;
  notification_id?: Maybe<Scalars["ID"]["output"]>;
  type: MerchantAccountEventType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MerchantAccountPaginatedResults = {
  __typename?: "MerchantAccountPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<MerchantAccounts>;
  totalPages: Scalars["Float"]["output"];
};

export type MerchantAccountPaymentMethodActionInput = {
  add?: InputMaybe<Array<MerchantAccountPaymentMethodInput>>;
  remove?: InputMaybe<Array<MerchantAccountPaymentMethodDeleteInput>>;
  update?: InputMaybe<MerchantAccountPaymentMethodUpdateInput>;
};

export type MerchantAccountPaymentMethodDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  methodId: Scalars["ID"]["input"];
};

export type MerchantAccountPaymentMethodInput = {
  /** Sequential order in list */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  paymentMethod: PaymentMethodTypeCodes;
};

export type MerchantAccountPaymentMethodListInput = {
  /** List name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethods?: InputMaybe<Array<MerchantAccountPaymentMethodInput>>;
};

export type MerchantAccountPaymentMethodListUpdateInput = {
  merchantListId: Scalars["ID"]["input"];
  /** List name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethods?: InputMaybe<MerchantAccountPaymentMethodActionInput>;
};

export type MerchantAccountPaymentMethodUpdateInput = {
  methodId: Scalars["ID"]["input"];
  /** Sequential order in list */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  paymentMethod?: InputMaybe<PaymentMethodTypeCodes>;
};

export type MerchantAccountPaymentMethods = {
  __typename?: "MerchantAccountPaymentMethods";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Payment method allowed to be used for tender */
  method: PaymentMethodTypeCodes;
  method_number: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MerchantAccountPaymentMethodsList = {
  __typename?: "MerchantAccountPaymentMethodsList";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  list_number: Scalars["Float"]["output"];
  merchant: MerchantAccounts;
  /** Payment methods this merchant allows */
  methods?: Maybe<Array<MerchantAccountPaymentMethods>>;
  /** List name provided by merchant */
  name?: Maybe<Scalars["String"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MerchantAccountUpdateInput = {
  accountId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** List of payment methods supported by merchant */
  supportedPaymentMethods?: InputMaybe<MerchantAccountPaymentMethodListUpdateInput>;
};

export type MerchantAccounts = {
  __typename?: "MerchantAccounts";
  account_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Currency ISO code allowed by merchant */
  currency: IsoCurrencyCodes;
  /** List of customers saved payment methods serviced by this merchant account */
  customer_payment_profiles?: Maybe<Array<SavedPaymentMethods>>;
  /** Reference to the user account assigned to the merchant account */
  cynergy_account_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Description of merchant account */
  description?: Maybe<Scalars["String"]["output"]>;
  events?: Maybe<Array<MerchantAccountEvents>>;
  gateways?: Maybe<Array<PaymentGateways>>;
  is_archived: Scalars["Boolean"]["output"];
  /** AP sub-ledger entries for this merchant */
  ledger_entries?: Maybe<Array<PayableLedgerEntries>>;
  /** The operational mode of the merchant account. */
  mode: OperationalModeCodes;
  /** Name of account */
  name: Scalars["String"]["output"];
  owner: CynergyAccounts;
  /** List of payment methods accepted by the merchant */
  payment_methods?: Maybe<Array<MerchantAccountPaymentMethodsList>>;
  /** Merchant account active and able to accept payments. */
  payment_status: PaymentGatewayComponentStatus;
  /** Payment provider can move funds to merchant account */
  payout_status: PaymentGatewayComponentStatus;
  /** Payouts made to this merchant */
  payouts?: Maybe<Array<Payouts>>;
  /** Pending payout balance (AP) */
  pending_balance: Scalars["USCurrency"]["output"];
  /** State of merchant account */
  status: PaymentGatewayStatus;
  /** Transfers routed to this merchant */
  transfers?: Maybe<Array<PaymentTransfers>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MerchantCredentialActionInput = {
  add?: InputMaybe<MerchantCredentialInput>;
  remove?: InputMaybe<MerchantCredentialDeleteInput>;
  update?: InputMaybe<MerchantCredentialUpdateInput>;
};

export type MerchantCredentialCreateInput = {
  /** Merchant gateway connection details */
  credentials: EndpointCredentialCreateInput;
  /** Indicates if these credentials are used to connect to gateway sandbox */
  isSandboxCredentials?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Merchant credential definition */
  merchantCredentialDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
  paymentGatewayId: Scalars["ID"]["input"];
};

export type MerchantCredentialDefinitionCreateInput = {
  credential: MerchantEndpointCredentialLinkOrCreateInput;
  /** The gateway this definition applies to */
  gateway: PaymentGatewayProcessorType;
  /** Human friendly name */
  name: Scalars["String"]["input"];
};

/** List of merchant credential definition status codes */
export enum MerchantCredentialDefinitionStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Retired = "RETIRED",
  Trial = "TRIAL",
}

export type MerchantCredentialDefinitions = {
  __typename?: "MerchantCredentialDefinitions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Defined credential set */
  credential: EndpointCredentialDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  gateway: PaymentGatewayProcessorType;
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  status: MerchantCredentialDefinitionStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Definition version */
  version: Scalars["String"]["output"];
  version_status: RecordVersionStatus;
};

export type MerchantCredentialDeleteInput = {
  credentialId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MerchantCredentialInput = {
  /** Merchant gateway connection details */
  credentials: EndpointCredentialCreateInput;
  /** Indicates if these credentials are used to connect to gateway sandbox */
  isSandboxCredentials?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Merchant credential definition */
  merchantCredentialDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MerchantCredentialPaginatedResults = {
  __typename?: "MerchantCredentialPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<MerchantCredentials>;
  totalPages: Scalars["Float"]["output"];
};

export type MerchantCredentialUpdateInput = {
  credentialId: Scalars["ID"]["input"];
  credentials?: InputMaybe<EndpointCredentialUpdateInput>;
  /** Indicates if these credentials are used to connect to gateway sandbox */
  isSandboxCredentials?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MerchantCredentials = {
  __typename?: "MerchantCredentials";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition: MerchantCredentialDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  endpoint_credentials: EndpointCredentials;
  gateway: PaymentGateways;
  is_archived: Scalars["Boolean"]["output"];
  sandbox_credentials: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MerchantEndpointCredentialLinkOrCreateInput = {
  endpointCredential?: InputMaybe<EndpointCredentialDefinitionCreateInput>;
  endpointCredentialDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MergeFieldOverrideInput = {
  field: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type MergeRequestResultObject = {
  __typename?: "MergeRequestResultObject";
  errors?: Maybe<Array<FieldError>>;
  /** ID of the master record */
  id: Scalars["ID"]["output"];
  mergedRecordIds: Array<Scalars["ID"]["output"]>;
  updatedRelationalIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export type MessageBodyObject = {
  __typename?: "MessageBodyObject";
  isRichText: Scalars["Boolean"]["output"];
  messageSegments?: Maybe<Array<MessageSegmentUnion>>;
  text?: Maybe<Scalars["String"]["output"]>;
};

/** List of folders for messages */
export enum MessageFolders {
  Inbox = "Inbox",
  Starred = "Starred",
  Trash = "Trash",
}

/** Labels or 'tags' to associate messages to */
export enum MessageLabels {
  Default = "Default",
  Important = "Important",
  Personal = "Personal",
  Private = "Private",
  Report = "Report",
}

/** List of supported rich text markup */
export enum MessageMarkupType {
  Bold = "Bold",
  Code = "Code",
  Hyperlink = "Hyperlink",
  Italic = "Italic",
  ListItem = "ListItem",
  OrderedList = "OrderedList",
  Paragraph = "Paragraph",
  Strikethrough = "Strikethrough",
  Underline = "Underline",
  UnorderedList = "UnorderedList",
}

export type MessageSegmentLinkObject = {
  __typename?: "MessageSegmentLinkObject";
  text?: Maybe<Scalars["String"]["output"]>;
  type: MessageSegmentType;
  url: Scalars["URL"]["output"];
};

export type MessageSegmentMarkupBeginObject = {
  __typename?: "MessageSegmentMarkupBeginObject";
  altText?: Maybe<Scalars["String"]["output"]>;
  htmlTag: Scalars["String"]["output"];
  markupType: MessageMarkupType;
  text?: Maybe<Scalars["String"]["output"]>;
  type: MessageSegmentType;
  url?: Maybe<Scalars["URL"]["output"]>;
};

export type MessageSegmentMarkupEndObject = {
  __typename?: "MessageSegmentMarkupEndObject";
  htmlTag: Scalars["String"]["output"];
  markupType: MessageMarkupType;
  text?: Maybe<Scalars["String"]["output"]>;
  type: MessageSegmentType;
};

export type MessageSegmentTextObject = {
  __typename?: "MessageSegmentTextObject";
  text?: Maybe<Scalars["String"]["output"]>;
  type: MessageSegmentType;
};

/** List of possible types of message segments */
export enum MessageSegmentType {
  EntityLink = "EntityLink",
  FieldChange = "FieldChange",
  FieldChangeName = "FieldChangeName",
  FieldChangeValue = "FieldChangeValue",
  Hashtag = "Hashtag",
  Link = "Link",
  MarkupBegin = "MarkupBegin",
  MarkupEnd = "MarkupEnd",
  Mention = "Mention",
  Text = "Text",
}

export type MessageSegmentUnion =
  MessageSegmentLinkObject | MessageSegmentMarkupBeginObject | MessageSegmentMarkupEndObject | MessageSegmentTextObject;

export type MessageUpdatePayload = {
  attachment?: InputMaybe<Scalars["String"]["input"]>;
  folder?: InputMaybe<MessageFolders>;
  is_read?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_starred?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_trashed?: InputMaybe<Scalars["Boolean"]["input"]>;
  labels?: InputMaybe<Array<MessageLabels>>;
};

export type Messages = {
  __typename?: "Messages";
  /** Minio link to file */
  attachment?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  folder: MessageFolders;
  from_email: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  is_read: Scalars["Boolean"]["output"];
  is_starred?: Maybe<Scalars["Boolean"]["output"]>;
  is_trashed?: Maybe<Scalars["Boolean"]["output"]>;
  labels: Array<MessageLabels>;
  message_id: Scalars["String"]["output"];
  notification?: Maybe<Notifications>;
  slug?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MetaDataType = {
  __typename?: "MetaDataType";
  priority?: Maybe<Scalars["Float"]["output"]>;
  rating?: Maybe<Scalars["Float"]["output"]>;
};

export type Metadata = {
  __typename?: "Metadata";
  /** Tracks click-through counts */
  clicks?: Maybe<Scalars["Float"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  meta_id: Scalars["String"]["output"];
  /** Profiles this resource claims to conform to (A URI referencing resource(s) with a "url" property) */
  profile?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Security label applied to this resource */
  security?: Maybe<SecurityLabel>;
  /** Identifies where the resource comes from (uri) */
  source?: Maybe<Scalars["String"]["output"]>;
  /** Tags applied to this resource */
  tags?: Maybe<Array<CommonMetaTags>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Version specific identifier */
  version_id?: Maybe<Scalars["String"]["output"]>;
};

/** Non-comprehensive list of mime-types */
export enum MimeTypes {
  Aac = "AAC",
  Ai = "AI",
  Apk = "APK",
  Apng = "APNG",
  AppleApp = "APPLE_APP",
  Application = "APPLICATION",
  Asx = "ASX",
  Atom = "ATOM",
  Avi = "AVI",
  Avif = "AVIF",
  Ayaml = "AYAML",
  Azw = "AZW",
  Bmp = "BMP",
  Bz = "BZ",
  C = "C",
  Cab = "CAB",
  Cbr = "CBR",
  Cbz = "CBZ",
  Cpp = "CPP",
  Crx = "CRX",
  Csharp = "CSHARP",
  Css = "CSS",
  Csv = "CSV",
  Cue = "CUE",
  Cur = "CUR",
  Deb = "DEB",
  Digsig = "DIGSIG",
  Dmg = "DMG",
  Doc = "DOC",
  Docx = "DOCX",
  Dwg = "DWG",
  Eml = "EML",
  Eot = "EOT",
  Eps = "EPS",
  Exe = "EXE",
  Fla = "FLA",
  Flac = "FLAC",
  Flv = "FLV",
  FormUrlencoded = "FORM_URLENCODED",
  GeoJson = "GEO_JSON",
  Gif = "GIF",
  Gpx = "GPX",
  Gtar = "GTAR",
  Gz = "GZ",
  Gzip = "GZIP",
  Hdf = "HDF",
  Heic = "HEIC",
  Heif = "HEIF",
  Html = "HTML",
  Icalendar = "ICALENDAR",
  Ico = "ICO",
  Jar = "JAR",
  Java = "JAVA",
  Javascript = "JAVASCRIPT",
  Jp2 = "JP2",
  Jpeg = "JPEG",
  Jpg = "JPG",
  Js = "JS",
  Json = "JSON",
  Jsonld = "JSONLD",
  Kml = "KML",
  Kmz = "KMZ",
  LdJson = "LD_JSON",
  Less = "LESS",
  M3U = "M3U",
  M3U8 = "M3U8",
  M4A = "M4A",
  Midi = "MIDI",
  Mkv = "MKV",
  Mobi = "MOBI",
  Mp3 = "MP3",
  Mp4 = "MP4",
  Msg = "MSG",
  Msi = "MSI",
  MsExcelXls = "MS_EXCEL_XLS",
  MsPowerpointPpt = "MS_POWERPOINT_PPT",
  MsWordDoc = "MS_WORD_DOC",
  MultipartFormData = "MULTIPART_FORM_DATA",
  OctetStream = "OCTET_STREAM",
  Odp = "ODP",
  Ods = "ODS",
  Odt = "ODT",
  Ogg = "OGG",
  Ogx = "OGX",
  Opus = "OPUS",
  Otf = "OTF",
  Pdf = "PDF",
  Php = "PHP",
  Pl = "PL",
  PlainText = "PLAIN_TEXT",
  Png = "PNG",
  Pot = "POT",
  Potx = "POTX",
  Pps = "PPS",
  Ppt = "PPT",
  Pptx = "PPTX",
  Prc = "PRC",
  Psd = "PSD",
  Python = "PYTHON",
  Ram = "RAM",
  Rar = "RAR",
  Rmp = "RMP",
  Rpm = "RPM",
  Rss = "RSS",
  Ruby = "RUBY",
  Sass = "SASS",
  Scss = "SCSS",
  SevenZip = "SEVEN_ZIP",
  SoapXml = "SOAP_XML",
  Spx = "SPX",
  Sql = "SQL",
  Srt = "SRT",
  Styl = "STYL",
  Svg = "SVG",
  Swf = "SWF",
  Tar = "TAR",
  Tbz = "TBZ",
  Tgz = "TGZ",
  Tif = "TIF",
  Tiff = "TIFF",
  Ttf = "TTF",
  Txt = "TXT",
  Txz = "TXZ",
  Typescript = "TYPESCRIPT",
  Tz = "TZ",
  Vcard = "VCARD",
  Vtt = "VTT",
  Wav = "WAV",
  Webm = "WEBM",
  Webp = "WEBP",
  Wgt = "WGT",
  Wma = "WMA",
  Wmv = "WMV",
  Woff = "WOFF",
  Woff2 = "WOFF2",
  Wpd = "WPD",
  Xap = "XAP",
  Xless = "XLESS",
  Xls = "XLS",
  Xlsx = "XLSX",
  Xml = "XML",
  Xpi = "XPI",
  Xz = "XZ",
  Yaml = "YAML",
  Z = "Z",
  Zip = "ZIP",
}

export type MinioS3DestinationInput = {
  bucket: Scalars["String"]["input"];
  path: Scalars["String"]["input"];
};

/** Device type of the Token Generation */
export enum MobileDeviceType {
  Android = "ANDROID",
  Iphone = "IPHONE",
}

export type MonthlyAvailabilities = {
  __typename?: "MonthlyAvailabilities";
  availability_id: Scalars["ID"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Available every month? */
  every_month: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The months of availability */
  months?: Maybe<Array<MonthsOfYear>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type MonthlyRecurrenceInput = {
  /** Indicates day and week of the month event should occur */
  dayInWeek?: InputMaybe<RecurrenceDayInWeekInput>;
  /** Recurs on a specific day of the month (1-31) */
  dayOfMonth?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MonthlyRecurrencePatternActionInput = {
  add?: InputMaybe<MonthlyRecurrencePatternCreateInput>;
  remove?: InputMaybe<MonthlyRecurrencePatternDeleteInput>;
  update?: InputMaybe<MonthlyRecurrencePatternUpdateInput>;
};

export type MonthlyRecurrencePatternCreateInput = {
  /** Event should occur every nth month */
  interval: Scalars["Float"]["input"];
  /** When the recurrence should take place */
  recurs: MonthlyRecurrenceInput;
};

export type MonthlyRecurrencePatternDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  patternId: Scalars["ID"]["input"];
};

export type MonthlyRecurrencePatternUpdateInput = {
  /** Event should occur every nth month */
  interval?: InputMaybe<Scalars["Float"]["input"]>;
  patternId: Scalars["ID"]["input"];
  /** When the recurrence should take place */
  recurs?: InputMaybe<MonthlyRecurrenceInput>;
};

export type MonthlyRecurrencePatterns = {
  __typename?: "MonthlyRecurrencePatterns";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Recurs on a specific day of the month (1-31) */
  day_of_month?: Maybe<Scalars["Float"]["output"]>;
  /** Indicates which day of the week the recurring event should occur each nth week */
  day_of_week?: Maybe<DaysOfWeek>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Recurs every nth month */
  interval: Scalars["Float"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  pattern_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Indicates which week of the month the event should occur */
  week_of_month?: Maybe<WeekOfMonth>;
};

/** Listed months of year */
export enum MonthsOfYear {
  April = "APRIL",
  August = "AUGUST",
  December = "DECEMBER",
  February = "FEBRUARY",
  January = "JANUARY",
  July = "JULY",
  June = "JUNE",
  March = "MARCH",
  May = "MAY",
  November = "NOVEMBER",
  October = "OCTOBER",
  September = "SEPTEMBER",
}

export type Mutation = {
  __typename?: "Mutation";
  acceptOnboardingInvite: CynergyUsers;
  activateStaffAssignment: StaffAssignments;
  addActivityDefinitionRequirements: ActivityDefinitions;
  addAnswerOptionsToQuestion: Array<FeedbackUnion>;
  addAppointmentRecurrence: AppointmentRecurrenceSeries;
  addBulkPatientMedications: Array<MedicationResults>;
  addCatalogItems: Array<ProductCatalogItems>;
  /** Add a destination endpoint to an integration channel */
  addChannelDestination: ChannelDestinationResponse;
  addClinicalNoteToPatient: ClinicalNotes;
  addDiagnosticReportMedia: DiagnosticReports;
  /** Add a filter rule to an integration channel */
  addIntegrationChannelFilter: IntegrationChannelFilterResponse;
  addLabObservationMembers: Array<Observations>;
  addMerchantCredentials: MerchantCredentials;
  addPatientSelfServiceCartItem: PatientSelfServiceCartItems;
  addPractitionerContacts: Array<ContactPoints>;
  addPractitionerQualifications: Array<PractitionerQualifications>;
  addPractitionerTaxonomies: Array<Taxonomies>;
  addSupportingDiagnosticReportInformation: DiagnosticReports;
  addToCart: WebCartItems;
  addToCollection: CollectionEntries;
  archiveCoverage: Coverages;
  assignPatientRoom: Scalars["String"]["output"];
  attachDiagnosticReportResults: DiagnosticReports;
  attachOrderSignature: OrderSignatures;
  bookAppointment: AppointmentBookResult;
  bulkRegisterLocationPatients: BulkRegisterLocationPatientsResult;
  cancelAppointmentRequest: Appointments;
  /** Cancel a lab order and all pending work items */
  cancelLabOrder: LabOrderResponse;
  cancelOrder: RecordsDeleted;
  cancelOrderAppointment: RecordsDeleted;
  cancelOrderBatch: RecordsDeleted;
  changeEmployeePassword: Scalars["String"]["output"];
  changeUserPassword: Scalars["String"]["output"];
  checkInAppointment: Appointments;
  checkoutCart: Orders;
  clearCart: WebCarts;
  clearPatientSelfServiceCart: PatientSelfServiceCart;
  collectOrderFee: OrderChargeResult;
  confirmBookingAppointment: Scalars["Boolean"]["output"];
  confirmEmail: Scalars["String"]["output"];
  convertPatientSelfServiceCartForCheckout: WebCarts;
  copyLocationStaff: Array<StaffAssignments>;
  createAccessGroup: AccessGroups;
  createActivityDefinition: ActivityDefinitions;
  createAppointmentRequest: Appointments;
  createBillingAccount: BillingAccounts;
  createBulkRouteLocation: Array<RoutesUnion>;
  createCarePlan: CarePlans;
  createCareTeam: CareTeams;
  createCareTeamMembers: CareTeams;
  createChannelMembers: Array<ChannelMembers>;
  /** Create a new channel template */
  createChannelTemplate: ChannelTemplateResponse;
  createCommunication: Communications;
  createCommunicationRequest: CommunicationRequests;
  createConditionsAssessment: Array<ClinicalImpressions>;
  createCynergyUserProfile: CynergyUsers;
  /** Create a new device (gateway) */
  createDevice: DeviceResponse;
  createDiagnosticCatalog: DiagnosticServiceCatalog;
  createDiagnosticReport: DiagnosticReports;
  createDiagnosticService: DiagnosticServices;
  createDuplicateJobDefinition: DuplicateJobDefinitions;
  createDuplicateRecordRule: DuplicateRecordRules;
  createEmployee: StaffAssignments;
  /** Create a new endpoint */
  createEndpoint: EndpointResponse;
  /** Create structured endpoint configuration */
  createEndpointConfig: EndpointConfigResponse;
  createEpisodeOfCare: EpisodeOfCare;
  createEvent: Events;
  /** Create a new external code mapping */
  createExternalCodeMapping: ExternalCodeMappingResponse;
  createFieldMatchProbabilityDefinition: RecordFieldMatchProbabilityDefinitions;
  createHealthcareService: HealthcareServices;
  /** Create a new integration channel */
  createIntegrationChannel: IntegrationChannelResponse;
  createKeycloakOrganizations: Scalars["JSON"]["output"];
  createLab: Labs;
  createLabObservation: Observations;
  createLocation: Locations;
  createMedicalCondition: Array<Conditions>;
  createMerchantCredentialDefinition: MerchantCredentialDefinitions;
  createNewFolder: Scalars["String"]["output"];
  createObservationDefinition: ObservationDefinitions;
  createOrder: Orders;
  createOrderAppointment: OrderAppointment;
  createOrganization: Organizations;
  createOrganizationAffiliation: OrganizationAffiliations;
  createPatientSelfServiceCart: PatientSelfServiceCart;
  createPaymentGroup: PaymentGroups;
  createPaymentProfile: PaymentResultsUnion;
  createPaymentTerm: PaymentTerms;
  createPriceBook: PriceBooks;
  createProduct: Products;
  createProductCatalog: ProductCatalogs;
  createQuestionnaireAnswers: Array<FeedbackUnion>;
  createQuestionnaireForm: FeedbackUnion;
  createQuestionnaireItems: Array<FeedbackUnion>;
  createQuestionnaireResponse: FeedbackUnion;
  createRecordFieldMatchProbability: RecordFieldMatchProbabilities;
  createRecordMatchingRule: RecordMatchingRules;
  createRecurrencePattern: RecurrencePatterns;
  createReportSetting: DiagnosticReportSettings;
  createResourceIdentifier: ResourceUnion;
  createResourceReference: ResourceUnion;
  createRouteAssignment: RoutesUnion;
  createRouteLocation: RoutesUnion;
  createServiceRequest: ServiceRequests;
  createServiceSchedule: Schedules;
  createSpecimenConditioningDefinition: SpecimenDefinitionTests;
  createSpecimenContainerCapDefinition: SpecimenDefinitionContainerCaps;
  createSpecimenDefinition: SpecimenDefinitions;
  createStoreCategoryDefinitions: Array<WebStoreCategoryDefinitions>;
  createSubscriberChannel: SubscriptionChannels;
  createSubscriberTopic: SubscriptionTopics;
  createTask: Tasks;
  createTaskSteps: Array<TaskSteps>;
  createTreatmentPlan: CarePlans;
  createTwilioChallenge: CreateChallengeResponse;
  createUserAddress: Addresses;
  createUserCollection: Collections;
  createUserEvent: Array<UserEventData>;
  createUserProductBundle: UserProductBundles;
  createWaypoint: Scalars["String"]["output"];
  createWaypointsBulk: Scalars["String"]["output"];
  createWebCart: WebCarts;
  createWebStore: WebStores;
  createWebStoreConfiguration: WebStoreConfigurations;
  deactivateEventSeries: EventSeries;
  deactivateEventSeriesBatch: EventSeriesBulkDeactivateResult;
  deleteAccessGroup: RecordsDeleted;
  deleteAccessGroupBatch: RecordsDeleted;
  deleteActivityDefinition: RecordsDeleted;
  deleteAssignedWaypoint: Scalars["String"]["output"];
  deleteAssignedWaypointsBulk: Scalars["String"]["output"];
  /** Soft-delete a channel template */
  deleteChannelTemplate: ChannelTemplateResponse;
  deleteClinicalNote: Scalars["String"]["output"];
  deleteCommunication: RecordsDeleted;
  deleteCommunicationRequest: RecordsDeleted;
  deleteContactDetail: RecordsDeleted;
  deleteCynergyAccount: Scalars["String"]["output"];
  /** Soft-delete a device */
  deleteDevice: DeviceResponse;
  deleteDiagnosticCatalog: RecordsDeleted;
  deleteDiagnosticService: RecordsDeleted;
  deleteDuplicateJobDefinition: RecordsDeleted;
  deleteDuplicateRecordRule: RecordsDeleted;
  deleteEmployee: RecordsDeleted;
  /** Soft-delete an endpoint */
  deleteEndpoint: EndpointResponse;
  /** Soft-delete an external code mapping */
  deleteExternalCodeMapping: ExternalCodeMappingResponse;
  deleteFieldMatchProbabilityDefinition: RecordsDeleted;
  deleteFiles: Scalars["String"]["output"];
  deleteHealthcareService: RecordsDeleted;
  /** Soft-delete an integration channel */
  deleteIntegrationChannel: IntegrationChannelResponse;
  deleteLab: RecordsDeleted;
  deleteLabObservation: Scalars["String"]["output"];
  deleteLocation: RecordsDeleted;
  deleteMedicalCondition: Scalars["String"]["output"];
  deleteMedicationUsage: Scalars["String"]["output"];
  deleteMerchantCredentials: RecordsDeleted;
  deleteNotificationDataByCynergyId: Scalars["Float"]["output"];
  deleteObservationDefinition: RecordsDeleted;
  deleteOrder: RecordsDeleted;
  deleteOrderBatch: RecordsDeleted;
  deleteOrganization: RecordsDeleted;
  deleteOrphanTokens: Scalars["String"]["output"];
  deletePatientFiles: Scalars["String"]["output"];
  deletePaymentProfile: Scalars["String"]["output"];
  deletePaymentTerm: RecordsDeleted;
  deletePractitioner: Scalars["String"]["output"];
  deletePractitionerSignature: Scalars["String"]["output"];
  deletePriceBook: RecordsDeleted;
  deleteProductCatalog: RecordsDeleted;
  deleteProducts: RecordsDeleted;
  deleteQuestionnaire: Scalars["String"]["output"];
  deleteQuestionnaireItems: Scalars["String"]["output"];
  deleteQuestionnaireResponse: Scalars["String"]["output"];
  deleteRecordMatchingRule: RecordsDeleted;
  deleteServiceRequest: RecordsDeleted;
  deleteSpecimenConditioningDefinition: RecordsDeleted;
  deleteSpecimenContainerCapDefinition: RecordsDeleted;
  deleteSpecimenDefinition: RecordsDeleted;
  deleteStoreCategoryDefinitions: RecordsDeleted;
  deleteSubscriberChannel: RecordsDeleted;
  deleteTask: RecordsDeleted;
  deleteTwilioEntity: Scalars["String"]["output"];
  deleteTwilioFactor: Scalars["String"]["output"];
  deleteUserAccount: RecordsDeleted;
  deleteUserAddress: Scalars["String"]["output"];
  deleteUserAddressLines: Scalars["String"]["output"];
  deleteUserCollection: RecordsDeleted;
  deleteUserEvent: Array<UserEventData>;
  deleteUserProductBundle: RecordsDeleted;
  deleteUserProductBundleBatch: RecordsDeleted;
  deleteWebStore: RecordsDeleted;
  /** Disable an integration channel */
  disableIntegrationChannel: IntegrationChannelResponse;
  disableTwoFactorAuthentication: TwoFactorAuthentication;
  emitToChannel: Scalars["JSONObject"]["output"];
  /** Enable an integration channel for processing */
  enableIntegrationChannel: IntegrationChannelResponse;
  /** Ensures the caller has a Stripe customer registered under the given store's gateway, returning its stripe_customer_id. */
  ensureStripeCustomerForStore?: Maybe<Scalars["String"]["output"]>;
  finishLeg: Scalars["String"]["output"];
  getFile: Array<Scalars["String"]["output"]>;
  getPresignedRequestUrl: Scalars["URL"]["output"];
  getPresignedUploadUrl: Scalars["URL"]["output"];
  getReportUrl: Scalars["URL"]["output"];
  /** Mark an unmapped code as IGNORED so it stops appearing in the review list */
  ignoreUnmappedCode: UnmappedCodeResponse;
  importKeycloakUsers: Scalars["String"]["output"];
  /** Ingest a raw gateway message for processing and tracking */
  ingestGatewayMessage: IngestGatewayMessageResponse;
  /** Ingest a new order into the gateway routing engine from an HL7 ORM, EHR, or LIS */
  ingestGatewayOrder: LabOrderResponse;
  ingestGatewayWebhookEvent: Scalars["JSONObject"]["output"];
  initializeUserNotificationChannels: Array<Scalars["String"]["output"]>;
  /** Link a device to an endpoint */
  linkDeviceEndpoint: DeviceResponse;
  /** Link an instrument to an endpoint by instrument code */
  linkInstrumentToEndpoint: InstrumentRoutingResponse;
  login: LoginResponse;
  manageAccessGroupMembers: AccessGroups;
  manageCollectionEntries: Collections;
  manageEmployee: StaffAssignments;
  manageFiles: ExploreFilesResponse;
  manageFolder: ExploreFilesResponse;
  managePaymentGateway: PaymentGateways;
  managePriceBook: PriceBooks;
  manageProduct: Products;
  manageProductCatalog: ProductCatalogs;
  manageRecurrencePattern: RecurrencePatterns;
  manageSharedFile: Scalars["String"]["output"];
  manageUserAddress: UpdateAddressResponse;
  manageUserContacts: UpdateContactsResponse;
  manageUserDependents: UpdateDependentsResponse;
  manageUserProductBundleItems: UserProductBundles;
  manageUserProductBundleShares: UserProductBundles;
  mergeOrders: Orders;
  mergeRecords: MergeRequestResultObject;
  mergeRecordsBatch: Array<MergeRequestResultObject>;
  moveFiles: ExploreFilesResponse;
  orderSignatureSync: Scalars["Float"]["output"];
  orderSubjectNameSync: Scalars["String"]["output"];
  parseDriverLicense: DriverLicenseResult;
  parseMedication: MedicationResult;
  /** Process an inbound ORU result message — match to work items and check completion */
  processInboundResult: ProcessResultResponse;
  processOrderPayment: PaymentGatewayResultCodes;
  pubSubMutationToDynamicTopic: Notifications;
  /** Purge (soft-delete) gateway messages older than a given date */
  purgeGatewayMessages: PurgeGatewayMessagesResponse;
  readUserNotification: Scalars["String"]["output"];
  /** Receive aggregated results from the gateway and create DiagnosticReport + Observations */
  receiveLabResults: ReceiveResultsResponse;
  /** Records user acceptance of a specific legal document. Idempotent - safe to call multiple times. */
  recordUserAcceptance: Scalars["Boolean"]["output"];
  /** Record a result for a specific work item */
  recordWorkItemResult: LabOrderResponse;
  /** Register (find-or-create) a gateway device for a specific org + location + hostname */
  registerDeviceGateway: RegisterDeviceGatewayResponse;
  registerLocationPatient: LocationPatients;
  registerLocationStaff: StaffAssignments;
  registerOrActivateExpoNotificationToken: Scalars["String"]["output"];
  registerPractitioner: Practitioners;
  registerTwilioFactor: TwoFactorAuthentication;
  removeActivityDefinitionRequirements: RecordsDeleted;
  removeAnswerOptionsFromQuestion: Scalars["String"]["output"];
  removeCatalogItems: RecordsDeleted;
  /** Remove a destination from an integration channel */
  removeChannelDestination: ChannelDestinationResponse;
  removeChannelMembers: RecordsDeleted;
  removeEnableWhenConstraintFromQuestion: Scalars["String"]["output"];
  removeFromCart: WebCarts;
  removeFromCollection: RecordsDeleted;
  removeFromCollectionBulk: RecordsDeleted;
  /** Remove a filter rule from an integration channel */
  removeIntegrationChannelFilter: IntegrationChannelFilterResponse;
  removeLabObservationMember: Observations;
  removeLocationPatient: LocationPatients;
  removeObservationDefinitionContact: RecordsDeleted;
  removeOrganizationAffiliation: RecordsDeleted;
  removePatientDocument: Scalars["ID"]["output"];
  removePatientSelfServiceCartItem: PatientSelfServiceCart;
  reorderTrackedTests: Array<TrackedTest>;
  reportRequesterSync: Scalars["Float"]["output"];
  reportSubjectNameSync: Scalars["String"]["output"];
  /** Reprocess a previously failed or processed gateway message */
  reprocessGatewayMessage: IngestGatewayMessageResponse;
  requestPasswordReset: Scalars["String"]["output"];
  rescheduleAppointmentRequest: Appointments;
  rescheduleOrderAppointment: OrderAppointment;
  resendVerificationEmail: Scalars["String"]["output"];
  resetPassword: Scalars["String"]["output"];
  restoreCoverage: Coverages;
  restoreLocationPatient: LocationPatients;
  /** Retry a failed work item — reset to pending and re-dispatch */
  retryWorkItem: LabOrderResponse;
  /** Route an ingested gateway order: resolve test codes to instruments and create work items */
  routeGatewayOrder: LabOrderResponse;
  runExpansionJob: Scalars["Float"]["output"];
  runSymptomAssessment: SymptomAssessmentResults;
  sendAlertNotification: Scalars["JSONObject"]["output"];
  sendNotification: Notifications;
  sendOnboardingInvite: OnboardingInvite;
  /** Manually trigger sending aggregated results to the LIS */
  sendOrderResults: LabOrderResponse;
  /** Sends new orders to external source. */
  sendOrderToExternal: ExternalOrderResponse;
  sendSmsVerificationCode: TwilioVerifyResponse;
  sendToStratus: Scalars["Float"]["output"];
  sendoutRequisitionEmails: RequisitionEmailSendoutResponse;
  setChannelAlertEmails: Array<ChannelAlertEmails>;
  setEnableWhenConstraintToQuestion: FeedbackUnion;
  setLabObservationResultValue: ObservationResultValues;
  settleOrder: OrderChargeResult;
  setupMerchantAccount: MerchantAccounts;
  setupPaymentGateway: PaymentGateways;
  setupTwoFactorProfile: TwoFactorAuthentication;
  shareUserProductBundleWithGroups: UserProductBundles;
  startLeg: Scalars["String"]["output"];
  submitCriteriaResults: CriteriaFormResults;
  /** Submit a lab order from LabCynergy to the gateway for instrument routing */
  submitLabOrder: SubmitLabOrderResponse;
  submitOrderRequest: Orders;
  /** Batch sync all destinations for a channel (create/update/remove) */
  syncChannelDestinations: Scalars["String"]["output"];
  testGatewayConnection: Scalars["String"]["output"];
  toggleAlertType: UserAlertSettings;
  toggleSupervisorRole: SupervisorRoleResult;
  trackTest: Scalars["Boolean"]["output"];
  /** Unlink a device from an endpoint */
  unlinkDeviceEndpoint: DeviceResponse;
  /** Unlink an instrument from its endpoint */
  unlinkInstrumentFromEndpoint: InstrumentRoutingResponse;
  untrackTest: Scalars["Boolean"]["output"];
  updateAccessGroup: AccessGroups;
  updateActivityDefinition: ActivityDefinitions;
  updateAppointmentRequest: Appointments;
  updateAssignedWaypoint: Scalars["String"]["output"];
  updateBillingAccount: BillingAccounts;
  updateCatalogItem: ProductCatalogItems;
  updateChannelMember: ChannelMembers;
  /** Update an existing channel template */
  updateChannelTemplate: ChannelTemplateResponse;
  updateClinicalNote: ClinicalNotes;
  updateCommunication: Communications;
  updateCommunicationRequest: CommunicationRequests;
  updateConditionAssessment: ClinicalImpressions;
  /** Update an existing device */
  updateDevice: DeviceResponse;
  updateDiagnosticCatalog: DiagnosticServiceCatalog;
  updateDiagnosticReport: DiagnosticReports;
  updateDiagnosticService: DiagnosticServices;
  updateDuplicateJobDefinition: DuplicateJobDefinitions;
  updateDuplicateRecordRule: DuplicateRecordRules;
  updateEmployee: StaffAssignments;
  /** Update an existing endpoint */
  updateEndpoint: EndpointResponse;
  /** Update endpoint configuration */
  updateEndpointConfig: EndpointConfigResponse;
  updateEpisodeOfCare: EpisodeOfCare;
  updateEvent: Events;
  updateEventSeries: EventSeries;
  /** Update an existing external code mapping */
  updateExternalCodeMapping: ExternalCodeMappingResponse;
  updateFieldMatchProbabilityDefinition: RecordFieldMatchProbabilityDefinitions;
  updateHealthcareService: HealthcareServices;
  /** Update an existing integration channel */
  updateIntegrationChannel: IntegrationChannelResponse;
  updateLocation: Locations;
  updateMedicalCondition: Conditions;
  updateMerchantAccount: MerchantAccounts;
  updateOrder: Orders;
  updateOrderAppointment: Orders;
  updateOrganization: Organizations;
  updateOrganizationAffiliation: OrganizationAffiliations;
  updatePatientMedication: MedicationResults;
  updatePatientSelfServiceCartItem: PatientSelfServiceCartItems;
  updatePatientVitals: UserResults;
  updatePaymentProfile: PaymentResultsUnion;
  updatePaymentTerm: PaymentTerms;
  updateProfilePhoto: UpdateProfileResponse;
  updateQuestionnaireForm: FeedbackUnion;
  updateQuestionnaireItem: FeedbackUnion;
  updateQuestionnaireResponse: FeedbackUnion;
  updateRecordFieldMatchProbability: RecordFieldMatchProbabilities;
  updateRecordMatchingRule: RecordMatchingRules;
  updateRouteAssignment: RoutesUnion;
  updateRouteLocation: RoutesUnion;
  updateScheduleSlot: Slots;
  updateSeriesOccurrence: Events;
  updateServiceRequest: ServiceRequests;
  updateServiceSchedule: Schedules;
  updateSpecimenConditioningDefinition: SpecimenDefinitionTests;
  updateSpecimenContainerCapDefinition: SpecimenDefinitionContainerCaps;
  updateSpecimenDefinition: SpecimenDefinitions;
  updateStoreCategoryDefinition: WebStoreCategoryDefinitions;
  updateSubscriberChannel: SubscriptionChannels;
  updateSubscriberTopic: SubscriptionTopics;
  updateTask: Tasks;
  updateTaskStep: TaskSteps;
  updateUserAddress: Addresses;
  updateUserEvent: Array<UserEventData>;
  updateUserMessages: Array<Messages>;
  updateUserNotification: Scalars["String"]["output"];
  updateUserProductBundle: UserProductBundles;
  updateUserProfile: CynergyUsers;
  updateWaypointSequence: Scalars["String"]["output"];
  updateWebStoreConfiguration: WebStoreConfigurations;
  uploadFiles: FileUploadResponse;
  /** Accepts completed external observations. Not meant to accept internal lab observations. */
  uploadLabResult: ExternalDiagnosticResultResponse;
  uploadPatientDocuments: Array<PatientDocumentResponse>;
  uploadPatientFiles: Array<PatientFileResponse>;
  uploadPractitionerSignature: PractitionerSignatures;
  /** Creates orders from external sources. Not meant to accept internal lab observations. */
  uploadServiceRequest: ExternalServiceRequestResponse;
  upsertCoverage: Coverages;
  userRegister: CynergyUsers;
  verifySmsVerificationCode: TwilioVerifyResponse;
  verifyTokenActivity: Scalars["String"]["output"];
  verifyTwilioFactor: TwilioVerifyResponse;
};

export type MutationAcceptOnboardingInviteArgs = {
  invitePayload: AcceptOnboardingInviteInput;
};

export type MutationActivateStaffAssignmentArgs = {
  assignmentId: Scalars["String"]["input"];
};

export type MutationAddActivityDefinitionRequirementsArgs = {
  requirements: ActivityDefinitionRequirementCreateInput;
};

export type MutationAddAnswerOptionsToQuestionArgs = {
  options: Array<QuestionnaireAnswerOptionsInput>;
  questionItemID: Scalars["String"]["input"];
};

export type MutationAddAppointmentRecurrenceArgs = {
  recurrence: AppointmentRecurrenceSeriesCreateInput;
};

export type MutationAddBulkPatientMedicationsArgs = {
  medicationPayload: AddPatientMedicationInput;
};

export type MutationAddCatalogItemsArgs = {
  items: ProductCatalogItemBulkCreateInput;
};

export type MutationAddChannelDestinationArgs = {
  channelId: Scalars["String"]["input"];
  endpointId: Scalars["String"]["input"];
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationAddClinicalNoteToPatientArgs = {
  payload: ClinicalNoteCreateInput;
};

export type MutationAddDiagnosticReportMediaArgs = {
  media: DiagnosticReportMediaBulkCreateInput;
};

export type MutationAddIntegrationChannelFilterArgs = {
  channelId: Scalars["String"]["input"];
  fieldPath: Scalars["String"]["input"];
  filterType: Scalars["String"]["input"];
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  operator: Scalars["String"]["input"];
  sortOrder?: InputMaybe<Scalars["Float"]["input"]>;
  value: Scalars["String"]["input"];
};

export type MutationAddLabObservationMembersArgs = {
  members: ObservationMemberBulkCreateInput;
};

export type MutationAddMerchantCredentialsArgs = {
  credential: MerchantCredentialCreateInput;
};

export type MutationAddPatientSelfServiceCartItemArgs = {
  item: PatientSelfServiceCartItemInput;
};

export type MutationAddPractitionerContactsArgs = {
  contacts: PractitionerContactCreateInput;
};

export type MutationAddPractitionerQualificationsArgs = {
  qualifications: QualificationCreateInput;
};

export type MutationAddPractitionerTaxonomiesArgs = {
  taxonomies: TaxonomyCreateInput;
};

export type MutationAddSupportingDiagnosticReportInformationArgs = {
  information: DiagnosticReportInformationBulkCreateInput;
};

export type MutationAddToCartArgs = {
  item: WebCartItemCreateInput;
};

export type MutationAddToCollectionArgs = {
  collection: AddToCollectionInput;
};

export type MutationArchiveCoverageArgs = {
  payload: CoverageArchiveInput;
};

export type MutationAssignPatientRoomArgs = {
  assignPayload: AssignPatientRoomInput;
};

export type MutationAttachDiagnosticReportResultsArgs = {
  results: DiagnosticResultBulkCreateInput;
};

export type MutationAttachOrderSignatureArgs = {
  signature: OrderSignatureUpsertInput;
};

export type MutationBookAppointmentArgs = {
  appointmentId: Scalars["String"]["input"];
};

export type MutationBulkRegisterLocationPatientsArgs = {
  payload: BulkRegisterLocationPatientsInput;
};

export type MutationCancelAppointmentRequestArgs = {
  request: AppointmentCancelInput;
};

export type MutationCancelLabOrderArgs = {
  labOrderId: Scalars["String"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCancelOrderArgs = {
  order: OrderDeleteInput;
};

export type MutationCancelOrderAppointmentArgs = {
  order: OrderDeleteInput;
  request: AppointmentCancelInput;
};

export type MutationCancelOrderBatchArgs = {
  batch: OrderBulkDeleteInput;
};

export type MutationChangeEmployeePasswordArgs = {
  assignmentId: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type MutationChangeUserPasswordArgs = {
  change: ChangeUserPasswordInput;
};

export type MutationCheckInAppointmentArgs = {
  appointmentId: Scalars["String"]["input"];
};

export type MutationCheckoutCartArgs = {
  checkout: CartCheckoutInput;
};

export type MutationConfirmBookingAppointmentArgs = {
  appointmentId: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
};

export type MutationConfirmEmailArgs = {
  cynergyId: Scalars["String"]["input"];
  validationId: Scalars["String"]["input"];
};

export type MutationCopyLocationStaffArgs = {
  payload: CopyLocationStaffInput;
};

export type MutationCreateAccessGroupArgs = {
  group: AccessGroupCreateInput;
};

export type MutationCreateActivityDefinitionArgs = {
  definition: ActivityDefinitionCreateInput;
};

export type MutationCreateAppointmentRequestArgs = {
  request: AppointmentCreateInput;
};

export type MutationCreateBillingAccountArgs = {
  account: BillingAccountCreateInput;
};

export type MutationCreateBulkRouteLocationArgs = {
  payload: BulkRouteLocationInput;
};

export type MutationCreateCarePlanArgs = {
  payload: CarePlanCreateInput;
};

export type MutationCreateCareTeamArgs = {
  payload: CareTeamCreateInput;
};

export type MutationCreateCareTeamMembersArgs = {
  payload: CareTeamMemberBulkCreateInput;
};

export type MutationCreateChannelMembersArgs = {
  members: ChannelMemberBulkCreateInput;
};

export type MutationCreateChannelTemplateArgs = {
  category: Scalars["String"]["input"];
  connectionType: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  destinationConfig?: InputMaybe<Scalars["String"]["input"]>;
  direction: Scalars["String"]["input"];
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  manufacturer: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  pollingIntervalMs?: InputMaybe<Scalars["Float"]["input"]>;
  protocols?: InputMaybe<Scalars["String"]["input"]>;
  retryAttempts?: InputMaybe<Scalars["Float"]["input"]>;
  retryDelayMs?: InputMaybe<Scalars["Float"]["input"]>;
  sourceConfig: Scalars["String"]["input"];
  timeoutMs?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationCreateCommunicationArgs = {
  communication: CommunicationCreateInput;
};

export type MutationCreateCommunicationRequestArgs = {
  request: CommunicationRequestCreateInput;
};

export type MutationCreateConditionsAssessmentArgs = {
  newSymptoms?: InputMaybe<SymptomsCreateInput>;
  patientId: Scalars["String"]["input"];
  payload: Array<ClinicalImpressionCreateInput>;
  taskId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateCynergyUserProfileArgs = {
  profileData: CynergyUserProfileCreateInput;
};

export type MutationCreateDeviceArgs = {
  availability: Scalars["String"]["input"];
  category: Scalars["String"]["input"];
  displayName: Scalars["String"]["input"];
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  manufacturer: Scalars["String"]["input"];
  modelNumber?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["String"]["input"];
  serialNumber?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["String"]["input"];
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateDiagnosticCatalogArgs = {
  catalog: DiagnosticCatalogCreateInput;
};

export type MutationCreateDiagnosticReportArgs = {
  report: DiagnosticReportCreateInput;
};

export type MutationCreateDiagnosticServiceArgs = {
  service: DiagnosticServiceCreateInput;
};

export type MutationCreateDuplicateJobDefinitionArgs = {
  definition: DuplicateJobDefinitionCreateInput;
};

export type MutationCreateDuplicateRecordRuleArgs = {
  rule: DuplicateRecordRuleCreateInput;
};

export type MutationCreateEmployeeArgs = {
  employee: StaffAssignmentCreateInput;
};

export type MutationCreateEndpointArgs = {
  address: Scalars["String"]["input"];
  connectionType: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  endpointId?: InputMaybe<Scalars["String"]["input"]>;
  environmentType?: InputMaybe<Scalars["String"]["input"]>;
  managingOrganizationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  status: Scalars["String"]["input"];
};

export type MutationCreateEndpointConfigArgs = {
  additionalConfig?: InputMaybe<Scalars["String"]["input"]>;
  codingId?: InputMaybe<Scalars["String"]["input"]>;
  endpointId: Scalars["String"]["input"];
  host?: InputMaybe<Scalars["String"]["input"]>;
  maxConnections?: InputMaybe<Scalars["Float"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  port?: InputMaybe<Scalars["Float"]["input"]>;
  privateKey?: InputMaybe<Scalars["String"]["input"]>;
  protocol: Scalars["String"]["input"];
  timeoutMs?: InputMaybe<Scalars["Float"]["input"]>;
  tlsCa?: InputMaybe<Scalars["String"]["input"]>;
  tlsCert?: InputMaybe<Scalars["String"]["input"]>;
  tlsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  tlsKey?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateEpisodeOfCareArgs = {
  payload: EpisodeOfCareCreateInput;
};

export type MutationCreateEventArgs = {
  event: EventCreateInput;
};

export type MutationCreateExternalCodeMappingArgs = {
  codingId: Scalars["String"]["input"];
  conceptMapGroupId?: InputMaybe<Scalars["String"]["input"]>;
  externalCode: Scalars["String"]["input"];
  externalDisplay?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  relationship?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  testCodeId?: InputMaybe<Scalars["String"]["input"]>;
  testPanelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateFieldMatchProbabilityDefinitionArgs = {
  definition: RecordFieldMatchProbabilityDefinitionCreateInput;
};

export type MutationCreateHealthcareServiceArgs = {
  service: HealthcareServiceCreateInput;
};

export type MutationCreateIntegrationChannelArgs = {
  config?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  destinationEndpointId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  direction: Scalars["String"]["input"];
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  messageDefinitionId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  pollingIntervalMs?: InputMaybe<Scalars["Float"]["input"]>;
  retryAttempts?: InputMaybe<Scalars["Float"]["input"]>;
  retryDelayMs?: InputMaybe<Scalars["Float"]["input"]>;
  sourceEndpointId: Scalars["String"]["input"];
  status: Scalars["String"]["input"];
  timeoutMs?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationCreateKeycloakOrganizationsArgs = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type MutationCreateLabArgs = {
  lab: LabCreateInput;
};

export type MutationCreateLabObservationArgs = {
  observation: ObservationCreateInput;
};

export type MutationCreateLocationArgs = {
  location: LocationCreateInput;
};

export type MutationCreateMedicalConditionArgs = {
  payload: ConditionCreateInput;
};

export type MutationCreateMerchantCredentialDefinitionArgs = {
  definition: MerchantCredentialDefinitionCreateInput;
};

export type MutationCreateNewFolderArgs = {
  path: Scalars["String"]["input"];
};

export type MutationCreateObservationDefinitionArgs = {
  definition: ObservationDefinitionCreateInput;
};

export type MutationCreateOrderArgs = {
  order: OrderCreateInput;
};

export type MutationCreateOrderAppointmentArgs = {
  order: SubmitOrderRequestInput;
  request: AppointmentCreateInput;
};

export type MutationCreateOrganizationArgs = {
  organization: OrganizationCreateInput;
};

export type MutationCreateOrganizationAffiliationArgs = {
  affiliation: AffiliationCreateInput;
};

export type MutationCreatePaymentGroupArgs = {
  group: PaymentGroupCreateInput;
};

export type MutationCreatePaymentProfileArgs = {
  billingAddress: BillingAddressType;
  cardDetails: CreditCardDetailsType;
  isDefault: Scalars["Boolean"]["input"];
};

export type MutationCreatePaymentTermArgs = {
  term: PaymentTermCreateInput;
};

export type MutationCreatePriceBookArgs = {
  priceBook: PriceBookCreateInput;
};

export type MutationCreateProductArgs = {
  product: ProductCreateInput;
};

export type MutationCreateProductCatalogArgs = {
  catalog: ProductCatalogCreateInput;
};

export type MutationCreateQuestionnaireAnswersArgs = {
  payload: Array<QuestionnaireAnswerCreateInput>;
  questionResponseID: Scalars["String"]["input"];
};

export type MutationCreateQuestionnaireFormArgs = {
  payload: QuestionnaireFormCreateInput;
};

export type MutationCreateQuestionnaireItemsArgs = {
  payload: QuestionnaireQuestionCreateInput;
};

export type MutationCreateQuestionnaireResponseArgs = {
  payload: QuestionnaireResponseCreateInput;
};

export type MutationCreateRecordFieldMatchProbabilityArgs = {
  matchProbability: RecordFieldMatchProbabilityCreateInput;
};

export type MutationCreateRecordMatchingRuleArgs = {
  rule: RecordMatchingRuleCreateInput;
};

export type MutationCreateRecurrencePatternArgs = {
  pattern: RecurrencePatternCreateInput;
};

export type MutationCreateReportSettingArgs = {
  reportSetting: DiagnosticReportSettingsCreateInput;
};

export type MutationCreateResourceIdentifierArgs = {
  payload: IdentifierCreateInput;
};

export type MutationCreateResourceReferenceArgs = {
  payload: ReferenceCreateInput;
};

export type MutationCreateRouteAssignmentArgs = {
  payload: RouteAssignmentInput;
};

export type MutationCreateRouteLocationArgs = {
  payload: RouteLocationInput;
};

export type MutationCreateServiceRequestArgs = {
  request: ServiceRequestCreateInput;
};

export type MutationCreateServiceScheduleArgs = {
  schedule: ScheduleCreateInput;
};

export type MutationCreateSpecimenConditioningDefinitionArgs = {
  specimenConditioning: SpecimenDefinitionTestCreateInput;
};

export type MutationCreateSpecimenContainerCapDefinitionArgs = {
  cap: SpecimenDefinitionContainerCapCreateInput;
};

export type MutationCreateSpecimenDefinitionArgs = {
  specimen: SpecimenDefinitionCreateInput;
};

export type MutationCreateStoreCategoryDefinitionsArgs = {
  definitions: WebStoreCategoryDefinitionBulkCreateInput;
};

export type MutationCreateSubscriberChannelArgs = {
  channel: ChannelCreateInput;
};

export type MutationCreateSubscriberTopicArgs = {
  topic: SubscriberTopicCreateInput;
};

export type MutationCreateTaskArgs = {
  payload: TaskCreateInput;
};

export type MutationCreateTaskStepsArgs = {
  payload: TaskStepCreateInput;
};

export type MutationCreateTreatmentPlanArgs = {
  payload: TreatmentPlanCreateInput;
};

export type MutationCreateTwilioChallengeArgs = {
  challenge: ChallengeCreateInput;
};

export type MutationCreateUserAddressArgs = {
  address: AddressCreateInput;
};

export type MutationCreateUserCollectionArgs = {
  collection: CollectionCreateInput;
};

export type MutationCreateUserEventArgs = {
  event: UserEvent;
};

export type MutationCreateUserProductBundleArgs = {
  bundle: UserProductBundleCreateInput;
};

export type MutationCreateWaypointArgs = {
  payload: AssignLocationInput;
};

export type MutationCreateWaypointsBulkArgs = {
  payload: AssignLocationsBulkInput;
};

export type MutationCreateWebStoreArgs = {
  store: WebStoreCreateInput;
};

export type MutationCreateWebStoreConfigurationArgs = {
  configuration: WebStoreConfigurationCreateInput;
};

export type MutationDeactivateEventSeriesArgs = {
  series: EventSeriesDeactivateInput;
};

export type MutationDeactivateEventSeriesBatchArgs = {
  series: EventSeriesBulkDeactivateInput;
};

export type MutationDeleteAccessGroupArgs = {
  group: AccessGroupDeleteInput;
};

export type MutationDeleteAccessGroupBatchArgs = {
  groups: AccessGroupBulkDeleteInput;
};

export type MutationDeleteActivityDefinitionArgs = {
  definition: ActivityDefinitionDeleteInput;
};

export type MutationDeleteAssignedWaypointArgs = {
  payload: DeleteAssignedWaypoint;
};

export type MutationDeleteAssignedWaypointsBulkArgs = {
  payload: DeleteAssignedWaypointsBulk;
};

export type MutationDeleteChannelTemplateArgs = {
  templateId: Scalars["String"]["input"];
};

export type MutationDeleteClinicalNoteArgs = {
  noteID: Scalars["String"]["input"];
};

export type MutationDeleteCommunicationArgs = {
  communication: CommunicationDeleteInput;
};

export type MutationDeleteCommunicationRequestArgs = {
  request: CommunicationRequestDeleteInput;
};

export type MutationDeleteContactDetailArgs = {
  contact: ContactDetailDeleteInput;
};

export type MutationDeleteCynergyAccountArgs = {
  cynergyId: Scalars["String"]["input"];
  force?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationDeleteDeviceArgs = {
  deviceId: Scalars["String"]["input"];
};

export type MutationDeleteDiagnosticCatalogArgs = {
  catalog: DiagnosticCatalogDeleteInput;
};

export type MutationDeleteDiagnosticServiceArgs = {
  service: DiagnosticServiceDeleteInput;
};

export type MutationDeleteDuplicateJobDefinitionArgs = {
  definition: DuplicateJobDefinitionDeleteInput;
};

export type MutationDeleteDuplicateRecordRuleArgs = {
  rule: DuplicateRecordRuleDeleteInput;
};

export type MutationDeleteEmployeeArgs = {
  employee: EmployeeAssignmentReleaseInput;
};

export type MutationDeleteEndpointArgs = {
  endpointId: Scalars["String"]["input"];
};

export type MutationDeleteExternalCodeMappingArgs = {
  mappingId: Scalars["String"]["input"];
};

export type MutationDeleteFieldMatchProbabilityDefinitionArgs = {
  definition: RecordFieldMatchProbabilityDefinitionDeleteInput;
};

export type MutationDeleteFilesArgs = {
  fileNames: Array<Scalars["String"]["input"]>;
};

export type MutationDeleteHealthcareServiceArgs = {
  service: HealthcareServiceDeleteInput;
};

export type MutationDeleteIntegrationChannelArgs = {
  channelId: Scalars["String"]["input"];
};

export type MutationDeleteLabArgs = {
  lab: LabDeleteInput;
};

export type MutationDeleteLabObservationArgs = {
  observation: ObservationDeleteInput;
};

export type MutationDeleteLocationArgs = {
  location: LocationDeleteInput;
};

export type MutationDeleteMedicalConditionArgs = {
  conditionId: Scalars["String"]["input"];
};

export type MutationDeleteMedicationUsageArgs = {
  usageId: Scalars["String"]["input"];
};

export type MutationDeleteMerchantCredentialsArgs = {
  credential: MerchantCredentialDeleteInput;
};

export type MutationDeleteNotificationDataByCynergyIdArgs = {
  cynergyId: Scalars["String"]["input"];
  force: Scalars["Boolean"]["input"];
};

export type MutationDeleteObservationDefinitionArgs = {
  definition: ObservationDefinitionDeleteInput;
};

export type MutationDeleteOrderArgs = {
  order: OrderDeleteInput;
};

export type MutationDeleteOrderBatchArgs = {
  batch: OrderBulkDeleteInput;
};

export type MutationDeleteOrganizationArgs = {
  organization: OrganizationDeleteInput;
};

export type MutationDeleteOrphanTokensArgs = {
  payload: ExpoNotificationTokenInput;
};

export type MutationDeletePatientFilesArgs = {
  fileCodes: Array<Scalars["String"]["input"]>;
};

export type MutationDeletePaymentProfileArgs = {
  paymentProfileID: Scalars["String"]["input"];
};

export type MutationDeletePaymentTermArgs = {
  term: PaymentTermDeleteInput;
};

export type MutationDeletePractitionerArgs = {
  deletePayload: PractitionerDeleteInput;
};

export type MutationDeletePractitionerSignatureArgs = {
  signature: PractitionerSignatureDeleteInput;
};

export type MutationDeletePriceBookArgs = {
  priceBook: PriceBookDeleteInput;
};

export type MutationDeleteProductCatalogArgs = {
  catalog: ProductCatalogDeleteInput;
};

export type MutationDeleteProductsArgs = {
  products: ProductBulkDeleteInput;
};

export type MutationDeleteQuestionnaireArgs = {
  questionnaireNumber: Scalars["Float"]["input"];
};

export type MutationDeleteQuestionnaireItemsArgs = {
  questionItemIDs: Array<Scalars["String"]["input"]>;
};

export type MutationDeleteQuestionnaireResponseArgs = {
  responseID: Scalars["String"]["input"];
};

export type MutationDeleteRecordMatchingRuleArgs = {
  rule: RecordMatchingRuleDeleteInput;
};

export type MutationDeleteServiceRequestArgs = {
  request: ServiceRequestDeleteInput;
};

export type MutationDeleteSpecimenConditioningDefinitionArgs = {
  specimenConditioning: SpecimenDefinitionTestDeleteInput;
};

export type MutationDeleteSpecimenContainerCapDefinitionArgs = {
  cap: SpecimenDefinitionContainerCapDeleteInput;
};

export type MutationDeleteSpecimenDefinitionArgs = {
  specimen: SpecimenDefinitionDeleteInput;
};

export type MutationDeleteStoreCategoryDefinitionsArgs = {
  definitions: WebStoreCategoryDefinitionBulkDeleteInput;
};

export type MutationDeleteSubscriberChannelArgs = {
  channel: ChannelDeleteInput;
};

export type MutationDeleteTaskArgs = {
  payload: TaskDeleteInput;
};

export type MutationDeleteTwilioFactorArgs = {
  delete: FactorDeleteInput;
};

export type MutationDeleteUserAccountArgs = {
  force?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationDeleteUserAddressArgs = {
  addressId: Scalars["String"]["input"];
};

export type MutationDeleteUserAddressLinesArgs = {
  addressLineIds: Array<Scalars["String"]["input"]>;
};

export type MutationDeleteUserCollectionArgs = {
  collection: CollectionDeleteInput;
};

export type MutationDeleteUserEventArgs = {
  eventID: Scalars["String"]["input"];
};

export type MutationDeleteUserProductBundleArgs = {
  bundle: UserProductBundleDeleteInput;
};

export type MutationDeleteUserProductBundleBatchArgs = {
  bundle: UserProductBundleBulkDeleteInput;
};

export type MutationDeleteWebStoreArgs = {
  store: WebStoreDeleteInput;
};

export type MutationDisableIntegrationChannelArgs = {
  channelId: Scalars["String"]["input"];
};

export type MutationEmitToChannelArgs = {
  payload: ChannelPublishInput;
};

export type MutationEnableIntegrationChannelArgs = {
  channelId: Scalars["String"]["input"];
};

export type MutationEnsureStripeCustomerForStoreArgs = {
  storeId: Scalars["String"]["input"];
};

export type MutationFinishLegArgs = {
  legId: Scalars["String"]["input"];
};

export type MutationGetFileArgs = {
  fileID: Scalars["String"]["input"];
};

export type MutationGetPresignedRequestUrlArgs = {
  destination: MinioS3DestinationInput;
};

export type MutationGetPresignedUploadUrlArgs = {
  destination: MinioS3DestinationInput;
};

export type MutationGetReportUrlArgs = {
  reportId: Scalars["String"]["input"];
};

export type MutationIgnoreUnmappedCodeArgs = {
  unmappedCodeId: Scalars["String"]["input"];
};

export type MutationImportKeycloakUsersArgs = {
  cynergyIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type MutationIngestGatewayMessageArgs = {
  accession?: InputMaybe<Scalars["String"]["input"]>;
  channelId: Scalars["String"]["input"];
  channelName: Scalars["String"]["input"];
  contentType?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  messageType?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  rawPayload: Scalars["String"]["input"];
  sourceIp?: InputMaybe<Scalars["String"]["input"]>;
  sourceType: Scalars["String"]["input"];
};

export type MutationIngestGatewayOrderArgs = {
  accession: Scalars["String"]["input"];
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  gatewayMessageId?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["String"]["input"]>;
  orderControl?: InputMaybe<Scalars["String"]["input"]>;
  orderPayload?: InputMaybe<Scalars["String"]["input"]>;
  orderingProvider?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  patientName?: InputMaybe<Scalars["String"]["input"]>;
  priority?: InputMaybe<Scalars["String"]["input"]>;
  resultChannelId?: InputMaybe<Scalars["String"]["input"]>;
  sourceCodingId?: InputMaybe<Scalars["String"]["input"]>;
  sourceSystem?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationIngestGatewayWebhookEventArgs = {
  event: Scalars["JSONObject"]["input"];
};

export type MutationLinkDeviceEndpointArgs = {
  deviceId: Scalars["String"]["input"];
  endpointId: Scalars["String"]["input"];
};

export type MutationLinkInstrumentToEndpointArgs = {
  endpointId: Scalars["String"]["input"];
  instrumentCode: Scalars["String"]["input"];
};

export type MutationLoginArgs = {
  loginPayload: LoginRequest;
};

export type MutationManageAccessGroupMembersArgs = {
  members: AccessGroupMemberManageInput;
};

export type MutationManageCollectionEntriesArgs = {
  collection: CollectionEntryManageInput;
};

export type MutationManageEmployeeArgs = {
  employee: StaffAssignmentManageInput;
};

export type MutationManageFilesArgs = {
  fileNames: Array<Scalars["String"]["input"]>;
  isStarred?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTrashed?: InputMaybe<Scalars["Boolean"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  newName?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationManageFolderArgs = {
  action: AppActions;
  folder?: InputMaybe<Scalars["String"]["input"]>;
  foldersToDelete?: InputMaybe<Array<Scalars["String"]["input"]>>;
  moveFolder?: InputMaybe<Scalars["Boolean"]["input"]>;
  newFolder?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationManagePaymentGatewayArgs = {
  gateway: PaymentGatewayUpdateInput;
};

export type MutationManagePriceBookArgs = {
  priceBook: PriceBookUpdateInput;
};

export type MutationManageProductArgs = {
  product: ProductUpdateInput;
};

export type MutationManageProductCatalogArgs = {
  catalog: ProductCatalogUpdateInput;
};

export type MutationManageRecurrencePatternArgs = {
  pattern: RecurrencePatternManageInput;
};

export type MutationManageSharedFileArgs = {
  action: AppActions;
  sourcePath: Scalars["String"]["input"];
};

export type MutationManageUserAddressArgs = {
  action: Scalars["String"]["input"];
  addressData: UserAddressInput;
};

export type MutationManageUserContactsArgs = {
  action: Scalars["String"]["input"];
  contactData: UserContactData;
};

export type MutationManageUserDependentsArgs = {
  action: Scalars["String"]["input"];
  dependentData: UserDependentData;
};

export type MutationManageUserProductBundleItemsArgs = {
  items: UserProductBundleItemManageInput;
};

export type MutationManageUserProductBundleSharesArgs = {
  shares: UserProductBundleShareManageInput;
};

export type MutationMergeOrdersArgs = {
  merge: OrderMergeInput;
};

export type MutationMergeRecordsArgs = {
  request: RecordMergeRequestInput;
};

export type MutationMergeRecordsBatchArgs = {
  requests: Array<RecordMergeRequestInput>;
};

export type MutationMoveFilesArgs = {
  folder: Scalars["String"]["input"];
  paths: Array<Scalars["String"]["input"]>;
};

export type MutationOrderSignatureSyncArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  secret: Scalars["String"]["input"];
};

export type MutationOrderSubjectNameSyncArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  secret: Scalars["String"]["input"];
};

export type MutationParseDriverLicenseArgs = {
  input: ParseDriverLicenseInput;
};

export type MutationParseMedicationArgs = {
  input: ParseMedicationInput;
};

export type MutationProcessInboundResultArgs = {
  channelId: Scalars["String"]["input"];
  gatewayMessageId: Scalars["String"]["input"];
  rawPayload: Scalars["String"]["input"];
};

export type MutationProcessOrderPaymentArgs = {
  orderId: Scalars["String"]["input"];
  paymentMethod: CheckoutPaymentMethodInput;
};

export type MutationPubSubMutationToDynamicTopicArgs = {
  channel: Scalars["String"]["input"];
  notificationId?: InputMaybe<Scalars["String"]["input"]>;
  notificationPayload?: InputMaybe<NotificationCreateInput>;
};

export type MutationPurgeGatewayMessagesArgs = {
  beforeDate: Scalars["String"]["input"];
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationReadUserNotificationArgs = {
  notificationID: Scalars["String"]["input"];
};

export type MutationReceiveLabResultsArgs = {
  accession: Scalars["String"]["input"];
  encounterId?: InputMaybe<Scalars["String"]["input"]>;
  labOrderId: Scalars["String"]["input"];
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  performerId?: InputMaybe<Scalars["String"]["input"]>;
  results: Scalars["String"]["input"];
};

export type MutationRecordUserAcceptanceArgs = {
  documentId: Scalars["String"]["input"];
};

export type MutationRecordWorkItemResultArgs = {
  gatewayMessageId?: InputMaybe<Scalars["String"]["input"]>;
  resultPayload: Scalars["String"]["input"];
  workItemId: Scalars["String"]["input"];
};

export type MutationRegisterDeviceGatewayArgs = {
  displayName: Scalars["String"]["input"];
  locationId: Scalars["String"]["input"];
  manufacturer?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["String"]["input"];
};

export type MutationRegisterLocationPatientArgs = {
  registerPayload: LocationPatientCreateInput;
};

export type MutationRegisterLocationStaffArgs = {
  registerPayload: LocationStaffCreateInput;
};

export type MutationRegisterOrActivateExpoNotificationTokenArgs = {
  payload: ExpoNotificationTokenInput;
};

export type MutationRegisterPractitionerArgs = {
  registerPayload: PractitionerRegisterInput;
};

export type MutationRegisterTwilioFactorArgs = {
  factor: FactorCreateInput;
};

export type MutationRemoveActivityDefinitionRequirementsArgs = {
  requirements: ActivityDefinitionRequirementDeleteInput;
};

export type MutationRemoveAnswerOptionsFromQuestionArgs = {
  answerOptionIDs: Array<Scalars["String"]["input"]>;
  questionItemID: Scalars["String"]["input"];
};

export type MutationRemoveCatalogItemsArgs = {
  items: ProductCatalogItemBulkDeleteInput;
};

export type MutationRemoveChannelDestinationArgs = {
  channelDestinationId: Scalars["String"]["input"];
};

export type MutationRemoveChannelMembersArgs = {
  members: ChannelMemberBulkDeleteInput;
};

export type MutationRemoveEnableWhenConstraintFromQuestionArgs = {
  enableWhenID: Scalars["String"]["input"];
};

export type MutationRemoveFromCartArgs = {
  items: Array<WebCartItemDeleteInput>;
};

export type MutationRemoveFromCollectionArgs = {
  entry: RemoveFromCollectionInput;
};

export type MutationRemoveFromCollectionBulkArgs = {
  entries: CollectionEntryBulkDeleteInput;
};

export type MutationRemoveIntegrationChannelFilterArgs = {
  filterId: Scalars["String"]["input"];
};

export type MutationRemoveLabObservationMemberArgs = {
  member: ObservationMemberDeleteInput;
};

export type MutationRemoveLocationPatientArgs = {
  patientId: Scalars["String"]["input"];
};

export type MutationRemoveObservationDefinitionContactArgs = {
  contact: ObservationDefinitionContactDeleteInput;
};

export type MutationRemoveOrganizationAffiliationArgs = {
  affiliation: AffiliationDeleteInput;
};

export type MutationRemovePatientDocumentArgs = {
  patientDocumentId: Scalars["ID"]["input"];
};

export type MutationRemovePatientSelfServiceCartItemArgs = {
  item: PatientSelfServiceCartItemDeleteInput;
};

export type MutationReorderTrackedTestsArgs = {
  input: ReorderTrackedTestsInput;
};

export type MutationReportRequesterSyncArgs = {
  secret: Scalars["String"]["input"];
};

export type MutationReportSubjectNameSyncArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  secret: Scalars["String"]["input"];
};

export type MutationReprocessGatewayMessageArgs = {
  messageId: Scalars["String"]["input"];
};

export type MutationRequestPasswordResetArgs = {
  reset: RequestPasswordResetInput;
};

export type MutationRescheduleAppointmentRequestArgs = {
  request: AppointmentRescheduleInput;
};

export type MutationRescheduleOrderAppointmentArgs = {
  order: OrderUpdateInput;
  request: AppointmentRescheduleInput;
};

export type MutationResendVerificationEmailArgs = {
  payload: ResendVerificationEmailInput;
};

export type MutationResetPasswordArgs = {
  password: Scalars["String"]["input"];
};

export type MutationRestoreCoverageArgs = {
  payload: CoverageRestoreInput;
};

export type MutationRestoreLocationPatientArgs = {
  patientId: Scalars["String"]["input"];
};

export type MutationRetryWorkItemArgs = {
  workItemId: Scalars["String"]["input"];
};

export type MutationRouteGatewayOrderArgs = {
  labOrderId: Scalars["String"]["input"];
};

export type MutationRunSymptomAssessmentArgs = {
  patientId: Scalars["String"]["input"];
  symptoms: Array<Scalars["String"]["input"]>;
};

export type MutationSendAlertNotificationArgs = {
  alertTypeCode: Scalars["String"]["input"];
  body: Scalars["String"]["input"];
  category?: InputMaybe<Scalars["String"]["input"]>;
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  data?: InputMaybe<Scalars["JSONObject"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  recipientCynergyId: Scalars["String"]["input"];
  recipientEmail?: InputMaybe<Scalars["String"]["input"]>;
  resourceReferenceId?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type MutationSendNotificationArgs = {
  notificationId?: InputMaybe<Scalars["String"]["input"]>;
  notificationPayload?: InputMaybe<NotificationCreateInput>;
};

export type MutationSendOnboardingInviteArgs = {
  invitePayload: OnboardingInviteCreateInput;
};

export type MutationSendOrderResultsArgs = {
  labOrderId: Scalars["String"]["input"];
};

export type MutationSendOrderToExternalArgs = {
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  endpointId: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
  services?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationSendSmsVerificationCodeArgs = {
  verificationPayload: VerificationCodeRequest;
};

export type MutationSendToStratusArgs = {
  order: SendOrderToStratusInput;
};

export type MutationSetChannelAlertEmailsArgs = {
  input: SetChannelAlertEmailsInput;
};

export type MutationSetEnableWhenConstraintToQuestionArgs = {
  payload: QuestionnaireEnableWhenCreateInput;
};

export type MutationSetLabObservationResultValueArgs = {
  result: ObservationResultValueCreateInput;
};

export type MutationSettleOrderArgs = {
  request: SettleOrderInput;
};

export type MutationSetupMerchantAccountArgs = {
  account: MerchantAccountCreateInput;
};

export type MutationSetupPaymentGatewayArgs = {
  gateway: PaymentGatewayCreateInput;
};

export type MutationSetupTwoFactorProfileArgs = {
  profile: SetupTwoFactorProfileInput;
};

export type MutationShareUserProductBundleWithGroupsArgs = {
  shares: UserProductBundleGroupShareCreateInput;
};

export type MutationStartLegArgs = {
  legId: Scalars["String"]["input"];
};

export type MutationSubmitCriteriaResultsArgs = {
  payload: SubmitCriteriaFormResult;
};

export type MutationSubmitLabOrderArgs = {
  accession: Scalars["String"]["input"];
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["String"]["input"]>;
  orderingProvider?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  patientName?: InputMaybe<Scalars["String"]["input"]>;
  priority?: InputMaybe<Scalars["String"]["input"]>;
  sourceCodingId?: InputMaybe<Scalars["String"]["input"]>;
  testCodes: Scalars["String"]["input"];
  testNames?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSubmitOrderRequestArgs = {
  order: SubmitOrderRequestInput;
};

export type MutationSyncChannelDestinationsArgs = {
  channelId: Scalars["String"]["input"];
  destinations: Scalars["String"]["input"];
};

export type MutationTestGatewayConnectionArgs = {
  gatewayId: Scalars["String"]["input"];
};

export type MutationToggleAlertTypeArgs = {
  input: ToggleAlertTypeInput;
};

export type MutationToggleSupervisorRoleArgs = {
  payload: ToggleSupervisorRoleInput;
};

export type MutationTrackTestArgs = {
  input: TrackTestInput;
};

export type MutationUnlinkDeviceEndpointArgs = {
  deviceId: Scalars["String"]["input"];
  endpointId: Scalars["String"]["input"];
};

export type MutationUnlinkInstrumentFromEndpointArgs = {
  instrumentCode: Scalars["String"]["input"];
};

export type MutationUntrackTestArgs = {
  input: UntrackTestInput;
};

export type MutationUpdateAccessGroupArgs = {
  group: AccessGroupUpdateInput;
};

export type MutationUpdateActivityDefinitionArgs = {
  definition: ActivityDefinitionUpdateInput;
};

export type MutationUpdateAppointmentRequestArgs = {
  request: AppointmentUpdateInput;
};

export type MutationUpdateAssignedWaypointArgs = {
  payload: UpdateAssignedWaypoint;
};

export type MutationUpdateBillingAccountArgs = {
  account: BillingAccountUpdateInput;
};

export type MutationUpdateCatalogItemArgs = {
  item: ProductCatalogItemUpdateInput;
};

export type MutationUpdateChannelMemberArgs = {
  payload: ChannelMemberUpdateInput;
};

export type MutationUpdateChannelTemplateArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  connectionType?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  destinationConfig?: InputMaybe<Scalars["String"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  manufacturer?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  pollingIntervalMs?: InputMaybe<Scalars["Float"]["input"]>;
  protocols?: InputMaybe<Scalars["String"]["input"]>;
  retryAttempts?: InputMaybe<Scalars["Float"]["input"]>;
  retryDelayMs?: InputMaybe<Scalars["Float"]["input"]>;
  sourceConfig?: InputMaybe<Scalars["String"]["input"]>;
  templateId: Scalars["String"]["input"];
  timeoutMs?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationUpdateClinicalNoteArgs = {
  payload: ClinicalNoteUpdateInput;
};

export type MutationUpdateCommunicationArgs = {
  communication: CommunicationUpdateInput;
};

export type MutationUpdateCommunicationRequestArgs = {
  request: CommunicationRequestUpdateInput;
};

export type MutationUpdateConditionAssessmentArgs = {
  payload: ClinicalImpressionUpdateInput;
};

export type MutationUpdateDeviceArgs = {
  availability?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  deviceId: Scalars["String"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  modelNumber?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  serialNumber?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateDiagnosticCatalogArgs = {
  catalog: DiagnosticCatalogUpdateInput;
};

export type MutationUpdateDiagnosticReportArgs = {
  payload: DiagnosticReportUpdateInput;
};

export type MutationUpdateDiagnosticServiceArgs = {
  service: DiagnosticServiceUpdateInput;
};

export type MutationUpdateDuplicateJobDefinitionArgs = {
  definition: DuplicateJobDefinitionUpdateInput;
};

export type MutationUpdateDuplicateRecordRuleArgs = {
  rule: DuplicateRecordRuleUpdateInput;
};

export type MutationUpdateEmployeeArgs = {
  employee: StaffAssignmentUpdateInput;
};

export type MutationUpdateEndpointArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  connectionType?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  endpointId: Scalars["String"]["input"];
  environmentType?: InputMaybe<Scalars["String"]["input"]>;
  managingOrganizationId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateEndpointConfigArgs = {
  additionalConfig?: InputMaybe<Scalars["String"]["input"]>;
  codingId?: InputMaybe<Scalars["String"]["input"]>;
  endpointConfigId: Scalars["String"]["input"];
  host?: InputMaybe<Scalars["String"]["input"]>;
  maxConnections?: InputMaybe<Scalars["Float"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  port?: InputMaybe<Scalars["Float"]["input"]>;
  privateKey?: InputMaybe<Scalars["String"]["input"]>;
  protocol?: InputMaybe<Scalars["String"]["input"]>;
  timeoutMs?: InputMaybe<Scalars["Float"]["input"]>;
  tlsCa?: InputMaybe<Scalars["String"]["input"]>;
  tlsCert?: InputMaybe<Scalars["String"]["input"]>;
  tlsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  tlsKey?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateEpisodeOfCareArgs = {
  payload: EpisodeOfCareUpdateInput;
};

export type MutationUpdateEventArgs = {
  event: EventUpdateInput;
};

export type MutationUpdateEventSeriesArgs = {
  series: EventSeriesUpdateInput;
};

export type MutationUpdateExternalCodeMappingArgs = {
  codingId?: InputMaybe<Scalars["String"]["input"]>;
  conceptMapGroupId?: InputMaybe<Scalars["String"]["input"]>;
  externalCode?: InputMaybe<Scalars["String"]["input"]>;
  externalCodeMappingId: Scalars["String"]["input"];
  externalDisplay?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  relationship?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  testCodeId?: InputMaybe<Scalars["String"]["input"]>;
  testPanelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateFieldMatchProbabilityDefinitionArgs = {
  definition: RecordFieldMatchProbabilityDefinitionUpdateInput;
};

export type MutationUpdateHealthcareServiceArgs = {
  service: HealthcareServiceUpdateInput;
};

export type MutationUpdateIntegrationChannelArgs = {
  channelId: Scalars["String"]["input"];
  config?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  destinationEndpointId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  messageDefinitionId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pollingIntervalMs?: InputMaybe<Scalars["Float"]["input"]>;
  retryAttempts?: InputMaybe<Scalars["Float"]["input"]>;
  retryDelayMs?: InputMaybe<Scalars["Float"]["input"]>;
  sourceEndpointId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  timeoutMs?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationUpdateLocationArgs = {
  location: LocationUpdateInput;
};

export type MutationUpdateMedicalConditionArgs = {
  payload: ConditionUpdateInput;
};

export type MutationUpdateMerchantAccountArgs = {
  account: MerchantAccountUpdateInput;
};

export type MutationUpdateOrderArgs = {
  order: OrderUpdateInput;
};

export type MutationUpdateOrderAppointmentArgs = {
  order: OrderUpdateInput;
  request: AppointmentUpdateInput;
};

export type MutationUpdateOrganizationArgs = {
  organization: OrganizationUpdateInput;
};

export type MutationUpdateOrganizationAffiliationArgs = {
  affiliation: AffiliationUpdateInput;
};

export type MutationUpdatePatientMedicationArgs = {
  updatePayload: PatientMedicationUpdateInput;
};

export type MutationUpdatePatientSelfServiceCartItemArgs = {
  update: PatientSelfServiceCartItemUpdateInput;
};

export type MutationUpdatePatientVitalsArgs = {
  patientId: Scalars["String"]["input"];
};

export type MutationUpdatePaymentProfileArgs = {
  billingAddress: BillingAddressType;
  cardDetails: UpdateCreditCardType;
  isDefault: Scalars["Boolean"]["input"];
  paymentProfileID: Scalars["String"]["input"];
};

export type MutationUpdatePaymentTermArgs = {
  term: PaymentTermUpdateInput;
};

export type MutationUpdateProfilePhotoArgs = {
  file: Scalars["Upload"]["input"];
};

export type MutationUpdateQuestionnaireFormArgs = {
  payload: QuestionnaireFormUpdateInput;
};

export type MutationUpdateQuestionnaireItemArgs = {
  payload: QuestionnaireQuestionUpdateInput;
};

export type MutationUpdateQuestionnaireResponseArgs = {
  payload: QuestionnaireResponseUpdateInput;
};

export type MutationUpdateRecordFieldMatchProbabilityArgs = {
  matchProbability: RecordFieldMatchProbabilityUpdateInput;
};

export type MutationUpdateRecordMatchingRuleArgs = {
  rule: RecordMatchingRuleUpdateInput;
};

export type MutationUpdateRouteAssignmentArgs = {
  payload: UpdateRouteAssignmentInput;
};

export type MutationUpdateRouteLocationArgs = {
  payload: UpdateRouteLocationInput;
};

export type MutationUpdateScheduleSlotArgs = {
  slot: SlotUpdateInput;
};

export type MutationUpdateSeriesOccurrenceArgs = {
  occurrence: SeriesOccurrenceUpdateInput;
};

export type MutationUpdateServiceRequestArgs = {
  request: ServiceRequestUpdateInput;
};

export type MutationUpdateServiceScheduleArgs = {
  schedule: ScheduleUpdateInput;
};

export type MutationUpdateSpecimenConditioningDefinitionArgs = {
  specimenConditioning: SpecimenDefinitionTestUpdateInput;
};

export type MutationUpdateSpecimenContainerCapDefinitionArgs = {
  cap: SpecimenDefinitionContainerCapUpdateInput;
};

export type MutationUpdateSpecimenDefinitionArgs = {
  specimen: SpecimenDefinitionUpdateInput;
};

export type MutationUpdateStoreCategoryDefinitionArgs = {
  definition: WebStoreCategoryDefinitionUpdateInput;
};

export type MutationUpdateSubscriberChannelArgs = {
  payload: ChannelUpdateInput;
};

export type MutationUpdateSubscriberTopicArgs = {
  payload: SubscriberTopicUpdateInput;
};

export type MutationUpdateTaskArgs = {
  payload: TaskUpdateInput;
};

export type MutationUpdateTaskStepArgs = {
  payload: TaskStepUpdateInput;
};

export type MutationUpdateUserAddressArgs = {
  updatedAddress: AddressUpdateInput;
};

export type MutationUpdateUserEventArgs = {
  eventID: Scalars["String"]["input"];
  updateData: UpdateUserEvent;
};

export type MutationUpdateUserMessagesArgs = {
  messageIDs: Array<Scalars["String"]["input"]>;
  updatePayload: MessageUpdatePayload;
};

export type MutationUpdateUserNotificationArgs = {
  notificationIds: Array<Scalars["String"]["input"]>;
  updatePayload: NotificationUpdatePayload;
};

export type MutationUpdateUserProductBundleArgs = {
  bundle: UserProductBundleUpdateInput;
};

export type MutationUpdateUserProfileArgs = {
  profile: CynergyProfileUpdateInput;
};

export type MutationUpdateWaypointSequenceArgs = {
  payload: UpdateAssignedWaypointSequence;
};

export type MutationUpdateWebStoreConfigurationArgs = {
  configuration: WebStoreConfigurationUpdateInput;
};

export type MutationUploadFilesArgs = {
  files: Array<Scalars["Upload"]["input"]>;
  folder?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUploadLabResultArgs = {
  altId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  endpointId: Scalars["String"]["input"];
  file: Scalars["Upload"]["input"];
  fileType?: InputMaybe<LabResultFileTypes>;
  fillerOrderNumber?: InputMaybe<Scalars["String"]["input"]>;
  locationCode?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  orderingProviderId?: InputMaybe<Scalars["String"]["input"]>;
  patientDemos: PatientDemosResultInput;
  patientExternalId: Scalars["String"]["input"];
  receiverCynergyId?: InputMaybe<Scalars["String"]["input"]>;
  reprocessOfIntakeId?: InputMaybe<Scalars["String"]["input"]>;
  senderCynergyId: Scalars["String"]["input"];
  senderOrganizationId: Scalars["String"]["input"];
  vendorCode: Scalars["String"]["input"];
};

export type MutationUploadPatientDocumentsArgs = {
  payload: UploadPatientDocumentsInput;
};

export type MutationUploadPatientFilesArgs = {
  files: Array<PatientFileInput>;
};

export type MutationUploadPractitionerSignatureArgs = {
  signature: UploadPractitionerSignatureInput;
};

export type MutationUploadServiceRequestArgs = {
  altId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  endpointId: Scalars["String"]["input"];
  file: Scalars["Upload"]["input"];
  fileType?: InputMaybe<LabResultFileTypes>;
  fillerOrderNumber?: InputMaybe<Scalars["String"]["input"]>;
  locationCode?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  orderingProviderId?: InputMaybe<Scalars["String"]["input"]>;
  patientDemos: PatientDemosResultInput;
  patientExternalId: Scalars["String"]["input"];
  receiverCynergyId?: InputMaybe<Scalars["String"]["input"]>;
  reprocessOfIntakeId?: InputMaybe<Scalars["String"]["input"]>;
  senderCynergyId: Scalars["String"]["input"];
  senderOrganizationId: Scalars["String"]["input"];
  vendorCode: Scalars["String"]["input"];
};

export type MutationUpsertCoverageArgs = {
  payload: CoverageUpsertInput;
};

export type MutationUserRegisterArgs = {
  registerPayload: RegisterUserInput;
};

export type MutationVerifySmsVerificationCodeArgs = {
  payload: VerificationCheckInput;
};

export type MutationVerifyTokenActivityArgs = {
  payload: ExpoNotificationTokenInput;
};

export type MutationVerifyTwilioFactorArgs = {
  factor: FactorVerifyInput;
};

export type NpiDemographicInformation = {
  __typename?: "NPIDemographicInformation";
  credential: Scalars["String"]["output"];
  first_name: Scalars["String"]["output"];
  gender: Scalars["String"]["output"];
  last_name: Scalars["String"]["output"];
  last_updated: Scalars["String"]["output"];
  middle_name?: Maybe<Scalars["String"]["output"]>;
  prefix?: Maybe<Scalars["String"]["output"]>;
  sole_proprietor?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  suffix?: Maybe<Scalars["String"]["output"]>;
};

export type NotificationCategories = {
  __typename?: "NotificationCategories";
  category: Scalars["String"]["output"];
  category_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The order in which to display this category for rendering purposes. */
  order: Scalars["Float"]["output"];
  scope: NotificationScopes;
  slug?: Maybe<Scalars["String"]["output"]>;
  supported_delivery_methods: Array<NotificationTypes>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type NotificationCreateInput = {
  body: Scalars["String"]["input"];
  category?: InputMaybe<Scalars["String"]["input"]>;
  data?: InputMaybe<Scalars["JSONObject"]["input"]>;
  expoPushToken?: InputMaybe<Scalars["String"]["input"]>;
  /** Full name of sender */
  from: Scalars["String"]["input"];
  fromCynergyId?: InputMaybe<Scalars["String"]["input"]>;
  /** Default(false) */
  isRead?: InputMaybe<Scalars["Boolean"]["input"]>;
  link?: InputMaybe<NotificationLinkCreateInput>;
  priority?: InputMaybe<AlertPriority>;
  recipientCynergyId: Scalars["String"]["input"];
  reminderFrequency?: InputMaybe<ReminderFrequencyCreateInput>;
  /** Identifier of the resource this notification relates to. */
  resourceReferenceId?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

/** Frequency of which to send notification. */
export enum NotificationFrequency {
  Daily = "DAILY",
  Instant = "INSTANT",
  Weekly = "WEEKLY",
}

export type NotificationLinkCreateInput = {
  /** Provide text display for notification link */
  linkText?: InputMaybe<Scalars["String"]["input"]>;
  /** Specify navigation link. */
  url: Scalars["String"]["input"];
};

export type NotificationPreferences = {
  __typename?: "NotificationPreferences";
  /** Preferred delivery methods to send notification (I.e. "Email", "SMS", "Push") */
  alert_preferences: Array<AlertPreferences>;
  category: NotificationCategories;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  frequency: NotificationFrequency;
  is_archived: Scalars["Boolean"]["output"];
  preference_id: Scalars["String"]["output"];
  setting: NotificationSettings;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Scope the notification applies to. */
export enum NotificationScopes {
  Admin = "ADMIN",
  Global = "GLOBAL",
  Patient = "PATIENT",
  Provider = "PROVIDER",
}

export type NotificationSettings = {
  __typename?: "NotificationSettings";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_default: Scalars["Boolean"]["output"];
  notification_setting_id: Scalars["String"]["output"];
  preferences: Array<NotificationPreferences>;
  /** Human friendly name for configuration. */
  preset_display: Scalars["String"]["output"];
  settings: Settings;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Notification status regarding to Ticket and Receipt */
export enum NotificationStatus {
  Error = "ERROR",
  Ok = "OK",
}

/** Type of notification. */
export enum NotificationTypes {
  App = "APP",
  Email = "EMAIL",
  Push = "PUSH",
  Sms = "SMS",
}

export type NotificationUpdatePayload = {
  is_read?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Notifications = {
  __typename?: "Notifications";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  expo_push_token?: Maybe<Scalars["String"]["output"]>;
  from: Scalars["String"]["output"];
  from_cynergy_id?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_read: Scalars["Boolean"]["output"];
  /** Provide text display for notification link */
  link_label?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Messages>;
  notification_body: Scalars["String"]["output"];
  notification_category?: Maybe<Scalars["String"]["output"]>;
  notification_data?: Maybe<Scalars["JSONObject"]["output"]>;
  notification_id: Scalars["String"]["output"];
  /** Specify navigation link */
  notification_link?: Maybe<Scalars["String"]["output"]>;
  notification_priority: AlertPriority;
  notification_title: Scalars["String"]["output"];
  recipient?: Maybe<CynergyUsers>;
  recipient_cynergy_id: Scalars["String"]["output"];
  /** Identifier of the resource this notification relates to. */
  ref_id?: Maybe<Scalars["String"]["output"]>;
  reminder_frequency?: Maybe<ReminderFrequency>;
  sender?: Maybe<CynergyUsers>;
  tickets?: Maybe<Array<ExpoNotificationTickets>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Refers to whether the address information entered pertains to the provider's Mailing Address or the provider's Practice Location Address. */
export enum NpiAddressPurposes {
  Location = "LOCATION",
  Mailing = "MAILING",
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
}

export type NpiAddresses = {
  __typename?: "NpiAddresses";
  address_1: Scalars["String"]["output"];
  address_2?: Maybe<Scalars["String"]["output"]>;
  address_purpose: NpiAddressPurposes;
  address_type: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  country_code: Scalars["String"]["output"];
  country_name: Scalars["String"]["output"];
  fax_number?: Maybe<Scalars["String"]["output"]>;
  postal_code: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  telephone_number?: Maybe<Scalars["String"]["output"]>;
};

/** NPI type. (Individual or Organizational) */
export enum NpiEnumerationType {
  Individual = "INDIVIDUAL",
  Organization = "ORGANIZATION",
}

export type NpiIdentifiers = {
  __typename?: "NpiIdentifiers";
  code: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  identifier: Scalars["String"]["output"];
  issuer?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
};

export type NpiRegistryProfiles = {
  __typename?: "NpiRegistryProfiles";
  addresses?: Maybe<Array<NpiAddresses>>;
  demographics: NpiDemographicInformation;
  identifiers?: Maybe<Array<NpiIdentifiers>>;
  npi: Scalars["String"]["output"];
  practice_locations?: Maybe<Array<NpiAddresses>>;
  registration_date: Scalars["DateTime"]["output"];
  taxonomies?: Maybe<Array<NpiTaxonomies>>;
  type: NpiEnumerationType;
};

export type NpiRegistrySearchTerm = {
  attribute: NpiSearchAttributeKeys;
  value: Scalars["String"]["input"];
};

/** Valid npi registry api search attributes. */
export enum NpiSearchAttributeKeys {
  City = "CITY",
  Description = "DESCRIPTION",
  EnumerationType = "ENUMERATION_TYPE",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
  Npi = "NPI",
  OrganizationName = "ORGANIZATION_NAME",
  Postal = "POSTAL",
  State = "STATE",
}

export type NpiTaxonomies = {
  __typename?: "NpiTaxonomies";
  code: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  group: Scalars["String"]["output"];
  license?: Maybe<Scalars["String"]["output"]>;
  primary: Scalars["Boolean"]["output"];
  state?: Maybe<Scalars["String"]["output"]>;
};

export type ObservationBasedOn = CarePlans | ServiceRequests;

export type ObservationBasedOnInput = {
  /** [External] CarePlans -> planId */
  carePlanId?: InputMaybe<Scalars["String"]["input"]>;
  /** [External] ServiceRequests -> requestId */
  requestId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR Observations category codes */
export enum ObservationCategory {
  /** Observations that measure or record any bodily activity that enhances or maintains physical fitness and overall health and wellness. Not under direct supervision of practitioner such as a physical therapist. (e.g., laps swum, steps, sleep data) */
  Activity = "ACTIVITY",
  /** Observations generated by physical exam findings including direct observations made by a clinician and use of simple instruments and the result of simple maneuvers performed directly on the patient's body. */
  Exam = "EXAM",
  /** Observations generated by imaging. The scope includes observations regarding plain x-ray, ultrasound, CT, MRI, angiography, echocardiography, and nuclear medicine. */
  Imaging = "IMAGING",
  /** The results of observations generated by laboratories. Laboratory results are typically generated by laboratories providing analytic services in areas such as chemistry, hematology, serology, histology, cytology, anatomic pathology (including digital pathology), microbiology, and/or virology. These observations are based on analysis of specimens obtained from the patient and submitted to the laboratory. */
  Laboratory = "LABORATORY",
  /** Observations generated by other procedures. This category includes observations resulting from interventional and non-interventional procedures excluding laboratory and imaging (e.g., cardiology catheterization, endoscopy, electrodiagnostics, etc.). Procedure results are typically generated by a clinician to provide more granular information about component observations made during a procedure. An example would be when a gastroenterologist reports the size of a polyp observed during a colonoscopy. */
  Procedure = "PROCEDURE",
  /** Social History Observations define the patient's occupational, personal (e.g., lifestyle), social, familial, and environmental history and health risk factors that may impact the patient's health. */
  SocialHistory = "SOCIAL_HISTORY",
  /** Assessment tool/survey instrument observations (e.g., Apgar Scores, Montreal Cognitive Assessment (MoCA)). */
  Survey = "SURVEY",
  /** Observations generated by non-interventional treatment protocols (e.g. occupational, physical, radiation, nutritional and medication therapy) */
  Therapy = "THERAPY",
  /** Clinical observations measure the body's basic functions such as blood pressure, heart rate, respiratory rate, height, weight, body mass index, head circumference, pulse oximetry, temperature, and body surface area. */
  VitalSigns = "VITAL_SIGNS",
}

export type ObservationComponentInput = {
  dataAbsentReason?: InputMaybe<DataAbsentReason>;
  interpretation: ObservationInterpretation;
  /** LOINC codeable concept. Must supply at least text name */
  loincConcept: CodeableConceptCreateInput;
  /** Reference to the Observation component reference range */
  referenceRangeId?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference to the Observation result value */
  resultValueId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ObservationComponentMemberInput = {
  member: ObservationDefinitionComponentInput;
};

export type ObservationComponents = {
  __typename?: "ObservationComponents";
  code: Scalars["String"]["output"];
  component_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Why the component result is missing */
  data_absent_reason?: Maybe<DataAbsentReason>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** For some results, particularly numeric results, an interpretation is necessary to fully understand the significance of a result. */
  interpretation: ObservationInterpretation;
  is_archived: Scalars["Boolean"]["output"];
  /** Type of component observation (LOINC code) */
  loinc: LoincCodes;
  observation: Observations;
  reference_range?: Maybe<ObservationReferenceRanges>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Actual component result */
  value?: Maybe<ObservationResultValues>;
};

export type ObservationCreateInput = {
  /** A plan, proposal or order that is fulfilled in part or whole by this event. */
  basedOn?: InputMaybe<ObservationBasedOnInput>;
  bodySite?: InputMaybe<Scalars["String"]["input"]>;
  category: ObservationCategory;
  components?: InputMaybe<Array<ObservationComponentInput>>;
  dataAbsentReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Observation definition identifier instance instantiates from */
  definitionId?: InputMaybe<Scalars["String"]["input"]>;
  /** A reference to the device that generates/generated the measurements */
  device?: InputMaybe<ObservationDeviceInput>;
  /** Clinically relevant time-period for observation */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** [External] Encounters -> encounterId; Healthcare event during which this observation is made */
  encounterId?: InputMaybe<Scalars["String"]["input"]>;
  interpretation: ObservationInterpretation;
  /** LOINC code */
  loincCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference to an observation group this observation is a member of. */
  memberOf?: InputMaybe<ObservationMemberOfInput>;
  /** Related resources that belong to this observation group. (e.g. tests from a panel) */
  members?: InputMaybe<Array<ObservationMemberInput>>;
  /** Indicates the mechanism used to perform the observation. */
  method?: InputMaybe<Scalars["String"]["input"]>;
  /** What was observed (code/type/name) */
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Patient the observation is about */
  patientId: Scalars["String"]["input"];
  /** MUST include ONLY ONE key/value pair from set */
  performer: ObservationPerformerInput;
  /** Guidance on how to interpret the value by comparison to a normal or recommended range. (Ignored if definition reference provided) */
  referenceRange?: InputMaybe<Array<ObservationReferenceRangeInput>>;
  /** Reference to observation result value record */
  resultValue?: InputMaybe<ObservationResultValueInput>;
  /** The specimen that was used when the observation was made */
  specimen?: InputMaybe<ObservationSpecimenInput>;
  status: ObservationStatus;
  /** What triggered this observation */
  triggeredBy?: InputMaybe<Array<ObservationTriggeredByInput>>;
  type: ObservationTypCode;
};

export type ObservationDefinitionComponentInput = {
  code: Scalars["String"]["input"];
  /** Formula expression for calculating value. */
  formula?: InputMaybe<ExpressionCreateInput>;
  /** Loinc code for observation component */
  loincCode: Scalars["String"]["input"];
  /** Max depth: 1 */
  members?: InputMaybe<Array<ObservationComponentMemberInput>>;
  /** Display name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Data type allowed for this observation component */
  permittedDataTypes?: InputMaybe<Array<PermittedDataType>>;
  /** Unit for quantitative results */
  permittedUnits?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Rule sets for observation component results */
  rules?: InputMaybe<Array<ObservationDefinitionRuleInput>>;
};

export type ObservationDefinitionComponents = {
  __typename?: "ObservationDefinitionComponents";
  code: Scalars["String"]["output"];
  component_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition: ObservationDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Formula expression for calculating value */
  formula?: Maybe<Expressions>;
  is_archived: Scalars["Boolean"]["output"];
  /** Type of observation (LOINC code) */
  loinc: LoincCodes;
  members?: Maybe<Array<ObservationDefinitionComponents>>;
  name?: Maybe<Scalars["String"]["output"]>;
  /** Data type allowed for this observation component */
  permitted_data_type?: Maybe<Array<PermittedDataType>>;
  /** Unit for quantitative results */
  permitted_unit?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Set of qualified values for observation component result */
  rules?: Maybe<Array<ObservationDefinitionRules>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ObservationDefinitionContactDeleteInput = {
  contactDetailId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  observationDefinitionId: Scalars["ID"]["input"];
};

export type ObservationDefinitionCreateInput = {
  /** Body part to be observed */
  bodySite?: InputMaybe<Scalars["String"]["input"]>;
  /** General type of observation */
  category: ObservationCategory;
  /** Type of observation */
  code?: InputMaybe<Scalars["String"]["input"]>;
  /** Definitions of observations belonging to this observation group */
  components?: InputMaybe<Array<ObservationDefinitionComponentInput>>;
  /** Contact details for publisher */
  contacts?: InputMaybe<Array<ContactDetailsCreateInput>>;
  description: Scalars["String"]["input"];
  /** Reference to device used for measurement */
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Definition not for real usage */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** List of locations this definition may be used. */
  locationScope?: InputMaybe<Array<ReferenceCreateInput>>;
  /** Loinc code of observed target. (Required if definition defines panel test) */
  loincCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Definitions of observations belonging to this observation group */
  members?: InputMaybe<Array<ObservationDefinitionMemberInput>>;
  /** Method used to produce the observation */
  method?: InputMaybe<Scalars["String"]["input"]>;
  /** Multiple results allowed for conforming observations? */
  multipleResultsAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Computer-friendly name */
  name: Scalars["String"]["input"];
  /** The organization this definition belongs to */
  organizationId: Scalars["ID"]["input"];
  /** Desired kind of performer for observation */
  performerType?: InputMaybe<Scalars["String"]["input"]>;
  /** Data type allowed for the value element of conforming observation instances */
  permittedDataTypes: Array<PermittedDataType>;
  /** Unit for quantitative results */
  permittedUnits?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The preferred name to be used when reporting the observation results */
  preferredReportName?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["input"];
  /** Why this ObservationDefinition is defined */
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  /** Rule sets for observation results */
  rules?: InputMaybe<Array<ObservationDefinitionRuleInput>>;
  /** Kind of specimen used by this type of observation. */
  specimens?: InputMaybe<Array<ObservationDefinitionSpecimenInput>>;
  status?: InputMaybe<PublicationStatus>;
  /** Type of subject for the defined observation */
  subject: CareGroupTypes;
  /** Human-friendly name */
  title: Scalars["String"]["input"];
  type: ObservationTypCode;
  /** Logical URL to reference this definition */
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ObservationDefinitionDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  observationDefinitionId: Scalars["ID"]["input"];
};

export type ObservationDefinitionMemberInput = {
  memberDefinitionId: Scalars["ID"]["input"];
};

export type ObservationDefinitionRuleInput = {
  /** Applicable age range for rule set */
  ageRange?: InputMaybe<RangeCreateInput>;
  /** Condition associated with rule set. */
  condition?: InputMaybe<Scalars["String"]["input"]>;
  /** Context qualifier for rule set. */
  context?: InputMaybe<ReferenceRangeMeaning>;
  /** The gender this rule set applies to. */
  gender?: InputMaybe<AdministrativeGender>;
  /** Applicable gestational age range for rule set */
  gestationalAge?: InputMaybe<RangeCreateInput>;
  qualitativeCodeSets?: InputMaybe<QualitativeCodeSets>;
  /** Range category this rule set pertains to. */
  rangeCategory: ObservationRangeCategory;
  /** Range of values defined for observation that match the criteria set of qualified values */
  referenceRange?: InputMaybe<RangeCreateInput>;
};

export type ObservationDefinitionRules = {
  __typename?: "ObservationDefinitionRules";
  /** Value set of abnormal coded values as part of this set of qualified values */
  abnormal_codes?: Maybe<ValueSets>;
  /** Applicable age range for set of qualified values */
  age?: Maybe<Range>;
  component?: Maybe<ObservationDefinitionComponents>;
  /** Condition associated with the set of qualified values */
  condition?: Maybe<Scalars["String"]["output"]>;
  /** Context qualifier for the set of qualified values */
  context?: Maybe<ReferenceRangeMeaning>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Value set of critical coded values as part of this set of qualified values */
  critical_codes?: Maybe<ValueSets>;
  definition: ObservationDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** The gender this set of qualified values applies to. */
  gender?: Maybe<AdministrativeGender>;
  /** Applicable gestational age range for the set of qualified values */
  gestational_age?: Maybe<Range>;
  is_archived: Scalars["Boolean"]["output"];
  /** Value set of normal coded values as part of this set of qualified values */
  normal_codes?: Maybe<ValueSets>;
  /** Range of values defined for observation that match the criteria set of qualified values */
  range?: Maybe<Range>;
  /** Category of range this range set pertains to */
  range_category: ObservationRangeCategory;
  rule_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Value set of valid coded values as part of this set of qualified values */
  valid_codes?: Maybe<ValueSets>;
};

export type ObservationDefinitionSpecimenInput = {
  specimenDefinitionId: Scalars["ID"]["input"];
};

export type ObservationDefinitions = {
  __typename?: "ObservationDefinitions";
  /** When definition was approved by publisher */
  approval_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Body part to be observed */
  body_site?: Maybe<Scalars["String"]["output"]>;
  /** General type of observation */
  category: ObservationCategory;
  /** Type of observation */
  code: Scalars["String"]["output"];
  /** Component results */
  components?: Maybe<Array<ObservationDefinitionComponents>>;
  /** Contact details for the publisher */
  contact?: Maybe<Array<ContactDetails>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Based on another definition */
  derived_definition?: Maybe<ObservationDefinitions>;
  /** Natural language description of this definition */
  description: Scalars["String"]["output"];
  /** Device used for measurement */
  device?: Maybe<Devices>;
  device_id?: Maybe<Scalars["ID"]["output"]>;
  /** Definition not for real usage */
  experimental: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The date on which the asset content was last reviewed by the publisher */
  last_review_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Loinc code corresponding to observed target */
  loinc?: Maybe<LoincCodes>;
  /** Definitions of related resources belonging to this kind of observation group */
  members?: Maybe<Array<ObservationDefinitions>>;
  /** Method used to produce the observation */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Multiple results allowed for conforming observations */
  multiple_results_allowed: Scalars["Boolean"]["output"];
  organization_id: Scalars["ID"]["output"];
  /** Desired kind of performer for such kind of observation */
  performer_type?: Maybe<Scalars["String"]["output"]>;
  /** Data type allowed for the value element of conforming observation instances */
  permitted_data_type: Array<PermittedDataType>;
  /** Unit for quantitative results */
  permitted_unit?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The preferred name to be used when reporting the observation results */
  preferred_report_name?: Maybe<Scalars["String"]["output"]>;
  /** The name of the individual or organization that published the definition */
  publisher: Scalars["String"]["output"];
  /** Why this ObservationDefinition is defined */
  purpose?: Maybe<Scalars["String"]["output"]>;
  /** Set of qualified values for observation results */
  rules?: Maybe<Array<ObservationDefinitionRules>>;
  /** List of location references this definition is available to. */
  scope?: Maybe<Array<References>>;
  /** Kind of specimen used by this type of observation */
  specimen?: Maybe<Array<SpecimenDefinitions>>;
  status: PublicationStatus;
  /** Type of subject for the defined observation */
  subject: CareGroupTypes;
  /** Human friendly name for this definition */
  title: Scalars["String"]["output"];
  type: ObservationTypCode;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Logical URL to reference this definition (globally unique) */
  url?: Maybe<Scalars["String"]["output"]>;
  /** Business version of this definition */
  version: Scalars["String"]["output"];
};

export type ObservationDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  observationId: Scalars["String"]["input"];
};

export type ObservationDeviceInput = {
  /** [External] Devices -> deviceId  */
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  /** [External] DeviceMetrics -> metricId */
  metricId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ObservationFlags = {
  __typename?: "ObservationFlags";
  alert_priority: AlertPriority;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Human friendly text representation */
  display: Scalars["String"]["output"];
  flag_id: Scalars["ID"]["output"];
  /** hl7 code to send */
  hl7_code: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  observation: Observations;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR observation interpretation codes */
export enum ObservationInterpretation {
  A = "A",
  Aa = "AA",
  B = "B",
  Car = "CAR",
  D = "D",
  Det = "DET",
  E = "E",
  Ex = "EX",
  Exp = "EXP",
  H = "H",
  Hh = "HH",
  Hu = "HU",
  Hx = "HX",
  I = "I",
  Ie = "IE",
  Ind = "IND",
  L = "L",
  Ll = "LL",
  Lu = "LU",
  Lx = "LX",
  N = "N",
  Ncl = "NCL",
  Nd = "ND",
  Neg = "NEG",
  NotApplicable = "NOT_APPLICABLE",
  Nr = "NR",
  Ns = "NS",
  Pos = "POS",
  R = "R",
  Rr = "RR",
  S = "S",
  Sdd = "SDD",
  Sh = "SH",
  Sl = "SL",
  SynR = "SYN_R",
  SysS = "SYS_S",
  U = "U",
  Une = "UNE",
  W = "W",
  Wr = "WR",
}

export type ObservationMemberBulkCreateInput = {
  members: Array<ObservationMemberInput>;
  observationId: Scalars["String"]["input"];
};

export type ObservationMemberDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  memberObservationId: Scalars["String"]["input"];
  observationId: Scalars["String"]["input"];
};

export type ObservationMemberInput = {
  memberObservationId: Scalars["String"]["input"];
};

export type ObservationMemberOfInput = {
  observationId: Scalars["String"]["input"];
};

export type ObservationPaginatedResults = {
  __typename?: "ObservationPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Observations>;
  totalPages: Scalars["Float"]["output"];
};

export type ObservationPartOf = MedicationAdministrations | MedicationDispenses | MedicationUsages | Procedures;

export type ObservationPerformer = CareTeams | Organizations | Patients | StaffAssignments;

export type ObservationPerformerInput = {
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible observation range category fhir codes */
export enum ObservationRangeCategory {
  /** Absolute Range for Ordinal and Continuous Observations. Results outside this range are not possible. */
  Absolute = "ABSOLUTE",
  /** Critical Range for Ordinal and Continuous Observations. Results outside this range are critical. */
  Critical = "CRITICAL",
  High = "HIGH",
  Low = "LOW",
  /** Reference (Normal) Range for Ordinal and Continuous Observations. */
  Reference = "REFERENCE",
}

export type ObservationReferenceRangeInput = {
  /** Applicable age range, if relevant */
  ageRange?: InputMaybe<RangeCreateInput>;
  /** High/Low range */
  highLowRange?: InputMaybe<RangeCreateInput>;
  /** Reference to Quantity resource representing normal numeric value (if relevant) */
  normalValue?: InputMaybe<QuantityCreateInput>;
  /** Text representation of reference range */
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type ObservationReferenceRanges = {
  __typename?: "ObservationReferenceRanges";
  /** Applicable age range, if relevant */
  age?: Maybe<Range>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Normal numeric value, if relevant */
  normal_value?: Maybe<Quantity>;
  observation: Observations;
  /** High/Low range */
  range?: Maybe<Range>;
  reference_range_id: Scalars["String"]["output"];
  /** Text based reference range */
  text?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ObservationResultValueCreateInput = {
  observationId: Scalars["String"]["input"];
  /** MUST supply ONLY one key/value pair */
  value: ObservationValueUnionInput;
};

export type ObservationResultValueInput = {
  /** MUST supply ONLY one key/value pair */
  value: ObservationValueUnionInput;
};

export type ObservationResultValues = {
  __typename?: "ObservationResultValues";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  observation: Observations;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  value_concept?: Maybe<CodeableConcepts>;
  value_date?: Maybe<Scalars["DateTime"]["output"]>;
  value_id: Scalars["String"]["output"];
  value_integer?: Maybe<Scalars["Float"]["output"]>;
  value_period?: Maybe<Periods>;
  value_quantity?: Maybe<Quantity>;
  value_range?: Maybe<Range>;
  value_string?: Maybe<Scalars["String"]["output"]>;
  value_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
};

export type ObservationSpecimen = Groups | Specimens;

export type ObservationSpecimenInput = {
  specimenGroupId?: InputMaybe<Scalars["String"]["input"]>;
  specimenId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR observation status codes. */
export enum ObservationStatus {
  /** Subsequent to being Final, the observation has been modified subsequent. This includes updates/new information and corrections. */
  Amended = "AMENDED",
  /** The observation is unavailable because the measurement was not started or not completed (also sometimes called "aborted"). */
  Cancelled = "CANCELLED",
  /** Subsequent to being Final, the observation has been modified to correct an error in the test result. */
  Corrected = "CORRECTED",
  /** The observation has been withdrawn following previous final release. This electronic record should never have existed, though it is possible that real-world decisions were based on it. (If real-world activity has occurred, the status should be "cancelled" rather than "entered-in-error".). */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The observation is complete and there are no further actions needed. Additional information such "released", "signed", etc. would be represented using Provenance which provides not only the act but also the actors and dates and other related data. These act states would be associated with an observation status of preliminary until they are all completed and then a status of final would be applied. */
  Final = "FINAL",
  /** This is an initial or interim observation: data may be incomplete or unverified. */
  Preliminary = "PRELIMINARY",
  /** The existence of the observation is registered, but there is no result yet available. */
  Registered = "REGISTERED",
  /** The authoring/source system does not know which of the status values currently applies for this observation. Note: This concept is not to be used for "other" - one of the listed statuses is presumed to apply, but the authoring/source system does not know which. */
  Unknown = "UNKNOWN",
}

/** Types of targets for lab observations */
export enum ObservationTargetType {
  Allele = "ALLELE",
  Gene = "GENE",
  Organism = "ORGANISM",
}

export type ObservationTriggeredBy = {
  __typename?: "ObservationTriggeredBy";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  observation: Observations;
  observation_id: Scalars["String"]["output"];
  /** Reason that the observation was triggered */
  reason?: Maybe<Scalars["String"]["output"]>;
  trigger_id: Scalars["String"]["output"];
  type: ObservationTriggeredByType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ObservationTriggeredByInput = {
  /** Reason that the observation was triggered */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of trigger */
  type: ObservationTriggeredByType;
};

/** All possible FHIR Observation triggered by type codes. */
export enum ObservationTriggeredByType {
  /** Performance of one or more other tests depending on the results of the initial test. This may include collection of additional specimen. While a new ServiceRequest is not required to perform the additional test, where it is still needed (e.g., requesting another laboratory to perform the reflex test), the Observation.basedOn would reference the new ServiceRequest that requested the additional test to be performed as well as the original ServiceRequest to reflect the one that provided the authorization. */
  Reflex = "REFLEX",
  /** Performance of the same test again with the same parameters/settings/solution. */
  Repeat = "REPEAT",
  /** Performance of the same test but with different parameters/settings/solution. */
  ReRun = "RE_RUN",
}

/** Type of observation */
export enum ObservationTypCode {
  Other = "OTHER",
  Panel = "PANEL",
  Test = "TEST",
}

/** All possible FHIR observation type codes. */
export enum ObservationType {
  Qst = "QST",
  Rslt = "RSLT",
  Sci = "SCI",
}

export type ObservationValueUnionInput = {
  valueBoolean?: InputMaybe<Scalars["Boolean"]["input"]>;
  valueConcept?: InputMaybe<CodeableConceptCreateInput>;
  valueInteger?: InputMaybe<Scalars["Float"]["input"]>;
  valuePeriod?: InputMaybe<PeriodCreateInput>;
  valueQuantity?: InputMaybe<QuantityCreateInput>;
  valueRange?: InputMaybe<RangeCreateInput>;
  valueString?: InputMaybe<Scalars["String"]["input"]>;
  valueTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type Observations = {
  __typename?: "Observations";
  /** Fulfills plan, proposal or order */
  based_on?: Maybe<ObservationBasedOn>;
  /** Observed body part */
  body_site?: Maybe<Scalars["String"]["output"]>;
  care_plan_id?: Maybe<Scalars["String"]["output"]>;
  category: ObservationCategory;
  /** Describes what was observed. (code/type) */
  code: Scalars["String"]["output"];
  /** Results for each component of observation */
  components: Array<ObservationComponents>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Why the result is missing */
  data_absent_reason?: Maybe<DataAbsentReason>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  device_id?: Maybe<Scalars["String"]["output"]>;
  /** Clinically relevant time/time-period for observation */
  effective?: Maybe<Periods>;
  encounter: Encounters;
  encounter_id?: Maybe<Scalars["String"]["output"]>;
  flag?: Maybe<ObservationFlags>;
  /** Instantiates FHIR ObservationDefinition */
  instantiates?: Maybe<ObservationDefinitions>;
  /** For some results, particularly numeric results, an interpretation is necessary to fully understand the significance of a result. */
  interpretation: ObservationInterpretation;
  is_archived: Scalars["Boolean"]["output"];
  /** Loinc code corresponding to observed target */
  loinc?: Maybe<LoincCodes>;
  /** Related resources that belong to this observation group. (e.g. tests from a panel) */
  members?: Maybe<Array<Observations>>;
  /** Indicates the mechanism used to perform the observation. */
  method?: Maybe<Scalars["String"]["output"]>;
  metric_id?: Maybe<Scalars["String"]["output"]>;
  note?: Maybe<Annotations>;
  observation_id: Scalars["String"]["output"];
  /** Part of referenced event */
  part_of?: Maybe<ObservationPartOf>;
  /** Who the observation is about */
  patient: Patients;
  patient_id?: Maybe<Scalars["String"]["output"]>;
  performer?: Maybe<ObservationPerformer>;
  /** Provides guide for interpretation */
  reference_range?: Maybe<Array<ObservationReferenceRanges>>;
  /** Diagnostic report generated as part of this observation */
  report?: Maybe<Array<DiagnosticReports>>;
  request_id?: Maybe<Scalars["String"]["output"]>;
  /** The specimen that was used when this observation was made. */
  specimen?: Maybe<ObservationSpecimen>;
  status: ObservationStatus;
  target_type?: Maybe<ObservationTargetType>;
  triggered_by?: Maybe<Array<ObservationTriggeredBy>>;
  type: ObservationTypCode;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Actual result */
  value?: Maybe<ObservationResultValues>;
};

export type OnboardingInvite = {
  __typename?: "OnboardingInvite";
  application_id: Scalars["ID"]["output"];
  assignment_id?: Maybe<Scalars["ID"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  demographics: OnboardingInviteDemographics;
  email: Scalars["EmailAddress"]["output"];
  expiration_date: Scalars["DateTime"]["output"];
  /** User that sent the invite. */
  from: CynergyUsers;
  invite_id: Scalars["ID"]["output"];
  /** Recipient of the invite. */
  invitee: CynergyUsers;
  is_archived: Scalars["Boolean"]["output"];
  phone?: Maybe<Scalars["PhoneNumber"]["output"]>;
  role: ApplicationRoles;
  status: OnboardingInviteStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingInviteCreateInput = {
  applicationId: Scalars["String"]["input"];
  assignmentId?: InputMaybe<Scalars["String"]["input"]>;
  /** When does invite expire. */
  expirationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** CynergyId of user sending invite */
  fromCynergyId: Scalars["String"]["input"];
  /** The delivery method used to send invite */
  method: AccountRegistrationMethodInput;
  /** Intended role of invitee */
  role: ApplicationRoles;
  /** Status of invite */
  status?: InputMaybe<OnboardingInviteStatus>;
  /** CynergyId of invited user */
  toCynergyId: Scalars["String"]["input"];
};

export type OnboardingInviteDemographics = {
  __typename?: "OnboardingInviteDemographics";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dob?: Maybe<Scalars["DateTime"]["output"]>;
  first_name: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  last_name: Scalars["String"]["output"];
  sex?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** List of possible status codes for Onboarding invitation. */
export enum OnboardingInviteStatus {
  Complete = "COMPLETE",
  Draft = "DRAFT",
  Expired = "EXPIRED",
  Opened = "OPENED",
  Pending = "PENDING",
  Sent = "SENT",
}

export enum OperationParameterScope {
  Instance = "INSTANCE",
  System = "SYSTEM",
  Type = "TYPE",
}

export enum OperationParameterUse {
  /** This is an input parameter. */
  In = "IN",
  /** This is an output parameter. */
  Out = "OUT",
}

/** The operational mode of a particular system or entity */
export enum OperationalModeCodes {
  /** Connected but functionality may be limited */
  Connected = "CONNECTED",
  /** Active and fully operational */
  Live = "LIVE",
  /** Entity mode pending health/status checks */
  Pending = "PENDING",
  /** Active but with limited functionality constrained by sandbox. Used for testing purposes */
  Sandbox = "SANDBOX",
}

export type OperatorSearch = {
  columnName: Scalars["String"]["input"];
  operator: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type OrderAgentActionInput = {
  add?: InputMaybe<Array<OrderAgentInput>>;
  remove?: InputMaybe<OrderAgentBulkDeleteInput>;
  update?: InputMaybe<OrderAgentUpdateInput>;
};

export type OrderAgentActor = CareTeams | Locations | Organizations | Practitioners | StaffAssignments;

export type OrderAgentActorInput = {
  assignmentId?: InputMaybe<Scalars["ID"]["input"]>;
  careTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  practitionerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrderAgentBulkDeleteInput = {
  agents: Array<OrderAgentIdentifierInput>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["ID"]["input"];
};

export type OrderAgentIdentifierInput = {
  agentId: Scalars["ID"]["input"];
};

export type OrderAgentInput = {
  /** An actor taking a role in the order for which it can be assigned some degree of responsibility for the order taking place */
  actor: OrderAgentActorInput;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Is agent active (Default: true) */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  /** Agents role in order */
  role: ParticipantRoleType;
};

export type OrderAgentUpdateInput = {
  agentId: Scalars["ID"]["input"];
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Is agent active (Default: true) */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Agents role in order */
  role?: InputMaybe<ParticipantRoleType>;
};

export type OrderAgents = {
  __typename?: "OrderAgents";
  /** Is active agent of order */
  active: Scalars["Boolean"]["output"];
  /** An actor taking a role in an order for which it can be assigned some degree of responsibility for the order taking place */
  actor?: Maybe<OrderAgentActor>;
  agent_id: Scalars["ID"]["output"];
  agent_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name of agent */
  name?: Maybe<Scalars["String"]["output"]>;
  order: Orders;
  /** What the agents role in order was/is. */
  role: ParticipantRoleType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderAmounts = {
  __typename?: "OrderAmounts";
  order_id: Scalars["ID"]["output"];
  /** Sum of every line before tax */
  subtotal: Scalars["USCurrency"]["output"];
  /** The platform's order fee, of the total */
  surcharge: Scalars["USCurrency"]["output"];
  /** Sum of line tax */
  tax: Scalars["USCurrency"]["output"];
  /** Sum of every line including tax */
  total: Scalars["USCurrency"]["output"];
};

export type OrderAppointment = {
  __typename?: "OrderAppointment";
  appointment_id: Scalars["ID"]["output"];
  order_id: Scalars["ID"]["output"];
};

export type OrderBillingInput = {
  billTo: BillToTypes;
  /** The patient coverage (billingcynergy Coverages.coverage_id) to bill this order against. When provided, a point-in-time snapshot is captured onto the order. Typically set when billTo = Insurance. For a single plan; use coverageIds for primary + secondary. */
  coverageId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Multiple patient coverages to bill against (primary, secondary, …). Each is snapshotted at its own coordination-of-benefits rank; together they REPLACE the order’s full coverage set. Use this OR coverageId (this wins when both are sent). */
  coverageIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type OrderBulkDeleteInput = {
  orders: Array<OrderDeleteInput>;
};

export type OrderByArgs = {
  column: Scalars["String"]["input"];
  direction: Scalars["String"]["input"];
};

export type OrderChargeResult = {
  __typename?: "OrderChargeResult";
  payment: Payments;
};

export type OrderContactActionInput = {
  add?: InputMaybe<Array<OrderContactLinkOrCreateInput>>;
  remove?: InputMaybe<OrderContactBulkDeleteInput>;
  update?: InputMaybe<ContactDetailsUpdateInput>;
};

export type OrderContactBulkDeleteInput = {
  contacts: Array<OrderContactInput>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["ID"]["input"];
};

export type OrderContactInput = {
  contactDetailId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrderContactLinkOrCreateInput = {
  contact?: InputMaybe<ContactDetailsCreateInput>;
  contactDetailId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrderCoverages = {
  __typename?: "OrderCoverages";
  captured_at: Scalars["DateTime"]["output"];
  /** Phase that captured this snapshot ('Submit' | 'Processing') */
  captured_phase?: Maybe<Scalars["String"]["output"]>;
  /** Live coverage this snapshot was taken from */
  coverage_id?: Maybe<Scalars["ID"]["output"]>;
  /** Coordination-of-benefits rank (1 = primary, 2 = secondary, …) */
  coverage_order: Scalars["Int"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Group number (coverage class type "group") */
  group_number?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  kind: FhirCoverageKind;
  order_coverage_id: Scalars["ID"]["output"];
  /** Order this coverage snapshot belongs to */
  order_id: Scalars["ID"]["output"];
  organization_id?: Maybe<Scalars["ID"]["output"]>;
  patient_id: Scalars["ID"]["output"];
  payor_address_city?: Maybe<Scalars["String"]["output"]>;
  payor_address_line1?: Maybe<Scalars["String"]["output"]>;
  payor_address_line2?: Maybe<Scalars["String"]["output"]>;
  payor_address_state?: Maybe<Scalars["String"]["output"]>;
  payor_address_zip?: Maybe<Scalars["String"]["output"]>;
  payor_external_id?: Maybe<Scalars["String"]["output"]>;
  payor_name?: Maybe<Scalars["String"]["output"]>;
  /** Plan name (coverage class type "plan") */
  plan_name?: Maybe<Scalars["String"]["output"]>;
  plan_type?: Maybe<Scalars["String"]["output"]>;
  /** Policy / member ID */
  policy_number?: Maybe<Scalars["String"]["output"]>;
  status: FhirCoverageStatus;
  subscriber_address_city?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_line1?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_line2?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_state?: Maybe<Scalars["String"]["output"]>;
  subscriber_address_zip?: Maybe<Scalars["String"]["output"]>;
  subscriber_dob?: Maybe<Scalars["DateTime"]["output"]>;
  subscriber_first_name?: Maybe<Scalars["String"]["output"]>;
  subscriber_last_name?: Maybe<Scalars["String"]["output"]>;
  subscriber_relationship_to_patient?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderCreateInput = {
  /** Agents of order */
  agents?: InputMaybe<Array<OrderAgentInput>>;
  /** Channel to broadcast alerts/updates to */
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Notes/comments */
  comments?: InputMaybe<Array<OrderNoteInput>>;
  contacts?: InputMaybe<Array<OrderContactLinkOrCreateInput>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Date/time order was fulfilled */
  fulfilledAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Additional identifiers pertaining to the order */
  identifiers?: InputMaybe<Array<OrderIdentifierInput>>;
  /** Order line items */
  lineItems?: InputMaybe<Array<OrderLineItemInput>>;
  patientId: Scalars["String"]["input"];
  paymentTerm?: InputMaybe<DurationCreateInput>;
  /** Order recurrence */
  recurrence?: InputMaybe<RecurrencePatternCreateInput>;
  requester: OrderRequesterInput;
  requisitionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Review status of order */
  reviewStatus?: InputMaybe<ReviewStatusInput>;
  /** Date/time order is scheduled to occur */
  scheduledDate?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Whether to send an email notification */
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  specimen?: InputMaybe<OrderSpecimenInput>;
  status?: InputMaybe<OrderStatus>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Title of order to display */
  title: Scalars["String"]["input"];
};

export type OrderDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["ID"]["input"];
  /** Reason for cancelling order */
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrderFlags = {
  __typename?: "OrderFlags";
  alert_priority: AlertPriority;
  /** Human friendly text representation */
  display: Scalars["String"]["output"];
  flag_id: Scalars["ID"]["output"];
  /** hl7 code to send */
  hl7_code: Scalars["String"]["output"];
  observation?: Maybe<Observations>;
  request_id: Scalars["ID"]["output"];
};

export type OrderHistory = {
  __typename?: "OrderHistory";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  history_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  new_value: Scalars["JSON"]["output"];
  old_value: Scalars["JSON"]["output"];
  order: Orders;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderIdentifier = {
  identifierId: Scalars["ID"]["input"];
};

export type OrderIdentifierActionInput = {
  add?: InputMaybe<Array<OrderIdentifierInput>>;
  remove?: InputMaybe<OrderIdentifierBulkDeleteInput>;
  update?: InputMaybe<IdentifierUpdateInput>;
};

export type OrderIdentifierBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  identifiers: Array<OrderIdentifier>;
  orderId: Scalars["ID"]["input"];
};

export type OrderIdentifierInput = {
  identifier: IdentifierCreateInput;
};

export type OrderInput = {
  /** Agents of order */
  agents?: InputMaybe<Array<OrderAgentInput>>;
  /** Channel to broadcast alerts/updates to */
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Notes/comments */
  comments?: InputMaybe<Array<OrderNoteInput>>;
  contacts?: InputMaybe<Array<OrderContactLinkOrCreateInput>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Date/time order was fulfilled */
  fulfilledAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Additional identifiers pertaining to the order */
  identifiers?: InputMaybe<Array<OrderIdentifierInput>>;
  paymentTerm?: InputMaybe<DurationCreateInput>;
  /** Order recurrence */
  recurrence?: InputMaybe<RecurrencePatternCreateInput>;
  requester: OrderRequesterInput;
  requisitionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Review status of order */
  reviewStatus?: InputMaybe<ReviewStatusInput>;
  /** Date/time order is scheduled to occur */
  scheduledDate?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Whether to send an email notification */
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  specimen?: InputMaybe<OrderSpecimenInput>;
  status?: InputMaybe<OrderStatus>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Title of order to display */
  title: Scalars["String"]["input"];
};

export type OrderItemPaginatedResults = {
  __typename?: "OrderItemPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<OrderLineItems>;
  totalPages: Scalars["Float"]["output"];
};

/** Describes what the order item represents */
export enum OrderItemType {
  DeliveryCharge = "DeliveryCharge",
  Fee = "Fee",
  Product = "Product",
}

/** Category associated with order item type */
export enum OrderItemTypeCode {
  Charge = "Charge",
  Product = "Product",
}

export type OrderLineItemActionInput = {
  add?: InputMaybe<Array<OrderLineItemInput>>;
  remove?: InputMaybe<OrderLineItemDeleteInput>;
  update?: InputMaybe<Array<OrderLineItemUpdateInput>>;
};

export type OrderLineItemDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  lineItems: Array<LineItemIdentifierInput>;
};

export type OrderLineItemInput = {
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Reference to the price book entry associated to order line item */
  priceBookEntryId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Service being requested */
  service: ServiceRequestCreateInput;
  /** specimen capture being requested */
  specimen?: InputMaybe<SpecimenCollectionRequestInput>;
  /** Reference to the store associated with this order line item */
  storeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrderLineItemUpdateInput = {
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  lineItemId: Scalars["ID"]["input"];
  /** Service being requested */
  service?: InputMaybe<ServiceRequestUpdateInput>;
};

export type OrderLineItems = {
  __typename?: "OrderLineItems";
  channel_id?: Maybe<Scalars["ID"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Short line item description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Total line item amount */
  gross_total: Scalars["USCurrency"]["output"];
  invoice_line?: Maybe<InvoiceLines>;
  is_archived: Scalars["Boolean"]["output"];
  /** Whether this line has a priced catalog item and a store */
  is_billable: Scalars["Boolean"]["output"];
  line_item_id: Scalars["ID"]["output"];
  /** What this line was sold as */
  name: Scalars["String"]["output"];
  /** Net total line item amount */
  net_total: Scalars["USCurrency"]["output"];
  order: Orders;
  price_entry: PriceBookEntries;
  pricebook_entry_id?: Maybe<Scalars["ID"]["output"]>;
  request?: Maybe<ServiceRequests>;
  store_id?: Maybe<Scalars["ID"]["output"]>;
  /** Total tax amount */
  tax?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Represents the type of line item. */
  type: OrderItemType;
  /** Type code of line item */
  type_code: OrderItemTypeCode;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderMergeInput = {
  /** Order to merge into */
  orderId: Scalars["ID"]["input"];
  /** Order to merge */
  orderToMergeIds: Array<Scalars["ID"]["input"]>;
};

export type OrderNote = {
  annotationId: Scalars["ID"]["input"];
};

export type OrderNoteActionInput = {
  add?: InputMaybe<Array<OrderNoteInput>>;
  remove?: InputMaybe<OrderNoteBulkDeleteInput>;
  update?: InputMaybe<AnnotationUpdateInput>;
};

export type OrderNoteBulkDeleteInput = {
  annotations: Array<OrderNote>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["ID"]["input"];
};

export type OrderNoteInput = {
  annotation: AnnotationCreateInput;
};

export type OrderNotePaginatedResults = {
  __typename?: "OrderNotePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Annotations>;
  totalPages: Scalars["Float"]["output"];
};

export type OrderPaginatedResults = {
  __typename?: "OrderPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Orders>;
  totalPages: Scalars["Float"]["output"];
};

export type OrderPatient = {
  billing: OrderBillingInput;
  patientId: Scalars["ID"]["input"];
};

export type OrderPaymentSummaries = {
  __typename?: "OrderPaymentSummaries";
  account: BillingAccounts;
  authorizations?: Maybe<Array<PaymentAuthorizations>>;
  balances?: Maybe<OrderPaymentSummaryBalances>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  order_id: Scalars["ID"]["output"];
  /** Payment method used by the summary payments */
  payment_method: PaymentMethods;
  payments?: Maybe<Array<Payments>>;
  refunds?: Maybe<Array<Refunds>>;
  summary_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderPaymentSummaryBalances = {
  __typename?: "OrderPaymentSummaryBalances";
  /** Sum of authorized amounts */
  authorized_amount: Scalars["USCurrency"]["output"];
  /** Summary payment balance */
  balance: Scalars["USCurrency"]["output"];
  /** Amount capturable */
  capturable_amount: Scalars["USCurrency"]["output"];
  /** Sum of processed payment amounts */
  captured_amount: Scalars["USCurrency"]["output"];
  /** Most recent payment activity */
  last_payment_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Number of processed payments on the summary */
  payment_count: Scalars["Float"]["output"];
  /** Amount pending authorization */
  pending_authorization_amount: Scalars["USCurrency"]["output"];
  /** Amount pending capture */
  pending_capture_amount: Scalars["USCurrency"]["output"];
  /** Amount pending refund */
  pending_refund_amount: Scalars["USCurrency"]["output"];
  /** Amount that may be refunded */
  refundable_amount: Scalars["USCurrency"]["output"];
  /** Sum of processed refund amounts */
  refunded_amount: Scalars["USCurrency"]["output"];
  summary_id: Scalars["ID"]["output"];
};

export type OrderProviderInput = {
  name: Scalars["String"]["input"];
  /** Identifier of the signing practitioner */
  practitionerId: Scalars["ID"]["input"];
  signatureUrl: Scalars["URL"]["input"];
};

export type OrderRequester = CareTeams | Locations | Organizations | Patients | Practitioners | StaffAssignments;

export type OrderRequesterInput = {
  assignmentId?: InputMaybe<Scalars["ID"]["input"]>;
  careTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
  practitionerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrderSignatureUpsertInput = {
  /** Name of practitioner who signed */
  name: Scalars["String"]["input"];
  orderId: Scalars["ID"]["input"];
  practitionerId: Scalars["ID"]["input"];
  signature: SignatureInput;
};

export type OrderSignatures = {
  __typename?: "OrderSignatures";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name of practitioner who attests to this order */
  name: Scalars["String"]["output"];
  order: Orders;
  order_id: Scalars["ID"]["output"];
  practitioner?: Maybe<Practitioners>;
  practitioner_id: Scalars["ID"]["output"];
  /** Practitioner signature */
  signature?: Maybe<Signatures>;
  signature_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderSpecimenInput = {
  /** Date and time specimen is scheduled for pickup */
  collectionDateTime: Scalars["GraphQLDateTime"]["input"];
};

export type OrderStatisticEntry = {
  __typename?: "OrderStatisticEntry";
  count: Scalars["Int"]["output"];
  value: Scalars["String"]["output"];
};

export type OrderStatisticsInput = {
  by: OrderStatsTargetKeys;
};

export type OrderStatisticsResults = {
  __typename?: "OrderStatisticsResults";
  field: OrderStatsTargetKeys;
  stats: Array<OrderStatisticEntry>;
};

/** Available order keys to fetch stats by */
export enum OrderStatsTargetKeys {
  Category = "category",
  Code = "code",
  Intent = "intent",
  Priority = "priority",
  Status = "status",
}

/** Status codes for application orders */
export enum OrderStatus {
  /** The order has been archived by the user */
  Archived = "ARCHIVED",
  Cancelled = "CANCELLED",
  /** The order has been finalized and results are available */
  Complete = "COMPLETE",
  /** The order has been soft-deleted and hidden from normal views. Distinct from CANCELLED (which remains visible). */
  Deleted = "DELETED",
  /** The order is being processed */
  InProgress = "IN_PROGRESS",
  /** The order is awaiting acceptance from organization or other 3rd party */
  Pending = "PENDING",
  /** The organization has rejected the order */
  Rejected = "REJECTED",
}

export type OrderStatusHistory = {
  __typename?: "OrderStatusHistory";
  /** Username / actor responsible for the change. Falls back to "System" for cron writes. */
  changed_by: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  order: Orders;
  order_id: Scalars["ID"]["output"];
  /** The status before this transition */
  previous_status?: Maybe<OrderStatus>;
  /** Reason recorded for this status change */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** The status the order moved to */
  status: OrderStatus;
  status_change_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderSummary = {
  __typename?: "OrderSummary";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Total number of ordered items on order */
  item_count: Scalars["Float"]["output"];
  order: Orders;
  order_number: Scalars["String"]["output"];
  /** Date when the associated order was placed */
  ordered_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Status of order */
  status: OrderStatus;
  /** Order subtotal */
  subtotal: Scalars["USCurrency"]["output"];
  summary_id: Scalars["ID"]["output"];
  /** Amount in fees */
  surcharge: Scalars["USCurrency"]["output"];
  /** Total tax amount */
  tax?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Order grand total amount */
  total?: Maybe<Scalars["USCurrency"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrderUpdateInput = {
  agent?: InputMaybe<OrderAgentActionInput>;
  /** Update the order's billing/coverage. billTo = Insurance + coverageId captures a fresh point-in-time coverage snapshot onto the order; any other billTo (or no coverage) clears the order's coverage snapshot. Regenerates the requisition so the new payor/policy is reflected. */
  billing?: InputMaybe<OrderBillingInput>;
  /** Channel to broadcast alerts/updates to */
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  comment?: InputMaybe<OrderNoteActionInput>;
  contact?: InputMaybe<OrderContactActionInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Date/time order was fulfilled */
  fulfilledAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  identifier?: InputMaybe<OrderIdentifierActionInput>;
  /** Order line items */
  lineItems?: InputMaybe<OrderLineItemActionInput>;
  orderId: Scalars["ID"]["input"];
  /** Physician signature */
  physician?: InputMaybe<OrderProviderInput>;
  /** Order recurrence */
  recurrence?: InputMaybe<RecurrencePatternCreateInput>;
  requisitionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Review status of order */
  reviewStatus?: InputMaybe<ReviewStatusInput>;
  /** Date/time order is scheduled to occur */
  scheduledDate?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Whether to send an email notification */
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  specimen?: InputMaybe<OrderSpecimenInput>;
  status?: InputMaybe<OrderStatus>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Title of order to display */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Orders = {
  __typename?: "Orders";
  /** Actors involved */
  agents?: Maybe<Array<OrderAgents>>;
  amounts?: Maybe<OrderAmounts>;
  appointments?: Maybe<Array<Appointments>>;
  balance?: Maybe<Scalars["USCurrency"]["output"]>;
  channel_id?: Maybe<Scalars["ID"]["output"]>;
  conditions?: Maybe<Array<Conditions>>;
  /** Contact details relevant to this order */
  contacts?: Maybe<Array<ContactDetails>>;
  /** Primary (lowest-rank) point-in-time insurance coverage snapshot for this order */
  coverage?: Maybe<OrderCoverages>;
  /** All ranked insurance coverage snapshots for this order (primary, secondary, …), ordered by coordination-of-benefits rank */
  coverages?: Maybe<Array<OrderCoverages>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  diagnosis_codes?: Maybe<Array<Icd10>>;
  event?: Maybe<Events>;
  event_id?: Maybe<Scalars["ID"]["output"]>;
  flags?: Maybe<Array<OrderFlags>>;
  /** Datetime order was fulfilled */
  fulfilled_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  history?: Maybe<Array<OrderHistory>>;
  /** Identifiers associated with order */
  identifiers?: Maybe<Array<Identifiers>>;
  invoices?: Maybe<Array<Invoices>>;
  is_archived: Scalars["Boolean"]["output"];
  is_reviewed: Scalars["Boolean"]["output"];
  is_series_source?: Maybe<Scalars["Boolean"]["output"]>;
  line_items?: Maybe<Array<OrderLineItems>>;
  /** Next scheduled date in recurring series */
  next_scheduled_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Notes and comments made about the order */
  notes?: Maybe<Array<Annotations>>;
  order_id: Scalars["ID"]["output"];
  /** Patient the order is for */
  patient: Patients;
  payment_initiation_source?: Maybe<PaymentInitiationSources>;
  payment_term?: Maybe<PaymentTerms>;
  payment_term_id?: Maybe<Scalars["ID"]["output"]>;
  priority: RequestPriority;
  /** Indicates if this order is part of a recurring series */
  recurs: Scalars["Boolean"]["output"];
  reports?: Maybe<Array<DiagnosticReports>>;
  /** Requested date/time for specimen collection */
  requested_collection_date?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Who is requesting the order be carried out. (dispatcher) */
  requester?: Maybe<OrderRequester>;
  requester_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  /** Requested services to be performed */
  requests?: Maybe<Array<ServiceRequests>>;
  /** Reference to requisition PDF */
  requisition?: Maybe<DocumentReferences>;
  /** Review status of the order */
  review_status?: Maybe<ReviewStatuses>;
  /** The date/time the order is scheduled to occur */
  scheduled_date: Scalars["GraphQLDateTime"]["output"];
  series?: Maybe<EventSeries>;
  series_id?: Maybe<Scalars["ID"]["output"]>;
  /** Signing practitioner */
  signature?: Maybe<OrderSignatures>;
  slug?: Maybe<Scalars["String"]["output"]>;
  status: OrderStatus;
  /** Chronological status changes with reason and actor per transition */
  status_history?: Maybe<Array<OrderStatusHistory>>;
  status_reason?: Maybe<Scalars["String"]["output"]>;
  subject_name: Scalars["String"]["output"];
  summary?: Maybe<OrderSummary>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrdersFlagsArgs = {
  priority?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganismCounts = {
  __typename?: "OrganismCounts";
  count: Scalars["Float"]["output"];
  mapType: Scalars["String"]["output"];
  organism: Scalars["String"]["output"];
};

export type OrganizationAffiliations = {
  __typename?: "OrganizationAffiliations";
  /** Whether this organization affiliation record is in active use */
  active: Scalars["Boolean"]["output"];
  affiliation_id: Scalars["ID"]["output"];
  /** Official contact details at the participating organization relevant to this affiliation */
  contacts?: Maybe<Array<ContactDetails>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Business identifiers that are specific to this role */
  identifiers?: Maybe<Array<Identifiers>>;
  is_archived: Scalars["Boolean"]["output"];
  /** The location(s) at which the role occurs */
  locations?: Maybe<Array<Locations>>;
  /** The network in which the participatingOrganization provides the role's services (if defined) at the indicated locations (if defined) */
  network?: Maybe<Array<Organizations>>;
  /** Organization where the role is available */
  organization: Organizations;
  /** Organization that provides/performs the role (e.g. providing services or is a member of) */
  participating_organization: Organizations;
  /** The period during which the participating organization is affiliated with the primary organization */
  period?: Maybe<Periods>;
  /** Definition of the role the participating organization plays */
  role: OrganizationRoles;
  /** Healthcare services provided through the role */
  services?: Maybe<Array<HealthcareServices>>;
  /** Specific speciality of the participating organization in the context of the role */
  speciality?: Maybe<CodeableConcepts>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationChanges = ChangesEntity & {
  __typename?: "OrganizationChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  organization_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationContactRelations = {
  __typename?: "OrganizationContactRelations";
  contact: OrganizationContacts;
  contact_id: OrganizationContacts;
  contact_relation_id: Scalars["String"]["output"];
  contact_type_id: OrganizationContactTypes;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  location?: Maybe<Locations>;
  location_id?: Maybe<Scalars["String"]["output"]>;
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** all available organization contact type codes */
export enum OrganizationContactTypes {
  /** Contact details for administrative enquiries. */
  Admin = "ADMIN",
  /** Contact details for information regarding to billing/general finance enquiries. */
  Billing = "BILLING",
  /** Contact details for issues related to Human Resources, such as staff matters, OHAndS etc. */
  Hr = "HR",
  /** Generic information contact for patients. */
  Patient = "PATIENT",
  /** Contact details for dealing with issues related to insurance claims/adjudication/payment. */
  Payor = "PAYOR",
  /** Dedicated contact point for matters relating to press enquiries. */
  Press = "PRESS",
}

export type OrganizationContacts = {
  __typename?: "OrganizationContacts";
  contact_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  last_name?: Maybe<Scalars["String"]["output"]>;
  locations: Array<Locations>;
  nickname: Scalars["String"]["output"];
  organizations: Array<Organizations>;
  phone?: Maybe<Scalars["String"]["output"]>;
  relationships: Array<OrganizationContactRelations>;
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationCreateInput = {
  address: UserAddressInput;
  alias?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  ownerUserId?: InputMaybe<Scalars["ID"]["input"]>;
  role: OrganizationRoles;
  safetyPrecautions?: InputMaybe<Array<OrganizationHealthAndSafetyPrecautions>>;
  type: OrganizationTypes;
  /** Unique vendor code */
  vendorCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["ID"]["input"];
};

/** The health and safety precautions and organization has in place */
export enum OrganizationHealthAndSafetyPrecautions {
  /** An appointment is required */
  AppointmentRequired = "AppointmentRequired",
  /** Surfaces are disinfected between visits */
  DisinfectSurfaces = "DisinfectSurfaces",
  /** Clients are required to wear maks during their visit */
  MasksRequired = "MasksRequired",
  /** Staff members are required to wear masks whilst operating within the facility */
  StaffMasks = "StaffMasks",
  /** Staff members are required to have their temperature taken before each shift */
  StaffTemperatureChecks = "StaffTemperatureChecks",
  /** Clients are required to have their temperature taken upon arrival */
  TemperatureChecks = "TemperatureChecks",
}

/** All available organization roles */
export enum OrganizationRoles {
  /** An organization such as a public health agency, community/social services provider, etc. */
  Agency = "AGENCY",
  /** An organization providing diagnostic testing/laboratory services */
  Diagnostics = "DIAGNOSTICS",
  /** An organization which manages or otherwise oversees their owned provider locations. */
  Entity = "ENTITY",
  /** An organization that facilitates electronic clinical data exchange between entities */
  HieHio = "HIE_HIO",
  /** A type of non-ownership relationship between entities (encompasses partnerships, collaboration, joint ventures, etc.) */
  Member = "MEMBER",
  /** An organization providing reimbursement, payment, or related services. */
  Payer = "PAYER",
  /** An organization that provides general healthcare services. (e.g. Doctors Offices, Nursing Homes, etc.) */
  Provider = "PROVIDER",
  /** An organization providing research-related services such as conducting research, recruiting research participants, analyzing data, etc. */
  Research = "RESEARCH",
  /** An organization that provides medical supplies (e.g. medical devices, equipment, pharmaceutical products, etc.) */
  Supplier = "SUPPLIER",
}

/** All available organization types */
export enum OrganizationTypes {
  /** An organization that is identified as a Pharmaceutical/Clinical Research Sponsor. */
  ClinicalResearchSponsor = "CLINICAL_RESEARCH_SPONSOR",
  /** An un-incorporated community group. */
  CommunityGroup = "COMMUNITY_GROUP",
  /** An educational institution that provides education or research facilities. */
  EducationalInstitute = "EDUCATIONAL_INSTITUTE",
  /** A political body, often used when including organization records for government bodies such as a Federal Government, State or Local Government. */
  Government = "GOVERNMENT",
  /** An organization that provides healthcare services. */
  HealthcareProvider = "HEALTHCARE_PROVIDER",
  /** A department or ward within a hospital (Generally is not applicable to top level organizations) */
  HospitalDepartment = "HOSPITAL_DEPARTMENT",
  /** A company that provides insurance to its subscribers that may include healthcare related policies. */
  InsuranceCompany = "INSURANCE_COMPANY",
  /** An organization that is a registered business or corporation but not identified by other types. */
  NonHealthcareBusiness = "NON_HEALTHCARE_BUSINESS",
  /** An organizational team is usually a grouping of practitioners that perform a specific function within an organization (which could be a top level organization, or a department). */
  OrganizationalTeam = "ORGANIZATIONAL_TEAM",
  /** Other type of organization not already specified. */
  Other = "OTHER",
  /** A company, charity, or governmental organization, which processes claims and/or issues payments to providers on behalf of patients or groups of patients. */
  Payer = "PAYER",
  /** An organization that is identified as a part of a religious institution. */
  ReligiousInstitution = "RELIGIOUS_INSTITUTION",
}

export type OrganizationUpdateInput = {
  address?: InputMaybe<UserAddressInput>;
  alias?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  role?: InputMaybe<OrganizationRoles>;
  safetyPrecautions?: InputMaybe<Array<OrganizationHealthAndSafetyPrecautions>>;
  type?: InputMaybe<OrganizationTypes>;
  /** Unique vendor code */
  vendorCode?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible organization verification status codes */
export enum OrganizationVerificationStatuses {
  Attested = "ATTESTED",
  InProgress = "IN_PROGRESS",
  RequiresValidation = "REQUIRES_VALIDATION",
  RevalidationFailed = "REVALIDATION_FAILED",
  Validated = "VALIDATED",
  ValidationFailed = "VALIDATION_FAILED",
}

export type OrganizationVerifications = OrganizationVerificationsEntity & {
  __typename?: "OrganizationVerifications";
  clia?: Maybe<Scalars["String"]["output"]>;
  cola?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_verified: Scalars["Boolean"]["output"];
  npi?: Maybe<Scalars["String"]["output"]>;
  organization_id: Scalars["String"]["output"];
  period_end?: Maybe<Scalars["DateTime"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  verification_id: Scalars["String"]["output"];
  verification_status: OrganizationVerificationStatuses;
  verified_by?: Maybe<Scalars["String"]["output"]>;
  verified_on?: Maybe<Scalars["DateTime"]["output"]>;
};

export type OrganizationVerificationsEntity = {
  clia?: Maybe<Scalars["String"]["output"]>;
  cola?: Maybe<Scalars["String"]["output"]>;
  is_verified: Scalars["Boolean"]["output"];
  npi?: Maybe<Scalars["String"]["output"]>;
  period_end?: Maybe<Scalars["DateTime"]["output"]>;
  verified_by?: Maybe<Scalars["String"]["output"]>;
  verified_on?: Maybe<Scalars["DateTime"]["output"]>;
};

export type Organizations = {
  __typename?: "Organizations";
  address: WebCynergyAddresses;
  alias: Scalars["String"]["output"];
  authnet_customer_profile_id?: Maybe<Scalars["String"]["output"]>;
  changes?: Maybe<Array<OrganizationChanges>>;
  contacts?: Maybe<Array<OrganizationContacts>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encounters?: Maybe<Array<Encounters>>;
  groups: Array<Groups>;
  is_archived: Scalars["Boolean"]["output"];
  locations?: Maybe<Array<Locations>>;
  name: Scalars["String"]["output"];
  offerings?: Maybe<Array<HealthcareServices>>;
  organization_id: Scalars["String"]["output"];
  organization_role: OrganizationRoles;
  organization_type: OrganizationTypes;
  owner: Users;
  preferred_member: Scalars["Boolean"]["output"];
  safety_precautions?: Maybe<Array<OrganizationHealthAndSafetyPrecautions>>;
  sub_organizations?: Maybe<Array<Organizations>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Unique vendor code */
  vendor_code: Scalars["String"]["output"];
  verification?: Maybe<OrganizationVerifications>;
};

export type PaginatedCynergyUsersResponse = {
  __typename?: "PaginatedCynergyUsersResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<CynergyIdentityUnion>;
  totalPages: Scalars["Float"]["output"];
};

export type PaginationArgs = {
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
  page?: InputMaybe<Scalars["Float"]["input"]>;
  size?: InputMaybe<Scalars["Float"]["input"]>;
};

export type Parameters = {
  __typename?: "Parameters";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** A brief description of the parameter. */
  documentation?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The maximum number of times this element is permitted to appear in the request or response. */
  max: Scalars["Float"]["output"];
  /** The minimum number of times this parameter SHALL appear in the request or response. */
  min: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  parameter_id: Scalars["String"]["output"];
  scope?: Maybe<OperationParameterScope>;
  /** How the parameter is understood if/when it used as search parameter. This is only used if the parameter is a string. */
  search_type?: Maybe<SearchParamType>;
  /** The type of the parameter. */
  type?: Maybe<CodeableConcepts>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Input or output parameter? */
  use: OperationParameterUse;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type ParseDriverLicenseInput = {
  input: Scalars["String"]["input"];
  is_image?: InputMaybe<Scalars["Boolean"]["input"]>;
  max_tokens?: InputMaybe<Scalars["Float"]["input"]>;
  temperature?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ParseMedicationInput = {
  input: Scalars["String"]["input"];
  is_image?: InputMaybe<Scalars["Boolean"]["input"]>;
  max_tokens?: InputMaybe<Scalars["Float"]["input"]>;
  temperature?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ParticipantIdentifier = {
  participantId: Scalars["ID"]["input"];
};

/** All possible FHIR participant resource type codes. */
export enum ParticipantResourceType {
  /** The Care Team includes all the people and organizations who plan to participate in the coordination and delivery of care. */
  CareTeam = "CARE_TEAM",
  /** This resource describes the properties (regulated, has real time clock, etc.), adminstrative (manufacturer name, model number, serial number, firmware, etc.), and type (knee replacement, blood pressure cuff, MRI, etc.) of a physical unit (these values do not change much within a given module, for example the serail number, manufacturer name, and model number). An actual unit may consist of several modules in a distinct hierarchy and these are represented by multiple Device resources and bound through the 'parent' element. */
  Device = "DEVICE",
  /** Represents a defined collection of entities that may be discussed or acted upon collectively but which are not expected to act collectively, and are not formally or legally recognized; i.e. a collection of entities that isn't an Organization. */
  Group = "GROUP",
  /** The details of a healthcare service available at a location or in a catalog. In the case where there is a hierarchy of services (for example, Lab -> Pathology -> Wound Cultures), this can be represented using a set of linked HealthcareServices. */
  HealthcareService = "HEALTHCARE_SERVICE",
  /** Details and position information for a place where services are provided and resources and participants may be stored, found, contained, or accommodated. */
  Location = "LOCATION",
  /** A formally or informally recognized grouping of people or organizations formed for the purpose of achieving some form of collective action. Includes companies, institutions, corporations, departments, community groups, healthcare practice groups, payer/insurer, etc. */
  Organization = "ORGANIZATION",
  /** Demographics and other administrative information about an individual or animal receiving care or other health-related services. */
  Patient = "PATIENT",
  /** A person who is directly or indirectly involved in the provisioning of healthcare or related services. */
  Practitioner = "PRACTITIONER",
  /** A specific set of Roles/Locations/specialties/services that a practitioner may perform, or has performed at an organization during a period of time. */
  PractitionerRole = "PRACTITIONER_ROLE",
  /** Information about a person that is involved in a patient's health or the care for a patient, but who is not the target of healthcare, nor has a formal responsibility in the care process. */
  RelatedPerson = "RELATED_PERSON",
}

/** All available FHIR participant role codes. */
export enum ParticipantRole {
  Caregiver = "CAREGIVER",
  HealthcareProfessional = "HEALTHCARE_PROFESSIONAL",
  Nurse = "NURSE",
  Patient = "PATIENT",
  Pharmacist = "PHARMACIST",
  Physician = "PHYSICIAN",
}

/** This FHIR value set is comprised of Actor participation Type codes, which can be used to value FHIR agents, actors, and other role elements. The codes are intended to express how the agent participated in some activity. Sometimes referred to the agent functional-role relative to the activity. */
export enum ParticipantRoleType {
  /** A device that operates independently of an author on custodian's algorithms for data extraction of existing information for purpose of generating a new artifact. */
  Assembler = "ASSEMBLER",
  /** A verifier who attests to the accuracy of the resource */
  Attester = "ATTESTER",
  /** A party that originates the resource and therefore has responsibility for the information given in the resource and ownership of this resource */
  Author = "AUTHOR",
  /** An entity providing authorization services to enable the electronic sharing of health-related information based on resource owner's preapproved permissions. For example, an UMA Authorization Server[UMA] */
  Authserver = "AUTHSERVER",
  /** A device used by an author to record new information, which may also be used by the author to select existing information for aggregation with newly recorded information for the purpose of generating a new artifact. */
  Composer = "COMPOSER",
  /** The entity that is accountable for maintaining a true an accurate copy of the original record */
  Custodian = "CUSTODIAN",
  /** An entity that collects information over which the data subject may have certain rights under policy or law to control that information's management and distribution by data collectors, including the right to access, retrieve, distribute, or delete that information. */
  Datacollector = "DATACOLLECTOR",
  /** An entity that processes collected information over which the data subject may have certain rights under policy or law to control that information's management and distribution by data processors, including the right to access, retrieve, distribute, or delete that information. */
  Dataprocessor = "DATAPROCESSOR",
  /** A person whose personal information is collected or processed, and who may have certain rights under policy or law to control that information's management and distribution by data collectors or processors, including the right to access, retrieve, distribute, or delete that information. */
  Datasubject = "DATASUBJECT",
  /** A person entering the data into the originating system */
  Enterer = "ENTERER",
  /** The human user that has participated. */
  Humanuser = "HUMANUSER",
  /** A person who reported information that contributed to the resource */
  Informant = "INFORMANT",
  /** The person authenticated the content and accepted legal responsibility for its content */
  Legal = "LEGAL",
  /** A person, animal, organization or device that who actually and principally carries out the activity */
  Performer = "PERFORMER",
  /** A person who verifies the correctness and appropriateness of activity */
  Verifier = "VERIFIER",
}

/** All possible FHIR participant type codes. */
export enum ParticipantType {
  /** The practitioner who is responsible for admitting a patient to a patient encounter. */
  Adm = "ADM",
  /** The practitioner that has responsibility for overseeing a patient's care during a patient encounter. */
  Atnd = "ATND",
  Aut = "AUT",
  /** A person or organization who should be contacted for follow-up questions about the act in place of the author. */
  Callbck = "CALLBCK",
  /** An advisor participating in the service by performing evaluations and making recommendations. */
  Con = "CON",
  /** The practitioner who is responsible for the discharge of a patient from a patient encounter. */
  Dis = "DIS",
  /** A person to be contacted in case of an emergency during the encounter. */
  Emergency = "EMERGENCY",
  /** Only with Transportation services. A person who escorts the patient. */
  Esc = "ESC",
  Loc = "LOC",
  Prf = "PRF",
  /** A person having referred the subject of the service to the performer (referring physician). Typically, a referring physician will receive a report. */
  Ref = "REF",
  Sbj = "SBJ",
  /** A translator who is facilitating communication with the patient during the encounter */
  Translator = "TRANSLATOR",
}

/** All possible FHIR participation mode codes. */
export enum ParticipationMode {
  Appwrit = "APPWRIT",
  Electronic = "ELECTRONIC",
  Emailwrit = "EMAILWRIT",
  Face = "FACE",
  Faxwrit = "FAXWRIT",
  Handwrit = "HANDWRIT",
  Mailwrit = "MAILWRIT",
  Mmswrit = "MMSWRIT",
  Msgwrit = "MSGWRIT",
  Onlinewrit = "ONLINEWRIT",
  Phone = "PHONE",
  Physical = "PHYSICAL",
  Remote = "REMOTE",
  Smswrit = "SMSWRIT",
  Typewrit = "TYPEWRIT",
  Verbal = "VERBAL",
  Videoconf = "VIDEOCONF",
  Written = "WRITTEN",
}

/** All fhir participation status codes. */
export enum ParticipationStatus {
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  NeedsAction = "NEEDS_ACTION",
  Tentative = "TENTATIVE",
}

export type PasswordChanges = {
  __typename?: "PasswordChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  password_id?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Passwords = CynergyRelationEntity & {
  __typename?: "Passwords";
  changes?: Maybe<Array<PasswordChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  expires_at: Scalars["DateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  password: Scalars["String"]["output"];
  password_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user_type: UserTypes;
};

export type Patient = {
  __typename?: "Patient";
  AltPatID?: Maybe<Scalars["String"]["output"]>;
  CreatedDate: Scalars["String"]["output"];
  DOB: Scalars["String"]["output"];
  Gender: Scalars["String"]["output"];
  Hospice: Scalars["Boolean"]["output"];
  LTC: Scalars["Boolean"]["output"];
  Lk_PatID?: Maybe<Scalars["String"]["output"]>;
  MBI_ID?: Maybe<Scalars["String"]["output"]>;
  PatAddress: Scalars["String"]["output"];
  PatCity?: Maybe<Scalars["String"]["output"]>;
  PatEmail?: Maybe<Scalars["String"]["output"]>;
  PatFName: Scalars["String"]["output"];
  PatFullName: Scalars["String"]["output"];
  PatID: Scalars["String"]["output"];
  PatLName: Scalars["String"]["output"];
  PatMid?: Maybe<Scalars["String"]["output"]>;
  PatPhone?: Maybe<Scalars["String"]["output"]>;
  PatState?: Maybe<Scalars["String"]["output"]>;
  PatZip?: Maybe<Scalars["String"]["output"]>;
  PosDup: Scalars["Boolean"]["output"];
  SSN?: Maybe<Scalars["String"]["output"]>;
  SkilledNursing: Scalars["Boolean"]["output"];
  UpdatedDate: Scalars["String"]["output"];
};

export type PatientChanges = ChangesEntity & {
  __typename?: "PatientChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  patient_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** all available organization contact type codes */
export enum PatientContactCodes {
  CareContact = "Care_Contact",
  EmergencyContact = "Emergency_Contact",
  Employer = "Employer",
  FederalAgency = "Federal_Agency",
  InsuranceCompany = "Insurance_Company",
  NextOfKin = "Next_of_Kin",
  StateAgency = "State_Agency",
  Unknown = "Unknown",
}

export type PatientContactRequiredInput = {
  period?: InputMaybe<PeriodCreateInput>;
  /** Specify preferred order of use (1 = highest) */
  rank?: InputMaybe<Scalars["Float"]["input"]>;
  system: ContactPointSystem;
  use: ContactPointUse;
  value: Scalars["String"]["input"];
};

export type PatientDemographicInput = {
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>;
  dob: Scalars["String"]["input"];
  ethnicity?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  maritalStatus?: InputMaybe<MaritalStatus>;
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  /** Name prefix (e.g. Mr., Dr.). */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  race?: InputMaybe<Scalars["String"]["input"]>;
  sex: Scalars["String"]["input"];
  /** Name suffix (e.g. Jr., III, MD). */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatientDemosResultInput = {
  /** Address Line 1 */
  address?: InputMaybe<Scalars["String"]["input"]>;
  /** City */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Date of Birth */
  dob?: InputMaybe<Scalars["String"]["input"]>;
  /** Given Name */
  fName?: InputMaybe<Scalars["String"]["input"]>;
  /** Family Name */
  lName?: InputMaybe<Scalars["String"]["input"]>;
  /** Middle Name */
  mName?: InputMaybe<Scalars["String"]["input"]>;
  /** Prefix: Mr./Mrs. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** Sex */
  sex?: InputMaybe<Scalars["String"]["input"]>;
  /** State */
  state?: InputMaybe<Scalars["String"]["input"]>;
  /** Suffix: Jr./Sr. */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** Zip code */
  zip?: InputMaybe<Scalars["String"]["input"]>;
};

/** Type of patient onboarding document (face sheet, onboarding paperwork, …). */
export enum PatientDocumentCategory {
  FaceSheet = "FACE_SHEET",
  Onboarding = "ONBOARDING",
  Other = "OTHER",
}

/** A single onboarding document to upload for a patient. */
export type PatientDocumentInput = {
  category: PatientDocumentCategory;
  /** The file (face sheet, intake paperwork, …). */
  file: Scalars["Upload"]["input"];
  /** Human-friendly label. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Existing patient document to add a new version to. Omit to create a new logical document. */
  patientDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** A patient onboarding document with its full version history. */
export type PatientDocumentResponse = {
  __typename?: "PatientDocumentResponse";
  category: PatientDocumentCategory;
  /** Presigned URL for the latest version. */
  currentUrl?: Maybe<Scalars["URL"]["output"]>;
  /** When the document was soft-deleted (only set for deleted documents). */
  deletedAt?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Username that soft-deleted the document. */
  deletedBy?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  locationId?: Maybe<Scalars["ID"]["output"]>;
  patientDocumentId: Scalars["ID"]["output"];
  patientId: Scalars["ID"]["output"];
  /** Username that first uploaded the document. */
  uploadedBy?: Maybe<Scalars["String"]["output"]>;
  /** Newest-first version history. */
  versions: Array<PatientDocumentVersionResponse>;
};

/** One stored version of a patient document, with a fetchable URL. */
export type PatientDocumentVersionResponse = {
  __typename?: "PatientDocumentVersionResponse";
  patientDocumentVersionId: Scalars["ID"]["output"];
  /** 1-based version number; newest is highest. */
  sequence: Scalars["Int"]["output"];
  uploadedAt: Scalars["GraphQLDateTime"]["output"];
  /** Username that uploaded this version. */
  uploadedBy?: Maybe<Scalars["String"]["output"]>;
  /** Version-scoped presigned download URL. */
  url: Scalars["URL"]["output"];
  /** MinIO object versionId. */
  versionId?: Maybe<Scalars["String"]["output"]>;
};

/** The uniquely identifying organization patient value. */
export type PatientExternalIdInput = {
  externalIdentifier: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
};

export type PatientFileInput = {
  file: Scalars["Upload"]["input"];
  fileCode: Scalars["String"]["input"];
};

export type PatientFileResponse = {
  __typename?: "PatientFileResponse";
  exists: Scalars["Boolean"]["output"];
  fileCode: Scalars["String"]["output"];
  mimetype: Scalars["String"]["output"];
  uploadedAt: Scalars["GraphQLDateTime"]["output"];
  url: Scalars["URL"]["output"];
};

/** A coverage classification grouping (group / plan / RX-BIN / …). */
export type PatientInsuranceClassInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  type: FhirCoverageClassType;
  value: Scalars["String"]["input"];
};

/** Insurance coverage to record for the patient at creation. */
export type PatientInsuranceInput = {
  classes?: InputMaybe<Array<PatientInsuranceClassInput>>;
  /** Coordination-of-benefits rank (1 = primary, 2 = secondary, …). Defaults to 1. */
  coverageOrder?: InputMaybe<Scalars["Int"]["input"]>;
  kind?: InputMaybe<FhirCoverageKind>;
  /** Sender-supplied payor identifier */
  payorExternalId?: InputMaybe<Scalars["String"]["input"]>;
  /** Insurer / payor name */
  payorName: Scalars["String"]["input"];
  /** Payor-specified plan type (PPO, HMO, …) */
  planType?: InputMaybe<Scalars["String"]["input"]>;
  /** Policy / member ID */
  policyNumber: Scalars["String"]["input"];
  status?: InputMaybe<FhirCoverageStatus>;
  subscriberDob?: InputMaybe<Scalars["DateTime"]["input"]>;
  subscriberFirstName?: InputMaybe<Scalars["String"]["input"]>;
  subscriberLastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Subscriber relationship to patient (Self, Spouse, Child, …) */
  subscriberRelationshipToPatient?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatientMedicationUpdateInput = {
  medication?: InputMaybe<MedicationUpdateInput>;
  usage?: InputMaybe<MedicationUsageUpdateInput>;
};

/** The uniquely identifying organization patient value. */
export type PatientRegisterExternalIdInput = {
  externalIdentifier: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
};

/** The uniquely identifying registration method. (Must provide email OR phone #) */
export type PatientRegisterMethodInput = {
  method: IdentityRegistrationMethods;
  value: Scalars["String"]["input"];
};

export type PatientSelfServiceCart = {
  __typename?: "PatientSelfServiceCart";
  booking_requests?: Maybe<Array<WebCartBookingRequests>>;
  cart_holder: Scalars["String"]["output"];
  expiresAt?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Indicates if all cart items are resolved and ready for checkout */
  isCheckoutReady: Scalars["Boolean"]["output"];
  items: Array<PatientSelfServiceCartItems>;
  metadata: PatientSelfServiceCartMetadata;
  status: WebCartStatus;
  summary?: Maybe<WebCartSummaries>;
  type: CommerceStoreType;
};

export type PatientSelfServiceCartItemDeleteInput = {
  itemId: Scalars["ID"]["input"];
};

export type PatientSelfServiceCartItemInput = {
  /** Additional metadata for storing supplementary item information */
  metadata?: InputMaybe<Scalars["JSONObject"]["input"]>;
  /** Price book entry ID - when provided with storeCode, creates a fully resolved item */
  priceBookEntryId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Product ID - required to identify the product being added */
  productId: Scalars["ID"]["input"];
  /** Quantity of items */
  quantity?: Scalars["Float"]["input"];
  /** Reference to the time slot requested for booking */
  requestedSlotId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Store code - when provided with priceBookEntryId, creates a fully resolved item */
  storeCode?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PatientSelfServiceCartItemUpdateInput = {
  /** The cart item ID to update */
  itemId: Scalars["ID"]["input"];
  metadata?: InputMaybe<Scalars["JSONObject"]["input"]>;
  /** Price book entry ID to resolve */
  priceBookEntryId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Product ID to resolve */
  productId?: InputMaybe<Scalars["ID"]["input"]>;
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  requestedSlotId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Store code to resolve */
  storeCode?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PatientSelfServiceCartItems = {
  __typename?: "PatientSelfServiceCartItems";
  cart_id: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  /** Indicates if the item has all required information for checkout */
  isResolved: Scalars["Boolean"]["output"];
  metadata?: Maybe<Scalars["JSONObject"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<Scalars["USCurrency"]["output"]>;
  priceBookEntryId?: Maybe<Scalars["ID"]["output"]>;
  product?: Maybe<Products>;
  productCode?: Maybe<Scalars["String"]["output"]>;
  product_id?: Maybe<Scalars["ID"]["output"]>;
  quantity: Scalars["Float"]["output"];
  store?: Maybe<WebStores>;
  store_id?: Maybe<Scalars["ID"]["output"]>;
  tax?: Maybe<Scalars["USCurrency"]["output"]>;
  thumbnail?: Maybe<WebCartItemThumbNails>;
};

export type PatientSelfServiceCartMetadata = {
  __typename?: "PatientSelfServiceCartMetadata";
  /** Cart mode indicator */
  cart_mode: Scalars["String"]["output"];
  ttl?: Maybe<Scalars["Float"]["output"]>;
  /** Number of unresolved items in the cart */
  unresolved_items_count: Scalars["Float"]["output"];
};

export type PatientSelfServiceCartValidationResult = {
  __typename?: "PatientSelfServiceCartValidationResult";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  isValid: Scalars["Boolean"]["output"];
  unresolvedItems?: Maybe<Array<PatientSelfServiceCartItems>>;
};

export type PatientTest = {
  __typename?: "PatientTest";
  AccessionID: Scalars["Float"]["output"];
  AltPatID?: Maybe<Scalars["Float"]["output"]>;
  BillType?: Maybe<Scalars["String"]["output"]>;
  CollectedBy?: Maybe<Scalars["String"]["output"]>;
  CollectionDate: Scalars["String"]["output"];
  Comment?: Maybe<Scalars["String"]["output"]>;
  CreateDate: Scalars["String"]["output"];
  DetectedSamples?: Maybe<Array<PatientTestSample>>;
  DiagnosticInsCodes: Scalars["String"]["output"];
  DocumentStatusNotes?: Maybe<Scalars["String"]["output"]>;
  DocumentStorageID?: Maybe<Scalars["String"]["output"]>;
  FacilityID: Scalars["String"]["output"];
  Fasting: Scalars["String"]["output"];
  FinalDate?: Maybe<Scalars["String"]["output"]>;
  FinalPathName?: Maybe<Scalars["String"]["output"]>;
  OrderComment?: Maybe<Scalars["String"]["output"]>;
  Panel: Scalars["String"]["output"];
  PatID: Scalars["String"]["output"];
  PatientMeds?: Maybe<Scalars["String"]["output"]>;
  PatientTestID: Scalars["String"]["output"];
  PhysicianID?: Maybe<Scalars["String"]["output"]>;
  RecvDate?: Maybe<Scalars["String"]["output"]>;
  ResultsComment?: Maybe<Scalars["String"]["output"]>;
  ServiceDate: Scalars["String"]["output"];
  SpecimenRcvd: Scalars["String"]["output"];
  SpecimenSource: Scalars["String"]["output"];
  SpecimenStatus: Scalars["String"]["output"];
  Status: Scalars["String"]["output"];
  TestPanel: Scalars["String"]["output"];
  TestType: Scalars["String"]["output"];
  Urgency: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  demographics?: Maybe<Demographics>;
  practitioner?: Maybe<Practitioners>;
  user: Users;
};

export type PatientTestDetectedSamplesArgs = {
  MapType?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatientTestSample = {
  __typename?: "PatientTestSample";
  AbbrevName: Scalars["String"]["output"];
  AccessionID: Scalars["Float"]["output"];
  BacterialLoad?: Maybe<Scalars["String"]["output"]>;
  CT: Scalars["Float"]["output"];
  CTCutoff: Scalars["Float"]["output"];
  CollectionDate?: Maybe<Scalars["String"]["output"]>;
  Comment?: Maybe<Scalars["String"]["output"]>;
  EnzymeFunction?: Maybe<Scalars["String"]["output"]>;
  Flag?: Maybe<Scalars["String"]["output"]>;
  GenoType?: Maybe<Scalars["String"]["output"]>;
  MapType?: Maybe<Scalars["String"]["output"]>;
  PTOrder?: Maybe<Scalars["Float"]["output"]>;
  PanelCode: Scalars["String"]["output"];
  PanelTestSample: Scalars["String"]["output"];
  PatientTestID: Scalars["String"]["output"];
  PatientTestSampleID: Scalars["Float"]["output"];
  PhenoType?: Maybe<Scalars["String"]["output"]>;
  PrevResult?: Maybe<Scalars["String"]["output"]>;
  PrevResultDt?: Maybe<Scalars["String"]["output"]>;
  RefRange?: Maybe<Scalars["String"]["output"]>;
  Results: Scalars["String"]["output"];
  ResultsDate?: Maybe<Scalars["String"]["output"]>;
  Status: Scalars["String"]["output"];
  UOM?: Maybe<Scalars["String"]["output"]>;
  partOf?: Maybe<PatientTest>;
};

export type PatientVitals = {
  __typename?: "PatientVitals";
  blood_pressure?: Maybe<Ratio>;
  blood_type?: Maybe<BloodTypes>;
  bmi?: Maybe<Quantity>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  glucose?: Maybe<Quantity>;
  heart_rate?: Maybe<Scalars["Float"]["output"]>;
  heart_rhythm?: Maybe<HeartyRhythms>;
  height?: Maybe<Quantity>;
  indwelling_catheter: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  patient: Patients;
  patient_id: Scalars["String"]["output"];
  temperature?: Maybe<Quantity>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  weight?: Maybe<Quantity>;
};

export type Patients = {
  __typename?: "Patients";
  appointments?: Maybe<Array<Appointments>>;
  booking_confirmations: Array<BookingConfirmations>;
  changes?: Maybe<Array<PatientChanges>>;
  conditions?: Maybe<Array<Conditions>>;
  /** Insurance coverages on file for this patient */
  coverages?: Maybe<Array<Coverages>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  current_location?: Maybe<Locations>;
  current_location_id?: Maybe<Scalars["String"]["output"]>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  dependents?: Maybe<Array<Patients>>;
  encounters?: Maybe<Array<Encounters>>;
  episodes_of_care?: Maybe<Array<EpisodeOfCare>>;
  is_archived: Scalars["Boolean"]["output"];
  locations?: Maybe<Array<Locations>>;
  medications?: Maybe<Array<MedicationUsages>>;
  notes?: Maybe<Array<ClinicalNotes>>;
  orders?: Maybe<Array<Orders>>;
  patient_id: Scalars["String"]["output"];
  primary_provider?: Maybe<Practitioners>;
  primary_provider_id?: Maybe<Scalars["String"]["output"]>;
  questionnaire_responses?: Maybe<Array<QuestionnaireResponses>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
  vitals?: Maybe<PatientVitals>;
};

/** Category of a merchant AP sub-ledger entry */
export enum PayableLedgerCategory {
  Adjustment = "ADJUSTMENT",
  Payout = "PAYOUT",
  PayoutReversal = "PAYOUT_REVERSAL",
  Transfer = "TRANSFER",
  TransferReversal = "TRANSFER_REVERSAL",
}

export type PayableLedgerEntries = {
  __typename?: "PayableLedgerEntries";
  /** Entry amount (always positive) */
  amount: Scalars["USCurrency"]["output"];
  category: PayableLedgerCategory;
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** When the economic event occurred (vs. when recorded) */
  effective_date: Scalars["DateTime"]["output"];
  entry_id: Scalars["ID"]["output"];
  /** Auto-assigned payable ledger entry number */
  entry_number: Scalars["String"]["output"];
  event?: Maybe<GatewayWebhookEvents>;
  external_reference_id?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  merchant: MerchantAccounts;
  /** Pending payout balance after this entry */
  running_balance: Scalars["USCurrency"]["output"];
  source?: Maybe<PayableLedgerSourceUnion>;
  source_type?: Maybe<PayableLedgerSourceType>;
  type: LedgerEntryType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Source discriminator for a merchant sub-ledger entry */
export enum PayableLedgerSourceType {
  Payout = "PAYOUT",
  Transfer = "TRANSFER",
}

export type PayableLedgerSourceUnion = PaymentTransfers | Payouts;

/** List of payment allocation types */
export enum PaymentAllocationInstanceType {
  Applied = "APPLIED",
  Unapplied = "UNAPPLIED",
}

export type PaymentAllocations = {
  __typename?: "PaymentAllocations";
  /** Date the payment allocation was applied or unapplied to invoice */
  allocation_date?: Maybe<Scalars["DateTime"]["output"]>;
  amount: Scalars["USCurrency"]["output"];
  /** Additional comment about the payment allocation */
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  invoice: Invoices;
  is_archived: Scalars["Boolean"]["output"];
  /** Reference to the payment record being used to allocate funds from */
  payment: Payments;
  /** Indicates whether this payment allocation is applied or unapplied to invoice */
  type: PaymentAllocationInstanceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentAuthorizationBalances = {
  __typename?: "PaymentAuthorizationBalances";
  /** Authorized amount */
  amount: Scalars["USCurrency"]["output"];
  authorization_id: Scalars["ID"]["output"];
  /** Remaining capturable balance */
  balance: Scalars["USCurrency"]["output"];
  /** Sum of PROCESSED child payments */
  captured_amount: Scalars["USCurrency"]["output"];
  /** Reversed amount (maintained column pass-through) */
  reversal_amount?: Maybe<Scalars["USCurrency"]["output"]>;
};

/** List of possible payment authorization status codes */
export enum PaymentAuthorizationStatusCodes {
  /** Authorization successful and funds may be captured */
  Authorized = "AUTHORIZED",
  /** Payment has been cancelled, and no longer capturable */
  Cancelled = "CANCELLED",
  /** Authorization draft, unable to be acted upon and may be edited/modified */
  Draft = "DRAFT",
  /** Authorization failed */
  Failed = "FAILED",
  /** Payment authorization is awaiting response from gateway */
  Pending = "PENDING",
}

export type PaymentAuthorizations = {
  __typename?: "PaymentAuthorizations";
  /** Customer account */
  account: BillingAccounts;
  /** Amount authorized from payment event */
  amount: Scalars["USCurrency"]["output"];
  /** Auto-assigned payment authorization number */
  authorization_number: Scalars["String"]["output"];
  /** Derived captured amount and remaining balance (computed on read) */
  balances?: Maybe<PaymentAuthorizationBalances>;
  comments?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  events?: Maybe<Array<PaymentGatewayEvents>>;
  /** Date the authorization expires and can no longer be used to capture/reverse payments */
  expires_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** The payment gateway responsible for processing the authorization */
  gateway: PaymentGateways;
  /** Payment gateway result code */
  gateway_result_code?: Maybe<Scalars["String"]["output"]>;
  /** Reason for the gateway result */
  gateway_result_reason?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<PaymentGroups>;
  is_archived: Scalars["Boolean"]["output"];
  /** Payment method used during this authorization */
  payment_method?: Maybe<PaymentMethods>;
  payment_splits?: Maybe<PaymentSplits>;
  payment_summary?: Maybe<OrderPaymentSummaries>;
  /** Captures/reversals made on this payment authorization */
  payments?: Maybe<Array<Payments>>;
  /** Payment authorization result code */
  result_code?: Maybe<PaymentGatewayResultCodes>;
  /** Sum of all processed authorization reversals made against the payment authorization */
  reversal_amount?: Maybe<Scalars["USCurrency"]["output"]>;
  status: PaymentAuthorizationStatusCodes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentBalances = {
  __typename?: "PaymentBalances";
  /** Original payment amount */
  amount: Scalars["USCurrency"]["output"];
  /** Remaining spendable balance */
  balance: Scalars["USCurrency"]["output"];
  /** Net amount allocated to invoices */
  net_applied: Scalars["USCurrency"]["output"];
  /** Net amount refunded */
  net_refund_applied: Scalars["USCurrency"]["output"];
  payment_id: Scalars["ID"]["output"];
  /** Sum of APPLIED allocations */
  total_applied: Scalars["USCurrency"]["output"];
  /** Sum of APPLIED refund lines */
  total_refund_applied: Scalars["USCurrency"]["output"];
  /** Sum of UNAPPLIED refund lines */
  total_refund_unapplied: Scalars["USCurrency"]["output"];
  /** Sum of UNAPPLIED allocations */
  total_unapplied: Scalars["USCurrency"]["output"];
};

/** Payment gateway components status codes */
export enum PaymentGatewayComponentStatus {
  Disabled = "DISABLED",
  Enabled = "ENABLED",
}

export type PaymentGatewayCreateInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** If true, gateway will go into sandbox (test) mode */
  enableSandboxMode?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Identifier of the external payment gateway */
  externalGatewayReferenceId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The payment gateway provider handling payment processing */
  gatewayProcessor: PaymentGatewayProcessorType;
  /** Indicates if this gateway should be used by default */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Credentials used to authenticate merchant to payment gateway system */
  merchantCredentials?: InputMaybe<MerchantCredentialInput>;
  merchantId: Scalars["ID"]["input"];
  /** User defined name for this gateway */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type PaymentGatewayEventSubject = PaymentAuthorizations | Payments | Refunds;

export type PaymentGatewayEvents = {
  __typename?: "PaymentGatewayEvents";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  event_id: Scalars["ID"]["output"];
  gateway: PaymentGateways;
  /** Authorization code given by gateway */
  gateway_authorization_code?: Maybe<Scalars["String"]["output"]>;
  gateway_avs_code?: Maybe<Scalars["String"]["output"]>;
  /** Message from gateway */
  gateway_message?: Maybe<Scalars["String"]["output"]>;
  /** Gateway specific result code */
  gateway_result_code?: Maybe<Scalars["String"]["output"]>;
  /** Reason for the gateway result */
  gateway_result_reason?: Maybe<Scalars["String"]["output"]>;
  /** Transaction ID created by the gateway system */
  gateway_transaction_id?: Maybe<Scalars["ID"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Coded outcome result */
  outcome: PaymentGatewayOperationOutcome;
  result_code?: Maybe<PaymentGatewayResultCodes>;
  /** Record which is the subject of the gateway operation */
  subject?: Maybe<PaymentGatewayEventSubject>;
  /** Type of operation performed by gateway */
  type: PaymentGatewayOperationType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentGatewayFeeSchedules = {
  __typename?: "PaymentGatewayFeeSchedules";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Currency the fixed fee is denominated in */
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** When this pricing took effect */
  effective_from: Scalars["DateTime"]["output"];
  effective_to?: Maybe<Scalars["DateTime"]["output"]>;
  /** Flat amount the processor adds per transaction */
  fixed_fee: Scalars["USCurrency"]["output"];
  gateway_id: Scalars["ID"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Processor cut as a fraction of the amount charged, e.g. 0.029 for 2.9% */
  percentage_rate: Scalars["Float"]["output"];
  schedule_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Payment gateway operation codes */
export enum PaymentGatewayOperationOutcome {
  Failed = "FAILED",
  Initiated = "INITIATED",
  Noop = "NOOP",
  Success = "SUCCESS",
  Timeout = "TIMEOUT",
}

/** Payment gateway operation type codes */
export enum PaymentGatewayOperationType {
  Authorization = "AUTHORIZATION",
  AuthorizationReversal = "AUTHORIZATION_REVERSAL",
  Avs = "AVS",
  Balance = "BALANCE",
  Capture = "CAPTURE",
  PostAuthorization = "POST_AUTHORIZATION",
  Refund = "REFUND",
  Sale = "SALE",
  Token = "TOKEN",
  Transfer = "TRANSFER",
  TransferReversal = "TRANSFER_REVERSAL",
  Void = "VOID",
}

export type PaymentGatewayPaginatedResults = {
  __typename?: "PaymentGatewayPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<PaymentGateways>;
  totalPages: Scalars["Float"]["output"];
};

/** Payment gateway provider options */
export enum PaymentGatewayProcessorType {
  Authnet = "AUTHNET",
  Paypal = "PAYPAL",
  Stripe = "STRIPE",
}

export type PaymentGatewayProviders = {
  __typename?: "PaymentGatewayProviders";
  /** Additional comments about the gateway provider */
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  gateways?: Maybe<Array<PaymentGateways>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly name */
  label: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Mapped result code from gateway to cynergy billing service */
export enum PaymentGatewayResultCodes {
  AuthenticationError = "AUTHENTICATION_ERROR",
  Declined = "DECLINED",
  Failed = "FAILED",
  NeedsReview = "NEEDS_REVIEW",
  NoResponse = "NO_RESPONSE",
  PermissionError = "PERMISSION_ERROR",
  Success = "SUCCESS",
  SystemError = "SYSTEM_ERROR",
  ValidationError = "VALIDATION_ERROR",
}

/** Payment gateway status codes */
export enum PaymentGatewayStatus {
  /** Merchant account enabled and can accept payments */
  Active = "ACTIVE",
  /** Gateway can accept payments and handle payouts, but the payment provider may require more information later */
  Enabled = "ENABLED",
  Inactive = "INACTIVE",
  /** Connection and operational verification pending */
  Pending = "PENDING",
  /** Merchant account rejected by gateway provider */
  Rejected = "REJECTED",
  /** Restricted account capabilities. This happens when payment status, payout status or both are disabled */
  Restricted = "RESTRICTED",
}

export type PaymentGatewayUpdateInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** If true, gateway will go into sandbox (test) mode */
  enableSandboxMode?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Identifier of the external payment gateway */
  externalGatewayReferenceId?: InputMaybe<Scalars["ID"]["input"]>;
  gatewayId: Scalars["ID"]["input"];
  /** Indicates if this gateway should be used by default */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Credentials used to authenticate merchant to payment gateway system */
  merchantCredentials?: InputMaybe<MerchantCredentialActionInput>;
  /** User defined name for this gateway */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type PaymentGateways = {
  __typename?: "PaymentGateways";
  /** Payment authorizations created using this gateway */
  authorizations?: Maybe<Array<PaymentAuthorizations>>;
  /** Additional comments about gateway */
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  events?: Maybe<Array<PaymentGatewayEvents>>;
  fee_schedule?: Maybe<PaymentGatewayFeeSchedules>;
  gateway_id: Scalars["ID"]["output"];
  /** Name of payment processor */
  gateway_processor: PaymentGatewayProcessorType;
  /** Payment intents created using this gateway */
  intents?: Maybe<Array<PaymentIntents>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Indicates if this gateway should be used by default */
  is_default: Scalars["Boolean"]["output"];
  /** Merchant account used by gateway */
  merchant: MerchantAccounts;
  /** Gateways operational mode. */
  mode: OperationalModeCodes;
  /** User defined name for this gateway */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Gateway active and can accept payments */
  payment_status: PaymentGatewayComponentStatus;
  /** Payments created using this gateway */
  payments?: Maybe<Array<Payments>>;
  /** Money may be transferred from gateway provider to merchants linked bank account. */
  payout_status: PaymentGatewayComponentStatus;
  /** Reference to the provider that handles transactions between the merchant account and application */
  provider?: Maybe<PaymentGatewayProviders>;
  /** Indicates the gateways overall working status */
  status: PaymentGatewayStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentGroupCreateInput = {
  /** Subject of payment group */
  subject: PaymentGroupSubjectInput;
};

export type PaymentGroupSubjectInput = {
  invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PaymentGroupSubjectUnion = Invoices | Orders;

export type PaymentGroups = {
  __typename?: "PaymentGroups";
  authorizations?: Maybe<Array<PaymentAuthorizations>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  group_number: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  order_id?: Maybe<Scalars["ID"]["output"]>;
  payment_splits?: Maybe<PaymentSplits>;
  payments?: Maybe<Array<Payments>>;
  /** Order or Invoice the set of payments are the subject of */
  subject: PaymentGroupSubjectUnion;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentInitiationSources = {
  __typename?: "PaymentInitiationSources";
  /** Billing account of buyer */
  account: BillingAccounts;
  appointment_id?: Maybe<Scalars["ID"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  order_id?: Maybe<Scalars["ID"]["output"]>;
  payment_intents: Array<PaymentIntents>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  web_cart_id?: Maybe<Scalars["String"]["output"]>;
  web_store_id?: Maybe<Scalars["String"]["output"]>;
};

/** List of payment instance types */
export enum PaymentInstanceType {
  Capture = "CAPTURE",
  Sale = "SALE",
}

/** List of payment intent status codes */
export enum PaymentIntentStatusCodes {
  Authorized = "AUTHORIZED",
  Canceled = "CANCELED",
  Created = "CREATED",
  Expired = "EXPIRED",
  Failed = "FAILED",
  PartialCapture = "PARTIAL_CAPTURE",
  PartialRefund = "PARTIAL_REFUND",
  Pending = "PENDING",
  Refunded = "REFUNDED",
  Succeeded = "SUCCEEDED",
}

export type PaymentIntents = {
  __typename?: "PaymentIntents";
  /** Total amount the merchant is expected to receive from buyer */
  amount?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Payment amount collectible by merchant upon order fulfillment */
  amount_capturable?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Amount that merchant can refund */
  amount_refundable?: Maybe<Scalars["USCurrency"]["output"]>;
  authorizations?: Maybe<Array<PaymentAuthorizations>>;
  /** Amount authorized by customers bank */
  authorized_amount?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Amount that the merchant successfully secured from a buyer. */
  captured_amount?: Maybe<Scalars["USCurrency"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Gateway that processed the payment */
  gateway: PaymentGateways;
  /** Assigned payment intent number */
  intent_number: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Indicates payment has been made to merchant */
  is_captured: Scalars["Boolean"]["output"];
  /** Merchant account this payment intent is associated with. */
  merchant: MerchantAccounts;
  payment_initiation_source: PaymentInitiationSources;
  /** Reference to the payment method used */
  payment_method?: Maybe<PaymentMethods>;
  /** Payment method used */
  payment_method_type?: Maybe<PaymentMethodTypeCodes>;
  /** Payment purpose */
  payment_purpose_type: PaymentPurpose;
  /** Associated payments made from intent */
  payments?: Maybe<Array<Payments>>;
  refunded_amount?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Amount canceled before completing the transfer of funds from a buyer to a merchant */
  reversal_amount?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Status of payment */
  status?: Maybe<PaymentIntentStatusCodes>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentMetadata = {
  __typename?: "PaymentMetadata";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** List of payment methods */
export enum PaymentMethodTypeCodes {
  Ach = "ACH",
  BankAccount = "BankAccount",
  Cash = "Cash",
  Check = "Check",
  CreditCard = "CreditCard",
  DebitCard = "DebitCard",
  DigitalWallet = "DigitalWallet",
}

export type PaymentMethods = {
  __typename?: "PaymentMethods";
  /** Reference to the user account linked to payment method */
  account: BillingAccounts;
  /** Can this payment method be used for autopay? */
  autopay_enabled: Scalars["Boolean"]["output"];
  /** Billing address of payment method */
  billing_address?: Maybe<Addresses>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  method_id: Scalars["ID"]["output"];
  saved_method?: Maybe<SavedPaymentMethods>;
  /** Type of payment method used */
  type: PaymentMethodTypeCodes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentProfileChanges = {
  __typename?: "PaymentProfileChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  profile: PaymentProfiles;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentProfiles = {
  __typename?: "PaymentProfiles";
  authnet_payment_profile_id?: Maybe<Scalars["String"]["output"]>;
  billing_address: Scalars["String"]["output"];
  card_type: Scalars["String"]["output"];
  changes: Array<PaymentProfileChanges>;
  city: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  expiration: Scalars["String"]["output"];
  first_name: Scalars["String"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  is_default: Scalars["Boolean"]["output"];
  last_four_of_card: Scalars["String"]["output"];
  last_name: Scalars["String"]["output"];
  profile_id: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
  zip: Scalars["String"]["output"];
};

/** List of payment purpose codes */
export enum PaymentPurpose {
  AppointmentBooking = "APPOINTMENT_BOOKING",
  MedicalService = "MEDICAL_SERVICE",
}

export type PaymentResultsUnion = PaymentProfiles | Transactions;

export type PaymentSplitSourceUnion = PaymentAuthorizations | Payments;

export type PaymentSplitStores = {
  __typename?: "PaymentSplitStores";
  /** This store's share of the split, in dollars */
  amount: Scalars["USCurrency"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  split: PaymentSplits;
  split_store_id: Scalars["ID"]["output"];
  store_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentSplits = {
  __typename?: "PaymentSplits";
  /** Planned transfer amount for this merchant */
  amount: Scalars["USCurrency"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  group: PaymentGroups;
  is_archived: Scalars["Boolean"]["output"];
  /** Destination merchant account */
  merchant_account: MerchantAccounts;
  source?: Maybe<PaymentSplitSourceUnion>;
  split_id: Scalars["ID"]["output"];
  /** Each contributing webstore's share of this split */
  stores: Array<PaymentSplitStores>;
  /** The executed transfer, once settled */
  transfer?: Maybe<PaymentTransfers>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** List of payment status codes */
export enum PaymentStatusCodes {
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
  Failed = "FAILED",
  Processed = "PROCESSED",
}

export type PaymentTermCreateInput = {
  /** Type of store this term may be used with. */
  appliesTo?: InputMaybe<CommerceStoreType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates if this should be the default payment term used on orders/invoices */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  period: DurationCreateInput;
  status?: InputMaybe<PublicationStatus>;
};

export type PaymentTermDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  paymentTermId: Scalars["ID"]["input"];
};

export type PaymentTermUpdateInput = {
  /** Type of store this term may be used with. */
  appliesTo?: InputMaybe<CommerceStoreType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates if this should be the default payment term used on orders/invoices */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  paymentTermId: Scalars["ID"]["input"];
  period?: InputMaybe<DurationUpdateInput>;
  status?: InputMaybe<PublicationStatus>;
};

export type PaymentTerms = {
  __typename?: "PaymentTerms";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Textual description of payment term */
  description: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** User-defined name for payment term */
  name: Scalars["String"]["output"];
  organization_id: Scalars["ID"]["output"];
  status: PublicationStatus;
  term: Durations;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the term should apply to only B2B or B2C customers */
  usage_context?: Maybe<CommerceStoreType>;
};

export type PaymentToken = {
  token: Scalars["String"]["input"];
};

export type PaymentTransferReversals = {
  __typename?: "PaymentTransferReversals";
  /** Reversed amount (always positive) */
  amount: Scalars["USCurrency"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  event?: Maybe<GatewayWebhookEvents>;
  gateway_reversal_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  livemode: Scalars["Boolean"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  reversal_id: Scalars["ID"]["output"];
  /** The transfer this reversal applies to */
  transfer: PaymentTransfers;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentTransfers = {
  __typename?: "PaymentTransfers";
  /** Transfer amount (always positive) */
  amount: Scalars["USCurrency"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  event?: Maybe<GatewayWebhookEvents>;
  gateway_transfer_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  livemode: Scalars["Boolean"]["output"];
  /** Destination merchant account */
  merchant_account: MerchantAccounts;
  payment?: Maybe<Payments>;
  /** Reversals applied against this transfer (a transfer may reverse partially, several times) */
  reversals?: Maybe<Array<PaymentTransferReversals>>;
  /** The split plan this transfer fulfills */
  split?: Maybe<PaymentSplits>;
  status: TransferStatus;
  transfer_id: Scalars["ID"]["output"];
  /** Auto-assigned transfer number */
  transfer_number: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Payments = {
  __typename?: "Payments";
  /** Reference to customers account */
  account: BillingAccounts;
  /** Allocations made against this payment */
  allocations?: Maybe<Array<PaymentAllocations>>;
  /** Amount to be captured/debited */
  amount: Scalars["USCurrency"]["output"];
  /** The authorization related to payment */
  authorization: PaymentAuthorizations;
  /** Derived applied/refunded totals and remaining balance (computed on read) */
  balances?: Maybe<PaymentBalances>;
  /** Date the payment was cancelled */
  cancellation_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Reason the payment was cancelled */
  cancellation_reason?: Maybe<Scalars["String"]["output"]>;
  /** Payment cancellation result code */
  cancellation_result_code?: Maybe<PaymentGatewayResultCodes>;
  comments?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  events?: Maybe<Array<PaymentGatewayEvents>>;
  /** Gateway responsible for processing this payment. */
  gateway: PaymentGateways;
  /** Payment gateway result code */
  gateway_cancellation_result_code?: Maybe<Scalars["String"]["output"]>;
  /** Payment gateway result code */
  gateway_result_code?: Maybe<Scalars["String"]["output"]>;
  /** Reason for the gateway result */
  gateway_result_reason?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<PaymentGroups>;
  /** The payment intent related to this payment */
  intent?: Maybe<PaymentIntents>;
  is_archived: Scalars["Boolean"]["output"];
  /** Payment method used by customer */
  payment_method?: Maybe<PaymentMethods>;
  /** Auto-assigned payment number */
  payment_number: Scalars["String"]["output"];
  payment_summary?: Maybe<OrderPaymentSummaries>;
  /** Refunds associated with the payment */
  refunds?: Maybe<Array<Refunds>>;
  /** Payment result code */
  result_code?: Maybe<PaymentGatewayResultCodes>;
  status: PaymentStatusCodes;
  type: PaymentInstanceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Normalized, gateway-agnostic status of a payout */
export enum PayoutStatus {
  Canceled = "CANCELED",
  Failed = "FAILED",
  InTransit = "IN_TRANSIT",
  Paid = "PAID",
  Pending = "PENDING",
  Unknown = "UNKNOWN",
}

export type Payouts = {
  __typename?: "Payouts";
  /** Payout amount (always positive) */
  amount: Scalars["USCurrency"]["output"];
  /** Expected/actual bank arrival date */
  arrival_date: Scalars["DateTime"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  event?: Maybe<GatewayWebhookEvents>;
  gateway_payout_id: Scalars["String"]["output"];
  gateway_status: Scalars["String"]["output"];
  gateway_status_code?: Maybe<Scalars["String"]["output"]>;
  gateway_status_reason?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  livemode: Scalars["Boolean"]["output"];
  /** Merchant the payout was made to */
  merchant_account: MerchantAccounts;
  original_payout?: Maybe<Payouts>;
  payout_id: Scalars["ID"]["output"];
  reversed_by?: Maybe<Payouts>;
  status: PayoutStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PeriodCreateInput = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type PeriodUpsertInput = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  periodId?: InputMaybe<Scalars["ID"]["input"]>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Periods = {
  __typename?: "Periods";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  end?: Maybe<Scalars["DateTime"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  period_id: Scalars["String"]["output"];
  start?: Maybe<Scalars["DateTime"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PeriodsType = {
  __typename?: "PeriodsType";
  close: TimeSlotPeriodsType;
  open: TimeSlotPeriodsType;
};

/** All possible FHIR permitted data type codes */
export enum PermittedDataType {
  Boolean = "BOOLEAN",
  CodeableConcept = "CODEABLE_CONCEPT",
  Datetime = "DATETIME",
  Integer = "INTEGER",
  Period = "PERIOD",
  Quantity = "QUANTITY",
  Range = "RANGE",
  Ratio = "RATIO",
  SampledData = "SAMPLED_DATA",
  String = "STRING",
  Time = "TIME",
}

export type PlaceMatchedSubstringType = {
  __typename?: "PlaceMatchedSubstringType";
  length: Scalars["Float"]["output"];
  offset: Scalars["Float"]["output"];
};

export type PlaceTermType = {
  __typename?: "PlaceTermType";
  offset: Scalars["Float"]["output"];
  value: Scalars["String"]["output"];
};

export enum PlacesAutocompleteStatusCodes {
  InvalidRequest = "INVALID_REQUEST",
  Ok = "OK",
  OverQueryLimit = "OVER_QUERY_LIMIT",
  RequestDenied = "REQUEST_DENIED",
  UnknownError = "UNKNOWN_ERROR",
  ZeroResults = "ZERO_RESULTS",
}

export type PlanDefinitionActions = {
  __typename?: "PlanDefinitionActions";
  action_id: Scalars["String"]["output"];
  /** Indicates if action should be performed on an as-needed basis. (default: false) */
  as_needed: Scalars["Boolean"]["output"];
  cardinality_behavior?: Maybe<ActionCardinalityBehavior>;
  code: ActionCode;
  /** Whether or not the action is applicable */
  conditions?: Maybe<Array<PlanDefinitionConditions>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition?: Maybe<PlanDefinitionCanonicalResults>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  /** Identifies goals that this action supports. */
  goal?: Maybe<PlanDefinitionGoals>;
  grouping_behavior?: Maybe<ActionGroupingBehavior>;
  is_archived: Scalars["Boolean"]["output"];
  /** Unique id for the action in the PlanDefinition */
  link_id?: Maybe<Scalars["String"]["output"]>;
  location_id: Scalars["ID"]["output"];
  /** Who should participate in the action */
  participants: Array<PlanDefinitionParticipants>;
  plan: PlanDefinitions;
  precheck_behavior?: Maybe<ActionPrecheckBehavior>;
  /** User-visible prefix for the action (e.g. 1. or A.) */
  prefix?: Maybe<Scalars["String"]["output"]>;
  priority: RequestPriority;
  /** Why the action should be performed. */
  reason?: Maybe<ActionReasonCode>;
  related_actions?: Maybe<Array<PlanDefinitionRelatedActions>>;
  required_behavior?: Maybe<ActionRequiredBehavior>;
  selection_behavior?: Maybe<ActionSelectionBehavior>;
  /** Type of individual the action is focused on. */
  subject_type: ParticipantResourceType;
  /** Static text equivalent of the action, used if the dynamic aspects cannot be interpreted by the receiving system */
  text_equivalent?: Maybe<Scalars["String"]["output"]>;
  /** User-visible title */
  title: Scalars["String"]["output"];
  /** When the action should be triggered. */
  trigger: TriggerDefinitions;
  type: ActionType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PlanDefinitionActorInput = {
  /** How the actor fits into the overall actions of the plan definition. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The role the participant should play in performing the described action. */
  role: PractitionerRole;
  /** User-visible title. */
  title: Scalars["String"]["input"];
  /** Who or what can be this actor */
  type: ParticipantResourceType;
};

export type PlanDefinitionActors = {
  __typename?: "PlanDefinitionActors";
  actor_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** A description of how the actor fits into the overall actions of the plan definition. */
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The role the participant should play in performing the described action. */
  role: PractitionerRole;
  /** User-visible title */
  title: Scalars["String"]["output"];
  /** Who or what can be this actor */
  type: ParticipantResourceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PlanDefinitionCanonicalResults = ActivityDefinitions | ObservationDefinitions | PlanDefinitions | SpecimenDefinitions;

export type PlanDefinitionConditions = {
  __typename?: "PlanDefinitionConditions";
  condition_kind: ActionConditionKind;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Whether or not the action is applicable. */
  expressions: Expressions;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PlanDefinitionGoals = {
  __typename?: "PlanDefinitionGoals";
  /** What does the goal address */
  addresses: Scalars["String"]["output"];
  category: GoalCategory;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_goal_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  plan: PlanDefinitions;
  priority: GoalPriority;
  /** The event after which the goal should begin being pursued. */
  start?: Maybe<GoalStartEvent>;
  target: PlanDefinitionTargets;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PlanDefinitionParticipants = {
  __typename?: "PlanDefinitionParticipants";
  action: PlanDefinitionActions;
  actor: PlanDefinitionActors;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  function: ActionParticipantFunction;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PlanDefinitionRelatedActionOffsetResults = Quantity | Range;

export type PlanDefinitionRelatedActions = {
  __typename?: "PlanDefinitionRelatedActions";
  action: PlanDefinitionActions;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  end_relationship: ActionRelationshipType;
  is_archived: Scalars["Boolean"]["output"];
  offset: PlanDefinitionRelatedActionOffsetResults;
  relationship: ActionRelationshipType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PlanDefinitionTargets = {
  __typename?: "PlanDefinitionTargets";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_goal_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  detail_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  detail_integer?: Maybe<Scalars["Float"]["output"]>;
  detail_quantity?: Maybe<Quantity>;
  detail_range?: Maybe<Range>;
  detail_ratio?: Maybe<Ratio>;
  detail_string?: Maybe<Scalars["String"]["output"]>;
  due?: Maybe<Scalars["DateTime"]["output"]>;
  goal: PlanDefinitionGoals;
  is_archived: Scalars["Boolean"]["output"];
  /** The parameter whose value is to be tracked */
  measure: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR plan definition type codes. */
export enum PlanDefinitionType {
  /** Defines a desired/typical sequence of clinical activities including preconditions, triggers and temporal relationships. */
  ClinicalProtocol = "CLINICAL_PROTOCOL",
  /** A decision support rule of the form [on Event] if Condition then Action. It is intended to be a shareable, computable definition of actions that should be taken whenever some condition is met in response to a particular event or events. */
  EcaRule = "ECA_RULE",
  /** A pre-defined and approved group of orders related to a particular clinical condition (e.g. hypertension treatment and monitoring) or stage of care (e.g. hospital admission to Coronary Care Unit). An order set is used as a checklist for the clinician when managing a patient with a specific condition. It is a structured collection of orders relevant to that condition and presented to the clinician in a computerized provider order entry (CPOE) system. */
  OrderSet = "ORDER_SET",
  /** Defines the steps for a group of one or more systems in an event flow process along with the step constraints, sequence, pre-conditions and decision points to complete a particular objective. */
  WorkflowDefinition = "WORKFLOW_DEFINITION",
}

export type PlanDefinitions = {
  __typename?: "PlanDefinitions";
  /** Action defined by the plan. */
  actions: Array<PlanDefinitionActions>;
  /** Actors represent the individuals or groups involved in the execution of the defined set of activities. */
  actors: Array<PlanDefinitionActors>;
  approval_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Use and/or publishing restrictions */
  copyright?: Maybe<Scalars["String"]["output"]>;
  /** Copyright holder and year(s) */
  copyright_label?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Natural language description of the plan definition */
  description: Scalars["String"]["output"];
  /** When the plan definition is expected to be used */
  effective_period?: Maybe<Periods>;
  /** For testing purposes, not real usage. */
  experimental: Scalars["Boolean"]["output"];
  /** What the plan is trying to accomplish. */
  goals?: Maybe<Array<PlanDefinitionGoals>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Intended jurisdiction for plan definition (if applicable) */
  jurisdiction?: Maybe<Scalars["String"]["output"]>;
  last_reviewed?: Maybe<Scalars["DateTime"]["output"]>;
  /** Name for this plan definition (computer friendly) */
  name: Scalars["String"]["output"];
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["output"];
  publisher_contact?: Maybe<ContactDetails>;
  /** Why this plan definition is defined */
  purpose: Scalars["String"]["output"];
  status: PublicationStatus;
  /** Type of individual the plan definition is focused on. */
  subject_type: ParticipantResourceType;
  /** Subordinate title of the plan definition */
  subtitle?: Maybe<Scalars["String"]["output"]>;
  /** Name for this plan definition (human friendly) */
  title: Scalars["String"]["output"];
  topic: DefinitionTopic;
  type: PlanDefinitionType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  /** Describes the clinical usage of the plan */
  usage?: Maybe<Scalars["String"]["output"]>;
  /** Business version of the plan definition. */
  version: Scalars["String"]["output"];
};

export type PositionInput = {
  altitude?: InputMaybe<Scalars["Float"]["input"]>;
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

export type PractitionerContactCreateInput = {
  contacts: Array<PractitionerContactRequiredInput>;
  practitionerId: Scalars["String"]["input"];
};

export type PractitionerContactRequiredInput = {
  period?: InputMaybe<PeriodCreateInput>;
  /** Specify preferred order of use (1 = highest) */
  rank?: InputMaybe<Scalars["Float"]["input"]>;
  system: ContactPointSystem;
  use: ContactPointUse;
  value: Scalars["String"]["input"];
};

export type PractitionerDeleteInput = {
  practitionerId: Scalars["String"]["input"];
};

export type PractitionerLocationAffiliations = {
  __typename?: "PractitionerLocationAffiliations";
  affiliation_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  employee_assignment?: Maybe<StaffAssignments>;
  is_archived: Scalars["Boolean"]["output"];
  location_id: Scalars["String"]["output"];
  practitioner: Practitioners;
  practitioner_id: Scalars["String"]["output"];
  prescriptions?: Maybe<Array<MedicationUsages>>;
  /** Functional role of practitioner. (Ex. "Nurse", "Accessioner", "Prescriber") */
  role: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PractitionerPaginatedResponse = {
  __typename?: "PractitionerPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<UserResults>;
  totalPages: Scalars["Float"]["output"];
};

export type PractitionerPaginatedResults = {
  __typename?: "PractitionerPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Practitioners>;
  totalPages: Scalars["Float"]["output"];
};

export type PractitionerQualifications = {
  __typename?: "PractitionerQualifications";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  credential: DegreeLicenseCertificate;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  effective_period?: Maybe<Periods>;
  is_archived: Scalars["Boolean"]["output"];
  is_verified: Scalars["Boolean"]["output"];
  /** Name or title of the qualification. */
  label: Scalars["String"]["output"];
  /** License number (if applicable) */
  license?: Maybe<Scalars["String"]["output"]>;
  practitioner: Practitioners;
  practitioner_id: Scalars["String"]["output"];
  qualification_id: Scalars["String"]["output"];
  /** If applicable, a field to specify the medical specialty associated with the qualification (e.g., Cardiology, Pediatrics, Orthopedics, etc.) */
  speciality?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  verified_by?: Maybe<Scalars["String"]["output"]>;
  verified_on?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PractitionerRegisterInput = {
  /** List of initial locations this practitioner is affiliated with. */
  affiliatedLocations?: InputMaybe<Array<LocationAffiliationDetailsInput>>;
  applicationId: Scalars["String"]["input"];
  contacts?: InputMaybe<Array<PractitionerContactRequiredInput>>;
  /** Optional field to pass cynergyId from higher services. */
  cynergyId?: InputMaybe<Scalars["String"]["input"]>;
  method: AccountRegistrationMethodInput;
  npi: Scalars["Float"]["input"];
  /** Reference to the organization that initiated registration. */
  organizationId: Scalars["String"]["input"];
  role: ApplicationRoles;
};

/** All possible FHIR practitioner role codes. */
export enum PractitionerRole {
  ClinicalNurseSpecialist = "CLINICAL_NURSE_SPECIALIST",
  Dentist = "DENTIST",
  GeneralPractitioner = "GENERAL_PRACTITIONER",
  MedicalAssistant = "MEDICAL_ASSISTANT",
  NurseAnesthetist = "NURSE_ANESTHETIST",
  NursePractitioner = "NURSE_PRACTITIONER",
  NursingAssistant = "NURSING_ASSISTANT",
  /** A qualified/registered/licensed pharmacist */
  Pharmacist = "PHARMACIST",
  /** Medical Doctors (MD) and Doctors of Osteopathic Medicine (DO) are licensed physicians who have completed medical school and residency training. They have the broadest authority to prescribe medications for a wide range of medical conditions */
  Physician = "PHYSICIAN",
  PhysicianAssistant = "PHYSICIAN_ASSISTANT",
  Psychiatrist = "PSYCHIATRIST",
  RegisteredNurse = "REGISTERED_NURSE",
  Surgeon = "SURGEON",
}

export type PractitionerSignatureDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  practitionerId: Scalars["String"]["input"];
  /** Required reason for removing the signature; recorded in the audit trail. */
  reason: Scalars["String"]["input"];
};

export type PractitionerSignatures = {
  __typename?: "PractitionerSignatures";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The party represented */
  on_behalf_of?: Maybe<Organizations>;
  /** The technical format of the signature */
  signature_format: MimeTypes;
  signature_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** The URL pointer to the actual signature content (XML DigSig. JWS, picture, etc.) */
  url: Scalars["String"]["output"];
  /** When the signature was captured. */
  when: Scalars["GraphQLDateTime"]["output"];
  /** Who signed. */
  who: Practitioners;
};

export type Practitioners = {
  __typename?: "Practitioners";
  affiliation_date?: Maybe<Scalars["DateTime"]["output"]>;
  contacts?: Maybe<Array<ContactPoints>>;
  /** Represents practitioners relationship to current contextual session.locationId, providing insight into their active role and location specific details within that context. */
  contextual_affiliation?: Maybe<PractitionerLocationAffiliations>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  demographics?: Maybe<Demographics>;
  identity?: Maybe<CynergyUsers>;
  is_archived: Scalars["Boolean"]["output"];
  location_affiliations?: Maybe<Array<PractitionerLocationAffiliations>>;
  npi: Scalars["Float"]["output"];
  orders?: Maybe<Array<PatientTest>>;
  practitioner_id: Scalars["String"]["output"];
  /** If applicable, prefix of name (E.g. Dr) */
  prefix?: Maybe<Scalars["String"]["output"]>;
  prescriptions?: Maybe<Array<MedicationUsages>>;
  primary_care_population?: Maybe<Array<Patients>>;
  qualifications?: Maybe<Array<PractitionerQualifications>>;
  /** The organization responsible for registering practitioner to registry. */
  registration_authority_id: Scalars["String"]["output"];
  signature?: Maybe<PractitionerSignatures>;
  /** If applicable, suffix of name (E.g. III) */
  suffix?: Maybe<Scalars["String"]["output"]>;
  taxonomies: Array<Taxonomies>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PreferenceChanges = {
  __typename?: "PreferenceChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  preference_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PreferredTimeSlotsType = {
  __typename?: "PreferredTimeSlotsType";
  periods: Array<PeriodsType>;
  weekday_text: Array<Scalars["String"]["output"]>;
};

export type PrescriptionPaginatedResults = {
  __typename?: "PrescriptionPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<MedicationUsages>;
  totalPages: Scalars["Float"]["output"];
};

export type PriceBookAffiliations = {
  __typename?: "PriceBookAffiliations";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PriceBookCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodUpsertInput>;
  entries?: InputMaybe<Array<PriceBookEntryInput>>;
  /** Name of price book */
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PriceBookStatus>;
  /** Link pricebook to store */
  storeId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Standard or custom price book? Default is "Custom" */
  type?: InputMaybe<PriceBookType>;
};

export type PriceBookDeleteInput = {
  bookId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PriceBookEntries = {
  __typename?: "PriceBookEntries";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  entry_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  price_book: PriceBooks;
  /** The orderable product/service the entry applies to */
  product: Products;
  product_code: Scalars["String"]["output"];
  /** Unit price for entry */
  unit_price: Scalars["USCurrency"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type PriceBookEntryActionInput = {
  add?: InputMaybe<Array<PriceBookEntryInput>>;
  remove?: InputMaybe<Array<PriceBookEntryDeleteInput>>;
  update?: InputMaybe<PriceBookEntryUpdateInput>;
};

export type PriceBookEntryDeleteInput = {
  entryId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PriceBookEntryInput = {
  productId: Scalars["ID"]["input"];
  /** Product unit price for this entry */
  unitPrice?: InputMaybe<Scalars["USCurrency"]["input"]>;
  useStandardPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PriceBookEntryPaginatedResult = {
  __typename?: "PriceBookEntryPaginatedResult";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<PriceBookEntries>;
  totalPages: Scalars["Float"]["output"];
};

export type PriceBookEntryUpdateInput = {
  entryId: Scalars["ID"]["input"];
  /** Product unit price for this entry */
  unitPrice?: InputMaybe<Scalars["USCurrency"]["input"]>;
  useStandardPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PriceBookInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodUpsertInput>;
  entries?: InputMaybe<Array<PriceBookEntryInput>>;
  /** Name of price book */
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PriceBookStatus>;
  /** Link pricebook to store */
  storeId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Standard or custom price book? Default is "Custom" */
  type?: InputMaybe<PriceBookType>;
};

export type PriceBookLinkOrCreateInput = {
  book?: InputMaybe<PriceBookInput>;
  bookId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PriceBookPaginatedResults = {
  __typename?: "PriceBookPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<PriceBooks>;
  totalPages: Scalars["Float"]["output"];
};

/** List of Price book status codes */
export enum PriceBookStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
}

/** Price book type codes. */
export enum PriceBookType {
  Custom = "CUSTOM",
  Standard = "STANDARD",
}

export type PriceBookUpdateInput = {
  bookId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodUpsertInput>;
  entries?: InputMaybe<PriceBookEntryActionInput>;
  /** Name of price book */
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PriceBookStatus>;
  /** Standard or custom price book? Default is "Custom" */
  type?: InputMaybe<PriceBookType>;
};

export type PriceBooks = {
  __typename?: "PriceBooks";
  affiliates?: Maybe<Array<PriceBookAffiliations>>;
  book_id: Scalars["ID"]["output"];
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** Period in which this price book is effective */
  effective_period?: Maybe<Periods>;
  entries?: Maybe<Array<PriceBookEntries>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name for price book */
  name: Scalars["String"]["output"];
  /** Organization which owns this price book */
  owner: Organizations;
  status: PriceBookStatus;
  type: PriceBookType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR procedure category codes. */
export enum ProcedureCategories {
  Chiropractic = "CHIROPRACTIC",
  Counselling = "COUNSELLING",
  Diagnostic = "DIAGNOSTIC",
  Education = "EDUCATION",
  Psychiatry = "PSYCHIATRY",
  SocialService = "SOCIAL_SERVICE",
  Surgical = "SURGICAL",
}

/** All possible FHIR procedure codes. */
export enum ProcedureCodes {
  ExcisionOfLesion = "EXCISION_OF_LESION",
  Procedure = "PROCEDURE",
  RemovableApplianceTherapy = "REMOVABLE_APPLIANCE_THERAPY",
}

/** All possible FHIR procedure follow-up codes. */
export enum ProcedureFollowUps {
  CardiopulmonaryExerciseTest = "CARDIOPULMONARY_EXERCISE_TEST",
  ChangeOfDressing = "CHANGE_OF_DRESSING",
  Cytopathology = "CYTOPATHOLOGY",
  DiabetesMedicationReview = "DIABETES_MEDICATION_REVIEW",
  RemovalOfDrain = "REMOVAL_OF_DRAIN",
  RemovalOfLigature = "REMOVAL_OF_LIGATURE",
  RemovalOfStaples = "REMOVAL_OF_STAPLES",
  RemovalOfSuture = "REMOVAL_OF_SUTURE",
  ScarTissueMassage = "SCAR_TISSUE_MASSAGE",
  SuctionDrainage = "SUCTION_DRAINAGE",
}

/** All possible FHIR procedure outcome codes. */
export enum ProcedureOutcomes {
  PartiallySuccessful = "PARTIALLY_SUCCESSFUL",
  Successful = "SUCCESSFUL",
  Unsuccessful = "UNSUCCESSFUL",
}

export type Procedures = {
  __typename?: "Procedures";
  /** Target body sites */
  body_site?: Maybe<Scalars["String"]["output"]>;
  category: ProcedureCategories;
  code: ProcedureCodes;
  /** Complication (if any) following the procedure. */
  complication?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encounter: Encounters;
  follow_up?: Maybe<ProcedureFollowUps>;
  /** Instantiates external protocol or definition */
  instantiates_uri?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  notes?: Maybe<Scalars["String"]["output"]>;
  /** When the procedure occurred or is occurring */
  occurrence: Periods;
  outcome?: Maybe<ProcedureOutcomes>;
  procedure_id: Scalars["String"]["output"];
  /** The justification for procedure being performed. */
  reason: ConditionCodes;
  /** When the procedure was first captured in the subjects record */
  recorded: Scalars["DateTime"]["output"];
  /** Who recorded the procedure. */
  recorder: StaffAssignments;
  /** Minio report url path */
  report?: Maybe<Scalars["String"]["output"]>;
  /** Reported rather than primary record. */
  reported?: Maybe<Scalars["Boolean"]["output"]>;
  status: EventStatuses;
  status_reason?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ProcessResultResponse = {
  __typename?: "ProcessResultResponse";
  /** Lab order UUID */
  labOrderId?: Maybe<Scalars["String"]["output"]>;
  /** Whether the order is now complete */
  orderComplete?: Maybe<Scalars["Boolean"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
  /** Matched work item UUID */
  workItemId?: Maybe<Scalars["String"]["output"]>;
};

export type ProductAttributeActionInput = {
  add?: InputMaybe<Array<AttributeLinkOrCreateInput>>;
  remove?: InputMaybe<AttributeDeleteInput>;
  update?: InputMaybe<AttributeUpdateInput>;
};

export type ProductBulkDeleteInput = {
  products: Array<ProductDeleteInput>;
};

export type ProductCatalogCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodUpsertInput>;
  /** Catalog name */
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  status?: InputMaybe<ProductCatalogStatus>;
  type: CommerceProductFamily;
};

export type ProductCatalogDeleteInput = {
  catalogId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductCatalogInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodUpsertInput>;
  /** Catalog name */
  name: Scalars["String"]["input"];
  status?: InputMaybe<ProductCatalogStatus>;
  type: CommerceProductFamily;
};

export type ProductCatalogItemActionInput = {
  add?: InputMaybe<Array<ProductCatalogItemInput>>;
  remove?: InputMaybe<Array<ProductCatalogItemDeleteInput>>;
  update?: InputMaybe<ProductCatalogItemUpdateInput>;
};

export type ProductCatalogItemBulkCreateInput = {
  catalogId: Scalars["ID"]["input"];
  items: Array<ProductCatalogItemInput>;
};

export type ProductCatalogItemBulkDeleteInput = {
  catalogId: Scalars["ID"]["input"];
  items: Array<ProductCatalogItemDeleteInput>;
};

export type ProductCatalogItemDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  itemId: Scalars["ID"]["input"];
};

export type ProductCatalogItemInput = {
  category: ProductCategoryProductLinkOrCreateInput;
  /** Indicates if this is the products primary category */
  isPrimaryCategory?: InputMaybe<Scalars["Boolean"]["input"]>;
  productId: Scalars["ID"]["input"];
  status?: InputMaybe<ProductCatalogStatus>;
};

export type ProductCatalogItemPaginatedResults = {
  __typename?: "ProductCatalogItemPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<ProductCatalogItems>;
  totalPages: Scalars["Float"]["output"];
};

export type ProductCatalogItemUpdateInput = {
  /** Indicates if this is the products primary category */
  isPrimaryCategory?: InputMaybe<Scalars["Boolean"]["input"]>;
  itemId: Scalars["ID"]["input"];
  status?: InputMaybe<ProductCatalogStatus>;
};

export type ProductCatalogItems = {
  __typename?: "ProductCatalogItems";
  catalog: ProductCatalogs;
  category: ProductCategories;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  item_id: Scalars["ID"]["output"];
  /** Auto generated item number */
  item_number: Scalars["String"]["output"];
  product: Products;
  status: ProductCatalogStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ProductCatalogLinkOrCreateInput = {
  catalog?: InputMaybe<ProductCatalogInput>;
  catalogId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProductCatalogPaginatedResults = {
  __typename?: "ProductCatalogPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<ProductCatalogs>;
  totalPages: Scalars["Float"]["output"];
};

/** List of product catalog status codes */
export enum ProductCatalogStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
}

export type ProductCatalogUpdateInput = {
  catalogId: Scalars["ID"]["input"];
  categories?: InputMaybe<ProductCategoryActionInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  effectivePeriod?: InputMaybe<PeriodUpsertInput>;
  /** Catalog name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Catalog products */
  products?: InputMaybe<ProductCatalogItemActionInput>;
  status?: InputMaybe<ProductCatalogStatus>;
  type?: InputMaybe<CommerceProductFamily>;
};

export type ProductCatalogs = {
  __typename?: "ProductCatalogs";
  catalog_id: Scalars["ID"]["output"];
  categories?: Maybe<Array<ProductCategories>>;
  /** Catalog code */
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** Period for which this catalog is effective */
  effective_period?: Maybe<Periods>;
  is_archived: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  number_of_categories: Scalars["Float"]["output"];
  number_of_products: Scalars["Float"]["output"];
  /** Organization which owns this price book */
  owner: Organizations;
  products?: Maybe<Array<ProductCatalogItems>>;
  status: ProductCatalogStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ProductCategories = {
  __typename?: "ProductCategories";
  /** Catalog this category belongs to */
  catalog: ProductCatalogs;
  category_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition: WebStoreCategoryDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  number_of_products: Scalars["Float"]["output"];
  products?: Maybe<Array<ProductCatalogItems>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ProductCategoryActionInput = {
  add?: InputMaybe<Array<ProductCategoryInput>>;
  remove?: InputMaybe<Array<ProductCategoryDeleteInput>>;
};

export type ProductCategoryDeleteInput = {
  categoryId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductCategoryInput = {
  categoryDefinitionId: Scalars["ID"]["input"];
};

export type ProductCategoryProductLinkOrCreateInput = {
  category?: InputMaybe<ProductCategoryInput>;
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProductCreateInput = {
  /** Product attributes */
  attributes?: InputMaybe<Array<AttributeLinkOrCreateInput>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Category of product */
  family: CommerceProductFamily;
  /** Product image */
  image?: InputMaybe<AttachmentLinkOrCreateInput>;
  /** Product name */
  name: Scalars["String"]["input"];
  productServiceId: Scalars["ID"]["input"];
  publisher?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  /** Product tags */
  tags?: InputMaybe<Array<TagLinkOrCreateInput>>;
};

export type ProductDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  productId: Scalars["ID"]["input"];
};

export type ProductPaginatedResults = {
  __typename?: "ProductPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Products>;
  totalPages: Scalars["Float"]["output"];
};

export type ProductResults = DrugNdc | DrugProducts;

export type ProductTagActionInput = {
  add?: InputMaybe<Array<TagLinkOrCreateInput>>;
  remove?: InputMaybe<TagDeleteInput>;
  update?: InputMaybe<TagUpdateInput>;
};

export type ProductUpdateInput = {
  /** Product attributes */
  attributes?: InputMaybe<ProductAttributeActionInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Category of product */
  family?: InputMaybe<CommerceProductFamily>;
  /** Product image */
  image?: InputMaybe<AttachmentLinkOrCreateInput>;
  /** Product name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  productId: Scalars["ID"]["input"];
  publisher?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  /** Product tags */
  tags?: InputMaybe<ProductTagActionInput>;
};

export type Products = {
  __typename?: "Products";
  /** Properties that describe the product and provide users with information they can use to find, compare, and, make an informed purchase decision. */
  attributes?: Maybe<Array<Attributes>>;
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  family: CommerceProductFamily;
  /** Product image */
  image?: Maybe<Attachments>;
  isInCart?: Maybe<Scalars["Boolean"]["output"]>;
  isWishListed?: Maybe<Scalars["Boolean"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Product name */
  name: Scalars["String"]["output"];
  product_id: Scalars["ID"]["output"];
  /** Name of entity that published this record */
  publisher: Scalars["String"]["output"];
  resource: HealthcareServices;
  status: PublicationStatus;
  /** Product tags to improve searchability and categorization */
  tags?: Maybe<Array<Tags>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Organization offering the product */
  vendor: Organizations;
};

/** All possible FHIR provenance activity type codes */
export enum ProvenanceActivityType {
  /** Occurs when an agent makes any change to record entry content currently residing in storage considered permanent (persistent). */
  Amend = "AMEND",
  /** Occurs when an agent causes the system to scrub record entry content to reduce the association between a set of identifying data and the data subject in a way that might or might not be reversible. */
  Deidentify = "DEIDENTIFY",
  /** Occurs when an agent causes the system to combine or join content from two or more record entries, resulting in a single logical record entry. */
  Merge = "MERGE",
  /** Occurs when an agent causes the system to: a) initiate capture of potential record content, and b) incorporate that content into the storage considered a permanent part of the health record. */
  Originate = "ORIGINATE",
  /** Occurs when an agent causes the system to a) initiate capture of data content from elsewhere, and b) incorporate that content into the storage considered a permanent part of the health record. */
  Receive = "RECEIVE",
  /** Occurs when an agent causes the system to change the form, language or code system used to represent record entry content. */
  Transform = "TRANSFORM",
  /** Occurs when an agent causes the system to confirm compliance of data or data objects with regulations, requirements, specifications, or other imposed conditions based on organizational policy. */
  Verify = "VERIFY",
}

export type ProvenanceAgentUnionType = Organizations | Patients | StaffAssignments;

export type ProvenanceAgents = {
  __typename?: "ProvenanceAgents";
  agent: ProvenanceAgentUnionType;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  organization_id?: Maybe<Scalars["ID"]["output"]>;
  patient_id?: Maybe<Scalars["String"]["output"]>;
  provenance: Provenances;
  role: SecurityRoleType;
  type: ParticipantRoleType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ProvenanceBasedOnUnion = CarePlans | ServiceRequests | Tasks;

export type Provenances = {
  __typename?: "Provenances";
  /** Activity that occurred */
  activity: ProvenanceActivityType;
  /** An actor(s) taking a role in an activity for which it can be assigned some degree of responsibility for the activity taking place. */
  agents: Array<ProvenanceAgents>;
  authorization: PurposeOfUse;
  based_on?: Maybe<ProvenanceBasedOnUnion>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encounter?: Maybe<Encounters>;
  encounter_id?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  /** When the activity occurred */
  occurred_at: Scalars["GraphQLDateTime"]["output"];
  patient?: Maybe<Patients>;
  patient_id?: Maybe<Scalars["String"]["output"]>;
  /** Policy or plan the activity was defined by. */
  policy?: Maybe<Scalars["String"]["output"]>;
  provenance_id: Scalars["String"]["output"];
  request_id?: Maybe<Scalars["String"]["output"]>;
  signature?: Maybe<Signatures>;
  /** The Reference that was generated or updated by the activity described in this resource */
  target: References;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Publication status codes */
export enum PublicationStatus {
  /** This resource is ready for normal use. */
  Active = "ACTIVE",
  /** This resource is still under development and is not yet considered to be ready for normal use. */
  Draft = "DRAFT",
  /** This resource has been withdrawn or superseded and should no longer be used. */
  Retired = "RETIRED",
  /** The authoring system does not know which of the status values currently applies for this resource. Note: This concept is not to be used for "other" - one of the listed statuses is presumed to apply, it's just not known which one. */
  Unknown = "UNKNOWN",
}

export type PurchasedPromos = {
  __typename?: "PurchasedPromos";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  promo_code: Scalars["String"]["output"];
  promo_id: Scalars["String"]["output"];
  promo_transaction_id: Scalars["String"]["output"];
  remaining_tests: Scalars["Float"]["output"];
  status: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
};

export type PurgeGatewayMessagesResponse = {
  __typename?: "PurgeGatewayMessagesResponse";
  /** Number of messages purged */
  purgedCount?: Maybe<Scalars["Float"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR purpose of use codes. */
export enum PurposeOfUse {
  /** To perform one or more operations on information for conducting scientific investigations to obtain health care knowledge. Use of the data must be related to specified biomedical basic or applied research. For example, research on rare plants to determine whether biologic properties may be useful for pharmaceutical development. May be used in combination with clinical trial and other healthcare research purposes of use. */
  Biorch = "BIORCH",
  /** To perform policy override operations on information for provision of immediately needed health care for an emergent condition affecting potential harm, death or patient safety by end users who are not provisioned for this purpose of use. Includes override of organizational provisioning policies and may include override of subject of care consent directive restricting access. */
  Btg = "BTG",
  /** To perform analytics, evaluation and other secondary uses of treatment and healthcare related information to manage the quality, efficacy, patient safety, population health, and cost effectiveness of healthcare delivery. Explicitly excludes the use of information to organize the delivery of health care for care coordination and case management, or to provide healthcare treatment. */
  Caremgt = "CAREMGT",
  /** To perform one or more operations on information for conducting scientific investigations in accordance with clinical trial protocols to obtain health care knowledge. */
  Clintrch = "CLINTRCH",
  /** To perform one or more operations on information for conducting scientific investigations in accordance with clinical trial protocols to obtain health care knowledge without provision of patient care. May be post-coordinated or used with other purposes of use such as disease, discipline, specialty, population origins or ancestry, translational healthcare research. For example, a clinical trial conducted on laboratory specimens collected from a specified patient population. */
  Clintrchnpc = "CLINTRCHNPC",
  /** To perform one or more operations on information for conducting scientific investigations with patient care in accordance with clinical trial protocols to obtain health care knowledge. May be post-coordinated or used with other purposes of use such as disease, discipline, specialty, population origins or ancestry, translational healthcare research. For example, an "off-label" drug used for cancer therapy administer to a specified patient population. */
  Clintrchpc = "CLINTRCHPC",
  /** To perform health care as part of the clinical trial protocol. */
  Clintrl = "CLINTRL",
  /** To perform one or more operations on information for provision of additional clinical evidence in support of a request for coverage or payment for health services. */
  Clmattch = "CLMATTCH",
  /** To perform one or more actions on information in order to organize the provision and case management of an individualâ€™s healthcare, including: Monitoring a person's goals, needs, and preferences; acting as the communication link between two or more participants concerned with a person's health and wellness; organizing and facilitating care activities and promoting self-management by advocating for, empowering, and educating a person; and ensuring safe, appropriate, non-duplicative, and effective integrated care. */
  Coc = "COC",
  /** To perform one or more operations on information for conducting prior authorization or predetermination of coverage for services. */
  Covauth = "COVAUTH",
  /** To perform one or more operations on information for conducting activities related to coverage under a program or policy. */
  Coverage = "COVERAGE",
  /** To perform one or more operations on information used for provision of immediately needed health care to a population of living subjects located in a disaster zone. */
  Disaster = "DISASTER",
  /** To perform one or more operations on information used for cadaveric organ, eye or tissue donation. */
  Donat = "DONAT",
  /** To perform one or more operations on information for conducting scientific investigations to obtain health care knowledge. Use of the data must be related to specified conditions, diagnosis, or disease healthcare research. For example, conducting cancer research by testing reaction of tumor cells to certain biologics. May be used in combination with clinical trial and other healthcare research purposes of use. */
  Dsrch = "DSRCH",
  /** To perform one or more operations on information used for conducting eligibility determination for coverage in a program or policy. May entail review of financial status or disability assessment. */
  Eligdtrm = "ELIGDTRM",
  /** To perform one or more operations on information used for conducting eligibility verification of coverage in a program or policy. May entail provider contacting coverage source (e.g., government health program such as workers compensation or health plan) for confirmation of enrollment, eligibility for specific services, and any applicable copays. */
  Eligver = "ELIGVER",
  /** To perform one or more operations on information used for enrolling a covered party in a program or policy. May entail recording of covered party's and any dependent's demographic information and benefit choices. */
  Enrollm = "ENROLLM",
  /** To perform one or more operations on information for provision of immediately needed health care for an emergent condition in an emergency room or similar emergent care context by end users provisioned for this purpose, which does not constitute as policy override such as in a "Break the Glass" purpose of use. */
  Ertreat = "ERTREAT",
  /** To perform one or more operations on information for provision of immediately needed health care for an emergent condition. */
  Etreat = "ETREAT",
  /** To perform one or more operations on information in response to a request by a family member authorized by the patient. */
  Famrqt = "FAMRQT",
  /** To perform one or more operations on information used for fraud detection and prevention processes. */
  Fraud = "FRAUD",
  /** To perform one or more operations on information used within government processes. */
  Gov = "GOV",
  /** To perform one or more operations on information for conducting activities related to meeting accreditation criteria. */
  Haccred = "HACCRED",
  /** To perform one or more operations on information used for conducting activities required to meet a mandate. */
  Hcompl = "HCOMPL",
  /** To perform one or more operations on information used for handling deceased patient matters. */
  Hdecd = "HDECD",
  /** To perform one or more operation operations on information used to manage a patient directory. */
  Hdirect = "HDIRECT",
  /** To perform one or more actions on information used for conducting administrative and contractual activities by or on behalf of organizational entities responsible for delivery of an individual's benefits in a healthcare program, health plan or insurance. Explicitly excludes the use of information to organize the delivery of health care for care coordination and case management, or to provide healthcare treatment. */
  Hdm = "HDM",
  /** To perform one or more operations on information for conducting activities required by legal proceeding. */
  Hlegal = "HLEGAL",
  /** To perform one or more operations on information for marketing services and products related to health care. */
  Hmarkt = "HMARKT",
  /** To perform one or more operations on information used for conducting administrative and contractual activities related to the provision of health care. */
  Hoperat = "HOPERAT",
  /** To perform one or more operations on information used for assessing results and comparative effectiveness achieved by health care practices and interventions. */
  Houtcoms = "HOUTCOMS",
  /** To perform one or more operations on information for conducting financial or contractual activities related to payment for provision of health care. */
  Hpaymt = "HPAYMT",
  /** To perform one or more operations on information used for conducting activities to meet program accounting requirements. */
  Hprgrp = "HPRGRP",
  /** To perform one or more operations on information used for conducting administrative activities to improve health care quality. */
  Hqualimp = "HQUALIMP",
  /** To perform one or more operations on information for conducting scientific investigations to obtain health care knowledge. Use of the data iincludes basic and applied research such as biomedical, population origin or ancestry, translational research, and disease, discipline, specialty specific healthcare research and clinical trial research. */
  Hresch = "HRESCH",
  /** To perform one or more operations on information to administer the electronic systems used for the delivery of health care. */
  Hsysadmin = "HSYSADMIN",
  /** To perform one or more operations on information that is simulated or synthetic health data used for testing system capabilities outside of a production or operational system environment. */
  Htest = "HTEST",
  /** To perform one or more operations on information to assign, persist, and manage labels to healthcare data to characterize various aspects, such as its security classification, sensitivity, compartment, integrity, and provenance; applicable privacy, consent, security, provenance, and trust policies; and handling caveats such as purpose of use, obligations, and refrain policies. */
  Labeling = "LABELING",
  /** To perform one or more operations on information to administer health care coverage to an enrollee under a policy or program. */
  Memadmin = "MEMADMIN",
  /** To perform one or more operations on information to assign, persist, and manage metadata to healthcare data to characterize various aspects used for its indexing, discovery, retrieval, and processing by systems, applications, and end users. For example, master index identifier, media type, and location. */
  Metamgt = "METAMGT",
  /** To perform one or more operations on information for conducting activities required by military processes, procedures, policies, or law. */
  Milcdm = "MILCDM",
  /** To perform one or more operations on information for the process of releasing military personnel from their service obligations, which may include determining service merit, discharge benefits, and disability assessment. */
  Mildcrg = "MILDCRG",
  /** To perform one or more operations on information used for operational activities conducted to administer the delivery of health care to a patient. */
  Patadmin = "PATADMIN",
  /** To perform one or more operations on information in response to a patient's request. */
  Patrqt = "PATRQT",
  /** To perform one or more operations on information in processes related to ensuring the safety of health care. */
  Patsfty = "PATSFTY",
  /** To perform one or more operations on information used for monitoring performance of recommended health care practices and interventions. */
  Perfmsr = "PERFMSR",
  /** To perform one or more operations on information, including genealogical pedigrees, historical records, surveys, family health data, health records, and genetic information, for conducting scientific investigations to obtain health care knowledge. Use of the data must be related to population origins and/or ancestry healthcare research. For example, gathering genetic specimens from a specific population in order to determine the ancestry and population origins of that group. May be used in combination with clinical trial and other healthcare research purposes of use. */
  Poarch = "POARCH",
  /** To perform one or more operations on information for provision of health care to a population of living subjects, e.g., needle exchange program. */
  Pophlth = "POPHLTH",
  /** To perform one or more operations on information in preparation for conducting scientific investigation to obtain health care knowledge, such as research on animals or review of patient health records, to determine the feasibility of a clinical trial study; assist with protocol design; or in preparation for institutional review board or ethics committee approval process. May be post-coordinated or used with other purposes of use such as disease, discipline, specialty, population origins or ancestry, translational healthcare research. */
  Preclintrch = "PRECLINTRCH",
  /** To perform one or more operations on information for conducting public health activities, such as the reporting of notifiable conditions. */
  Pubhlth = "PUBHLTH",
  /** To perform one or more operations on information in response to a request by a person appointed as the patient's legal representative. */
  Pwatrny = "PWATRNY",
  /** To perform one or more operations on information used within the health records management process. */
  Recordmgt = "RECORDMGT",
  /** To perform one or more operations on information about the amount remitted for a health care claim. */
  Remitadv = "REMITADV",
  /** To perform one or more operations on information in response to a request by a person authorized by the patient. */
  Supnwk = "SUPNWK",
  /** To perform one or more operations on information to design, develop, implement, test, or deploy a healthcare system or application. */
  Sysdev = "SYSDEV",
  /** To perform one or more operations on information used to prevent injury or disease to living subjects who may be the target of violence. */
  Threat = "THREAT",
  /** To perform one or more operations on information used in training and education. */
  Train = "TRAIN",
  /** To perform one or more operations on information for conducting scientific investigations to obtain health care knowledge related to evidence based medicine during the course of providing healthcare treatment. Sometimes referred to as "bench to bedside", which is the iterative feedback loop between healthcare research and clinical trials with input from information collected in the course of routine provision of healthcare. For example, by extending a patient encounter to conduct a survey related to a research topic such as attitudes about use of a wellness device that a patient agreed to use. May be used in combination with clinical trial and other healthcare research purposes of use. */
  Transrch = "TRANSRCH",
  /** To perform one or more operations on information for provision of health care. */
  Treat = "TREAT",
}

export type QualificationCreateInput = {
  practitionerId: Scalars["String"]["input"];
  qualifications: Array<QualificationRequiredInput>;
};

export type QualificationRequiredInput = {
  credential: DegreeLicenseCertificate;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
  license?: InputMaybe<Scalars["String"]["input"]>;
  /** Period qualification is valid */
  period?: InputMaybe<PeriodCreateInput>;
  speciality?: InputMaybe<Scalars["String"]["input"]>;
  verificationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  verifiedBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type QualitativeCodeSets = {
  /** Value set of abnormal coded values as part of this set of qualified values */
  abnormalCodeSet?: InputMaybe<ValueSetCreateInput>;
  /** Value set of critical coded values as part of this set of qualified values */
  criticalCodeSet?: InputMaybe<ValueSetCreateInput>;
  /** Value set of normal coded values as part of this set of qualified values */
  normalCodeSet?: InputMaybe<ValueSetCreateInput>;
  /** Value set of valid coded values as part of this set of qualified values */
  validCodeSet?: InputMaybe<ValueSetCreateInput>;
};

export type Quantity = {
  __typename?: "Quantity";
  /** A computer processable form of the unit in some unit representation system. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** How the value should be understood and represented - whether the actual value is greater or less than the stated value due to measurement issues; e.g. if the comparator is "<", then the real value is "<" stated value. */
  comparator?: Maybe<QuantityComparator>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  quantity_id: Scalars["String"]["output"];
  /** The identification of the system that provides the coded form of the unit. */
  system?: Maybe<Scalars["String"]["output"]>;
  /** A human readable form of the unit */
  unit: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** The value of the measured amount. The value includes an implicit precision in the presentation of the value */
  value: Scalars["Float"]["output"];
};

/** All possible FHIR quantity comparator operator codes. */
export enum QuantityComparator {
  Equals = "EQUALS",
  GreaterOrEqual = "GREATER_OR_EQUAL",
  GreaterThan = "GREATER_THAN",
  LessOrEqual = "LESS_OR_EQUAL",
  LessThan = "LESS_THAN",
  NotEquals = "NOT_EQUALS",
  Sufficient = "SUFFICIENT",
}

export type QuantityCreateInput = {
  code?: InputMaybe<Scalars["String"]["input"]>;
  /** How the value should be understood and represented - whether the actual value is greater or less than the stated value due to measurement issues; e.g. if the comparator is "<", then the real value is "<" stated value. */
  comparator?: InputMaybe<QuantityComparator>;
  system?: InputMaybe<Scalars["String"]["input"]>;
  unit: Scalars["String"]["input"];
  value: Scalars["Float"]["input"];
};

export type Query = {
  __typename?: "Query";
  UserSession: SessionResponse;
  UserSessionIP: UserSessionIpData;
  appointmentList: AppointmentPaginatedResults;
  /** Batch translate multiple external codes to internal LIS codes */
  batchTranslateToInternal?: Maybe<Scalars["String"]["output"]>;
  cart: WebCarts;
  catalogCategories: Array<WebStoreCategoryDefinitions>;
  catalogCategoryProducts: Array<StoreFrontCategories>;
  catalogProducts: CatalogProductPaginatedResults;
  checkSlotAvailability: SlotAvailability;
  downloadBulkOrderResultsReport: DownloadReportResults;
  downloadCSVLocationPatientsReport: DownloadLocationPatientsReportResults;
  downloadCSVOrdersReport: DownloadOrdersReportResults;
  downloadCSVPractitionersReport: DownloadPractitionersReportResults;
  downloadDailyLabReport: DownloadReportResults;
  downloadOrderReport: DownloadMedicalReportResults;
  employeesFeed: EmployeePaginatedResults;
  exploreDirectoryFiles: ExploreFilesResponse;
  findFDAMedications: Array<ProductResults>;
  findFDAMedicationsNDC: Array<ProductResults>;
  findFDAMedicationsWithDetails: Array<ProductResults>;
  getAMRAgent: Agents;
  getAccessGroup: AccessGroups;
  getAccountSettings: Settings;
  getActiveExpoNotificationTokens: Array<ExpoNotificationTokens>;
  getActivityDefinition: ActivityDefinitions;
  getAddressAutocomplete: GooglePlacesAutocompleteResponseType;
  getAddressById?: Maybe<Addresses>;
  getAllAMRAgents: Array<Agents>;
  getAllAccessGroups: Array<AccessGroups>;
  getAllActivityDefinitions: Array<ActivityDefinitions>;
  getAllAppointmentSeries: Array<AppointmentRecurrenceSeries>;
  getAllAppointments: Array<Appointments>;
  getAllAssignedWaypoints: Array<RoutesUnion>;
  getAllBillingAccounts: Array<BillingAccounts>;
  getAllCarePlans: Array<CarePlans>;
  getAllCareTeams: Array<CareTeams>;
  getAllCategoryDefinitions: Array<WebStoreCategoryDefinitions>;
  getAllChannelMembers: Array<ChannelMembers>;
  getAllClinicalNotes: Array<ClinicalNotes>;
  getAllCommunicationRequests: Array<CommunicationRequests>;
  getAllCommunications: Array<Communications>;
  getAllConditionAssessments: Array<ClinicalImpressions>;
  getAllCriteriaDefinitions: Array<CriteriaDefinitions>;
  getAllCriteriaFormResults: Array<CriteriaFormResults>;
  getAllCynergyUsers: Array<CynergyUsers>;
  getAllDetailedMedicationUsages: Array<MedicationResults>;
  getAllDiagnosticCatalogs: Array<DiagnosticServiceCatalog>;
  getAllDiagnosticReports: Array<DiagnosticReports>;
  getAllDiagnosticService: Array<DiagnosticServices>;
  getAllEncounters: Array<EncounterResults>;
  getAllEpisodesOfCare: Array<EpisodeOfCare>;
  getAllEventSeries: Array<EventSeries>;
  getAllEvents: Array<Events>;
  getAllHealthcareServiceLocations: Array<HealthcareServiceLocations>;
  getAllHealthcareServices: Array<HealthcareServices>;
  getAllICD10Codes: Array<Icd10>;
  getAllLabObservations: Array<Observations>;
  getAllLabs: Array<Labs>;
  getAllLegs: Array<RoutesUnion>;
  getAllLocationPatients: Array<LocationPatients>;
  getAllLocationPrescriptions: Array<MedicationUsages>;
  getAllLocations: Array<Locations>;
  getAllMedicationUsages: Array<MedicationResults>;
  getAllMerchantAccounts: Array<MerchantAccounts>;
  getAllMerchantCredentialDefinitions: Array<MerchantCredentialDefinitions>;
  getAllMerchantCredentials: Array<MerchantCredentials>;
  getAllNotificationTickets: Array<ExpoNotificationTickets>;
  getAllObservationDefinitions: Array<ObservationDefinitions>;
  getAllOrders: Array<Orders>;
  getAllOrganizations: Array<UserResults>;
  getAllPatientConditions: Array<Conditions>;
  getAllPatientMedications: Array<MedicationResults>;
  getAllPatients: Array<UserResults>;
  getAllPaymentGateways: Array<PaymentGateways>;
  getAllPaymentProfiles: Array<PaymentResultsUnion>;
  getAllPractitionerQualifications: Array<PractitionerQualifications>;
  getAllPractitioners: Array<Practitioners>;
  getAllPriceBookEntries: Array<PriceBookEntries>;
  getAllPriceBooks: Array<PriceBooks>;
  getAllProductCatalogItems: Array<ProductCatalogItems>;
  getAllProductCatalogs: Array<ProductCatalogs>;
  getAllProductResources: Array<Products>;
  getAllProducts: Array<Products>;
  getAllQuestionnaireAnswers: Array<FeedbackUnion>;
  getAllQuestionnaireItems: Array<FeedbackUnion>;
  getAllQuestionnaireResponses: Array<FeedbackUnion>;
  getAllQuestionnaires: Array<FeedbackUnion>;
  getAllRecurrencePatterns: Array<RecurrencePatterns>;
  getAllRelayTasks: Array<RelayTasks>;
  getAllResistantGenes: Array<Genotypes>;
  getAllResourceIdentifiers: Array<ResourceUnion>;
  getAllResourceReferences: Array<ResourceUnion>;
  getAllRouteAssignments: Array<RoutesUnion>;
  getAllRouteLocations: Array<RoutesUnion>;
  getAllSchedules: Array<Schedules>;
  getAllServiceRequests: Array<ServiceRequests>;
  getAllSpecimenConditioningDefinitions: Array<SpecimenDefinitionTests>;
  getAllSpecimenContainerCapDefinitions: Array<SpecimenDefinitionContainerCaps>;
  getAllSpecimenContainerDefinitions: Array<SpecimenDefinitionContainers>;
  getAllSpecimenDefinitions: Array<SpecimenDefinitions>;
  getAllStaffAssignments: Array<UserResults>;
  getAllStaffMembers: Array<UserResults>;
  getAllStoreCategoryDefinitions: Array<WebStoreCategoryDefinitions>;
  getAllSubscriberChannels: Array<SubscriptionChannels>;
  getAllSubscriberTopics: Array<SubscriptionTopics>;
  getAllTasks: Array<Tasks>;
  getAllTwilioUserFactors: Array<FactorInstanceResponse>;
  getAllUserAccounts: Array<UserResults>;
  getAllUserCollections: Array<Collections>;
  getAllUserEvents: Array<UserEventData>;
  getAllUserMessages: Array<Messages>;
  getAllUserProductBundles: Array<UserProductBundles>;
  getAllWebStores: Array<WebStores>;
  getAllWellnessPatientTestSamples: Array<WellnessResultUnion>;
  getAllWellnessPatientTests: Array<WellnessResultUnion>;
  getAppointment: Appointments;
  getAppointmentSeries: AppointmentRecurrenceSeries;
  getAppointmentSlots: Array<Slots>;
  getAssignedWaypoint: RoutesUnion;
  getAvailableAlertTypes: Array<AlertTypes>;
  getBillingAccount: BillingAccounts;
  getBulkDemographics: Array<CynergyIdentityUnion>;
  getCarePlan: CarePlans;
  getCareTeam: CareTeams;
  getChannelAlertEmails: Array<ChannelAlertEmails>;
  getChannelMember: ChannelMembers;
  /** Get a single channel template by ID */
  getChannelTemplate?: Maybe<Scalars["String"]["output"]>;
  getClinicalNote: ClinicalNotes;
  getCollectionEntries: Array<CollectionEntries>;
  getCommunication: Communications;
  getCommunicationRequest: CommunicationRequests;
  getConditionAssessment: ClinicalImpressions;
  getCoverage: Coverages;
  getCoverageAudits: Array<CoverageAudits>;
  getCriteriaDefinition: CriteriaDefinitions;
  getCriteriaFormResult: CriteriaFormResults;
  getCynergyUser: CynergyUsersType;
  getDetailedMedicationUsage: MedicationResults;
  /** Get a device by ID with its endpoints */
  getDevice?: Maybe<Scalars["String"]["output"]>;
  /** Get all enabled channels for a device (gateway startup query) */
  getDeviceChannels?: Maybe<Scalars["String"]["output"]>;
  getDiagnosticCatalog: DiagnosticServiceCatalog;
  getDiagnosticReport: DiagnosticReports;
  getDiagnosticService: DiagnosticServices;
  getDuplicateRecordRule: DuplicateRecordRules;
  getEmployee: StaffAssignments;
  getEncounter: EncounterResults;
  /** Get structured endpoint configuration by endpoint ID */
  getEndpointConfig?: Maybe<Scalars["String"]["output"]>;
  getEpisodeOfCare: EpisodeOfCare;
  getEvent: Events;
  getEventSeries: EventSeries;
  /** Get a single external code mapping by ID with associations */
  getExternalCodeMapping?: Maybe<Scalars["String"]["output"]>;
  getFeedElement: FeedItemObject;
  /** Get a single gateway message with its event trail */
  getGatewayMessage?: Maybe<Scalars["String"]["output"]>;
  /** Get aggregate statistics for gateway message throughput */
  getGatewayMessageStats?: Maybe<Scalars["String"]["output"]>;
  /** List gateway messages with optional filters and pagination */
  getGatewayMessages?: Maybe<Scalars["String"]["output"]>;
  getGeoData: GoogleGeocodingResponseType;
  getGroupedICD10Codes: GroupedIcd10CodesResult;
  getHealthcareService: HealthcareServices;
  getHealthcareServiceLocation: HealthcareServiceLocations;
  getHealthcareServiceLocations: HealthcareServiceLocationPaginatedResults;
  /** Get a single intake message; includeRaw also returns the archived raw HL7 content (base64) for client resend */
  getHl7IntakeMessage?: Maybe<Scalars["String"]["output"]>;
  getICD10Codes: Icd10;
  /** Get all instruments and their panels linked to a specific endpoint */
  getInstrumentRoutes?: Maybe<Scalars["String"]["output"]>;
  /** Get a single integration channel by ID with all associations */
  getIntegrationChannel?: Maybe<Scalars["String"]["output"]>;
  /** Get the complete channel configuration for a gateway client (channel + endpoints + configs + filters + message def) */
  getIntegrationChannelConfig?: Maybe<Scalars["String"]["output"]>;
  getLab: Labs;
  getLabObservation: Observations;
  /** Get a single lab order by ID with all work items and associations */
  getLabOrder?: Maybe<Scalars["String"]["output"]>;
  /** Find a lab order by accession number */
  getLabOrderByAccession?: Maybe<Scalars["String"]["output"]>;
  /** Query the status of a submitted lab order from the gateway */
  getLabOrderStatus?: Maybe<Scalars["String"]["output"]>;
  getLayoutSetting: LayoutSettings;
  getLeg: RoutesUnion;
  getLocation: Locations;
  getLocationAddresses: Array<Locations>;
  getLocationPatient: LocationPatients;
  getMedicationUsage: MedicationResults;
  getMerchantAccount: MerchantAccounts;
  getMerchantCredential: MerchantCredentials;
  getMerchantCredentialDefinition: MerchantCredentialDefinitions;
  getObservationDefinition: ObservationDefinitions;
  getOnboardingInvite: OnboardingInvite;
  getOneOrganization: UserResults;
  getOrder: Orders;
  getOrderCoverage?: Maybe<OrderCoverages>;
  getOrderDetails: Orders;
  getOrderLineItem: OrderLineItems;
  getOrderSignature?: Maybe<OrderSignatures>;
  /** Get aggregate statistics for order throughput */
  getOrderStats?: Maybe<Scalars["String"]["output"]>;
  /** Get all work items for a specific lab order */
  getOrderWorkItems?: Maybe<Scalars["String"]["output"]>;
  getOrganizationAffiliation: OrganizationAffiliations;
  getPaginatedAbnormalObservations: ObservationPaginatedResults;
  getPaginatedAccessGroups: AccessGroupPaginatedResults;
  getPaginatedAppointmentSeries: AppointmentSeriesPaginatedResults;
  getPaginatedAppointments: AppointmentPaginatedResults;
  getPaginatedBillingAccounts: BillingAccountPaginatedResults;
  getPaginatedCarePlans: CarePlanPaginatedResponse;
  getPaginatedCommunicationRequests: CommunicationRequestPaginatedResults;
  getPaginatedCommunications: CommunicationPaginatedResults;
  getPaginatedConditionAssessments: ConditionAssessmentsPaginatedResponse;
  getPaginatedCoverages: CoveragePaginatedResults;
  getPaginatedCriteriaDefinitions: CriteriaDefinitionPaginatedResults;
  getPaginatedCriteriaFormResults: CriteriaFormPaginatedResults;
  getPaginatedCynergyUsers: PaginatedCynergyUsersResponse;
  getPaginatedDiagnosticReports: DiagnosticReportPaginatedResults;
  getPaginatedDuplicateJobDefinitions: DuplicateJobDefinitionPaginatedResults;
  getPaginatedDuplicateRecordRules: DuplicateRecordRulePaginatedResults;
  getPaginatedDuplicateRecordSets: DuplicateRecordSetPaginatedResults;
  getPaginatedEmployees: EmployeePaginatedResults;
  getPaginatedEncounters: EncounterPaginatedResponse;
  getPaginatedEvents: EventPaginatedResults;
  getPaginatedFeedItems: FeedElementCollectionObject;
  getPaginatedFieldMatchProbabilityDefinitions: MatchProbabilityDefinitionPaginatedResults;
  getPaginatedHealthcareServices: HealthcareServicePaginatedResults;
  getPaginatedICD10Codes: Icd10CodePaginatedResults;
  getPaginatedLabObservations: ObservationPaginatedResults;
  getPaginatedLocationPatients: LocationPatientPaginatedResults;
  getPaginatedMerchantAccounts: MerchantAccountPaginatedResults;
  getPaginatedMerchantCredentials: MerchantCredentialPaginatedResults;
  getPaginatedOrderItems: OrderItemPaginatedResults;
  getPaginatedOrderNotes: OrderNotePaginatedResults;
  getPaginatedOrders: OrderPaginatedResults;
  getPaginatedPaymentGateways: PaymentGatewayPaginatedResults;
  getPaginatedPractitioners: PractitionerPaginatedResults;
  getPaginatedPrescriptions: PrescriptionPaginatedResults;
  getPaginatedPriceBookEntries: PriceBookEntryPaginatedResult;
  getPaginatedPriceBooks: PriceBookPaginatedResults;
  getPaginatedProductCatalogItems: ProductCatalogItemPaginatedResults;
  getPaginatedProductCatalogs: ProductCatalogPaginatedResults;
  getPaginatedProducts: ProductPaginatedResults;
  getPaginatedQuestionnaireResponses: FeedbackPaginatedResponse;
  getPaginatedQuestionnaires: FeedbackPaginatedResponse;
  getPaginatedRecordMatchingRules: RecordMatchingRulePaginatedResults;
  getPaginatedRecurrencePatterns: RecurrencePatternPaginatedResults;
  getPaginatedRecurringOrders: OrderPaginatedResults;
  getPaginatedSchedules: SchedulePaginatedResults;
  getPaginatedServiceRequests: ServiceRequestPaginatedResults;
  getPaginatedStaffAssignments: StaffAssignmentPaginatedResponse;
  getPaginatedStaffMembers: PractitionerPaginatedResponse;
  getPaginatedTasks: TaskPaginatedResults;
  getPaginatedUserProductBundles: UserProductBundlePaginatedResults;
  getPaginatedWebStores: WebStorePaginatedResults;
  getPaginatedWellnessPatientTestSamples: WellnessPatientTestSampleData;
  getPaginatedWellnessPatientTests: WellnessPaginatedResponse;
  getPaginatedWellnessTestPositives: WellnessTestsPaginatedResponse;
  getPaginatedWellnessTestSamplesByFacility: WellnessPatientTestSampleData;
  getPatient: Patients;
  getPatientCondition: Conditions;
  getPatientFiles: Array<PatientFileResponse>;
  getPatientMedication: MedicationResults;
  getPatientSelfServiceCart: PatientSelfServiceCart;
  getPaymentGateway: PaymentGateways;
  getPaymentProfile: PaymentResultsUnion;
  getPractitioner: Practitioners;
  getPractitionerQualification: PractitionerQualifications;
  getPractitionerSignature: PractitionerSignatures;
  getPriceBook: PriceBooks;
  getPriceBookEntry: PriceBookEntries;
  getProduct: Products;
  getProductCatalog: ProductCatalogs;
  getProductCatalogItem: ProductCatalogItems;
  getQuestionnaire: FeedbackUnion;
  getQuestionnaireItem: FeedbackUnion;
  getQuestionnaireResponse: FeedbackUnion;
  getRecordMatchingRule: RecordMatchingRules;
  getRecurrencePattern: RecurrencePatterns;
  getRelayTask: RelayTasks;
  /** Returns all required legal documents the user must accept with all available language translations. Each document includes an English URL (always present) and optional translations array. Frontend can display language selector if translations exist. Returns empty array if all documents have been accepted. */
  getRequiredLegalDocuments: Array<RequiredLegalAcceptance>;
  getResistantGene: Genotypes;
  getResourceIdentifier: ResourceUnion;
  getResourceReference: ResourceUnion;
  getRouteAssignment: RoutesUnion;
  getRouteLocation: RoutesUnion;
  /** Get the complete instrument-to-endpoint routing table for a device (gateway startup companion to getDeviceChannels) */
  getRoutingTable?: Maybe<Scalars["String"]["output"]>;
  getSchedule: Schedules;
  getServiceRequest: ServiceRequests;
  getServiceState: Scalars["String"]["output"];
  getSpecimenConditioningDefinition: SpecimenDefinitionTests;
  getSpecimenContainerCapDefinition: SpecimenDefinitionContainerCaps;
  getSpecimenContainerDefinition: SpecimenDefinitionContainers;
  getSpecimenDefinition: SpecimenDefinitions;
  getStaffAssignment: UserResults;
  getStaffMember: UserResults;
  getStoreCategoryDefinition: WebStoreCategoryDefinitions;
  getStoreInformation: WebStores;
  getStoreProduct: CatalogProductResult;
  getStoreSurcharge: Scalars["Float"]["output"];
  getSubscriberChannel: SubscriptionChannels;
  getSubscriberTopic: SubscriptionTopics;
  getSymptomAssessment: SymptomAssessmentResults;
  getTask: Tasks;
  getTaskCount: Scalars["Float"]["output"];
  getTaskStatistics: TaskStatisticsResponse;
  getTwoFactorProfile: TwoFactorAuthentication;
  getUnreadUserNotifications: Array<Notifications>;
  getUserAccount: UserResults;
  getUserAlertSettings: Array<UserAlertSettingDetail>;
  getUserAvailableTestsToTrack: Array<AvailableTest>;
  getUserAvailableTestsToTrackNonReporting: AvailableTestsPaginatedResults;
  getUserCollection: Collections;
  getUserDemographics: Demographics;
  getUserMessage: Messages;
  getUserNotificationTopics: Array<Scalars["String"]["output"]>;
  getUserNotifications: Array<Notifications>;
  getUserProductBundle: UserProductBundles;
  getUserProductBundleShares: Array<UserProductBundleShares>;
  getUserTestHistory: Array<TestHistoryData>;
  getUserTestHistoryNonReporting: Array<TestHistoryNonReportingData>;
  getUserTrackedTests: Array<TrackedTest>;
  getWebStore: WebStores;
  hasPatientFiles: Scalars["Boolean"]["output"];
  labObservationStats: Array<LabObservationStats>;
  /** List channel templates with optional category/manufacturer/organization filters */
  listChannelTemplates?: Maybe<Scalars["String"]["output"]>;
  /** List all active coding systems (unfiltered — used by integration channels) */
  listCodings?: Maybe<Scalars["String"]["output"]>;
  /** List devices with optional status, organization, or location filters */
  listDevices?: Maybe<Scalars["String"]["output"]>;
  /** List external code mappings with optional filters (codingId, source, org, gateway, etc.) */
  listExternalCodeMappings?: Maybe<Scalars["String"]["output"]>;
  /** List gateway devices for a given organization (and optionally location) */
  listGatewayDevices?: Maybe<Scalars["String"]["output"]>;
  /** List external-pipeline HL7 intake messages with optional filters (status: received, processing, processed, failed, reprocessed) */
  listHl7IntakeMessages?: Maybe<Scalars["String"]["output"]>;
  /** List integration channels with optional status/direction/organization/location filters */
  listIntegrationChannels?: Maybe<Scalars["String"]["output"]>;
  /** List lab orders with optional status/accession/channel/date filters */
  listLabOrders?: Maybe<Scalars["String"]["output"]>;
  /** List coding systems applicable to external code mapping (excludes protocol and status codes) */
  listMappableCodings?: Maybe<Scalars["String"]["output"]>;
  /** List all active test codes */
  listTestCodes?: Maybe<Scalars["String"]["output"]>;
  /** List all active test panels with instrument and method associations */
  listTestPanels?: Maybe<Scalars["String"]["output"]>;
  /** List codes seen during HL7 ingestion that had no mapping (UNMAPPED_CODE flags), with occurrence counts */
  listUnmappedCodes?: Maybe<Scalars["String"]["output"]>;
  locationPatientsFeed: LocationPatientPaginatedResults;
  nearbyLocations: LocationPaginatedResults;
  npiLookup: Array<NpiRegistryProfiles>;
  orderStatistics: OrderStatisticsResults;
  paginatedPrescriptionList: PrescriptionPaginatedResults;
  patientDocuments: Array<PatientDocumentResponse>;
  practitionersFeed: PractitionerPaginatedResults;
  previewRecurrenceSchedule: RecurrenceSchedulePreview;
  previewRenewalWindow: RecurrenceScheduleRenewalWindow;
  productResource: Products;
  productServiceLocations: StoreProductPaginatedResults;
  searchProductsAcrossStores: StoreProductPaginatedResults;
  signatureAudits: Array<SignatureAuditResponse>;
  /** Translate an internal LIS panel to an external system code */
  translatePanelToExternal?: Maybe<Scalars["String"]["output"]>;
  /** Translate an internal LIS test code to an external system code */
  translateTestToExternal?: Maybe<Scalars["String"]["output"]>;
  /** Translate an external system code to internal LIS panel/test code */
  translateToInternal?: Maybe<Scalars["String"]["output"]>;
  userProductBundlesFeed: UserProductBundlePaginatedResults;
  userTimeline: TimelinePaginatedResults;
  validatePatientSelfServiceCart: PatientSelfServiceCartValidationResult;
};

export type QueryAppointmentListArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryBatchTranslateToInternalArgs = {
  codingId: Scalars["String"]["input"];
  externalCodes: Array<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCatalogCategoryProductsArgs = {
  distance?: InputMaybe<DistanceInput>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  type?: InputMaybe<CommerceProductFamily>;
};

export type QueryCatalogProductsArgs = {
  distance?: InputMaybe<DistanceInput>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<CatalogProductSearchBy>;
  sort?: InputMaybe<SortingArgs>;
  type?: InputMaybe<CommerceProductFamily>;
};

export type QueryCheckSlotAvailabilityArgs = {
  slotId: Scalars["String"]["input"];
};

export type QueryDownloadBulkOrderResultsReportArgs = {
  input: BulkOrderResultsExportInput;
};

export type QueryDownloadCsvLocationPatientsReportArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryDownloadCsvOrdersReportArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryDownloadCsvPractitionersReportArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryDownloadDailyLabReportArgs = {
  options?: InputMaybe<ReportSummaryInput>;
};

export type QueryDownloadOrderReportArgs = {
  orderId: Scalars["ID"]["input"];
  settingsId: Scalars["ID"]["input"];
};

export type QueryEmployeesFeedArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryExploreDirectoryFilesArgs = {
  folder?: InputMaybe<Scalars["String"]["input"]>;
  recursive: Scalars["Boolean"]["input"];
};

export type QueryFindFdaMedicationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryFindFdaMedicationsNdcArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryFindFdaMedicationsWithDetailsArgs = {
  classifications?: InputMaybe<Array<Scalars["String"]["input"]>>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  strictSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGetAmrAgentArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAccessGroupArgs = {
  groupId: Scalars["ID"]["input"];
};

export type QueryGetAccountSettingsArgs = {
  applicationId: Scalars["String"]["input"];
};

export type QueryGetActivityDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAddressAutocompleteArgs = {
  input: AddressAutocompleteInput;
};

export type QueryGetAddressByIdArgs = {
  addressId: Scalars["String"]["input"];
};

export type QueryGetAllAmrAgentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllAccessGroupsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllActivityDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllAppointmentSeriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllAppointmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllAssignedWaypointsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllBillingAccountsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCarePlansArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCareTeamsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCategoryDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllChannelMembersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllClinicalNotesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCommunicationRequestsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCommunicationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllConditionAssessmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCriteriaDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCriteriaFormResultsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllCynergyUsersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllDetailedMedicationUsagesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllDiagnosticCatalogsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllDiagnosticReportsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllDiagnosticServiceArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllEncountersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllEpisodesOfCareArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllEventSeriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllEventsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllHealthcareServiceLocationsArgs = {
  includePrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllHealthcareServicesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllIcd10CodesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllLabObservationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllLabsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllLegsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllLocationPatientsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllLocationPrescriptionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllLocationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllMedicationUsagesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllMerchantAccountsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllMerchantCredentialDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllMerchantCredentialsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllNotificationTicketsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllObservationDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllOrdersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllOrganizationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPatientConditionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPatientMedicationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPatientsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPaymentGatewaysArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPaymentProfilesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPractitionerQualificationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPractitionersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPriceBookEntriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllPriceBooksArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllProductCatalogItemsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllProductCatalogsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllProductResourcesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllProductsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllQuestionnaireAnswersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllQuestionnaireItemsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllQuestionnaireResponsesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllQuestionnairesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllRecurrencePatternsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllRelayTasksArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllResistantGenesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllResourceIdentifiersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllResourceReferencesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllRouteAssignmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllRouteLocationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSchedulesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllServiceRequestsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSpecimenConditioningDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSpecimenContainerCapDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSpecimenContainerDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSpecimenDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllStaffAssignmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllStaffMembersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllStoreCategoryDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSubscriberChannelsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllSubscriberTopicsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllTasksArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllTwilioUserFactorsArgs = {
  limit?: InputMaybe<Scalars["Float"]["input"]>;
};

export type QueryGetAllUserAccountsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllUserCollectionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllUserMessagesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllUserProductBundlesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  scope?: InputMaybe<RecordAccessScope>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllWebStoresArgs = {
  distance?: InputMaybe<DistanceInput>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllWellnessPatientTestSamplesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAllWellnessPatientTestsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAppointmentArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAppointmentSeriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetAppointmentSlotsArgs = {
  horizon?: InputMaybe<AppointmentAvailabilityHorizon>;
  resource: AppointmentResourceAvailability;
};

export type QueryGetAssignedWaypointArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetBillingAccountArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCarePlanArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCareTeamArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetChannelAlertEmailsArgs = {
  channelId: Scalars["String"]["input"];
};

export type QueryGetChannelMemberArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetChannelTemplateArgs = {
  templateId: Scalars["String"]["input"];
};

export type QueryGetClinicalNoteArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCollectionEntriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCommunicationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCommunicationRequestArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetConditionAssessmentArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCoverageArgs = {
  coverageId: Scalars["String"]["input"];
  includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGetCoverageAuditsArgs = {
  coverageId: Scalars["String"]["input"];
};

export type QueryGetCriteriaDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCriteriaFormResultArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetCynergyUserArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetDetailedMedicationUsageArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetDeviceArgs = {
  deviceId: Scalars["String"]["input"];
};

export type QueryGetDeviceChannelsArgs = {
  deviceId: Scalars["String"]["input"];
};

export type QueryGetDiagnosticCatalogArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetDiagnosticReportArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetDiagnosticServiceArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetDuplicateRecordRuleArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetEmployeeArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetEncounterArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetEndpointConfigArgs = {
  endpointId: Scalars["String"]["input"];
};

export type QueryGetEpisodeOfCareArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetEventArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetEventSeriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetExternalCodeMappingArgs = {
  mappingId: Scalars["String"]["input"];
};

export type QueryGetFeedElementArgs = {
  parameters: FeedElementSearchArgs;
};

export type QueryGetGatewayMessageArgs = {
  messageId: Scalars["String"]["input"];
};

export type QueryGetGatewayMessageStatsArgs = {
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetGatewayMessagesArgs = {
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  messageType?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetGeoDataArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  zipcode?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetGroupedIcd10CodesArgs = {
  groupSizeLimit?: InputMaybe<Scalars["Float"]["input"]>;
  groups?: InputMaybe<Array<DiagnosisCodeGroupType>>;
  subjectPatientId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetHealthcareServiceArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetHealthcareServiceLocationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetHealthcareServiceLocationsArgs = {
  distance?: InputMaybe<DistanceInput>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetHl7IntakeMessageArgs = {
  includeRaw?: InputMaybe<Scalars["Boolean"]["input"]>;
  intakeMessageId: Scalars["String"]["input"];
};

export type QueryGetIcd10CodesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetInstrumentRoutesArgs = {
  endpointId: Scalars["String"]["input"];
};

export type QueryGetIntegrationChannelArgs = {
  channelId: Scalars["String"]["input"];
};

export type QueryGetIntegrationChannelConfigArgs = {
  channelId: Scalars["String"]["input"];
};

export type QueryGetLabArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetLabObservationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetLabOrderArgs = {
  labOrderId: Scalars["String"]["input"];
};

export type QueryGetLabOrderByAccessionArgs = {
  accession: Scalars["String"]["input"];
};

export type QueryGetLabOrderStatusArgs = {
  accession: Scalars["String"]["input"];
};

export type QueryGetLayoutSettingArgs = {
  applicationId: Scalars["String"]["input"];
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetLegArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetLocationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetLocationAddressesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetLocationPatientArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetMedicationUsageArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetMerchantAccountArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetMerchantCredentialArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetMerchantCredentialDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetObservationDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetOnboardingInviteArgs = {
  inviteId: Scalars["String"]["input"];
};

export type QueryGetOneOrganizationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetOrderArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetOrderCoverageArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryGetOrderDetailsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetOrderLineItemArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetOrderSignatureArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryGetOrderStatsArgs = {
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOrderWorkItemsArgs = {
  labOrderId: Scalars["String"]["input"];
};

export type QueryGetOrganizationAffiliationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedAbnormalObservationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedAccessGroupsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedAppointmentSeriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedAppointmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedBillingAccountsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCarePlansArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCommunicationRequestsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCommunicationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedConditionAssessmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCoveragesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCriteriaDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCriteriaFormResultsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedCynergyUsersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedDiagnosticReportsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedDuplicateJobDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedDuplicateRecordRulesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedDuplicateRecordSetsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedEmployeesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedEncountersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedEventsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedFeedItemsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
  parameters: FeedElementSearchArgs;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedFieldMatchProbabilityDefinitionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedHealthcareServicesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedIcd10CodesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedLabObservationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedLocationPatientsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedMerchantAccountsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedMerchantCredentialsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedOrderItemsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedOrderNotesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedOrdersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedPaymentGatewaysArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedPractitionersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedPrescriptionsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedPriceBookEntriesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedPriceBooksArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedProductCatalogItemsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedProductCatalogsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedProductsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedQuestionnaireResponsesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedQuestionnairesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedRecordMatchingRulesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedRecurrencePatternsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedRecurringOrdersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedSchedulesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedServiceRequestsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedStaffAssignmentsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedStaffMembersArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedTasksArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedUserProductBundlesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  scope?: InputMaybe<RecordAccessScope>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedWebStoresArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedWellnessPatientTestSamplesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedWellnessPatientTestsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedWellnessTestPositivesArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaginatedWellnessTestSamplesByFacilityArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPatientArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPatientConditionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPatientFilesArgs = {
  fileCodes: Array<Scalars["String"]["input"]>;
};

export type QueryGetPatientMedicationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaymentGatewayArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPaymentProfileArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPractitionerArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPractitionerQualificationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPractitionerSignatureArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPriceBookArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetPriceBookEntryArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetProductArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetProductCatalogArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetProductCatalogItemArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetQuestionnaireArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetQuestionnaireItemArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetQuestionnaireResponseArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetRecordMatchingRuleArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetRecurrencePatternArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetRelayTaskArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetResistantGeneArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetResourceIdentifierArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetResourceReferenceArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetRouteAssignmentArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetRouteLocationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetRoutingTableArgs = {
  deviceId: Scalars["String"]["input"];
};

export type QueryGetScheduleArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetServiceRequestArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetSpecimenConditioningDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetSpecimenContainerCapDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetSpecimenContainerDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetSpecimenDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetStaffAssignmentArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetStaffMemberArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetStoreCategoryDefinitionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetStoreInformationArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetStoreProductArgs = {
  productCode: Scalars["String"]["input"];
  storeCode: Scalars["String"]["input"];
};

export type QueryGetStoreSurchargeArgs = {
  storeId: Scalars["String"]["input"];
};

export type QueryGetSubscriberChannelArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetSubscriberTopicArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetSymptomAssessmentArgs = {
  flagId?: InputMaybe<Scalars["String"]["input"]>;
  patientId: Scalars["String"]["input"];
};

export type QueryGetTaskArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetTaskCountArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetTaskStatisticsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetUnreadUserNotificationsArgs = {
  isRead: Scalars["Boolean"]["input"];
};

export type QueryGetUserAccountArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetUserAlertSettingsArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserAvailableTestsToTrackArgs = {
  userId: Scalars["ID"]["input"];
};

export type QueryGetUserAvailableTestsToTrackNonReportingArgs = {
  pagination?: InputMaybe<PaginationArgs>;
  userId: Scalars["ID"]["input"];
};

export type QueryGetUserCollectionArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetUserMessageArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetUserNotificationsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryGetUserProductBundleArgs = {
  bundleId: Scalars["ID"]["input"];
};

export type QueryGetUserProductBundleSharesArgs = {
  bundleId: Scalars["ID"]["input"];
};

export type QueryGetUserTestHistoryArgs = {
  testCode: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

export type QueryGetUserTestHistoryNonReportingArgs = {
  testCode: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

export type QueryGetUserTrackedTestsArgs = {
  userId: Scalars["ID"]["input"];
};

export type QueryGetWebStoreArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryHasPatientFilesArgs = {
  fileCodes: Array<Scalars["String"]["input"]>;
};

export type QueryLabObservationStatsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryListChannelTemplatesArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  manufacturer?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListDevicesArgs = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListExternalCodeMappingsArgs = {
  codingId?: InputMaybe<Scalars["String"]["input"]>;
  gatewayDeviceId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  testCodeId?: InputMaybe<Scalars["String"]["input"]>;
  testPanelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListGatewayDevicesArgs = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["String"]["input"];
};

export type QueryListHl7IntakeMessagesArgs = {
  accession?: InputMaybe<Scalars["String"]["input"]>;
  endpointId?: InputMaybe<Scalars["String"]["input"]>;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  messageType?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListIntegrationChannelsArgs = {
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListLabOrdersArgs = {
  accession?: InputMaybe<Scalars["String"]["input"]>;
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  sourceSystem?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListUnmappedCodesArgs = {
  codingId?: InputMaybe<Scalars["String"]["input"]>;
  endpointId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  segment?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLocationPatientsFeedArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryNearbyLocationsArgs = {
  distance: DistanceInput;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryNpiLookupArgs = {
  pagination?: InputMaybe<PaginationArgs>;
  search: Array<NpiRegistrySearchTerm>;
};

export type QueryOrderStatisticsArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  parameters: OrderStatisticsInput;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryPaginatedPrescriptionListArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryPatientDocumentsArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["ID"]["input"];
};

export type QueryPractitionersFeedArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryPreviewRecurrenceScheduleArgs = {
  count?: InputMaybe<Scalars["Float"]["input"]>;
  recurrence: RecurrencePatternCreateInput;
};

export type QueryPreviewRenewalWindowArgs = {
  patternId: Scalars["String"]["input"];
};

export type QueryProductResourceArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryProductServiceLocationsArgs = {
  distance?: InputMaybe<DistanceInput>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QuerySearchProductsAcrossStoresArgs = {
  distance?: InputMaybe<DistanceInput>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  searchBy?: InputMaybe<StoreProductSearchBy>;
  sort?: InputMaybe<SortingArgs>;
  storeId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<CommerceProductFamily>;
};

export type QuerySignatureAuditsArgs = {
  practitionerId: Scalars["ID"]["input"];
};

export type QueryTranslatePanelToExternalArgs = {
  codingId: Scalars["String"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
  testPanelId: Scalars["String"]["input"];
};

export type QueryTranslateTestToExternalArgs = {
  codingId: Scalars["String"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
  testCodeId: Scalars["String"]["input"];
};

export type QueryTranslateToInternalArgs = {
  codingId: Scalars["String"]["input"];
  externalCode: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUserProductBundlesFeedArgs = {
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  scope?: InputMaybe<RecordAccessScope>;
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
};

export type QueryUserTimelineArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type QueryOptionsInputType = {
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  paranoid?: InputMaybe<Scalars["Boolean"]["input"]>;
  subQuery?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuestionUpdateInput = {
  isReadOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** An indication, if true, that a QuestionnaireResponse for this item may include multiple answers associated with a single instance of this item (for question-type items) or multiple repetitions of the item (for group-type items). */
  isRepeating?: InputMaybe<Scalars["Boolean"]["input"]>;
  isRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The maximum number of characters that are permitted in the answer to be considered a "valid" QuestionnaireResponse. */
  maxAnswerLength?: InputMaybe<Scalars["Float"]["input"]>;
  /** The order in which to display this question. */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  questionPrefix?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary text for question. */
  questionText?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR Questionnaire answer constraint codes */
export enum QuestionnaireAnswerConstraint {
  /** Only values listed as answerOption or in the expansion of the answerValueSet are permitted */
  OptionsOnly = "OPTIONS_ONLY",
  /** In addition to the values listed as answerOption or in the expansion of the answerValueSet, free-text strings are permitted. Answers will have a type of 'string'. */
  OptionsOrString = "OPTIONS_OR_STRING",
  /** In addition to the values listed as answerOption or in the expansion of the answerValueSet, any other values that correspond to the specified item.type are permitted */
  OptionsOrType = "OPTIONS_OR_TYPE",
}

export type QuestionnaireAnswerCreateInput = {
  answer: QuestionnaireProvidedAnswerOptions;
  questionItemID: Scalars["String"]["input"];
};

export type QuestionnaireAnswerOptions = {
  __typename?: "QuestionnaireAnswerOptions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Minio url path */
  icon?: Maybe<Scalars["String"]["output"]>;
  /** Whether option is selected by default */
  initial_selected: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  item: QuestionnaireItems;
  /** Text display for this option */
  label?: Maybe<Scalars["String"]["output"]>;
  option_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  option_coding?: Maybe<Scalars["String"]["output"]>;
  option_date?: Maybe<Scalars["DateTime"]["output"]>;
  option_id: Scalars["String"]["output"];
  option_integer?: Maybe<Scalars["Float"]["output"]>;
  option_range?: Maybe<Range>;
  option_string?: Maybe<Scalars["String"]["output"]>;
  option_time?: Maybe<Scalars["String"]["output"]>;
  /** The order in which to display this option. */
  order?: Maybe<Scalars["Float"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type QuestionnaireAnswerOptionsInput = {
  booleanOption?: InputMaybe<Scalars["Boolean"]["input"]>;
  codingOption?: InputMaybe<Scalars["String"]["input"]>;
  dateOption?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Minio url path */
  icon?: InputMaybe<Scalars["String"]["input"]>;
  integerOption?: InputMaybe<Scalars["Float"]["input"]>;
  /** Whether option is selected by default */
  isInitiallySelected?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Text display for this option */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** True if option is part of question that allows multiple answers */
  multiOption?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The order in which to display this option. */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  rangeOption?: InputMaybe<RangeCreateInput>;
  stringOption?: InputMaybe<Scalars["String"]["input"]>;
  timeOption?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuestionnaireAnswerOptionsUpdateInput = {
  /** For items that have a defined set of allowed answers (via answerOption), indicates whether values other than those specified can be selected. */
  answerConstraint?: InputMaybe<QuestionnaireAnswerConstraint>;
  options?: InputMaybe<Array<AnswerOptionsUpdateInput>>;
};

/** All possible FHIR Questionnaire answer status codes. */
export enum QuestionnaireAnswerStatus {
  /** This QuestionnaireResponse has been filled out with answers, then marked as complete, yet changes or additions have been made to it afterwards. */
  Amended = "AMENDED",
  /** This QuestionnaireResponse has been filled out with answers and the current content is regarded as definitive. */
  Completed = "COMPLETED",
  /** This QuestionnaireResponse was entered in error and voided. */
  EnteredInError = "ENTERED_IN_ERROR",
  Incomplete = "INCOMPLETE",
  /** This QuestionnaireResponse has been partially filled out with answers but changes or additions are still expected to be made to it. */
  InProgress = "IN_PROGRESS",
  /** This QuestionnaireResponse has been partially filled out with answers but has been abandoned. No subsequent changes can be made. */
  Stopped = "STOPPED",
}

export type QuestionnaireAnswerUpdateInput = {
  answer: QuestionnaireProvidedAnswerOptions;
  answerID: Scalars["String"]["input"];
};

export type QuestionnaireAnswers = {
  __typename?: "QuestionnaireAnswers";
  answer_attachment?: Maybe<Scalars["String"]["output"]>;
  answer_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  answer_coding?: Maybe<Scalars["String"]["output"]>;
  answer_date?: Maybe<Scalars["DateTime"]["output"]>;
  answer_decimal?: Maybe<Scalars["Float"]["output"]>;
  answer_id: Scalars["String"]["output"];
  answer_integer?: Maybe<Scalars["Float"]["output"]>;
  answer_option?: Maybe<QuestionnaireAnswerOptions>;
  answer_quantity?: Maybe<Quantity>;
  answer_range?: Maybe<Range>;
  answer_string?: Maybe<Scalars["String"]["output"]>;
  answer_time?: Maybe<Scalars["String"]["output"]>;
  answer_uri?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Pointer to specific item from Questionnaire */
  link_id: Scalars["String"]["output"];
  question: QuestionnaireItems;
  source: QuestionnaireResponses;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type QuestionnaireChanges = ChangesEntity & {
  __typename?: "QuestionnaireChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  questionnaire: Questionnaires;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Questionnaire disabled display codes. */
export enum QuestionnaireDisabledDisplay {
  /** The item (and its children) should not be visible to the user at all. */
  Hidden = "HIDDEN",
  /** The item (and possibly its children) should not be selectable or editable but should still be visible - to allow the user to see what questions could have been completed had other answers caused the item to be enabled. */
  Protected = "PROTECTED",
}

/** All possible FHIR Questionnaire enable behavior codes */
export enum QuestionnaireEnableBehavior {
  /** Enable the question when all the enableWhen criteria are satisfied. */
  All = "ALL",
  /** Enable the question when any of the enableWhen criteria are satisfied. */
  Any = "ANY",
}

/** All possible FHIR Questionnaire enable operators */
export enum QuestionnaireEnableOperator {
  Equals = "EQUALS",
  Exists = "EXISTS",
  GreaterOrEquals = "GREATER_OR_EQUALS",
  GreaterThan = "GREATER_THAN",
  LessOrEquals = "LESS_OR_EQUALS",
  LessThan = "LESS_THAN",
  NotEquals = "NOT_EQUALS",
}

export type QuestionnaireEnableWhen = {
  __typename?: "QuestionnaireEnableWhen";
  answer_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  answer_coding?: Maybe<Scalars["String"]["output"]>;
  answer_date?: Maybe<Scalars["DateTime"]["output"]>;
  answer_decimal?: Maybe<Scalars["Float"]["output"]>;
  answer_integer?: Maybe<Scalars["Float"]["output"]>;
  answer_quantity?: Maybe<Quantity>;
  answer_string?: Maybe<Scalars["String"]["output"]>;
  answer_time?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  enable_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The linkId of question that determines whether item is enabled/disabled */
  link_id: Scalars["String"]["output"];
  /** Specifies the criteria by which the question is enabled. */
  operator: QuestionnaireEnableOperator;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type QuestionnaireEnableWhenAnswers = {
  booleanAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
  codingAnswer?: InputMaybe<Scalars["String"]["input"]>;
  dateAnswer?: InputMaybe<Scalars["DateTime"]["input"]>;
  decimalAnswer?: InputMaybe<Scalars["Float"]["input"]>;
  integerAnswer?: InputMaybe<Scalars["Float"]["input"]>;
  quantity?: InputMaybe<QuantityCreateInput>;
  stringAnswer?: InputMaybe<Scalars["String"]["input"]>;
  timeAnswer?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuestionnaireEnableWhenCreateInput = {
  answer: QuestionnaireEnableWhenAnswers;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  disabledDisplay?: InputMaybe<QuestionnaireDisabledDisplay>;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  enableBehavior: QuestionnaireEnableBehavior;
  linkId?: InputMaybe<Scalars["String"]["input"]>;
  operator: QuestionnaireEnableOperator;
  /** Unique id for the questionnaire question item this enable when indicator belongs to. */
  questionItemID: Scalars["String"]["input"];
};

export type QuestionnaireEnableWhenUpdateInput = {
  answer?: InputMaybe<QuestionnaireEnableWhenAnswers>;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  disabledDisplay?: InputMaybe<QuestionnaireDisabledDisplay>;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  enableBehavior?: InputMaybe<QuestionnaireEnableBehavior>;
  enableWhenID: Scalars["String"]["input"];
  linkId?: InputMaybe<Scalars["String"]["input"]>;
  operator?: InputMaybe<QuestionnaireEnableOperator>;
};

export type QuestionnaireFormCreateInput = {
  activePeriod?: InputMaybe<PeriodCreateInput>;
  description: Scalars["String"]["input"];
  /** Indicates if for testing purposes, not real usage. (defaults false) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Unique identifier for questionnaire form. */
  linkID: Scalars["String"]["input"];
  protocol?: InputMaybe<QuestionnaireLogicHandler>;
  purpose: Scalars["String"]["input"];
  questionnaireUrl?: InputMaybe<Scalars["String"]["input"]>;
  status: PublicationStatus;
  subjectType?: InputMaybe<Scalars["String"]["input"]>;
  /** Name for this questionnaire (human friendly) */
  title: Scalars["String"]["input"];
};

export type QuestionnaireFormUpdateInput = {
  activePeriod?: InputMaybe<PeriodCreateInput>;
  approvalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates if for testing purposes, not real usage. (defaults false) */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Unique identifier for questionnaire form. */
  linkID?: InputMaybe<Scalars["String"]["input"]>;
  protocol?: InputMaybe<QuestionnaireLogicHandler>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of question(s) on this questionnaire */
  questionTypes?: InputMaybe<QuestionnaireItemType>;
  questionnaireNumber: Scalars["Float"]["input"];
  questionnaireUrl?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  subjectType?: InputMaybe<Scalars["String"]["input"]>;
  /** Name for this questionnaire (human friendly) */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuestionnaireItemChanges = ChangesEntity & {
  __typename?: "QuestionnaireItemChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  question: QuestionnaireItems;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR Questionnaire item type codes. */
export enum QuestionnaireItemType {
  /** Question with binary content such as an image, PDF, etc. as an answer (valueAttachment). */
  Attachment = "ATTACHMENT",
  /** Question with a yes/no answer (valueBoolean). */
  Boolean = "BOOLEAN",
  /** Question with a Coding - generally drawn from a list of possible answers (valueCoding) */
  Coding = "CODING",
  /** Question with a date answer (valueDate). */
  Date = "DATE",
  /** Question with a date and time answer (valueDateTime). */
  DateTime = "DATE_TIME",
  /** Question with is a real number answer (valueDecimal). There is an extension 'http://hl7.org/fhir/StructureDefinition/questionnaire-unit' that can be used to computably convey the unit of measure associated with the answer for use when performing data extraction to an element of type Quantity. */
  Decimal = "DECIMAL",
  /** Text for display that will not capture an answer or have child items. */
  Display = "DISPLAY",
  /** An item with no direct answer but should have at least one child item. */
  Group = "GROUP",
  /** Question with an integer answer (valueInteger). There is an extension 'http://hl7.org/fhir/StructureDefinition/questionnaire-unit' that can be used to computably convey the unit of measure associated with the answer for use when performing data extraction to an element of type Quantity. */
  Integer = "INTEGER",
  /** Question with a combination of a numeric value and unit as an answer. (valueSimpleQuantity) There are two extensions ('http://hl7.org/fhir/StructureDefinition/questionnaire-unitOption' and 'http://hl7.org/fhir/StructureDefinition/questionnaire-unitValueSet') that can be used to define what unit should be selected for the Quantity.code and Quantity.system. */
  Quantity = "QUANTITY",
  /** An item that defines a specific answer to be captured, and which may have child items. (the answer provided in the QuestionnaireResponse should be of the defined datatype). */
  Question = "QUESTION",
  /** A radio field where multiple selections are supported. */
  RadioGroup = "RADIO_GROUP",
  /** Question with a reference to another resource (practitioner, organization, etc.) as an answer (valueReference). */
  Reference = "REFERENCE",
  /** Question with a short (few words to short sentence) free-text entry answer (valueString). Strings SHOULD NOT contain carriage return or newline characters. If multi-line answers are needed, use the 'text' type. */
  String = "STRING",
  /** Question with a long (potentially multi-paragraph) free-text entry answer (valueString). */
  Text = "TEXT",
  /** Question with a time (hour:minute:second) answer independent of date. (valueTime). */
  Time = "TIME",
  /** Question with a URL (website, FTP site, etc.) answer (valueUri). */
  Url = "URL",
}

export type QuestionnaireItems = {
  __typename?: "QuestionnaireItems";
  /** For items that have a defined set of allowed answers (via answerOption), indicates whether values other than those specified can be selected. */
  answer_constraint?: Maybe<QuestionnaireAnswerConstraint>;
  answer_options?: Maybe<Array<QuestionnaireAnswerOptions>>;
  /** Describes UI input layout configuration */
  appearance?: Maybe<LayoutConfiguration>;
  changes?: Maybe<Array<QuestionnaireItemChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  disabled_display: QuestionnaireDisabledDisplay;
  /** Controls how multiple enableWhen values are interpreted - whether all or any must be true. */
  enable_behavior: QuestionnaireEnableBehavior;
  enabled_when?: Maybe<QuestionnaireEnableWhen>;
  /** Tells the UI what type of form input this should render. */
  input_type: FormInputGroupType;
  is_archived: Scalars["Boolean"]["output"];
  item_id: Scalars["String"]["output"];
  /** The FHIR coding type of the questionnaire item. */
  item_type: QuestionnaireItemType;
  /** Unique id for item in questionnaire */
  link_id: Scalars["String"]["output"];
  /** The maximum number of characters that are permitted in the answer to be considered a "valid" QuestionnaireResponse. */
  max_length?: Maybe<Scalars["Float"]["output"]>;
  /** The order in which to display this question. */
  order: Scalars["Float"]["output"];
  /** E.g. "1(a)", "2.5.3" */
  prefix?: Maybe<Scalars["String"]["output"]>;
  questionnaire: Questionnaires;
  ready_only: Scalars["Boolean"]["output"];
  /** An indication, if true, that a QuestionnaireResponse for this item may include multiple answers associated with a single instance of this item (for question-type items) or multiple repetitions of the item (for group-type items). */
  repeats: Scalars["Boolean"]["output"];
  /** An indication, if true, that the item must be present in a "completed" QuestionnaireResponse. If false, the item may be skipped when answering the questionnaire. */
  required: Scalars["Boolean"]["output"];
  /** An alternative question text label to display when viewing completed form. */
  response_label?: Maybe<Scalars["String"]["output"]>;
  responses?: Maybe<Array<QuestionnaireAnswers>>;
  /** Primary text for for item */
  text: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Logic processing identifiers. Use when questionnaire responses need additional processing logic */
export enum QuestionnaireLogicHandler {
  McgeerUti = "MCGEER_UTI",
}

export type QuestionnaireProvidedAnswerOptions = {
  attachmentAnswer?: InputMaybe<Scalars["String"]["input"]>;
  booleanAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
  codingAnswer?: InputMaybe<Scalars["String"]["input"]>;
  dateAnswer?: InputMaybe<Scalars["DateTime"]["input"]>;
  decimalAnswer?: InputMaybe<Scalars["Float"]["input"]>;
  integerAnswer?: InputMaybe<Scalars["Float"]["input"]>;
  quantity?: InputMaybe<QuantityCreateInput>;
  rangeAnswer?: InputMaybe<RangeCreateInput>;
  /** Chosen optionId from originating questions answer options */
  selectAnswer?: InputMaybe<Scalars["String"]["input"]>;
  stringAnswer?: InputMaybe<Scalars["String"]["input"]>;
  timeAnswer?: InputMaybe<Scalars["String"]["input"]>;
  uriAnswer?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuestionnaireQuestionCreateInput = {
  /** unique questionnaire identifier number this questions a part of. */
  questionnaireNumber: Scalars["Float"]["input"];
  questions: Array<QuestionnaireQuestionInput>;
};

export type QuestionnaireQuestionInput = {
  answerOptions?: InputMaybe<BaseAnswerOptionsInput>;
  enableWhen?: InputMaybe<BaseEnableWhenInput>;
  /** Tells the UI what type of form input this should render. */
  inputType: FormInputGroupType;
  isReadOnly: Scalars["Boolean"]["input"];
  /** An indication, if true, that a QuestionnaireResponse for this item may include multiple answers associated with a single instance of this item (for question-type items) or multiple repetitions of the item (for group-type items). */
  isRepeating?: InputMaybe<Scalars["Boolean"]["input"]>;
  isRequired: Scalars["Boolean"]["input"];
  /** Describes to the UI how the input should be laid out, such as grid systems or positioning rules */
  layoutConfig?: InputMaybe<LayoutConfigurationInput>;
  /** Secondary linking identifier for this question item */
  linkId: Scalars["String"]["input"];
  /** The maximum number of characters that are permitted in the answer to be considered a "valid" QuestionnaireResponse. */
  maxAnswerLength?: InputMaybe<Scalars["Float"]["input"]>;
  /** The order in which to display this question. */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  questionPrefix?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary text for question. */
  questionText: Scalars["String"]["input"];
  /** The type of question on this question */
  questionType: QuestionnaireItemType;
  /** An alternative question text label to display when viewing completed form. */
  responseLabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuestionnaireQuestionUpdateInput = {
  answerOptions?: InputMaybe<QuestionnaireAnswerOptionsUpdateInput>;
  enableWhen?: InputMaybe<QuestionnaireEnableWhenUpdateInput>;
  question?: InputMaybe<QuestionUpdateInput>;
  questionItemID: Scalars["String"]["input"];
};

export type QuestionnaireResponseChanges = ChangesEntity & {
  __typename?: "QuestionnaireResponseChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  response: QuestionnaireResponses;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type QuestionnaireResponseCreateInput = {
  answers: Array<QuestionnaireAnswerCreateInput>;
  /** The care plan this response is based on */
  carePlanID?: InputMaybe<Scalars["String"]["input"]>;
  completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  patientId: Scalars["String"]["input"];
  /** unique questionnaire identifier number this response belongs to. */
  questionnaireNumber: Scalars["Float"]["input"];
  status: QuestionnaireAnswerStatus;
  /** The task this response fulfillment relates to */
  taskID?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuestionnaireResponseUpdateInput = {
  answers?: InputMaybe<Array<QuestionnaireAnswerUpdateInput>>;
  completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  responseID: Scalars["String"]["input"];
  status?: InputMaybe<QuestionnaireAnswerStatus>;
};

export type QuestionnaireResponses = {
  __typename?: "QuestionnaireResponses";
  answers: Array<QuestionnaireAnswers>;
  authored: Scalars["DateTime"]["output"];
  based_on?: Maybe<CarePlans>;
  changes?: Maybe<Array<QuestionnaireResponseChanges>>;
  completed_at?: Maybe<Scalars["DateTime"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  encounter?: Maybe<Encounters>;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  progress?: Maybe<Scalars["Float"]["output"]>;
  questionnaire: Questionnaires;
  response_id: Scalars["ID"]["output"];
  source: Patients;
  status: QuestionnaireAnswerStatus;
  task?: Maybe<Tasks>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Questionnaires = {
  __typename?: "Questionnaires";
  approval_date?: Maybe<Scalars["DateTime"]["output"]>;
  changes?: Maybe<Array<QuestionnaireChanges>>;
  /** Contact details for the publisher */
  contact?: Maybe<Contacts>;
  /** Use and/or publishing restrictions */
  copyright?: Maybe<Scalars["String"]["output"]>;
  /** Copyright holder and year(s) */
  copyright_label?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  /** When the questionnaire is expected to be used */
  effective_period?: Maybe<Periods>;
  /** For testing purposes, not real usage */
  experimental: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  last_review_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Unique id for questionnaire form. */
  link_id: Scalars["String"]["output"];
  /** Name for this questionnaire (computer friendly) */
  name: Scalars["String"]["output"];
  protocol?: Maybe<QuestionnaireLogicHandler>;
  publish_date: Scalars["DateTime"]["output"];
  /** Name of the publisher/steward (organization or individual) */
  publisher: Scalars["String"]["output"];
  purpose: Scalars["String"]["output"];
  questionnaire_number: Scalars["Float"]["output"];
  questions: Array<QuestionnaireItems>;
  responses?: Maybe<Array<QuestionnaireResponses>>;
  status: PublicationStatus;
  subject_type: Scalars["String"]["output"];
  /** Name for this questionnaire (human friendly) */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["String"]["output"];
  version_algorithm?: Maybe<Scalars["String"]["output"]>;
};

export type Range = {
  __typename?: "Range";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** The value of the high bound of the reference range. The high bound of the reference range endpoint is inclusive of the value (e.g. reference range is >=5 - <=9). If the high bound is omitted, it is assumed to be meaningless (e.g. reference range is >= 2.3). */
  high?: Maybe<Quantity>;
  is_archived: Scalars["Boolean"]["output"];
  /** The value of the low bound of the reference range. The low bound of the reference range endpoint is inclusive of the value (e.g. reference range is >=5 - <=9). If the low bound is omitted, it is assumed to be meaningless (e.g. reference range is <=2.3) */
  low?: Maybe<Quantity>;
  range_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RangeCreateInput = {
  high?: InputMaybe<QuantityCreateInput>;
  low?: InputMaybe<QuantityCreateInput>;
};

export type RangeSearch = {
  columnName: Scalars["String"]["input"];
  dateRange?: InputMaybe<Array<Scalars["String"]["input"]>>;
  numRange?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type RangeValue = {
  __typename?: "RangeValue";
  max: Scalars["Float"]["output"];
  min: Scalars["Float"]["output"];
};

export type Ratio = {
  __typename?: "Ratio";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  denominator: Quantity;
  is_archived: Scalars["Boolean"]["output"];
  numerator: Quantity;
  ratio_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RatioCreateInput = {
  denominator: QuantityCreateInput;
  numerator: QuantityCreateInput;
};

export type ReasonIdentifier = {
  reasonId: Scalars["ID"]["input"];
};

export type ReasonInput = {
  conditionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Will automatically generate Condition from code */
  icd10Code?: InputMaybe<Scalars["ID"]["input"]>;
  issueId?: InputMaybe<Scalars["ID"]["input"]>;
  observationId?: InputMaybe<Scalars["ID"]["input"]>;
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Category of a customer AR sub-ledger entry */
export enum ReceivableLedgerCategory {
  Adjustment = "ADJUSTMENT",
  CreditMemo = "CREDIT_MEMO",
  InvoicePosted = "INVOICE_POSTED",
  InvoiceVoided = "INVOICE_VOIDED",
  PaymentApplied = "PAYMENT_APPLIED",
  PaymentUnapplied = "PAYMENT_UNAPPLIED",
  WriteOff = "WRITE_OFF",
}

export type ReceivableLedgerEntries = {
  __typename?: "ReceivableLedgerEntries";
  account: BillingAccounts;
  /** Entry amount (always positive) */
  amount: Scalars["USCurrency"]["output"];
  category: ReceivableLedgerCategory;
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  currency: IsoCurrencyCodes;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** When the economic event occurred (vs. when recorded) */
  effective_date: Scalars["DateTime"]["output"];
  entry_id: Scalars["ID"]["output"];
  /** Auto-assigned receivable ledger entry number */
  entry_number: Scalars["String"]["output"];
  event?: Maybe<GatewayWebhookEvents>;
  external_reference_id?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Outstanding receivable after this entry */
  running_balance: Scalars["USCurrency"]["output"];
  source?: Maybe<ReceivableLedgerSourceUnion>;
  source_type?: Maybe<ReceivableLedgerSourceType>;
  type: LedgerEntryType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Source discriminator for a receivable sub-ledger entry */
export enum ReceivableLedgerSourceType {
  Allocation = "ALLOCATION",
  Invoice = "INVOICE",
}

export type ReceivableLedgerSourceUnion = Invoices | PaymentAllocations;

export type ReceiveResultsResponse = {
  __typename?: "ReceiveResultsResponse";
  /** Operation result message */
  message: Scalars["String"]["output"];
  /** DiagnosticReport UUID created */
  reportId?: Maybe<Scalars["String"]["output"]>;
  /** Whether the operation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** All possible FHIR recommendation strength codes. */
export enum RecommendationStrength {
  /** Ordered recommendation. */
  Ordered = "ORDERED",
  /** Strong recommendation. */
  Strong = "STRONG",
  /** Weak recommendation. */
  Weak = "WEAK",
}

/** Which side of a shared collection a read should return */
export enum RecordAccessScope {
  All = "ALL",
  Owned = "OWNED",
  Shared = "SHARED",
}

export type RecordFieldMatchProbabilities = {
  __typename?: "RecordFieldMatchProbabilities";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  field: RecordMatchingRuleFields;
  is_archived: Scalars["Boolean"]["output"];
  key: Scalars["ID"]["output"];
  match_probability: Scalars["Float"]["output"];
  probability_id: Scalars["ID"]["output"];
  rule: RecordMatchingRules;
  unmatch_probability: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RecordFieldMatchProbabilityCreateInput = {
  /** Reference Id of Record Matching rule field associated with field probability */
  fieldId: Scalars["ID"]["input"];
  probability: RecordFieldMatchProbabilityMetricInput;
  /** Reference Id of Record Matching rule associated with field probability */
  ruleId: Scalars["ID"]["input"];
};

export type RecordFieldMatchProbabilityDefinitionCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Display friendly name for target field */
  fieldLabel: Scalars["String"]["input"];
  /** The probability that two matched record should have the same value */
  matchProbability: Scalars["Float"]["input"];
  /** Name for definition */
  name: Scalars["String"]["input"];
  unmatchProbability: Scalars["Float"]["input"];
  version?: InputMaybe<Scalars["String"]["input"]>;
  versionStatus?: InputMaybe<RecordVersionStatus>;
};

export type RecordFieldMatchProbabilityDefinitionDeleteInput = {
  definitionId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RecordFieldMatchProbabilityDefinitionUpdateInput = {
  definitionId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Display friendly name for target field */
  fieldLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** The probability that two matched record should have the same value */
  matchProbability?: InputMaybe<Scalars["Float"]["input"]>;
  /** Name for definition */
  name?: InputMaybe<Scalars["String"]["input"]>;
  unmatchProbability?: InputMaybe<Scalars["Float"]["input"]>;
  version?: InputMaybe<Scalars["String"]["input"]>;
  versionStatus?: InputMaybe<RecordVersionStatus>;
};

export type RecordFieldMatchProbabilityDefinitions = {
  __typename?: "RecordFieldMatchProbabilityDefinitions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  field_label: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  match_probability: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  unmatch_probability: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["SemVer"]["output"];
  version_status: RecordVersionStatus;
};

export type RecordFieldMatchProbabilityMetricInput = {
  /** Reference to the probability definition this record adheres to */
  definitionId?: InputMaybe<Scalars["ID"]["input"]>;
  values?: InputMaybe<FelligiSunterMatchProbability>;
};

export type RecordFieldMatchProbabilityUpdateInput = {
  probability?: InputMaybe<RecordFieldMatchProbabilityMetricInput>;
  probabilityId: Scalars["ID"]["input"];
};

/** List of possible record matching entity types */
export enum RecordMatchEntityType {
  Addresses = "Addresses",
  ContactDetails = "ContactDetails",
  CynergyUsers = "CynergyUsers",
  Demographics = "Demographics",
}

/** List of methods to use when scoring record matches */
export enum RecordMatchScoringMethod {
  Average = "Average",
  Maximum = "Maximum",
  Minimum = "Minimum",
  WeightedAverage = "WeightedAverage",
}

/** List of record matching algorithms */
export enum RecordMatchingAlgorithm {
  CharacterFrequency = "CharacterFrequency",
  DoubleMetaphone = "DoubleMetaphone",
  EditDistance = "EditDistance",
  Exact = "Exact",
  JaroWinkler = "JaroWinkler",
  KeyboardDistance = "KeyboardDistance",
  NameVariant = "NameVariant",
  PhoneSimilarity = "PhoneSimilarity",
}

/** List field types to assignment to record matching rule field */
export enum RecordMatchingFieldType {
  BusinessName = "BusinessName",
  City = "City",
  DateOfBirth = "DateOfBirth",
  Email = "Email",
  Fax = "Fax",
  FirstName = "FirstName",
  LastName = "LastName",
  MiddleName = "MiddleName",
  Phone = "Phone",
  Street = "Street",
  Title = "Title",
  Zip = "Zip",
}

export type RecordMatchingRuleCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Specifies field matching behavior */
  engine?: InputMaybe<RecordMatchingRuleEngine>;
  fields?: InputMaybe<Array<RecordMatchingRuleFieldInput>>;
  /** Display name for rule */
  label: Scalars["String"]["input"];
  matchingEquation?: InputMaybe<Scalars["String"]["input"]>;
  /** Object type for which this rule is based on */
  objectType: RecordMatchEntityType;
  parentObjectType?: InputMaybe<RecordMatchEntityType>;
  status?: InputMaybe<RecordMatchingRuleStatus>;
};

export type RecordMatchingRuleDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  ruleId: Scalars["ID"]["input"];
};

/** Engine to use when evaluating record matches */
export enum RecordMatchingRuleEngine {
  Exact = "Exact",
  Fuzzy = "Fuzzy",
}

export type RecordMatchingRuleFieldActionInput = {
  add?: InputMaybe<Array<RecordMatchingRuleFieldInput>>;
  remove?: InputMaybe<Array<RecordMatchingRuleFieldDeleteInput>>;
  set?: InputMaybe<Array<RecordMatchingRuleFieldInput>>;
  update?: InputMaybe<RecordMatchingRuleFieldUpdateInput>;
};

export type RecordMatchingRuleFieldDeleteInput = {
  fieldId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RecordMatchingRuleFieldInput = {
  field: Scalars["String"]["input"];
  /** Type of field */
  fieldType?: InputMaybe<RecordMatchingFieldType>;
  /** Display friendly field label */
  label: Scalars["String"]["input"];
  /** Ignore blank fields? */
  matchBlank?: InputMaybe<Scalars["Boolean"]["input"]>;
  matchProbability: RecordFieldMatchProbabilityMetricInput;
  matchingMethod?: InputMaybe<Array<RecordMatchingAlgorithm>>;
  /** Sort order */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  scoringMethod: RecordMatchScoringMethod;
  status?: InputMaybe<RecordMatchingRuleStatus>;
  /** Score threshold */
  threshold: Scalars["Float"]["input"];
};

export type RecordMatchingRuleFieldUpdateInput = {
  fieldId: Scalars["ID"]["input"];
  /** Type of field */
  fieldType?: InputMaybe<RecordMatchingFieldType>;
  /** Display friendly field label */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Ignore blank fields? */
  matchBlank?: InputMaybe<Scalars["Boolean"]["input"]>;
  matchProbability?: InputMaybe<RecordFieldMatchProbabilityMetricInput>;
  matchingMethod?: InputMaybe<Array<RecordMatchingAlgorithm>>;
  /** Sort order */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  scoringMethod?: InputMaybe<RecordMatchScoringMethod>;
  status?: InputMaybe<RecordMatchingRuleStatus>;
  /** Score threshold */
  threshold?: InputMaybe<Scalars["Float"]["input"]>;
};

export type RecordMatchingRuleFields = {
  __typename?: "RecordMatchingRuleFields";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  field: Scalars["String"]["output"];
  field_id: Scalars["ID"]["output"];
  field_type?: Maybe<RecordMatchingFieldType>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  match_blank: Scalars["Boolean"]["output"];
  match_probability?: Maybe<RecordFieldMatchProbabilities>;
  matching_method: Array<RecordMatchingAlgorithm>;
  order: Scalars["Float"]["output"];
  rule: RecordMatchingRules;
  scoring_method: RecordMatchScoringMethod;
  status: RecordMatchingRuleStatus;
  threshold: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RecordMatchingRulePaginatedResults = {
  __typename?: "RecordMatchingRulePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<RecordMatchingRules>;
  totalPages: Scalars["Float"]["output"];
};

/** Available statuses for RecordMatchingRule objects */
export enum RecordMatchingRuleStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export type RecordMatchingRuleUpdateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Specifies field matching behavior */
  engine?: InputMaybe<RecordMatchingRuleEngine>;
  fields?: InputMaybe<RecordMatchingRuleFieldActionInput>;
  /** Display name for rule */
  label?: InputMaybe<Scalars["String"]["input"]>;
  matchingEquation?: InputMaybe<Scalars["String"]["input"]>;
  ruleId: Scalars["ID"]["input"];
  status?: InputMaybe<RecordMatchingRuleStatus>;
};

export type RecordMatchingRules = {
  __typename?: "RecordMatchingRules";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  engine: RecordMatchingRuleEngine;
  fields?: Maybe<Array<RecordMatchingRuleFields>>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  matching_equation?: Maybe<Scalars["String"]["output"]>;
  object_type: RecordMatchEntityType;
  parent_object_type?: Maybe<RecordMatchEntityType>;
  probabilities?: Maybe<Array<RecordFieldMatchProbabilities>>;
  rule_id: Scalars["ID"]["output"];
  status: RecordMatchingRuleStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RecordMergeRequestInput = {
  fieldOverrides?: InputMaybe<Array<MergeFieldOverrideInput>>;
  masterRecordId: Scalars["ID"]["input"];
  objectType: RecordMatchEntityType;
  /** Limit of 3 */
  recordToMergeIds: Array<Scalars["String"]["input"]>;
};

export type RecordSearch = {
  booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  columnName: Scalars["String"]["input"];
  numberValues?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  stringValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Level of access a share grants over the record it points at */
export enum RecordShareAccessLevel {
  All = "ALL",
  Edit = "EDIT",
  Read = "READ",
}

/** List of record version status codes */
export enum RecordVersionStatus {
  Latest = "LATEST",
  Outdated = "OUTDATED",
}

export type RecordsDeleted = {
  __typename?: "RecordsDeleted";
  count: Scalars["Float"]["output"];
};

export type RecurrenceDayInWeekInput = {
  /** Indicates the day of the week the recurring event should occur (each nth weekOfMonth) */
  dayOfWeek: DaysOfWeek;
  /** Indicates which week of the month the event should occur */
  weekOfMonth: WeekOfMonth;
};

export type RecurrencePatternCreateInput = {
  /** Dates that should be excluded from recurrence, such as holidays */
  dateExclusions?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  /** Date when the recurrence should end */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** recurring sequence(s) that should be skipped */
  excludedSequences?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  /** Specific dates for a recurring set of events */
  occurrenceDates?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  /** Recurrence pattern (Union) */
  pattern: RecurrencePatternInput;
  /** Number of events that are planned in the recurrence */
  plannedOccurrences?: InputMaybe<Scalars["Float"]["input"]>;
  /** Date and time when the recurrence will take effect */
  startDate: Scalars["DateTime"]["input"];
  /** Timezone of the occurrences */
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type RecurrencePatternInput = {
  monthly?: InputMaybe<MonthlyRecurrencePatternCreateInput>;
  weekly?: InputMaybe<WeeklyRecurrencePatternCreateInput>;
};

export type RecurrencePatternManageInput = {
  monthly?: InputMaybe<MonthlyRecurrencePatternActionInput>;
  patternId: Scalars["ID"]["input"];
  weekly?: InputMaybe<WeeklyRecurrencePatternActionInput>;
};

export type RecurrencePatternPaginatedResults = {
  __typename?: "RecurrencePatternPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<RecurrencePatterns>;
  totalPages: Scalars["Float"]["output"];
};

export type RecurrencePatterns = {
  __typename?: "RecurrencePatterns";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["ID"]["output"];
  /** Any dates that should be excluded from recurrence such as holidays. */
  date_exclusions?: Maybe<Array<Scalars["DateTime"]["output"]>>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Textual description of recurrence template */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Date when the recurrence will end */
  end_date?: Maybe<Scalars["String"]["output"]>;
  /** Frequency pattern of recurrence */
  frequency?: Maybe<FrequencyPattern>;
  is_archived: Scalars["Boolean"]["output"];
  /** Information about monthly recurring events */
  monthly?: Maybe<MonthlyRecurrencePatterns>;
  /** Number of events that are planned in the recurrence. */
  occurrence_count?: Maybe<Scalars["Float"]["output"]>;
  /** Specific dates for a recurring set of events */
  occurrence_dates?: Maybe<Array<Scalars["DateTime"]["output"]>>;
  pattern_id: Scalars["ID"]["output"];
  /** Any recurrences that should be skipped */
  sequence_exclusions?: Maybe<Array<Scalars["Float"]["output"]>>;
  /** Date and time when the recurrence will take effect */
  start_date: Scalars["DateTime"]["output"];
  /** Textual representation of the recurrence pattern */
  text?: Maybe<Scalars["String"]["output"]>;
  /** Timezone of the ocurrences */
  timezone?: Maybe<Scalars["TimeZone"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Information about weekly recurring events */
  weekly?: Maybe<WeeklyRecurrencePatterns>;
  /** Information about monthly recurring events */
  yearly?: Maybe<YearlyRecurrencePatterns>;
};

export type RecurrenceSchedulePreview = {
  __typename?: "RecurrenceSchedulePreview";
  /** Recurrence dates derived from pattern */
  dates: Array<Scalars["DateTime"]["output"]>;
  /** Human-friendly text representation */
  text: Scalars["String"]["output"];
};

export type RecurrenceScheduleRenewalWindow = {
  __typename?: "RecurrenceScheduleRenewalWindow";
  end: Scalars["DateTime"]["output"];
  start: Scalars["DateTime"]["output"];
};

export type ReferenceCreateInput = {
  /** Text display for reference */
  display: Scalars["String"]["input"];
  identifier?: InputMaybe<IdentifierCreateInput>;
  /** A reference to a location at which the other resource is found. The reference may be a relative reference, in which case it is relative to the service base URL, or an absolute URL that resolves to the location where the resource is found. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** Resource type the reference refers to (e.g. "Patients") */
  type: Scalars["String"]["input"];
};

export type ReferencePayloadInput = {
  /** Text display for reference */
  display: Scalars["String"]["input"];
  identifier?: InputMaybe<IdentifierCreateInput>;
  /** A reference to a location at which the other resource is found. The reference may be a relative reference, in which case it is relative to the service base URL, or an absolute URL that resolves to the location where the resource is found. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** Resource type the reference refers to (e.g. "Patients") */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR reference range meaning codes. */
export enum ReferenceRangeMeaning {
  Critical = "CRITICAL",
  Endocrine = "ENDOCRINE",
  FirstTrimester = "FIRST_TRIMESTER",
  Follicular = "FOLLICULAR",
  HighRange = "HIGH_RANGE",
  LowRange = "LOW_RANGE",
  Luteal = "LUTEAL",
  Midcycle = "MIDCYCLE",
  Normal = "NORMAL",
  Ovulatory = "OVULATORY",
  Post = "POST",
  Postmenopausal = "POSTMENOPAUSAL",
  Pre = "PRE",
  PrePuberty = "PRE_PUBERTY",
  Recommended = "RECOMMENDED",
  SecondTrimester = "SECOND_TRIMESTER",
  Therapeutic = "THERAPEUTIC",
  ThirdTrimester = "THIRD_TRIMESTER",
  Treatment = "TREATMENT",
  Type = "TYPE",
}

export type ReferenceUpdateInput = {
  /** Text display for reference */
  display?: InputMaybe<Scalars["String"]["input"]>;
  identifier?: InputMaybe<IdentifierCreateInput>;
  /** A reference to a location at which the other resource is found. The reference may be a relative reference, in which case it is relative to the service base URL, or an absolute URL that resolves to the location where the resource is found. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  referenceId: Scalars["ID"]["input"];
  /** Resource type the reference refers to (e.g. "Patients") */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReferenceUpsertInput = {
  /** Text display for reference */
  display: Scalars["String"]["input"];
  identifier?: InputMaybe<IdentifierCreateInput>;
  /** A reference to a location at which the other resource is found. The reference may be a relative reference, in which case it is relative to the service base URL, or an absolute URL that resolves to the location where the resource is found. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  referenceId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Resource type the reference refers to (e.g. "Patients") */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type References = {
  __typename?: "References";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Text alternative for the resource */
  display: Scalars["String"]["output"];
  /** Logical reference, when literal reference is unknown */
  identifier?: Maybe<Identifiers>;
  is_archived: Scalars["Boolean"]["output"];
  /** A reference to a location at which the other resource is found. The reference may be a relative reference, in which case it is relative to the service base URL, or an absolute URL that resolves to the location where the resource is found. */
  reference?: Maybe<Scalars["String"]["output"]>;
  reference_id: Scalars["String"]["output"];
  /** Resource type the reference refers to (e.g. "Patients") */
  type: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RefundBalances = {
  __typename?: "RefundBalances";
  /** Original refund amount */
  amount: Scalars["USCurrency"]["output"];
  /** Unapplied remainder of the refund */
  balance: Scalars["USCurrency"]["output"];
  /** Net amount applied against payments */
  net_applied: Scalars["USCurrency"]["output"];
  refund_id: Scalars["ID"]["output"];
  /** Sum of APPLIED refund lines */
  total_applied: Scalars["USCurrency"]["output"];
  /** Sum of UNAPPLIED refund lines */
  total_unapplied: Scalars["USCurrency"]["output"];
};

/** List of refund line instance types */
export enum RefundLineInstanceType {
  Applied = "APPLIED",
  Unapplied = "UNAPPLIED",
}

export type RefundLines = {
  __typename?: "RefundLines";
  amount: Scalars["USCurrency"]["output"];
  comments?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  line_id: Scalars["ID"]["output"];
  /** Referenced payment this refund applies to */
  payment: Payments;
  /** The updated referenced payment balance following the applied or unapplied refund line */
  payment_balance?: Maybe<Scalars["USCurrency"]["output"]>;
  /** Date the refund was either applied or unapplied to payment */
  processed_date: Scalars["DateTime"]["output"];
  /** The refund container this line applies to */
  refund: Refunds;
  /** The updated referenced refund balance following the applied or unapplied refund line */
  refund_balance?: Maybe<Scalars["USCurrency"]["output"]>;
  type: RefundLineInstanceType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Refunds = {
  __typename?: "Refunds";
  /** The user account containing the payment this refund targets */
  account: BillingAccounts;
  /** Refund amount */
  amount: Scalars["USCurrency"]["output"];
  /** Derived applied totals and remaining balance (computed on read) */
  balances?: Maybe<RefundBalances>;
  /** Date the refund was cancelled */
  cancellation_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Reason the refund was cancelled */
  cancellation_reason?: Maybe<Scalars["String"]["output"]>;
  /** Refund cancellation result code */
  cancellation_result_code?: Maybe<PaymentGatewayResultCodes>;
  comments?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  events?: Maybe<Array<PaymentGatewayEvents>>;
  /** Payment gateway responsible for processing the refund */
  gateway?: Maybe<PaymentGateways>;
  /** Payment gateway result code */
  gateway_result_code?: Maybe<Scalars["String"]["output"]>;
  /** Reason for the gateway result */
  gateway_result_reason?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Refund lines of the overall refund */
  lines?: Maybe<Array<RefundLines>>;
  metadata?: Maybe<PaymentMetadata>;
  /** Reference to the payment this refund applies to */
  payment?: Maybe<Payments>;
  /** The payment method that was used for the payment being refunded */
  payment_method?: Maybe<PaymentMethods>;
  payment_summary?: Maybe<OrderPaymentSummaries>;
  refund_id: Scalars["ID"]["output"];
  /** Payment authorization result code */
  result_code?: Maybe<PaymentGatewayResultCodes>;
  status: PaymentStatusCodes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RegisterDeviceGatewayResponse = {
  __typename?: "RegisterDeviceGatewayResponse";
  /** True if the device was newly created, false if it already existed */
  created?: Maybe<Scalars["Boolean"]["output"]>;
  /** Device UUID of the registered gateway */
  deviceId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
};

export type RegisterUserInput = {
  applicationId: Scalars["ID"]["input"];
  password: Scalars["String"]["input"];
  profile: CynergyUserProfileCreateInput;
};

/** All possible FHIR rejection criteria section codes. */
export enum RejectionCriteria {
  Broken = "BROKEN",
  Clotted = "CLOTTED",
  Hemolized = "HEMOLIZED",
  Insufficient = "INSUFFICIENT",
  WrongTemperature = "WRONG_TEMPERATURE",
}

/** All applicable related person types */
export enum RelatedPersonTypes {
  AdoptedChild = "Adopted_Child",
  AdoptedDaughter = "Adopted_Daughter",
  AdoptedSon = "Adopted_Son",
  Aunt = "Aunt",
  Brother = "Brother",
  BrotherInLaw = "Brother_In_Law",
  Child = "Child",
  ChildInLaw = "Child_In_law",
  Cousin = "Cousin",
  Daughter = "Daughter",
  DaughterInLaw = "Daughter_In_Law",
  ExtendedFamilyMember = "Extended_Family_Member",
  FamilyMember = "Family_Member",
  Father = "Father",
  FatherInLaw = "Father_In_Law",
  Fiance = "Fiance",
  FosterChild = "Foster_Child",
  FosterDaughter = "Foster_Daughter",
  FosterSon = "Foster_Son",
  Grandchild = "Grandchild",
  Granddaughter = "Granddaughter",
  Grandfather = "Grandfather",
  Grandmother = "Grandmother",
  Grandparent = "Grandparent",
  Grandson = "Grandson",
  GreatGrandfather = "Great_Grandfather",
  GreatGrandmother = "Great_Grandmother",
  GreatGrandparent = "Great_Grandparent",
  Husband = "Husband",
  InLaw = "In_Law",
  Mother = "Mother",
  MotherInLaw = "Mother_In_Law",
  Neighbor = "Neighbor",
  Nephew = "Nephew",
  Niece = "Niece",
  Parent = "Parent",
  ParentInLaw = "Parent_In_Law",
  Roommate = "Roommate",
  Self = "Self",
  Sibling = "Sibling",
  SiblingInLaw = "Sibling_In_Law",
  Sister = "Sister",
  SisterInLaw = "Sister_In_Law",
  Son = "Son",
  SonInLaw = "Son_In_Law",
  Spouse = "Spouse",
  StepChild = "Step_Child",
  StepParent = "Step_Parent",
  Stepbrother = "Stepbrother",
  Stepdaughter = "Stepdaughter",
  Stepfather = "Stepfather",
  Stepmother = "Stepmother",
  Stepsister = "Stepsister",
  Stepson = "Stepson",
  Uncle = "Uncle",
  UnrelatedFriend = "Unrelated_Friend",
  Wife = "Wife",
}

export type RelayTaskSteps = {
  __typename?: "RelayTaskSteps";
  /** Date time the assignee completed task step */
  completed_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Application navigation link. */
  link?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** The sequential order of this step. */
  order: Scalars["Float"]["output"];
  /** Percentage completion of task */
  progress: Scalars["Float"]["output"];
  /** Is this step required to complete task? */
  required: Scalars["Boolean"]["output"];
  /** Date time the assignee started task */
  started_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  status: TaskStatus;
  step_id: Scalars["ID"]["output"];
  task: RelayTasks;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type RelayTasks = {
  __typename?: "RelayTasks";
  /** Request fulfilled by this task */
  based_on: References;
  /** E.g. "Specimen collected", "IV prepped" */
  business_status: Scalars["String"]["output"];
  /** Task type */
  code: TaskCode;
  /** Comments made about the task */
  comments?: Maybe<Array<Annotations>>;
  /** Date time the task completed */
  completed_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  /** True if task is prohibiting action. */
  do_not_perform: Scalars["Boolean"]["output"];
  encounter_id?: Maybe<Scalars["ID"]["output"]>;
  /** Start and end time of execution */
  execution_period?: Maybe<Periods>;
  /** What task is acting on. (I.e. lab DiagnosticService) */
  focus: References;
  /** Requisition or grouper id */
  group_identifier?: Maybe<Identifiers>;
  /** Action of task */
  intent: TaskIntent;
  is_archived: Scalars["Boolean"]["output"];
  /** Label used to categorize task. */
  label: TaskLabels;
  last_modified?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Application navigation link. */
  link?: Maybe<Scalars["String"]["output"]>;
  location_id: Scalars["ID"]["output"];
  notification_id?: Maybe<Scalars["ID"]["output"]>;
  patient_id: Scalars["ID"]["output"];
  performer_assignment_id: Scalars["ID"]["output"];
  performer_organization_id: Scalars["ID"]["output"];
  performer_patient_id: Scalars["ID"]["output"];
  performer_practitioner_id: Scalars["ID"]["output"];
  /** Indicates how quickly the Task should be addressed with respect to other requests. */
  priority: RequestPriority;
  /** Percentage completion of task */
  progress: Scalars["Float"]["output"];
  /** Why task is needed */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** When the task should be performed */
  requested_period?: Maybe<Periods>;
  requester_assignment_id: Scalars["ID"]["output"];
  requester_organization_id: Scalars["ID"]["output"];
  requester_patient_id: Scalars["ID"]["output"];
  requester_practitioner_id: Scalars["ID"]["output"];
  /** Date time the task started */
  started_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  status: TaskStatus;
  status_reason?: Maybe<Scalars["String"]["output"]>;
  /** Task steps */
  steps?: Maybe<Array<RelayTaskSteps>>;
  task_id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ReminderFrequency = {
  __typename?: "ReminderFrequency";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  frequency: Quantity;
  frequency_id: Scalars["String"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  last_reminder_date?: Maybe<Scalars["DateTime"]["output"]>;
  next_reminder_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Flags whether or not a reminder should be sent */
  remind: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ReminderFrequencyCreateInput = {
  frequency: FrequencyCreateInput;
  isActive: Scalars["Boolean"]["input"];
  lastReminderDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  nextReminderDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Flag whether or not a reminder should be sent. Default(false) */
  shouldRemind?: InputMaybe<Scalars["Boolean"]["input"]>;
  title: Scalars["String"]["input"];
};

export type RemoveFromCollectionInput = {
  collection: UserCollectionIdentifier;
  entry: CollectionEntryIdentifierInput;
};

export type ReorderTrackedTestsInput = {
  trackingIdsInOrder: Array<Scalars["ID"]["input"]>;
  userId: Scalars["ID"]["input"];
};

export enum ReportFormat {
  Csv = "CSV",
  Pdf = "PDF",
}

export type ReportInformationReferenceInput = {
  observationId?: InputMaybe<Scalars["String"]["input"]>;
  reportId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReportSummaryInput = {
  dateRange?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Defaults to CSV. */
  format?: InputMaybe<ReportFormat>;
  /** Entity that the report data pertains to. */
  requester?: InputMaybe<RequesterInput>;
};

/** All possible FHIR request intent codes */
export enum RequestIntent {
  Directive = "DIRECTIVE",
  FillerOrder = "FILLER_ORDER",
  InstanceOrder = "INSTANCE_ORDER",
  Option = "OPTION",
  Order = "ORDER",
  OriginalOrder = "ORIGINAL_ORDER",
  Plan = "PLAN",
  Proposal = "PROPOSAL",
  ReflexOrder = "REFLEX_ORDER",
}

export type RequestOccurrenceInput = {
  dateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  period?: InputMaybe<PeriodCreateInput>;
};

export type RequestPasswordResetInput = {
  /** Email, username or phone number linked to account */
  identifier: Scalars["String"]["input"];
};

/** All possible service request priorities */
export enum RequestPriority {
  Asap = "ASAP",
  Low = "LOW",
  Routine = "ROUTINE",
  Stat = "STAT",
  Urgent = "URGENT",
}

export type RequestRecipient = {
  recipientReferenceId: Scalars["ID"]["input"];
};

export type RequestRequisitionDocumentActionInput = {
  add?: InputMaybe<DocumentReferenceCreateInput>;
  remove?: InputMaybe<DocumentReferenceDeleteInput>;
  update?: InputMaybe<DocumentReferenceUpdateInput>;
};

export type RequestRequisitionDocumentManageInput = {
  action: RequestRequisitionDocumentActionInput;
  serviceRequestId: Scalars["ID"]["input"];
};

/** All possible FHIR request resource type codes. */
export enum RequestResourceType {
  /** https://build.fhir.org/valueset-request-resource-types.html */
  Appointment = "APPOINTMENT",
  /** A reply to an appointment request for a patient and/or practitioner(s), such as a confirmation or rejection. */
  AppointmentResponse = "APPOINTMENT_RESPONSE",
  /** Describes the intention of how one or more practitioners intend to deliver care for a particular patient, group or community for a period of time, possibly limited to care for a specific condition or set of conditions. */
  CarePlan = "CARE_PLAN",
  /** A provider issued list of professional services and products which have been provided, or are to be provided, to a patient which is sent to an insurer for reimbursement. */
  Claim = "CLAIM",
  /** A request to convey information; e.g. the CDS system proposes that an alert be sent to a responsible provider, the CDS system proposes that the public health agency be notified about a reportable condition. */
  CommunicationRequest = "COMMUNICATION_REQUEST",
  /** The CoverageEligibilityRequest provides patient and insurance coverage information to an insurer for them to respond, in the form of an CoverageEligibilityResponse, with information regarding whether the stated coverage is valid and in-force and optionally to provide the insurance details of the policy. */
  CoverageEligibilityRequest = "COVERAGE_ELIGIBILITY_REQUEST",
  /** Represents a request a device to be provided to a specific patient. The device may be an implantable device to be subsequently implanted, or an external assistive device, such as a walker, to be delivered and subsequently be used. */
  DeviceRequest = "DEVICE_REQUEST",
  /** This resource provides the insurance enrollment details to the insurer regarding a specified coverage. */
  EnrollmentRequest = "ENROLLMENT_REQUEST",
  /** A patient's point-in-time set of recommendations (i.e. forecasting) according to a published schedule with optional supporting justification. */
  ImmunizationRecommendation = "IMMUNIZATION_RECOMMENDATION",
  /** An order or request for both supply of the medication and the instructions for administration of the medication to a patient. The resource is called "MedicationRequest" rather than "MedicationPrescription" or "MedicationOrder" to generalize the use across inpatient and outpatient settings, including care plans, etc., and to harmonize with workflow patterns. */
  MedicationRequest = "MEDICATION_REQUEST",
  /** A request to supply a diet, formula feeding (enteral) or oral nutritional supplement to a patient/resident. */
  NutritionOrder = "NUTRITION_ORDER",
  /** A set of related requests that can be used to capture intended activities that have inter-dependencies such as "give this medication after that one". */
  RequestOrchestration = "REQUEST_ORCHESTRATION",
  /** A record of a request for service such as diagnostic investigations, treatments, or operations to be performed. */
  ServiceRequest = "SERVICE_REQUEST",
  /** A record of a non-patient specific request for a medication, substance, device, certain types of biologically derived product, and nutrition product used in the healthcare setting. */
  SupplyRequest = "SUPPLY_REQUEST",
  /** A task to be performed. */
  Task = "TASK",
  /** Record of transport. */
  Transport = "TRANSPORT",
  /** An authorization for the provision of glasses and/or contact lenses to a patient. */
  VisionPrescription = "VISION_PRESCRIPTION",
}

/** All possible FHIR request status codes */
export enum RequestStatus {
  Active = "ACTIVE",
  Completed = "COMPLETED",
  Draft = "DRAFT",
  EnteredInError = "ENTERED_IN_ERROR",
  OnHold = "ON_HOLD",
  Revoked = "REVOKED",
  Unknown = "UNKNOWN",
}

export type RequestSubjectInput = {
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RequesterInput = {
  assignmentId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  locationId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  organizationId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  patientId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  practitionerId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type RequiredLegalAcceptance = {
  __typename?: "RequiredLegalAcceptance";
  documentId: Scalars["ID"]["output"];
  effectiveAt: Scalars["Date"]["output"];
  /** URL to the English version of the document (always available) */
  englishUrl: Scalars["URL"]["output"];
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  /** Available translations for this document in other languages. Frontend can display language selector if translations exist. */
  translations?: Maybe<Array<LegalDocumentTranslation>>;
  typeCode: Scalars["String"]["output"];
  typeName: Scalars["String"]["output"];
  version: Scalars["String"]["output"];
};

export type RequisitionEmailSendoutResponse = {
  __typename?: "RequisitionEmailSendoutResponse";
  message: Scalars["String"]["output"];
  status: Scalars["Float"]["output"];
};

export type ResendVerificationEmailInput = {
  userType: UserTypes;
};

export type ResourceUnion = Icd10 | Identifiers | Parameters | References;

export type ReviewStatusInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  reviewedBy?: InputMaybe<ReviewStatusReviewerInput>;
};

export type ReviewStatusReviewerInput = {
  /** Name of reviewer */
  name: Scalars["String"]["input"];
  timestamp?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
};

export type ReviewStatuses = {
  __typename?: "ReviewStatuses";
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Has been reviewed */
  is_reviewed: Scalars["Boolean"]["output"];
  /** Date and time of review */
  reviewed_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  reviewed_by?: Maybe<Scalars["String"]["output"]>;
  /** Reviewer cynergy account id */
  reviewer_account_id: Scalars["ID"]["output"];
  reviewer_role?: Maybe<Scalars["String"]["output"]>;
  status_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RouteAssignmentInput = {
  scheduleDate: Scalars["DateTime"]["input"];
  staffId: Scalars["String"]["input"];
};

export type RouteAssignments = {
  __typename?: "RouteAssignments";
  assignedLocations: Array<AssignedWaypoints>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  route_assignment_id: Scalars["String"]["output"];
  route_legs: Array<RouteLegs>;
  schedule_date: Scalars["Date"]["output"];
  staff: Staffs;
  staff_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RouteLegs = {
  __typename?: "RouteLegs";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  end_location?: Maybe<Locations>;
  end_location_id?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  leg_id: Scalars["ID"]["output"];
  route_assignment?: Maybe<RouteAssignments>;
  route_assignment_id: Scalars["String"]["output"];
  /** Specifies the sequence in which the staff must complete the legs. A lower value indicates an earlier stop, ensuring an optimized and structured route. */
  sequence: Scalars["Float"]["output"];
  start_location?: Maybe<Locations>;
  start_location_id?: Maybe<Scalars["String"]["output"]>;
  status: LegStatus;
  travel_distance?: Maybe<Scalars["Float"]["output"]>;
  travel_time?: Maybe<Scalars["Float"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RouteLocationInput = {
  locationId: Scalars["String"]["input"];
  routeGroup: Scalars["String"]["input"];
};

export type RouteLocations = {
  __typename?: "RouteLocations";
  assignedLocations: Array<AssignedWaypoints>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  location_id: Scalars["String"]["output"];
  route_group: Scalars["String"]["output"];
  route_location_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** It shows the route rule */
export enum RouteRuleKey {
  AllowedDays = "ALLOWED_DAYS",
}

export type RouteRuleValueUnion = AllowedDaysRule;

export type RouteRules = {
  __typename?: "RouteRules";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  route_location: RouteLocations;
  route_location_id: Scalars["String"]["output"];
  route_rule_id: Scalars["String"]["output"];
  rule_key: RouteRuleKey;
  rule_value: RouteRuleValueUnion;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type RoutesUnion = AssignedWaypoints | RouteAssignments | RouteLegs | RouteLocations | RouteRules;

export type RuleRequirements = {
  __typename?: "RuleRequirements";
  conformance: ConformanceExpectation;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  required_count: Quantity;
  rule: CriteriaRules;
  /** The minimum sum of selection scores, indicating positive result. Default behavior should be [required_count * 10] */
  threshold: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export enum RuleType {
  Range = "RANGE",
  Value = "VALUE",
}

export type RuleValue = RangeValue | StringValue;

/** List of saved payment method status codes */
export enum SavedPaymentMethodStatus {
  Active = "ACTIVE",
  Error = "ERROR",
  Inactive = "INACTIVE",
}

export type SavedPaymentMethods = {
  __typename?: "SavedPaymentMethods";
  /** Reference to the user account assigned to the payment method */
  account: BillingAccounts;
  /** Account holder email */
  account_holder_email?: Maybe<Scalars["String"]["output"]>;
  /** Name of payment method holder */
  account_holder_name: Scalars["String"]["output"];
  /** Checking or savings */
  bank_account_type?: Maybe<BankAccountTypes>;
  /** Name of bank account */
  bank_name?: Maybe<Scalars["String"]["output"]>;
  card_issuer?: Maybe<CreditCardIssuerCodes>;
  card_network?: Maybe<CreditCardNetworkCodes>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Month the payment method expires */
  expiration_month?: Maybe<Scalars["Float"]["output"]>;
  /** Year the payment method expires */
  expiration_year?: Maybe<Scalars["Float"]["output"]>;
  gateway: PaymentGateways;
  is_archived: Scalars["Boolean"]["output"];
  /** Is this a users default payment method? */
  is_default: Scalars["Boolean"]["output"];
  /** Last 4 digits of card number */
  last_four_digits?: Maybe<Scalars["Float"]["output"]>;
  merchant: MerchantAccounts;
  method_id: Scalars["ID"]["output"];
  /** User-defined name for this payment method */
  nickname?: Maybe<Scalars["String"]["output"]>;
  status: SavedPaymentMethodStatus;
  /** Type of payment method */
  type: PaymentMethodTypeCodes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  usages: Array<PaymentMethods>;
};

export type ScheduleActors = {
  __typename?: "ScheduleActors";
  actor_care_team_id?: Maybe<Scalars["ID"]["output"]>;
  actor_device_id?: Maybe<Scalars["ID"]["output"]>;
  actor_id: Scalars["ID"]["output"];
  actor_location_id?: Maybe<Scalars["ID"]["output"]>;
  actor_patient_id?: Maybe<Scalars["ID"]["output"]>;
  actor_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  /** HealthcareService reference */
  actor_service_id?: Maybe<Scalars["ID"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  schedule: Schedules;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ScheduleActorsListInput = {
  careTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Specific HealthcareService to be performed */
  healthcareServiceId?: InputMaybe<Scalars["ID"]["input"]>;
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
  practitionerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ScheduleCreateInput = {
  /** Cron Job uses the field. Resolver does not affect to anything */
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  /** Schedule in active use? */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Slots that reference this schedule resource provide the availability details for this actor. (Union) */
  actor: ScheduleActorsListInput;
  /** Additional comment about this schedule */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Human readable label */
  name: Scalars["String"]["input"];
  /** Period of time covered by schedule */
  planningHorizon: PeriodCreateInput;
  serviceCategory: ServiceRequestCategory;
  /** Type of service to be performed */
  serviceType: Scalars["String"]["input"];
  slots?: InputMaybe<Array<SlotInput>>;
  /** Type of speciality needed */
  specialityRequirements?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SchedulePaginatedResults = {
  __typename?: "SchedulePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Schedules>;
  totalPages: Scalars["Float"]["output"];
};

export type ScheduleTemplates = {
  __typename?: "ScheduleTemplates";
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Daily availability */
  daily: DailyAvailabilities;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Monthly availability. If empty, every month is assumed */
  monthly?: Maybe<MonthlyAvailabilities>;
  /** Human friendly label */
  name: Scalars["String"]["output"];
  schedules?: Maybe<Array<Schedules>>;
  /** Default slot capacity */
  slot_capacity?: Maybe<Scalars["Float"]["output"]>;
  template_id: Scalars["ID"]["output"];
  /** Dates that should be made unavailable for bookings. */
  unavailable_dates?: Maybe<Array<Scalars["DateTime"]["output"]>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** weekly availability. If empty, every week is assumed */
  weekly?: Maybe<WeeklyAvailabilities>;
};

export type ScheduleUpdateInput = {
  /** Schedule in active use? */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Additional comment about this schedule */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Human readable label */
  name?: InputMaybe<Scalars["String"]["input"]>;
  scheduleId: Scalars["ID"]["input"];
  serviceCategory?: InputMaybe<ServiceRequestCategory>;
  /** Type of service to be performed */
  serviceType?: InputMaybe<Scalars["String"]["input"]>;
  slots?: InputMaybe<SlotActionInput>;
  /** Type of speciality needed */
  specialityRequirements?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type Schedules = {
  __typename?: "Schedules";
  /** Whether this schedule is in active use */
  active: Scalars["Boolean"]["output"];
  /** Slots that reference this schedule resource provide the availability details to these referenced resource(s). */
  actor: ScheduleActors;
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human-readable label */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Period of time covered by schedule */
  planning_horizon: Periods;
  schedule_id: Scalars["ID"]["output"];
  service_category: ServiceRequestCategory;
  /** Type of service to be performed */
  service_type: Scalars["String"]["output"];
  slots: Array<Slots>;
  /** Type of specialty needed */
  speciality?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Template schedule was created from */
  template?: Maybe<ScheduleTemplates>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SearchByArgs = {
  basicQuery?: InputMaybe<BasicSearch>;
  queryKeyword?: InputMaybe<Array<KeywordSearch>>;
  queryOperator?: InputMaybe<Array<OperatorSearch>>;
  queryRange?: InputMaybe<RangeSearch>;
  querySet?: InputMaybe<Array<RecordSearch>>;
};

export enum SearchParamType {
  Composite = "COMPOSITE",
  Date = "DATE",
  Number = "NUMBER",
  Quantity = "QUANTITY",
  Reference = "REFERENCE",
  Special = "SPECIAL",
  String = "STRING",
  Token = "TOKEN",
  Uri = "URI",
}

export enum SecurityLabel {
  Delau = "DELAU",
  Etreat = "ETREAT",
  Hpaymt = "HPAYMT",
  L = "L",
  M = "M",
  N = "N",
  Noauth = "NOAUTH",
  R = "R",
  Std = "STD",
  Treat = "TREAT",
  U = "U",
  V = "V",
}

/** All possible FHIR Security role type codes. */
export enum SecurityRoleType {
  BusinessManager = "BUSINESS_MANAGER",
  ClaimsAdjudicator = "CLAIMS_ADJUDICATOR",
  /** The specialty relating to the function and diseases of the teeth, mouth, and gums. */
  Dentist = "DENTIST",
  /** The health profession concerned with the practical application of diet in the prophylaxis and treatment of disease. */
  Dietician = "DIETICIAN",
  /** The branch of medicine involving the study and treatment of general diseases or those affecting the internal parts of the body, especially those not usually requiring surgical intervention */
  GeneralMedicine = "GENERAL_MEDICINE",
  /** The branch of healthcare concerned with caring for the sick or injured in any environment. */
  GeneralNursing = "GENERAL_NURSING",
  /** person employed by a healthcare organization who is not a health professional */
  NonRegulatedHealthProfessionals = "NON_REGULATED_HEALTH_PROFESSIONALS",
  /** The medical specialty concerned with the study of treatment of children in health and disease during development from birth through adolescence. */
  Pediatrics = "PEDIATRICS",
  /** The branch of medical science that deals with drugs and their uses. */
  Pharmacy = "PHARMACY",
  Receptionist = "RECEPTIONIST",
  /** A person who is authorized by a national recognized body to be qualified to perform health services */
  RegulatedHealthProfessionals = "REGULATED_HEALTH_PROFESSIONALS",
  Transcriptionist = "TRANSCRIPTIONIST",
  /** The specialty relating to non-human subjects. */
  Veterinarian = "VETERINARIAN",
}

export type SendOrderToStratusInput = {
  orderId: Scalars["ID"]["input"];
};

export type SeriesOccurrenceIdentifier = {
  eventId?: InputMaybe<Scalars["ID"]["input"]>;
  occurrenceDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type SeriesOccurrenceUpdateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Date and time the event is to conclude */
  endDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  eventDate?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  identifier: SeriesOccurrenceIdentifier;
  isAllDayEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Where the event is to occur */
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  series?: InputMaybe<EventSeriesUpdateInput>;
  seriesId: Scalars["ID"]["input"];
  /** Date and time the event is to occur */
  startDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  what?: InputMaybe<ReferenceUpdateInput>;
  who?: InputMaybe<ReferenceUpdateInput>;
};

export type ServiceActionSpecimenInput = {
  specimenDefinitionId: Scalars["ID"]["input"];
};

export type ServiceAttributeLinkOrCreateInput = {
  attribute?: InputMaybe<AttributeCreateInput>;
  attributeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ServiceBasedOnInput = {
  carePlanId?: InputMaybe<Scalars["ID"]["input"]>;
  medicationUsageId?: InputMaybe<Scalars["ID"]["input"]>;
  serviceRequestId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ServiceIdentifierLinkOrCreateInput = {
  identifier?: InputMaybe<IdentifierCreateInput>;
  identifierId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** All possible service intent status codes */
export enum ServiceIntentStatus {
  Cancelled = "CANCELLED",
  Directive = "DIRECTIVE",
  FilledOrder = "FILLED_ORDER",
  InstanceOrder = "INSTANCE_ORDER",
  Order = "ORDER",
  OriginalOrder = "ORIGINAL_ORDER",
  Pending = "PENDING",
  Plan = "PLAN",
  ReflexOrder = "REFLEX_ORDER",
}

export type ServiceLocationLinkInput = {
  /** Targets all organization labs if true */
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  labs?: InputMaybe<Array<DiagnosticServiceLabInput>>;
};

export type ServicePerformerInput = {
  careTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
  practitionerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ServiceReflexInput = {
  triggerDefinitionId: Scalars["ID"]["input"];
};

export type ServiceRequestBasedOn = CarePlans | MedicationUsages | ServiceRequests;

/** All possible FHIR service request category codes */
export enum ServiceRequestCategory {
  Counselling = "COUNSELLING",
  Education = "EDUCATION",
  Imaging = "IMAGING",
  Lab = "LAB",
  Surgical = "SURGICAL",
}

export type ServiceRequestCreateInput = {
  /** What request fulfills */
  basedOn?: InputMaybe<ServiceBasedOnInput>;
  /** Anatomic location where the procedure should be performed. This is the target site. */
  bodySite?: InputMaybe<CodeableConceptCreateInput>;
  /** Classification of service */
  category: ServiceRequestCategory;
  /** What is being requested/ordered */
  code: Scalars["String"]["input"];
  /** Comments */
  comment?: InputMaybe<AnnotationCreateInput>;
  /** Indicates if service should not be performed */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Reference to the healthcare service being requested */
  healthcareServiceId: Scalars["ID"]["input"];
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  intent: RequestIntent;
  /** Requested location */
  locationId: Scalars["ID"]["input"];
  /** When service should occur */
  occurrence?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Individual the service is ordered for */
  patientId: Scalars["ID"]["input"];
  /** Requested performer */
  performer?: InputMaybe<ServicePerformerInput>;
  /** Performer role */
  performerType?: InputMaybe<Scalars["String"]["input"]>;
  /** How quickly the ServiceRequest should be addressed with respect to other requests. */
  priority?: InputMaybe<RequestPriority>;
  /** Explanation/Justification for procedure or service */
  reasons?: InputMaybe<Array<ServiceRequestReasonInput>>;
  replacedRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Who/what is requesting service */
  requester: ServiceRequesterInput;
  requisition?: InputMaybe<IdentifierCreateInput>;
  /** Reference to requisition PDF document */
  requisitionDocument?: InputMaybe<DocumentReferenceCreateInput>;
  requisitionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Specimen collection request details */
  specimen?: InputMaybe<SpecimenCollectionRequestInput>;
  status: RequestStatus;
  type?: InputMaybe<ServiceRequestType>;
};

export type ServiceRequestDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  requestId: Scalars["ID"]["input"];
};

export type ServiceRequestPaginatedResults = {
  __typename?: "ServiceRequestPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<ServiceRequests>;
  totalPages: Scalars["Float"]["output"];
};

export type ServiceRequestPerformer = CareTeams | Devices | HealthcareServiceLocations | Locations | Organizations | Patients | Practitioners;

export type ServiceRequestReason = Conditions | DetectedIssues | DiagnosticReports | Observations;

export type ServiceRequestReasonActionInput = {
  add?: InputMaybe<Array<ServiceRequestReasonInput>>;
  remove?: InputMaybe<ServiceRequestReasonBulkDeleteInput>;
  set?: InputMaybe<ServiceRequestReasonSetInput>;
};

export type ServiceRequestReasonBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  reasons: Array<ReasonIdentifier>;
  serviceRequestId: Scalars["ID"]["input"];
};

export type ServiceRequestReasonInput = {
  reason: ReasonInput;
};

export type ServiceRequestReasonManageInput = {
  action: ServiceRequestReasonActionInput;
  serviceRequestId: Scalars["ID"]["input"];
};

export type ServiceRequestReasonSetInput = {
  reasons: Array<ServiceRequestReasonInput>;
};

export type ServiceRequestReasons = {
  __typename?: "ServiceRequestReasons";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Explanation/Justification for procedure or service */
  reason: ServiceRequestReason;
  reason_id: Scalars["ID"]["output"];
  reason_report_id?: Maybe<Scalars["ID"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ServiceRequestRequester = Devices | Locations | Organizations | Patients | Practitioners | StaffAssignments;

/** All possible service request statuses */
export enum ServiceRequestStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Collected = "COLLECTED",
  Completed = "COMPLETED",
  Draft = "DRAFT",
  EnteredInError = "ENTERED_IN_ERROR",
  InProgress = "IN_PROGRESS",
  OnHold = "ON_HOLD",
  Revoke = "REVOKE",
  Unknown = "UNKNOWN",
}

/** All possible service request types */
export enum ServiceRequestType {
  Usual = "USUAL",
  WriteIn = "WRITE_IN",
}

export type ServiceRequestUpdateInput = {
  /** What request fulfills */
  basedOn?: InputMaybe<ServiceBasedOnInput>;
  /** Anatomic location where the procedure should be performed. This is the target site. */
  bodySite?: InputMaybe<CodeableConceptCreateInput>;
  /** Classification of service */
  category?: InputMaybe<ServiceRequestCategory>;
  /** What is being requested/ordered */
  code?: InputMaybe<Scalars["String"]["input"]>;
  /** Comments */
  comment?: InputMaybe<AnnotationCreateInput>;
  /** Indicates if service should not be performed */
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  encounterId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  intent?: InputMaybe<RequestIntent>;
  /** Requested location */
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** When service should occur */
  occurrence?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Requested performer */
  performer?: InputMaybe<ServicePerformerInput>;
  /** Performer role */
  performerType?: InputMaybe<Scalars["String"]["input"]>;
  /** How quickly the ServiceRequest should be addressed with respect to other requests. */
  priority?: InputMaybe<RequestPriority>;
  reasons?: InputMaybe<ServiceRequestReasonManageInput>;
  replacedRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  requestId: Scalars["ID"]["input"];
  requisition?: InputMaybe<IdentifierCreateInput>;
  requisitionDocument?: InputMaybe<RequestRequisitionDocumentManageInput>;
  requisitionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<RequestStatus>;
  type?: InputMaybe<ServiceRequestType>;
};

export type ServiceRequesterInput = {
  assignmentId?: InputMaybe<Scalars["ID"]["input"]>;
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId?: InputMaybe<Scalars["ID"]["input"]>;
  practitionerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ServiceRequests = {
  __typename?: "ServiceRequests";
  /** What request fulfills */
  based_on?: Maybe<ServiceRequestBasedOn>;
  /** Anatomic location where the procedure should be performed. This is the target site. */
  body_site?: Maybe<CodeableConcepts>;
  /** Classification of service */
  category: ServiceRequestCategory;
  /** What is being requested/ordered */
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Indicates if service should not be performed */
  do_not_perform: Scalars["Boolean"]["output"];
  /** An encounter that provides additional information about the healthcare context in which this request is made. */
  encounter?: Maybe<Encounters>;
  /** Additional identifiers associated with service request */
  identifiers?: Maybe<Array<Identifiers>>;
  /** Whether the request is a proposal, plan, an original order or a reflex order. */
  intent: RequestIntent;
  is_archived: Scalars["Boolean"]["output"];
  /** Requested location */
  location: Locations;
  note?: Maybe<Annotations>;
  /** When service should occur */
  occurrence?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Order this request belongs to */
  order?: Maybe<Orders>;
  /** Individual the service is ordered for */
  patient: Patients;
  /** Requested performer */
  performer?: Maybe<ServiceRequestPerformer>;
  performer_device_id?: Maybe<Scalars["ID"]["output"]>;
  performer_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  /** Performer role */
  performer_type?: Maybe<Scalars["String"]["output"]>;
  /** Indicates how quickly the ServiceRequest should be addressed with respect to other requests. */
  priority: RequestPriority;
  /** Explanation/Justification for procedure or service */
  reasons?: Maybe<Array<ServiceRequestReasons>>;
  /** Key events in the history of the request */
  relevant_history?: Maybe<Array<Provenances>>;
  /** Reference to the Service request this replaces */
  replaces?: Maybe<ServiceRequests>;
  reports?: Maybe<Array<DiagnosticReports>>;
  request_id: Scalars["ID"]["output"];
  /** Who/what is requesting service */
  requester: ServiceRequestRequester;
  requester_device_id?: Maybe<Scalars["ID"]["output"]>;
  requester_practitioner_id?: Maybe<Scalars["ID"]["output"]>;
  /** Composite request Id */
  requisition?: Maybe<Identifiers>;
  /** Reference to requisition PDF */
  requisition_document?: Maybe<DocumentReferences>;
  /** Reference to the service requested to be performed */
  service: HealthcareServices;
  service_id: Scalars["ID"]["output"];
  status: RequestStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ServiceSubActionInput = {
  subActionId: Scalars["ID"]["input"];
};

export type ServiceTagLinkOrCreateInput = {
  tag?: InputMaybe<TagCreateInput>;
  tagId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ServiceUsageContextInput = {
  /** Age range requirements of service */
  ageRange?: InputMaybe<RangeCreateInput>;
  /** Gender restrictions of service (if applicable) */
  genderRestriction?: InputMaybe<GenderRestrictions>;
  /** Is service orderable? */
  orderable: Scalars["Boolean"]["input"];
};

export type ServiceUsageContextUpdate = {
  /** Age range requirements of service */
  ageRange?: InputMaybe<RangeCreateInput>;
  /** Gender restrictions of service (if applicable) */
  genderRestriction?: InputMaybe<GenderRestrictions>;
  /** Is service orderable? */
  orderable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SessionResponse = {
  __typename?: "SessionResponse";
  errors?: Maybe<Array<FieldError>>;
  permissions?: Maybe<Scalars["String"]["output"]>;
  session?: Maybe<UserSessionData>;
};

export type SetChannelAlertEmailsInput = {
  channelId: Scalars["String"]["input"];
  /** Full list of email addresses to set for this channel. Backend diffs vs current state. */
  emails: Array<Scalars["String"]["input"]>;
};

export type Settings = {
  __typename?: "Settings";
  application_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  layouts?: Maybe<Array<LayoutSettings>>;
  notifications?: Maybe<Array<NotificationSettings>>;
  setting_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: CynergyUsers;
};

export type SettleOrderInput = {
  idempotencyKey?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["ID"]["input"];
  payerCynergyAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  paymentMethod: CheckoutPaymentMethodInput;
};

export type SetupTwoFactorProfileInput = {
  method: TwoFactorMethods;
  overwriteExisting?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Must supply field if sms method is chosen. */
  smsNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** List of application pages shared among ecosystems */
export enum SharedApplicationPages {
  Account = "ACCOUNT",
  Dashboard = "DASHBOARD",
}

/** A practitioner signature lifecycle event (e.g. who deleted a signature and when). */
export type SignatureAuditResponse = {
  __typename?: "SignatureAuditResponse";
  /** Cynergy id of the user who performed the event. */
  actorCynergyId?: Maybe<Scalars["ID"]["output"]>;
  auditId: Scalars["ID"]["output"];
  /** When the event occurred. */
  createdAt: Scalars["GraphQLDateTime"]["output"];
  /** Username that performed the event. */
  createdBy: Scalars["String"]["output"];
  /** Cynergy id of the practitioner the signature belongs to. */
  cynergyId: Scalars["ID"]["output"];
  /** Reason the event was performed. */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** The signature record the event applies to. */
  referenceId?: Maybe<Scalars["ID"]["output"]>;
  type: SignatureEventType;
};

/** Event options related to signatures */
export enum SignatureEventType {
  Approve = "APPROVE",
  Comment = "COMMENT",
  Delete = "DELETE",
  Reject = "REJECT",
  RequestSign = "REQUEST_SIGN",
  Revoke = "REVOKE",
  Sign = "SIGN",
  Update = "UPDATE",
  View = "VIEW",
}

export type SignatureInput = {
  name: Scalars["String"]["input"];
  /** The technical format of the signature */
  signatureFormat: MimeTypes;
  /**  An indication of the reason that the entity signed this document */
  signatureType: SignatureType;
  signedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  targetFormat?: InputMaybe<MimeTypes>;
  url: Scalars["URL"]["input"];
};

/** All possible FHIR signature type codes. */
export enum SignatureType {
  AddendumSignature = "ADDENDUM_SIGNATURE",
  AdministrativeSignature = "ADMINISTRATIVE_SIGNATURE",
  AuthorsSignature = "AUTHORS_SIGNATURE",
  ConsentSignature = "CONSENT_SIGNATURE",
  ConsentWitnessSignature = "CONSENT_WITNESS_SIGNATURE",
  CoAuthorsSignature = "CO_AUTHORS_SIGNATURE",
  CoParticipantsSignature = "CO_PARTICIPANTS_SIGNATURE",
  EventWitnessSignature = "EVENT_WITNESS_SIGNATURE",
  IdentityWitnessSignature = "IDENTITY_WITNESS_SIGNATURE",
  InterpreterSignature = "INTERPRETER_SIGNATURE",
  ModificationSignature = "MODIFICATION_SIGNATURE",
  ProofOfApproval = "PROOF_OF_APPROVAL",
  ProofOfCreation = "PROOF_OF_CREATION",
  ProofOfDelivery = "PROOF_OF_DELIVERY",
  ProofOfOrigin = "PROOF_OF_ORIGIN",
  ProofOfReceipt = "PROOF_OF_RECEIPT",
  ProofOfSender = "PROOF_OF_SENDER",
  ReviewSignature = "REVIEW_SIGNATURE",
  SourceSignature = "SOURCE_SIGNATURE",
  TimestampSignature = "TIMESTAMP_SIGNATURE",
  Transcriptionist = "TRANSCRIPTIONIST",
  ValidationSignature = "VALIDATION_SIGNATURE",
  VerificationSignature = "VERIFICATION_SIGNATURE",
  WitnessSignature = "WITNESS_SIGNATURE",
}

export type Signatures = {
  __typename?: "Signatures";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The technical format of the signature */
  signature_format: MimeTypes;
  signature_id: Scalars["ID"]["output"];
  /** Name of person signing */
  signed_by: Scalars["String"]["output"];
  /** When the signature was captured. */
  signed_date: Scalars["GraphQLDateTime"]["output"];
  signer_account_id: Scalars["ID"]["output"];
  /** The technical format of the signed resources */
  target_format?: Maybe<MimeTypes>;
  /**  An indication of the reason that the entity signed this document */
  type: SignatureType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** URL pointing to the signature content destination */
  url?: Maybe<Scalars["URL"]["output"]>;
};

export type SlotActionInput = {
  add?: InputMaybe<Array<SlotInput>>;
  remove?: InputMaybe<SlotDeleteInput>;
  update?: InputMaybe<SlotUpdateInput>;
};

export type SlotAvailability = {
  __typename?: "SlotAvailability";
  /** Indicates if slot is available for booking */
  bookable: Scalars["Boolean"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
};

export type SlotDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  slots: Array<SlotIdentifier>;
};

export type SlotIdentifier = {
  slotId: Scalars["ID"]["input"];
};

export type SlotInput = {
  /** Indicates the number of appointments that have been assigned or allocated to the slot */
  allocated?: InputMaybe<Scalars["Float"]["input"]>;
  /** The style of appointment or patient that may be booked in the slot (not service type) */
  appointmentTypes: Array<AppointmentType>;
  /** Any additional comment about the slot */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Date/time the slot is to conclude */
  endTime: Scalars["GraphQLDateTime"]["input"];
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time */
  overbooked?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A broad categorization of the service that is to be performed during this appointment */
  serviceCategory: ServiceRequestCategory;
  /** The type of appointments that can be booked into this slot */
  serviceType: Scalars["String"]["input"];
  /** Indicates the maximum number of appointments this slot can accommodate */
  slotCapacity?: InputMaybe<Scalars["Float"]["input"]>;
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment */
  specialityRequirements?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Date/time the slot is to begin */
  startTime: Scalars["GraphQLDateTime"]["input"];
  status?: InputMaybe<SlotStatus>;
};

/** All available slot status codes */
export enum SlotStatus {
  /** Indicates that the time interval is busy because one or more events have been scheduled for that interval. */
  Busy = "BUSY",
  /** Indicates that the time interval is busy because one or more events have been tentatively scheduled for that interval. */
  BusyTentative = "BUSY_TENTATIVE",
  /** Indicates that the time interval is busy and that the interval cannot be scheduled. */
  BusyUnavailable = "BUSY_UNAVAILABLE",
  /** This instance should not have been part of this patient's medical record. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** Indicates that the time interval is free for scheduling. */
  Free = "FREE",
}

export type SlotUpdateInput = {
  /** Indicates the number of appointments that have been assigned or allocated to the slot */
  allocated?: InputMaybe<Scalars["Float"]["input"]>;
  /** The style of appointment or patient that may be booked in the slot (not service type) */
  appointmentTypes?: InputMaybe<Array<AppointmentType>>;
  /** Any additional comment about the slot */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Date/time the slot is to conclude */
  endTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time */
  overbooked?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A broad categorization of the service that is to be performed during this appointment */
  serviceCategory?: InputMaybe<ServiceRequestCategory>;
  /** The type of appointments that can be booked into this slot */
  serviceType?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates the maximum number of appointments this slot can accommodate */
  slotCapacity?: InputMaybe<Scalars["Float"]["input"]>;
  slotId: Scalars["ID"]["input"];
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment */
  specialityRequirements?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Date/time the slot is to begin */
  startTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status?: InputMaybe<SlotStatus>;
};

export type Slots = {
  __typename?: "Slots";
  /** Indicates the number of appointments that have been assigned or allocated to the slot */
  allocated: Scalars["Float"]["output"];
  /** The style of appointment or patient that may be booked in the slot (not service type) */
  appointment_type: Array<AppointmentType>;
  appointments?: Maybe<Array<Appointments>>;
  /** Indicates the maximum number of appointments this slot can accommodate */
  capacity: Scalars["Float"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Date/time the slot is to conclude */
  end: Scalars["GraphQLDateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** This slot has already been overbooked, appointments are unlikely to be accepted for this time */
  overbooked: Scalars["Boolean"]["output"];
  schedule: Schedules;
  /** A broad categorization of the service that is to be performed during this appointment */
  service_category: ServiceRequestCategory;
  /** The type of appointments that can be booked into this slot */
  service_type: Scalars["String"]["output"];
  slot_id: Scalars["ID"]["output"];
  /** The specialty of a practitioner that would be required to perform the service requested in this appointment */
  speciality?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Date/time the slot is to begin */
  start: Scalars["GraphQLDateTime"]["output"];
  status: SlotStatus;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SortingArgs = {
  order: OrderByArgs;
};

/** All possible specimen type codes */
export enum SpecimenCodes {
  Abs = "ABS",
  Acne = "ACNE",
  Acnfld = "ACNFLD",
  Airs = "AIRS",
  All = "ALL",
  Amn = "AMN",
  Amp = "AMP",
  Angi = "ANGI",
  Artc = "ARTC",
  Aseru = "ASERU",
  Asp = "ASP",
  Atte = "ATTE",
  Autoa = "AUTOA",
  Autoc = "AUTOC",
  Autp = "AUTP",
  Bbl = "BBL",
  Bcyst = "BCYST",
  Bdy = "BDY",
  Bifl = "BIFL",
  Bite = "BITE",
  Blda = "BLDA",
  Bldco = "BLDCO",
  Blds = "BLDS",
  Bldv = "BLDV",
  Bleb = "BLEB",
  Blist = "BLIST",
  Blood = "BLOOD",
  Boil = "BOIL",
  Bone = "BONE",
  Bowl = "BOWL",
  Bph = "BPH",
  Bpu = "BPU",
  Brn = "BRN",
  Brsh = "BRSH",
  Brth = "BRTH",
  Brus = "BRUS",
  Bub = "BUB",
  Bulla = "BULLA",
  Bx = "BX",
  Calc = "CALC",
  Carbu = "CARBU",
  Cat = "CAT",
  Cbite = "CBITE",
  Cdm = "CDM",
  Clipp = "CLIPP",
  Cnjt = "CNJT",
  Cnl = "CNL",
  Col = "COL",
  Cone = "CONE",
  Cscr = "CSCR",
  Cseru = "CSERU",
  Csf = "CSF",
  Csite = "CSITE",
  Csmy = "CSMY",
  Cst = "CST",
  Csvr = "CSVR",
  Ctp = "CTP",
  Cur = "CUR",
  Cvm = "CVM",
  Cvps = "CVPS",
  Cvpt = "CVPT",
  Cyn = "CYN",
  Cyst = "CYST",
  Dbite = "DBITE",
  Dcs = "DCS",
  Dec = "DEC",
  Deion = "DEION",
  Dia = "DIA",
  Diaf = "DIAF",
  Dischg = "DISCHG",
  Div = "DIV",
  Drn = "DRN",
  Drng = "DRNG",
  Drngp = "DRNGP",
  Dufl = "DUFL",
  Earw = "EARW",
  Ebrush = "EBRUSH",
  Eeye = "EEYE",
  Eff = "EFF",
  Effus = "EFFUS",
  Efod = "EFOD",
  Eiso = "EISO",
  Elt = "ELT",
  Envir = "ENVIR",
  Eos = "EOS",
  Eoth = "EOTH",
  Esoi = "ESOI",
  Esos = "ESOS",
  Eta = "ETA",
  Ettp = "ETTP",
  Ettub = "ETTUB",
  Ewhi = "EWHI",
  Exg = "EXG",
  Exs = "EXS",
  Exudte = "EXUDTE",
  Faw = "FAW",
  Fblood = "FBLOOD",
  Fga = "FGA",
  Fib = "FIB",
  Fist = "FIST",
  Fld = "FLD",
  Flt = "FLT",
  Flu = "FLU",
  Fluid = "FLUID",
  Foley = "FOLEY",
  Frs = "FRS",
  Fsclp = "FSCLP",
  Fur = "FUR",
  Gas = "GAS",
  Gasa = "GASA",
  Gasan = "GASAN",
  Gasbr = "GASBR",
  Gasd = "GASD",
  Gast = "GAST",
  Genl = "GENL",
  Genv = "GENV",
  Graft = "GRAFT",
  Grafts = "GRAFTS",
  Granu = "GRANU",
  Grosh = "GROSH",
  Gsol = "GSOL",
  Gspec = "GSPEC",
  Gt = "GT",
  Gtube = "GTUBE",
  Har = "HAR",
  Hbite = "HBITE",
  Hblud = "HBLUD",
  Hemaq = "HEMAQ",
  Hemo = "HEMO",
  Herni = "HERNI",
  Hev = "HEV",
  Hic = "HIC",
  Hydc = "HYDC",
  Ibite = "IBITE",
  Icyst = "ICYST",
  Idc = "IDC",
  Ihg = "IHG",
  Ileo = "ILEO",
  Illeg = "ILLEG",
  Imp = "IMP",
  Inci = "INCI",
  Infil = "INFIL",
  Ins = "INS",
  Intrd = "INTRD",
  Islt = "ISLT",
  It = "IT",
  Iud = "IUD",
  Ivcat = "IVCAT",
  Ivfld = "IVFLD",
  Ivtip = "IVTIP",
  Jeju = "JEJU",
  Jntfld = "JNTFLD",
  Jp = "JP",
  Keloi = "KELOI",
  Kidfld = "KIDFLD",
  Lavg = "LAVG",
  Lavgg = "LAVGG",
  Lavgp = "LAVGP",
  Lavpg = "LAVPG",
  Lens1 = "LENS1",
  Lens2 = "LENS2",
  Lesn = "LESN",
  Liq = "LIQ",
  Liqo = "LIQO",
  Lna = "LNA",
  Lnv = "LNV",
  Lsac = "LSAC",
  Lym = "LYM",
  Mac = "MAC",
  Mahur = "MAHUR",
  Mar = "MAR",
  Mass = "MASS",
  Mbld = "MBLD",
  Mec = "MEC",
  Milk = "MILK",
  Mlk = "MLK",
  Mucos = "MUCOS",
  Mucus = "MUCUS",
  Nail = "NAIL",
  Nasdr = "NASDR",
  Nedl = "NEDL",
  Neph = "NEPH",
  Ngasp = "NGASP",
  Ngast = "NGAST",
  Ngs = "NGS",
  Nodul = "NODUL",
  Np = "NP",
  Nsecr = "NSECR",
  Orh = "ORH",
  Orl = "ORL",
  Oth = "OTH",
  Pacem = "PACEM",
  Pafl = "PAFL",
  Pcfl = "PCFL",
  Pdsit = "PDSIT",
  Pdts = "PDTS",
  Pelva = "PELVA",
  Penil = "PENIL",
  Peria = "PERIA",
  Piloc = "PILOC",
  Pins = "PINS",
  Pis = "PIS",
  Plan = "PLAN",
  Plas = "PLAS",
  Plb = "PLB",
  Plc = "PLC",
  Plevs = "PLEVS",
  Plr = "PLR",
  Pmn = "PMN",
  Pnd = "PND",
  Pol = "POL",
  Popgs = "POPGS",
  Poplg = "POPLG",
  Poplv = "POPLV",
  Porta = "PORTA",
  Ppp = "PPP",
  Prost = "PROST",
  Prp = "PRP",
  Psc = "PSC",
  Punct = "PUNCT",
  Pus = "PUS",
  Pusfr = "PUSFR",
  Qc3 = "QC3",
  Randu = "RANDU",
  Rbc = "RBC",
  Rbite = "RBITE",
  Rect = "RECT",
  Recta = "RECTA",
  Renalc = "RENALC",
  Renc = "RENC",
  Res = "RES",
  Sal = "SAL",
  Scar = "SCAR",
  Sclv = "SCLV",
  Scroa = "SCROA",
  Secre = "SECRE",
  Ser = "SER",
  Shu = "SHU",
  Shunf = "SHUNF",
  Shunt = "SHUNT",
  Site = "SITE",
  Skbp = "SKBP",
  Skn = "SKN",
  Smm = "SMM",
  Smn = "SMN",
  Snv = "SNV",
  Sprm = "SPRM",
  Sprp = "SPRP",
  Sprpb = "SPRPB",
  Sps = "SPS",
  Spt = "SPT",
  Sptc = "SPTC",
  Sptt = "SPTT",
  Sput1 = "SPUT1",
  Sputin = "SPUTIN",
  Sputsp = "SPUTSP",
  Ster = "STER",
  Stl = "STL",
  Stone = "STONE",
  Subma = "SUBMA",
  Submx = "SUBMX",
  Sump = "SUMP",
  Sup = "SUP",
  Sutur = "SUTUR",
  Swgz = "SWGZ",
  Swt = "SWT",
  Tasp = "TASP",
  Tear = "TEAR",
  Thrb = "THRB",
  Tiss = "TISS",
  Tisu = "TISU",
  Tlc = "TLC",
  Trac = "TRAC",
  Trans = "TRANS",
  Tseru = "TSERU",
  Tstes = "TSTES",
  Ttra = "TTRA",
  Tubes = "TUBES",
  Tumor = "TUMOR",
  Tzanc = "TZANC",
  Udent = "UDENT",
  Umed = "UMED",
  Ur = "UR",
  Urc = "URC",
  Urinb = "URINB",
  Urinc = "URINC",
  Urinm = "URINM",
  Urinn = "URINN",
  Urinp = "URINP",
  Urns = "URNS",
  Urt = "URT",
  Uscop = "USCOP",
  Uspec = "USPEC",
  Usub = "USUB",
  Vastip = "VASTIP",
  Vent = "VENT",
  Vitf = "VITF",
  Vom = "VOM",
  Wash = "WASH",
  Wasi = "WASI",
  Wat = "WAT",
  Wb = "WB",
  Wbc = "WBC",
  Wen = "WEN",
  Wick = "WICK",
  Wnd = "WND",
  Wnda = "WNDA",
  Wndd = "WNDD",
  Wnde = "WNDE",
  Worm = "WORM",
  Wrt = "WRT",
  Wwa = "WWA",
  Wwo = "WWO",
  Wwt = "WWT",
}

/** All possible specimen collection methods */
export enum SpecimenCollectionMethod {
  Aspiration = "ASPIRATION",
  Biopsy = "BIOPSY",
  Cough = "COUGH",
  Excision = "EXCISION",
  FingerPrick = "FINGER_PRICK",
  Puncture = "PUNCTURE",
  Scraping = "SCRAPING",
  TimeUrine = "TIME_URINE",
  Urine = "URINE",
  UrineCatheterized = "URINE_CATHETERIZED",
}

export type SpecimenCollectionRequestInput = {
  /** Date/time specimen collection should occur */
  collectionDateTime: Scalars["GraphQLDateTime"]["input"];
};

export type SpecimenCollections = {
  __typename?: "SpecimenCollections";
  collected_date_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  collected_period?: Maybe<Periods>;
  collector: SpecimenCollector;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Device used to perform collection */
  device?: Maybe<Devices>;
  device_id?: Maybe<Scalars["String"]["output"]>;
  /** How long it took to collect specimen */
  duration?: Maybe<Scalars["String"]["output"]>;
  /** How long fasting occurred? (E.g. "7 Days") */
  fasting_duration?: Maybe<Scalars["String"]["output"]>;
  /** Abstinence or reduction from some or all food, drink, or both, for a period of time prior to sample collection. */
  fasting_status: FastingStatus;
  is_archived: Scalars["Boolean"]["output"];
  method: SpecimenCollectionMethod;
  patient_id?: Maybe<Scalars["String"]["output"]>;
  /** The quantity of specimen collected */
  quantity: Quantity;
  specimen_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenCollector = Patients | StaffAssignments;

/** All possible specimen combined codes */
export enum SpecimenCombined {
  /** The specimen is in a group */
  Grouped = "GROUPED",
  /** The specimen is pooled. */
  Pooled = "POOLED",
}

/** All possible specimen conditions */
export enum SpecimenCondition {
  Aut = "AUT",
  Cfu = "CFU",
  Clot = "CLOT",
  Con = "CON",
  Cool = "COOL",
  Froz = "FROZ",
  Hem = "HEM",
  Live = "LIVE",
  Room = "ROOM",
  Snr = "SNR",
}

/** All possible FHIR Specimen contained preference codes */
export enum SpecimenContainedPreference {
  /** This type of conditioned specimen is an alternate. */
  Alternate = "ALTERNATE",
  /** This type of contained specimen is preferred to collect this kind of specimen. */
  Preferred = "PREFERRED",
}

export type SpecimenContainers = {
  __typename?: "SpecimenContainers";
  container_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** The device resource for the the container holding the specimen. If the container is in a holder then the referenced device will point to a parent device. */
  device: Devices;
  device_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  location_id: Scalars["ID"]["output"];
  /** Quantity of specimen within container */
  quantity: Scalars["Float"]["output"];
  specimen: Specimens;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionAdditives = {
  __typename?: "SpecimenDefinitionAdditives";
  /** Additive associated with container */
  additive: Scalars["String"]["output"];
  additive_id: Scalars["ID"]["output"];
  container: SpecimenDefinitionContainers;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionCollectionInput = {
  /** Additional specimen collection instructions */
  instructions?: InputMaybe<Scalars["String"]["input"]>;
  /** Specimen collection method/procedure */
  method?: InputMaybe<CodeableConceptCreateInput>;
  /** Patient preparation for collection */
  patientPreparation?: InputMaybe<Scalars["String"]["input"]>;
  specimenType: SpecimenCodes;
  /** Type of subject for specimen collection */
  subject: CareGroupTypes;
  /** Time aspect of specimen collection */
  timeAspect?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpecimenDefinitionCollections = {
  __typename?: "SpecimenDefinitionCollections";
  collection_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition: SpecimenDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Additional specimen collection instructions. (ex. Separate serum or plasma from cells within 45 minutes of collection.) */
  instructions?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Specimen collection procedure */
  method?: Maybe<CodeableConcepts>;
  /** Patient preparation for collection */
  patient_preparation?: Maybe<Scalars["String"]["output"]>;
  specimen_type: SpecimenCodes;
  /** Type of subject for specimen collection */
  subject: CareGroupTypes;
  /** Time aspect of specimen collection (duration or offset). */
  time_aspect?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionContact = {
  contact?: InputMaybe<ContactDetailsCreateInput>;
  contactDetailId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SpecimenDefinitionContainerCapCreateInput = {
  /** In active use. (Default - true) */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Color of container cap */
  color: Scalars["String"]["input"];
  labId: Scalars["ID"]["input"];
  /** Name associated with container cap */
  name: Scalars["String"]["input"];
};

export type SpecimenDefinitionContainerCapDeleteInput = {
  containerCapId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SpecimenDefinitionContainerCapInput = {
  /** In active use. (Default - true) */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Color of container cap */
  color: Scalars["String"]["input"];
  labId: Scalars["ID"]["input"];
  /** Name associated with container cap */
  name: Scalars["String"]["input"];
};

export type SpecimenDefinitionContainerCapUpdateInput = {
  /** In active use. (Default - true) */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Color of container cap */
  color?: InputMaybe<Scalars["String"]["input"]>;
  containerCapId: Scalars["ID"]["input"];
  labId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Name associated with container cap */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpecimenDefinitionContainerCaps = {
  __typename?: "SpecimenDefinitionContainerCaps";
  /** In active use */
  active: Scalars["Boolean"]["output"];
  cap_id: Scalars["ID"]["output"];
  /** Color of container cap */
  color: Scalars["String"]["output"];
  containers?: Maybe<SpecimenDefinitionContainers>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Name associated with container cap */
  name: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionContainerInput = {
  brandName?: InputMaybe<Scalars["String"]["input"]>;
  /** The capacity of container */
  capacity?: InputMaybe<QuantityCreateInput>;
  containerCap: ContainerCapLinkOrCreateInput;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Kind of container associated with the kind of specimen */
  kind?: InputMaybe<CodeableConceptCreateInput>;
  /** The material type used for this container */
  material: ContainerMaterial;
};

export type SpecimenDefinitionContainers = {
  __typename?: "SpecimenDefinitionContainers";
  /** Additive(s) associated with container */
  additive?: Maybe<Array<SpecimenDefinitionAdditives>>;
  brand?: Maybe<Scalars["String"]["output"]>;
  cap: SpecimenDefinitionContainerCaps;
  /** The capacity of this kind of container */
  capacity?: Maybe<Quantity>;
  container_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Kind of container associated with the kind of specimen */
  kind?: Maybe<CodeableConcepts>;
  /** The material type used for this container */
  material: ContainerMaterial;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionCreateInput = {
  /** Specimen collection procedures */
  collection: SpecimenDefinitionCollectionInput;
  definition: SpecimenDefinitionInput;
  /** List of locations this definition may be used. */
  locationScope?: InputMaybe<Array<ReferenceCreateInput>>;
  /** Specimen conditioned in a container as expected by the testing laboratory. */
  specimensTested: Array<SpecimenDefinitionTestInput>;
};

export type SpecimenDefinitionDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  specimenDefinitionId: Scalars["ID"]["input"];
};

export type SpecimenDefinitionHandling = {
  __typename?: "SpecimenDefinitionHandling";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  handling_id: Scalars["String"]["output"];
  /** Preservation instruction */
  instruction: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Specimen preservation time */
  preservation_time?: Maybe<Durations>;
  /** It qualifies the interval of temperature, which characterizes an occurrence of handling. Conditions that are not related to temperature may be handled in the instruction element. */
  temperature_qualifier?: Maybe<HandlingConditionSet>;
  /** Temperature range for these handling instructions */
  temperature_range?: Maybe<Range>;
  test: SpecimenDefinitionTests;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionHandlingInput = {
  /** Preservation instructions */
  additionalInstructions?: InputMaybe<Scalars["String"]["input"]>;
  /** Specimen preservation time */
  preservationTime?: InputMaybe<DurationCreateInput>;
  /** It qualifies the interval of temperature, which characterizes an occurrence of handling.  */
  temperatureQualifier?: InputMaybe<HandlingConditionSet>;
  /** Temperature range for these handling instructions */
  temperatureRange?: InputMaybe<RangeCreateInput>;
};

export type SpecimenDefinitionInput = {
  approvalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Contact details for publisher */
  contacts?: InputMaybe<Array<SpecimenDefinitionContact>>;
  /** Definition this specimen definition is based on */
  derivedDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Effective date range for the definition */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastReviewDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The name of the individual or organization that published the definition */
  publisher: Scalars["String"]["input"];
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpecimenDefinitionTestContainerInput = {
  container: TestContainerLinkOrCreateInput;
  /** The minimum volume to be conditioned in the container */
  minimumVolume?: InputMaybe<QuantityCreateInput>;
  /** The preferred volume to be conditioned in the container */
  preferredVolume?: InputMaybe<QuantityCreateInput>;
  /** Special processing applied to the container for this specimen type */
  preparation?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpecimenDefinitionTestContainerUpdateInput = {
  container?: InputMaybe<TestContainerLinkOrCreateInput>;
  /** The minimum volume to be conditioned in the container */
  minimumVolume?: InputMaybe<QuantityCreateInput>;
  /** The preferred volume to be conditioned in the container */
  preferredVolume?: InputMaybe<QuantityCreateInput>;
  /** Special processing applied to the container for this specimen type */
  preparation?: InputMaybe<Scalars["String"]["input"]>;
  testContainerId: Scalars["ID"]["input"];
};

export type SpecimenDefinitionTestContainers = {
  __typename?: "SpecimenDefinitionTestContainers";
  container: SpecimenDefinitionContainers;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** The minimum volume to be conditioned in the container. */
  minimum_volume?: Maybe<Quantity>;
  /** The preferred volume to be conditioned in the container. */
  preferred_volume?: Maybe<Quantity>;
  /** Special processing applied to the container for this specimen type */
  preparation?: Maybe<Scalars["String"]["output"]>;
  test: SpecimenDefinitionTests;
  test_container_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionTestCreateInput = {
  /** Set of instructions for preservation/transport of the specimen */
  handling?: InputMaybe<Array<SpecimenDefinitionHandlingInput>>;
  /** Primary or secondary specimen */
  isDerived?: InputMaybe<Scalars["Boolean"]["input"]>;
  preference: SpecimenContainedPreference;
  /** Requirements for specimen delivery and special handling */
  requirements?: InputMaybe<Scalars["String"]["input"]>;
  /** The usual time for retaining this kind of specimen */
  retentionTime?: InputMaybe<DurationCreateInput>;
  /** Specimen for single use only */
  singleUse?: InputMaybe<Scalars["Boolean"]["input"]>;
  specimenDefinitionId: Scalars["ID"]["input"];
  /** Criterion specified for specimen rejection */
  specimenRejectionCriterion?: InputMaybe<Array<RejectionCriteria>>;
  /** Type of intended specimen */
  specimenType: SpecimenCodes;
  /** The specimens container */
  testContainer: SpecimenDefinitionTestContainerInput;
  /** Where the specimen will be tested */
  testingDestination?: InputMaybe<DiagnosticServiceSection>;
};

export type SpecimenDefinitionTestDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  specimenDefinitionTestId: Scalars["ID"]["input"];
};

export type SpecimenDefinitionTestInput = {
  /** Set of instructions for preservation/transport of the specimen */
  handling?: InputMaybe<Array<SpecimenDefinitionHandlingInput>>;
  /** Primary or secondary specimen */
  isDerived?: InputMaybe<Scalars["Boolean"]["input"]>;
  preference: SpecimenContainedPreference;
  /** Requirements for specimen delivery and special handling */
  requirements?: InputMaybe<Scalars["String"]["input"]>;
  /** The usual time for retaining this kind of specimen */
  retentionTime?: InputMaybe<DurationCreateInput>;
  /** Specimen for single use only */
  singleUse?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Criterion specified for specimen rejection */
  specimenRejectionCriterion?: InputMaybe<Array<RejectionCriteria>>;
  /** Type of intended specimen */
  specimenType: SpecimenCodes;
  /** The specimens container */
  testContainer: SpecimenDefinitionTestContainerInput;
  /** Where the specimen will be tested */
  testingDestination?: InputMaybe<DiagnosticServiceSection>;
};

export type SpecimenDefinitionTestUpdateInput = {
  container?: InputMaybe<SpecimenDefinitionTestContainerUpdateInput>;
  /** Primary or secondary specimen */
  isDerived?: InputMaybe<Scalars["Boolean"]["input"]>;
  preference?: InputMaybe<SpecimenContainedPreference>;
  /** Requirements for specimen delivery and special handling */
  requirements?: InputMaybe<Scalars["String"]["input"]>;
  /** The usual time for retaining this kind of specimen */
  retentionTime?: InputMaybe<DurationCreateInput>;
  /** Specimen for single use only */
  singleUse?: InputMaybe<Scalars["Boolean"]["input"]>;
  specimenDefinitionTestId: Scalars["ID"]["input"];
  /** Criterion specified for specimen rejection */
  specimenRejectionCriterion?: InputMaybe<Array<RejectionCriteria>>;
  /** Type of intended specimen */
  specimenType?: InputMaybe<SpecimenCodes>;
  /** Where the specimen will be tested */
  testingDestination?: InputMaybe<DiagnosticServiceSection>;
};

export type SpecimenDefinitionTests = {
  __typename?: "SpecimenDefinitionTests";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition: SpecimenDefinitions;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Set of instructions for preservation/transport of the specimen at a defined temperature interval, prior the testing process. */
  handling?: Maybe<Array<SpecimenDefinitionHandling>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Primary or secondary specimen */
  is_derived: Scalars["Boolean"]["output"];
  /** The preference for this type of conditioned specimen. */
  preference: SpecimenContainedPreference;
  /** Criterion specified for specimen rejection */
  rejection_criterion?: Maybe<Array<RejectionCriteria>>;
  /** Requirements for specimen delivery and special handling */
  requirement?: Maybe<Scalars["String"]["output"]>;
  /** The usual time for retaining this kind of specimen (Eg. "30 minutes") */
  retention_time?: Maybe<Durations>;
  /** Specimen for single use only */
  single_use?: Maybe<Scalars["Boolean"]["output"]>;
  /** The specimens container */
  test_container: SpecimenDefinitionTestContainers;
  test_id: Scalars["ID"]["output"];
  /** Where the specimen will be tested */
  testing_destination?: Maybe<DiagnosticServiceSection>;
  /** Type of intended specimen */
  type: SpecimenCodes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenDefinitionUpdateInput = {
  approvalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Definition this specimen definition is based on */
  derivedDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Effective date range for the definition */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastReviewDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The name of the individual or organization that published the definition */
  publisher?: InputMaybe<Scalars["String"]["input"]>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  specimenDefinitionId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpecimenDefinitions = {
  __typename?: "SpecimenDefinitions";
  /** When definition was approved by publisher */
  approval_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Specimen collection procedure */
  collection: SpecimenDefinitionCollections;
  /** Contact details for the publisher */
  contact?: Maybe<Array<ContactDetails>>;
  /** The content was developed with a focus and intent of supporting the contexts that are listed. These terms may be used to assist with indexing and searching of specimen definitions. */
  context?: Maybe<Array<UsageContexts>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Based on another Specimen definition */
  derived_from?: Maybe<SpecimenDefinitions>;
  /** Natural language description of this definition */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The effective date range for the definition */
  effective_period?: Maybe<Periods>;
  /** Definition not for real usage */
  experimental: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The date on which the asset content was last reviewed by the publisher */
  last_review_date?: Maybe<Scalars["DateTime"]["output"]>;
  organization_id: Scalars["ID"]["output"];
  /** The name of the individual or organization that published the SpecimenDefinition */
  publisher: Scalars["String"]["output"];
  purpose?: Maybe<Scalars["String"]["output"]>;
  /** List of location references this definition is available to. */
  scope?: Maybe<Array<References>>;
  /** Specimen in container intended for testing by lab */
  specimens_tested?: Maybe<Array<SpecimenDefinitionTests>>;
  status: PublicationStatus;
  /** Human friendly name for this definition */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Logical URL to reference this definition (globally unique) */
  url?: Maybe<Scalars["String"]["output"]>;
  /** Business version of this definition */
  version: Scalars["String"]["output"];
};

export type SpecimenFeatures = {
  __typename?: "SpecimenFeatures";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Information about the feature */
  description: Scalars["String"]["output"];
  feature_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  specimen: Specimens;
  /** The landmark or feature being highlighted. */
  type: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SpecimenProcessing = {
  __typename?: "SpecimenProcessing";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  method?: Maybe<Scalars["String"]["output"]>;
  processing_id: Scalars["String"]["output"];
  specimen: Specimens;
  /** Date/time of specimen processing */
  time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible specimen role codes */
export enum SpecimenRole {
  B = "B",
  C = "C",
  E = "E",
  F = "F",
  O = "O",
  P = "P",
  Q = "Q",
  R = "R",
  V = "V",
}

/** All possible specimen statuses */
export enum SpecimenStatus {
  Available = "AVAILABLE",
  EnteredInError = "ENTERED_IN_ERROR",
  Unavailable = "UNAVAILABLE",
  Unsatisfactory = "UNSATISFACTORY",
}

export type SpecimenSubject = Devices | Patients;

export type Specimens = {
  __typename?: "Specimens";
  /** Identifier assigned by the lab */
  accession_identifier: Identifiers;
  /** Collection details */
  collection: SpecimenCollections;
  /** This element signifies if the specimen is part of a group or pooled. */
  combined: SpecimenCombined;
  /** State of the specimen */
  condition: SpecimenCondition;
  /** Direct container of specimen (tube/slide, etc.) */
  containers: Array<SpecimenContainers>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  device_id?: Maybe<Scalars["String"]["output"]>;
  /** The physical features of a specimen */
  features?: Maybe<Array<SpecimenFeatures>>;
  is_archived: Scalars["Boolean"]["output"];
  /** Comments */
  note?: Maybe<Annotations>;
  parent?: Maybe<Specimens>;
  patient_id?: Maybe<Scalars["String"]["output"]>;
  /** Processing and processing step details */
  processing?: Maybe<Array<SpecimenProcessing>>;
  received_time: Scalars["GraphQLDateTime"]["output"];
  request?: Maybe<ServiceRequests>;
  request_id?: Maybe<Scalars["String"]["output"]>;
  /** The role or reason for the specimen in the testing workflow. */
  role?: Maybe<SpecimenRole>;
  specimen_id: Scalars["String"]["output"];
  status: SpecimenStatus;
  subject: SpecimenSubject;
  type: SpecimenCodes;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type StaffAssignmentActionInput = {
  add?: InputMaybe<Array<StaffAssignmentInput>>;
  remove?: InputMaybe<Array<StaffAssignmentDeleteInput>>;
  update?: InputMaybe<StaffAssignmentUpdateInput>;
};

export type StaffAssignmentCreateInput = {
  /** Represents the location the employee is assigned to work. */
  assignedLocationId: Scalars["ID"]["input"];
  /** Employee hire date */
  hireDate: Scalars["DateTime"]["input"];
  /** Represents the organization under which the employee is employed */
  organizationId: Scalars["ID"]["input"];
  /** Identifier referencing the staff user */
  staffId: Scalars["ID"]["input"];
  status?: InputMaybe<EmploymentStatus>;
  /** Job title of the staff within the organization. */
  title: Scalars["String"]["input"];
};

export type StaffAssignmentDeleteInput = {
  assignmentId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StaffAssignmentInput = {
  /** Represents the location the employee is assigned to work. */
  assignedLocationId: Scalars["ID"]["input"];
  /** Employee hire date */
  hireDate: Scalars["DateTime"]["input"];
  /** Represents the organization under which the employee is employed */
  organizationId: Scalars["ID"]["input"];
  status?: InputMaybe<EmploymentStatus>;
  /** Job title of the staff within the organization. */
  title: Scalars["String"]["input"];
};

export type StaffAssignmentManageInput = {
  action: StaffAssignmentActionInput;
  staffId: Scalars["ID"]["input"];
};

export type StaffAssignmentPaginatedResponse = {
  __typename?: "StaffAssignmentPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<StaffAssignments>;
  totalPages: Scalars["Float"]["output"];
};

export type StaffAssignmentUpdateInput = {
  assignedLocationId?: InputMaybe<Scalars["ID"]["input"]>;
  assignmentId: Scalars["ID"]["input"];
  status?: InputMaybe<EmploymentStatus>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type StaffAssignments = {
  __typename?: "StaffAssignments";
  assignment_id: Scalars["String"]["output"];
  clinical_notes?: Maybe<Array<ClinicalNotes>>;
  company: Organizations;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  departments?: Maybe<Array<Departments>>;
  employee: Staffs;
  hire_date: Scalars["DateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  location: Locations;
  location_id: Scalars["String"]["output"];
  organization_id: Scalars["String"]["output"];
  staff_id: Scalars["String"]["output"];
  status: EmploymentStatus;
  teams?: Maybe<Array<Teams>>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type StaffChanges = ChangesEntity & {
  __typename?: "StaffChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  staff_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type StaffContactRequiredInput = {
  period?: InputMaybe<PeriodCreateInput>;
  /** Specify preferred order of use (1 = highest) */
  rank?: InputMaybe<Scalars["Float"]["input"]>;
  system: ContactPointSystem;
  use: ContactPointUse;
  value: Scalars["String"]["input"];
};

export type StaffDemographicInput = {
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>;
  dob: Scalars["String"]["input"];
  ethnicity?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  maritalStatus?: InputMaybe<MaritalStatus>;
  race?: InputMaybe<Scalars["String"]["input"]>;
  sex: Scalars["String"]["input"];
};

/** The uniquely identifying organization staff value. */
export type StaffRegisterExternalIdInput = {
  externalIdentifier: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
};

/** The uniquely identifying registration method. (Must provide email OR phone #) */
export type StaffRegisterMethodInput = {
  method: IdentityRegistrationMethods;
  value: Scalars["String"]["input"];
};

export type Staffs = {
  __typename?: "Staffs";
  assignments: Array<StaffAssignments>;
  changes?: Maybe<Array<StaffChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  practitioner?: Maybe<Practitioners>;
  /** External provider reference id */
  practitioner_id?: Maybe<Scalars["String"]["output"]>;
  routeAssignments: Array<RouteAssignments>;
  staff_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
};

export type StepInformationCreateInput = {
  /** Text note for input */
  annotation?: InputMaybe<Scalars["String"]["input"]>;
  /** Label for the input */
  label: Scalars["String"]["input"];
  value: StepInformationValuesInput;
};

export type StepInformationValuesInput = {
  identifier?: InputMaybe<IdentifierCreateInput>;
  period?: InputMaybe<PeriodCreateInput>;
  quantity?: InputMaybe<QuantityCreateInput>;
  range?: InputMaybe<RangeCreateInput>;
  ratio?: InputMaybe<RatioCreateInput>;
  reference: ReferenceCreateInput;
  valueArray?: InputMaybe<Array<Scalars["String"]["input"]>>;
  valueBoolean?: InputMaybe<Scalars["Boolean"]["input"]>;
  valueDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  valueDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  valueDecimal?: InputMaybe<Scalars["Float"]["input"]>;
  valueInteger?: InputMaybe<Scalars["Float"]["input"]>;
  valueMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  valueString?: InputMaybe<Scalars["String"]["input"]>;
  valueUrl?: InputMaybe<Scalars["String"]["input"]>;
  valueUuid?: InputMaybe<Scalars["String"]["input"]>;
};

export type StepOutputUpdateInput = {
  /** Label for the input */
  label?: InputMaybe<Scalars["String"]["input"]>;
  taskOutputId: Scalars["String"]["input"];
  value: StepInformationValuesInput;
};

export type StoreFrontCategories = {
  __typename?: "StoreFrontCategories";
  label: Scalars["String"]["output"];
  number_of_products: Scalars["Float"]["output"];
  products?: Maybe<Array<ProductCatalogItems>>;
};

export type StoreProductPaginatedResults = {
  __typename?: "StoreProductPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<StoreProductResult>;
  stores?: Maybe<Array<WebStores>>;
  totalPages: Scalars["Float"]["output"];
};

export type StoreProductResult = {
  __typename?: "StoreProductResult";
  id: Scalars["ID"]["output"];
  price: PriceBookEntries;
  product: Products;
  store: WebStores;
};

export type StoreProductSearchBy = {
  category?: InputMaybe<SearchByArgs>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  price?: InputMaybe<SearchByArgs>;
  product?: InputMaybe<SearchByArgs>;
  store?: InputMaybe<SearchByArgs>;
};

export type StringValue = {
  __typename?: "StringValue";
  value: Scalars["String"]["output"];
};

export type SubmitCriteriaFormResult = {
  /** The identifier for the criteria definition of result */
  criteriaDefinitionId: Scalars["String"]["input"];
  /** List of flags (if any) that triggered positive result. */
  flaggedBy?: InputMaybe<Array<CriteriaFormResultFlagsInput>>;
  /** Additional notes or comments about criteria result. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether or not criteria was met */
  passed: Scalars["Boolean"]["input"];
  patientId: Scalars["String"]["input"];
};

export type SubmitLabOrderResponse = {
  __typename?: "SubmitLabOrderResponse";
  /** Lab order UUID from the gateway */
  labOrderId?: Maybe<Scalars["String"]["output"]>;
  /** Operation result message */
  message: Scalars["String"]["output"];
  /** Whether the operation succeeded */
  success: Scalars["Boolean"]["output"];
};

export type SubmitOrderRequestInput = {
  /** Services being requested */
  lineItems?: InputMaybe<Array<OrderLineItemInput>>;
  order: OrderInput;
  patient: OrderPatient;
  physician?: InputMaybe<OrderProviderInput>;
  /** If true, skip duplicate check for order */
  skipDuplicateCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SubscriberTopicCreateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Determines if topic is for testing purposes, not real usage. */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Computer-friendly name for this topic. */
  name: Scalars["String"]["input"];
  status?: InputMaybe<PublicationStatus>;
  /** Human-friendly name for topic. */
  title?: InputMaybe<Scalars["String"]["input"]>;
  topic: SubscriptionTrigger;
  /** An absolute URI that is used to identify this subscription topic when it is referenced in a specification, model, design or an instance; */
  uri?: InputMaybe<Scalars["String"]["input"]>;
};

export type SubscriberTopicUpdateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Determines if topic is for testing purposes, not real usage. */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  /** Human-friendly name for topic. */
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId: Scalars["String"]["input"];
  /** An absolute URI that is used to identify this subscription topic when it is referenced in a specification, model, design or an instance; */
  uri?: InputMaybe<Scalars["String"]["input"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  channelEventSubscriptions: ChannelSubscriberMessage;
  newNotification: Notifications;
  notificationSubscriptions: Notifications;
  timelineSubscription: TimelineSubscriberMessage;
};

export type SubscriptionChannelEventSubscriptionsArgs = {
  cynergyId: Scalars["String"]["input"];
};

export type SubscriptionNewNotificationArgs = {
  topics: Array<Scalars["String"]["input"]>;
};

export type SubscriptionNotificationSubscriptionsArgs = {
  cynergyId: Scalars["String"]["input"];
};

export type SubscriptionTimelineSubscriptionArgs = {
  cynergyId: Scalars["String"]["input"];
  locationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All possible FHIR Subscription channel type codes. */
export enum SubscriptionChannelType {
  /** The channel is executed by sending an email to the email addressed in the URI (which must be a mailto:). */
  Email = "EMAIL",
  /** The channel is executed by sending a message (e.g. a Bundle with a MessageHeader resource etc.) to the application identified in the URI. */
  Message = "MESSAGE",
  /** The channel is executed by making a POST to the URI with the selected payload and MIME type. */
  RestHook = "REST_HOOK",
  /** The channel is executed by sending a packet across a web socket connection maintained by the client. The URL identifies the websocket, and the client binds to this URL. */
  Websocket = "WEBSOCKET",
}

export type SubscriptionChannels = {
  __typename?: "SubscriptionChannels";
  channel_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** When to automatically delete the channel. */
  end: Scalars["GraphQLDateTime"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  members: Array<ChannelMembers>;
  /** Human readable name for this channel */
  name: Scalars["String"]["output"];
  status: SubscriptionStatus;
  topic: SubscriptionTopics;
  type: SubscriptionChannelType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SubscriptionHistory = {
  __typename?: "SubscriptionHistory";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  history_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  subscription: Subscriptions;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SubscriptionPayments = {
  __typename?: "SubscriptionPayments";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SubscriptionPlans = {
  __typename?: "SubscriptionPlans";
  base_price: Scalars["Float"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_active: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Defines the multiplier (if any) to times the number of locations against. If subscription is meant for patients, this should be zero. */
  multiplier: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  plan_id: Scalars["Float"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR SubscriptionStatus codes. */
export enum SubscriptionStatus {
  /** The subscription is active. */
  Active = "ACTIVE",
  /** This subscription has been flagged as incorrect. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The server has an error executing the notification. */
  Error = "ERROR",
  /** Too many errors have occurred or the subscription has expired. */
  Off = "OFF",
  /** The client has requested the subscription, and the server has not yet set it up. */
  Requested = "REQUESTED",
}

export type SubscriptionTopics = {
  __typename?: "SubscriptionTopics";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** Determines if topic is for testing purposes, not real usage. */
  experimental: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Name for this subscription topic (computer friendly) */
  name: Scalars["String"]["output"];
  status: PublicationStatus;
  /** Name for this subscription topic (human friendly) */
  title: Scalars["String"]["output"];
  topic: SubscriptionTrigger;
  topic_id?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** An absolute URI that is used to identify this subscription topic when it is referenced in a specification, model, design or an instance; */
  url: Scalars["String"]["output"];
};

/** List of possible subscribable topic triggers. */
export enum SubscriptionTrigger {
  CartTimeToLive = "CartTimeToLive",
  OnCartExpire = "onCartExpire",
  OnChannel = "onChannel",
  OnChat = "onChat",
  OnGateway = "onGateway",
  OnMessage = "onMessage",
  OnNotification = "onNotification",
  OnOrder = "onOrder",
  OnTask = "onTask",
  OnTimeline = "onTimeline",
}

export type Subscriptions = {
  __typename?: "Subscriptions";
  active: Scalars["Boolean"]["output"];
  /** annual or monthly */
  billing_cycle: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  history: Array<SubscriptionHistory>;
  is_archived: Scalars["Boolean"]["output"];
  payments: Array<Transactions>;
  subscription_id: Scalars["String"]["output"];
  subscription_plan: SubscriptionPlans;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
};

/** All possible substance FHIR category codes */
export enum SubstanceCategories {
  /** A substance that causes an allergic reaction. */
  Allergen = "ALLERGEN",
  /** A substance that is produced by or extracted from a biological source. */
  Biological = "BIOLOGICAL",
  /** A substance that comes directly from a human or an animal (e.g. blood, urine, feces, tears, etc.). */
  Body = "BODY",
  /** Any organic or inorganic substance of a particular molecular identity, including -- (i) any combination of such substances occurring in whole or in part as a result of a chemical reaction or occurring in nature and (ii) any element or uncombined radical (http://www.epa.gov/opptintr/import-export/pubs/importguide.pdf). */
  Chemical = "CHEMICAL",
  /** A substance intended for use in the diagnosis, cure, mitigation, treatment, or prevention of disease in man or other animals (Federal Food Drug and Cosmetic Act). */
  Drug = "DRUG",
  /** A food, dietary ingredient, or dietary supplement for human or animal. */
  Food = "FOOD",
  /** A finished product which is not normally ingested, absorbed or injected (e.g. steel, iron, wood, plastic and paper). */
  Material = "MATERIAL",
}

export type SubstanceIngredients = {
  __typename?: "SubstanceIngredients";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  ingredient_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  quantity: Quantity;
  substance: Substances;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible substance FHIR status codes */
export enum SubstanceStatus {
  /** The substance is considered for use or reference. */
  Active = "ACTIVE",
  /** The substance is entered in error. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The substance is considered for reference, but not for use. */
  Inactive = "INACTIVE",
}

export type Substances = {
  __typename?: "Substances";
  category: SubstanceCategories;
  /** What substance this is. See: https://build.fhir.org/valueset-substance-code.html */
  code: Scalars["Float"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** When the substance is no longer valid to use. For some substances, a single arbitrary date is used for expiry. */
  expiry: Scalars["DateTime"]["output"];
  ingredient: SubstanceIngredients;
  /** A boolean to indicate if this an instance of a substance or a kind of one (a definition) */
  instance: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  quantity: Quantity;
  status: SubstanceStatus;
  substance_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type SupervisorRoleResult = {
  __typename?: "SupervisorRoleResult";
  cynergyId: Scalars["String"]["output"];
  /** True when the user now holds the SUPERVISOR client role in Keycloak after the toggle. */
  isSupervisor: Scalars["Boolean"]["output"];
};

export type SymptomAssessment = {
  __typename?: "SymptomAssessment";
  confidence: Scalars["Float"]["output"];
  indicators: Array<Indicator>;
  item: CriteriaItems;
  statement: Scalars["String"]["output"];
};

export type SymptomAssessmentResults = {
  __typename?: "SymptomAssessmentResults";
  assessedOn: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  results: Array<SymptomAssessment>;
};

/** List of all patient symptom codes. */
export enum SymptomCodes {
  AbdominalPain = "ABDOMINAL_PAIN",
  BloodClots = "BLOOD_CLOTS",
  ChestPain = "CHEST_PAIN",
  Chills = "CHILLS",
  Coughing = "COUGHING",
  EarPain = "EAR_PAIN",
  Fever = "FEVER",
  LightHeaded = "LIGHT_HEADED",
  Migraine = "MIGRAINE",
  Rash = "RASH",
  Redness = "REDNESS",
  Swelling = "SWELLING",
  ThroatPain = "THROAT_PAIN",
  Vertigo = "VERTIGO",
}

export type SymptomsCreateInput = {
  carePlanId?: InputMaybe<Scalars["String"]["input"]>;
  icd10Codes: Array<Scalars["String"]["input"]>;
};

export type TagCreateInput = {
  iconUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /** Human friendly name */
  name: Scalars["String"]["input"];
  slug?: InputMaybe<Scalars["String"]["input"]>;
  tag: Scalars["String"]["input"];
};

export type TagDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  tags: Array<TagIdentifier>;
};

export type TagIdentifier = {
  tagId: Scalars["ID"]["input"];
};

export type TagLinkOrCreateInput = {
  tag?: InputMaybe<TagCreateInput>;
  tagId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TagUpdateInput = {
  iconUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /** Human friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  tag?: InputMaybe<Scalars["String"]["input"]>;
  tagId: Scalars["ID"]["input"];
};

export type Tags = {
  __typename?: "Tags";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Minio path to tag icon */
  icon_url?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly name */
  name: Scalars["String"]["output"];
  slug?: Maybe<Scalars["String"]["output"]>;
  tag: Scalars["String"]["output"];
  tag_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TaskActorInput = {
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  practitionerId?: InputMaybe<Scalars["String"]["input"]>;
  staffRelationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type TaskActorUnion = Organizations | Patients | Practitioners | StaffAssignments;

/** All possible FHIR task codes. */
export enum TaskCode {
  /** Abort, cancel or withdraw the focal resource, as appropriate for the type of resource. */
  Abort = "ABORT",
  /** Take what actions are needed to transition the focus resource from 'draft' to 'active' or 'in-progress', as appropriate for the resource type. This may involve additing additional content, approval, validation, etc. */
  Approve = "APPROVE",
  /** Update the focal resource of the owning system to reflect the content specified as the Task.focus */
  Change = "CHANGE",
  /** Act to perform the actions described in the focus request. This might result in a 'more assertive' request (order for a plan or proposal, filler order for a placer order), but is intend to eventually result in events. The degree of fulfillment requested might be limited by Task.restriction. */
  Fulfill = "FULFILL",
  /** Act to perform the actions defined in the focus definition resource (ActivityDefinition, PlanDefinition, Questionnaire, etc.) For PlanDefinition or ActivityDefinition, this might result in a 'more assertive' request (order for a plan or proposal, filler order for a placer order), but is intend to eventually result in events. For Questionnaire, this would result in a QuestionnaireResponse - and possibly resources constructed using data extracted from the response. The degree of fulfillment requested might be limited by Task.restriction. */
  Instantiate = "INSTANTIATE",
  /** Replace the focal resource with the specified input resource */
  Replace = "REPLACE",
  /** Transition the focal resource from 'suspended' to 'active' or 'in-progress' as appropriate for the resource type. */
  Resume = "RESUME",
  /** Transition the focal resource from 'active' or 'in-progress' to 'suspended' */
  Suspend = "SUSPEND",
}

export type TaskCreateInput = {
  /** Formal definition of task */
  activityDefinitionId?: InputMaybe<Scalars["String"]["input"]>;
  /** Comments made about the task. */
  annotation?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual or device responsible for task execution. */
  assignee: TaskActorInput;
  assigneeFunction: ActionParticipantFunction;
  /** Type of requested performer */
  assigneeRole: Scalars["String"]["input"];
  /** E.g. "Specimen collected", "IV prepped" */
  businessStatus: Scalars["String"]["input"];
  code: TaskCode;
  completedAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  description: Scalars["String"]["input"];
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  encounterId?: InputMaybe<Scalars["String"]["input"]>;
  /** The entity who benefits from the performance of the service specified in the task (e.g., the patient). */
  for: ReferenceCreateInput;
  intent: TaskIntent;
  label?: InputMaybe<TaskLabels>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  locationId: Scalars["String"]["input"];
  notificationId?: InputMaybe<Scalars["String"]["input"]>;
  /** Composite task */
  parentTaskId?: InputMaybe<Scalars["String"]["input"]>;
  /** The patient who benefits from the performance of the service specified in the task (e.g., the patient). */
  patientId: Scalars["String"]["input"];
  priority: RequestPriority;
  /** Why task is needed */
  reason: Scalars["String"]["input"];
  /** Resource that triggered the creation of the task */
  reference: ReferenceCreateInput;
  /** When the task should be performed */
  requestedPeriod: PeriodCreateInput;
  startedAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status: TaskStatus;
  statusReason?: InputMaybe<TaskStatusReason>;
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type TaskDeleteInput = {
  taskId: Scalars["ID"]["input"];
};

export type TaskInputs = {
  __typename?: "TaskInputs";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Label for the input */
  label: Scalars["String"]["output"];
  step: TaskSteps;
  task_input_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value_annotation?: Maybe<Annotations>;
  value_array?: Maybe<Scalars["String"]["output"]>;
  value_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  value_date?: Maybe<Scalars["DateTime"]["output"]>;
  value_date_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  value_decimal?: Maybe<Scalars["Float"]["output"]>;
  value_identifier?: Maybe<Identifiers>;
  value_integer?: Maybe<Scalars["Float"]["output"]>;
  value_markdown?: Maybe<Scalars["String"]["output"]>;
  value_period?: Maybe<Periods>;
  value_quantity?: Maybe<Quantity>;
  value_range?: Maybe<Range>;
  value_ratio?: Maybe<Ratio>;
  value_reference?: Maybe<References>;
  value_signature?: Maybe<Signatures>;
  value_string?: Maybe<Scalars["String"]["output"]>;
  value_timing?: Maybe<Timings>;
  value_url?: Maybe<Scalars["String"]["output"]>;
  value_uuid?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR task intent codes. */
export enum TaskIntent {
  /** The request represents the view of an authorization instantiated by a fulfilling system representing the details of the fulfiller's intention to act upon a submitted order. */
  FillerOrder = "FILLER_ORDER",
  /** An order created in fulfillment of a broader order that represents the authorization for a single activity occurrence. E.g. The administration of a single dose of a drug. */
  InstanceOrder = "INSTANCE_ORDER",
  /** The request represents a request/demand and authorization for action by the requestor. */
  Order = "ORDER",
  /** The request represents a component or option for a RequestOrchestration that establishes timing, conditionality and/or other constraints among a set of requests. Refer to [[[RequestOrchestration]]] for additional information on how this status is used. */
  OrderOption = "ORDER_OPTION",
  /** The request represents an original authorization for action. */
  OriginalOrder = "ORIGINAL_ORDER",
  /** The request represents an intention to ensure something occurs without providing an authorization for others to act. */
  Plan = "PLAN",
  /** The request is a suggestion made by someone/something that does not have an intention to ensure it occurs and without providing an authorization to act. */
  Proposal = "PROPOSAL",
  /** The request represents an automatically generated supplemental authorization for action based on a parent authorization together with initial results of the action taken against that parent authorization. */
  ReflexOrder = "REFLEX_ORDER",
  /** The intent is not known. When dealing with Task, it's not always known (or relevant) how the task was initiated - i.e. whether it was proposed, planned, ordered or just done spontaneously. */
  Unknown = "UNKNOWN",
}

/** Categorization labels for user tasks. */
export enum TaskLabels {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Default = "DEFAULT",
  Deleted = "DELETED",
  Draft = "DRAFT",
  Important = "IMPORTANT",
  InProgress = "IN_PROGRESS",
  New = "NEW",
}

export type TaskOutputs = {
  __typename?: "TaskOutputs";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Label for the output */
  label: Scalars["String"]["output"];
  step: TaskSteps;
  task_output_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value_annotation?: Maybe<Annotations>;
  value_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  value_date?: Maybe<Scalars["DateTime"]["output"]>;
  value_date_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  value_decimal?: Maybe<Scalars["Float"]["output"]>;
  value_identifier?: Maybe<Identifiers>;
  value_integer?: Maybe<Scalars["Float"]["output"]>;
  value_markdown?: Maybe<Scalars["String"]["output"]>;
  value_period?: Maybe<Periods>;
  value_quantity?: Maybe<Quantity>;
  value_range?: Maybe<Range>;
  value_ratio?: Maybe<Ratio>;
  value_reference?: Maybe<References>;
  value_signature?: Maybe<Signatures>;
  value_string?: Maybe<Scalars["String"]["output"]>;
  value_timing?: Maybe<Timings>;
  value_url?: Maybe<Scalars["String"]["output"]>;
  value_uuid?: Maybe<Scalars["String"]["output"]>;
};

export type TaskPaginatedResults = {
  __typename?: "TaskPaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<Tasks>;
  totalPages: Scalars["Float"]["output"];
};

export enum TaskRequirementValueTypes {
  Boolean = "BOOLEAN",
  Null = "NULL",
  Number = "NUMBER",
  String = "STRING",
}

export type TaskRestrictions = {
  __typename?: "TaskRestrictions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Over what time-period is fulfillment sought. E.g. order that authorizes 1 year's services. Fulfillment is sought for next 3 months. Note that period.high is the due date representing the time by which the task should be completed. */
  period?: Maybe<Periods>;
  /** How many times to repeat */
  repetitions: Scalars["Float"]["output"];
  task: Tasks;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TaskStatisticsResponse = {
  __typename?: "TaskStatisticsResponse";
  cancelled_tasks: Scalars["Float"]["output"];
  completed_tasks: Scalars["Float"]["output"];
  completion_percentage: Scalars["Float"]["output"];
  new_tasks: Scalars["Float"]["output"];
  open_tasks: Scalars["Float"]["output"];
  total: Scalars["Float"]["output"];
};

/** All possible FHIR task status codes. */
export enum TaskStatus {
  /** The potential performer has agreed to execute the task but has not yet started work. */
  Accepted = "ACCEPTED",
  /** The task was not completed. */
  Cancelled = "CANCELLED",
  /** The task has been completed. */
  Completed = "COMPLETED",
  /** The task is not yet ready to be acted upon. */
  Draft = "DRAFT",
  /** The task should never have existed and is retained only because of the possibility it may have used. */
  EnteredInError = "ENTERED_IN_ERROR",
  /** The task was attempted but could not be completed due to some error. */
  Failed = "FAILED",
  /** The task has been started but is not yet complete. */
  InProgress = "IN_PROGRESS",
  /** The task has been started but work has been paused. */
  OnHold = "ON_HOLD",
  /** The task is ready to be performed, but no action has yet been taken. Used in place of requested/received/accepted/rejected when request assignment and acceptance is a given. */
  Ready = "READY",
  /** A potential performer has claimed ownership of the task and is evaluating whether to perform it. */
  Received = "RECEIVED",
  /** The potential performer who claimed ownership of the task has decided not to execute it prior to performing any action. */
  Rejected = "REJECTED",
  /** The task is ready to be acted upon and action is sought. */
  Requested = "REQUESTED",
}

/** All possible FHIR task status reason codes. */
export enum TaskStatusReason {
  /** Something in the environment is preventing task completion. */
  EnvironmentalIssue = "ENVIRONMENTAL_ISSUE",
  /** A piece of equipment necessary for completion of the task is malfunctioning. */
  EquipmentIssue = "EQUIPMENT_ISSUE",
  /** Something related to the task was misidentified. */
  Misidentified = "MISIDENTIFIED",
  /** An item nessary for task completion is missing. */
  Missing = "MISSING",
  Na = "NA",
  /** Key personnel necessary for task completion are not present. */
  PersonnelIssue = "PERSONNEL_ISSUE",
  Unknown = "UNKNOWN",
}

export type TaskStepCreateInput = {
  steps: Array<TaskStepInput>;
  taskId: Scalars["String"]["input"];
};

export type TaskStepInput = {
  /** Comments made about the task. */
  annotation?: InputMaybe<Scalars["String"]["input"]>;
  description: Scalars["String"]["input"];
  /** The reference to a request being actioned or the resource being manipulated by this task. */
  focusReference: ReferenceCreateInput;
  /** Information used to perform task. */
  input: Array<StepInformationCreateInput>;
  label: Scalars["String"]["input"];
  /** Application navigation link */
  link?: InputMaybe<Scalars["String"]["input"]>;
  /** The sequential order of this step in relation to task */
  order: Scalars["Float"]["input"];
  /** 0-100 [default: 0] */
  progress?: InputMaybe<Scalars["Float"]["input"]>;
  /** Is this step required to complete task? [default: true] */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  startedAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status: TaskStatus;
  statusReason?: InputMaybe<TaskStatusReason>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type TaskStepRequirements = {
  __typename?: "TaskStepRequirements";
  comparator: QuantityComparator;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  step: TaskSteps;
  /** The target TaskStep.output attribute to compare requirement against. */
  target: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
  /** How the value should be read. [typeof TaskStepRequirements.value] */
  value_type: TaskRequirementValueTypes;
};

export type TaskStepUpdateInput = {
  /** Comments made about the task. */
  annotation?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The reference to a request being actioned or the resource being manipulated by this task. */
  focusReferenceId?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Application navigation link */
  link?: InputMaybe<Scalars["String"]["input"]>;
  /** The sequential order of this step in relation to task */
  order?: InputMaybe<Scalars["Float"]["input"]>;
  /** Information produced as part of task */
  output?: InputMaybe<Array<StepOutputUpdateInput>>;
  /** 0-100 [default: 0] */
  progress?: InputMaybe<Scalars["Float"]["input"]>;
  /** Is this step required to complete task? [default: true] */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  startedAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status?: InputMaybe<TaskStatus>;
  statusReason?: InputMaybe<TaskStatusReason>;
  stepId?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type TaskSteps = {
  __typename?: "TaskSteps";
  /** Date time the assignee completed task step */
  completed_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  /** The request being actioned or the resource being manipulated by this task. */
  focus: References;
  /** Information used to perform task */
  input?: Maybe<Array<TaskInputs>>;
  is_archived: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  /** Application navigation link. */
  link?: Maybe<Scalars["String"]["output"]>;
  /** Comments made about the task step. */
  note?: Maybe<Annotations>;
  /** The sequential order of this step. */
  order: Scalars["Float"]["output"];
  /** Information produced as part of task */
  output?: Maybe<Array<TaskOutputs>>;
  /** Percentage completion of task */
  progress: Scalars["Float"]["output"];
  /** Is this step required to complete task? */
  required: Scalars["Boolean"]["output"];
  /** List of requirements needed to satisfy step. */
  requirements?: Maybe<TaskStepRequirements>;
  /** Date time the assignee started task */
  started_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  status: TaskStatus;
  status_reason?: Maybe<TaskStatusReason>;
  step_id: Scalars["String"]["output"];
  task: Tasks;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type TaskUpdateInput = {
  /** Formal definition of task */
  activityDefinitionId?: InputMaybe<Scalars["String"]["input"]>;
  /** Comments made about the task. */
  annotation?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual or device responsible for task execution. */
  assignee?: InputMaybe<TaskActorInput>;
  /** E.g. "Specimen collected", "IV prepped" */
  businessStatus?: InputMaybe<Scalars["String"]["input"]>;
  code?: InputMaybe<TaskCode>;
  completedAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  doNotPerform?: InputMaybe<Scalars["Boolean"]["input"]>;
  encounterId?: InputMaybe<Scalars["String"]["input"]>;
  intent?: InputMaybe<TaskIntent>;
  label?: InputMaybe<TaskLabels>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  notificationId?: InputMaybe<Scalars["String"]["input"]>;
  /** Composite task */
  parentTaskId?: InputMaybe<Scalars["String"]["input"]>;
  /** The entity who performed the requested task. */
  performer?: InputMaybe<TaskActorInput>;
  priority?: InputMaybe<RequestPriority>;
  /** Why task is needed */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  /** When the task should be performed */
  requestedPeriod?: InputMaybe<PeriodCreateInput>;
  startedAt?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  status?: InputMaybe<TaskStatus>;
  statusReason?: InputMaybe<TaskStatusReason>;
  taskId: Scalars["String"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type Tasks = {
  __typename?: "Tasks";
  /** Individual or device responsible for task execution. */
  assignee: TaskActorUnion;
  assignee_function: ActionParticipantFunction;
  /** Type of requested performer */
  assignee_role: Scalars["String"]["output"];
  /** Refers to a higher-level authorization that triggered the creation of the task. It references a "request" resource such as a ServiceRequest, MedicationRequest, CarePlan, etc. */
  based_on: References;
  /** E.g. "Specimen collected", "IV prepped" */
  business_status: Scalars["String"]["output"];
  code: TaskCode;
  /** Date time the assignee completed task */
  completed_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Formal definition of task */
  definition?: Maybe<ActivityDefinitions>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  /** True if task is prohibiting action. */
  do_not_perform: Scalars["Boolean"]["output"];
  /** Healthcare event during which this task originated. */
  encounter?: Maybe<Encounters>;
  /** Start and end time of execution */
  execution_period?: Maybe<Periods>;
  /** The entity who benefits from the performance of the service specified in the task (e.g., the patient). */
  for: References;
  intent: TaskIntent;
  is_archived: Scalars["Boolean"]["output"];
  /** Label used to categorize task. */
  label: TaskLabels;
  last_modified?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  /** Application navigation link. */
  link?: Maybe<Scalars["String"]["output"]>;
  /** Where task occurs. */
  location: Locations;
  /** Comments made about the task. */
  note?: Maybe<Annotations>;
  notification_id?: Maybe<Scalars["String"]["output"]>;
  /** Composite task. */
  part_of?: Maybe<Tasks>;
  /** The patient who benefits from the performance of the service specified in the task. */
  patient?: Maybe<Patients>;
  performer?: Maybe<TaskActorUnion>;
  priority: RequestPriority;
  /** Percentage completion of task */
  progress: Scalars["Float"]["output"];
  /** Why task is needed */
  reason: Scalars["String"]["output"];
  /** When the task should be performed */
  requested_period: Periods;
  /** Who is asking for task to be done. */
  requester: TaskActorUnion;
  /** Fulfillment task constraints. */
  restrictions?: Maybe<Array<TaskRestrictions>>;
  /** Date time the assignee started task */
  started_at?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  status: TaskStatus;
  status_reason?: Maybe<TaskStatusReason>;
  /** List of steps taken to complete task. */
  steps?: Maybe<Array<TaskSteps>>;
  task_id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type Taxonomies = {
  __typename?: "Taxonomies";
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description: Scalars["String"]["output"];
  group?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  license?: Maybe<Scalars["String"]["output"]>;
  practitioner: Practitioners;
  primary: Scalars["Boolean"]["output"];
  /** State abbreviation. */
  state?: Maybe<Scalars["String"]["output"]>;
  taxonomy_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TaxonomyCreateInput = {
  practitionerId: Scalars["String"]["input"];
  taxonomies: Array<TaxonomyRequiredInput>;
};

export type TaxonomyRequiredInput = {
  /** Taxonomy code */
  code: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  group?: InputMaybe<Scalars["String"]["input"]>;
  license?: InputMaybe<Scalars["String"]["input"]>;
  /** Primary taxonomy */
  primary?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamMembers = {
  __typename?: "TeamMembers";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  member_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type Teams = {
  __typename?: "Teams";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  members: Array<TeamMembers>;
  name: Scalars["String"]["output"];
  team_id: Scalars["String"]["output"];
  team_lead: StaffAssignments;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TestContainerLinkOrCreateInput = {
  container?: InputMaybe<SpecimenDefinitionContainerInput>;
  containerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type TestHistoryData = {
  __typename?: "TestHistoryData";
  effective_time?: Maybe<Scalars["String"]["output"]>;
  flag?: Maybe<Scalars["String"]["output"]>;
  issued?: Maybe<Scalars["String"]["output"]>;
  observation_id: Scalars["ID"]["output"];
  panel_name?: Maybe<Scalars["String"]["output"]>;
  reference_high?: Maybe<Scalars["Float"]["output"]>;
  reference_high_unit?: Maybe<Scalars["String"]["output"]>;
  reference_low?: Maybe<Scalars["Float"]["output"]>;
  reference_low_unit?: Maybe<Scalars["String"]["output"]>;
  result_value?: Maybe<Scalars["Float"]["output"]>;
  test_code: Scalars["String"]["output"];
  test_name: Scalars["String"]["output"];
  value_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  value_date?: Maybe<Scalars["DateTime"]["output"]>;
  value_string?: Maybe<Scalars["String"]["output"]>;
  value_time?: Maybe<Scalars["String"]["output"]>;
};

export type TestHistoryNonReportingData = {
  __typename?: "TestHistoryNonReportingData";
  flag?: Maybe<Scalars["String"]["output"]>;
  observation_id: Scalars["ID"]["output"];
  reference_high?: Maybe<Scalars["Float"]["output"]>;
  reference_high_unit?: Maybe<Scalars["String"]["output"]>;
  reference_low?: Maybe<Scalars["Float"]["output"]>;
  reference_low_unit?: Maybe<Scalars["String"]["output"]>;
  result_created_at?: Maybe<Scalars["DateTime"]["output"]>;
  result_value?: Maybe<Scalars["Float"]["output"]>;
  test_code: Scalars["String"]["output"];
  test_name?: Maybe<Scalars["String"]["output"]>;
  value_boolean?: Maybe<Scalars["Boolean"]["output"]>;
  value_date?: Maybe<Scalars["DateTime"]["output"]>;
  value_string?: Maybe<Scalars["String"]["output"]>;
  value_time?: Maybe<Scalars["String"]["output"]>;
};

export type TimeSlotPeriodsType = {
  __typename?: "TimeSlotPeriodsType";
  day: Scalars["Float"]["output"];
  time: Scalars["String"]["output"];
};

export type TimelineEntry = {
  __typename?: "TimelineEntry";
  action: ActionType;
  extras?: Maybe<TimelineExtras>;
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  reference?: Maybe<TimelineTargetReference>;
  subject: TimelineSubject;
  timestamp: Scalars["GraphQLDateTime"]["output"];
  title: Scalars["String"]["output"];
};

export type TimelineExtras = {
  __typename?: "TimelineExtras";
  category?: Maybe<FlagCategory>;
  link?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type TimelinePaginatedResults = {
  __typename?: "TimelinePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<TimelineEntry>;
  totalPages: Scalars["Float"]["output"];
};

export type TimelineSubject = {
  __typename?: "TimelineSubject";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  type: UserTypes;
};

export type TimelineSubscriberMessage = {
  __typename?: "TimelineSubscriberMessage";
  message: Scalars["String"]["output"];
  payload: TimelineEntry;
  status?: Maybe<Scalars["Float"]["output"]>;
};

export type TimelineTargetReference = {
  __typename?: "TimelineTargetReference";
  id?: Maybe<Scalars["ID"]["output"]>;
  resource: Scalars["String"]["output"];
};

/** All possible FHIR timing abbreviation codes. */
export enum TimingAbbreviations {
  Am = "AM",
  Bed = "BED",
  Bid = "BID",
  Mo = "MO",
  Pm = "PM",
  Q1H = "Q1H",
  Q2H = "Q2H",
  Q3H = "Q3H",
  Q4H = "Q4H",
  Q6H = "Q6H",
  Q8H = "Q8H",
  Qd = "QD",
  Qid = "QID",
  Qod = "QOD",
  Tid = "TID",
  Wk = "WK",
}

export type Timings = {
  __typename?: "Timings";
  /** type of length used */
  bounds?: Maybe<Scalars["String"]["output"]>;
  /** Number of times to repeat. */
  count: Scalars["Float"]["output"];
  /** Maximum number of times to repeat. */
  count_max: Scalars["Float"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  days_of_week: Array<DaysOfWeek>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** How long when it happens. */
  duration?: Maybe<Scalars["Float"]["output"]>;
  duration_max?: Maybe<Scalars["Float"]["output"]>;
  duration_unit?: Maybe<UnitsOfTime>;
  /** When the event occurs */
  event: Scalars["DateTime"]["output"];
  /** Indicates the number of repetitions that should occur within a period. I.e. Event occurs frequency times per period */
  frequency: Scalars["Float"]["output"];
  /** Event occurs up to frequencyMax times per period. */
  frequency_max?: Maybe<Scalars["Float"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Minutes from event (before or after) */
  offset?: Maybe<Scalars["Float"]["output"]>;
  /** The duration to which the frequency applies. I.e. Event occurs frequency times per period */
  period?: Maybe<Scalars["Float"]["output"]>;
  /** Upper limit of period (3-4 Hours) */
  period_max?: Maybe<Scalars["Float"]["output"]>;
  period_unit?: Maybe<UnitsOfTime>;
  /** Time of day for action. EX: 10:00am */
  time_of_day?: Maybe<Scalars["String"]["output"]>;
  timing_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  when: EventTimings;
};

export type ToggleAlertTypeInput = {
  alertTypeId: Scalars["String"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  /** Delivery channel preferences: { email: bool, push: bool, inApp: bool } */
  preferences?: InputMaybe<Scalars["JSON"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type ToggleSupervisorRoleInput = {
  /** Cynergy / Keycloak user id (NOT staff_id or assignment_id). The Keycloak realm user is located via the `cynergyId` attribute. */
  cynergyId: Scalars["String"]["input"];
};

export type TokenTypes = {
  __typename?: "TokenTypes";
  accessToken?: Maybe<Scalars["String"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
};

export type TrackTestInput = {
  testCode: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

export type TrackedChangeBundleCapabilityObject = {
  __typename?: "TrackedChangeBundleCapabilityObject";
  bundleType: FeedBundleType;
  changes: Array<TrackedChangeItemObject>;
  collection?: Maybe<FeedElementCollectionObject>;
  totalElements: Scalars["Float"]["output"];
};

export type TrackedChangeItemObject = {
  __typename?: "TrackedChangeItemObject";
  fieldName: Scalars["String"]["output"];
  newValue?: Maybe<Scalars["String"]["output"]>;
  oldValue?: Maybe<Scalars["String"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type TrackedChangesCapabilityObject = {
  __typename?: "TrackedChangesCapabilityObject";
  changes: Array<TrackedChangeItemObject>;
};

export type TrackedTest = {
  __typename?: "TrackedTest";
  created_at: Scalars["DateTime"]["output"];
  sort_order?: Maybe<Scalars["Float"]["output"]>;
  test_code: Scalars["String"]["output"];
  tracking_id: Scalars["ID"]["output"];
};

export type Transactions = TransactionsEntity & {
  __typename?: "Transactions";
  authnet_account_number?: Maybe<Scalars["String"]["output"]>;
  authnet_account_type?: Maybe<Scalars["String"]["output"]>;
  authnet_auth_code?: Maybe<Scalars["String"]["output"]>;
  authnet_customer_shipping_profile_id?: Maybe<Scalars["String"]["output"]>;
  authnet_network_trans_id?: Maybe<Scalars["String"]["output"]>;
  authnet_ref_trans_id?: Maybe<Scalars["String"]["output"]>;
  authnet_trans_id?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_authorized?: Maybe<Scalars["Boolean"]["output"]>;
  is_captured?: Maybe<Scalars["Boolean"]["output"]>;
  is_refunded?: Maybe<Scalars["Boolean"]["output"]>;
  is_voided?: Maybe<Scalars["Boolean"]["output"]>;
  payment_profile_id?: Maybe<Scalars["String"]["output"]>;
  total_charge: Scalars["Float"]["output"];
  transaction_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: Users;
};

export type TransactionsEntity = {
  authnet_account_number?: Maybe<Scalars["String"]["output"]>;
  authnet_account_type?: Maybe<Scalars["String"]["output"]>;
  authnet_auth_code?: Maybe<Scalars["String"]["output"]>;
  authnet_network_trans_id?: Maybe<Scalars["String"]["output"]>;
  authnet_ref_trans_id?: Maybe<Scalars["String"]["output"]>;
  authnet_trans_id?: Maybe<Scalars["String"]["output"]>;
  is_authorized?: Maybe<Scalars["Boolean"]["output"]>;
  is_captured?: Maybe<Scalars["Boolean"]["output"]>;
  is_refunded?: Maybe<Scalars["Boolean"]["output"]>;
  is_voided?: Maybe<Scalars["Boolean"]["output"]>;
  total_charge: Scalars["Float"]["output"];
};

/** Lifecycle status of an executed gateway transfer */
export enum TransferStatus {
  PartiallyReversed = "PARTIALLY_REVERSED",
  Reversed = "REVERSED",
  Succeeded = "SUCCEEDED",
}

/** Populate either "conditionId" for existing condition, or "condition" to create new condition */
export type TreatmentConditionsCreateInput = {
  condition?: InputMaybe<TreatmentConditionsInput>;
  conditionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type TreatmentConditionsInput = {
  abatement?: InputMaybe<ConditionAbatementInput>;
  /** The person or device that asserted the condition. */
  asserter?: InputMaybe<ConditionAsserterInput>;
  bodySite?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<ConditionCategoryCodes>;
  clinicalStatus: ConditionClinicalStatus;
  conditionCode?: InputMaybe<ConditionCodes>;
  icd10Code: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  onset?: InputMaybe<ConditionOnsetInput>;
  recordedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  severity?: InputMaybe<ConditionSeverityCodes>;
  typeOfParticipantInvolvement: ParticipantRoleType;
  verificationStatus?: InputMaybe<ConditionVerificationStatus>;
};

export type TreatmentGoalAddressesInput = {
  conditionIcd10?: InputMaybe<Scalars["String"]["input"]>;
  conditionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type TreatmentGoalInput = {
  achievementStatus: GoalAchievementStatus;
  addresses: TreatmentGoalAddressesInput;
  category: GoalCategory;
  /** After meeting the goal, ongoing activity is needed to sustain the goal objective */
  continuous?: InputMaybe<Scalars["Boolean"]["input"]>;
  description: Scalars["String"]["input"];
  dueDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  goalStatus: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  patientId: Scalars["String"]["input"];
  priority: GoalPriority;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  statusReason?: InputMaybe<Scalars["String"]["input"]>;
  target: GoalTargetInput;
};

export type TreatmentPlanCreateInput = {
  conditions: Array<TreatmentConditionsCreateInput>;
  goals?: InputMaybe<Array<TreatmentGoalInput>>;
  plan: CarePlanCreateInput;
  team?: InputMaybe<CareTeamInput>;
};

export type TriggerDefinitionTimings = {
  __typename?: "TriggerDefinitionTimings";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  date?: Maybe<Scalars["DateTime"]["output"]>;
  date_time?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  timing?: Maybe<Timings>;
  trigger: TriggerDefinitions;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TriggerDefinitions = {
  __typename?: "TriggerDefinitions";
  /** Coded definition of the event. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Whether the event triggers (boolean expression) */
  condition?: Maybe<Expressions>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  /** A reference to a SubscriptionTopic resource that defines the event. If this element is provided, no other information about the trigger definition may be supplied. */
  subscription_topic?: Maybe<SubscriptionTopics>;
  timing?: Maybe<TriggerDefinitionTimings>;
  topic_id?: Maybe<Scalars["String"]["output"]>;
  type: TriggerType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** All possible FHIR trigger type codes. */
export enum TriggerType {
  /** The trigger occurs whenever data of a particular type is accessed. */
  DataAccessed = "DATA_ACCESSED",
  /** The trigger occurs whenever access to data of a particular type is completed. */
  DataAccessEnded = "DATA_ACCESS_ENDED",
  /** The trigger occurs whenever data of a particular type is added. */
  DataAdded = "DATA_ADDED",
  /** The trigger occurs whenever data of a particular type is changed in any way, either added, modified, or removed. */
  DataChanged = "DATA_CHANGED",
  /** The trigger occurs whenever data of a particular type is modified. */
  DataModified = "DATA_MODIFIED",
  /** The trigger occurs whenever data of a particular type is removed. */
  DataRemoved = "DATA_REMOVED",
  /** The trigger occurs in response to a specific named event, and no other information about the trigger is specified. Named events are completely pre-coordinated, and the formal semantics of the trigger are not provided. */
  NamedEvent = "NAMED_EVENT",
  /** The trigger occurs at a specific time or periodically as described by a timing or schedule. A periodic event cannot have any data elements, but may have a name assigned as a shorthand for the event. */
  Periodic = "PERIODIC",
}

/** All possible challenge statuses provided by twilio api */
export enum TwilioChallengeStatus {
  Approved = "APPROVED",
  Denied = "DENIED",
  Expired = "EXPIRED",
  Pending = "PENDING",
}

export type TwilioFactor = {
  __typename?: "TwilioFactor";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  factor_id: Scalars["String"]["output"];
  factor_type: TwilioFactorTypes;
  is_archived: Scalars["Boolean"]["output"];
  /** Human friendly name to distinguish between factors */
  name: Scalars["String"]["output"];
  /** Twilio's internal resource identifier ("sid") */
  sid: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user: CynergyUsers;
  /** Twilio factor verification status */
  verified: Scalars["Boolean"]["output"];
};

/** All possible twilio entity factor types. */
export enum TwilioFactorTypes {
  /** A push notification sent to the users device. */
  Push = "PUSH",
  /** Time-based one-time password. Used to authenticate with 3rd party authenticator apps such as Authy and Google Authenticator. */
  Totp = "TOTP",
}

export type TwilioVerifyResponse = {
  __typename?: "TwilioVerifyResponse";
  /** Verification identifier */
  sid: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type TwoFactorAuthentication = {
  __typename?: "TwoFactorAuthentication";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  factor?: Maybe<TwoFactorUnion>;
  is_archived: Scalars["Boolean"]["output"];
  method?: Maybe<TwoFactorMethods>;
  /** Phone number used for verifying sms code. */
  sms_number?: Maybe<Scalars["String"]["output"]>;
  sms_verified: Scalars["Boolean"]["output"];
  two_factor_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<CynergyUsers>;
};

/** All possible methods of 2FA */
export enum TwoFactorMethods {
  /** A push notification, sent to the users device notifying them of a login attempt. The user may approve or deny the request. */
  Push = "PUSH",
  /** Text message with authentication code sent to users phone. */
  Sms = "SMS",
  /** Time-based one-time password. Used to authenticate with 3rd party authenticator apps such as Authy and Google Authenticator. */
  Totp = "TOTP",
}

export type TwoFactorPush = {
  __typename?: "TwoFactorPush";
  authentication: TwoFactorAuthentication;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  properties: TwilioFactor;
  two_factor_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TwoFactorTotp = {
  __typename?: "TwoFactorTotp";
  authentication: TwoFactorAuthentication;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  properties: TwilioFactor;
  /** 2FA Authenticator QR code URI */
  qr_uri: Scalars["String"]["output"];
  /** 2FA Authenticator seed to enter manually. */
  secret: Scalars["String"]["output"];
  two_factor_id: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type TwoFactorUnion = TwoFactorPush | TwoFactorTotp;

/** A list of all US states and territories */
export enum UsStates {
  Ak = "AK",
  Al = "AL",
  Ar = "AR",
  As = "AS",
  Az = "AZ",
  Ca = "CA",
  Co = "CO",
  Ct = "CT",
  Dc = "DC",
  De = "DE",
  Fl = "FL",
  Fm = "FM",
  Ga = "GA",
  Gu = "GU",
  Hi = "HI",
  Ia = "IA",
  Id = "ID",
  Il = "IL",
  In = "IN",
  Ks = "KS",
  Ky = "KY",
  La = "LA",
  Ma = "MA",
  Md = "MD",
  Me = "ME",
  Mh = "MH",
  Mi = "MI",
  Mn = "MN",
  Mo = "MO",
  Mp = "MP",
  Ms = "MS",
  Mt = "MT",
  Nc = "NC",
  Nd = "ND",
  Ne = "NE",
  Nh = "NH",
  Nj = "NJ",
  Nm = "NM",
  Nv = "NV",
  Ny = "NY",
  Oh = "OH",
  Ok = "OK",
  Or = "OR",
  Pa = "PA",
  Pr = "PR",
  Pw = "PW",
  Ri = "RI",
  Sc = "SC",
  Sd = "SD",
  Tn = "TN",
  Tx = "TX",
  Ut = "UT",
  Va = "VA",
  Vi = "VI",
  Vt = "VT",
  Wa = "WA",
  Wi = "WI",
  Wv = "WV",
  Wy = "WY",
}

/** All possible FHIR unit of time codes */
export enum UnitsOfTime {
  Day = "DAY",
  Hour = "HOUR",
  Minute = "MINUTE",
  Month = "MONTH",
  Second = "SECOND",
  Week = "WEEK",
  Year = "YEAR",
}

export type UnmappedCodeResponse = {
  __typename?: "UnmappedCodeResponse";
  /** Operation result message */
  response?: Maybe<Scalars["String"]["output"]>;
  /** Unmapped code UUID */
  unmappedCodeId?: Maybe<Scalars["String"]["output"]>;
};

export type UntrackTestInput = {
  testCode: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

export type UpdateAddressResponse = {
  __typename?: "UpdateAddressResponse";
  addresses?: Maybe<Array<WebCynergyAddresses>>;
  errors?: Maybe<Array<FieldError>>;
  token?: Maybe<TokenTypes>;
};

export type UpdateAssignedWaypoint = {
  assignedWaypointId: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAssignedWaypointSequence = {
  assignedWaypointIds: Array<Scalars["String"]["input"]>;
  routeAssignmentId: Scalars["String"]["input"];
};

export type UpdateContactsResponse = {
  __typename?: "UpdateContactsResponse";
  contacts?: Maybe<Array<Contacts>>;
  errors?: Maybe<Array<FieldError>>;
};

export type UpdateCreditCardType = {
  cardNumber?: InputMaybe<Scalars["String"]["input"]>;
  cvv?: InputMaybe<Scalars["String"]["input"]>;
  expirationDate: Scalars["String"]["input"];
};

export type UpdateDependentsResponse = {
  __typename?: "UpdateDependentsResponse";
  dependents?: Maybe<Array<UserResults>>;
  errors?: Maybe<Array<FieldError>>;
};

export type UpdateEventMeta = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  participants?: InputMaybe<Array<EventParticipantsInput>>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateProfileResponse = {
  __typename?: "UpdateProfileResponse";
  errors?: Maybe<Array<FieldError>>;
  session?: Maybe<UserSessionData>;
  token?: Maybe<TokenTypes>;
};

export type UpdateRouteAssignmentInput = {
  routeAssignmentId: Scalars["String"]["input"];
  scheduleDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  staffId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateRouteLocationInput = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  routeGroup: Scalars["String"]["input"];
  routeLocationId: Scalars["String"]["input"];
};

export type UpdateUserEvent = {
  meta?: InputMaybe<UpdateEventMeta>;
  time?: InputMaybe<EventTime>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UploadPatientDocumentsInput = {
  documents: Array<PatientDocumentInput>;
  /** Location the documents are associated with. */
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  patientId: Scalars["ID"]["input"];
};

export type UploadPractitionerSignatureInput = {
  /** When the signature was captured (date/time) */
  captureDateTime?: InputMaybe<Scalars["GraphQLDateTime"]["input"]>;
  /** Reference to the organization this signature is valid for */
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  practitionerId: Scalars["String"]["input"];
  /** Actual signature data */
  signature: Scalars["Upload"]["input"];
};

/** All possible FHIR UsageContext type codes */
export enum UsageContextType {
  /** The age of the patients for which this artifact/element applies. For this context type, the value could be a range that specifies the applicable ages or a code from an appropriate value set such as the MeSH value set http://terminology.hl7.org/ValueSet/v3-AgeGroupObservationValue. */
  Age = "AGE",
  /** The clinical concept(s) addressed by the artifact/element. For example, disease, diagnostic test interpretation, medication ordering as in http://hl7.org/fhir/ValueSet/condition-code. */
  Focus = "FOCUS",
  /** The gender of the patient for which this artifact/element applies. For this context type, appropriate values can be found in the http://hl7.org/fhir/ValueSet/administrative-gender value set. */
  Gender = "GENDER",
  /** A country, state, territory or other geographic or geopolicital area for which this artifact/element is applicable. */
  Jurisdiction = "JURISDICTION",
  /** A program/project of work for which this artifact/element is applicable. */
  Program = "PROGRAM",
  /** The species to which an artifact/element applies. For example, SNOMED - 387961004 | Kingdom Animalia (organism). */
  Species = "SPECIES",
  /** The context for the clinical task(s) represented by this artifact/element. For example, this could be any task context represented by the HL7 ActTaskCode value set http://terminology.hl7.org/ValueSet/v3-ActTaskCode. General categories include: order entry, patient documentation and patient information review. */
  Task = "TASK",
  /** The clinical specialty of the context in which the patient is being treated - For example, PCP, Patient, Cardiologist, Behavioral Professional, Oral Health Professional, Prescriber, etc... taken from a specialty value set such as the NUCC Health Care provider taxonomy value set http://hl7.org/fhir/ValueSet/provider-taxonomy that is relevant to this artifact/element. */
  User = "USER",
  /** The venue in which an artifact/element could be used. For example, Outpatient, Inpatient, Home, Nursing home. The code value may originate from the HL7 ServiceDeliveryLocationRoleType value set (http://terminology.hl7.org/ValueSet/v3-ServiceDeliveryLocationRoleType). */
  Venue = "VENUE",
  /** The settings in which the artifact/element is intended for use. For example, admission, pre-op, etc. For example, the ActEncounterCode value set http://terminology.hl7.org/ValueSet/v3-ActEncounterCode. */
  Workflow = "WORKFLOW",
}

export type UsageContextValueUnion = CodeableConcepts | Groups | Locations | Organizations | PlanDefinitions | Quantity | Range;

export type UsageContexts = {
  __typename?: "UsageContexts";
  /** Type of context being specified */
  code: UsageContextType;
  context_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value: UsageContextValueUnion;
};

export type UserActorsUnion = Admins | Organizations | Patients | Staffs;

export type UserAddressData = {
  __typename?: "UserAddressData";
  addressId?: Maybe<Scalars["String"]["output"]>;
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  formattedAddress?: Maybe<Scalars["String"]["output"]>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  lat?: Maybe<Scalars["Float"]["output"]>;
  lng?: Maybe<Scalars["Float"]["output"]>;
  nickname?: Maybe<Scalars["String"]["output"]>;
  placeId?: Maybe<Scalars["String"]["output"]>;
  replacementId?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  use?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
  zip?: Maybe<Scalars["String"]["output"]>;
};

export type UserAddressInput = {
  addressId?: InputMaybe<Scalars["String"]["input"]>;
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  formattedAddress?: InputMaybe<Scalars["String"]["input"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  lat?: InputMaybe<Scalars["Float"]["input"]>;
  lng?: InputMaybe<Scalars["Float"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  placeId?: InputMaybe<Scalars["String"]["input"]>;
  replacementId?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  use?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
  zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserAlertSettingDetail = {
  __typename?: "UserAlertSettingDetail";
  alertType: AlertTypes;
  isEnabled: Scalars["Boolean"]["output"];
  preferences?: Maybe<Scalars["JSON"]["output"]>;
  userAlertSettingId?: Maybe<Scalars["String"]["output"]>;
};

export type UserAlertSettings = {
  __typename?: "UserAlertSettings";
  alert_type: AlertTypes;
  alert_type_id: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_enabled: Scalars["Boolean"]["output"];
  preferences?: Maybe<Scalars["JSON"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user_alert_setting_id: Scalars["String"]["output"];
  user_id: Scalars["String"]["output"];
};

export type UserChanges = ChangesEntity & {
  __typename?: "UserChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user_id: Scalars["String"]["output"];
};

export type UserCollectionIdentifier = {
  collectionId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserContactData = {
  authorizedAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  contactId?: InputMaybe<Scalars["String"]["input"]>;
  contactRelationId?: InputMaybe<Scalars["String"]["input"]>;
  contactRelationTypeId?: InputMaybe<Scalars["String"]["input"]>;
  contactTypeId?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nickname?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserDependentData = {
  dob?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  maritalStatus?: InputMaybe<Scalars["String"]["input"]>;
  parentId?: InputMaybe<Scalars["String"]["input"]>;
  patientId?: InputMaybe<Scalars["String"]["input"]>;
  permissionId?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  userConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserEvent = {
  eventRefID: Scalars["String"]["input"];
  link?: InputMaybe<Scalars["String"]["input"]>;
  meta: EventMeta;
  time: EventTime;
  title: Scalars["String"]["input"];
};

export type UserEventData = {
  __typename?: "UserEventData";
  end: Scalars["GraphQLDateTime"]["output"];
  id: Scalars["String"]["output"];
  link?: Maybe<Scalars["String"]["output"]>;
  meta: EventMetaType;
  start: Scalars["GraphQLDateTime"]["output"];
  title: Scalars["String"]["output"];
};

export type UserPreferences = {
  __typename?: "UserPreferences";
  changes?: Maybe<Array<PreferenceChanges>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Languages which may be used to communicate with the patient about his or her health */
  languages?: Maybe<Scalars["String"]["output"]>;
  preference_id: Scalars["String"]["output"];
  preferred_contact_method: Scalars["String"]["output"];
  preferred_settings: Scalars["String"]["output"];
  profile_photo: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type UserProductBundleAccountShareInput = {
  accessLevel?: InputMaybe<RecordShareAccessLevel>;
  /** Account the bundle is shared with */
  accountId: Scalars["ID"]["input"];
};

export type UserProductBundleBulkDeleteInput = {
  bundles: Array<UserProductBundleIdentifierInput>;
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UserProductBundleCreateInput = {
  /** What the bundle covers */
  description?: InputMaybe<Scalars["String"]["input"]>;
  items?: InputMaybe<Array<UserProductBundleItemInput>>;
  /** User-friendly name */
  name: Scalars["String"]["input"];
};

export type UserProductBundleDeleteInput = {
  bundleId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UserProductBundleGroupShareCreateInput = {
  bundleId: Scalars["ID"]["input"];
  shares: Array<UserProductBundleGroupShareInput>;
};

export type UserProductBundleGroupShareInput = {
  accessLevel?: InputMaybe<RecordShareAccessLevel>;
  /** Access group the bundle is shared with */
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The type of Access Group to share with */
  groupType?: InputMaybe<AccessGroupType>;
};

export type UserProductBundleIdentifierInput = {
  bundleId: Scalars["ID"]["input"];
};

export type UserProductBundleItemActionInput = {
  add?: InputMaybe<Array<UserProductBundleItemInput>>;
  remove?: InputMaybe<UserProductBundleItemBulkDeleteInput>;
  update?: InputMaybe<Array<UserProductBundleItemUpdateInput>>;
};

export type UserProductBundleItemBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  items: Array<UserProductBundleItemIdentifierInput>;
};

export type UserProductBundleItemIdentifierInput = {
  bundleItemId: Scalars["ID"]["input"];
};

export type UserProductBundleItemInput = {
  priceBookEntryId: Scalars["ID"]["input"];
  productId: Scalars["ID"]["input"];
  /** Sort order of the item within the bundle */
  sequence?: InputMaybe<Scalars["Int"]["input"]>;
  storeId: Scalars["ID"]["input"];
};

export type UserProductBundleItemManageInput = {
  action: UserProductBundleItemActionInput;
  bundleId: Scalars["ID"]["input"];
};

export type UserProductBundleItemUpdateInput = {
  bundleItemId: Scalars["ID"]["input"];
  /** Sort order of the item within the bundle */
  sequence?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserProductBundleItems = {
  __typename?: "UserProductBundleItems";
  bundle: UserProductBundles;
  bundle_item_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  price_entry: PriceBookEntries;
  pricebook_entry_id: Scalars["ID"]["output"];
  product: Products;
  product_id: Scalars["ID"]["output"];
  /** Sort order of the item within the bundle */
  sequence: Scalars["Float"]["output"];
  store: WebStores;
  store_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type UserProductBundlePaginatedResults = {
  __typename?: "UserProductBundlePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<UserProductBundles>;
  totalPages: Scalars["Float"]["output"];
};

export type UserProductBundleShareActionInput = {
  add?: InputMaybe<Array<UserProductBundleAccountShareInput>>;
  remove?: InputMaybe<UserProductBundleShareBulkDeleteInput>;
};

export type UserProductBundleShareBulkDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  shares: Array<UserProductBundleShareIdentifierInput>;
};

export type UserProductBundleShareIdentifierInput = {
  shareId: Scalars["ID"]["input"];
};

export type UserProductBundleShareManageInput = {
  action: UserProductBundleShareActionInput;
  bundleId: Scalars["ID"]["input"];
};

export type UserProductBundleShares = {
  __typename?: "UserProductBundleShares";
  access_level: RecordShareAccessLevel;
  account?: Maybe<CynergyAccounts>;
  account_id?: Maybe<Scalars["ID"]["output"]>;
  bundle: UserProductBundles;
  bundle_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  group?: Maybe<AccessGroups>;
  /** Access group the record is shared with */
  group_id?: Maybe<Scalars["ID"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  share_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type UserProductBundleUpdateInput = {
  bundleId: Scalars["ID"]["input"];
  /** What the bundle covers */
  description?: InputMaybe<Scalars["String"]["input"]>;
  items?: InputMaybe<UserProductBundleItemActionInput>;
  /** User-friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserProductBundles = {
  __typename?: "UserProductBundles";
  account_id: Scalars["ID"]["output"];
  bundle_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** What the bundle covers */
  description?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_shared: Scalars["Boolean"]["output"];
  items?: Maybe<Array<UserProductBundleItems>>;
  /** User-friendly name */
  name: Scalars["String"]["output"];
  owner: Scalars["String"]["output"];
  shares?: Maybe<Array<UserProductBundleShares>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type UserResults = Admins | Dependents | Groups | Organizations | Patients | StaffAssignments | Staffs | Users;

export type UserSessionData = {
  __typename?: "UserSessionData";
  accountId: Scalars["String"]["output"];
  address?: Maybe<UserAddressData>;
  appId: Scalars["String"]["output"];
  authnetProfileId?: Maybe<Scalars["String"]["output"]>;
  availableLocations?: Maybe<Array<AssignmentType>>;
  cynergyId: Scalars["String"]["output"];
  defaultPage?: Maybe<Scalars["String"]["output"]>;
  dob?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  firstLogin?: Maybe<Scalars["Boolean"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  locationId?: Maybe<Scalars["String"]["output"]>;
  locationName?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organizationId?: Maybe<Scalars["String"]["output"]>;
  patientId?: Maybe<Scalars["String"]["output"]>;
  paymentProfiles?: Maybe<Array<PaymentProfiles>>;
  phone?: Maybe<Scalars["String"]["output"]>;
  photo?: Maybe<Scalars["String"]["output"]>;
  practitionerId?: Maybe<Scalars["String"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  roleId?: Maybe<Scalars["String"]["output"]>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
  staffRelationId?: Maybe<Scalars["String"]["output"]>;
  twoFactorEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  twoFactorMethod?: Maybe<TwoFactorMethods>;
  userId?: Maybe<Scalars["String"]["output"]>;
  userType?: Maybe<UserTypes>;
  username?: Maybe<Scalars["String"]["output"]>;
  validated?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserSessionIpData = {
  __typename?: "UserSessionIPData";
  as: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  countryCode: Scalars["String"]["output"];
  isp: Scalars["String"]["output"];
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
  org: Scalars["String"]["output"];
  query: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  timeZone: Scalars["String"]["output"];
  zip: Scalars["String"]["output"];
};

/** Application User Types */
export enum UserTypes {
  /** Administrative user */
  Admin = "admin",
  /** Organization offering healthcare services */
  Organization = "organization",
  /** General user of the application and purchaser of services */
  Patient = "patient",
  Practitioner = "practitioner",
  /** Staff workers or reps for a organization */
  Staff = "staff",
}

export type Users = {
  __typename?: "Users";
  account?: Maybe<CynergyAccounts>;
  actor?: Maybe<UserActorsUnion>;
  addresses?: Maybe<Array<WebCynergyAddresses>>;
  authnet_customer_profile_id?: Maybe<Scalars["String"]["output"]>;
  changes?: Maybe<Array<UserChanges>>;
  contacts?: Maybe<Array<Contacts>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  demographics?: Maybe<Demographics>;
  first_login: Scalars["Boolean"]["output"];
  identity?: Maybe<CynergyUsers>;
  is_archived: Scalars["Boolean"]["output"];
  payment_profiles?: Maybe<Array<PaymentProfiles>>;
  promos?: Maybe<Array<PurchasedPromos>>;
  subscription_payments?: Maybe<Array<SubscriptionPayments>>;
  subscriptions?: Maybe<Array<Subscriptions>>;
  supervising_locations?: Maybe<Array<Locations>>;
  transactions?: Maybe<Array<Transactions>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  user_id: Scalars["String"]["output"];
  user_type: UserTypes;
  username: Scalars["String"]["output"];
};

export type UsersActorArgs = {
  userType?: InputMaybe<UserTypes>;
};

export type UsersChanges = ChangesEntity & {
  __typename?: "UsersChanges";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  cynergy_id: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  edit_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ValueSetCompositionInput = {
  /** Default property to return, if the client doesn't ask for any */
  defaultProperties?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether inactive codes, or codes not approved for current use are in the value set */
  includesInactiveCodes?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Included codes from a code system or other value set(s) */
  inclusions?: InputMaybe<Array<ValueSetIncludeInput>>;
  /** Lock the value set? */
  lock?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ValueSetCompositions = {
  __typename?: "ValueSetCompositions";
  composition_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Included codes from a code system or other value set(s) */
  include: Array<ValueSetIncludes>;
  is_archived: Scalars["Boolean"]["output"];
  /** Property to return if client doesn't override */
  property?: Maybe<Array<Scalars["String"]["output"]>>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  value_set: ValueSets;
};

export type ValueSetConceptInput = {
  /** Code or expression from system */
  code: Scalars["String"]["input"];
  /** Text to display for this code in the value set */
  display: Scalars["String"]["input"];
};

export type ValueSetConcepts = {
  __typename?: "ValueSetConcepts";
  /** Code or expression from system */
  code: Scalars["String"]["output"];
  concept_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Text to display for this code for this value set in this value set */
  display: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type ValueSetCreateInput = {
  /** When value set was approved by publisher */
  approvalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Content logical definition of the value set (CLD) */
  compose?: InputMaybe<ValueSetCompositionInput>;
  /** Description of value set */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** When the value set is expected to be used */
  effectivePeriod?: InputMaybe<PeriodCreateInput>;
  /** Value set not for real usage */
  experimental?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When the value set was last reviewed by the publisher */
  lastReviewDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Computer friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  /** The name of the individual or organization that published the value set */
  publisher: Scalars["String"]["input"];
  /** Why this value set is defined */
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  /** Default: "Draft" */
  status?: InputMaybe<PublicationStatus>;
  /** Human friendly name */
  title: Scalars["String"]["input"];
  /** Canonical identifier for this value set, represented as a URI (globally unique) */
  url?: InputMaybe<Scalars["URL"]["input"]>;
};

export type ValueSetFilters = {
  __typename?: "ValueSetFilters";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  filter_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The kind of operation to perform as a part of the filter criteria. */
  operator: FilterOperator;
  /** A property/filter defined by the code system */
  property: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Code from the system, or regex criteria, or boolean value for exists */
  value: Scalars["String"]["output"];
};

export type ValueSetIncludeInput = {
  /** List of concepts to be included */
  concepts?: InputMaybe<Array<ValueSetConceptInput>>;
  /** System the codes are from */
  system: Scalars["String"]["input"];
};

export type ValueSetIncludes = {
  __typename?: "ValueSetIncludes";
  composition: ValueSetCompositions;
  /** Specifies list of concepts to be included */
  concepts?: Maybe<Array<ValueSetConcepts>>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Select codes/concepts by their properties (including relationships) */
  filters?: Maybe<Array<ValueSetFilters>>;
  include_id: Scalars["ID"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** The system the codes come from */
  system: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Specific version of the code system referred to */
  version?: Maybe<Scalars["String"]["output"]>;
};

export type ValueSets = {
  __typename?: "ValueSets";
  /** When value set was approved by publisher */
  approval_date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Content logical definition of the value set (CLD) */
  compose?: Maybe<ValueSetCompositions>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Natural language description of this value set */
  description?: Maybe<Scalars["String"]["output"]>;
  /** When the value set is expected to be used */
  effective_period?: Maybe<Periods>;
  /** Value set not for real usage */
  experimental: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** When the value set was last reviewed by the publisher */
  last_review_date?: Maybe<Scalars["DateTime"]["output"]>;
  organization_id: Scalars["ID"]["output"];
  /** The name of the individual or organization that published the value set */
  publisher: Scalars["String"]["output"];
  /** Why this value set is defined */
  purpose?: Maybe<Scalars["String"]["output"]>;
  status: PublicationStatus;
  /** Name for this value set (Human friendly) */
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Canonical identifier for this value set, represented as a URI (globally unique) */
  url?: Maybe<Scalars["URL"]["output"]>;
  value_set_id: Scalars["ID"]["output"];
  /** Business version of this value set */
  version: Scalars["String"]["output"];
};

export type VerificationCheckInput = {
  code: Scalars["String"]["input"];
  verificationSid?: InputMaybe<Scalars["String"]["input"]>;
};

export type VerificationCodeRequest = {
  local?: InputMaybe<Scalars["String"]["input"]>;
  /** Either an email or phone number in E.164 format. */
  to: Scalars["String"]["input"];
};

export type VirtualServiceDetails = {
  __typename?: "VirtualServiceDetails";
  /** Address to see alternative connection details */
  additional_info?: Maybe<Scalars["String"]["output"]>;
  address: ContactPoints;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  detail_id: Scalars["String"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  /** Maximum number of participants supported by the virtual service */
  max_participants?: Maybe<Scalars["Float"]["output"]>;
  /** Session key required by the virtual service */
  session_key: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** It represents whether a location has been visited by the user */
export enum VisitState {
  NotVisited = "NOT_VISITED",
  Visited = "VISITED",
}

export type WebCartBookingRequests = {
  __typename?: "WebCartBookingRequests";
  cart_id: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  items: Array<WebCartItems>;
  location?: Maybe<Locations>;
  location_id: Scalars["ID"]["output"];
  /** Reference to the time slot requested for booking */
  requested_slot_id?: Maybe<Scalars["ID"]["output"]>;
  slot?: Maybe<Slots>;
};

export type WebCartItemCreateInput = {
  priceBookEntryId: Scalars["ID"]["input"];
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  /** Reference to the time slot requested for booking */
  requestedSlotId?: InputMaybe<Scalars["ID"]["input"]>;
  storeCode: Scalars["ID"]["input"];
};

export type WebCartItemDeleteInput = {
  itemId: Scalars["ID"]["input"];
};

export type WebCartItemThumbNails = {
  __typename?: "WebCartItemThumbNails";
  url: Scalars["String"]["output"];
};

export type WebCartItems = {
  __typename?: "WebCartItems";
  cart_id: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  isWishListed?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  price: Scalars["USCurrency"]["output"];
  product: Products;
  productCode: Scalars["String"]["output"];
  quantity: Scalars["Float"]["output"];
  store: WebStores;
  tax?: Maybe<Scalars["USCurrency"]["output"]>;
  thumbnail?: Maybe<WebCartItemThumbNails>;
};

export type WebCartMetadata = {
  __typename?: "WebCartMetadata";
  ttl?: Maybe<Scalars["Float"]["output"]>;
};

/** List of WebCart status codes */
export enum WebCartStatus {
  Abandoned = "Abandoned",
  Active = "Active",
  Checkout = "Checkout",
  Complete = "Complete",
  Expired = "Expired",
}

export type WebCartSummaries = {
  __typename?: "WebCartSummaries";
  cart_id: Scalars["ID"]["output"];
  item_count: Scalars["Float"]["output"];
  subtotal: Scalars["USCurrency"]["output"];
  surcharge?: Maybe<Scalars["USCurrency"]["output"]>;
  tax: Scalars["USCurrency"]["output"];
  total: Scalars["USCurrency"]["output"];
};

export type WebCarts = {
  __typename?: "WebCarts";
  booking_requests?: Maybe<Array<WebCartBookingRequests>>;
  cart_holder: Scalars["String"]["output"];
  expiresAt?: Maybe<Scalars["GraphQLDateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  items: Array<WebCartItems>;
  metadata: WebCartMetadata;
  summary?: Maybe<WebCartSummaries>;
  ttl?: Maybe<Scalars["Float"]["output"]>;
};

export type WebCynergyAddresses = {
  __typename?: "WebCynergyAddresses";
  address_id: Scalars["String"]["output"];
  address_line_1: Scalars["String"]["output"];
  address_line_2?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  formatted_address?: Maybe<Scalars["String"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  is_default: Scalars["Boolean"]["output"];
  latitude?: Maybe<Scalars["Float"]["output"]>;
  longitude?: Maybe<Scalars["Float"]["output"]>;
  nickname?: Maybe<Scalars["String"]["output"]>;
  place_id?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  use: Scalars["String"]["output"];
  user?: Maybe<Users>;
  zip: Scalars["String"]["output"];
};

export type WebStoreCategoryDefinitionBulkCreateInput = {
  categories: Array<WebStoreCategoryDefinitionInput>;
  siteId: Scalars["ID"]["input"];
};

export type WebStoreCategoryDefinitionBulkDeleteInput = {
  categories: Array<WebStoreCategoryDefinitionDeleteInput>;
  siteId: Scalars["ID"]["input"];
};

export type WebStoreCategoryDefinitionDeleteInput = {
  definitionId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type WebStoreCategoryDefinitionInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Category image */
  image?: InputMaybe<AttachmentLinkOrCreateInput>;
  /** Appears in navigational menu? */
  isNavigational?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Product category text as it appears in menu */
  label: Scalars["String"]["input"];
  /** Computer-friendly name */
  name: Scalars["String"]["input"];
  /** Category slug (ex. "/fitness") */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
  /** Catalog type */
  type: CommerceProductFamily;
};

export type WebStoreCategoryDefinitionUpdateInput = {
  definitionId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Category image */
  image?: InputMaybe<AttachmentLinkOrCreateInput>;
  /** Appears in navigational menu? */
  isNavigational?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Product category text as it appears in menu */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Computer-friendly name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Category slug (ex. "/fitness") */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<PublicationStatus>;
};

export type WebStoreCategoryDefinitions = {
  __typename?: "WebStoreCategoryDefinitions";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  definition_id: Scalars["ID"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** Menu item icon */
  image?: Maybe<Attachments>;
  is_archived: Scalars["Boolean"]["output"];
  /** Product category text as it appears in menu */
  label: Scalars["String"]["output"];
  /** Computer-friendly name */
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  status: PublicationStatus;
  /** Category type */
  type: CommerceProductFamily;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type WebStoreConfigurationCategoryActionInput = {
  add?: InputMaybe<Array<WebStoreConfigurationCategoryInput>>;
  remove?: InputMaybe<Array<WebStoreConfigurationCategoryDeleteInput>>;
};

export type WebStoreConfigurationCategoryDeleteInput = {
  categoryDefinitionId: Scalars["ID"]["input"];
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type WebStoreConfigurationCategoryInput = {
  categoryDefinitionId: Scalars["ID"]["input"];
};

export type WebStoreConfigurationCreateInput = {
  /** Cart time-to-live duration */
  cartDuration?: InputMaybe<DurationUpsertInput>;
  /** Store product categories */
  categories?: InputMaybe<Array<WebStoreConfigurationCategoryInput>>;
  checkoutSurcharge?: InputMaybe<Scalars["USCurrency"]["input"]>;
  /** Default number of results displayed per result set */
  defaultPaginationSize?: InputMaybe<Scalars["Float"]["input"]>;
  defaultPaymentTerm?: InputMaybe<DurationCreateInput>;
  /** Indicates whether guest browsing is enabled */
  guestBrowsingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  guestCartDuration?: InputMaybe<DurationUpsertInput>;
  /** Indicates whether guest cart access is enabled */
  guestCartEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether guest checkout is enabled */
  guestCheckoutEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  siteId: Scalars["ID"]["input"];
  storeType: CommerceStoreType;
};

export type WebStoreConfigurationUpdateInput = {
  /** Cart time-to-live duration */
  cartDuration?: InputMaybe<DurationUpsertInput>;
  /** Store product categories */
  categories?: InputMaybe<WebStoreConfigurationCategoryActionInput>;
  checkoutSurcharge?: InputMaybe<Scalars["USCurrency"]["input"]>;
  /** Default number of results displayed per result set */
  defaultPaginationSize?: InputMaybe<Scalars["Float"]["input"]>;
  defaultPaymentTerm?: InputMaybe<DurationUpsertInput>;
  /** Indicates whether guest browsing is enabled */
  guestBrowsingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  guestCartDuration?: InputMaybe<DurationUpsertInput>;
  /** Indicates whether guest cart access is enabled */
  guestCartEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether guest checkout is enabled */
  guestCheckoutEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeConfigurationId: Scalars["ID"]["input"];
  storeType?: InputMaybe<CommerceStoreType>;
};

export type WebStoreConfigurations = {
  __typename?: "WebStoreConfigurations";
  categories?: Maybe<Array<WebStoreCategoryDefinitions>>;
  configuration_id: Scalars["ID"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  payment_term_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type WebStoreCreateInput = {
  /** Store catalogs */
  catalog?: InputMaybe<ProductCatalogLinkOrCreateInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  locationId: Scalars["ID"]["input"];
  merchantAccountId: Scalars["ID"]["input"];
  /** Store name */
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  paymentGatewayId?: InputMaybe<Scalars["ID"]["input"]>;
  priceBook?: InputMaybe<PriceBookLinkOrCreateInput>;
  type: CommerceStoreType;
};

export type WebStoreDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeId: Scalars["ID"]["input"];
};

export type WebStorePaginatedResults = {
  __typename?: "WebStorePaginatedResults";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<WebStores>;
  totalPages: Scalars["Float"]["output"];
};

/** List of Webstore status codes */
export enum WebStoreStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
}

export type WebStores = {
  __typename?: "WebStores";
  /** Store catalog directory */
  catalogs?: Maybe<Array<ProductCatalogs>>;
  code: Scalars["String"]["output"];
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  distance?: Maybe<Scalars["Float"]["output"]>;
  gateway_id: Scalars["ID"]["output"];
  isLocal?: Maybe<Scalars["Boolean"]["output"]>;
  is_archived: Scalars["Boolean"]["output"];
  /** Location of the store */
  location: Locations;
  name: Scalars["String"]["output"];
  organization: Organizations;
  price_book?: Maybe<PriceBooks>;
  products?: Maybe<Array<ProductCatalogItems>>;
  status: WebStoreStatus;
  store_id: Scalars["ID"]["output"];
  surcharge?: Maybe<Scalars["Float"]["output"]>;
  type: CommerceStoreType;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

/** Processing state of an ingested gateway webhook event */
export enum WebhookProcessingStatus {
  DeadLetter = "DEAD_LETTER",
  Duplicate = "DUPLICATE",
  Ignored = "IGNORED",
  Processed = "PROCESSED",
  Received = "RECEIVED",
}

/** All possible FHIR week of month codes */
export enum WeekOfMonth {
  First = "FIRST",
  Fourth = "FOURTH",
  Last = "LAST",
  Second = "SECOND",
  Third = "THIRD",
}

export type WeeklyAvailabilities = {
  __typename?: "WeeklyAvailabilities";
  availability_id: Scalars["ID"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Available every week? */
  every_week: Scalars["Boolean"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
  /** Available weeks */
  weeks?: Maybe<Array<WeekOfMonth>>;
};

export type WeeklyRecurrence = {
  /** Days of recurrence */
  days?: InputMaybe<Array<DaysOfWeek>>;
  /** Recurs every day? */
  everyDay?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type WeeklyRecurrencePatternActionInput = {
  add?: InputMaybe<WeeklyRecurrencePatternCreateInput>;
  remove?: InputMaybe<WeeklyRecurrencePatternDeleteInput>;
  update?: InputMaybe<WeeklyRecurrencePatternUpdateInput>;
};

export type WeeklyRecurrencePatternCreateInput = {
  /** Recurs every nth week (Default: 1) */
  interval?: InputMaybe<Scalars["Float"]["input"]>;
  /** Days event should occur (Union) */
  recurs: WeeklyRecurrence;
};

export type WeeklyRecurrencePatternDeleteInput = {
  /** Perform hard delete? */
  hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
  patternId: Scalars["ID"]["input"];
};

export type WeeklyRecurrencePatternUpdateInput = {
  /** Recurs every nth week (Default: 1) */
  interval?: InputMaybe<Scalars["Float"]["input"]>;
  patternId: Scalars["ID"]["input"];
  /** Days event should occur (Union) */
  recurs?: InputMaybe<WeeklyRecurrence>;
};

export type WeeklyRecurrencePatterns = {
  __typename?: "WeeklyRecurrencePatterns";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  /** Days event recurs on */
  days?: Maybe<Array<DaysOfWeek>>;
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Event recurs everyday? */
  every_day: Scalars["Boolean"]["output"];
  /** To recur every nth week */
  interval: Scalars["Float"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  pattern_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type WellnessPaginatedResponse = {
  __typename?: "WellnessPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  errors?: Maybe<Array<FieldError>>;
  rows: Array<WellnessResultUnion>;
  totalPages: Scalars["Float"]["output"];
};

export type WellnessPatientTestSampleData = {
  __typename?: "WellnessPatientTestSampleData";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  organismCounts?: Maybe<Array<OrganismCounts>>;
  rows: Array<WellnessResultUnion>;
  totalPages: Scalars["Float"]["output"];
};

export type WellnessResultUnion = Patient | PatientTest | PatientTestSample;

export type WellnessTestsPaginatedResponse = {
  __typename?: "WellnessTestsPaginatedResponse";
  count: Scalars["Float"]["output"];
  currentPage: Scalars["Float"]["output"];
  rows: Array<PatientTest>;
  totalPages: Scalars["Float"]["output"];
};

export type YearlyRecurrencePatterns = {
  __typename?: "YearlyRecurrencePatterns";
  created_at: Scalars["Date"]["output"];
  created_by: Scalars["String"]["output"];
  deleted_at?: Maybe<Scalars["Date"]["output"]>;
  /** Recurs every nth year */
  interval: Scalars["Float"]["output"];
  is_archived: Scalars["Boolean"]["output"];
  pattern_id: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  updated_by?: Maybe<Scalars["String"]["output"]>;
};

export type AgentAlternativesFragmentFragment = {
  __typename: "Genotypes";
  genotype_id: string;
  agent_class_alternatives?: Array<{
    __typename?: "AgentClassifications";
    classification_number: number;
    code: AntibioticClassificationCodes;
    label: string;
    description?: string | null;
  }> | null;
  agent_alternatives?: Array<{
    __typename?: "AgentAlternatives";
    suitability: AntibioticSuitabilityRating;
    notes?: string | null;
    nus: boolean;
    gene: { __typename: "Genotypes"; genotype_id: string; gene: string };
    agent: { __typename: "Agents"; description?: string | null; agent_id: string; name: string };
  }> | null;
};

export type AgentResistanceFragmentFragment = {
  __typename: "Genotypes";
  genotype_id: string;
  gene: string;
  encoding?: string | null;
  mechanism?: string | null;
  classification?: string | null;
  resistant_to?: Array<{ __typename: "Agents"; description?: string | null; agent_id: string; name: string }> | null;
  agent_class_resistance?: Array<{
    __typename?: "AgentClassResistance";
    class_resistance_id: string;
    classification: {
      __typename: "AgentClassifications";
      classification_number: number;
      code: AntibioticClassificationCodes;
      label: string;
      description?: string | null;
    };
    exceptions?: Array<{ __typename: "Agents"; agent_id: string; name: string }> | null;
  }> | null;
};

export type ProductCardFragmentFragment = {
  __typename?: "CatalogProductResult";
  id: string;
  store: {
    __typename: "WebStores";
    distance?: number | null;
    name: string;
    type: CommerceStoreType;
    code: string;
    isLocal?: boolean | null;
    location: { __typename?: "Locations"; location_id: string; alias?: string | null };
  };
  product: {
    __typename: "Products";
    code: string;
    name: string;
    product_id: string;
    description?: string | null;
    family: CommerceProductFamily;
    isInCart?: boolean | null;
    isWishListed?: boolean | null;
    resource: { __typename?: "HealthcareServices"; service_id: string };
    image?: {
      __typename?: "Attachments";
      attachment_id: string;
      title: string;
      url?: string | null;
      size?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
  };
  price: { __typename?: "PriceBookEntries"; entry_id: string; product_code: string; unit_price: any };
};

export type FlagCardFragmentFragment = {
  __typename: "CriteriaFormResultFlags";
  flag_id: string;
  syndrome: string;
  created_at: any;
  diagnoses: Array<{
    __typename: "ICD10";
    icd10_code: string;
    label: string;
    description?: string | null;
    hex?: string | null;
    note?: string | null;
    type?: DiagnosisType | null;
    created_at: any;
  }>;
  flags: Array<{ __typename: "CriteriaFormResultFlagItems"; label: string; icd10_codes: Array<string>; applies_to: Array<string>; created_at: any }>;
};

export type CriteriaFormPatientFragmentFragment = {
  __typename?: "Patients";
  patient_id: string;
  user: { __typename?: "Users"; demographics?: { __typename?: "Demographics"; full_name?: string | null; dob?: string | null; age: number } | null };
};

export type OrderedServicesColumnQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderedServicesColumnQuery = {
  __typename?: "Query";
  getAllServiceRequests: Array<{
    __typename: "ServiceRequests";
    request_id: string;
    code: string;
    status: RequestStatus;
    priority: RequestPriority;
    intent: RequestIntent;
    category: ServiceRequestCategory;
    occurrence?: any | null;
    created_at: any;
    requisition?: {
      __typename: "Identifiers";
      identifier_id: string;
      type: IdentifierType;
      value: string;
      use: IdentifierUse;
      system?: string | null;
    } | null;
    patient: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
    reports?: Array<{
      __typename: "DiagnosticReports";
      report_id: string;
      code: string;
      presented_form?: { __typename: "Attachments"; attachment_id: string; url?: string | null } | null;
      flags?: Array<{ __typename: "ObservationFlags"; flag_id: string; hl7_code: string; alert_priority: AlertPriority; display: string }> | null;
    }> | null;
    performer?:
      | { __typename?: "CareTeams" }
      | { __typename?: "Devices" }
      | { __typename?: "HealthcareServiceLocations" }
      | { __typename: "Locations"; location_id: string; name: string; preferred_member: boolean }
      | { __typename?: "Organizations"; organization_id: string; alias: string; preferred_member: boolean }
      | { __typename?: "Patients" }
      | { __typename?: "Practitioners" }
      | null;
    location: { __typename: "Locations"; location_id: string; alias?: string | null };
  }>;
};

export type OrderHeaderFragmentFragment = {
  __typename: "Orders";
  order_id: string;
  status: OrderStatus;
  status_reason?: string | null;
  scheduled_date: any;
  requested_collection_date?: any | null;
  created_at: any;
  created_by: string;
  diagnosis_codes?: Array<{
    __typename: "ICD10";
    icd10_code: string;
    icd11_code?: string | null;
    label: string;
    description?: string | null;
    type?: DiagnosisType | null;
    hex?: string | null;
  }> | null;
  requisition?: {
    __typename?: "DocumentReferences";
    reference_id: string;
    content: { __typename?: "Attachments"; attachment_id: string; title: string; url?: string | null };
  } | null;
  flags?: Array<{ __typename: "OrderFlags"; flag_id: string; hl7_code: string; alert_priority: AlertPriority; display: string }> | null;
  reports?: Array<{
    __typename: "DiagnosticReports";
    report_id: string;
    request_id?: string | null;
    presented_form?: { __typename?: "Attachments"; attachment_id: string; title: string; url?: string | null; content_type: MimeTypes } | null;
  }> | null;
};

export type PatientDemographicFragmentFragment = {
  __typename: "Patients";
  patient_id: string;
  user: {
    __typename: "Users";
    user_id: string;
    demographics?: {
      __typename: "Demographics";
      cynergy_id: string;
      full_name?: string | null;
      first_name?: string | null;
      last_name?: string | null;
      prefix?: string | null;
      suffix?: string | null;
      middle_name?: string | null;
      age: number;
      deceased: boolean;
      dob?: string | null;
      ethnicity?: string | null;
      marital_status?: MaritalStatus | null;
      sex: string;
      race?: string | null;
    } | null;
  };
};

export type OrderDocumentsFragmentFragment = {
  __typename?: "Orders";
  order_id: string;
  reports?: Array<{
    __typename?: "DiagnosticReports";
    report_id: string;
    presented_form?: {
      __typename: "Attachments";
      attachment_id: string;
      content_type: MimeTypes;
      title: string;
      url?: string | null;
      width?: number | null;
      height?: number | null;
      pages?: number | null;
      size?: number | null;
      created_at: any;
    } | null;
  }> | null;
  requisition?: {
    __typename?: "DocumentReferences";
    reference_id: string;
    content: {
      __typename: "Attachments";
      attachment_id: string;
      content_type: MimeTypes;
      title: string;
      url?: string | null;
      width?: number | null;
      height?: number | null;
      pages?: number | null;
      size?: number | null;
      created_at: any;
    };
  } | null;
};

export type LayoutPositionCoreFragmentFragment = { __typename: "LayoutPosition"; x: number; y: number };

export type LayoutGridCoreFragmentFragment = {
  __typename: "GridLayoutProperties";
  xs?: number | null;
  sm?: number | null;
  md?: number | null;
  lg?: number | null;
  xl?: number | null;
  xxl?: number | null;
};

export type LayoutConfigurationCoreFragmentFragment = {
  __typename: "LayoutConfiguration";
  column: {
    __typename: "GridLayoutProperties";
    xs?: number | null;
    sm?: number | null;
    md?: number | null;
    lg?: number | null;
    xl?: number | null;
    xxl?: number | null;
  };
};

export type PageLayoutConfigurationCoreFragmentFragment = {
  __typename: "ComponentLayoutConfiguration";
  id: string;
  component: string;
  props?: any | null;
  column: {
    __typename: "GridLayoutProperties";
    xs?: number | null;
    sm?: number | null;
    md?: number | null;
    lg?: number | null;
    xl?: number | null;
    xxl?: number | null;
  };
  position: { __typename: "LayoutPosition"; x: number; y: number };
};

export type QuantityCoreFragmentFragment = {
  __typename: "Quantity";
  quantity_id: string;
  value: number;
  unit: string;
  code?: string | null;
  system?: string | null;
};

export type RatioCoreFragmentFragment = {
  __typename: "Ratio";
  ratio_id: string;
  numerator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
  denominator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
};

export type TagCoreFragmentFragment = {
  __typename: "Tags";
  tag_id: string;
  tag: string;
  name: string;
  slug?: string | null;
  icon_url?: string | null;
};

export type AttributeValuesCoreFragmentFragment = { __typename: "AttributeValues"; value_id: string; value: string; color?: string | null };

export type AttributeCoreFragmentFragment = {
  __typename: "Attributes";
  attribute_id: string;
  attribute: string;
  name: string;
  values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
};

export type IdentifierCoreFragmentFragment = {
  __typename: "Identifiers";
  identifier_id: string;
  type: IdentifierType;
  value: string;
  use: IdentifierUse;
  system?: string | null;
};

export type ResourceReferenceCoreFragmentFragment = {
  __typename: "References";
  reference_id: string;
  type: string;
  display: string;
  reference?: string | null;
};

export type Icd10CoreFragmentFragment = {
  __typename: "ICD10";
  icd10_code: string;
  icd11_code?: string | null;
  label: string;
  description?: string | null;
  type?: DiagnosisType | null;
  hex?: string | null;
};

export type Icd10CodeFragmentFragment = { __typename: "ICD10"; icd10_code: string; label: string };

export type TaskCoreFragmentFragment = {
  __typename: "Tasks";
  task_id: string;
  notification_id?: string | null;
  title: string;
  description: string;
  status: TaskStatus;
  business_status: string;
  status_reason?: TaskStatusReason | null;
  label: TaskLabels;
  progress: number;
  code: TaskCode;
  reason: string;
  url?: string | null;
  link?: string | null;
  priority: RequestPriority;
  do_not_perform: boolean;
  assignee_function: ActionParticipantFunction;
  assignee_role: string;
  last_modified?: any | null;
  started_at?: any | null;
  completed_at?: any | null;
  created_at: any;
};

export type TaskStepCoreFragmentFragment = {
  __typename: "TaskSteps";
  step_id: string;
  label: string;
  description: string;
  status: TaskStatus;
  order: number;
  required: boolean;
  progress: number;
  link?: string | null;
  url?: string | null;
  status_reason?: TaskStatusReason | null;
  started_at?: any | null;
};

export type QuestionnaireCoreFragmentFragment = {
  __typename: "Questionnaires";
  questionnaire_number: number;
  title: string;
  url?: string | null;
  description: string;
  link_id: string;
  publisher: string;
  publish_date: any;
  status: PublicationStatus;
  subject_type: string;
  purpose: string;
  last_review_date?: any | null;
  version: string;
  created_at: any;
};

export type QuestionnaireItemCoreFragmentFragment = {
  __typename: "QuestionnaireItems";
  item_id: string;
  link_id: string;
  item_type: QuestionnaireItemType;
  input_type: FormInputGroupType;
  response_label?: string | null;
  order: number;
  text: string;
  prefix?: string | null;
  answer_constraint?: QuestionnaireAnswerConstraint | null;
  disabled_display: QuestionnaireDisabledDisplay;
  enable_behavior: QuestionnaireEnableBehavior;
  max_length?: number | null;
  ready_only: boolean;
  required: boolean;
  repeats: boolean;
  created_at: any;
  appearance?: {
    __typename: "LayoutConfiguration";
    column: {
      __typename?: "GridLayoutProperties";
      xs?: number | null;
      sm?: number | null;
      md?: number | null;
      lg?: number | null;
      xl?: number | null;
      xxl?: number | null;
    };
  } | null;
};

export type QuestionnaireResponseCoreFragmentFragment = {
  __typename: "QuestionnaireResponses";
  response_id: string;
  status: QuestionnaireAnswerStatus;
  authored: any;
  completed_at?: any | null;
  created_at: any;
  updated_at?: any | null;
  progress?: number | null;
  questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
};

export type QuestionnaireAnswersCoreFragmentFragment = {
  __typename: "QuestionnaireAnswers";
  answer_id: string;
  answer_decimal?: number | null;
  answer_date?: any | null;
  answer_time?: string | null;
  answer_integer?: number | null;
  answer_boolean?: boolean | null;
  answer_coding?: string | null;
  answer_attachment?: string | null;
  answer_string?: string | null;
  answer_uri?: string | null;
  answer_option?: { __typename: "QuestionnaireAnswerOptions"; option_id: string; label?: string | null } | null;
  answer_range?: {
    __typename?: "Range";
    high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
    low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
  } | null;
  answer_quantity?: {
    __typename: "Quantity";
    quantity_id: string;
    value: number;
    unit: string;
    code?: string | null;
    system?: string | null;
    created_at: any;
  } | null;
};

export type QuestionnaireEnableWhenCoreFragmentFragment = {
  __typename: "QuestionnaireEnableWhen";
  enable_id: string;
  link_id: string;
  answer_boolean?: boolean | null;
  answer_coding?: string | null;
  answer_date?: any | null;
  answer_time?: string | null;
  answer_decimal?: number | null;
  answer_integer?: number | null;
  answer_quantity?: {
    __typename: "Quantity";
    quantity_id: string;
    value: number;
    unit: string;
    system?: string | null;
    code?: string | null;
    created_at: any;
  } | null;
};

export type QuestionnaireAnswerOptionsCoreFragmentFragment = {
  __typename: "QuestionnaireAnswerOptions";
  option_id: string;
  label?: string | null;
  icon?: string | null;
  initial_selected: boolean;
  option_coding?: string | null;
  option_date?: any | null;
  option_time?: string | null;
  option_integer?: number | null;
  option_string?: string | null;
  option_boolean?: boolean | null;
  created_at: any;
  option_range?: {
    __typename?: "Range";
    low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
    high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
  } | null;
};

export type QuestionnaireAbxStatisticsFragmentFragment = {
  __typename: "QuestionnaireResponses";
  response_id: string;
  questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
  answers: Array<{
    __typename?: "QuestionnaireAnswers";
    answer_id: string;
    question: { __typename?: "QuestionnaireItems"; item_id: string; link_id: string };
    answer_range?: {
      __typename?: "Range";
      range_id: string;
      low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
      high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
    } | null;
  }>;
};

export type NotificationCoreFragmentFragment = {
  __typename: "Notifications";
  is_read: boolean;
  notification_id: string;
  notification_title: string;
  notification_body: string;
  notification_data?: any | null;
  notification_category?: string | null;
  notification_link?: string | null;
  link_label?: string | null;
  notification_priority: AlertPriority;
  from_cynergy_id?: string | null;
  recipient_cynergy_id: string;
  ref_id?: string | null;
  from: string;
  created_at: any;
  updated_at?: any | null;
};

export type MessageCoreFragmentFragment = {
  __typename: "Messages";
  message_id: string;
  cynergy_id: string;
  title: string;
  body: string;
  from_email: string;
  folder: MessageFolders;
  labels: Array<MessageLabels>;
  is_read: boolean;
  slug?: string | null;
  is_trashed?: boolean | null;
  is_starred?: boolean | null;
  attachment?: string | null;
  created_at: any;
  notification?: {
    __typename: "Notifications";
    is_read: boolean;
    notification_id: string;
    notification_title: string;
    notification_body: string;
    notification_data?: any | null;
    notification_category?: string | null;
    notification_link?: string | null;
    link_label?: string | null;
    notification_priority: AlertPriority;
    from_cynergy_id?: string | null;
    recipient_cynergy_id: string;
    ref_id?: string | null;
    from: string;
    created_at: any;
    updated_at?: any | null;
  } | null;
};

export type CynergyAccountCoreFragmentFragment = {
  __typename: "CynergyUsers";
  cynergy_id: string;
  email?: string | null;
  phone?: string | null;
  username: string;
  validated: boolean;
  is_default?: boolean | null;
  created_at: any;
  updated_at?: any | null;
};

export type CynergyAccountCoreFragmentAltFragment = {
  __typename: "CynergyUsers";
  cynergy_id: string;
  email?: string | null;
  phone?: string | null;
  username: string;
  validated: boolean;
  is_default?: boolean | null;
  created_at: any;
  updated_at?: any | null;
};

export type DemographicsCoreFragmentFragment = {
  __typename: "Demographics";
  cynergy_id: string;
  full_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  prefix?: string | null;
  suffix?: string | null;
  middle_name?: string | null;
  age: number;
  deceased: boolean;
  dob?: string | null;
  ethnicity?: string | null;
  sex: string;
  race?: string | null;
};

export type DemographicsCoreFragmentAltFragment = {
  __typename: "Demographics";
  cynergy_id: string;
  full_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  prefix?: string | null;
  suffix?: string | null;
  middle_name?: string | null;
  age: number;
  deceased: boolean;
  dob?: string | null;
  ethnicity?: string | null;
  marital_status?: MaritalStatus | null;
  sex: string;
  race?: string | null;
};

export type UserCoreFragmentFragment = {
  __typename: "Users";
  cynergy_id: string;
  user_id: string;
  username: string;
  first_login: boolean;
  identity?: {
    __typename: "CynergyUsers";
    cynergy_id: string;
    email?: string | null;
    phone?: string | null;
    username: string;
    validated: boolean;
    is_default?: boolean | null;
    created_at: any;
    updated_at?: any | null;
  } | null;
  demographics?: {
    __typename: "Demographics";
    cynergy_id: string;
    full_name?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    prefix?: string | null;
    suffix?: string | null;
    middle_name?: string | null;
    age: number;
    deceased: boolean;
    dob?: string | null;
    ethnicity?: string | null;
    sex: string;
    race?: string | null;
  } | null;
};

export type UserCoreFragmentAltFragment = { __typename: "Users"; cynergy_id: string; user_id: string; username: string };

export type PatientCoreFragmentFragment = { __typename: "Patients"; patient_id: string; user: { __typename: "Users"; user_id: string } };

export type LocationPatientCoreFragmentFragment = {
  __typename: "LocationPatients";
  status: string;
  patient_id: string;
  location_id: string;
  patient: {
    __typename?: "Patients";
    patient_id: string;
    user: {
      __typename?: "Users";
      user_id: string;
      demographics?: {
        __typename?: "Demographics";
        cynergy_id: string;
        first_name?: string | null;
        last_name?: string | null;
        full_name?: string | null;
        dob?: string | null;
        age: number;
      } | null;
    };
  };
};

export type DependentCoreFragmentFragment = {
  __typename: "Dependents";
  patient_id: string;
  parent_patient_id: string;
  parent: { __typename: "Patients"; patient_id: string };
  dependent: { __typename: "Patients"; patient_id: string };
};

export type UserEventsCoreFragmentFragment = {
  __typename: "UserEventData";
  id: string;
  title: string;
  start: any;
  end: any;
  link?: string | null;
  meta: {
    __typename: "EventMetaType";
    type: CalendarEventTypes;
    description: string;
    location: string;
    participants?: Array<{ __typename?: "EventParticipantsType"; label: string; value: string }> | null;
  };
};

export type GroupCoreFragmentFragment = {
  __typename: "Groups";
  group_id: string;
  name: string;
  description: string;
  type: CareGroupTypes;
  membership: GroupMembershipBasis;
  active: boolean;
  code?: number | null;
  created_at: any;
};

export type TwilioFactorCoreFragmentFragment = { __typename: "TwilioFactor"; factor_id: string; sid: string; name: string; verified: boolean };

export type TwoFactorAuthenticationCoreFragmentFragment = {
  __typename: "TwoFactorAuthentication";
  two_factor_id: string;
  cynergy_id: string;
  enabled: boolean;
  method?: TwoFactorMethods | null;
  sms_number?: string | null;
  sms_verified: boolean;
};

export type TwoFactorTotpCoreFragmentFragment = { __typename: "TwoFactorTotp"; two_factor_id: string; qr_uri: string; secret: string };

export type TwoFactorPushCoreFragmentFragment = { __typename: "TwoFactorPush"; two_factor_id: string };

export type StaffCoreFragmentFragment = { __typename: "Staffs"; staff_id: string; created_at: any };

export type StaffAssignmentCoreFragmentFragment = {
  __typename: "StaffAssignments";
  assignment_id: string;
  organization_id: string;
  location_id: string;
  staff_id: string;
  title: string;
  status: EmploymentStatus;
  hire_date: any;
};

export type PractitionerCoreFragmentFragment = {
  __typename: "Practitioners";
  practitioner_id: string;
  cynergy_id: string;
  registration_authority_id: string;
  npi: number;
  prefix?: string | null;
  suffix?: string | null;
  created_at: any;
  affiliation_date?: any | null;
};

export type PractitionerAffiliationsFragmentFragment = {
  __typename: "Practitioners";
  practitioner_id: string;
  location_affiliations?: Array<{ __typename: "PractitionerLocationAffiliations"; role: string }> | null;
};

export type PractitionerAssignmentCoreFragmentFragment = {
  __typename: "StaffAssignments";
  assignment_id: string;
  staff_id: string;
  location_id: string;
  organization_id: string;
  status: EmploymentStatus;
  title: string;
  hire_date: any;
};

export type PractitionerQualificationCoreFragmentFragment = {
  __typename: "PractitionerQualifications";
  qualification_id: string;
  practitioner_id: string;
  credential: DegreeLicenseCertificate;
  label: string;
  license?: string | null;
  speciality?: string | null;
  is_verified: boolean;
  verified_on?: any | null;
  created_at: any;
};

export type PractitionerSignatureCoreFragmentFragment = {
  __typename: "PractitionerSignatures";
  signature_id: string;
  signature_format: MimeTypes;
  url: string;
  when: any;
};

export type TaxonomiesCoreFragmentFragment = {
  __typename: "Taxonomies";
  taxonomy_id: string;
  license?: string | null;
  code: string;
  primary: boolean;
  description: string;
  group?: string | null;
  state?: string | null;
};

export type PeriodCoreFragmentFragment = { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };

export type RecurrencePatternCoreFragmentFragment = {
  __typename: "RecurrencePatterns";
  pattern_id: string;
  start_date: any;
  end_date?: string | null;
  description?: string | null;
  timezone?: any | null;
  text?: string | null;
};

export type RecurrencePatternWeeklyCoreFragmentFragment = {
  __typename: "WeeklyRecurrencePatterns";
  pattern_id: string;
  interval: number;
  days?: Array<DaysOfWeek> | null;
  every_day: boolean;
};

export type RecurrencePatternMonthlyCoreFragmentFragment = {
  __typename: "MonthlyRecurrencePatterns";
  pattern_id: string;
  interval: number;
  day_of_month?: number | null;
  day_of_week?: DaysOfWeek | null;
  week_of_month?: WeekOfMonth | null;
};

export type EventCoreFragmentFragment = {
  __typename: "Events";
  event_id: string;
  name: string;
  description?: string | null;
  type: string;
  event_date: any;
  all_day_event: boolean;
  start_time?: any | null;
  end_time?: any | null;
  repeats: boolean;
};

export type EventSeriesCoreFragmentFragment = { __typename: "EventSeries"; series_id: string; start_time?: any | null; end_time?: any | null };

export type EncounterCoreFragmentFragment = {
  __typename: "Encounters";
  encounter_id: string;
  status: EncounterStatus;
  class: EncounterClass;
  priority: ActPriority;
  service_type: string;
  subject_status: EncounterSubjectStatus;
  planned_start_date: any;
  planned_end_date?: any | null;
  diet_preference?: EncounterDiet | null;
  special_arrangement?: EncounterSpecialArrangements | null;
  special_courtesy?: EncounterSpecialCourtesy | null;
  created_at: any;
  deleted_at?: any | null;
};

export type EncounterReasonsCoreFragmentFragment = { __typename: "EncounterReasons"; reason_code: string; use: EncounterReasonUse; created_at: any };

export type EncounterParticipantsCoreFragmentFragment = { __typename: "EncounterParticipants"; type: ParticipantType; created_at: any };

export type EncounterAdmissionsCoreFragmentFragment = {
  __typename: "EncounterAdmissions";
  admit_source: EncounterAdmitSource;
  discharge_disposition?: DischargeDisposition | null;
  readmission: boolean;
  created_at: any;
};

export type WebCartCoreFragmentFragment = { __typename?: "WebCarts"; id: string; cart_holder: string; expiresAt?: any | null };

export type WebCartItemCoreFragmentFragment = {
  __typename?: "WebCartItems";
  id: string;
  cart_id: string;
  productCode: string;
  name: string;
  price: any;
  tax?: any | null;
  thumbnail?: { __typename?: "WebCartItemThumbNails"; url: string } | null;
};

export type WebCartSummaryCoreFragmentFragment = {
  __typename?: "WebCartSummaries";
  cart_id: string;
  total: any;
  subtotal: any;
  tax: any;
  surcharge?: any | null;
  item_count: number;
};

export type WebCartBookingRequestCoreFragmentFragment = {
  __typename?: "WebCartBookingRequests";
  id: string;
  cart_id: string;
  items: Array<{ __typename?: "WebCartItems"; id: string; price: any; name: string }>;
  location?: {
    __typename?: "Locations";
    location_id: string;
    alias?: string | null;
    address: { __typename?: "WebCynergyAddresses"; address_id: string; formatted_address?: string | null };
  } | null;
  slot?: { __typename?: "Slots"; slot_id: string; start: any; end: any } | null;
};

export type CartItemsFragmentFragment = {
  __typename?: "WebCarts";
  id: string;
  items: Array<{
    __typename?: "WebCartItems";
    id: string;
    cart_id: string;
    productCode: string;
    name: string;
    price: any;
    tax?: any | null;
    thumbnail?: { __typename?: "WebCartItemThumbNails"; url: string } | null;
  }>;
};

export type UserTimelineFragmentFragment = {
  __typename: "TimelineEntry";
  id: string;
  title: string;
  message: string;
  action: ActionType;
  timestamp: any;
  subject: { __typename: "TimelineSubject"; id: string; type: UserTypes; name: string };
  reference?: { __typename: "TimelineTargetReference"; id?: string | null; resource: string } | null;
  extras?: { __typename: "TimelineExtras"; category?: FlagCategory | null; link?: string | null; meta?: any | null } | null;
};

export type FeedItemFragmentFragment = {
  __typename: "FeedItemObject";
  id: string;
  elementType: FeedElementType;
  publishDate: any;
  relativePublishedDate: string;
};

export type FeedActorObjectFragmentFragment = { __typename: "FeedActorObject"; id: string; type: FeedActorType; name: string; url?: any | null };

export type FeedElementCollectionFragmentFragment = {
  __typename: "FeedElementCollectionObject";
  count: number;
  currentPage: number;
  totalPages: number;
};

export type LinkCapabilityObjectFragmentFragment = { __typename: "LinkCapabilityObject"; url: any; urlName?: string | null };

export type FeedItemCapabilityFragmentFragment = { __typename: "FeedElementCapabilitiesObject" };

export type FeedBundleCapabilityFragmentFragment = { __typename: "FeedBundleCapabilityObject"; bundleType: FeedBundleType; totalElements: number };

export type TrackedChangeBundleCapabilityFragmentFragment = {
  __typename: "TrackedChangeBundleCapabilityObject";
  bundleType: FeedBundleType;
  totalElements: number;
};

export type TrackedChangeItemFragmentFragment = {
  __typename: "TrackedChangeItemObject";
  fieldName: string;
  newValue?: string | null;
  oldValue?: string | null;
  summary?: string | null;
};

export type MessageBodyObjectFragmentFragment = { __typename: "MessageBodyObject"; text?: string | null; isRichText: boolean };

export type MessageBodySegmentFragmentFragment = {
  __typename?: "MessageBodyObject";
  messageSegments?: Array<
    | { __typename: "MessageSegmentLinkObject"; text?: string | null; type: MessageSegmentType; linkUrl: any }
    | {
        __typename: "MessageSegmentMarkupBeginObject";
        text?: string | null;
        type: MessageSegmentType;
        altText?: string | null;
        htmlTag: string;
        markupType: MessageMarkupType;
        url?: any | null;
      }
    | { __typename: "MessageSegmentMarkupEndObject"; text?: string | null; type: MessageSegmentType; htmlTag: string; markupType: MessageMarkupType }
    | { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType }
  > | null;
};

export type MessageSegmentTextFragmentFragment = { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType };

export type MessageSegmentLinkFragmentFragment = { __typename: "MessageSegmentLinkObject"; text?: string | null; type: MessageSegmentType; url: any };

export type MessageSegmentMarkupBeginFragmentFragment = {
  __typename: "MessageSegmentMarkupBeginObject";
  text?: string | null;
  type: MessageSegmentType;
  altText?: string | null;
  htmlTag: string;
  markupType: MessageMarkupType;
  url?: any | null;
};

export type MessageSegmentMarkupEndFragmentFragment = {
  __typename: "MessageSegmentMarkupEndObject";
  text?: string | null;
  type: MessageSegmentType;
  htmlTag: string;
  markupType: MessageMarkupType;
};

export type PaymentProfileCoreFragmentFragment = {
  __typename: "PaymentProfiles";
  profile_id: string;
  authnet_payment_profile_id?: string | null;
  first_name: string;
  last_name: string;
  card_type: string;
  last_four_of_card: string;
  billing_address: string;
  state: string;
  city: string;
  zip: string;
  expiration: string;
  is_default: boolean;
  is_active: boolean;
  user: { __typename?: "Users"; user_id: string };
};

export type AddressCoreFragmentFragment = {
  __typename: "WebCynergyAddresses";
  address_id: string;
  city: string;
  state: string;
  zip: string;
  address_line_1: string;
  address_line_2?: string | null;
  nickname?: string | null;
  formatted_address?: string | null;
  type: string;
  longitude?: number | null;
  latitude?: number | null;
  is_default: boolean;
  place_id?: string | null;
};

export type ContactPointCoreFragmentFragment = {
  __typename: "ContactPoints";
  contact_point_id: string;
  system: ContactPointSystem;
  use: ContactPointUse;
  value: string;
  rank: number;
  created_at: any;
};

export type ContactDetailsCoreFragmentFragment = {
  __typename: "ContactDetails";
  contact_detail_id: string;
  name: string;
  purpose?: ContactEntityType | null;
};

export type ContactCoreFragmentFragment = {
  __typename: "Contacts";
  contact_id: string;
  first_name: string;
  last_name: string;
  nickname: string;
  email?: string | null;
  phone?: string | null;
  authorized_access: string;
  contact_type: PatientContactCodes;
  contact_relation_type: RelatedPersonTypes;
};

export type ContactInformationFragmentFragment = {
  __typename: "ContactDetails";
  contact_detail_id: string;
  name: string;
  purpose?: ContactEntityType | null;
  telecom: Array<{
    __typename: "ContactPoints";
    contact_point_id: string;
    system: ContactPointSystem;
    use: ContactPointUse;
    value: string;
    rank: number;
    created_at: any;
  }>;
};

export type OrganizationsCoreFragmentFragment = {
  __typename: "Organizations";
  organization_id: string;
  organization_role: OrganizationRoles;
  organization_type: OrganizationTypes;
  safety_precautions?: Array<OrganizationHealthAndSafetyPrecautions> | null;
  alias: string;
  name: string;
  preferred_member: boolean;
};

export type LocationsCoreFragmentFragment = {
  __typename?: "Locations";
  location_id: string;
  alias?: string | null;
  name: string;
  description?: string | null;
  phone?: string | null;
  preferred_member: boolean;
  organization_id: string;
  todays_operating_hours: string;
  open_now: boolean;
  location_role: string;
  location_status: string;
  meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
};

export type LocationOperatingHoursFragmentFragment = {
  __typename?: "Locations";
  preferred_timeslots?: {
    __typename?: "PreferredTimeSlotsType";
    weekday_text: Array<string>;
    periods: Array<{
      __typename?: "PeriodsType";
      open: { __typename?: "TimeSlotPeriodsType"; day: number; time: string };
      close: { __typename?: "TimeSlotPeriodsType"; day: number; time: string };
    }>;
  } | null;
};

export type AppointmentCoreFragmentFragment = {
  __typename: "Appointments";
  appointment_id: string;
  patient_id: string;
  title: string;
  patient_name: string;
  subject?: string | null;
  type: AppointmentType;
  category: ServiceRequestCategory;
  scheduled_start?: any | null;
  scheduled_end?: any | null;
  status: AppointmentStatus;
  description?: string | null;
};

export type AppointmentServiceTypesFragmentFragment = { __typename: "AppointmentServiceTypes"; service_id: string; type_id: string; name: string };

export type WebStoreCoreFragmentFragment = { __typename: "WebStores"; name: string; type: CommerceStoreType; code: string; isLocal?: boolean | null };

export type ProductCoreFragmentFragment = {
  __typename: "Products";
  code: string;
  name: string;
  product_id: string;
  description?: string | null;
  family: CommerceProductFamily;
  isInCart?: boolean | null;
  isWishListed?: boolean | null;
};

export type ProductCategoriesCoreFragmentFragment = {
  __typename: "ProductCategories";
  category_id: string;
  label: string;
  description?: string | null;
  number_of_products: number;
};

export type ProductCatalogItemsCoreFragmentFragment = { __typename: "ProductCatalogItems"; item_id: string };

export type ProductCatalogCoreFragmentFragment = {
  __typename: "ProductCatalogs";
  catalog_id: string;
  name?: string | null;
  description?: string | null;
  code: string;
  number_of_categories: number;
  number_of_products: number;
};

export type PriceBookCoreFragmentFragment = { __typename: "PriceBooks"; book_id: string; name: string; code: string; description?: string | null };

export type PriceBookEntryCoreFragmentFragment = {
  __typename: "PriceBookEntries";
  entry_id: string;
  name: string;
  product_code: string;
  unit_price: any;
};

export type WebStoreCategoryDefinitionCoreFragmentFragment = {
  __typename: "WebStoreCategoryDefinitions";
  definition_id: string;
  type: CommerceProductFamily;
  label: string;
  description?: string | null;
  image?: {
    __typename?: "Attachments";
    attachment_id: string;
    title: string;
    size?: number | null;
    width?: number | null;
    height?: number | null;
    url?: string | null;
  } | null;
};

export type UserProductBundleCoreFragmentFragment = {
  __typename: "UserProductBundles";
  bundle_id: string;
  account_id: string;
  name: string;
  owner: string;
  is_shared: boolean;
  description?: string | null;
  created_at: any;
};

export type UserProductBundleItemCoreFragmentFragment = {
  __typename: "UserProductBundleItems";
  bundle_item_id: string;
  name: string;
  sequence: number;
  product_id: string;
  pricebook_entry_id: string;
  store_id: string;
};

export type HealthcareServiceCoreFragmentFragment = {
  __typename: "HealthcareServices";
  service_id: string;
  name: string;
  type: string;
  category: ServiceRequestCategory;
  active: boolean;
  speciality?: Array<string> | null;
};

export type HealthcareServiceLocationCoreFragmentFragment = {
  __typename: "HealthcareServiceLocations";
  service_location_id: string;
  distance?: number | null;
};

export type DiagnosticServiceCoreFragmentFragment = {
  __typename?: "DiagnosticServices";
  service_id: string;
  title: string;
  subtitle?: string | null;
  type: LaboratoryServiceType;
};

export type DiagnosticServiceBiomarkersFragmentFragment = {
  __typename?: "DiagnosticServices";
  service_id: string;
  biomarkers?: Array<{
    __typename?: "ObservationDefinitions";
    definition_id: string;
    title: string;
    type: ObservationTypCode;
    method?: string | null;
    category: ObservationCategory;
    members?: Array<{
      __typename?: "ObservationDefinitions";
      definition_id: string;
      title: string;
      type: ObservationTypCode;
      method?: string | null;
      category: ObservationCategory;
    }> | null;
    components?: Array<{ __typename?: "ObservationDefinitionComponents"; component_id: string; name?: string | null }> | null;
  }> | null;
};

export type CriteriaCoreFragmentFragment = {
  __typename: "Criteria";
  criteria_number: number;
  title: string;
  publisher: string;
  reference_url?: string | null;
  citations?: Array<string> | null;
};

export type CriteriaDefinitionCoreFragmentFragment = {
  __typename: "CriteriaDefinitions";
  definition_id: string;
  slug: string;
  title: string;
  description: string;
  publisher: string;
  url?: string | null;
  created_by: string;
  created_at: any;
};

export type CriteriaItemCoreFragmentFragment = {
  __typename: "CriteriaItems";
  item_id: string;
  link_id: string;
  syndrome: string;
  icd10: { __typename: "ICD10"; icd10_code: string; label: string; description?: string | null; hex?: string | null };
};

export type CriteriaRuleCoreFragmentFragment = {
  __typename: "CriteriaRules";
  rule_id: string;
  statement: string;
  required_behavior?: ActionRequiredBehavior | null;
};

export type CriteriaFormResultCoreFragmentFragment = { __typename: "CriteriaFormResults"; result_id: string; passed: boolean; created_at: any };

export type CriteriaFormResultFlagCoreFragmentFragment = {
  __typename: "CriteriaFormResultFlags";
  flag_id: string;
  syndrome: string;
  created_at: any;
};

export type CriteriaFormResultFlagItemCoreFragmentFragment = {
  __typename: "CriteriaFormResultFlagItems";
  label: string;
  icd10_codes: Array<string>;
  applies_to: Array<string>;
  created_at: any;
};

export type CarePlanCoreFragmentFragment = {
  __typename: "CarePlans";
  care_plan_id: string;
  title: string;
  description: string;
  status: ServiceRequestStatus;
  category: string;
  created_at: any;
};

export type CareTeamCoreFragmentFragment = {
  __typename: "CareTeams";
  care_team_id: string;
  name: string;
  status: CareTeamStatus;
  category: CareTeamCategory;
  created_at: any;
};

export type CareTeamMemberCoreFragmentFragment = {
  __typename: "CareTeamMembers";
  member_id: string;
  role: ParticipantRole;
  name: string;
  created_at: any;
};

export type DetectedIssueCoreFragmentFragment = {
  __typename: "DetectedIssues";
  status: DetectedIssueStatus;
  category: DetectedIssueCategory;
  severity: DetectedIssueSeverity;
  detail?: string | null;
  identified_at: any;
  mitigation_action?: string | null;
  mitigation_date?: any | null;
  reference_uri?: string | null;
};

export type ConditionsCoreFragmentFragment = {
  __typename: "Conditions";
  condition_id: string;
  category: ConditionCategoryCodes;
  body_site?: string | null;
  verification_status: ConditionVerificationStatus;
  clinical_status: ConditionClinicalStatus;
  severity: ConditionSeverityCodes;
  note?: string | null;
  recorded_date?: any | null;
  abatement_date_string?: string | null;
  abatement_date_time?: any | null;
  onset_date_string?: string | null;
  onset_date_time?: any | null;
};

export type ConditionAssessmentCoreFragmentFragment = {
  __typename: "ClinicalImpressions";
  impression_id: string;
  status: EventStatuses;
  description?: string | null;
  summary: string;
  change_pattern: ImpressionChangePatternCodes;
  numeric_rating: number;
  protocol?: string | null;
  assessment_date_time: any;
  status_reason?: string | null;
  created_at: any;
};

export type ClinicalNoteCoreFragmentFragment = {
  __typename: "ClinicalNotes";
  note_id: string;
  subject: string;
  text: string;
  created_at: any;
  authored: any;
};

export type MedicationCoreFragmentFragment = {
  __typename: "Medications";
  medication_id: string;
  brand_name: string;
  status: MedicationsStatus;
  code: MedicationCodes;
  dose_form: string;
  manufacturer?: string | null;
};

export type MedicationUsageCoreFragmentFragment = {
  __typename: "MedicationUsages";
  usage_id: string;
  practitioner_id: string;
  notes?: string | null;
  adherence: MedicationUsageAdherence;
  date_asserted: any;
  category: MedicationRequestAdministrativeLocation;
  dosage_instruction: string;
  administration_method: string;
  administration_timing: TimingAbbreviations;
  timing_display?: string | null;
  effective: any;
  days_left: number;
  usage_status: MedicationUsageStatus;
  effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
};

export type MedicationCoreFragmentAltFragment = {
  __typename: "Medications";
  medication_id: string;
  brand_name: string;
  status: MedicationsStatus;
  code: MedicationCodes;
  dose_form: string;
  manufacturer?: string | null;
};

export type MedicationUsageCoreFragmentAltFragment = {
  __typename: "MedicationUsages";
  usage_id: string;
  practitioner_id: string;
  notes?: string | null;
  adherence: MedicationUsageAdherence;
  date_asserted: any;
  category: MedicationRequestAdministrativeLocation;
  dosage_instruction: string;
  administration_method: string;
  administration_timing: TimingAbbreviations;
  timing_display?: string | null;
  effective: any;
  days_left: number;
  usage_status: MedicationUsageStatus;
  effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
};

export type DiagnosticReportCoreFragmentFragment = {
  __typename: "DiagnosticReports";
  report_id: string;
  code: string;
  category: DiagnosticServiceSection;
  status: DiagnosticReportStatus;
  conclusion_code?: string | null;
  issued?: any | null;
};

export type ObservationCoreFragmentFragment = {
  __typename: "Observations";
  observation_id: string;
  code: string;
  category: ObservationCategory;
  status: ObservationStatus;
  method?: string | null;
  target_type?: ObservationTargetType | null;
  interpretation: ObservationInterpretation;
  created_at: any;
};

export type ObservationFlagCoreFragmentFragment = {
  __typename: "ObservationFlags";
  flag_id: string;
  hl7_code: string;
  display: string;
  alert_priority: AlertPriority;
  created_at: any;
};

export type ObservationDefinitionCoreFragmentFragment = {
  __typename?: "ObservationDefinitions";
  definition_id: string;
  title: string;
  type: ObservationTypCode;
  method?: string | null;
  category: ObservationCategory;
};

export type ObservationDefinitionComponentCoreFragmentFragment = {
  __typename?: "ObservationDefinitionComponents";
  component_id: string;
  name?: string | null;
};

export type SpecimenDefinitionCoreFragmentFragment = { __typename?: "SpecimenDefinitions"; definition_id: string };

export type SpecimenDefinitionCollectionCoreFragmentFragment = {
  __typename?: "SpecimenDefinitionCollections";
  collection_id: string;
  patient_preparation?: string | null;
  specimen_type: SpecimenCodes;
  method?: { __typename?: "CodeableConcepts"; text: string } | null;
};

export type LoincCodeCoreFragmentFragment = {
  __typename: "LoincCodes";
  code: string;
  display: string;
  status: LoincStatusCodes;
  classification?: string | null;
  class_type?: LoincClassTypes | null;
  order_observation?: LoincOrderObservation | null;
};

export type GenotypeCoreFragmentFragment = {
  __typename: "Genotypes";
  genotype_id: string;
  gene: string;
  encoding?: string | null;
  mechanism?: string | null;
  classification?: string | null;
};

export type AgentCoreFragmentFragment = { __typename: "Agents"; agent_id: string; name: string };

export type AgentClassificationCoreFragmentFragment = {
  __typename: "AgentClassifications";
  classification_number: number;
  code: AntibioticClassificationCodes;
  label: string;
  description?: string | null;
};

export type OrderCoreFragmentFragment = {
  __typename: "Orders";
  order_id: string;
  title: string;
  description?: string | null;
  status: OrderStatus;
  status_reason?: string | null;
  priority: RequestPriority;
  recurs: boolean;
  series_id?: string | null;
  event_id?: string | null;
  is_series_source?: boolean | null;
  scheduled_date: any;
  fulfilled_at?: any | null;
  requested_collection_date?: any | null;
  is_reviewed: boolean;
  created_by: string;
  deleted_at?: any | null;
};

export type OrderLineItemCoreFragmentFragment = {
  __typename: "OrderLineItems";
  line_item_id: string;
  description?: string | null;
  net_total: any;
  tax?: any | null;
};

export type OrderAgentCoreFragmentFragment = {
  __typename: "OrderAgents";
  agent_id: string;
  name?: string | null;
  active: boolean;
  role: ParticipantRoleType;
  comment?: string | null;
};

type OrderAgentActorCoreFragment_CareTeams_Fragment = { __typename: "CareTeams"; care_team_id: string };

type OrderAgentActorCoreFragment_Locations_Fragment = { __typename: "Locations"; location_id: string };

type OrderAgentActorCoreFragment_Organizations_Fragment = { __typename: "Organizations"; organization_id: string };

type OrderAgentActorCoreFragment_Practitioners_Fragment = { __typename: "Practitioners"; practitioner_id: string };

type OrderAgentActorCoreFragment_StaffAssignments_Fragment = { __typename: "StaffAssignments" };

export type OrderAgentActorCoreFragmentFragment =
  | OrderAgentActorCoreFragment_CareTeams_Fragment
  | OrderAgentActorCoreFragment_Locations_Fragment
  | OrderAgentActorCoreFragment_Organizations_Fragment
  | OrderAgentActorCoreFragment_Practitioners_Fragment
  | OrderAgentActorCoreFragment_StaffAssignments_Fragment;

export type ServiceRequestCoreFragmentFragment = {
  __typename: "ServiceRequests";
  request_id: string;
  code: string;
  status: RequestStatus;
  priority: RequestPriority;
  intent: RequestIntent;
  category: ServiceRequestCategory;
  occurrence?: any | null;
  created_at: any;
};

export type FileCoreFragmentFragment = {
  __typename: "BucketItem";
  name?: string | null;
  etag?: string | null;
  lastModified?: any | null;
  prefix?: string | null;
  size?: number | null;
};

export type FileMetaDataFragmentFragment = {
  __typename: "BucketMetaData";
  Fileextension?: string | null;
  Filename?: string | null;
  Folder?: string | null;
  Isstarred?: boolean | null;
  Istrashed?: boolean | null;
  Label?: string | null;
  Lastaccessed?: string | null;
};

export type FileBucketFragmentFragment = {
  __typename: "Bucket";
  folder: string;
  files: Array<{
    __typename: "BucketItem";
    size?: number | null;
    name?: string | null;
    prefix?: string | null;
    lastModified?: any | null;
    etag?: string | null;
  }>;
};

export type AttachmentCoreFragmentFragment = {
  __typename: "Attachments";
  attachment_id: string;
  content_type: MimeTypes;
  title: string;
  url?: string | null;
  width?: number | null;
  height?: number | null;
  pages?: number | null;
  size?: number | null;
  created_at: any;
};

export type DocumentReferenceCoreFragmentFragment = {
  __typename: "DocumentReferences";
  reference_id: string;
  status: DocumentReferenceStatus;
  description?: string | null;
  content_type: MimeTypes;
  document_status: CompositionStatus;
  security_tag?: SecurityLabel | null;
  version: string;
};

export type UserCollectionCoreFragmentFragment = {
  __typename: "Collections";
  collection_id: string;
  name: string;
  color?: any | null;
  url?: string | null;
  is_default: boolean;
};

export type CollectionEntryCoreFragmentFragment = { __typename: "CollectionEntries"; entry_id: string; name: string; url?: string | null };

export type GoogleGeocodeCoreFragmentFragment = {
  __typename: "GoogleGeocodingResponseType";
  status: GeocodingStatusCodes;
  error_message?: string | null;
  results: Array<{
    __typename?: "GoogleGeocodingResultType";
    formatted_address: string;
    types: Array<string>;
    address_components: Array<{ __typename?: "GoogleAddressComponentType"; long_name: string; short_name: string; types: Array<string> }>;
    geometry: { __typename?: "GoogleGeometryType"; location: { __typename?: "CoordinateType"; lat: number; lng: number } };
  }>;
};

export type GoogleGeocodingCoordinateFragmentsFragment = {
  __typename?: "GoogleGeocodingResponseType";
  results: Array<{
    __typename?: "GoogleGeocodingResultType";
    geometry: { __typename?: "GoogleGeometryType"; location: { __typename?: "CoordinateType"; lat: number; lng: number } };
  }>;
};

export type SetupTwoFactorProfileMutationVariables = Exact<{
  profile: SetupTwoFactorProfileInput;
}>;

export type SetupTwoFactorProfileMutation = {
  __typename?: "Mutation";
  setupTwoFactorProfile: {
    __typename: "TwoFactorAuthentication";
    two_factor_id: string;
    cynergy_id: string;
    enabled: boolean;
    method?: TwoFactorMethods | null;
    sms_number?: string | null;
    sms_verified: boolean;
    factor?:
      | { __typename: "TwoFactorPush"; two_factor_id: string }
      | { __typename: "TwoFactorTotp"; two_factor_id: string; qr_uri: string; secret: string }
      | null;
  };
};

export type DisableTwoFactorAuthenticationMutationVariables = Exact<{ [key: string]: never }>;

export type DisableTwoFactorAuthenticationMutation = {
  __typename?: "Mutation";
  disableTwoFactorAuthentication: {
    __typename: "TwoFactorAuthentication";
    two_factor_id: string;
    cynergy_id: string;
    enabled: boolean;
    method?: TwoFactorMethods | null;
    sms_number?: string | null;
    sms_verified: boolean;
  };
};

export type VerifyTwilioFactorMutationVariables = Exact<{
  factor: FactorVerifyInput;
}>;

export type VerifyTwilioFactorMutation = {
  __typename?: "Mutation";
  verifyTwilioFactor: { __typename?: "TwilioVerifyResponse"; sid: string; status: string };
};

export type CreateTwilioChallengeMutationVariables = Exact<{
  challenge: ChallengeCreateInput;
}>;

export type CreateTwilioChallengeMutation = {
  __typename?: "Mutation";
  createTwilioChallenge: { __typename?: "CreateChallengeResponse"; sid: string; status: TwilioChallengeStatus };
};

export type SendSmsVerificationCodeMutationVariables = Exact<{
  verificationPayload: VerificationCodeRequest;
}>;

export type SendSmsVerificationCodeMutation = {
  __typename?: "Mutation";
  sendSmsVerificationCode: { __typename?: "TwilioVerifyResponse"; sid: string; status: string };
};

export type VerifySmsVerificationCodeMutationVariables = Exact<{
  payload: VerificationCheckInput;
}>;

export type VerifySmsVerificationCodeMutation = {
  __typename?: "Mutation";
  verifySmsVerificationCode: { __typename?: "TwilioVerifyResponse"; sid: string; status: string };
};

export type UpdateUserProfileMutationVariables = Exact<{
  profile: CynergyProfileUpdateInput;
}>;

export type UpdateUserProfileMutation = {
  __typename?: "Mutation";
  updateUserProfile: {
    __typename: "CynergyUsers";
    cynergy_id: string;
    email?: string | null;
    phone?: string | null;
    username: string;
    validated: boolean;
    is_default?: boolean | null;
    created_at: any;
    updated_at?: any | null;
    demographics?: {
      __typename: "Demographics";
      cynergy_id: string;
      full_name?: string | null;
      first_name?: string | null;
      last_name?: string | null;
      prefix?: string | null;
      suffix?: string | null;
      middle_name?: string | null;
      age: number;
      deceased: boolean;
      dob?: string | null;
      ethnicity?: string | null;
      marital_status?: MaritalStatus | null;
      sex: string;
      race?: string | null;
    } | null;
  };
};

export type ChangeUserPasswordMutationVariables = Exact<{
  change: ChangeUserPasswordInput;
}>;

export type ChangeUserPasswordMutation = { __typename?: "Mutation"; changeUserPassword: string };

export type ManageUserAddressMutationVariables = Exact<{
  addressData: UserAddressInput;
  action: Scalars["String"]["input"];
}>;

export type ManageUserAddressMutation = {
  __typename?: "Mutation";
  manageUserAddress: {
    __typename?: "UpdateAddressResponse";
    token?: { __typename?: "TokenTypes"; accessToken?: string | null; refreshToken?: string | null } | null;
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
    addresses?: Array<{
      __typename?: "WebCynergyAddresses";
      address_id: string;
      nickname?: string | null;
      use: string;
      type: string;
      address_line_1: string;
      address_line_2?: string | null;
      city: string;
      state: string;
      zip: string;
      is_default: boolean;
      formatted_address?: string | null;
    }> | null;
  };
};

export type ManageUserContactsMutationVariables = Exact<{
  contactData: UserContactData;
  action: Scalars["String"]["input"];
}>;

export type ManageUserContactsMutation = {
  __typename?: "Mutation";
  manageUserContacts: {
    __typename?: "UpdateContactsResponse";
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
    contacts?: Array<{
      __typename?: "Contacts";
      phone?: string | null;
      nickname: string;
      email?: string | null;
      first_name: string;
      last_name: string;
      contact_id: string;
      contact_relation_type: RelatedPersonTypes;
      contact_type: PatientContactCodes;
      authorized_access: string;
    }> | null;
  };
};

export type ManageUserDependentsMutationVariables = Exact<{
  action: Scalars["String"]["input"];
  dependentData: UserDependentData;
}>;

export type ManageUserDependentsMutation = {
  __typename?: "Mutation";
  manageUserDependents: {
    __typename?: "UpdateDependentsResponse";
    dependents?: Array<
      | { __typename?: "Admins" }
      | { __typename?: "Dependents" }
      | { __typename?: "Groups" }
      | { __typename?: "Organizations" }
      | {
          __typename: "Patients";
          patient_id: string;
          user: {
            __typename: "Users";
            cynergy_id: string;
            user_id: string;
            username: string;
            first_login: boolean;
            identity?: {
              __typename: "CynergyUsers";
              cynergy_id: string;
              email?: string | null;
              phone?: string | null;
              username: string;
              validated: boolean;
              is_default?: boolean | null;
              created_at: any;
              updated_at?: any | null;
            } | null;
            demographics?: {
              __typename: "Demographics";
              cynergy_id: string;
              full_name?: string | null;
              first_name?: string | null;
              last_name?: string | null;
              prefix?: string | null;
              suffix?: string | null;
              middle_name?: string | null;
              age: number;
              deceased: boolean;
              dob?: string | null;
              ethnicity?: string | null;
              sex: string;
              race?: string | null;
            } | null;
          };
        }
      | { __typename?: "StaffAssignments" }
      | { __typename?: "Staffs" }
      | { __typename?: "Users" }
    > | null;
  };
};

export type CreatePaymentProfileMutationVariables = Exact<{
  isDefault: Scalars["Boolean"]["input"];
  billingAddress: BillingAddressType;
  cardDetails: CreditCardDetailsType;
}>;

export type CreatePaymentProfileMutation = {
  __typename?: "Mutation";
  createPaymentProfile:
    | {
        __typename: "PaymentProfiles";
        profile_id: string;
        authnet_payment_profile_id?: string | null;
        first_name: string;
        last_name: string;
        card_type: string;
        last_four_of_card: string;
        billing_address: string;
        state: string;
        city: string;
        zip: string;
        expiration: string;
        is_default: boolean;
        is_active: boolean;
        user: { __typename?: "Users"; user_id: string };
      }
    | { __typename?: "Transactions" };
};

export type UpdatePaymentProfileMutationVariables = Exact<{
  paymentProfileId: Scalars["String"]["input"];
  isDefault: Scalars["Boolean"]["input"];
  billingAddress: BillingAddressType;
  cardDetails: UpdateCreditCardType;
}>;

export type UpdatePaymentProfileMutation = {
  __typename?: "Mutation";
  updatePaymentProfile:
    | {
        __typename: "PaymentProfiles";
        profile_id: string;
        authnet_payment_profile_id?: string | null;
        first_name: string;
        last_name: string;
        card_type: string;
        last_four_of_card: string;
        billing_address: string;
        state: string;
        city: string;
        zip: string;
        expiration: string;
        is_default: boolean;
        is_active: boolean;
        user: { __typename?: "Users"; user_id: string };
      }
    | { __typename?: "Transactions" };
};

export type DeletePaymentProfileMutationVariables = Exact<{
  paymentProfileId: Scalars["String"]["input"];
}>;

export type DeletePaymentProfileMutation = { __typename?: "Mutation"; deletePaymentProfile: string };

export type DeleteUserAccountMutationVariables = Exact<{
  force?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type DeleteUserAccountMutation = { __typename?: "Mutation"; deleteUserAccount: { __typename: "RecordsDeleted"; count: number } };

export type UpdateAppointmentRequestMutationVariables = Exact<{
  request: AppointmentUpdateInput;
}>;

export type UpdateAppointmentRequestMutation = {
  __typename?: "Mutation";
  updateAppointmentRequest: {
    __typename: "Appointments";
    appointment_id: string;
    patient_id: string;
    title: string;
    patient_name: string;
    subject?: string | null;
    type: AppointmentType;
    category: ServiceRequestCategory;
    scheduled_start?: any | null;
    scheduled_end?: any | null;
    status: AppointmentStatus;
    description?: string | null;
  };
};

export type CancelAppointmentRequestMutationVariables = Exact<{
  request: AppointmentCancelInput;
}>;

export type CancelAppointmentRequestMutation = {
  __typename?: "Mutation";
  cancelAppointmentRequest: {
    __typename: "Appointments";
    appointment_id: string;
    patient_id: string;
    title: string;
    patient_name: string;
    subject?: string | null;
    type: AppointmentType;
    category: ServiceRequestCategory;
    scheduled_start?: any | null;
    scheduled_end?: any | null;
    status: AppointmentStatus;
    description?: string | null;
  };
};

export type AddToCartMutationVariables = Exact<{
  item: WebCartItemCreateInput;
}>;

export type AddToCartMutation = {
  __typename?: "Mutation";
  addToCart: {
    __typename?: "WebCartItems";
    id: string;
    cart_id: string;
    productCode: string;
    name: string;
    price: any;
    tax?: any | null;
    thumbnail?: { __typename?: "WebCartItemThumbNails"; url: string } | null;
  };
};

export type RemoveFromCartMutationVariables = Exact<{
  items: Array<WebCartItemDeleteInput> | WebCartItemDeleteInput;
}>;

export type RemoveFromCartMutation = {
  __typename?: "Mutation";
  removeFromCart: {
    __typename?: "WebCarts";
    id: string;
    cart_holder: string;
    expiresAt?: any | null;
    booking_requests?: Array<{
      __typename?: "WebCartBookingRequests";
      id: string;
      cart_id: string;
      items: Array<{ __typename?: "WebCartItems"; id: string; price: any; name: string }>;
      location?: {
        __typename?: "Locations";
        location_id: string;
        alias?: string | null;
        address: { __typename?: "WebCynergyAddresses"; address_id: string; formatted_address?: string | null };
      } | null;
      slot?: { __typename?: "Slots"; slot_id: string; start: any; end: any } | null;
    }> | null;
    summary?: {
      __typename?: "WebCartSummaries";
      cart_id: string;
      total: any;
      subtotal: any;
      tax: any;
      surcharge?: any | null;
      item_count: number;
    } | null;
  };
};

export type ClearCartMutationVariables = Exact<{ [key: string]: never }>;

export type ClearCartMutation = { __typename?: "Mutation"; clearCart: { __typename?: "WebCarts"; id: string } };

export type CheckoutCartMutationVariables = Exact<{
  checkout: CartCheckoutInput;
}>;

export type CheckoutCartMutation = {
  __typename?: "Mutation";
  checkoutCart: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    appointments?: Array<{
      __typename: "Appointments";
      appointment_id: string;
      patient_id: string;
      title: string;
      patient_name: string;
      subject?: string | null;
      type: AppointmentType;
      category: ServiceRequestCategory;
      scheduled_start?: any | null;
      scheduled_end?: any | null;
      status: AppointmentStatus;
      description?: string | null;
      service_types: Array<{ __typename?: "AppointmentServiceTypes"; service: { __typename?: "HealthcareServices"; name: string } }>;
    }> | null;
  };
};

export type CreateTreatmentPlanMutationVariables = Exact<{
  payload: TreatmentPlanCreateInput;
}>;

export type CreateTreatmentPlanMutation = {
  __typename?: "Mutation";
  createTreatmentPlan: {
    __typename: "CarePlans";
    care_plan_id: string;
    title: string;
    description: string;
    status: ServiceRequestStatus;
    category: string;
    created_at: any;
    subject:
      | { __typename?: "Groups" }
      | {
          __typename: "Patients";
          patient_id: string;
          user: {
            __typename: "Users";
            cynergy_id: string;
            user_id: string;
            demographics?: {
              __typename: "Demographics";
              cynergy_id: string;
              full_name?: string | null;
              first_name?: string | null;
              last_name?: string | null;
              prefix?: string | null;
              suffix?: string | null;
              middle_name?: string | null;
              age: number;
              deceased: boolean;
              dob?: string | null;
              ethnicity?: string | null;
              marital_status?: MaritalStatus | null;
              sex: string;
              race?: string | null;
            } | null;
          };
        };
    addresses?: Array<{
      __typename: "Conditions";
      condition_id: string;
      category: ConditionCategoryCodes;
      body_site?: string | null;
      verification_status: ConditionVerificationStatus;
      clinical_status: ConditionClinicalStatus;
      severity: ConditionSeverityCodes;
      note?: string | null;
      recorded_date?: any | null;
      abatement_date_string?: string | null;
      abatement_date_time?: any | null;
      onset_date_string?: string | null;
      onset_date_time?: any | null;
    }> | null;
    care_team?: {
      __typename: "CareTeams";
      care_team_id: string;
      name: string;
      status: CareTeamStatus;
      category: CareTeamCategory;
      created_at: any;
      members?: Array<{ __typename: "CareTeamMembers"; member_id: string; role: ParticipantRole; name: string; created_at: any }> | null;
    } | null;
    period?: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null } | null;
  };
};

export type CreateConditionsAssessmentMutationVariables = Exact<{
  payload: Array<ClinicalImpressionCreateInput> | ClinicalImpressionCreateInput;
  patientId: Scalars["String"]["input"];
  newSymptoms?: InputMaybe<SymptomsCreateInput>;
  taskId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateConditionsAssessmentMutation = {
  __typename?: "Mutation";
  createConditionsAssessment: Array<{
    __typename: "ClinicalImpressions";
    impression_id: string;
    status: EventStatuses;
    description?: string | null;
    summary: string;
    change_pattern: ImpressionChangePatternCodes;
    numeric_rating: number;
    protocol?: string | null;
    assessment_date_time: any;
    status_reason?: string | null;
    created_at: any;
  }>;
};

export type CreateMedicalConditionMutationVariables = Exact<{
  payload: ConditionCreateInput;
}>;

export type CreateMedicalConditionMutation = {
  __typename?: "Mutation";
  createMedicalCondition: Array<{
    __typename: "Conditions";
    condition_id: string;
    category: ConditionCategoryCodes;
    body_site?: string | null;
    verification_status: ConditionVerificationStatus;
    clinical_status: ConditionClinicalStatus;
    severity: ConditionSeverityCodes;
    note?: string | null;
    recorded_date?: any | null;
    abatement_date_string?: string | null;
    abatement_date_time?: any | null;
    onset_date_string?: string | null;
    onset_date_time?: any | null;
  }>;
};

export type DeleteMedicalConditionMutationVariables = Exact<{
  conditionId: Scalars["String"]["input"];
}>;

export type DeleteMedicalConditionMutation = { __typename?: "Mutation"; deleteMedicalCondition: string };

export type UpdateMedicalConditionMutationVariables = Exact<{
  payload: ConditionUpdateInput;
}>;

export type UpdateMedicalConditionMutation = {
  __typename?: "Mutation";
  updateMedicalCondition: {
    __typename: "Conditions";
    condition_id: string;
    category: ConditionCategoryCodes;
    body_site?: string | null;
    verification_status: ConditionVerificationStatus;
    clinical_status: ConditionClinicalStatus;
    severity: ConditionSeverityCodes;
    note?: string | null;
    recorded_date?: any | null;
    abatement_date_string?: string | null;
    abatement_date_time?: any | null;
    onset_date_string?: string | null;
    onset_date_time?: any | null;
  };
};

export type AddClinicalNoteToPatientMutationVariables = Exact<{
  payload: ClinicalNoteCreateInput;
}>;

export type AddClinicalNoteToPatientMutation = {
  __typename?: "Mutation";
  addClinicalNoteToPatient: {
    __typename: "ClinicalNotes";
    note_id: string;
    subject: string;
    text: string;
    created_at: any;
    authored: any;
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      description?: string | null;
      phone?: string | null;
      preferred_member: boolean;
      organization_id: string;
      todays_operating_hours: string;
      open_now: boolean;
      location_role: string;
      location_status: string;
      meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
    };
    author: {
      __typename: "StaffAssignments";
      assignment_id: string;
      staff_id: string;
      location_id: string;
      organization_id: string;
      status: EmploymentStatus;
      title: string;
      hire_date: any;
      employee: {
        __typename: "Staffs";
        staff_id: string;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    };
    patient: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        cynergy_id: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
  };
};

export type DeleteClinicalNoteMutationVariables = Exact<{
  noteId: Scalars["String"]["input"];
}>;

export type DeleteClinicalNoteMutation = { __typename?: "Mutation"; deleteClinicalNote: string };

export type AddToCollectionMutationVariables = Exact<{
  collection: AddToCollectionInput;
}>;

export type AddToCollectionMutation = {
  __typename?: "Mutation";
  addToCollection: { __typename: "CollectionEntries"; entry_id: string; name: string; url?: string | null };
};

export type RemoveFromCollectionMutationVariables = Exact<{
  entry: RemoveFromCollectionInput;
}>;

export type RemoveFromCollectionMutation = { __typename?: "Mutation"; removeFromCollection: { __typename?: "RecordsDeleted"; count: number } };

export type ConfirmEmailMutationVariables = Exact<{
  validationId: Scalars["String"]["input"];
  cynergyId: Scalars["String"]["input"];
}>;

export type ConfirmEmailMutation = { __typename?: "Mutation"; confirmEmail: string };

export type UpsertCoverageMutationVariables = Exact<{
  payload: CoverageUpsertInput;
}>;

export type UpsertCoverageMutation = {
  __typename?: "Mutation";
  upsertCoverage: {
    __typename: "Coverages";
    coverage_id: string;
    patient_id: string;
    organization_id: string;
    payor_name: string;
    payor_external_id?: string | null;
    policy_number: string;
    plan_type?: string | null;
    coverage_order: number;
    kind: FhirCoverageKind;
    status: FhirCoverageStatus;
    subscriber_first_name?: string | null;
    subscriber_last_name?: string | null;
    subscriber_dob?: any | null;
    subscriber_relationship_to_patient?: string | null;
    is_archived: boolean;
    deleted_at?: any | null;
    created_at: any;
    updated_at?: any | null;
  };
};

export type ArchiveCoverageMutationVariables = Exact<{
  payload: CoverageArchiveInput;
}>;

export type ArchiveCoverageMutation = {
  __typename?: "Mutation";
  archiveCoverage: {
    __typename: "Coverages";
    coverage_id: string;
    patient_id: string;
    organization_id: string;
    payor_name: string;
    payor_external_id?: string | null;
    policy_number: string;
    plan_type?: string | null;
    coverage_order: number;
    kind: FhirCoverageKind;
    status: FhirCoverageStatus;
    subscriber_first_name?: string | null;
    subscriber_last_name?: string | null;
    subscriber_dob?: any | null;
    subscriber_relationship_to_patient?: string | null;
    is_archived: boolean;
    deleted_at?: any | null;
    created_at: any;
    updated_at?: any | null;
  };
};

export type RestoreCoverageMutationVariables = Exact<{
  payload: CoverageRestoreInput;
}>;

export type RestoreCoverageMutation = {
  __typename?: "Mutation";
  restoreCoverage: {
    __typename: "Coverages";
    coverage_id: string;
    patient_id: string;
    organization_id: string;
    payor_name: string;
    payor_external_id?: string | null;
    policy_number: string;
    plan_type?: string | null;
    coverage_order: number;
    kind: FhirCoverageKind;
    status: FhirCoverageStatus;
    subscriber_first_name?: string | null;
    subscriber_last_name?: string | null;
    subscriber_dob?: any | null;
    subscriber_relationship_to_patient?: string | null;
    is_archived: boolean;
    deleted_at?: any | null;
    created_at: any;
    updated_at?: any | null;
  };
};

export type SubmitCriteriaResultsMutationVariables = Exact<{
  payload: SubmitCriteriaFormResult;
}>;

export type SubmitCriteriaResultsMutation = {
  __typename?: "Mutation";
  submitCriteriaResults: {
    __typename: "CriteriaFormResults";
    result_id: string;
    passed: boolean;
    created_by: string;
    created_at: any;
    prescriptions?: Array<{
      __typename: "MedicationUsages";
      usage_id: string;
      status: MedicationUsageStatus;
      medication: { __typename: "Medications"; medication_id: string; brand_name: string };
    }> | null;
    flagged_by?: Array<{
      __typename: "CriteriaFormResultFlags";
      flag_id: string;
      syndrome: string;
      created_at: any;
      flags: Array<{
        __typename: "CriteriaFormResultFlagItems";
        label: string;
        icd10_codes: Array<string>;
        applies_to: Array<string>;
        created_at: any;
      }>;
      diagnoses: Array<{
        __typename: "ICD10";
        icd10_code: string;
        label: string;
        description?: string | null;
        hex?: string | null;
        note?: string | null;
        type?: DiagnosisType | null;
        created_at: any;
      }>;
    }> | null;
    criteria: {
      __typename: "CriteriaDefinitions";
      definition_id: string;
      slug: string;
      title: string;
      description: string;
      publisher: string;
      url?: string | null;
      created_by: string;
      created_at: any;
    };
    patient: {
      __typename?: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        cynergy_id: string;
        user_id: string;
        username: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
    performer?:
      | {
          __typename: "Practitioners";
          practitioner_id: string;
          cynergy_id: string;
          registration_authority_id: string;
          npi: number;
          prefix?: string | null;
          suffix?: string | null;
          created_at: any;
          affiliation_date?: any | null;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        }
      | {
          __typename: "StaffAssignments";
          assignment_id: string;
          staff_id: string;
          location_id: string;
          organization_id: string;
          status: EmploymentStatus;
          title: string;
          hire_date: any;
          employee: {
            __typename: "Staffs";
            staff_id: string;
            user: {
              __typename: "Users";
              cynergy_id: string;
              user_id: string;
              demographics?: {
                __typename: "Demographics";
                cynergy_id: string;
                full_name?: string | null;
                first_name?: string | null;
                last_name?: string | null;
                prefix?: string | null;
                suffix?: string | null;
                middle_name?: string | null;
                age: number;
                deceased: boolean;
                dob?: string | null;
                ethnicity?: string | null;
                marital_status?: MaritalStatus | null;
                sex: string;
                race?: string | null;
              } | null;
            };
          };
        }
      | null;
  };
};

export type UploadPatientDocumentsMutationVariables = Exact<{
  payload: UploadPatientDocumentsInput;
}>;

export type UploadPatientDocumentsMutation = {
  __typename?: "Mutation";
  uploadPatientDocuments: Array<{
    __typename?: "PatientDocumentResponse";
    patientDocumentId: string;
    patientId: string;
    category: PatientDocumentCategory;
    label?: string | null;
    currentUrl?: any | null;
    versions: Array<{ __typename?: "PatientDocumentVersionResponse"; patientDocumentVersionId: string; sequence: number; uploadedAt: any; url: any }>;
  }>;
};

export type RemovePatientDocumentMutationVariables = Exact<{
  patientDocumentId: Scalars["ID"]["input"];
}>;

export type RemovePatientDocumentMutation = { __typename?: "Mutation"; removePatientDocument: string };

export type MergeDuplicateRecordsMutationVariables = Exact<{
  request: RecordMergeRequestInput;
}>;

export type MergeDuplicateRecordsMutation = {
  __typename?: "Mutation";
  mergeRecords: { __typename?: "MergeRequestResultObject"; id: string; mergedRecordIds: Array<string> };
};

export type CreateEmployeeMutationVariables = Exact<{
  employee: StaffAssignmentCreateInput;
}>;

export type CreateEmployeeMutation = {
  __typename?: "Mutation";
  createEmployee: {
    __typename: "StaffAssignments";
    assignment_id: string;
    organization_id: string;
    location_id: string;
    staff_id: string;
    title: string;
    status: EmploymentStatus;
    hire_date: any;
  };
};

export type UpdateEmployeeMutationVariables = Exact<{
  employee: StaffAssignmentUpdateInput;
}>;

export type UpdateEmployeeMutation = {
  __typename?: "Mutation";
  updateEmployee: {
    __typename: "StaffAssignments";
    assignment_id: string;
    organization_id: string;
    location_id: string;
    staff_id: string;
    title: string;
    status: EmploymentStatus;
    hire_date: any;
  };
};

export type DeleteEmployeeMutationVariables = Exact<{
  employee: EmployeeAssignmentReleaseInput;
}>;

export type DeleteEmployeeMutation = { __typename?: "Mutation"; deleteEmployee: { __typename?: "RecordsDeleted"; count: number } };

export type RegisterStaffUserMutationVariables = Exact<{
  registerPayload: LocationStaffCreateInput;
}>;

export type RegisterStaffUserMutation = {
  __typename?: "Mutation";
  registerLocationStaff: {
    __typename: "StaffAssignments";
    assignment_id: string;
    organization_id: string;
    location_id: string;
    staff_id: string;
    title: string;
    status: EmploymentStatus;
    hire_date: any;
  };
};

export type ChangeEmployeePasswordMutationVariables = Exact<{
  password: Scalars["String"]["input"];
  assignmentId: Scalars["String"]["input"];
}>;

export type ChangeEmployeePasswordMutation = { __typename?: "Mutation"; changeEmployeePassword: string };

export type ToggleSupervisorRoleMutationVariables = Exact<{
  payload: ToggleSupervisorRoleInput;
}>;

export type ToggleSupervisorRoleMutation = {
  __typename?: "Mutation";
  toggleSupervisorRole: { __typename?: "SupervisorRoleResult"; cynergyId: string; isSupervisor: boolean };
};

export type ModifyOccurrenceMutationVariables = Exact<{
  occurrence: SeriesOccurrenceUpdateInput;
}>;

export type ModifyOccurrenceMutation = {
  __typename?: "Mutation";
  updateSeriesOccurrence: {
    __typename: "Events";
    event_id: string;
    name: string;
    description?: string | null;
    type: string;
    event_date: any;
    all_day_event: boolean;
    start_time?: any | null;
    end_time?: any | null;
    repeats: boolean;
  };
};

export type UpdateEventSeriesMutationVariables = Exact<{
  series: EventSeriesUpdateInput;
}>;

export type UpdateEventSeriesMutation = {
  __typename?: "Mutation";
  updateEventSeries: {
    __typename: "EventSeries";
    series_id: string;
    start_time?: any | null;
    end_time?: any | null;
    pattern: {
      __typename: "RecurrencePatterns";
      pattern_id: string;
      start_date: any;
      end_date?: string | null;
      description?: string | null;
      timezone?: any | null;
      text?: string | null;
    };
  };
};

export type DeactivateEventSeriesMutationVariables = Exact<{
  series: EventSeriesDeactivateInput;
}>;

export type DeactivateEventSeriesMutation = {
  __typename?: "Mutation";
  deactivateEventSeries: { __typename: "EventSeries"; series_id: string; deleted_at?: any | null };
};

export type DeactivateEventSeriesBatchMutationVariables = Exact<{
  series: EventSeriesBulkDeactivateInput;
}>;

export type DeactivateEventSeriesBatchMutation = {
  __typename?: "Mutation";
  deactivateEventSeriesBatch: { __typename?: "EventSeriesBulkDeactivateResult"; deactivatedCount: number; failedSeriesIds: Array<string> };
};

export type CreateQuestionnaireFormMutationVariables = Exact<{
  payload: QuestionnaireFormCreateInput;
}>;

export type CreateQuestionnaireFormMutation = {
  __typename?: "Mutation";
  createQuestionnaireForm:
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | { __typename?: "QuestionnaireResponses" }
    | {
        __typename: "Questionnaires";
        questionnaire_number: number;
        title: string;
        url?: string | null;
        description: string;
        link_id: string;
        publisher: string;
        publish_date: any;
        status: PublicationStatus;
        subject_type: string;
        purpose: string;
        last_review_date?: any | null;
        version: string;
        created_at: any;
      };
};

export type CreateQuestionnaireItemsMutationVariables = Exact<{
  payload: QuestionnaireQuestionCreateInput;
}>;

export type CreateQuestionnaireItemsMutation = {
  __typename?: "Mutation";
  createQuestionnaireItems: Array<
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | {
        __typename: "QuestionnaireItems";
        item_id: string;
        link_id: string;
        item_type: QuestionnaireItemType;
        input_type: FormInputGroupType;
        response_label?: string | null;
        order: number;
        text: string;
        prefix?: string | null;
        answer_constraint?: QuestionnaireAnswerConstraint | null;
        disabled_display: QuestionnaireDisabledDisplay;
        enable_behavior: QuestionnaireEnableBehavior;
        max_length?: number | null;
        ready_only: boolean;
        required: boolean;
        repeats: boolean;
        created_at: any;
        answer_options?: Array<{
          __typename: "QuestionnaireAnswerOptions";
          option_id: string;
          label?: string | null;
          icon?: string | null;
          initial_selected: boolean;
          option_coding?: string | null;
          option_date?: any | null;
          option_time?: string | null;
          option_integer?: number | null;
          option_string?: string | null;
          option_boolean?: boolean | null;
          created_at: any;
          option_range?: {
            __typename?: "Range";
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
        }> | null;
        enabled_when?: { __typename: "QuestionnaireEnableWhen"; enable_id: string; link_id: string } | null;
        appearance?: {
          __typename: "LayoutConfiguration";
          column: {
            __typename?: "GridLayoutProperties";
            xs?: number | null;
            sm?: number | null;
            md?: number | null;
            lg?: number | null;
            xl?: number | null;
            xxl?: number | null;
          };
        } | null;
      }
    | { __typename?: "QuestionnaireResponses" }
    | { __typename?: "Questionnaires" }
  >;
};

export type CreateQuestionnaireResponseMutationVariables = Exact<{
  payload: QuestionnaireResponseCreateInput;
}>;

export type CreateQuestionnaireResponseMutation = {
  __typename?: "Mutation";
  createQuestionnaireResponse:
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | {
        __typename: "QuestionnaireResponses";
        response_id: string;
        status: QuestionnaireAnswerStatus;
        authored: any;
        completed_at?: any | null;
        created_at: any;
        updated_at?: any | null;
        progress?: number | null;
        answers: Array<{
          __typename: "QuestionnaireAnswers";
          answer_id: string;
          answer_decimal?: number | null;
          answer_date?: any | null;
          answer_time?: string | null;
          answer_integer?: number | null;
          answer_boolean?: boolean | null;
          answer_coding?: string | null;
          answer_attachment?: string | null;
          answer_string?: string | null;
          answer_uri?: string | null;
          question: {
            __typename: "QuestionnaireItems";
            item_id: string;
            link_id: string;
            item_type: QuestionnaireItemType;
            input_type: FormInputGroupType;
            response_label?: string | null;
            order: number;
            text: string;
            prefix?: string | null;
            answer_constraint?: QuestionnaireAnswerConstraint | null;
            disabled_display: QuestionnaireDisabledDisplay;
            enable_behavior: QuestionnaireEnableBehavior;
            max_length?: number | null;
            ready_only: boolean;
            required: boolean;
            repeats: boolean;
            created_at: any;
            appearance?: {
              __typename: "LayoutConfiguration";
              column: {
                __typename?: "GridLayoutProperties";
                xs?: number | null;
                sm?: number | null;
                md?: number | null;
                lg?: number | null;
                xl?: number | null;
                xxl?: number | null;
              };
            } | null;
          };
          answer_option?: { __typename: "QuestionnaireAnswerOptions"; option_id: string; label?: string | null } | null;
          answer_range?: {
            __typename?: "Range";
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
          answer_quantity?: {
            __typename: "Quantity";
            quantity_id: string;
            value: number;
            unit: string;
            code?: string | null;
            system?: string | null;
            created_at: any;
          } | null;
        }>;
        questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
      }
    | { __typename?: "Questionnaires" };
};

export type UpdateQuestionnaireResponseMutationVariables = Exact<{
  payload: QuestionnaireResponseUpdateInput;
}>;

export type UpdateQuestionnaireResponseMutation = {
  __typename?: "Mutation";
  updateQuestionnaireResponse:
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | {
        __typename: "QuestionnaireResponses";
        response_id: string;
        status: QuestionnaireAnswerStatus;
        authored: any;
        completed_at?: any | null;
        created_at: any;
        updated_at?: any | null;
        progress?: number | null;
        answers: Array<{
          __typename: "QuestionnaireAnswers";
          answer_id: string;
          answer_decimal?: number | null;
          answer_date?: any | null;
          answer_time?: string | null;
          answer_integer?: number | null;
          answer_boolean?: boolean | null;
          answer_coding?: string | null;
          answer_attachment?: string | null;
          answer_string?: string | null;
          answer_uri?: string | null;
          answer_option?: { __typename: "QuestionnaireAnswerOptions"; option_id: string; label?: string | null } | null;
          answer_range?: {
            __typename?: "Range";
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
          answer_quantity?: {
            __typename: "Quantity";
            quantity_id: string;
            value: number;
            unit: string;
            code?: string | null;
            system?: string | null;
            created_at: any;
          } | null;
        }>;
        questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
      }
    | { __typename?: "Questionnaires" };
};

export type UploadFilesMutationVariables = Exact<{
  files: Array<Scalars["Upload"]["input"]> | Scalars["Upload"]["input"];
  folder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UploadFilesMutation = {
  __typename?: "Mutation";
  uploadFiles: {
    __typename: "FileUploadResponse";
    message: string;
    paths: Array<string>;
    status: number;
    errors?: Array<{ __typename?: "FieldError"; message: string; path: string; code?: string | null }> | null;
  };
};

export type UpdateProfilePhotoMutationVariables = Exact<{
  file: Scalars["Upload"]["input"];
}>;

export type UpdateProfilePhotoMutation = {
  __typename?: "Mutation";
  updateProfilePhoto: {
    __typename?: "UpdateProfileResponse";
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
    token?: { __typename?: "TokenTypes"; accessToken?: string | null; refreshToken?: string | null } | null;
    session?: { __typename?: "UserSessionData"; photo?: string | null } | null;
  };
};

export type CreateNewFolderMutationVariables = Exact<{
  path: Scalars["String"]["input"];
}>;

export type CreateNewFolderMutation = { __typename?: "Mutation"; createNewFolder: string };

export type ManageFolderMutationVariables = Exact<{
  action: AppActions;
  folder: Scalars["String"]["input"];
  newFolder?: InputMaybe<Scalars["String"]["input"]>;
  moveFolder?: InputMaybe<Scalars["Boolean"]["input"]>;
  foldersToDelete?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type ManageFolderMutation = {
  __typename?: "Mutation";
  manageFolder: {
    __typename: "ExploreFilesResponse";
    message: string;
    status: number;
    paths?: Array<{
      __typename?: "Bucket";
      folder: string;
      files: Array<{
        __typename: "BucketItem";
        name?: string | null;
        etag?: string | null;
        lastModified?: any | null;
        prefix?: string | null;
        size?: number | null;
        metadata?: {
          __typename: "BucketMetaData";
          Fileextension?: string | null;
          Filename?: string | null;
          Folder?: string | null;
          Isstarred?: boolean | null;
          Istrashed?: boolean | null;
          Label?: string | null;
          Lastaccessed?: string | null;
        } | null;
      }>;
    }> | null;
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
  };
};

export type ManageFilesMutationVariables = Exact<{
  fileNames: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  label?: InputMaybe<Scalars["String"]["input"]>;
  isStarred?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTrashed?: InputMaybe<Scalars["Boolean"]["input"]>;
  newName?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ManageFilesMutation = {
  __typename?: "Mutation";
  manageFiles: {
    __typename: "ExploreFilesResponse";
    message: string;
    status: number;
    paths?: Array<{
      __typename: "Bucket";
      folder: string;
      files: Array<{
        __typename: "BucketItem";
        name?: string | null;
        etag?: string | null;
        lastModified?: any | null;
        prefix?: string | null;
        size?: number | null;
        metadata?: {
          __typename: "BucketMetaData";
          Fileextension?: string | null;
          Filename?: string | null;
          Folder?: string | null;
          Isstarred?: boolean | null;
          Istrashed?: boolean | null;
          Label?: string | null;
          Lastaccessed?: string | null;
        } | null;
      }>;
    }> | null;
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
  };
};

export type MoveFilesMutationVariables = Exact<{
  paths: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  folder: Scalars["String"]["input"];
}>;

export type MoveFilesMutation = {
  __typename?: "Mutation";
  moveFiles: {
    __typename?: "ExploreFilesResponse";
    message: string;
    status: number;
    paths?: Array<{
      __typename: "Bucket";
      folder: string;
      files: Array<{
        __typename: "BucketItem";
        name?: string | null;
        etag?: string | null;
        lastModified?: any | null;
        prefix?: string | null;
        size?: number | null;
        metadata?: {
          __typename: "BucketMetaData";
          Fileextension?: string | null;
          Filename?: string | null;
          Folder?: string | null;
          Isstarred?: boolean | null;
          Istrashed?: boolean | null;
          Label?: string | null;
          Lastaccessed?: string | null;
        } | null;
      }>;
    }> | null;
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
  };
};

export type DeleteFilesMutationVariables = Exact<{
  fileNames: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type DeleteFilesMutation = { __typename?: "Mutation"; deleteFiles: string };

export type ManageSharedFileMutationVariables = Exact<{
  sourcePath: Scalars["String"]["input"];
  action: AppActions;
}>;

export type ManageSharedFileMutation = { __typename?: "Mutation"; manageSharedFile: string };

export type GetPresignedUploadUrlMutationVariables = Exact<{
  destination: MinioS3DestinationInput;
}>;

export type GetPresignedUploadUrlMutation = { __typename?: "Mutation"; getPresignedUploadUrl: any };

export type GetPresignedRequestUrlMutationVariables = Exact<{
  destination: MinioS3DestinationInput;
}>;

export type GetPresignedRequestUrlMutation = { __typename?: "Mutation"; getPresignedRequestUrl: any };

export type GetReportUrlMutationVariables = Exact<{
  reportId: Scalars["String"]["input"];
}>;

export type GetReportUrlMutation = { __typename?: "Mutation"; getReportUrl: any };

export type PasswordResetRequestMutationVariables = Exact<{
  reset: RequestPasswordResetInput;
}>;

export type PasswordResetRequestMutation = { __typename?: "Mutation"; requestPasswordReset: string };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars["String"]["input"];
}>;

export type ResetPasswordMutation = { __typename?: "Mutation"; resetPassword: string };

export type AcceptOnboardingInviteMutationVariables = Exact<{
  invitePayload: AcceptOnboardingInviteInput;
}>;

export type AcceptOnboardingInviteMutation = {
  __typename?: "Mutation";
  acceptOnboardingInvite: {
    __typename: "CynergyUsers";
    cynergy_id: string;
    email?: string | null;
    phone?: string | null;
    username: string;
    validated: boolean;
    is_default?: boolean | null;
    created_at: any;
    updated_at?: any | null;
  };
};

export type RegisterLocationPatientMutationMutationVariables = Exact<{
  registerPayload: LocationPatientCreateInput;
}>;

export type RegisterLocationPatientMutationMutation = {
  __typename?: "Mutation";
  registerLocationPatient: {
    __typename: "LocationPatients";
    status: string;
    patient_id: string;
    location_id: string;
    patient: {
      __typename?: "Patients";
      patient_id: string;
      user: {
        __typename?: "Users";
        user_id: string;
        demographics?: {
          __typename?: "Demographics";
          cynergy_id: string;
          first_name?: string | null;
          last_name?: string | null;
          full_name?: string | null;
          dob?: string | null;
          age: number;
        } | null;
      };
    };
  };
};

export type RemoveLocationPatientMutationVariables = Exact<{
  patientId: Scalars["String"]["input"];
}>;

export type RemoveLocationPatientMutation = {
  __typename?: "Mutation";
  removeLocationPatient: {
    __typename: "LocationPatients";
    status: string;
    patient_id: string;
    location_id: string;
    patient: {
      __typename?: "Patients";
      patient_id: string;
      user: {
        __typename?: "Users";
        user_id: string;
        demographics?: {
          __typename?: "Demographics";
          cynergy_id: string;
          first_name?: string | null;
          last_name?: string | null;
          full_name?: string | null;
          dob?: string | null;
          age: number;
        } | null;
      };
    };
  };
};

export type RestoreLocationPatientMutationVariables = Exact<{
  patientId: Scalars["String"]["input"];
}>;

export type RestoreLocationPatientMutation = {
  __typename?: "Mutation";
  restoreLocationPatient: {
    __typename: "LocationPatients";
    status: string;
    patient_id: string;
    location_id: string;
    patient: {
      __typename?: "Patients";
      patient_id: string;
      user: {
        __typename?: "Users";
        user_id: string;
        demographics?: {
          __typename?: "Demographics";
          cynergy_id: string;
          first_name?: string | null;
          last_name?: string | null;
          full_name?: string | null;
          dob?: string | null;
          age: number;
        } | null;
      };
    };
  };
};

export type AssignPatientRoomMutationVariables = Exact<{
  assignPayload: AssignPatientRoomInput;
}>;

export type AssignPatientRoomMutation = { __typename?: "Mutation"; assignPatientRoom: string };

export type LoginMutationVariables = Exact<{
  loginPayload: LoginRequest;
}>;

export type LoginMutation = {
  __typename?: "Mutation";
  login: {
    __typename?: "LoginResponse";
    permissions?: string | null;
    token?: { __typename?: "TokenTypes"; accessToken?: string | null; refreshToken?: string | null } | null;
    session?: {
      __typename?: "UserSessionData";
      userId?: string | null;
      accountId: string;
      cynergyId: string;
      practitionerId?: string | null;
      staffRelationId?: string | null;
      organizationId?: string | null;
      locationId?: string | null;
      locationName?: string | null;
      email: string;
      userType?: UserTypes | null;
      phone?: string | null;
      lastName?: string | null;
      firstName?: string | null;
      username?: string | null;
      initials?: string | null;
      authnetProfileId?: string | null;
      defaultPage?: string | null;
      firstLogin?: boolean | null;
      twoFactorEnabled?: boolean | null;
      twoFactorMethod?: TwoFactorMethods | null;
      photo?: string | null;
      availableLocations?: Array<{
        __typename?: "AssignmentType";
        assignment_id: string;
        location_id: string;
        location?: { __typename?: "AssignmentLocationType"; alias: string } | null;
      }> | null;
      address?: {
        __typename?: "UserAddressData";
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        formattedAddress?: string | null;
        placeId?: string | null;
        isDefault?: boolean | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: "FieldError"; path: string; message: string }> | null;
  };
};

export type AddBulkPatientMedicationsMutationVariables = Exact<{
  medicationPayload: AddPatientMedicationInput;
}>;

export type AddBulkPatientMedicationsMutation = {
  __typename?: "Mutation";
  addBulkPatientMedications: Array<
    | { __typename?: "Dosage" }
    | { __typename?: "MedicationAdministrations" }
    | { __typename?: "MedicationBatch" }
    | { __typename?: "MedicationDispenses" }
    | { __typename?: "MedicationIngredients" }
    | {
        __typename: "MedicationUsages";
        usage_id: string;
        practitioner_id: string;
        notes?: string | null;
        adherence: MedicationUsageAdherence;
        date_asserted: any;
        category: MedicationRequestAdministrativeLocation;
        dosage_instruction: string;
        administration_method: string;
        administration_timing: TimingAbbreviations;
        timing_display?: string | null;
        effective: any;
        days_left: number;
        usage_status: MedicationUsageStatus;
        medication: {
          __typename: "Medications";
          medication_id: string;
          brand_name: string;
          status: MedicationsStatus;
          code: MedicationCodes;
          dose_form: string;
          manufacturer?: string | null;
        };
        effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
      }
    | { __typename?: "Medications" }
  >;
};

export type UpdateMedicationMutationVariables = Exact<{
  updatePayload: PatientMedicationUpdateInput;
}>;

export type UpdateMedicationMutation = {
  __typename?: "Mutation";
  updatePatientMedication:
    | { __typename?: "Dosage" }
    | { __typename?: "MedicationAdministrations" }
    | { __typename?: "MedicationBatch" }
    | { __typename?: "MedicationDispenses" }
    | { __typename?: "MedicationIngredients" }
    | {
        __typename: "MedicationUsages";
        usage_id: string;
        practitioner_id: string;
        notes?: string | null;
        adherence: MedicationUsageAdherence;
        date_asserted: any;
        category: MedicationRequestAdministrativeLocation;
        dosage_instruction: string;
        administration_method: string;
        administration_timing: TimingAbbreviations;
        timing_display?: string | null;
        effective: any;
        days_left: number;
        usage_status: MedicationUsageStatus;
        effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
      }
    | {
        __typename: "Medications";
        medication_id: string;
        brand_name: string;
        status: MedicationsStatus;
        code: MedicationCodes;
        dose_form: string;
        manufacturer?: string | null;
        total_volume: {
          __typename: "Ratio";
          ratio_id: string;
          numerator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
          denominator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
        };
      };
};

export type DeleteMedicationUsageMutationVariables = Exact<{
  usageId: Scalars["String"]["input"];
}>;

export type DeleteMedicationUsageMutation = { __typename?: "Mutation"; deleteMedicationUsage: string };

export type UpdateUserMessageMutationVariables = Exact<{
  updatePayload: MessageUpdatePayload;
  messageIDs: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type UpdateUserMessageMutation = {
  __typename?: "Mutation";
  updateUserMessages: Array<{
    __typename: "Messages";
    message_id: string;
    cynergy_id: string;
    title: string;
    body: string;
    from_email: string;
    folder: MessageFolders;
    labels: Array<MessageLabels>;
    is_read: boolean;
    slug?: string | null;
    is_trashed?: boolean | null;
    is_starred?: boolean | null;
    attachment?: string | null;
    created_at: any;
    notification?: {
      __typename: "Notifications";
      is_read: boolean;
      notification_id: string;
      notification_title: string;
      notification_body: string;
      notification_data?: any | null;
      notification_category?: string | null;
      notification_link?: string | null;
      link_label?: string | null;
      notification_priority: AlertPriority;
      from_cynergy_id?: string | null;
      recipient_cynergy_id: string;
      ref_id?: string | null;
      from: string;
      created_at: any;
      updated_at?: any | null;
    } | null;
  }>;
};

export type ReadUserNotificationMutationVariables = Exact<{
  notificationID: Scalars["String"]["input"];
}>;

export type ReadUserNotificationMutation = { __typename?: "Mutation"; readUserNotification: string };

export type UpdateUserNotificationMutationVariables = Exact<{
  updatePayload: NotificationUpdatePayload;
  notificationIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type UpdateUserNotificationMutation = { __typename?: "Mutation"; updateUserNotification: string };

export type SendOnboardingInviteMutationVariables = Exact<{
  invitePayload: OnboardingInviteCreateInput;
}>;

export type SendOnboardingInviteMutation = {
  __typename?: "Mutation";
  sendOnboardingInvite: { __typename?: "OnboardingInvite"; invite_id: string; status: OnboardingInviteStatus };
};

export type UpdateOrderBillingMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type UpdateOrderBillingMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename?: "Orders";
    order_id: string;
    status: OrderStatus;
    coverages?: Array<{
      __typename?: "OrderCoverages";
      order_coverage_id: string;
      coverage_id?: string | null;
      payor_name?: string | null;
      policy_number?: string | null;
      plan_type?: string | null;
      coverage_order: number;
    }> | null;
    requisition?: {
      __typename?: "DocumentReferences";
      reference_id: string;
      content: { __typename?: "Attachments"; attachment_id: string; title: string; url?: string | null };
    } | null;
  };
};

export type SubmitOrderRequestMutationVariables = Exact<{
  order: SubmitOrderRequestInput;
}>;

export type SubmitOrderRequestMutation = {
  __typename?: "Mutation";
  submitOrderRequest: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    agents?: Array<{
      __typename: "OrderAgents";
      agent_id: string;
      name?: string | null;
      active: boolean;
      role: ParticipantRoleType;
      comment?: string | null;
    }> | null;
  };
};

export type UpdateOrderMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type UpdateOrderMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    contacts?: Array<{
      __typename: "ContactDetails";
      contact_detail_id: string;
      name: string;
      purpose?: ContactEntityType | null;
      telecom: Array<{
        __typename: "ContactPoints";
        contact_point_id: string;
        system: ContactPointSystem;
        use: ContactPointUse;
        value: string;
        rank: number;
        created_at: any;
      }>;
    }> | null;
    agents?: Array<{
      __typename: "OrderAgents";
      agent_id: string;
      name?: string | null;
      active: boolean;
      role: ParticipantRoleType;
      comment?: string | null;
    }> | null;
    line_items?: Array<{ __typename: "OrderLineItems"; line_item_id: string; description?: string | null; net_total: any; tax?: any | null }> | null;
    signature?: { __typename?: "OrderSignatures"; name: string; order_id: string; signature_id: string; practitioner_id: string } | null;
  };
};

export type ManageOrderLineItemsMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderLineItemsMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    line_items?: Array<{
      __typename: "OrderLineItems";
      line_item_id: string;
      description?: string | null;
      net_total: any;
      tax?: any | null;
      request?: {
        __typename: "ServiceRequests";
        request_id: string;
        code: string;
        status: RequestStatus;
        priority: RequestPriority;
        intent: RequestIntent;
        category: ServiceRequestCategory;
        occurrence?: any | null;
        created_at: any;
        service: { __typename?: "HealthcareServices"; service_id: string };
        location: { __typename: "Locations"; location_id: string; alias?: string | null; phone?: string | null };
      } | null;
    }> | null;
    diagnosis_codes?: Array<{
      __typename: "ICD10";
      icd10_code: string;
      icd11_code?: string | null;
      label: string;
      description?: string | null;
      type?: DiagnosisType | null;
      hex?: string | null;
    }> | null;
  };
};

export type ManageOrderContactsMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderContactsMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    contacts?: Array<{
      __typename: "ContactDetails";
      contact_detail_id: string;
      name: string;
      purpose?: ContactEntityType | null;
      telecom: Array<{
        __typename: "ContactPoints";
        contact_point_id: string;
        system: ContactPointSystem;
        use: ContactPointUse;
        value: string;
        rank: number;
        created_at: any;
      }>;
    }> | null;
  };
};

export type ManageOrderDiagnosisCodesMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderDiagnosisCodesMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    diagnosis_codes?: Array<{ __typename: "ICD10"; icd10_code: string; label: string }> | null;
  };
};

export type ManageOrderSpecimenMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderSpecimenMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
  };
};

export type ManageOrderProviderMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderProviderMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    signature?: {
      __typename?: "OrderSignatures";
      order_id: string;
      practitioner_id: string;
      signature_id: string;
      name: string;
      practitioner?: { __typename?: "Practitioners"; practitioner_id: string; npi: number } | null;
      signature?: { __typename?: "Signatures"; signature_id: string; signature_format: MimeTypes; signed_by: string; url?: any | null } | null;
    } | null;
  };
};

export type ManageOrderRecurrenceMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderRecurrenceMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    series?: { __typename: "EventSeries"; series_id: string; start_time?: any | null; end_time?: any | null } | null;
  };
};

export type ManageOrderAgentsMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type ManageOrderAgentsMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    agents?: Array<{
      __typename: "OrderAgents";
      agent_id: string;
      name?: string | null;
      active: boolean;
      role: ParticipantRoleType;
      comment?: string | null;
    }> | null;
  };
};

export type RemoveOrderLineItemsMutationVariables = Exact<{
  order: OrderUpdateInput;
}>;

export type RemoveOrderLineItemsMutation = {
  __typename?: "Mutation";
  updateOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    line_items?: Array<{ __typename: "OrderLineItems"; line_item_id: string; description?: string | null; net_total: any; tax?: any | null }> | null;
    diagnosis_codes?: Array<{
      __typename: "ICD10";
      icd10_code: string;
      icd11_code?: string | null;
      label: string;
      description?: string | null;
      type?: DiagnosisType | null;
      hex?: string | null;
    }> | null;
  };
};

export type CancelOrderMutationVariables = Exact<{
  order: OrderDeleteInput;
}>;

export type CancelOrderMutation = { __typename?: "Mutation"; cancelOrder: { __typename?: "RecordsDeleted"; count: number } };

export type CancelOrderBatchMutationVariables = Exact<{
  batch: OrderBulkDeleteInput;
}>;

export type CancelOrderBatchMutation = { __typename?: "Mutation"; cancelOrderBatch: { __typename?: "RecordsDeleted"; count: number } };

export type DeleteOrderMutationVariables = Exact<{
  order: OrderDeleteInput;
}>;

export type DeleteOrderMutation = { __typename?: "Mutation"; deleteOrder: { __typename?: "RecordsDeleted"; count: number } };

export type DeleteOrderBatchMutationVariables = Exact<{
  batch: OrderBulkDeleteInput;
}>;

export type DeleteOrderBatchMutation = { __typename?: "Mutation"; deleteOrderBatch: { __typename?: "RecordsDeleted"; count: number } };

export type ProcessOrderPaymentMutationVariables = Exact<{
  paymentMethod: CheckoutPaymentMethodInput;
  orderId: Scalars["String"]["input"];
}>;

export type ProcessOrderPaymentMutation = { __typename?: "Mutation"; processOrderPayment: PaymentGatewayResultCodes };

export type MergeOrdersMutationVariables = Exact<{
  merge: OrderMergeInput;
}>;

export type MergeOrdersMutation = {
  __typename?: "Mutation";
  mergeOrders: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
  };
};

export type RegisterPractitionerMutationVariables = Exact<{
  registerPayload: PractitionerRegisterInput;
}>;

export type RegisterPractitionerMutation = {
  __typename?: "Mutation";
  registerPractitioner: {
    __typename: "Practitioners";
    practitioner_id: string;
    cynergy_id: string;
    registration_authority_id: string;
    npi: number;
    prefix?: string | null;
    suffix?: string | null;
    created_at: any;
    affiliation_date?: any | null;
    taxonomies: Array<{
      __typename: "Taxonomies";
      taxonomy_id: string;
      license?: string | null;
      code: string;
      primary: boolean;
      description: string;
      group?: string | null;
      state?: string | null;
    }>;
    contacts?: Array<{
      __typename: "ContactPoints";
      contact_point_id: string;
      system: ContactPointSystem;
      use: ContactPointUse;
      value: string;
      rank: number;
      created_at: any;
    }> | null;
    qualifications?: Array<{
      __typename: "PractitionerQualifications";
      qualification_id: string;
      practitioner_id: string;
      credential: DegreeLicenseCertificate;
      label: string;
      license?: string | null;
      speciality?: string | null;
      is_verified: boolean;
      verified_on?: any | null;
      created_at: any;
    }> | null;
    demographics?: {
      __typename: "Demographics";
      cynergy_id: string;
      full_name?: string | null;
      first_name?: string | null;
      last_name?: string | null;
      prefix?: string | null;
      suffix?: string | null;
      middle_name?: string | null;
      age: number;
      deceased: boolean;
      dob?: string | null;
      ethnicity?: string | null;
      marital_status?: MaritalStatus | null;
      sex: string;
      race?: string | null;
    } | null;
  };
};

export type UploadPractitionerSignatureMutationVariables = Exact<{
  signature: UploadPractitionerSignatureInput;
}>;

export type UploadPractitionerSignatureMutation = {
  __typename?: "Mutation";
  uploadPractitionerSignature: {
    __typename: "PractitionerSignatures";
    signature_id: string;
    signature_format: MimeTypes;
    url: string;
    when: any;
    who: { __typename: "Practitioners"; practitioner_id: string; npi: number };
  };
};

export type DeletePractitionerSignatureMutationVariables = Exact<{
  signature: PractitionerSignatureDeleteInput;
}>;

export type DeletePractitionerSignatureMutation = { __typename?: "Mutation"; deletePractitionerSignature: string };

export type DeletePractitionerMutationVariables = Exact<{
  payload: PractitionerDeleteInput;
}>;

export type DeletePractitionerMutation = { __typename?: "Mutation"; deletePractitioner: string };

export type CreateUserProductBundleMutationVariables = Exact<{
  bundle: UserProductBundleCreateInput;
}>;

export type CreateUserProductBundleMutation = {
  __typename?: "Mutation";
  createUserProductBundle: { __typename?: "UserProductBundles"; bundle_id: string };
};

export type UpdateUserProductBundleMutationVariables = Exact<{
  bundle: UserProductBundleUpdateInput;
}>;

export type UpdateUserProductBundleMutation = {
  __typename?: "Mutation";
  updateUserProductBundle: { __typename?: "UserProductBundles"; bundle_id: string };
};

export type ManageUserProductBundleItemsMutationVariables = Exact<{
  items: UserProductBundleItemManageInput;
}>;

export type ManageUserProductBundleItemsMutation = {
  __typename?: "Mutation";
  manageUserProductBundleItems: { __typename?: "UserProductBundles"; bundle_id: string };
};

export type DeleteUserProductBundleMutationVariables = Exact<{
  bundle: UserProductBundleDeleteInput;
}>;

export type DeleteUserProductBundleMutation = { __typename?: "Mutation"; deleteUserProductBundle: { __typename?: "RecordsDeleted"; count: number } };

export type DeleteUserProductBundleBatchMutationVariables = Exact<{
  bundle: UserProductBundleBulkDeleteInput;
}>;

export type DeleteUserProductBundleBatchMutation = {
  __typename?: "Mutation";
  deleteUserProductBundleBatch: { __typename?: "RecordsDeleted"; count: number };
};

export type ManageUserProductBundleSharesMutationVariables = Exact<{
  shares: UserProductBundleShareManageInput;
}>;

export type ManageUserProductBundleSharesMutation = {
  __typename?: "Mutation";
  manageUserProductBundleShares: { __typename?: "UserProductBundles"; bundle_id: string; name: string; is_shared: boolean };
};

export type ShareUserProductBundleWithGroupsMutationVariables = Exact<{
  shares: UserProductBundleGroupShareCreateInput;
}>;

export type ShareUserProductBundleWithGroupsMutation = {
  __typename?: "Mutation";
  shareUserProductBundleWithGroups: { __typename?: "UserProductBundles"; bundle_id: string; is_shared: boolean };
};

export type UserRegisterMutationVariables = Exact<{
  registerPayload: RegisterUserInput;
}>;

export type UserRegisterMutation = {
  __typename?: "Mutation";
  userRegister: { __typename?: "CynergyUsers"; cynergy_id: string; email?: string | null; phone?: string | null };
};

export type OrgRegisterMutationVariables = Exact<{
  registerPayload: RegisterUserInput;
}>;

export type OrgRegisterMutation = {
  __typename?: "Mutation";
  userRegister: { __typename?: "CynergyUsers"; cynergy_id: string; email?: string | null; phone?: string | null };
};

export type SendoutRequisitionEmailsMutationVariables = Exact<{ [key: string]: never }>;

export type SendoutRequisitionEmailsMutation = {
  __typename?: "Mutation";
  sendoutRequisitionEmails: { __typename?: "RequisitionEmailSendoutResponse"; message: string; status: number };
};

export type CreateRecurrencePatternMutationVariables = Exact<{
  pattern: RecurrencePatternCreateInput;
}>;

export type CreateRecurrencePatternMutation = {
  __typename?: "Mutation";
  createRecurrencePattern: {
    __typename: "RecurrencePatterns";
    pattern_id: string;
    start_date: any;
    end_date?: string | null;
    description?: string | null;
    timezone?: any | null;
    text?: string | null;
  };
};

export type CreateTaskMutationVariables = Exact<{
  payload: TaskCreateInput;
}>;

export type CreateTaskMutation = {
  __typename?: "Mutation";
  createTask: {
    __typename: "Tasks";
    task_id: string;
    notification_id?: string | null;
    title: string;
    description: string;
    status: TaskStatus;
    business_status: string;
    status_reason?: TaskStatusReason | null;
    label: TaskLabels;
    progress: number;
    code: TaskCode;
    reason: string;
    url?: string | null;
    link?: string | null;
    priority: RequestPriority;
    do_not_perform: boolean;
    assignee_function: ActionParticipantFunction;
    assignee_role: string;
    last_modified?: any | null;
    started_at?: any | null;
    completed_at?: any | null;
    created_at: any;
  };
};

export type DeleteTaskMutationVariables = Exact<{
  payload: TaskDeleteInput;
}>;

export type DeleteTaskMutation = { __typename?: "Mutation"; deleteTask: { __typename?: "RecordsDeleted"; count: number } };

export type UpdateTaskMutationVariables = Exact<{
  payload: TaskUpdateInput;
}>;

export type UpdateTaskMutation = {
  __typename?: "Mutation";
  updateTask: {
    __typename: "Tasks";
    task_id: string;
    notification_id?: string | null;
    title: string;
    description: string;
    status: TaskStatus;
    business_status: string;
    status_reason?: TaskStatusReason | null;
    label: TaskLabels;
    progress: number;
    code: TaskCode;
    reason: string;
    url?: string | null;
    link?: string | null;
    priority: RequestPriority;
    do_not_perform: boolean;
    assignee_function: ActionParticipantFunction;
    assignee_role: string;
    last_modified?: any | null;
    started_at?: any | null;
    completed_at?: any | null;
    created_at: any;
    assignee:
      | { __typename?: "Organizations" }
      | { __typename?: "Patients" }
      | { __typename?: "Practitioners" }
      | {
          __typename: "StaffAssignments";
          assignment_id: string;
          staff_id: string;
          location_id: string;
          organization_id: string;
          status: EmploymentStatus;
          title: string;
          hire_date: any;
        };
  };
};

export type UpdateTaskStepMutationVariables = Exact<{
  payload: TaskStepUpdateInput;
}>;

export type UpdateTaskStepMutation = {
  __typename?: "Mutation";
  updateTaskStep: {
    __typename: "TaskSteps";
    step_id: string;
    label: string;
    description: string;
    status: TaskStatus;
    order: number;
    required: boolean;
    progress: number;
    link?: string | null;
    url?: string | null;
    status_reason?: TaskStatusReason | null;
    started_at?: any | null;
    task: {
      __typename: "Tasks";
      task_id: string;
      notification_id?: string | null;
      title: string;
      description: string;
      status: TaskStatus;
      business_status: string;
      status_reason?: TaskStatusReason | null;
      label: TaskLabels;
      progress: number;
      code: TaskCode;
      reason: string;
      url?: string | null;
      link?: string | null;
      priority: RequestPriority;
      do_not_perform: boolean;
      assignee_function: ActionParticipantFunction;
      assignee_role: string;
      last_modified?: any | null;
      started_at?: any | null;
      completed_at?: any | null;
      created_at: any;
    };
  };
};

export type GetTwoFactorProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetTwoFactorProfileQuery = {
  __typename?: "Query";
  getTwoFactorProfile: {
    __typename: "TwoFactorAuthentication";
    two_factor_id: string;
    cynergy_id: string;
    enabled: boolean;
    method?: TwoFactorMethods | null;
    sms_number?: string | null;
    sms_verified: boolean;
    factor?:
      | { __typename: "TwoFactorPush"; two_factor_id: string }
      | { __typename: "TwoFactorTotp"; two_factor_id: string; qr_uri: string; secret: string }
      | null;
  };
};

export type GetAllCynergyUsersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllCynergyUsersQuery = {
  __typename?: "Query";
  getAllCynergyUsers: Array<{
    __typename: "CynergyUsers";
    cynergy_id: string;
    email?: string | null;
    phone?: string | null;
    username: string;
    validated: boolean;
    is_default?: boolean | null;
    created_at: any;
    updated_at?: any | null;
    demographics?: {
      __typename: "Demographics";
      cynergy_id: string;
      full_name?: string | null;
      first_name?: string | null;
      last_name?: string | null;
      prefix?: string | null;
      suffix?: string | null;
      middle_name?: string | null;
      age: number;
      deceased: boolean;
      dob?: string | null;
      ethnicity?: string | null;
      marital_status?: MaritalStatus | null;
      sex: string;
      race?: string | null;
    } | null;
  }>;
};

export type GetPaginatedCynergyUsersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedCynergyUsersQuery = {
  __typename?: "Query";
  getPaginatedCynergyUsers: {
    __typename?: "PaginatedCynergyUsersResponse";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<
      | {
          __typename: "CynergyUsers";
          cynergy_id: string;
          email?: string | null;
          phone?: string | null;
          username: string;
          validated: boolean;
          is_default?: boolean | null;
          created_at: any;
          updated_at?: any | null;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            sex: string;
            race?: string | null;
          } | null;
        }
      | { __typename?: "Demographics" }
    >;
  };
};

export type GetUserAccountQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  userType?: InputMaybe<UserTypes>;
}>;

export type GetUserAccountQuery = {
  __typename?: "Query";
  getUserAccount:
    | { __typename?: "Admins" }
    | { __typename?: "Dependents" }
    | { __typename?: "Groups" }
    | { __typename?: "Organizations" }
    | { __typename?: "Patients" }
    | { __typename?: "StaffAssignments" }
    | { __typename?: "Staffs" }
    | {
        __typename: "Users";
        cynergy_id: string;
        user_id: string;
        username: string;
        first_login: boolean;
        addresses?: Array<{
          __typename: "WebCynergyAddresses";
          address_id: string;
          city: string;
          state: string;
          zip: string;
          address_line_1: string;
          address_line_2?: string | null;
          nickname?: string | null;
          formatted_address?: string | null;
          type: string;
          longitude?: number | null;
          latitude?: number | null;
          is_default: boolean;
          place_id?: string | null;
        }> | null;
        contacts?: Array<{
          __typename: "Contacts";
          contact_id: string;
          first_name: string;
          last_name: string;
          nickname: string;
          email?: string | null;
          phone?: string | null;
          authorized_access: string;
          contact_type: PatientContactCodes;
          contact_relation_type: RelatedPersonTypes;
        }> | null;
        identity?: {
          __typename: "CynergyUsers";
          cynergy_id: string;
          email?: string | null;
          phone?: string | null;
          username: string;
          validated: boolean;
          is_default?: boolean | null;
          created_at: any;
          updated_at?: any | null;
        } | null;
        actor?:
          | { __typename?: "Admins" }
          | { __typename?: "Organizations" }
          | {
              __typename?: "Patients";
              dependents?: Array<{
                __typename: "Patients";
                patient_id: string;
                primary_provider?: { __typename?: "Practitioners"; practitioner_id: string } | null;
              }> | null;
            }
          | { __typename?: "Staffs" }
          | null;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          sex: string;
          race?: string | null;
        } | null;
      };
};

export type GetPatientQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetPatientQuery = {
  __typename?: "Query";
  getPatient: {
    __typename: "Patients";
    patient_id: string;
    user: {
      __typename: "Users";
      user_id: string;
      cynergy_id: string;
      username: string;
      first_login: boolean;
      identity?: {
        __typename: "CynergyUsers";
        cynergy_id: string;
        email?: string | null;
        phone?: string | null;
        username: string;
        validated: boolean;
        is_default?: boolean | null;
        created_at: any;
        updated_at?: any | null;
      } | null;
      demographics?: {
        __typename: "Demographics";
        cynergy_id: string;
        full_name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
        prefix?: string | null;
        suffix?: string | null;
        middle_name?: string | null;
        age: number;
        deceased: boolean;
        dob?: string | null;
        ethnicity?: string | null;
        sex: string;
        race?: string | null;
      } | null;
    };
    dependents?: Array<{
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        cynergy_id: string;
        username: string;
        first_login: boolean;
        identity?: {
          __typename: "CynergyUsers";
          cynergy_id: string;
          email?: string | null;
          phone?: string | null;
          username: string;
          validated: boolean;
          is_default?: boolean | null;
          created_at: any;
          updated_at?: any | null;
        } | null;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    }> | null;
  };
};

export type GetPatientDetailsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetPatientDetailsQuery = {
  __typename?: "Query";
  getPatient: {
    __typename: "Patients";
    patient_id: string;
    user: {
      __typename: "Users";
      user_id: string;
      demographics?: {
        __typename: "Demographics";
        cynergy_id: string;
        full_name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
        prefix?: string | null;
        suffix?: string | null;
        middle_name?: string | null;
        age: number;
        deceased: boolean;
        dob?: string | null;
        ethnicity?: string | null;
        marital_status?: MaritalStatus | null;
        sex: string;
        race?: string | null;
      } | null;
    };
    primary_provider?: {
      __typename: "Practitioners";
      practitioner_id: string;
      demographics?: {
        __typename: "Demographics";
        cynergy_id: string;
        full_name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
        prefix?: string | null;
        suffix?: string | null;
        middle_name?: string | null;
        age: number;
        deceased: boolean;
        dob?: string | null;
        ethnicity?: string | null;
        marital_status?: MaritalStatus | null;
        sex: string;
        race?: string | null;
      } | null;
    } | null;
  };
};

export type GetPatientDemographicsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPatientDemographicsQuery = {
  __typename?: "Query";
  getPatient: {
    __typename: "Patients";
    patient_id: string;
    user: {
      __typename: "Users";
      user_id: string;
      demographics?: {
        __typename: "Demographics";
        cynergy_id: string;
        full_name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
        prefix?: string | null;
        suffix?: string | null;
        middle_name?: string | null;
        age: number;
        deceased: boolean;
        dob?: string | null;
        ethnicity?: string | null;
        marital_status?: MaritalStatus | null;
        sex: string;
        race?: string | null;
      } | null;
    };
  };
};

export type GetPatientSubscriberQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetPatientSubscriberQuery = {
  __typename?: "Query";
  getPatient: {
    __typename: "Patients";
    patient_id: string;
    user: {
      __typename: "Users";
      user_id: string;
      demographics?: { __typename: "Demographics"; first_name?: string | null; last_name?: string | null; dob?: string | null } | null;
      addresses?: Array<{
        __typename: "WebCynergyAddresses";
        address_id: string;
        address_line_1: string;
        address_line_2?: string | null;
        city: string;
        state: string;
        zip: string;
        is_default: boolean;
      }> | null;
    };
  };
};

export type GetAppointmentSlotsQueryVariables = Exact<{
  resource: AppointmentResourceAvailability;
  horizon?: InputMaybe<AppointmentAvailabilityHorizon>;
}>;

export type GetAppointmentSlotsQuery = {
  __typename?: "Query";
  getAppointmentSlots: Array<{ __typename?: "Slots"; slot_id: string; service_type: string; start: any; end: any; status: SlotStatus }>;
};

export type GetAppointmentDetailsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAppointmentDetailsQuery = {
  __typename?: "Query";
  getAppointment: {
    __typename: "Appointments";
    appointment_id: string;
    patient_id: string;
    title: string;
    patient_name: string;
    subject?: string | null;
    type: AppointmentType;
    category: ServiceRequestCategory;
    scheduled_start?: any | null;
    scheduled_end?: any | null;
    status: AppointmentStatus;
    description?: string | null;
    service_types: Array<{ __typename: "AppointmentServiceTypes"; service_id: string; type_id: string; name: string }>;
    order?: {
      __typename?: "Orders";
      order_id: string;
      balance?: any | null;
      line_items?: Array<{
        __typename?: "OrderLineItems";
        line_item_id: string;
        net_total: any;
        request?: { __typename?: "ServiceRequests"; request_id: string; service_id: string; code: string } | null;
      }> | null;
      requisition?: {
        __typename?: "DocumentReferences";
        reference_id: string;
        content: {
          __typename?: "Attachments";
          attachment_id: string;
          title: string;
          url?: string | null;
          size?: number | null;
          content_type: MimeTypes;
        };
      } | null;
    } | null;
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      phone?: string | null;
      address: {
        __typename?: "WebCynergyAddresses";
        address_id: string;
        address_line_1: string;
        address_line_2?: string | null;
        city: string;
        state: string;
        zip: string;
      };
    };
    patient_instruction?: {
      __typename?: "CodeableReferences";
      reference_id: string;
      concept?: { __typename?: "CodeableConcepts"; concept_id: string; text: string } | null;
    } | null;
  };
};

export type GetPaginatedAppointmentsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedAppointmentsQuery = {
  __typename?: "Query";
  getPaginatedAppointments: {
    __typename?: "AppointmentPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "Appointments";
      appointment_id: string;
      patient_id: string;
      title: string;
      patient_name: string;
      subject?: string | null;
      type: AppointmentType;
      category: ServiceRequestCategory;
      scheduled_start?: any | null;
      scheduled_end?: any | null;
      status: AppointmentStatus;
      description?: string | null;
      patient: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
      service_types: Array<{ __typename: "AppointmentServiceTypes"; service_id: string; type_id: string; name: string }>;
      order?: { __typename?: "Orders"; order_id: string; balance?: any | null } | null;
      location: {
        __typename?: "Locations";
        location_id: string;
        alias?: string | null;
        name: string;
        phone?: string | null;
        address: {
          __typename?: "WebCynergyAddresses";
          address_id: string;
          address_line_1: string;
          address_line_2?: string | null;
          city: string;
          state: string;
          zip: string;
        };
      };
    }>;
  };
};

export type AppointmentsFeedQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type AppointmentsFeedQuery = {
  __typename?: "Query";
  appointmentList: {
    __typename?: "AppointmentPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "Appointments";
      appointment_id: string;
      patient_id: string;
      title: string;
      patient_name: string;
      subject?: string | null;
      type: AppointmentType;
      category: ServiceRequestCategory;
      scheduled_start?: any | null;
      scheduled_end?: any | null;
      status: AppointmentStatus;
      description?: string | null;
      service_types: Array<{ __typename: "AppointmentServiceTypes"; service_id: string; type_id: string; name: string }>;
    }>;
  };
};

export type CartQueryVariables = Exact<{ [key: string]: never }>;

export type CartQuery = {
  __typename?: "Query";
  cart: {
    __typename?: "WebCarts";
    id: string;
    cart_holder: string;
    expiresAt?: any | null;
    items: Array<{
      __typename?: "WebCartItems";
      id: string;
      cart_id: string;
      productCode: string;
      name: string;
      price: any;
      tax?: any | null;
      product: { __typename?: "Products"; code: string; description?: string | null; family: CommerceProductFamily };
      store: { __typename?: "WebStores"; code: string; location: { __typename?: "Locations"; location_id: string; alias?: string | null } };
      thumbnail?: { __typename?: "WebCartItemThumbNails"; url: string } | null;
    }>;
    booking_requests?: Array<{
      __typename?: "WebCartBookingRequests";
      id: string;
      cart_id: string;
      items: Array<{ __typename?: "WebCartItems"; id: string; price: any; name: string }>;
      location?: {
        __typename?: "Locations";
        location_id: string;
        alias?: string | null;
        address: { __typename?: "WebCynergyAddresses"; address_id: string; formatted_address?: string | null };
      } | null;
      slot?: { __typename?: "Slots"; slot_id: string; start: any; end: any } | null;
    }> | null;
    summary?: {
      __typename?: "WebCartSummaries";
      cart_id: string;
      total: any;
      subtotal: any;
      tax: any;
      surcharge?: any | null;
      item_count: number;
    } | null;
  };
};

export type GetCarePlanQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetCarePlanQuery = {
  __typename?: "Query";
  getCarePlan: {
    __typename: "CarePlans";
    care_plan_id: string;
    title: string;
    description: string;
    status: ServiceRequestStatus;
    category: string;
    created_at: any;
    subject:
      | { __typename?: "Groups" }
      | { __typename: "Patients"; patient_id: string; user: { __typename: "Users"; cynergy_id: string; user_id: string; username: string } };
    addresses?: Array<{ __typename: "Conditions"; condition_id: string }> | null;
    care_team?: {
      __typename: "CareTeams";
      care_team_id: string;
      name: string;
      status: CareTeamStatus;
      category: CareTeamCategory;
      created_at: any;
    } | null;
    diagnosis?: {
      __typename: "ICD10";
      icd10_code: string;
      icd11_code?: string | null;
      label: string;
      description?: string | null;
      type?: DiagnosisType | null;
      hex?: string | null;
    } | null;
    period?: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null } | null;
  };
};

export type GetCareTeamQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetCareTeamQuery = {
  __typename?: "Query";
  getCareTeam: {
    __typename: "CareTeams";
    care_team_id: string;
    name: string;
    status: CareTeamStatus;
    category: CareTeamCategory;
    created_at: any;
    subject: { __typename?: "Groups" } | { __typename: "Patients"; patient_id: string };
    contact: {
      __typename: "Contacts";
      contact_id: string;
      first_name: string;
      last_name: string;
      nickname: string;
      email?: string | null;
      phone?: string | null;
      authorized_access: string;
      contact_type: PatientContactCodes;
      contact_relation_type: RelatedPersonTypes;
    };
    managing_organization?: { __typename: "Organizations"; organization_id: string; organization_type: OrganizationTypes; alias: string } | null;
    members?: Array<{ __typename: "CareTeamMembers"; member_id: string; role: ParticipantRole; name: string; created_at: any }> | null;
  };
};

export type GetPatientConditionQueryVariables = Exact<{ [key: string]: never }>;

export type GetPatientConditionQuery = {
  __typename?: "Query";
  getPatientCondition: {
    __typename: "Conditions";
    condition_id: string;
    category: ConditionCategoryCodes;
    body_site?: string | null;
    verification_status: ConditionVerificationStatus;
    clinical_status: ConditionClinicalStatus;
    severity: ConditionSeverityCodes;
    note?: string | null;
    recorded_date?: any | null;
    abatement_date_string?: string | null;
    abatement_date_time?: any | null;
    onset_date_string?: string | null;
    onset_date_time?: any | null;
    classification: {
      __typename: "ICD10";
      icd10_code: string;
      icd11_code?: string | null;
      label: string;
      description?: string | null;
      type?: DiagnosisType | null;
      hex?: string | null;
    };
    treatment_plan?: {
      __typename: "CarePlans";
      care_plan_id: string;
      title: string;
      description: string;
      status: ServiceRequestStatus;
      category: string;
      created_at: any;
    } | null;
    assessments?: Array<{
      __typename: "ClinicalImpressions";
      impression_id: string;
      status: EventStatuses;
      description?: string | null;
      summary: string;
      change_pattern: ImpressionChangePatternCodes;
      numeric_rating: number;
      protocol?: string | null;
      assessment_date_time: any;
      status_reason?: string | null;
      created_at: any;
    }> | null;
  };
};

export type GetAllCarePlansQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllCarePlansQuery = {
  __typename?: "Query";
  getAllCarePlans: Array<{
    __typename: "CarePlans";
    care_plan_id: string;
    title: string;
    description: string;
    status: ServiceRequestStatus;
    category: string;
    created_at: any;
    addresses?: Array<{
      __typename: "Conditions";
      condition_id: string;
      category: ConditionCategoryCodes;
      body_site?: string | null;
      verification_status: ConditionVerificationStatus;
      clinical_status: ConditionClinicalStatus;
      severity: ConditionSeverityCodes;
      note?: string | null;
      recorded_date?: any | null;
      abatement_date_string?: string | null;
      abatement_date_time?: any | null;
      onset_date_string?: string | null;
      onset_date_time?: any | null;
    }> | null;
  }>;
};

export type GetPaginatedCarePlansQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedCarePlansQuery = {
  __typename?: "Query";
  getPaginatedCarePlans: {
    __typename?: "CarePlanPaginatedResponse";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "CarePlans";
      care_plan_id: string;
      title: string;
      description: string;
      status: ServiceRequestStatus;
      category: string;
      created_at: any;
      subject:
        | { __typename?: "Groups" }
        | {
            __typename: "Patients";
            patient_id: string;
            user: {
              __typename: "Users";
              cynergy_id: string;
              user_id: string;
              demographics?: {
                __typename: "Demographics";
                cynergy_id: string;
                full_name?: string | null;
                first_name?: string | null;
                last_name?: string | null;
                prefix?: string | null;
                suffix?: string | null;
                middle_name?: string | null;
                age: number;
                deceased: boolean;
                dob?: string | null;
                ethnicity?: string | null;
                marital_status?: MaritalStatus | null;
                sex: string;
                race?: string | null;
              } | null;
            };
          };
      addresses?: Array<{
        __typename: "Conditions";
        condition_id: string;
        category: ConditionCategoryCodes;
        body_site?: string | null;
        verification_status: ConditionVerificationStatus;
        clinical_status: ConditionClinicalStatus;
        severity: ConditionSeverityCodes;
        note?: string | null;
        recorded_date?: any | null;
        abatement_date_string?: string | null;
        abatement_date_time?: any | null;
        onset_date_string?: string | null;
        onset_date_time?: any | null;
      }> | null;
      care_team?: {
        __typename: "CareTeams";
        care_team_id: string;
        name: string;
        status: CareTeamStatus;
        category: CareTeamCategory;
        created_at: any;
        members?: Array<{ __typename: "CareTeamMembers"; member_id: string; role: ParticipantRole; name: string; created_at: any }> | null;
      } | null;
      period?: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null } | null;
    }>;
  };
};

export type GetAllPatientConditionsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetAllPatientConditionsQuery = {
  __typename?: "Query";
  getAllPatientConditions: Array<{
    __typename: "Conditions";
    condition_id: string;
    category: ConditionCategoryCodes;
    body_site?: string | null;
    verification_status: ConditionVerificationStatus;
    clinical_status: ConditionClinicalStatus;
    severity: ConditionSeverityCodes;
    note?: string | null;
    recorded_date?: any | null;
    abatement_date_string?: string | null;
    abatement_date_time?: any | null;
    onset_date_string?: string | null;
    onset_date_time?: any | null;
    classification: {
      __typename: "ICD10";
      icd10_code: string;
      icd11_code?: string | null;
      label: string;
      description?: string | null;
      type?: DiagnosisType | null;
      hex?: string | null;
    };
    assessments?: Array<{
      __typename: "ClinicalImpressions";
      impression_id: string;
      status: EventStatuses;
      description?: string | null;
      summary: string;
      change_pattern: ImpressionChangePatternCodes;
      numeric_rating: number;
      protocol?: string | null;
      assessment_date_time: any;
      status_reason?: string | null;
      created_at: any;
    }> | null;
    treatment_medications?: Array<{ __typename: "MedicationUsages"; usage_id: string }> | null;
  }>;
};

export type GetAllConditionAssessmentsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllConditionAssessmentsQuery = {
  __typename?: "Query";
  getAllConditionAssessments: Array<{
    __typename: "ClinicalImpressions";
    impression_id: string;
    status: EventStatuses;
    description?: string | null;
    summary: string;
    change_pattern: ImpressionChangePatternCodes;
    numeric_rating: number;
    protocol?: string | null;
    assessment_date_time: any;
    status_reason?: string | null;
    created_at: any;
    problem: {
      __typename: "Conditions";
      condition_id: string;
      category: ConditionCategoryCodes;
      body_site?: string | null;
      verification_status: ConditionVerificationStatus;
      clinical_status: ConditionClinicalStatus;
      severity: ConditionSeverityCodes;
      note?: string | null;
      recorded_date?: any | null;
      abatement_date_string?: string | null;
      abatement_date_time?: any | null;
      onset_date_string?: string | null;
      onset_date_time?: any | null;
    };
    subject: {
      __typename?: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        cynergy_id: string;
        user_id: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
  }>;
};

export type GetAllClinicalNotesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllClinicalNotesQuery = {
  __typename?: "Query";
  getAllClinicalNotes: Array<{
    __typename: "ClinicalNotes";
    note_id: string;
    subject: string;
    text: string;
    created_at: any;
    authored: any;
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      description?: string | null;
      phone?: string | null;
      preferred_member: boolean;
      organization_id: string;
      todays_operating_hours: string;
      open_now: boolean;
      location_role: string;
      location_status: string;
      meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
    };
    author: {
      __typename: "StaffAssignments";
      assignment_id: string;
      staff_id: string;
      location_id: string;
      organization_id: string;
      status: EmploymentStatus;
      title: string;
      hire_date: any;
      employee: {
        __typename: "Staffs";
        staff_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          cynergy_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    };
    patient: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        cynergy_id: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
  }>;
};

export type GetClinicalNoteQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetClinicalNoteQuery = {
  __typename?: "Query";
  getClinicalNote: {
    __typename: "ClinicalNotes";
    note_id: string;
    subject: string;
    text: string;
    created_at: any;
    authored: any;
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      description?: string | null;
      phone?: string | null;
      preferred_member: boolean;
      organization_id: string;
      todays_operating_hours: string;
      open_now: boolean;
      location_role: string;
      location_status: string;
      meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
    };
    author: {
      __typename: "StaffAssignments";
      assignment_id: string;
      staff_id: string;
      location_id: string;
      organization_id: string;
      status: EmploymentStatus;
      title: string;
      hire_date: any;
      employee: {
        __typename: "Staffs";
        staff_id: string;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    };
    patient: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        cynergy_id: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
  };
};

export type GetPaginatedConditionAssessmentsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedConditionAssessmentsQuery = {
  __typename?: "Query";
  getPaginatedConditionAssessments: {
    __typename?: "ConditionAssessmentsPaginatedResponse";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "ClinicalImpressions";
      impression_id: string;
      status: EventStatuses;
      description?: string | null;
      summary: string;
      change_pattern: ImpressionChangePatternCodes;
      numeric_rating: number;
      protocol?: string | null;
      assessment_date_time: any;
      status_reason?: string | null;
      created_at: any;
      problem: {
        __typename: "Conditions";
        condition_id: string;
        category: ConditionCategoryCodes;
        body_site?: string | null;
        verification_status: ConditionVerificationStatus;
        clinical_status: ConditionClinicalStatus;
        severity: ConditionSeverityCodes;
        note?: string | null;
        recorded_date?: any | null;
        abatement_date_string?: string | null;
        abatement_date_time?: any | null;
        onset_date_string?: string | null;
        onset_date_time?: any | null;
        classification: {
          __typename: "ICD10";
          icd10_code: string;
          icd11_code?: string | null;
          label: string;
          description?: string | null;
          type?: DiagnosisType | null;
          hex?: string | null;
        };
      };
      subject: {
        __typename?: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type CoverageCoreFragmentFragment = {
  __typename: "Coverages";
  coverage_id: string;
  patient_id: string;
  organization_id: string;
  payor_name: string;
  payor_external_id?: string | null;
  policy_number: string;
  plan_type?: string | null;
  coverage_order: number;
  kind: FhirCoverageKind;
  status: FhirCoverageStatus;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
  subscriber_dob?: any | null;
  subscriber_relationship_to_patient?: string | null;
  is_archived: boolean;
  deleted_at?: any | null;
  created_at: any;
  updated_at?: any | null;
};

export type GetPatientCoveragesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPatientCoveragesQuery = {
  __typename?: "Query";
  getPaginatedCoverages: {
    __typename?: "CoveragePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "Coverages";
      coverage_id: string;
      patient_id: string;
      organization_id: string;
      payor_name: string;
      payor_external_id?: string | null;
      policy_number: string;
      plan_type?: string | null;
      coverage_order: number;
      kind: FhirCoverageKind;
      status: FhirCoverageStatus;
      subscriber_first_name?: string | null;
      subscriber_last_name?: string | null;
      subscriber_dob?: any | null;
      subscriber_relationship_to_patient?: string | null;
      is_archived: boolean;
      deleted_at?: any | null;
      created_at: any;
      updated_at?: any | null;
    }>;
  };
};

export type GetCoverageQueryVariables = Exact<{
  coverageId: Scalars["String"]["input"];
}>;

export type GetCoverageQuery = {
  __typename?: "Query";
  getCoverage: {
    __typename: "Coverages";
    coverage_id: string;
    patient_id: string;
    organization_id: string;
    payor_name: string;
    payor_external_id?: string | null;
    policy_number: string;
    plan_type?: string | null;
    coverage_order: number;
    kind: FhirCoverageKind;
    status: FhirCoverageStatus;
    subscriber_first_name?: string | null;
    subscriber_last_name?: string | null;
    subscriber_dob?: any | null;
    subscriber_relationship_to_patient?: string | null;
    is_archived: boolean;
    deleted_at?: any | null;
    created_at: any;
    updated_at?: any | null;
  };
};

export type GetOrgPayorsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrgPayorsQuery = {
  __typename?: "Query";
  getPaginatedCoverages: {
    __typename?: "CoveragePaginatedResults";
    count: number;
    rows: Array<{ __typename?: "Coverages"; coverage_id: string; payor_name: string }>;
  };
};

export type GetCoverageAuditsQueryVariables = Exact<{
  coverageId: Scalars["String"]["input"];
}>;

export type GetCoverageAuditsQuery = {
  __typename?: "Query";
  getCoverageAudits: Array<{
    __typename?: "CoverageAudits";
    audit_id: string;
    type: CoverageEventType;
    reason?: string | null;
    created_at: any;
    created_by: string;
  }>;
};

export type GetSymptomAssessmentQueryVariables = Exact<{
  patientId: Scalars["String"]["input"];
}>;

export type GetSymptomAssessmentQuery = {
  __typename?: "Query";
  getSymptomAssessment: {
    __typename?: "SymptomAssessmentResults";
    id: string;
    assessedOn: string;
    results: Array<{
      __typename?: "SymptomAssessment";
      statement: string;
      confidence: number;
      indicators: Array<{ __typename: "Indicator"; icd10Code: string; label: string }>;
      item: {
        __typename: "CriteriaItems";
        item_id: string;
        link_id: string;
        syndrome: string;
        criteria: {
          __typename: "Criteria";
          criteria_number: number;
          title: string;
          publisher: string;
          reference_url?: string | null;
          citations?: Array<string> | null;
        };
        icd10: { __typename: "ICD10"; icd10_code: string; label: string; description?: string | null; hex?: string | null };
      };
    }>;
  };
};

export type GetAllCriteriaFormResultsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllCriteriaFormResultsQuery = {
  __typename?: "Query";
  getAllCriteriaFormResults: Array<{
    __typename?: "CriteriaFormResults";
    result_id: string;
    passed: boolean;
    criteria: { __typename?: "CriteriaDefinitions"; title: string; slug: string; publisher: string };
    flagged_by?: Array<{ __typename?: "CriteriaFormResultFlags"; flag_id: string; syndrome: string }> | null;
  }>;
};

export type GetCriteriaFormResultQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetCriteriaFormResultQuery = {
  __typename?: "Query";
  getCriteriaFormResult: {
    __typename: "CriteriaFormResults";
    result_id: string;
    passed: boolean;
    created_by: string;
    created_at: any;
    flagged_by?: Array<{
      __typename: "CriteriaFormResultFlags";
      flag_id: string;
      syndrome: string;
      created_at: any;
      flags: Array<{
        __typename: "CriteriaFormResultFlagItems";
        label: string;
        icd10_codes: Array<string>;
        applies_to: Array<string>;
        created_at: any;
      }>;
      diagnoses: Array<{
        __typename: "ICD10";
        icd10_code: string;
        label: string;
        description?: string | null;
        hex?: string | null;
        note?: string | null;
        type?: DiagnosisType | null;
        created_at: any;
      }>;
    }> | null;
    criteria: {
      __typename: "CriteriaDefinitions";
      definition_id: string;
      slug: string;
      title: string;
      description: string;
      publisher: string;
      url?: string | null;
      created_by: string;
      created_at: any;
    };
    prescriptions?: Array<{ __typename: "MedicationUsages"; usage_id: string }> | null;
    patient: {
      __typename?: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        cynergy_id: string;
        user_id: string;
        username: string;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
    };
    performer?:
      | {
          __typename: "Practitioners";
          practitioner_id: string;
          cynergy_id: string;
          registration_authority_id: string;
          npi: number;
          prefix?: string | null;
          suffix?: string | null;
          created_at: any;
          affiliation_date?: any | null;
          demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
        }
      | {
          __typename: "StaffAssignments";
          assignment_id: string;
          staff_id: string;
          location_id: string;
          organization_id: string;
          status: EmploymentStatus;
          title: string;
          hire_date: any;
          employee: {
            __typename: "Staffs";
            staff_id: string;
            user: {
              __typename: "Users";
              cynergy_id: string;
              user_id: string;
              demographics?: {
                __typename: "Demographics";
                cynergy_id: string;
                full_name?: string | null;
                first_name?: string | null;
                last_name?: string | null;
                prefix?: string | null;
                suffix?: string | null;
                middle_name?: string | null;
                age: number;
                deceased: boolean;
                dob?: string | null;
                ethnicity?: string | null;
                marital_status?: MaritalStatus | null;
                sex: string;
                race?: string | null;
              } | null;
            };
          };
        }
      | null;
    note?: { __typename: "Annotations"; annotation_id: string; text: string; created_by: string; created_at: any } | null;
  };
};

export type GetPaginatedCriteriaFormResultsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedCriteriaFormResultsQuery = {
  __typename?: "Query";
  getPaginatedCriteriaFormResults: {
    __typename?: "CriteriaFormPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "CriteriaFormResults";
      result_id: string;
      passed: boolean;
      created_by: string;
      created_at: any;
      prescriptions?: Array<{
        __typename: "MedicationUsages";
        usage_id: string;
        status: MedicationUsageStatus;
        medication: { __typename: "Medications"; medication_id: string; brand_name: string };
      }> | null;
      flagged_by?: Array<{
        __typename: "CriteriaFormResultFlags";
        flag_id: string;
        syndrome: string;
        created_at: any;
        flags: Array<{
          __typename: "CriteriaFormResultFlagItems";
          label: string;
          icd10_codes: Array<string>;
          applies_to: Array<string>;
          created_at: any;
        }>;
        diagnoses: Array<{
          __typename: "ICD10";
          icd10_code: string;
          label: string;
          description?: string | null;
          hex?: string | null;
          note?: string | null;
          type?: DiagnosisType | null;
          created_at: any;
        }>;
      }> | null;
      criteria: {
        __typename: "CriteriaDefinitions";
        definition_id: string;
        slug: string;
        title: string;
        description: string;
        publisher: string;
        url?: string | null;
        created_by: string;
        created_at: any;
      };
      patient: {
        __typename?: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          username: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
      performer?:
        | {
            __typename: "Practitioners";
            practitioner_id: string;
            cynergy_id: string;
            registration_authority_id: string;
            npi: number;
            prefix?: string | null;
            suffix?: string | null;
            created_at: any;
            affiliation_date?: any | null;
            demographics?: {
              __typename: "Demographics";
              cynergy_id: string;
              full_name?: string | null;
              first_name?: string | null;
              last_name?: string | null;
              prefix?: string | null;
              suffix?: string | null;
              middle_name?: string | null;
              age: number;
              deceased: boolean;
              dob?: string | null;
              ethnicity?: string | null;
              marital_status?: MaritalStatus | null;
              sex: string;
              race?: string | null;
            } | null;
          }
        | {
            __typename: "StaffAssignments";
            assignment_id: string;
            staff_id: string;
            location_id: string;
            organization_id: string;
            status: EmploymentStatus;
            title: string;
            hire_date: any;
            employee: {
              __typename: "Staffs";
              staff_id: string;
              user: {
                __typename: "Users";
                cynergy_id: string;
                user_id: string;
                demographics?: {
                  __typename: "Demographics";
                  cynergy_id: string;
                  full_name?: string | null;
                  first_name?: string | null;
                  last_name?: string | null;
                  prefix?: string | null;
                  suffix?: string | null;
                  middle_name?: string | null;
                  age: number;
                  deceased: boolean;
                  dob?: string | null;
                  ethnicity?: string | null;
                  marital_status?: MaritalStatus | null;
                  sex: string;
                  race?: string | null;
                } | null;
              };
            };
          }
        | null;
    }>;
  };
};

export type LabObservationStatsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type LabObservationStatsQuery = {
  __typename?: "Query";
  labObservationStats: Array<{ __typename?: "LabObservationStats"; code: string; count: number; target_type: ObservationTargetType }>;
};

export type GetPaginatedLabObservationsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetPaginatedLabObservationsQuery = {
  __typename?: "Query";
  getPaginatedLabObservations: {
    __typename?: "ObservationPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "Observations";
      observation_id: string;
      code: string;
      category: ObservationCategory;
      status: ObservationStatus;
      method?: string | null;
      target_type?: ObservationTargetType | null;
      interpretation: ObservationInterpretation;
      created_at: any;
      patient: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
      members?: Array<{
        __typename: "Observations";
        observation_id: string;
        code: string;
        target_type?: ObservationTargetType | null;
        interpretation: ObservationInterpretation;
        created_at: any;
      }> | null;
      based_on?:
        | { __typename?: "CarePlans" }
        | {
            __typename: "ServiceRequests";
            request_id: string;
            code: string;
            status: RequestStatus;
            priority: RequestPriority;
            intent: RequestIntent;
            category: ServiceRequestCategory;
            occurrence?: any | null;
            created_at: any;
            requisition?: {
              __typename: "Identifiers";
              identifier_id: string;
              type: IdentifierType;
              value: string;
              use: IdentifierUse;
              system?: string | null;
            } | null;
          }
        | null;
      report?: Array<{
        __typename: "DiagnosticReports";
        report_id: string;
        presented_form?: {
          __typename: "Attachments";
          attachment_id: string;
          content_type: MimeTypes;
          title: string;
          url?: string | null;
          width?: number | null;
          height?: number | null;
          pages?: number | null;
          size?: number | null;
          created_at: any;
        } | null;
      }> | null;
    }>;
  };
};

export type GetDiagnosticReportQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetDiagnosticReportQuery = {
  __typename?: "Query";
  getDiagnosticReport: {
    __typename: "DiagnosticReports";
    report_id: string;
    code: string;
    category: DiagnosticServiceSection;
    status: DiagnosticReportStatus;
    conclusion_code?: string | null;
    issued?: any | null;
    presented_form?: { __typename?: "Attachments"; attachment_id: string; title: string; url?: string | null } | null;
    flags?: Array<{
      __typename: "ObservationFlags";
      flag_id: string;
      hl7_code: string;
      display: string;
      alert_priority: AlertPriority;
      created_at: any;
    }> | null;
  };
};

export type GetDiagnosticReportAttachmentQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetDiagnosticReportAttachmentQuery = {
  __typename?: "Query";
  getDiagnosticReport: {
    __typename: "DiagnosticReports";
    report_id: string;
    presented_form?: { __typename?: "Attachments"; attachment_id: string; title: string; url?: string | null } | null;
  };
};

export type PatientDocumentsQueryVariables = Exact<{
  patientId: Scalars["ID"]["input"];
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type PatientDocumentsQuery = {
  __typename?: "Query";
  patientDocuments: Array<{
    __typename?: "PatientDocumentResponse";
    patientDocumentId: string;
    patientId: string;
    category: PatientDocumentCategory;
    label?: string | null;
    locationId?: string | null;
    currentUrl?: any | null;
    uploadedBy?: string | null;
    deletedAt?: any | null;
    deletedBy?: string | null;
    versions: Array<{
      __typename?: "PatientDocumentVersionResponse";
      patientDocumentVersionId: string;
      sequence: number;
      uploadedAt: any;
      uploadedBy?: string | null;
      url: any;
    }>;
  }>;
};

export type GetEmployeeQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetEmployeeQuery = {
  __typename?: "Query";
  getEmployee: {
    __typename: "StaffAssignments";
    assignment_id: string;
    organization_id: string;
    location_id: string;
    staff_id: string;
    title: string;
    status: EmploymentStatus;
    hire_date: any;
    company: {
      __typename: "Organizations";
      organization_id: string;
      organization_role: OrganizationRoles;
      organization_type: OrganizationTypes;
      safety_precautions?: Array<OrganizationHealthAndSafetyPrecautions> | null;
      alias: string;
      name: string;
      preferred_member: boolean;
    };
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      description?: string | null;
      phone?: string | null;
      preferred_member: boolean;
      organization_id: string;
      todays_operating_hours: string;
      open_now: boolean;
      location_role: string;
      location_status: string;
      meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
    };
    employee: {
      __typename: "Staffs";
      staff_id: string;
      created_at: any;
      user: {
        __typename: "Users";
        cynergy_id: string;
        user_id: string;
        username: string;
        identity?: { __typename?: "CynergyUsers"; cynergy_id: string; email?: string | null; phone?: string | null; username: string } | null;
        demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
      };
    };
  };
};

export type GetPaginatedEmployeesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedEmployeesQuery = {
  __typename?: "Query";
  getPaginatedEmployees: {
    __typename?: "EmployeePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "StaffAssignments";
      assignment_id: string;
      organization_id: string;
      location_id: string;
      staff_id: string;
      title: string;
      status: EmploymentStatus;
      hire_date: any;
      company: {
        __typename: "Organizations";
        organization_id: string;
        organization_role: OrganizationRoles;
        organization_type: OrganizationTypes;
        safety_precautions?: Array<OrganizationHealthAndSafetyPrecautions> | null;
        alias: string;
        name: string;
        preferred_member: boolean;
      };
      location: {
        __typename?: "Locations";
        location_id: string;
        alias?: string | null;
        name: string;
        description?: string | null;
        phone?: string | null;
        preferred_member: boolean;
        organization_id: string;
        todays_operating_hours: string;
        open_now: boolean;
        location_role: string;
        location_status: string;
        meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
      };
      employee: {
        __typename: "Staffs";
        staff_id: string;
        created_at: any;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          username: string;
          identity?: { __typename?: "CynergyUsers"; cynergy_id: string; email?: string | null; phone?: string | null; username: string } | null;
          demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
        };
      };
    }>;
  };
};

export type EmployeesFeedQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type EmployeesFeedQuery = {
  __typename?: "Query";
  employeesFeed: {
    __typename?: "EmployeePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "StaffAssignments";
      assignment_id: string;
      organization_id: string;
      location_id: string;
      staff_id: string;
      title: string;
      status: EmploymentStatus;
      hire_date: any;
      company: {
        __typename: "Organizations";
        organization_id: string;
        organization_role: OrganizationRoles;
        organization_type: OrganizationTypes;
        safety_precautions?: Array<OrganizationHealthAndSafetyPrecautions> | null;
        alias: string;
        name: string;
        preferred_member: boolean;
      };
      location: {
        __typename?: "Locations";
        location_id: string;
        alias?: string | null;
        name: string;
        description?: string | null;
        phone?: string | null;
        preferred_member: boolean;
        organization_id: string;
        todays_operating_hours: string;
        open_now: boolean;
        location_role: string;
        location_status: string;
        meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
      };
      employee: {
        __typename: "Staffs";
        staff_id: string;
        created_at: any;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          username: string;
          account?: { __typename?: "CynergyAccounts"; account_id: string } | null;
          identity?: { __typename?: "CynergyUsers"; cynergy_id: string; email?: string | null; phone?: string | null; username: string } | null;
          demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
        };
      };
    }>;
  };
};

export type GetAllEncountersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllEncountersQuery = {
  __typename?: "Query";
  getAllEncounters: Array<
    | { __typename?: "EncounterAdmissions" }
    | { __typename?: "EncounterDiagnosis" }
    | { __typename?: "EncounterLocations" }
    | { __typename?: "EncounterParticipants" }
    | { __typename?: "EncounterReasons" }
    | {
        __typename: "Encounters";
        encounter_id: string;
        status: EncounterStatus;
        class: EncounterClass;
        priority: ActPriority;
        service_type: string;
        subject_status: EncounterSubjectStatus;
        planned_start_date: any;
        planned_end_date?: any | null;
        diet_preference?: EncounterDiet | null;
        special_arrangement?: EncounterSpecialArrangements | null;
        special_courtesy?: EncounterSpecialCourtesy | null;
        created_at: any;
        deleted_at?: any | null;
        subject:
          | { __typename?: "Groups" }
          | {
              __typename: "Patients";
              patient_id: string;
              user: {
                __typename: "Users";
                cynergy_id: string;
                user_id: string;
                username: string;
                first_login: boolean;
                identity?: {
                  __typename: "CynergyUsers";
                  cynergy_id: string;
                  email?: string | null;
                  phone?: string | null;
                  username: string;
                  validated: boolean;
                  is_default?: boolean | null;
                  created_at: any;
                  updated_at?: any | null;
                } | null;
                demographics?: {
                  __typename: "Demographics";
                  cynergy_id: string;
                  full_name?: string | null;
                  first_name?: string | null;
                  last_name?: string | null;
                  prefix?: string | null;
                  suffix?: string | null;
                  middle_name?: string | null;
                  age: number;
                  deceased: boolean;
                  dob?: string | null;
                  ethnicity?: string | null;
                  sex: string;
                  race?: string | null;
                } | null;
              };
            };
        diagnosis?: Array<{
          __typename?: "EncounterDiagnosis";
          condition:
            | {
                __typename: "Conditions";
                condition_id: string;
                category: ConditionCategoryCodes;
                body_site?: string | null;
                verification_status: ConditionVerificationStatus;
                clinical_status: ConditionClinicalStatus;
                severity: ConditionSeverityCodes;
                note?: string | null;
                recorded_date?: any | null;
                abatement_date_string?: string | null;
                abatement_date_time?: any | null;
                onset_date_string?: string | null;
                onset_date_time?: any | null;
              }
            | {
                __typename: "ICD10";
                icd10_code: string;
                icd11_code?: string | null;
                label: string;
                description?: string | null;
                type?: DiagnosisType | null;
                hex?: string | null;
              };
        }> | null;
      }
  >;
};

export type GetEventQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetEventQuery = {
  __typename?: "Query";
  getEvent: {
    __typename: "Events";
    event_id: string;
    name: string;
    description?: string | null;
    type: string;
    event_date: any;
    all_day_event: boolean;
    start_time?: any | null;
    end_time?: any | null;
    repeats: boolean;
  };
};

export type GetEventSeriesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetEventSeriesQuery = {
  __typename?: "Query";
  getEventSeries: {
    __typename: "EventSeries";
    series_id: string;
    start_time?: any | null;
    end_time?: any | null;
    pattern: {
      __typename: "RecurrencePatterns";
      pattern_id: string;
      start_date: any;
      end_date?: string | null;
      description?: string | null;
      timezone?: any | null;
      text?: string | null;
      weekly?: {
        __typename: "WeeklyRecurrencePatterns";
        pattern_id: string;
        interval: number;
        days?: Array<DaysOfWeek> | null;
        every_day: boolean;
      } | null;
      monthly?: {
        __typename: "MonthlyRecurrencePatterns";
        pattern_id: string;
        interval: number;
        day_of_month?: number | null;
        day_of_week?: DaysOfWeek | null;
        week_of_month?: WeekOfMonth | null;
      } | null;
    };
  };
};

export type GetAllEventsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetAllEventsQuery = { __typename?: "Query"; getAllEvents: Array<{ __typename?: "Events"; event_id: string }> };

export type GetQuestionnaireQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetQuestionnaireQuery = {
  __typename?: "Query";
  getQuestionnaire:
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | { __typename?: "QuestionnaireResponses" }
    | {
        __typename: "Questionnaires";
        questionnaire_number: number;
        title: string;
        url?: string | null;
        description: string;
        link_id: string;
        publisher: string;
        publish_date: any;
        status: PublicationStatus;
        subject_type: string;
        purpose: string;
        last_review_date?: any | null;
        version: string;
        created_at: any;
        questions: Array<{
          __typename: "QuestionnaireItems";
          item_id: string;
          link_id: string;
          item_type: QuestionnaireItemType;
          input_type: FormInputGroupType;
          response_label?: string | null;
          order: number;
          text: string;
          prefix?: string | null;
          answer_constraint?: QuestionnaireAnswerConstraint | null;
          disabled_display: QuestionnaireDisabledDisplay;
          enable_behavior: QuestionnaireEnableBehavior;
          max_length?: number | null;
          ready_only: boolean;
          required: boolean;
          repeats: boolean;
          created_at: any;
          answer_options?: Array<{
            __typename: "QuestionnaireAnswerOptions";
            option_id: string;
            label?: string | null;
            icon?: string | null;
            initial_selected: boolean;
            option_coding?: string | null;
            option_date?: any | null;
            option_time?: string | null;
            option_integer?: number | null;
            option_string?: string | null;
            option_boolean?: boolean | null;
            created_at: any;
            option_range?: {
              __typename?: "Range";
              low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
              high?: {
                __typename: "Quantity";
                quantity_id: string;
                value: number;
                unit: string;
                code?: string | null;
                system?: string | null;
              } | null;
            } | null;
          }> | null;
          enabled_when?: {
            __typename: "QuestionnaireEnableWhen";
            enable_id: string;
            link_id: string;
            answer_boolean?: boolean | null;
            answer_coding?: string | null;
            answer_date?: any | null;
            answer_time?: string | null;
            answer_decimal?: number | null;
            answer_integer?: number | null;
            answer_quantity?: {
              __typename: "Quantity";
              quantity_id: string;
              value: number;
              unit: string;
              system?: string | null;
              code?: string | null;
              created_at: any;
            } | null;
          } | null;
          appearance?: {
            __typename: "LayoutConfiguration";
            column: {
              __typename?: "GridLayoutProperties";
              xs?: number | null;
              sm?: number | null;
              md?: number | null;
              lg?: number | null;
              xl?: number | null;
              xxl?: number | null;
            };
          } | null;
        }>;
      };
};

export type GetAllQuestionnairesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllQuestionnairesQuery = {
  __typename?: "Query";
  getAllQuestionnaires: Array<
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | { __typename?: "QuestionnaireResponses" }
    | {
        __typename: "Questionnaires";
        questionnaire_number: number;
        title: string;
        url?: string | null;
        description: string;
        link_id: string;
        publisher: string;
        publish_date: any;
        status: PublicationStatus;
        subject_type: string;
        purpose: string;
        last_review_date?: any | null;
        version: string;
        created_at: any;
        responses?: Array<{
          __typename: "QuestionnaireResponses";
          response_id: string;
          authored: any;
          status: QuestionnaireAnswerStatus;
          created_at: any;
        }> | null;
      }
  >;
};

export type GetQuestionnaireResponseQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetQuestionnaireResponseQuery = {
  __typename?: "Query";
  getQuestionnaireResponse:
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | {
        __typename: "QuestionnaireResponses";
        response_id: string;
        status: QuestionnaireAnswerStatus;
        authored: any;
        completed_at?: any | null;
        created_at: any;
        updated_at?: any | null;
        progress?: number | null;
        questionnaire: {
          __typename: "Questionnaires";
          questionnaire_number: number;
          title: string;
          url?: string | null;
          description: string;
          link_id: string;
          publisher: string;
          publish_date: any;
          status: PublicationStatus;
          subject_type: string;
          purpose: string;
          last_review_date?: any | null;
          version: string;
          created_at: any;
          questions: Array<{
            __typename: "QuestionnaireItems";
            item_id: string;
            link_id: string;
            item_type: QuestionnaireItemType;
            input_type: FormInputGroupType;
            response_label?: string | null;
            order: number;
            text: string;
            prefix?: string | null;
            answer_constraint?: QuestionnaireAnswerConstraint | null;
            disabled_display: QuestionnaireDisabledDisplay;
            enable_behavior: QuestionnaireEnableBehavior;
            max_length?: number | null;
            ready_only: boolean;
            required: boolean;
            repeats: boolean;
            created_at: any;
            appearance?: {
              __typename: "LayoutConfiguration";
              column: {
                __typename?: "GridLayoutProperties";
                xs?: number | null;
                sm?: number | null;
                md?: number | null;
                lg?: number | null;
                xl?: number | null;
                xxl?: number | null;
              };
            } | null;
          }>;
        };
        answers: Array<{
          __typename: "QuestionnaireAnswers";
          answer_id: string;
          answer_decimal?: number | null;
          answer_date?: any | null;
          answer_time?: string | null;
          answer_integer?: number | null;
          answer_boolean?: boolean | null;
          answer_coding?: string | null;
          answer_attachment?: string | null;
          answer_string?: string | null;
          answer_uri?: string | null;
          question: {
            __typename: "QuestionnaireItems";
            item_id: string;
            link_id: string;
            item_type: QuestionnaireItemType;
            input_type: FormInputGroupType;
            response_label?: string | null;
            order: number;
            text: string;
            prefix?: string | null;
            answer_constraint?: QuestionnaireAnswerConstraint | null;
            disabled_display: QuestionnaireDisabledDisplay;
            enable_behavior: QuestionnaireEnableBehavior;
            max_length?: number | null;
            ready_only: boolean;
            required: boolean;
            repeats: boolean;
            created_at: any;
            answer_options?: Array<{
              __typename: "QuestionnaireAnswerOptions";
              option_id: string;
              label?: string | null;
              icon?: string | null;
              initial_selected: boolean;
              option_coding?: string | null;
              option_date?: any | null;
              option_time?: string | null;
              option_integer?: number | null;
              option_string?: string | null;
              option_boolean?: boolean | null;
              created_at: any;
              option_range?: {
                __typename?: "Range";
                low?: {
                  __typename: "Quantity";
                  quantity_id: string;
                  value: number;
                  unit: string;
                  code?: string | null;
                  system?: string | null;
                } | null;
                high?: {
                  __typename: "Quantity";
                  quantity_id: string;
                  value: number;
                  unit: string;
                  code?: string | null;
                  system?: string | null;
                } | null;
              } | null;
            }> | null;
            appearance?: {
              __typename: "LayoutConfiguration";
              column: {
                __typename?: "GridLayoutProperties";
                xs?: number | null;
                sm?: number | null;
                md?: number | null;
                lg?: number | null;
                xl?: number | null;
                xxl?: number | null;
              };
            } | null;
          };
          answer_option?: { __typename: "QuestionnaireAnswerOptions"; option_id: string; label?: string | null } | null;
          answer_range?: {
            __typename?: "Range";
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
          answer_quantity?: {
            __typename: "Quantity";
            quantity_id: string;
            value: number;
            unit: string;
            code?: string | null;
            system?: string | null;
            created_at: any;
          } | null;
        }>;
        source: {
          __typename?: "Patients";
          patient_id: string;
          user: {
            __typename: "Users";
            cynergy_id: string;
            user_id: string;
            username: string;
            first_login: boolean;
            identity?: {
              __typename: "CynergyUsers";
              cynergy_id: string;
              email?: string | null;
              phone?: string | null;
              username: string;
              validated: boolean;
              is_default?: boolean | null;
              created_at: any;
              updated_at?: any | null;
            } | null;
            demographics?: {
              __typename: "Demographics";
              cynergy_id: string;
              full_name?: string | null;
              first_name?: string | null;
              last_name?: string | null;
              prefix?: string | null;
              suffix?: string | null;
              middle_name?: string | null;
              age: number;
              deceased: boolean;
              dob?: string | null;
              ethnicity?: string | null;
              sex: string;
              race?: string | null;
            } | null;
          };
        };
      }
    | { __typename?: "Questionnaires" };
};

export type GetAllQuestionnaireItemsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetAllQuestionnaireItemsQuery = {
  __typename?: "Query";
  getAllQuestionnaireItems: Array<
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | {
        __typename: "QuestionnaireItems";
        item_id: string;
        link_id: string;
        item_type: QuestionnaireItemType;
        input_type: FormInputGroupType;
        response_label?: string | null;
        order: number;
        text: string;
        prefix?: string | null;
        answer_constraint?: QuestionnaireAnswerConstraint | null;
        disabled_display: QuestionnaireDisabledDisplay;
        enable_behavior: QuestionnaireEnableBehavior;
        max_length?: number | null;
        ready_only: boolean;
        required: boolean;
        repeats: boolean;
        created_at: any;
        questionnaire: {
          __typename: "Questionnaires";
          questionnaire_number: number;
          title: string;
          url?: string | null;
          description: string;
          link_id: string;
          publisher: string;
          publish_date: any;
          status: PublicationStatus;
          subject_type: string;
          purpose: string;
          last_review_date?: any | null;
          version: string;
          created_at: any;
        };
        enabled_when?: {
          __typename: "QuestionnaireEnableWhen";
          enable_id: string;
          link_id: string;
          answer_boolean?: boolean | null;
          answer_coding?: string | null;
          answer_date?: any | null;
          answer_time?: string | null;
          answer_decimal?: number | null;
          answer_integer?: number | null;
          answer_quantity?: {
            __typename: "Quantity";
            quantity_id: string;
            value: number;
            unit: string;
            system?: string | null;
            code?: string | null;
            created_at: any;
          } | null;
        } | null;
        answer_options?: Array<{
          __typename: "QuestionnaireAnswerOptions";
          option_id: string;
          label?: string | null;
          icon?: string | null;
          initial_selected: boolean;
          option_coding?: string | null;
          option_date?: any | null;
          option_time?: string | null;
          option_integer?: number | null;
          option_string?: string | null;
          option_boolean?: boolean | null;
          created_at: any;
          option_range?: {
            __typename?: "Range";
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
        }> | null;
        appearance?: {
          __typename: "LayoutConfiguration";
          column: {
            __typename?: "GridLayoutProperties";
            xs?: number | null;
            sm?: number | null;
            md?: number | null;
            lg?: number | null;
            xl?: number | null;
            xxl?: number | null;
          };
        } | null;
      }
    | { __typename?: "QuestionnaireResponses" }
    | { __typename?: "Questionnaires" }
  >;
};

export type GetAllQuestionnaireResponsesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllQuestionnaireResponsesQuery = {
  __typename?: "Query";
  getAllQuestionnaireResponses: Array<
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | {
        __typename: "QuestionnaireResponses";
        response_id: string;
        status: QuestionnaireAnswerStatus;
        authored: any;
        completed_at?: any | null;
        created_at: any;
        updated_at?: any | null;
        progress?: number | null;
        answers: Array<{
          __typename: "QuestionnaireAnswers";
          answer_id: string;
          answer_decimal?: number | null;
          answer_date?: any | null;
          answer_time?: string | null;
          answer_integer?: number | null;
          answer_boolean?: boolean | null;
          answer_coding?: string | null;
          answer_attachment?: string | null;
          answer_string?: string | null;
          answer_uri?: string | null;
          question: {
            __typename: "QuestionnaireItems";
            item_id: string;
            link_id: string;
            item_type: QuestionnaireItemType;
            input_type: FormInputGroupType;
            response_label?: string | null;
            order: number;
            text: string;
            prefix?: string | null;
            answer_constraint?: QuestionnaireAnswerConstraint | null;
            disabled_display: QuestionnaireDisabledDisplay;
            enable_behavior: QuestionnaireEnableBehavior;
            max_length?: number | null;
            ready_only: boolean;
            required: boolean;
            repeats: boolean;
            created_at: any;
            appearance?: {
              __typename: "LayoutConfiguration";
              column: {
                __typename?: "GridLayoutProperties";
                xs?: number | null;
                sm?: number | null;
                md?: number | null;
                lg?: number | null;
                xl?: number | null;
                xxl?: number | null;
              };
            } | null;
          };
          answer_option?: { __typename: "QuestionnaireAnswerOptions"; option_id: string; label?: string | null } | null;
          answer_range?: {
            __typename?: "Range";
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
          answer_quantity?: {
            __typename: "Quantity";
            quantity_id: string;
            value: number;
            unit: string;
            code?: string | null;
            system?: string | null;
            created_at: any;
          } | null;
        }>;
        questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
      }
    | { __typename?: "Questionnaires" }
  >;
};

export type GetQuestionnaireResponseStatisticsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetQuestionnaireResponseStatisticsQuery = {
  __typename?: "Query";
  getAllQuestionnaireResponses: Array<
    | { __typename?: "QuestionnaireAnswerOptions" }
    | { __typename?: "QuestionnaireAnswers" }
    | { __typename?: "QuestionnaireEnableWhen" }
    | { __typename?: "QuestionnaireItems" }
    | {
        __typename: "QuestionnaireResponses";
        response_id: string;
        source: {
          __typename?: "Patients";
          patient_id: string;
          user: {
            __typename?: "Users";
            cynergy_id: string;
            demographics?: {
              __typename: "Demographics";
              cynergy_id: string;
              full_name?: string | null;
              first_name?: string | null;
              last_name?: string | null;
              prefix?: string | null;
              suffix?: string | null;
              middle_name?: string | null;
              age: number;
              deceased: boolean;
              dob?: string | null;
              ethnicity?: string | null;
              sex: string;
              race?: string | null;
            } | null;
          };
        };
        questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
        answers: Array<{
          __typename?: "QuestionnaireAnswers";
          answer_id: string;
          question: { __typename?: "QuestionnaireItems"; item_id: string; link_id: string };
          answer_range?: {
            __typename?: "Range";
            range_id: string;
            low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            high?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
          } | null;
        }>;
      }
    | { __typename?: "Questionnaires" }
  >;
};

export type GetPaginatedQuestionnairesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedQuestionnairesQuery = {
  __typename?: "Query";
  getPaginatedQuestionnaires: {
    __typename?: "FeedbackPaginatedResponse";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<
      | { __typename?: "QuestionnaireAnswerOptions" }
      | { __typename?: "QuestionnaireAnswers" }
      | { __typename?: "QuestionnaireEnableWhen" }
      | { __typename?: "QuestionnaireItems" }
      | { __typename?: "QuestionnaireResponses" }
      | {
          __typename: "Questionnaires";
          questionnaire_number: number;
          title: string;
          url?: string | null;
          description: string;
          link_id: string;
          publisher: string;
          publish_date: any;
          status: PublicationStatus;
          subject_type: string;
          purpose: string;
          last_review_date?: any | null;
          version: string;
          created_at: any;
          responses?: Array<{
            __typename: "QuestionnaireResponses";
            response_id: string;
            authored: any;
            status: QuestionnaireAnswerStatus;
            created_at: any;
          }> | null;
        }
    >;
  };
};

export type GetPaginatedQuestionnaireResponsesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedQuestionnaireResponsesQuery = {
  __typename?: "Query";
  getPaginatedQuestionnaireResponses: {
    __typename?: "FeedbackPaginatedResponse";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<
      | { __typename?: "QuestionnaireAnswerOptions" }
      | { __typename?: "QuestionnaireAnswers" }
      | { __typename?: "QuestionnaireEnableWhen" }
      | { __typename?: "QuestionnaireItems" }
      | {
          __typename: "QuestionnaireResponses";
          response_id: string;
          status: QuestionnaireAnswerStatus;
          authored: any;
          completed_at?: any | null;
          created_at: any;
          updated_at?: any | null;
          progress?: number | null;
          answers: Array<{
            __typename: "QuestionnaireAnswers";
            answer_id: string;
            answer_decimal?: number | null;
            answer_date?: any | null;
            answer_time?: string | null;
            answer_integer?: number | null;
            answer_boolean?: boolean | null;
            answer_coding?: string | null;
            answer_attachment?: string | null;
            answer_string?: string | null;
            answer_uri?: string | null;
            question: {
              __typename: "QuestionnaireItems";
              item_id: string;
              link_id: string;
              item_type: QuestionnaireItemType;
              input_type: FormInputGroupType;
              response_label?: string | null;
              order: number;
              text: string;
              prefix?: string | null;
              answer_constraint?: QuestionnaireAnswerConstraint | null;
              disabled_display: QuestionnaireDisabledDisplay;
              enable_behavior: QuestionnaireEnableBehavior;
              max_length?: number | null;
              ready_only: boolean;
              required: boolean;
              repeats: boolean;
              created_at: any;
              appearance?: {
                __typename: "LayoutConfiguration";
                column: {
                  __typename?: "GridLayoutProperties";
                  xs?: number | null;
                  sm?: number | null;
                  md?: number | null;
                  lg?: number | null;
                  xl?: number | null;
                  xxl?: number | null;
                };
              } | null;
            };
            answer_option?: { __typename: "QuestionnaireAnswerOptions"; option_id: string; label?: string | null } | null;
            answer_range?: {
              __typename?: "Range";
              high?: {
                __typename: "Quantity";
                quantity_id: string;
                value: number;
                unit: string;
                code?: string | null;
                system?: string | null;
              } | null;
              low?: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null } | null;
            } | null;
            answer_quantity?: {
              __typename: "Quantity";
              quantity_id: string;
              value: number;
              unit: string;
              code?: string | null;
              system?: string | null;
              created_at: any;
            } | null;
          }>;
          source: {
            __typename?: "Patients";
            patient_id: string;
            user: {
              __typename: "Users";
              cynergy_id: string;
              user_id: string;
              username: string;
              first_login: boolean;
              identity?: {
                __typename: "CynergyUsers";
                cynergy_id: string;
                email?: string | null;
                phone?: string | null;
                username: string;
                validated: boolean;
                is_default?: boolean | null;
                created_at: any;
                updated_at?: any | null;
              } | null;
              demographics?: {
                __typename: "Demographics";
                cynergy_id: string;
                full_name?: string | null;
                first_name?: string | null;
                last_name?: string | null;
                prefix?: string | null;
                suffix?: string | null;
                middle_name?: string | null;
                age: number;
                deceased: boolean;
                dob?: string | null;
                ethnicity?: string | null;
                sex: string;
                race?: string | null;
              } | null;
            };
          };
          questionnaire: { __typename: "Questionnaires"; questionnaire_number: number };
        }
      | { __typename?: "Questionnaires" }
    >;
  };
};

export type ExploreDirectoryFilesQueryVariables = Exact<{
  recursive: Scalars["Boolean"]["input"];
  folder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ExploreDirectoryFilesQuery = {
  __typename?: "Query";
  exploreDirectoryFiles: {
    __typename: "ExploreFilesResponse";
    message: string;
    status: number;
    paths?: Array<{
      __typename: "Bucket";
      folder: string;
      files: Array<{
        __typename: "BucketItem";
        size?: number | null;
        name?: string | null;
        prefix?: string | null;
        lastModified?: any | null;
        etag?: string | null;
        metadata?: {
          __typename: "BucketMetaData";
          Fileextension?: string | null;
          Filename?: string | null;
          Folder?: string | null;
          Isstarred?: boolean | null;
          Istrashed?: boolean | null;
          Label?: string | null;
          Lastaccessed?: string | null;
        } | null;
      }>;
    }> | null;
    errors?: Array<{ __typename?: "FieldError"; code?: string | null; path: string; message: string }> | null;
  };
};

export type GeneResistanceBreakdownQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GeneResistanceBreakdownQuery = {
  __typename?: "Query";
  getResistantGene: {
    __typename: "Genotypes";
    genotype_id: string;
    gene: string;
    encoding?: string | null;
    mechanism?: string | null;
    classification?: string | null;
    resistant_to?: Array<{ __typename: "Agents"; description?: string | null; agent_id: string; name: string }> | null;
    agent_class_resistance?: Array<{
      __typename?: "AgentClassResistance";
      class_resistance_id: string;
      classification: {
        __typename: "AgentClassifications";
        classification_number: number;
        code: AntibioticClassificationCodes;
        label: string;
        description?: string | null;
      };
      exceptions?: Array<{ __typename: "Agents"; agent_id: string; name: string }> | null;
    }> | null;
    agent_class_alternatives?: Array<{
      __typename?: "AgentClassifications";
      classification_number: number;
      code: AntibioticClassificationCodes;
      label: string;
      description?: string | null;
    }> | null;
    agent_alternatives?: Array<{
      __typename?: "AgentAlternatives";
      suitability: AntibioticSuitabilityRating;
      notes?: string | null;
      nus: boolean;
      gene: { __typename: "Genotypes"; genotype_id: string; gene: string };
      agent: { __typename: "Agents"; description?: string | null; agent_id: string; name: string };
    }> | null;
  };
};

export type GetOnboardingInviteQueryVariables = Exact<{
  inviteId: Scalars["String"]["input"];
}>;

export type GetOnboardingInviteQuery = {
  __typename?: "Query";
  getOnboardingInvite: {
    __typename?: "OnboardingInvite";
    invite_id: string;
    status: OnboardingInviteStatus;
    email: any;
    phone?: any | null;
    role: ApplicationRoles;
    expiration_date: any;
    demographics: { __typename: "OnboardingInviteDemographics"; dob?: any | null; first_name: string; last_name: string; sex?: string | null };
    from: { __typename?: "CynergyUsers"; cynergy_id: string; phone?: string | null; email?: string | null };
    invitee: {
      __typename?: "CynergyUsers";
      cynergy_id: string;
      username: string;
      phone?: string | null;
      email?: string | null;
      addresses?: Array<{
        __typename: "Addresses";
        address_id: string;
        use: AddressUse;
        type: AddressType;
        state: UsStates;
        city: string;
        postal_code?: string | null;
        lines: Array<{ __typename: "AddressLines"; line_id: string; line: string; order: number }>;
      }> | null;
    };
  };
};

export type FindLocationQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type FindLocationQuery = {
  __typename?: "Query";
  getLocation: {
    __typename?: "Locations";
    location_id: string;
    alias?: string | null;
    name: string;
    description?: string | null;
    phone?: string | null;
    preferred_member: boolean;
    organization_id: string;
    todays_operating_hours: string;
    open_now: boolean;
    location_role: string;
    location_status: string;
    meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
  };
};

export type DownloadCsvLocationPatientsReportQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type DownloadCsvLocationPatientsReportQuery = {
  __typename?: "Query";
  downloadCSVLocationPatientsReport: { __typename?: "DownloadLocationPatientsReportResults"; url: string };
};

export type GetPaginatedLocationPatientsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedLocationPatientsQuery = {
  __typename?: "Query";
  getPaginatedLocationPatients: {
    __typename: "LocationPatientPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "LocationPatients";
      status: string;
      deleted_at?: any | null;
      location_id: string;
      patient_id: string;
      patient: {
        __typename?: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          identity?: {
            __typename: "CynergyUsers";
            cynergy_id: string;
            email?: string | null;
            phone?: string | null;
            username: string;
            validated: boolean;
            is_default?: boolean | null;
            created_at: any;
            updated_at?: any | null;
            addresses?: Array<{
              __typename: "Addresses";
              address_id: string;
              room?: string | null;
              city: string;
              state: UsStates;
              postal_code?: string | null;
              nickname?: string | null;
              type: AddressType;
              use: AddressUse;
              display: string;
              district?: string | null;
              lines: Array<{ __typename?: "AddressLines"; line_id: string; line: string; order: number }>;
            }> | null;
          } | null;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type LocationPatientsFeedQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type LocationPatientsFeedQuery = {
  __typename?: "Query";
  locationPatientsFeed: {
    __typename: "LocationPatientPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "LocationPatients";
      status: string;
      location_id: string;
      patient_id: string;
      patient: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          identity?: {
            __typename: "CynergyUsers";
            cynergy_id: string;
            email?: string | null;
            phone?: string | null;
            username: string;
            validated: boolean;
            is_default?: boolean | null;
            created_at: any;
            updated_at?: any | null;
          } | null;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type GetAllLocationPatientsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllLocationPatientsQuery = {
  __typename?: "Query";
  getAllLocationPatients: Array<{
    __typename?: "LocationPatients";
    location_id: string;
    patient: { __typename?: "Patients"; user: { __typename: "Users"; user_id: string; cynergy_id: string } };
  }>;
};

export type GetLocationPatientQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetLocationPatientQuery = {
  __typename?: "Query";
  getLocationPatient: {
    __typename: "LocationPatients";
    location_id: string;
    patient_id: string;
    last_contact?: any | null;
    deleted_at?: any | null;
    status: string;
    patient: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        identity?: {
          __typename: "CynergyUsers";
          cynergy_id: string;
          email?: string | null;
          phone?: string | null;
          username: string;
          validated: boolean;
          is_default?: boolean | null;
          created_at: any;
          updated_at?: any | null;
        } | null;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      };
      medications?: Array<{
        __typename: "MedicationUsages";
        usage_id: string;
        practitioner_id: string;
        notes?: string | null;
        adherence: MedicationUsageAdherence;
        date_asserted: any;
        category: MedicationRequestAdministrativeLocation;
        dosage_instruction: string;
        administration_method: string;
        administration_timing: TimingAbbreviations;
        timing_display?: string | null;
        effective: any;
        usage_status: MedicationUsageStatus;
        effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
        reason?: Array<{
          __typename: "Conditions";
          condition_id: string;
          category: ConditionCategoryCodes;
          body_site?: string | null;
          verification_status: ConditionVerificationStatus;
          clinical_status: ConditionClinicalStatus;
          severity: ConditionSeverityCodes;
          note?: string | null;
          recorded_date?: any | null;
          abatement_date_string?: string | null;
          abatement_date_time?: any | null;
          onset_date_string?: string | null;
          onset_date_time?: any | null;
        }> | null;
        medication: {
          __typename: "Medications";
          medication_id: string;
          brand_name: string;
          status: MedicationsStatus;
          code: MedicationCodes;
          dose_form: string;
          manufacturer?: string | null;
          detected_issues?: Array<{
            __typename: "DetectedIssues";
            issue_id: string;
            status: DetectedIssueStatus;
            category: DetectedIssueCategory;
            severity: DetectedIssueSeverity;
            detail?: string | null;
            identified_at: any;
            mitigation_action?: string | null;
            mitigation_date?: any | null;
            reference_uri?: string | null;
          }> | null;
          total_volume: {
            __typename: "Ratio";
            ratio_id: string;
            numerator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
            denominator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
          };
        };
      }> | null;
    };
    location: { __typename: "Locations"; location_id: string; alias?: string | null };
  };
};

export type GetLocationAddressesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetLocationAddressesQuery = {
  __typename?: "Query";
  getLocationAddresses: Array<{
    __typename: "Locations";
    location_id: string;
    address: {
      __typename: "WebCynergyAddresses";
      address_id: string;
      city: string;
      state: string;
      zip: string;
      address_line_1: string;
      address_line_2?: string | null;
      nickname?: string | null;
      formatted_address?: string | null;
      type: string;
      longitude?: number | null;
      latitude?: number | null;
      is_default: boolean;
      place_id?: string | null;
    };
  }>;
};

export type FindFdaMedicationsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type FindFdaMedicationsQuery = {
  __typename?: "Query";
  findFDAMedications: Array<
    | { __typename?: "DrugNDC" }
    | {
        __typename?: "DrugProducts";
        product_id: number;
        drug_name?: string | null;
        active_ingredient?: string | null;
        resistant_genotypes?: Array<{
          __typename?: "Genotypes";
          genotype_id: string;
          gene: string;
          encoding?: string | null;
          mechanism?: string | null;
        }> | null;
      }
  >;
};

export type FindFdaMedicationsWithDetailsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  strictSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type FindFdaMedicationsWithDetailsQuery = {
  __typename?: "Query";
  findFDAMedicationsWithDetails: Array<
    | { __typename?: "DrugNDC" }
    | { __typename?: "DrugProducts"; drug_name?: string | null; form?: string | null; active_ingredient?: string | null; strength?: string | null }
  >;
};

export type GetAllDetailedMedicationUsagesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllDetailedMedicationUsagesQuery = {
  __typename?: "Query";
  getAllDetailedMedicationUsages: Array<
    | { __typename?: "Dosage" }
    | { __typename?: "MedicationAdministrations" }
    | { __typename?: "MedicationBatch" }
    | { __typename?: "MedicationDispenses" }
    | { __typename?: "MedicationIngredients" }
    | {
        __typename: "MedicationUsages";
        usage_id: string;
        practitioner_id: string;
        notes?: string | null;
        adherence: MedicationUsageAdherence;
        date_asserted: any;
        category: MedicationRequestAdministrativeLocation;
        dosage_instruction: string;
        administration_method: string;
        administration_timing: TimingAbbreviations;
        timing_display?: string | null;
        effective: any;
        days_left: number;
        usage_status: MedicationUsageStatus;
        patient: { __typename?: "Patients"; patient_id: string };
        reason?: Array<{
          __typename: "Conditions";
          condition_id: string;
          category: ConditionCategoryCodes;
          body_site?: string | null;
          verification_status: ConditionVerificationStatus;
          clinical_status: ConditionClinicalStatus;
          severity: ConditionSeverityCodes;
          note?: string | null;
          recorded_date?: any | null;
          abatement_date_string?: string | null;
          abatement_date_time?: any | null;
          onset_date_string?: string | null;
          onset_date_time?: any | null;
        }> | null;
        medication: {
          __typename: "Medications";
          medication_id: string;
          brand_name: string;
          status: MedicationsStatus;
          code: MedicationCodes;
          dose_form: string;
          manufacturer?: string | null;
          total_volume: {
            __typename: "Ratio";
            ratio_id: string;
            numerator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
            denominator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
          };
          detected_issues?: Array<{
            __typename: "DetectedIssues";
            issue_id: string;
            status: DetectedIssueStatus;
            category: DetectedIssueCategory;
            severity: DetectedIssueSeverity;
            detail?: string | null;
            identified_at: any;
            mitigation_action?: string | null;
            mitigation_date?: any | null;
            reference_uri?: string | null;
          }> | null;
        };
        effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
      }
    | { __typename?: "Medications" }
  >;
};

export type GetDetailedMedicationUsageQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetDetailedMedicationUsageQuery = {
  __typename?: "Query";
  getDetailedMedicationUsage:
    | { __typename?: "Dosage" }
    | { __typename?: "MedicationAdministrations" }
    | { __typename?: "MedicationBatch" }
    | { __typename?: "MedicationDispenses" }
    | { __typename?: "MedicationIngredients" }
    | {
        __typename: "MedicationUsages";
        usage_id: string;
        practitioner_id: string;
        notes?: string | null;
        adherence: MedicationUsageAdherence;
        date_asserted: any;
        category: MedicationRequestAdministrativeLocation;
        dosage_instruction: string;
        administration_method: string;
        administration_timing: TimingAbbreviations;
        timing_display?: string | null;
        effective: any;
        days_left: number;
        usage_status: MedicationUsageStatus;
        prescriber?: {
          __typename: "Practitioners";
          practitioner_id: string;
          demographics?: { __typename: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
        } | null;
        patient: { __typename: "Patients"; patient_id: string };
        reason?: Array<{
          __typename: "Conditions";
          condition_id: string;
          category: ConditionCategoryCodes;
          body_site?: string | null;
          verification_status: ConditionVerificationStatus;
          clinical_status: ConditionClinicalStatus;
          severity: ConditionSeverityCodes;
          note?: string | null;
          recorded_date?: any | null;
          abatement_date_string?: string | null;
          abatement_date_time?: any | null;
          onset_date_string?: string | null;
          onset_date_time?: any | null;
          classification: { __typename: "ICD10"; icd10_code: string; label: string };
        }> | null;
        medication: {
          __typename: "Medications";
          medication_id: string;
          brand_name: string;
          status: MedicationsStatus;
          code: MedicationCodes;
          dose_form: string;
          manufacturer?: string | null;
          total_volume: {
            __typename: "Ratio";
            ratio_id: string;
            numerator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
            denominator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string; code?: string | null; system?: string | null };
          };
          detected_issues?: Array<{
            __typename: "DetectedIssues";
            issue_id: string;
            status: DetectedIssueStatus;
            category: DetectedIssueCategory;
            severity: DetectedIssueSeverity;
            detail?: string | null;
            identified_at: any;
            mitigation_action?: string | null;
            mitigation_date?: any | null;
            reference_uri?: string | null;
          }> | null;
        };
        effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
      }
    | { __typename?: "Medications" };
};

export type GetAllLocationPrescriptionsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllLocationPrescriptionsQuery = {
  __typename?: "Query";
  getAllLocationPrescriptions: Array<{
    __typename: "MedicationUsages";
    usage_id: string;
    created_at: any;
    medication: {
      __typename: "Medications";
      medication_id: string;
      brand_name: string;
      ndc_information?: {
        __typename: "DrugProducts";
        product_id: number;
        resistant_genotypes?: Array<{ __typename: "Genotypes"; gene: string; genotype_id: string }> | null;
      } | null;
    };
    derived_from?: { __typename: "CriteriaFormResults"; result_id: string; passed: boolean } | null;
  }>;
};

export type GetPaginatedPrescriptionsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedPrescriptionsQuery = {
  __typename?: "Query";
  getPaginatedPrescriptions: {
    __typename?: "PrescriptionPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "MedicationUsages";
      expired: boolean;
      usage_id: string;
      practitioner_id: string;
      notes?: string | null;
      adherence: MedicationUsageAdherence;
      date_asserted: any;
      category: MedicationRequestAdministrativeLocation;
      dosage_instruction: string;
      administration_method: string;
      administration_timing: TimingAbbreviations;
      timing_display?: string | null;
      effective: any;
      days_left: number;
      usage_status: MedicationUsageStatus;
      medication: {
        __typename: "Medications";
        medication_id: string;
        brand_name: string;
        status: MedicationsStatus;
        code: MedicationCodes;
        dose_form: string;
        manufacturer?: string | null;
      };
      prescriber?: {
        __typename: "Practitioners";
        practitioner_id: string;
        cynergy_id: string;
        registration_authority_id: string;
        npi: number;
        prefix?: string | null;
        suffix?: string | null;
        created_at: any;
        affiliation_date?: any | null;
        taxonomies: Array<{
          __typename: "Taxonomies";
          taxonomy_id: string;
          license?: string | null;
          code: string;
          primary: boolean;
          description: string;
          group?: string | null;
          state?: string | null;
        }>;
        demographics?: {
          __typename: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
          prefix?: string | null;
          suffix?: string | null;
          middle_name?: string | null;
          age: number;
          deceased: boolean;
          dob?: string | null;
          ethnicity?: string | null;
          marital_status?: MaritalStatus | null;
          sex: string;
          race?: string | null;
        } | null;
      } | null;
      patient: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          cynergy_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
      reason?: Array<{
        __typename: "Conditions";
        condition_id: string;
        code?: ConditionCodes | null;
        recorded_date?: any | null;
        classification: { __typename: "ICD10"; icd10_code: string; description?: string | null; label: string; type?: DiagnosisType | null };
      }> | null;
      effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
    }>;
  };
};

export type PaginatedPrescriptionsListQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type PaginatedPrescriptionsListQuery = {
  __typename?: "Query";
  paginatedPrescriptionList: {
    __typename?: "PrescriptionPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "MedicationUsages";
      usage_id: string;
      status: MedicationUsageStatus;
      category: MedicationRequestAdministrativeLocation;
      days_left: number;
      dosage_instruction: string;
      timing_display?: string | null;
      created_at: any;
      deleted_at?: any | null;
      is_archived: boolean;
      medication: {
        __typename: "Medications";
        medication_id: string;
        brand_name: string;
        status: MedicationsStatus;
        code: MedicationCodes;
        dose_form: string;
        manufacturer?: string | null;
      };
    }>;
  };
};

export type PatientMedicationsListQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type PatientMedicationsListQuery = {
  __typename?: "Query";
  paginatedPrescriptionList: {
    __typename?: "PrescriptionPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "MedicationUsages";
      usage_id: string;
      practitioner_id: string;
      notes?: string | null;
      adherence: MedicationUsageAdherence;
      date_asserted: any;
      category: MedicationRequestAdministrativeLocation;
      dosage_instruction: string;
      administration_method: string;
      administration_timing: TimingAbbreviations;
      timing_display?: string | null;
      effective: any;
      days_left: number;
      usage_status: MedicationUsageStatus;
      medication: {
        __typename: "Medications";
        medication_id: string;
        brand_name: string;
        status: MedicationsStatus;
        code: MedicationCodes;
        dose_form: string;
        manufacturer?: string | null;
        total_volume: {
          __typename: "Ratio";
          ratio_id: string;
          numerator: { __typename: "Quantity"; quantity_id: string; value: number; unit: string };
        };
        detected_issues?: Array<{
          __typename: "DetectedIssues";
          issue_id: string;
          status: DetectedIssueStatus;
          category: DetectedIssueCategory;
          severity: DetectedIssueSeverity;
          detail?: string | null;
          identified_at: any;
          mitigation_action?: string | null;
          mitigation_date?: any | null;
          reference_uri?: string | null;
        }> | null;
      };
      effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
    }>;
  };
};

export type GetLocationPrescriptionCountsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetLocationPrescriptionCountsQuery = {
  __typename?: "Query";
  getAllLocationPrescriptions: Array<{
    __typename?: "MedicationUsages";
    usage_id: string;
    created_at: any;
    derived_from?: { __typename?: "CriteriaFormResults"; result_id: string; passed: boolean } | null;
  }>;
};

export type GetAllUserMessagesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetAllUserMessagesQuery = {
  __typename?: "Query";
  getAllUserMessages: Array<{
    __typename: "Messages";
    message_id: string;
    cynergy_id: string;
    title: string;
    body: string;
    from_email: string;
    folder: MessageFolders;
    labels: Array<MessageLabels>;
    is_read: boolean;
    slug?: string | null;
    is_trashed?: boolean | null;
    is_starred?: boolean | null;
    attachment?: string | null;
    created_at: any;
    notification?: {
      __typename: "Notifications";
      is_read: boolean;
      notification_id: string;
      notification_title: string;
      notification_body: string;
      notification_data?: any | null;
      notification_category?: string | null;
      notification_link?: string | null;
      link_label?: string | null;
      notification_priority: AlertPriority;
      from_cynergy_id?: string | null;
      recipient_cynergy_id: string;
      ref_id?: string | null;
      from: string;
      created_at: any;
      updated_at?: any | null;
    } | null;
  }>;
};

export type GetUnreadUserNotificationsQueryVariables = Exact<{
  isRead: Scalars["Boolean"]["input"];
}>;

export type GetUnreadUserNotificationsQuery = {
  __typename?: "Query";
  getUnreadUserNotifications: Array<{
    __typename: "Notifications";
    is_read: boolean;
    notification_id: string;
    notification_title: string;
    notification_body: string;
    notification_data?: any | null;
    notification_category?: string | null;
    notification_link?: string | null;
    link_label?: string | null;
    notification_priority: AlertPriority;
    from_cynergy_id?: string | null;
    recipient_cynergy_id: string;
    ref_id?: string | null;
    from: string;
    created_at: any;
    updated_at?: any | null;
  }>;
};

export type GetUserNotificationsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  pagination?: InputMaybe<PaginationArgs>;
}>;

export type GetUserNotificationsQuery = {
  __typename?: "Query";
  getUserNotifications: Array<{
    __typename: "Notifications";
    is_read: boolean;
    notification_id: string;
    notification_title: string;
    notification_body: string;
    notification_data?: any | null;
    notification_category?: string | null;
    notification_link?: string | null;
    link_label?: string | null;
    notification_priority: AlertPriority;
    from_cynergy_id?: string | null;
    recipient_cynergy_id: string;
    ref_id?: string | null;
    from: string;
    created_at: any;
    updated_at?: any | null;
  }>;
};

export type GetOrderBillingQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrderBillingQuery = {
  __typename?: "Query";
  getOrder: {
    __typename?: "Orders";
    order_id: string;
    status: OrderStatus;
    patient: { __typename?: "Patients"; patient_id: string };
    coverages?: Array<{
      __typename?: "OrderCoverages";
      order_coverage_id: string;
      coverage_id?: string | null;
      payor_name?: string | null;
      policy_number?: string | null;
      plan_type?: string | null;
      coverage_order: number;
      kind: FhirCoverageKind;
    }> | null;
  };
};

export type GetServiceRequestQueryVariables = Exact<{
  options?: InputMaybe<QueryOptionsInputType>;
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetServiceRequestQuery = {
  __typename?: "Query";
  getServiceRequest: {
    __typename: "ServiceRequests";
    request_id: string;
    code: string;
    status: RequestStatus;
    priority: RequestPriority;
    intent: RequestIntent;
    category: ServiceRequestCategory;
    occurrence?: any | null;
    created_at: any;
    requisition?: {
      __typename: "Identifiers";
      identifier_id: string;
      type: IdentifierType;
      value: string;
      use: IdentifierUse;
      system?: string | null;
    } | null;
    reports?: Array<{
      __typename: "DiagnosticReports";
      report_id: string;
      code: string;
      category: DiagnosticServiceSection;
      status: DiagnosticReportStatus;
      conclusion_code?: string | null;
      issued?: any | null;
    }> | null;
  };
};

export type GetAllServiceRequestsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllServiceRequestsQuery = {
  __typename?: "Query";
  getAllServiceRequests: Array<{
    __typename: "ServiceRequests";
    request_id: string;
    code: string;
    status: RequestStatus;
    priority: RequestPriority;
    intent: RequestIntent;
    category: ServiceRequestCategory;
    occurrence?: any | null;
    created_at: any;
    requisition?: {
      __typename: "Identifiers";
      identifier_id: string;
      type: IdentifierType;
      value: string;
      use: IdentifierUse;
      system?: string | null;
    } | null;
    performer?:
      | { __typename?: "CareTeams" }
      | { __typename?: "Devices" }
      | { __typename?: "HealthcareServiceLocations" }
      | { __typename?: "Locations" }
      | { __typename?: "Organizations"; organization_id: string; alias: string; preferred_member: boolean }
      | { __typename?: "Patients" }
      | { __typename?: "Practitioners" }
      | null;
    location: { __typename: "Locations"; location_id: string; alias?: string | null };
  }>;
};

export type GetPaginatedServiceRequestsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedServiceRequestsQuery = {
  __typename?: "Query";
  getPaginatedServiceRequests: {
    __typename?: "ServiceRequestPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "ServiceRequests";
      request_id: string;
      code: string;
      status: RequestStatus;
      priority: RequestPriority;
      intent: RequestIntent;
      category: ServiceRequestCategory;
      occurrence?: any | null;
      created_at: any;
      requisition?: {
        __typename: "Identifiers";
        identifier_id: string;
        type: IdentifierType;
        value: string;
        use: IdentifierUse;
        system?: string | null;
      } | null;
      patient: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
      performer?:
        | { __typename?: "CareTeams" }
        | { __typename?: "Devices" }
        | { __typename?: "HealthcareServiceLocations" }
        | { __typename?: "Locations"; location_id: string; name: string; preferred_member: boolean }
        | { __typename?: "Organizations"; organization_id: string; alias: string; preferred_member: boolean }
        | { __typename?: "Patients" }
        | { __typename?: "Practitioners" }
        | null;
      reports?: Array<{
        __typename: "DiagnosticReports";
        report_id: string;
        code: string;
        presented_form?: { __typename: "Attachments"; attachment_id: string; url?: string | null } | null;
        flags?: Array<{ __typename: "ObservationFlags"; flag_id: string; hl7_code: string; alert_priority: AlertPriority; display: string }> | null;
      }> | null;
      location: { __typename: "Locations"; location_id: string; alias?: string | null };
    }>;
  };
};

export type GetOrderQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrderQuery = {
  __typename?: "Query";
  getOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    series?: {
      __typename: "EventSeries";
      series_id: string;
      start_time?: any | null;
      end_time?: any | null;
      pattern: {
        __typename: "RecurrencePatterns";
        pattern_id: string;
        start_date: any;
        end_date?: string | null;
        description?: string | null;
        timezone?: any | null;
        text?: string | null;
      };
    } | null;
  };
};

export type GetOrderSpecimenQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrderSpecimenQuery = {
  __typename?: "Query";
  getOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
  };
};

export type OrderDetailsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderDetailsQuery = {
  __typename?: "Query";
  getOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    diagnosis_codes?: Array<{ __typename: "ICD10"; icd10_code: string; label: string }> | null;
    contacts?: Array<{
      __typename: "ContactDetails";
      contact_detail_id: string;
      name: string;
      purpose?: ContactEntityType | null;
      telecom: Array<{
        __typename: "ContactPoints";
        contact_point_id: string;
        system: ContactPointSystem;
        use: ContactPointUse;
        value: string;
        rank: number;
        created_at: any;
      }>;
    }> | null;
    patient: { __typename: "Patients"; patient_id: string; user: { __typename: "Users"; user_id: string } };
    agents?: Array<{
      __typename: "OrderAgents";
      agent_id: string;
      name?: string | null;
      active: boolean;
      role: ParticipantRoleType;
      comment?: string | null;
      actor?:
        | { __typename: "CareTeams"; care_team_id: string }
        | { __typename: "Locations"; location_id: string }
        | { __typename: "Organizations"; organization_id: string }
        | { __typename: "Practitioners"; practitioner_id: string }
        | { __typename: "StaffAssignments" }
        | null;
    }> | null;
    series?: {
      __typename: "EventSeries";
      series_id: string;
      start_time?: any | null;
      end_time?: any | null;
      pattern: {
        __typename: "RecurrencePatterns";
        pattern_id: string;
        start_date: any;
        end_date?: string | null;
        description?: string | null;
        timezone?: any | null;
        text?: string | null;
      };
    } | null;
    reports?: Array<{
      __typename: "DiagnosticReports";
      report_id: string;
      request_id?: string | null;
      code: string;
      status: DiagnosticReportStatus;
      presented_form?: {
        __typename: "Attachments";
        attachment_id: string;
        content_type: MimeTypes;
        title: string;
        url?: string | null;
        width?: number | null;
        height?: number | null;
        pages?: number | null;
        size?: number | null;
        created_at: any;
      } | null;
    }> | null;
    requisition?: {
      __typename?: "DocumentReferences";
      reference_id: string;
      content: {
        __typename: "Attachments";
        attachment_id: string;
        content_type: MimeTypes;
        title: string;
        url?: string | null;
        width?: number | null;
        height?: number | null;
        pages?: number | null;
        size?: number | null;
        created_at: any;
      };
    } | null;
    flags?: Array<{ __typename: "OrderFlags"; flag_id: string; hl7_code: string; alert_priority: AlertPriority; display: string }> | null;
  };
};

export type OrderRequisitionDocumentQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderRequisitionDocumentQuery = {
  __typename?: "Query";
  getOrderDetails: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    requisition?: {
      __typename?: "DocumentReferences";
      reference_id: string;
      content: { __typename?: "Attachments"; attachment_id: string; content_type: MimeTypes; title: string; url?: string | null; data?: any | null };
    } | null;
  };
};

export type OrderRequisitionDataQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderRequisitionDataQuery = {
  __typename?: "Query";
  getOrderDetails: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    diagnosis_codes?: Array<{
      __typename: "ICD10";
      icd10_code: string;
      icd11_code?: string | null;
      label: string;
      description?: string | null;
      type?: DiagnosisType | null;
      hex?: string | null;
    }> | null;
    requests?: Array<{ __typename?: "ServiceRequests"; request_id: string; code: string }> | null;
    patient: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        user_id: string;
        demographics?: {
          __typename?: "Demographics";
          cynergy_id: string;
          first_name?: string | null;
          last_name?: string | null;
          full_name?: string | null;
          dob?: string | null;
          sex: string;
        } | null;
      };
    };
    requisition?: {
      __typename?: "DocumentReferences";
      reference_id: string;
      content: { __typename?: "Attachments"; attachment_id: string; title: string; url?: string | null };
    } | null;
    signature?: {
      __typename?: "OrderSignatures";
      order_id: string;
      practitioner_id: string;
      name: string;
      practitioner?: {
        __typename?: "Practitioners";
        practitioner_id: string;
        npi: number;
        demographics?: {
          __typename?: "Demographics";
          cynergy_id: string;
          first_name?: string | null;
          last_name?: string | null;
          full_name?: string | null;
        } | null;
      } | null;
      signature?: { __typename?: "Signatures"; signature_id: string; url?: any | null } | null;
    } | null;
  };
};

export type OrderTimelineQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderTimelineQuery = {
  __typename?: "Query";
  getOrder: {
    __typename: "Orders";
    created_at: any;
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
  };
};

export type OrderDiagnosisCodesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderDiagnosisCodesQuery = {
  __typename?: "Query";
  getOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    patient: { __typename?: "Patients"; patient_id: string };
    line_items?: Array<{ __typename?: "OrderLineItems"; line_item_id: string }> | null;
    diagnosis_codes?: Array<{ __typename: "ICD10"; icd10_code: string; label: string }> | null;
  };
};

export type GetPaginatedOrderItemsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedOrderItemsQuery = {
  __typename?: "Query";
  getPaginatedOrderItems: {
    __typename?: "OrderItemPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "OrderLineItems";
      line_item_id: string;
      description?: string | null;
      net_total: any;
      tax?: any | null;
      request?: {
        __typename: "ServiceRequests";
        request_id: string;
        code: string;
        status: RequestStatus;
        priority: RequestPriority;
        intent: RequestIntent;
        category: ServiceRequestCategory;
        occurrence?: any | null;
        created_at: any;
        service: { __typename?: "HealthcareServices"; service_id: string };
        location: { __typename: "Locations"; location_id: string; alias?: string | null; phone?: string | null };
      } | null;
    }>;
  };
};

export type OrderNotesFeedQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type OrderNotesFeedQuery = {
  __typename?: "Query";
  getPaginatedOrderNotes: {
    __typename?: "OrderNotePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename?: "Annotations";
      annotation_id: string;
      text: string;
      created_at: any;
      author: {
        __typename?: "Users";
        user_id: string;
        demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
      };
    }>;
  };
};

export type GetCompletedPatientOrdersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetCompletedPatientOrdersQuery = {
  __typename?: "Query";
  getPaginatedOrders: {
    __typename?: "OrderPaginatedResults";
    count: number;
    rows: Array<{
      __typename: "Orders";
      order_id: string;
      title: string;
      description?: string | null;
      status: OrderStatus;
      status_reason?: string | null;
      priority: RequestPriority;
      recurs: boolean;
      series_id?: string | null;
      event_id?: string | null;
      is_series_source?: boolean | null;
      scheduled_date: any;
      fulfilled_at?: any | null;
      requested_collection_date?: any | null;
      is_reviewed: boolean;
      created_by: string;
      deleted_at?: any | null;
      requests?: Array<{
        __typename: "ServiceRequests";
        request_id: string;
        code: string;
        status: RequestStatus;
        reports?: Array<{
          __typename: "DiagnosticReports";
          report_id: string;
          code: string;
          result?: Array<{ __typename: "Observations"; observation_id: string; code: string; interpretation: ObservationInterpretation }> | null;
          flags?: Array<{
            __typename: "ObservationFlags";
            flag_id: string;
            hl7_code: string;
            alert_priority: AlertPriority;
            display: string;
            observation: { __typename: "Observations"; observation_id: string; interpretation: ObservationInterpretation; code: string };
          }> | null;
        }> | null;
      }> | null;
    }>;
  };
};

export type GetPaginatedOrdersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedOrdersQuery = {
  __typename?: "Query";
  getPaginatedOrders: {
    __typename?: "OrderPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "Orders";
      order_id: string;
      title: string;
      description?: string | null;
      status: OrderStatus;
      status_reason?: string | null;
      priority: RequestPriority;
      recurs: boolean;
      series_id?: string | null;
      event_id?: string | null;
      is_series_source?: boolean | null;
      scheduled_date: any;
      fulfilled_at?: any | null;
      requested_collection_date?: any | null;
      is_reviewed: boolean;
      created_by: string;
      deleted_at?: any | null;
      patient: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          user_id: string;
          identity?: {
            __typename: "CynergyUsers";
            cynergy_id: string;
            email?: string | null;
            phone?: string | null;
            username: string;
            validated: boolean;
            is_default?: boolean | null;
            created_at: any;
            updated_at?: any | null;
            addresses?: Array<{ __typename: "Addresses"; address_id: string; room?: string | null }> | null;
          } | null;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
      requisition?: {
        __typename: "DocumentReferences";
        reference_id: string;
        status: DocumentReferenceStatus;
        description?: string | null;
        content_type: MimeTypes;
        document_status: CompositionStatus;
        security_tag?: SecurityLabel | null;
        version: string;
        content: { __typename: "Attachments"; attachment_id: string; url?: string | null; title: string };
      } | null;
      flags?: Array<{ __typename: "OrderFlags"; flag_id: string; hl7_code: string; alert_priority: AlertPriority; display: string }> | null;
      requests?: Array<{
        __typename: "ServiceRequests";
        request_id: string;
        reports?: Array<{
          __typename: "DiagnosticReports";
          report_id: string;
          code: string;
          presented_form?: { __typename: "Attachments"; attachment_id: string; url?: string | null } | null;
        }> | null;
      }> | null;
    }>;
  };
};

export type OrderStatisticsQueryVariables = Exact<{
  parameters: OrderStatisticsInput;
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type OrderStatisticsQuery = {
  __typename?: "Query";
  orderStatistics: {
    __typename?: "OrderStatisticsResults";
    field: OrderStatsTargetKeys;
    stats: Array<{ __typename?: "OrderStatisticEntry"; count: number; value: string }>;
  };
};

export type GetOrderSignatureQueryVariables = Exact<{
  orderId: Scalars["String"]["input"];
}>;

export type GetOrderSignatureQuery = {
  __typename?: "Query";
  getOrderSignature?: {
    __typename?: "OrderSignatures";
    order_id: string;
    signature_id: string;
    name: string;
    practitioner_id: string;
    practitioner?: { __typename?: "Practitioners"; practitioner_id: string; npi: number } | null;
    signature?: { __typename?: "Signatures"; signature_id: string; signature_format: MimeTypes; signed_by: string; url?: any | null } | null;
  } | null;
};

export type DownloadCsvOrdersReportQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type DownloadCsvOrdersReportQuery = {
  __typename?: "Query";
  downloadCSVOrdersReport: { __typename?: "DownloadOrdersReportResults"; url: string };
};

export type RecurringOrdersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type RecurringOrdersQuery = {
  __typename?: "Query";
  getPaginatedRecurringOrders: {
    __typename?: "OrderPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename?: "Orders";
      order_id: string;
      series_id?: string | null;
      event_id?: string | null;
      title: string;
      subject_name: string;
      scheduled_date: any;
      next_scheduled_date?: any | null;
      created_at: any;
      status: OrderStatus;
      recurs: boolean;
      deleted_at?: any | null;
      patient: {
        __typename?: "Patients";
        patient_id: string;
        user: {
          __typename?: "Users";
          user_id: string;
          demographics?: {
            __typename?: "Demographics";
            cynergy_id: string;
            first_name?: string | null;
            last_name?: string | null;
            full_name?: string | null;
            dob?: string | null;
          } | null;
        };
      };
      series?: {
        __typename?: "EventSeries";
        series_id: string;
        start_time?: any | null;
        deleted_at?: any | null;
        created_at: any;
        pattern: { __typename?: "RecurrencePatterns"; pattern_id: string; text?: string | null; start_date: any; end_date?: string | null };
      } | null;
    }>;
  };
};

export type GetRecentOrdersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetRecentOrdersQuery = {
  __typename?: "Query";
  getAllOrders: Array<{
    __typename?: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    priority: RequestPriority;
    scheduled_date: any;
    subject_name: string;
    fulfilled_at?: any | null;
    created_at: any;
  }>;
};

export type GetOrderLineItemQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrderLineItemQuery = {
  __typename?: "Query";
  getOrderLineItem: {
    __typename: "OrderLineItems";
    line_item_id: string;
    description?: string | null;
    net_total: any;
    tax?: any | null;
    order: { __typename?: "Orders"; order_id: string };
    request?: {
      __typename: "ServiceRequests";
      request_id: string;
      code: string;
      status: RequestStatus;
      priority: RequestPriority;
      intent: RequestIntent;
      category: ServiceRequestCategory;
      occurrence?: any | null;
      created_at: any;
    } | null;
  };
};

export type GetOrderRenewalSourceQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrderRenewalSourceQuery = {
  __typename?: "Query";
  getOrder: {
    __typename: "Orders";
    order_id: string;
    title: string;
    description?: string | null;
    status: OrderStatus;
    status_reason?: string | null;
    priority: RequestPriority;
    recurs: boolean;
    series_id?: string | null;
    event_id?: string | null;
    is_series_source?: boolean | null;
    scheduled_date: any;
    fulfilled_at?: any | null;
    requested_collection_date?: any | null;
    is_reviewed: boolean;
    created_by: string;
    deleted_at?: any | null;
    patient: { __typename?: "Patients"; patient_id: string };
    diagnosis_codes?: Array<{ __typename: "ICD10"; icd10_code: string; label: string }> | null;
    line_items?: Array<{
      __typename?: "OrderLineItems";
      line_item_id: string;
      store_id?: string | null;
      pricebook_entry_id?: string | null;
      type_code: OrderItemTypeCode;
      request?: {
        __typename: "ServiceRequests";
        request_id: string;
        code: string;
        status: RequestStatus;
        priority: RequestPriority;
        intent: RequestIntent;
        category: ServiceRequestCategory;
        occurrence?: any | null;
        created_at: any;
        service: { __typename?: "HealthcareServices"; service_id: string };
        location: { __typename?: "Locations"; location_id: string };
      } | null;
    }> | null;
    signature?: {
      __typename?: "OrderSignatures";
      order_id: string;
      signature_id: string;
      practitioner_id: string;
      name: string;
      practitioner?: {
        __typename?: "Practitioners";
        practitioner_id: string;
        npi: number;
        demographics?: {
          __typename?: "Demographics";
          cynergy_id: string;
          full_name?: string | null;
          first_name?: string | null;
          last_name?: string | null;
        } | null;
      } | null;
      signature?: { __typename?: "Signatures"; signature_id: string; url?: any | null } | null;
    } | null;
    series?: {
      __typename: "EventSeries";
      series_id: string;
      start_time?: any | null;
      end_time?: any | null;
      pattern: {
        __typename: "RecurrencePatterns";
        pattern_id: string;
        start_date: any;
        end_date?: string | null;
        description?: string | null;
        timezone?: any | null;
        text?: string | null;
        weekly?: {
          __typename: "WeeklyRecurrencePatterns";
          pattern_id: string;
          interval: number;
          days?: Array<DaysOfWeek> | null;
          every_day: boolean;
        } | null;
        monthly?: {
          __typename: "MonthlyRecurrencePatterns";
          pattern_id: string;
          interval: number;
          day_of_month?: number | null;
          day_of_week?: DaysOfWeek | null;
          week_of_month?: WeekOfMonth | null;
        } | null;
      };
    } | null;
  };
};

export type GetOrganizationQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetOrganizationQuery = {
  __typename?: "Query";
  getOneOrganization:
    | { __typename?: "Admins" }
    | { __typename?: "Dependents" }
    | { __typename?: "Groups" }
    | { __typename?: "Organizations"; organization_id: string; alias: string; owner: { __typename: "Users"; user_id: string; cynergy_id: string } }
    | { __typename?: "Patients" }
    | { __typename?: "StaffAssignments" }
    | { __typename?: "Staffs" }
    | { __typename?: "Users" };
};

export type GetPractitionerLocationPrescriptionsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPractitionerLocationPrescriptionsQuery = {
  __typename?: "Query";
  getPractitioner: {
    __typename?: "Practitioners";
    practitioner_id: string;
    contextual_affiliation?: {
      __typename?: "PractitionerLocationAffiliations";
      location_id: string;
      prescriptions?: Array<{
        __typename: "MedicationUsages";
        usage_id: string;
        expired: boolean;
        notes?: string | null;
        dosage_instruction: string;
        status: MedicationUsageStatus;
        practitioner_id: string;
        adherence: MedicationUsageAdherence;
        date_asserted: any;
        category: MedicationRequestAdministrativeLocation;
        administration_method: string;
        administration_timing: TimingAbbreviations;
        timing_display?: string | null;
        effective: any;
        days_left: number;
        usage_status: MedicationUsageStatus;
        medication: { __typename: "Medications"; medication_id: string; brand_name: string; dose_form: string };
        effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
      }> | null;
    } | null;
  };
};

export type GetPractitionerQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPractitionerQuery = {
  __typename?: "Query";
  getPractitioner: {
    __typename: "Practitioners";
    practitioner_id: string;
    cynergy_id: string;
    registration_authority_id: string;
    npi: number;
    prefix?: string | null;
    suffix?: string | null;
    created_at: any;
    affiliation_date?: any | null;
    contacts?: Array<{
      __typename: "ContactPoints";
      contact_point_id: string;
      system: ContactPointSystem;
      use: ContactPointUse;
      value: string;
      rank: number;
      created_at: any;
    }> | null;
    qualifications?: Array<{
      __typename: "PractitionerQualifications";
      qualification_id: string;
      practitioner_id: string;
      credential: DegreeLicenseCertificate;
      label: string;
      license?: string | null;
      speciality?: string | null;
      is_verified: boolean;
      verified_on?: any | null;
      created_at: any;
    }> | null;
    demographics?: {
      __typename: "Demographics";
      cynergy_id: string;
      full_name?: string | null;
      first_name?: string | null;
      last_name?: string | null;
      prefix?: string | null;
      suffix?: string | null;
      middle_name?: string | null;
      age: number;
      deceased: boolean;
      dob?: string | null;
      ethnicity?: string | null;
      marital_status?: MaritalStatus | null;
      sex: string;
      race?: string | null;
    } | null;
    taxonomies: Array<{
      __typename: "Taxonomies";
      taxonomy_id: string;
      license?: string | null;
      code: string;
      primary: boolean;
      description: string;
      group?: string | null;
      state?: string | null;
    }>;
    identity?: {
      __typename: "CynergyUsers";
      cynergy_id: string;
      email?: string | null;
      phone?: string | null;
      status: CynergyAccountStatus;
      account_activated: boolean;
    } | null;
    contextual_affiliation?: {
      __typename: "PractitionerLocationAffiliations";
      affiliation_id: string;
      location_id: string;
      role: string;
      employee_assignment?: { __typename: "StaffAssignments"; assignment_id: string; title: string; status: EmploymentStatus } | null;
    } | null;
  };
};

export type GetPractitionerDemographicsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPractitionerDemographicsQuery = {
  __typename?: "Query";
  getPractitioner: {
    __typename: "Practitioners";
    practitioner_id: string;
    cynergy_id: string;
    registration_authority_id: string;
    npi: number;
    prefix?: string | null;
    suffix?: string | null;
    created_at: any;
    affiliation_date?: any | null;
    demographics?: {
      __typename: "Demographics";
      cynergy_id: string;
      full_name?: string | null;
      first_name?: string | null;
      last_name?: string | null;
      prefix?: string | null;
      suffix?: string | null;
      middle_name?: string | null;
      age: number;
      deceased: boolean;
      dob?: string | null;
      ethnicity?: string | null;
      marital_status?: MaritalStatus | null;
      sex: string;
      race?: string | null;
    } | null;
    identity?: { __typename: "CynergyUsers"; cynergy_id: string; email?: string | null; phone?: string | null } | null;
  };
};

export type GetPaginatedPractitionersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedPractitionersQuery = {
  __typename?: "Query";
  getPaginatedPractitioners: {
    __typename?: "PractitionerPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "Practitioners";
      practitioner_id: string;
      cynergy_id: string;
      registration_authority_id: string;
      npi: number;
      prefix?: string | null;
      suffix?: string | null;
      created_at: any;
      affiliation_date?: any | null;
      contacts?: Array<{
        __typename: "ContactPoints";
        contact_point_id: string;
        system: ContactPointSystem;
        use: ContactPointUse;
        value: string;
        rank: number;
        created_at: any;
      }> | null;
      qualifications?: Array<{
        __typename: "PractitionerQualifications";
        qualification_id: string;
        practitioner_id: string;
        credential: DegreeLicenseCertificate;
        label: string;
        license?: string | null;
        speciality?: string | null;
        is_verified: boolean;
        verified_on?: any | null;
        created_at: any;
      }> | null;
      demographics?: {
        __typename: "Demographics";
        cynergy_id: string;
        full_name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
        prefix?: string | null;
        suffix?: string | null;
        middle_name?: string | null;
        age: number;
        deceased: boolean;
        dob?: string | null;
        ethnicity?: string | null;
        marital_status?: MaritalStatus | null;
        sex: string;
        race?: string | null;
      } | null;
      contextual_affiliation?: {
        __typename: "PractitionerLocationAffiliations";
        affiliation_id: string;
        location_id: string;
        role: string;
        created_at: any;
        employee_assignment?: { __typename: "StaffAssignments"; assignment_id: string; title: string; status: EmploymentStatus } | null;
      } | null;
    }>;
  };
};

export type DownloadCsvPractitionersReportQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type DownloadCsvPractitionersReportQuery = {
  __typename?: "Query";
  downloadCSVPractitionersReport: { __typename?: "DownloadPractitionersReportResults"; url: string };
};

export type GetPaginatedEmployeeAssignmentsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetPaginatedEmployeeAssignmentsQuery = {
  __typename?: "Query";
  getPaginatedStaffAssignments: {
    __typename?: "StaffAssignmentPaginatedResponse";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "StaffAssignments";
      assignment_id: string;
      staff_id: string;
      location_id: string;
      organization_id: string;
      status: EmploymentStatus;
      title: string;
      hire_date: any;
      employee: {
        __typename: "Staffs";
        staff_id: string;
        created_at: any;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          username: string;
          account?: { __typename?: "CynergyAccounts"; account_id: string } | null;
          identity?: {
            __typename: "CynergyUsers";
            cynergy_id: string;
            email?: string | null;
            phone?: string | null;
            username: string;
            validated: boolean;
            is_default?: boolean | null;
            created_at: any;
            updated_at?: any | null;
          } | null;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type NpiLookupQueryVariables = Exact<{
  search: Array<NpiRegistrySearchTerm> | NpiRegistrySearchTerm;
  pagination?: InputMaybe<PaginationArgs>;
}>;

export type NpiLookupQuery = {
  __typename?: "Query";
  npiLookup: Array<{
    __typename: "NpiRegistryProfiles";
    npi: string;
    registration_date: any;
    type: NpiEnumerationType;
    demographics: {
      __typename?: "NPIDemographicInformation";
      first_name: string;
      last_name: string;
      credential: string;
      sole_proprietor?: string | null;
      status: string;
      prefix?: string | null;
      suffix?: string | null;
    };
  }>;
};

export type NpiExistsQueryVariables = Exact<{
  search: Array<NpiRegistrySearchTerm> | NpiRegistrySearchTerm;
  pagination?: InputMaybe<PaginationArgs>;
}>;

export type NpiExistsQuery = {
  __typename?: "Query";
  npiLookup: Array<{
    __typename: "NpiRegistryProfiles";
    npi: string;
    type: NpiEnumerationType;
    taxonomies?: Array<{ __typename?: "NpiTaxonomies"; primary: boolean; description: string }> | null;
    demographics: { __typename?: "NPIDemographicInformation"; first_name: string; last_name: string };
  }>;
};

export type PractitionersFeedQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type PractitionersFeedQuery = {
  __typename?: "Query";
  practitionersFeed: {
    __typename?: "PractitionerPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename: "Practitioners";
      practitioner_id: string;
      cynergy_id: string;
      registration_authority_id: string;
      npi: number;
      prefix?: string | null;
      suffix?: string | null;
      created_at: any;
      affiliation_date?: any | null;
      contacts?: Array<{
        __typename: "ContactPoints";
        contact_point_id: string;
        system: ContactPointSystem;
        use: ContactPointUse;
        value: string;
        rank: number;
        created_at: any;
      }> | null;
      qualifications?: Array<{
        __typename: "PractitionerQualifications";
        qualification_id: string;
        practitioner_id: string;
        credential: DegreeLicenseCertificate;
        label: string;
        license?: string | null;
        speciality?: string | null;
        is_verified: boolean;
        verified_on?: any | null;
        created_at: any;
      }> | null;
      demographics?: {
        __typename: "Demographics";
        cynergy_id: string;
        full_name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
        prefix?: string | null;
        suffix?: string | null;
        middle_name?: string | null;
        age: number;
        deceased: boolean;
        dob?: string | null;
        ethnicity?: string | null;
        marital_status?: MaritalStatus | null;
        sex: string;
        race?: string | null;
      } | null;
    }>;
  };
};

export type GetPaginatedPractitionerPrescriptionsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedPractitionerPrescriptionsQuery = {
  __typename?: "Query";
  getPaginatedPractitioners: {
    __typename?: "PractitionerPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename?: "Practitioners";
      practitioner_id: string;
      contextual_affiliation?: {
        __typename?: "PractitionerLocationAffiliations";
        location_id: string;
        prescriptions?: Array<{
          __typename: "MedicationUsages";
          usage_id: string;
          expired: boolean;
          notes?: string | null;
          dosage_instruction: string;
          status: MedicationUsageStatus;
          practitioner_id: string;
          adherence: MedicationUsageAdherence;
          date_asserted: any;
          category: MedicationRequestAdministrativeLocation;
          administration_method: string;
          administration_timing: TimingAbbreviations;
          timing_display?: string | null;
          effective: any;
          days_left: number;
          usage_status: MedicationUsageStatus;
          medication: { __typename: "Medications"; medication_id: string; brand_name: string; dose_form: string };
          effective_period: { __typename: "Periods"; period_id: string; start?: any | null; end?: any | null };
        }> | null;
      } | null;
    }>;
  };
};

export type GetPractitionerSignatureQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPractitionerSignatureQuery = {
  __typename?: "Query";
  getPractitionerSignature: {
    __typename: "PractitionerSignatures";
    signature_id: string;
    signature_format: MimeTypes;
    url: string;
    when: any;
    who: {
      __typename: "Practitioners";
      practitioner_id: string;
      npi: number;
      prefix?: string | null;
      suffix?: string | null;
      demographics?: { __typename: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
    };
  };
};

export type GetUserProductBundleQueryVariables = Exact<{
  bundleId: Scalars["ID"]["input"];
}>;

export type GetUserProductBundleQuery = {
  __typename?: "Query";
  getUserProductBundle: {
    __typename: "UserProductBundles";
    bundle_id: string;
    account_id: string;
    name: string;
    owner: string;
    is_shared: boolean;
    description?: string | null;
    created_at: any;
    items?: Array<{
      __typename: "UserProductBundleItems";
      bundle_item_id: string;
      name: string;
      sequence: number;
      product_id: string;
      pricebook_entry_id: string;
      store_id: string;
      product: {
        __typename: "Products";
        code: string;
        name: string;
        product_id: string;
        description?: string | null;
        family: CommerceProductFamily;
        isInCart?: boolean | null;
        isWishListed?: boolean | null;
        resource: {
          __typename: "HealthcareServices";
          service_id: string;
          name: string;
          type: string;
          category: ServiceRequestCategory;
          active: boolean;
          speciality?: Array<string> | null;
        };
        attributes?: Array<{
          __typename: "Attributes";
          attribute_id: string;
          attribute: string;
          name: string;
          values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
        }> | null;
      };
      price_entry: { __typename: "PriceBookEntries"; entry_id: string; name: string; product_code: string; unit_price: any };
      store: { __typename?: "WebStores"; store_id: string; name: string; location: { __typename?: "Locations"; location_id: string } };
    }> | null;
  };
};

export type GetAllUserProductBundlesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  scope?: InputMaybe<RecordAccessScope>;
}>;

export type GetAllUserProductBundlesQuery = {
  __typename?: "Query";
  getAllUserProductBundles: Array<{
    __typename: "UserProductBundles";
    bundle_id: string;
    account_id: string;
    name: string;
    owner: string;
    is_shared: boolean;
    description?: string | null;
    created_at: any;
  }>;
};

export type GetPaginatedUserProductBundlesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  scope?: InputMaybe<RecordAccessScope>;
}>;

export type GetPaginatedUserProductBundlesQuery = {
  __typename?: "Query";
  getPaginatedUserProductBundles: {
    __typename?: "UserProductBundlePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "UserProductBundles";
      bundle_id: string;
      account_id: string;
      name: string;
      owner: string;
      is_shared: boolean;
      description?: string | null;
      created_at: any;
      items?: Array<{
        __typename: "UserProductBundleItems";
        bundle_item_id: string;
        name: string;
        sequence: number;
        product_id: string;
        pricebook_entry_id: string;
        store_id: string;
        product: {
          __typename: "Products";
          code: string;
          name: string;
          product_id: string;
          description?: string | null;
          family: CommerceProductFamily;
          isInCart?: boolean | null;
          isWishListed?: boolean | null;
          resource: {
            __typename: "HealthcareServices";
            service_id: string;
            name: string;
            type: string;
            category: ServiceRequestCategory;
            active: boolean;
            speciality?: Array<string> | null;
          };
          attributes?: Array<{
            __typename: "Attributes";
            attribute_id: string;
            attribute: string;
            name: string;
            values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
          }> | null;
        };
        price_entry: { __typename: "PriceBookEntries"; entry_id: string; name: string; product_code: string; unit_price: any };
        store: { __typename?: "WebStores"; store_id: string; name: string; location: { __typename?: "Locations"; location_id: string } };
      }> | null;
    }>;
  };
};

export type UserProductBundlesFeedQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  scope?: InputMaybe<RecordAccessScope>;
}>;

export type UserProductBundlesFeedQuery = {
  __typename?: "Query";
  userProductBundlesFeed: {
    __typename?: "UserProductBundlePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "UserProductBundles";
      bundle_id: string;
      account_id: string;
      name: string;
      owner: string;
      is_shared: boolean;
      description?: string | null;
      created_at: any;
      items?: Array<{
        __typename: "UserProductBundleItems";
        bundle_item_id: string;
        name: string;
        sequence: number;
        product_id: string;
        pricebook_entry_id: string;
        store_id: string;
        product: {
          __typename: "Products";
          code: string;
          name: string;
          product_id: string;
          description?: string | null;
          family: CommerceProductFamily;
          isInCart?: boolean | null;
          isWishListed?: boolean | null;
          resource: {
            __typename: "HealthcareServices";
            service_id: string;
            name: string;
            type: string;
            category: ServiceRequestCategory;
            active: boolean;
            speciality?: Array<string> | null;
          };
          attributes?: Array<{
            __typename: "Attributes";
            attribute_id: string;
            attribute: string;
            name: string;
            values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
          }> | null;
        };
        price_entry: { __typename: "PriceBookEntries"; entry_id: string; name: string; product_code: string; unit_price: any };
        store: { __typename?: "WebStores"; store_id: string; name: string; location: { __typename?: "Locations"; location_id: string } };
      }> | null;
    }>;
  };
};

export type GetUserProductBundleSharesQueryVariables = Exact<{
  bundleId: Scalars["ID"]["input"];
}>;

export type GetUserProductBundleSharesQuery = {
  __typename?: "Query";
  getUserProductBundleShares: Array<{
    __typename?: "UserProductBundleShares";
    bundle_id: string;
    share_id: string;
    account_id?: string | null;
    group_id?: string | null;
    group?: { __typename?: "AccessGroups"; group_id: string; name: string; type: AccessGroupType } | null;
    account?: {
      __typename?: "CynergyAccounts";
      account_id: string;
      user: {
        __typename?: "CynergyUsers";
        cynergy_id: string;
        demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
      };
    } | null;
  }>;
};

export type GetProductQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetProductQuery = {
  __typename?: "Query";
  getProduct: {
    __typename: "Products";
    code: string;
    name: string;
    product_id: string;
    description?: string | null;
    family: CommerceProductFamily;
    isInCart?: boolean | null;
    isWishListed?: boolean | null;
    attributes?: Array<{
      __typename: "Attributes";
      attribute_id: string;
      attribute: string;
      name: string;
      values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
    }> | null;
    image?: {
      __typename?: "Attachments";
      attachment_id: string;
      size?: number | null;
      width?: number | null;
      height?: number | null;
      url?: string | null;
    } | null;
  };
};

export type GetAllProductsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetAllProductsQuery = {
  __typename?: "Query";
  getAllProducts: Array<{
    __typename: "Products";
    code: string;
    name: string;
    product_id: string;
    description?: string | null;
    family: CommerceProductFamily;
    isInCart?: boolean | null;
    isWishListed?: boolean | null;
  }>;
};

export type GetPaginatedProductsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedProductsQuery = {
  __typename?: "Query";
  getPaginatedProducts: {
    __typename?: "ProductPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "Products";
      code: string;
      name: string;
      product_id: string;
      description?: string | null;
      family: CommerceProductFamily;
      isInCart?: boolean | null;
      isWishListed?: boolean | null;
    }>;
  };
};

export type ProductResourceQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type ProductResourceQuery = {
  __typename?: "Query";
  productResource: {
    __typename?: "Products";
    code: string;
    family: CommerceProductFamily;
    resource: {
      __typename?: "HealthcareServices";
      service_id: string;
      name: string;
      service_identifier: { __typename?: "Identifiers"; identifier_id: string; value: string; type: IdentifierType };
    };
  };
};

export type GetAllProductResourcesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllProductResourcesQuery = {
  __typename?: "Query";
  getAllProductResources: Array<{
    __typename: "Products";
    code: string;
    resource: {
      __typename: "HealthcareServices";
      service_id: string;
      name: string;
      type: string;
      category: ServiceRequestCategory;
      active: boolean;
      speciality?: Array<string> | null;
    };
  }>;
};

export type CatalogProductsQueryVariables = Exact<{
  distance?: InputMaybe<DistanceInput>;
  type?: InputMaybe<CommerceProductFamily>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  searchBy?: InputMaybe<CatalogProductSearchBy>;
}>;

export type CatalogProductsQuery = {
  __typename?: "Query";
  catalogProducts: {
    __typename?: "CatalogProductPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename?: "CatalogProductResult";
      id: string;
      is_starred: boolean;
      store: {
        __typename?: "WebStores";
        store_id: string;
        code: string;
        name: string;
        type: CommerceStoreType;
        distance?: number | null;
        location: { __typename?: "Locations"; location_id: string; alias?: string | null };
      };
      product: {
        __typename: "Products";
        code: string;
        name: string;
        product_id: string;
        description?: string | null;
        family: CommerceProductFamily;
        isInCart?: boolean | null;
        isWishListed?: boolean | null;
        attributes?: Array<{
          __typename?: "Attributes";
          attribute_id: string;
          attribute: string;
          name: string;
          values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
        }> | null;
      };
      price: { __typename: "PriceBookEntries"; entry_id: string; name: string; product_code: string; unit_price: any };
    }>;
  };
};

export type ProductServiceLocationsQueryVariables = Exact<{
  distance?: InputMaybe<DistanceInput>;
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type ProductServiceLocationsQuery = {
  __typename?: "Query";
  productServiceLocations: {
    __typename?: "StoreProductPaginatedResults";
    count: number;
    totalPages: number;
    currentPage: number;
    rows: Array<{
      __typename?: "StoreProductResult";
      store: {
        __typename?: "WebStores";
        code: string;
        name: string;
        distance?: number | null;
        location: {
          __typename?: "Locations";
          location_id: string;
          alias?: string | null;
          address: {
            __typename?: "WebCynergyAddresses";
            address_id: string;
            formatted_address?: string | null;
            latitude?: number | null;
            longitude?: number | null;
          };
        };
      };
      product: { __typename?: "Products"; product_id: string; name: string; code: string };
      price: { __typename?: "PriceBookEntries"; entry_id: string; unit_price: any };
    }>;
  };
};

export type GetStoreProductQueryVariables = Exact<{
  productCode: Scalars["String"]["input"];
  storeCode: Scalars["String"]["input"];
}>;

export type GetStoreProductQuery = {
  __typename?: "Query";
  getStoreProduct: {
    __typename?: "CatalogProductResult";
    id: string;
    product: {
      __typename: "Products";
      code: string;
      name: string;
      product_id: string;
      description?: string | null;
      family: CommerceProductFamily;
      isInCart?: boolean | null;
      isWishListed?: boolean | null;
      attributes?: Array<{
        __typename: "Attributes";
        attribute_id: string;
        attribute: string;
        name: string;
        values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
      }> | null;
      tags?: Array<{ __typename: "Tags"; tag_id: string; tag: string; name: string; slug?: string | null; icon_url?: string | null }> | null;
      image?: { __typename?: "Attachments"; attachment_id: string; url?: string | null } | null;
    };
    store: { __typename?: "WebStores"; code: string; location: { __typename?: "Locations"; location_id: string; alias?: string | null } };
    price: { __typename: "PriceBookEntries"; entry_id: string; name: string; product_code: string; unit_price: any };
  };
};

export type DownloadDailyLabReportQueryVariables = Exact<{
  options?: InputMaybe<ReportSummaryInput>;
}>;

export type DownloadDailyLabReportQuery = { __typename?: "Query"; downloadDailyLabReport: { __typename?: "DownloadReportResults"; url: any } };

export type DownloadBulkOrderResultsReportQueryVariables = Exact<{
  input: BulkOrderResultsExportInput;
}>;

export type DownloadBulkOrderResultsReportQuery = {
  __typename?: "Query";
  downloadBulkOrderResultsReport: { __typename?: "DownloadReportResults"; url: any };
};

export type GetAllIcd10CodesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetAllIcd10CodesQuery = { __typename?: "Query"; getAllICD10Codes: Array<{ __typename?: "ICD10"; label: string; icd10_code: string }> };

export type GetPaginatedIcd10CodesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedIcd10CodesQuery = {
  __typename?: "Query";
  getPaginatedICD10Codes: {
    __typename?: "ICD10CodePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{ __typename?: "ICD10"; label: string; icd10_code: string; is_starred: boolean }>;
  };
};

export type GroupedIcd10CodeListQueryVariables = Exact<{
  subjectPatientId?: InputMaybe<Scalars["String"]["input"]>;
  groupSizeLimit?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type GroupedIcd10CodeListQuery = {
  __typename?: "Query";
  getGroupedICD10Codes: {
    __typename?: "GroupedICD10CodesResult";
    favorites: {
      __typename?: "DiagnosisCodeGroupObject";
      count: number;
      name: string;
      type: DiagnosisCodeGroupType;
      codes: Array<{ __typename?: "ICD10"; icd10_code: string; label: string; is_starred: boolean }>;
    };
    recentDiagnosis: {
      __typename?: "DiagnosisCodeGroupObject";
      count: number;
      name: string;
      type: DiagnosisCodeGroupType;
      codes: Array<{ __typename?: "ICD10"; icd10_code: string; label: string; is_starred: boolean }>;
    };
  };
};

export type PreviewRecurrenceScheduleQueryVariables = Exact<{
  recurrence: RecurrencePatternCreateInput;
  count?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type PreviewRecurrenceScheduleQuery = {
  __typename?: "Query";
  previewRecurrenceSchedule: { __typename?: "RecurrenceSchedulePreview"; text: string; dates: Array<any> };
};

export type PreviewRenewalWindowQueryVariables = Exact<{
  patternId: Scalars["String"]["input"];
}>;

export type PreviewRenewalWindowQuery = {
  __typename?: "Query";
  previewRenewalWindow: { __typename?: "RecurrenceScheduleRenewalWindow"; start: any; end: any };
};

export type GetHealthcareServiceQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetHealthcareServiceQuery = {
  __typename?: "Query";
  getHealthcareService: {
    __typename: "HealthcareServices";
    service_id: string;
    name: string;
    type: string;
    category: ServiceRequestCategory;
    active: boolean;
    speciality?: Array<string> | null;
    service_identifier: { __typename?: "Identifiers"; identifier_id: string; value: string; type: IdentifierType };
  };
};

export type GetPaginatedHealthcareServicesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedHealthcareServicesQuery = {
  __typename?: "Query";
  getPaginatedHealthcareServices: {
    __typename?: "HealthcareServicePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "HealthcareServices";
      service_id: string;
      name: string;
      type: string;
      category: ServiceRequestCategory;
      active: boolean;
      speciality?: Array<string> | null;
      locations?: Array<{
        __typename: "HealthcareServiceLocations";
        service_location_id: string;
        distance?: number | null;
        location: {
          __typename?: "Locations";
          alias?: string | null;
          location_id: string;
          name: string;
          description?: string | null;
          phone?: string | null;
          preferred_member: boolean;
          organization_id: string;
          todays_operating_hours: string;
          open_now: boolean;
          location_role: string;
          location_status: string;
          meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
        };
      }> | null;
      organization: { __typename: "Organizations"; organization_id: string; name: string; alias: string };
      service_identifier: { __typename: "Identifiers"; identifier_id: string; value: string };
    }>;
  };
};

export type GetHealthcareServiceLocationQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetHealthcareServiceLocationQuery = {
  __typename?: "Query";
  getHealthcareServiceLocation: {
    __typename: "HealthcareServiceLocations";
    service_location_id: string;
    distance?: number | null;
    service: {
      __typename: "HealthcareServices";
      service_id: string;
      name: string;
      type: string;
      category: ServiceRequestCategory;
      active: boolean;
      speciality?: Array<string> | null;
    };
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      description?: string | null;
      phone?: string | null;
      preferred_member: boolean;
      organization_id: string;
      todays_operating_hours: string;
      open_now: boolean;
      location_role: string;
      location_status: string;
      address: {
        __typename: "WebCynergyAddresses";
        address_id: string;
        city: string;
        state: string;
        zip: string;
        address_line_1: string;
        address_line_2?: string | null;
        nickname?: string | null;
        formatted_address?: string | null;
        type: string;
        longitude?: number | null;
        latitude?: number | null;
        is_default: boolean;
        place_id?: string | null;
      };
      meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
    };
  };
};

export type GetAllHealthcareServiceLocationsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllHealthcareServiceLocationsQuery = {
  __typename?: "Query";
  getAllHealthcareServiceLocations: Array<{
    __typename: "HealthcareServiceLocations";
    service_location_id: string;
    distance?: number | null;
    service: {
      __typename: "HealthcareServices";
      service_id: string;
      name: string;
      type: string;
      category: ServiceRequestCategory;
      active: boolean;
      speciality?: Array<string> | null;
    };
    location: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      name: string;
      description?: string | null;
      phone?: string | null;
      preferred_member: boolean;
      organization_id: string;
      todays_operating_hours: string;
      open_now: boolean;
      location_role: string;
      location_status: string;
      meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
    };
  }>;
};

export type GetHealthcareServiceLocationsQueryVariables = Exact<{
  distance?: InputMaybe<DistanceInput>;
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
}>;

export type GetHealthcareServiceLocationsQuery = {
  __typename?: "Query";
  getHealthcareServiceLocations: {
    __typename?: "HealthcareServiceLocationPaginatedResults";
    count: number;
    rows: Array<{
      __typename: "HealthcareServiceLocations";
      service_location_id: string;
      distance?: number | null;
      service: {
        __typename: "HealthcareServices";
        service_id: string;
        name: string;
        type: string;
        category: ServiceRequestCategory;
        active: boolean;
        speciality?: Array<string> | null;
      };
      location: {
        __typename?: "Locations";
        location_id: string;
        alias?: string | null;
        name: string;
        description?: string | null;
        phone?: string | null;
        preferred_member: boolean;
        organization_id: string;
        todays_operating_hours: string;
        open_now: boolean;
        location_role: string;
        location_status: string;
        address: {
          __typename: "WebCynergyAddresses";
          address_id: string;
          city: string;
          state: string;
          zip: string;
          address_line_1: string;
          address_line_2?: string | null;
          nickname?: string | null;
          formatted_address?: string | null;
          type: string;
          longitude?: number | null;
          latitude?: number | null;
          is_default: boolean;
          place_id?: string | null;
        };
        meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
      };
    }>;
  };
};

export type GetDiagnosticServiceQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetDiagnosticServiceQuery = {
  __typename?: "Query";
  getDiagnosticService: {
    __typename?: "DiagnosticServices";
    service_id: string;
    title: string;
    subtitle?: string | null;
    type: LaboratoryServiceType;
  };
};

export type DiagnosticServiceBiomarkersQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type DiagnosticServiceBiomarkersQuery = {
  __typename?: "Query";
  getDiagnosticService: {
    __typename?: "DiagnosticServices";
    service_id: string;
    biomarkers?: Array<{
      __typename?: "ObservationDefinitions";
      definition_id: string;
      title: string;
      type: ObservationTypCode;
      method?: string | null;
      category: ObservationCategory;
      members?: Array<{
        __typename?: "ObservationDefinitions";
        definition_id: string;
        title: string;
        type: ObservationTypCode;
        method?: string | null;
        category: ObservationCategory;
      }> | null;
      components?: Array<{ __typename?: "ObservationDefinitionComponents"; component_id: string; name?: string | null }> | null;
    }> | null;
  };
};

export type GetLayoutSettingQueryVariables = Exact<{
  applicationId: Scalars["String"]["input"];
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetLayoutSettingQuery = {
  __typename?: "Query";
  getLayoutSetting: {
    __typename?: "LayoutSettings";
    layout_setting_id: string;
    settings: { __typename: "Settings"; setting_id: string };
    layouts: Array<{
      __typename?: "LayoutPreferences";
      page: SharedApplicationPages;
      layout: Array<{
        __typename: "ComponentLayoutConfiguration";
        id: string;
        component: string;
        props?: any | null;
        column: {
          __typename: "GridLayoutProperties";
          xs?: number | null;
          sm?: number | null;
          md?: number | null;
          lg?: number | null;
          xl?: number | null;
          xxl?: number | null;
        };
        position: { __typename: "LayoutPosition"; x: number; y: number };
      }>;
    }>;
  };
};

export type SignatureAuditsQueryVariables = Exact<{
  practitionerId: Scalars["ID"]["input"];
}>;

export type SignatureAuditsQuery = {
  __typename?: "Query";
  signatureAudits: Array<{
    __typename?: "SignatureAuditResponse";
    auditId: string;
    type: SignatureEventType;
    reason?: string | null;
    createdAt: any;
    createdBy: string;
    actorCynergyId?: string | null;
    cynergyId: string;
    referenceId?: string | null;
  }>;
};

export type SiteCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type SiteCategoriesQuery = {
  __typename?: "Query";
  catalogCategories: Array<{
    __typename?: "WebStoreCategoryDefinitions";
    definition_id: string;
    name: string;
    label: string;
    type: CommerceProductFamily;
    slug: string;
  }>;
};

export type GetTaskCountQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetTaskCountQuery = { __typename?: "Query"; getTaskCount: number };

export type GetTaskStatisticsQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetTaskStatisticsQuery = {
  __typename?: "Query";
  getTaskStatistics: {
    __typename?: "TaskStatisticsResponse";
    total: number;
    new_tasks: number;
    open_tasks: number;
    cancelled_tasks: number;
    completed_tasks: number;
    completion_percentage: number;
  };
};

export type GetTaskQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetTaskQuery = {
  __typename?: "Query";
  getTask: {
    __typename: "Tasks";
    task_id: string;
    notification_id?: string | null;
    title: string;
    description: string;
    status: TaskStatus;
    business_status: string;
    status_reason?: TaskStatusReason | null;
    label: TaskLabels;
    progress: number;
    code: TaskCode;
    reason: string;
    url?: string | null;
    link?: string | null;
    priority: RequestPriority;
    do_not_perform: boolean;
    assignee_function: ActionParticipantFunction;
    assignee_role: string;
    last_modified?: any | null;
    started_at?: any | null;
    completed_at?: any | null;
    created_at: any;
    requested_period: { __typename: "Periods"; start?: any | null; end?: any | null; period_id: string };
    patient?: {
      __typename: "Patients";
      patient_id: string;
      user: { __typename: "Users"; cynergy_id: string; user_id: string; username: string };
    } | null;
    steps?: Array<{
      __typename: "TaskSteps";
      step_id: string;
      label: string;
      description: string;
      status: TaskStatus;
      order: number;
      required: boolean;
      progress: number;
      link?: string | null;
      url?: string | null;
      status_reason?: TaskStatusReason | null;
      started_at?: any | null;
      focus: {
        __typename: "References";
        reference_id: string;
        type: string;
        display: string;
        reference?: string | null;
        identifier?: {
          __typename: "Identifiers";
          identifier_id: string;
          type: IdentifierType;
          value: string;
          use: IdentifierUse;
          system?: string | null;
        } | null;
      };
    }> | null;
    assignee:
      | { __typename?: "Organizations" }
      | { __typename?: "Patients" }
      | { __typename?: "Practitioners" }
      | {
          __typename: "StaffAssignments";
          assignment_id: string;
          staff_id: string;
          location_id: string;
          organization_id: string;
          status: EmploymentStatus;
          title: string;
          hire_date: any;
        };
    based_on: {
      __typename: "References";
      reference_id: string;
      type: string;
      display: string;
      reference?: string | null;
      identifier?: {
        __typename: "Identifiers";
        identifier_id: string;
        type: IdentifierType;
        value: string;
        use: IdentifierUse;
        system?: string | null;
      } | null;
    };
  };
};

export type GetAllTasksQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetAllTasksQuery = {
  __typename?: "Query";
  getAllTasks: Array<{
    __typename: "Tasks";
    task_id: string;
    notification_id?: string | null;
    title: string;
    description: string;
    status: TaskStatus;
    business_status: string;
    status_reason?: TaskStatusReason | null;
    label: TaskLabels;
    progress: number;
    code: TaskCode;
    reason: string;
    url?: string | null;
    link?: string | null;
    priority: RequestPriority;
    do_not_perform: boolean;
    assignee_function: ActionParticipantFunction;
    assignee_role: string;
    last_modified?: any | null;
    started_at?: any | null;
    completed_at?: any | null;
    created_at: any;
    requested_period: { __typename: "Periods"; start?: any | null; end?: any | null; period_id: string };
    patient?: {
      __typename: "Patients";
      patient_id: string;
      user: {
        __typename: "Users";
        cynergy_id: string;
        user_id: string;
        username: string;
        demographics?: { __typename: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
      };
    } | null;
    assignee:
      | { __typename?: "Organizations" }
      | { __typename?: "Patients" }
      | { __typename?: "Practitioners" }
      | {
          __typename: "StaffAssignments";
          assignment_id: string;
          staff_id: string;
          location_id: string;
          organization_id: string;
          status: EmploymentStatus;
          title: string;
          hire_date: any;
          employee: {
            __typename: "Staffs";
            staff_id: string;
            created_at: any;
            user: {
              __typename: "Users";
              cynergy_id: string;
              user_id: string;
              username: string;
              demographics?: { __typename: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
            };
          };
        };
    based_on: {
      __typename: "References";
      reference_id: string;
      type: string;
      display: string;
      reference?: string | null;
      identifier?: {
        __typename: "Identifiers";
        identifier_id: string;
        type: IdentifierType;
        value: string;
        use: IdentifierUse;
        system?: string | null;
      } | null;
    };
  }>;
};

export type GetPaginatedTasksQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  sort?: InputMaybe<SortingArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type GetPaginatedTasksQuery = {
  __typename?: "Query";
  getPaginatedTasks: {
    __typename?: "TaskPaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "Tasks";
      task_id: string;
      notification_id?: string | null;
      title: string;
      description: string;
      status: TaskStatus;
      business_status: string;
      status_reason?: TaskStatusReason | null;
      label: TaskLabels;
      progress: number;
      code: TaskCode;
      reason: string;
      url?: string | null;
      link?: string | null;
      priority: RequestPriority;
      do_not_perform: boolean;
      assignee_function: ActionParticipantFunction;
      assignee_role: string;
      last_modified?: any | null;
      started_at?: any | null;
      completed_at?: any | null;
      created_at: any;
      requested_period: { __typename: "Periods"; start?: any | null; end?: any | null; period_id: string };
      patient?: {
        __typename: "Patients";
        patient_id: string;
        user: {
          __typename: "Users";
          cynergy_id: string;
          user_id: string;
          username: string;
          demographics?: {
            __typename: "Demographics";
            cynergy_id: string;
            full_name?: string | null;
            first_name?: string | null;
            last_name?: string | null;
            prefix?: string | null;
            suffix?: string | null;
            middle_name?: string | null;
            age: number;
            deceased: boolean;
            dob?: string | null;
            ethnicity?: string | null;
            marital_status?: MaritalStatus | null;
            sex: string;
            race?: string | null;
          } | null;
        };
      } | null;
      assignee:
        | { __typename?: "Organizations" }
        | { __typename?: "Patients" }
        | { __typename?: "Practitioners" }
        | {
            __typename: "StaffAssignments";
            assignment_id: string;
            staff_id: string;
            location_id: string;
            organization_id: string;
            status: EmploymentStatus;
            title: string;
            hire_date: any;
            employee: {
              __typename?: "Staffs";
              staff_id: string;
              user: {
                __typename?: "Users";
                user_id: string;
                demographics?: { __typename?: "Demographics"; cynergy_id: string; full_name?: string | null } | null;
              };
            };
          };
      based_on: {
        __typename: "References";
        reference_id: string;
        type: string;
        display: string;
        reference?: string | null;
        identifier?: {
          __typename: "Identifiers";
          identifier_id: string;
          type: IdentifierType;
          value: string;
          use: IdentifierUse;
          system?: string | null;
        } | null;
      };
    }>;
  };
};

export type GetUserTestHistoryNonReportingQueryVariables = Exact<{
  testCode: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
}>;

export type GetUserTestHistoryNonReportingQuery = {
  __typename?: "Query";
  getUserTestHistoryNonReporting: Array<{
    __typename?: "TestHistoryNonReportingData";
    observation_id: string;
    test_name?: string | null;
    test_code: string;
    flag?: string | null;
    result_value?: number | null;
    result_created_at?: any | null;
  }>;
};

export type UserTimelineQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
}>;

export type UserTimelineQuery = {
  __typename?: "Query";
  userTimeline: {
    __typename?: "TimelinePaginatedResults";
    count: number;
    currentPage: number;
    totalPages: number;
    rows: Array<{
      __typename: "TimelineEntry";
      id: string;
      title: string;
      message: string;
      action: ActionType;
      timestamp: any;
      subject: { __typename: "TimelineSubject"; id: string; type: UserTypes; name: string };
      reference?: { __typename: "TimelineTargetReference"; id?: string | null; resource: string } | null;
      extras?: { __typename: "TimelineExtras"; category?: FlagCategory | null; link?: string | null; meta?: any | null } | null;
    }>;
  };
};

export type GetFeedItemsQueryVariables = Exact<{
  sort?: InputMaybe<SortingArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  parameters: FeedElementSearchArgs;
}>;

export type GetFeedItemsQuery = {
  __typename?: "Query";
  getPaginatedFeedItems: {
    __typename?: "FeedElementCollectionObject";
    count: number;
    currentPage: number;
    totalPages: number;
    elements: Array<{
      __typename: "FeedItemObject";
      id: string;
      elementType: FeedElementType;
      publishDate: any;
      relativePublishedDate: string;
      actor?: { __typename: "FeedActorObject"; id: string; type: FeedActorType; name: string; url?: any | null } | null;
      header: {
        __typename: "MessageBodyObject";
        text?: string | null;
        isRichText: boolean;
        messageSegments?: Array<
          | { __typename?: "MessageSegmentLinkObject"; type: MessageSegmentType; text?: string | null; linkUrl: any }
          | {
              __typename: "MessageSegmentMarkupBeginObject";
              text?: string | null;
              type: MessageSegmentType;
              altText?: string | null;
              htmlTag: string;
              markupType: MessageMarkupType;
              url?: any | null;
            }
          | {
              __typename: "MessageSegmentMarkupEndObject";
              text?: string | null;
              type: MessageSegmentType;
              htmlTag: string;
              markupType: MessageMarkupType;
            }
          | { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType }
        > | null;
      };
      body?: {
        __typename: "MessageBodyObject";
        text?: string | null;
        isRichText: boolean;
        messageSegments?: Array<
          | { __typename: "MessageSegmentLinkObject"; text?: string | null; type: MessageSegmentType; linkUrl: any }
          | {
              __typename: "MessageSegmentMarkupBeginObject";
              text?: string | null;
              type: MessageSegmentType;
              altText?: string | null;
              htmlTag: string;
              markupType: MessageMarkupType;
              url?: any | null;
            }
          | {
              __typename: "MessageSegmentMarkupEndObject";
              text?: string | null;
              type: MessageSegmentType;
              htmlTag: string;
              markupType: MessageMarkupType;
            }
          | { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType }
        > | null;
      } | null;
      capabilities?: {
        __typename?: "FeedElementCapabilitiesObject";
        bundle?:
          | { __typename: "FeedBundleCapabilityObject"; bundleType: FeedBundleType; totalElements: number }
          | {
              __typename?: "TrackedChangeBundleCapabilityObject";
              changes: Array<{
                __typename: "TrackedChangeItemObject";
                fieldName: string;
                newValue?: string | null;
                oldValue?: string | null;
                summary?: string | null;
              }>;
            }
          | null;
      } | null;
    }>;
  };
};

export type UserSessionQueryVariables = Exact<{ [key: string]: never }>;

export type UserSessionQuery = {
  __typename?: "Query";
  UserSession: {
    __typename?: "SessionResponse";
    permissions?: string | null;
    session?: {
      __typename?: "UserSessionData";
      userId?: string | null;
      cynergyId: string;
      accountId: string;
      roleId?: string | null;
      role?: string | null;
      staffRelationId?: string | null;
      organizationId?: string | null;
      locationId?: string | null;
      locationName?: string | null;
      email: string;
      userType?: UserTypes | null;
      phone?: string | null;
      lastName?: string | null;
      firstName?: string | null;
      username?: string | null;
      authnetProfileId?: string | null;
      practitionerId?: string | null;
      defaultPage?: string | null;
      firstLogin?: boolean | null;
      twoFactorEnabled?: boolean | null;
      twoFactorMethod?: TwoFactorMethods | null;
      photo?: string | null;
      availableLocations?: Array<{
        __typename?: "AssignmentType";
        assignment_id: string;
        location_id: string;
        location?: { __typename?: "AssignmentLocationType"; alias: string } | null;
      }> | null;
      paymentProfiles?: Array<{
        __typename: "PaymentProfiles";
        profile_id: string;
        authnet_payment_profile_id?: string | null;
        first_name: string;
        last_name: string;
        card_type: string;
        last_four_of_card: string;
        billing_address: string;
        state: string;
        city: string;
        zip: string;
        expiration: string;
        is_default: boolean;
        is_active: boolean;
        user: { __typename?: "Users"; user_id: string };
      }> | null;
      address?: {
        __typename?: "UserAddressData";
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        formattedAddress?: string | null;
        placeId?: string | null;
        isDefault?: boolean | null;
      } | null;
    } | null;
  };
};

export type UserSessionIpQueryVariables = Exact<{ [key: string]: never }>;

export type UserSessionIpQuery = {
  __typename?: "Query";
  UserSessionIP: { __typename?: "UserSessionIPData"; region: string; state: string; city: string; zip: string; lat: number; lng: number };
};

export type GetUserDemographicsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserDemographicsQuery = {
  __typename?: "Query";
  getUserDemographics: {
    __typename: "Demographics";
    cynergy_id: string;
    full_name?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    prefix?: string | null;
    suffix?: string | null;
    middle_name?: string | null;
    age: number;
    deceased: boolean;
    dob?: string | null;
    ethnicity?: string | null;
    marital_status?: MaritalStatus | null;
    sex: string;
    race?: string | null;
  };
};

export type UserEventsQueryVariables = Exact<{ [key: string]: never }>;

export type UserEventsQuery = {
  __typename?: "Query";
  getAllUserEvents: Array<{
    __typename: "UserEventData";
    id: string;
    title: string;
    start: any;
    end: any;
    link?: string | null;
    meta: {
      __typename: "EventMetaType";
      type: CalendarEventTypes;
      description: string;
      location: string;
      participants?: Array<{ __typename?: "EventParticipantsType"; label: string; value: string }> | null;
    };
  }>;
};

export type GetUserDuplicatesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type GetUserDuplicatesQuery = {
  __typename?: "Query";
  getCynergyUser: {
    __typename?: "CynergyUsersType";
    cynergy_id: string;
    potential_duplicates?: Array<{ __typename: "DuplicateRecordEntries"; entry_id: string; record_id: string }> | null;
  };
};

export type PaymentProfilesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  sort?: InputMaybe<SortingArgs>;
  pagination?: InputMaybe<PaginationArgs>;
}>;

export type PaymentProfilesQuery = {
  __typename?: "Query";
  getAllPaymentProfiles: Array<
    | {
        __typename: "PaymentProfiles";
        profile_id: string;
        authnet_payment_profile_id?: string | null;
        first_name: string;
        last_name: string;
        card_type: string;
        last_four_of_card: string;
        billing_address: string;
        state: string;
        city: string;
        zip: string;
        expiration: string;
        is_default: boolean;
        is_active: boolean;
        user: { __typename?: "Users"; user_id: string };
      }
    | { __typename?: "Transactions" }
  >;
};

export type UserCollectionQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
  options?: InputMaybe<QueryOptionsInputType>;
}>;

export type UserCollectionQuery = {
  __typename?: "Query";
  getUserCollection: {
    __typename: "Collections";
    collection_id: string;
    name: string;
    color?: any | null;
    url?: string | null;
    is_default: boolean;
    entries?: Array<{ __typename: "CollectionEntries"; entry_id: string; name: string; url?: string | null }> | null;
  };
};

export type UserCollectionEntriesQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type UserCollectionEntriesQuery = {
  __typename?: "Query";
  getCollectionEntries: Array<{
    __typename: "CollectionEntries";
    entry_id: string;
    name: string;
    url?: string | null;
    entity: { __typename: "References"; reference_id: string; type: string; display: string; reference?: string | null };
  }>;
};

export type NewNotificationSubscriptionVariables = Exact<{
  topics: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type NewNotificationSubscription = {
  __typename?: "Subscription";
  newNotification: {
    __typename: "Notifications";
    is_read: boolean;
    notification_id: string;
    notification_title: string;
    notification_body: string;
    notification_data?: any | null;
    notification_category?: string | null;
    notification_link?: string | null;
    link_label?: string | null;
    notification_priority: AlertPriority;
    from_cynergy_id?: string | null;
    recipient_cynergy_id: string;
    ref_id?: string | null;
    from: string;
    created_at: any;
    updated_at?: any | null;
  };
};

export type NotificationSubscriptionsSubscriptionVariables = Exact<{
  cynergyId: Scalars["String"]["input"];
}>;

export type NotificationSubscriptionsSubscription = {
  __typename?: "Subscription";
  notificationSubscriptions: {
    __typename: "Notifications";
    is_read: boolean;
    notification_id: string;
    notification_title: string;
    notification_body: string;
    notification_data?: any | null;
    notification_category?: string | null;
    notification_link?: string | null;
    link_label?: string | null;
    notification_priority: AlertPriority;
    from_cynergy_id?: string | null;
    recipient_cynergy_id: string;
    ref_id?: string | null;
    from: string;
    created_at: any;
    updated_at?: any | null;
  };
};

export type TimelineSubscriptionSubscriptionVariables = Exact<{
  cynergyId: Scalars["String"]["input"];
  locationId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TimelineSubscriptionSubscription = {
  __typename?: "Subscription";
  timelineSubscription: {
    __typename?: "TimelineSubscriberMessage";
    message: string;
    payload: {
      __typename: "TimelineEntry";
      id: string;
      title: string;
      message: string;
      action: ActionType;
      timestamp: any;
      subject: { __typename: "TimelineSubject"; id: string; type: UserTypes; name: string };
      reference?: { __typename: "TimelineTargetReference"; id?: string | null; resource: string } | null;
      extras?: { __typename: "TimelineExtras"; category?: FlagCategory | null; link?: string | null; meta?: any | null } | null;
    };
  };
};

export type UserProductBundleItemDetailsFragmentFragment = {
  __typename: "UserProductBundleItems";
  bundle_item_id: string;
  name: string;
  sequence: number;
  product_id: string;
  pricebook_entry_id: string;
  store_id: string;
  product: {
    __typename: "Products";
    code: string;
    name: string;
    product_id: string;
    description?: string | null;
    family: CommerceProductFamily;
    isInCart?: boolean | null;
    isWishListed?: boolean | null;
    resource: {
      __typename: "HealthcareServices";
      service_id: string;
      name: string;
      type: string;
      category: ServiceRequestCategory;
      active: boolean;
      speciality?: Array<string> | null;
    };
    attributes?: Array<{
      __typename: "Attributes";
      attribute_id: string;
      attribute: string;
      name: string;
      values?: Array<{ __typename: "AttributeValues"; value_id: string; value: string; color?: string | null }> | null;
    }> | null;
  };
  price_entry: { __typename: "PriceBookEntries"; entry_id: string; name: string; product_code: string; unit_price: any };
  store: { __typename?: "WebStores"; store_id: string; name: string; location: { __typename?: "Locations"; location_id: string } };
};

export type UpcomingAppointmentTileFragmentFragment = {
  __typename: "Appointments";
  appointment_id: string;
  patient_id: string;
  title: string;
  patient_name: string;
  subject?: string | null;
  type: AppointmentType;
  category: ServiceRequestCategory;
  scheduled_start?: any | null;
  scheduled_end?: any | null;
  status: AppointmentStatus;
  description?: string | null;
  service_types: Array<{ __typename?: "AppointmentServiceTypes"; type_id: string; service_id: string; name: string }>;
};

export type CartCheckoutItemsFragmentFragment = {
  __typename?: "WebCarts";
  id: string;
  items: Array<{
    __typename?: "WebCartItems";
    id: string;
    cart_id: string;
    productCode: string;
    name: string;
    price: any;
    tax?: any | null;
    product: { __typename?: "Products"; code: string; description?: string | null; family: CommerceProductFamily };
    store: {
      __typename?: "WebStores";
      store_id: string;
      code: string;
      location: { __typename?: "Locations"; location_id: string; alias?: string | null };
    };
    thumbnail?: { __typename?: "WebCartItemThumbNails"; url: string } | null;
  }>;
};

export type CartBookingRequestsFragmentFragment = {
  __typename?: "WebCarts";
  id: string;
  booking_requests?: Array<{
    __typename?: "WebCartBookingRequests";
    id: string;
    cart_id: string;
    items: Array<{ __typename?: "WebCartItems"; id: string; price: any; name: string }>;
    location?: {
      __typename?: "Locations";
      location_id: string;
      alias?: string | null;
      address: { __typename?: "WebCynergyAddresses"; address_id: string; formatted_address?: string | null };
    } | null;
    slot?: { __typename?: "Slots"; slot_id: string; start: any; end: any } | null;
  }> | null;
};

export type FeedItemBodyFragmentFragment = {
  __typename?: "FeedItemObject";
  id: string;
  elementType: FeedElementType;
  header: {
    __typename: "MessageBodyObject";
    text?: string | null;
    isRichText: boolean;
    messageSegments?: Array<
      | { __typename: "MessageSegmentLinkObject"; text?: string | null; type: MessageSegmentType; linkUrl: any }
      | {
          __typename: "MessageSegmentMarkupBeginObject";
          text?: string | null;
          type: MessageSegmentType;
          altText?: string | null;
          htmlTag: string;
          markupType: MessageMarkupType;
          url?: any | null;
        }
      | {
          __typename: "MessageSegmentMarkupEndObject";
          text?: string | null;
          type: MessageSegmentType;
          htmlTag: string;
          markupType: MessageMarkupType;
        }
      | { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType }
    > | null;
  };
  body?: {
    __typename: "MessageBodyObject";
    text?: string | null;
    isRichText: boolean;
    messageSegments?: Array<
      | { __typename: "MessageSegmentLinkObject"; text?: string | null; type: MessageSegmentType; linkUrl: any }
      | {
          __typename: "MessageSegmentMarkupBeginObject";
          text?: string | null;
          type: MessageSegmentType;
          altText?: string | null;
          htmlTag: string;
          markupType: MessageMarkupType;
          url?: any | null;
        }
      | {
          __typename: "MessageSegmentMarkupEndObject";
          text?: string | null;
          type: MessageSegmentType;
          htmlTag: string;
          markupType: MessageMarkupType;
        }
      | { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType }
    > | null;
  } | null;
  capabilities?: {
    __typename?: "FeedElementCapabilitiesObject";
    bundle?:
      | { __typename: "FeedBundleCapabilityObject"; bundleType: FeedBundleType; totalElements: number }
      | {
          __typename: "TrackedChangeBundleCapabilityObject";
          bundleType: FeedBundleType;
          totalElements: number;
          changes: Array<{
            __typename: "TrackedChangeItemObject";
            fieldName: string;
            newValue?: string | null;
            oldValue?: string | null;
            summary?: string | null;
          }>;
        }
      | null;
  } | null;
};

export type FeedItemHeaderFragmentFragment = {
  __typename?: "FeedItemObject";
  id: string;
  elementType: FeedElementType;
  actor?: { __typename: "FeedActorObject"; id: string; type: FeedActorType; name: string; url?: any | null } | null;
  header: {
    __typename: "MessageBodyObject";
    text?: string | null;
    isRichText: boolean;
    messageSegments?: Array<
      | { __typename: "MessageSegmentLinkObject"; text?: string | null; type: MessageSegmentType; linkUrl: any }
      | {
          __typename: "MessageSegmentMarkupBeginObject";
          text?: string | null;
          type: MessageSegmentType;
          altText?: string | null;
          htmlTag: string;
          markupType: MessageMarkupType;
          url?: any | null;
        }
      | {
          __typename: "MessageSegmentMarkupEndObject";
          text?: string | null;
          type: MessageSegmentType;
          htmlTag: string;
          markupType: MessageMarkupType;
        }
      | { __typename: "MessageSegmentTextObject"; text?: string | null; type: MessageSegmentType }
    > | null;
  };
};

export type ContactManageFragmentFragment = {
  __typename: "ContactDetails";
  contact_detail_id: string;
  name: string;
  purpose?: ContactEntityType | null;
  telecom: Array<{
    __typename: "ContactPoints";
    contact_point_id: string;
    system: ContactPointSystem;
    use: ContactPointUse;
    value: string;
    rank: number;
    created_at: any;
  }>;
};

export type DiagnosisCodeFragmentFragment = { __typename?: "ICD10"; icd10_code: string; is_starred: boolean };

export type OrderAgentsFragmentFragment = {
  __typename: "OrderAgents";
  agent_id: string;
  name?: string | null;
  active: boolean;
  role: ParticipantRoleType;
  comment?: string | null;
  actor?:
    | { __typename: "CareTeams"; care_team_id: string }
    | { __typename: "Locations"; location_id: string }
    | { __typename: "Organizations"; organization_id: string }
    | { __typename: "Practitioners"; practitioner_id: string }
    | { __typename: "StaffAssignments" }
    | null;
};

export type PatientOrderDemographicsFragmentFragment = {
  __typename: "Patients";
  patient_id: string;
  user: {
    __typename: "Users";
    user_id: string;
    demographics?: {
      __typename?: "Demographics";
      cynergy_id: string;
      first_name?: string | null;
      last_name?: string | null;
      full_name?: string | null;
      dob?: string | null;
      age: number;
    } | null;
  };
};

export type ConditionCardFragmentFragment = {
  __typename: "Conditions";
  condition_id: string;
  onset_date_time?: any | null;
  recorded_date?: any | null;
  severity: ConditionSeverityCodes;
  clinical_status: ConditionClinicalStatus;
  classification: {
    __typename: "ICD10";
    icd10_code: string;
    icd11_code?: string | null;
    label: string;
    description?: string | null;
    type?: DiagnosisType | null;
    hex?: string | null;
  };
};

export type CriteriaPrescriptionsFragment = {
  __typename?: "CriteriaFormResults";
  prescriptions?: Array<{
    __typename: "MedicationUsages";
    usage_id: string;
    status: MedicationUsageStatus;
    medication: { __typename: "Medications"; medication_id: string; brand_name: string };
  }> | null;
};

export type ServiceLocationQueryVariables = Exact<{
  searchBy?: InputMaybe<SearchByArgs>;
}>;

export type ServiceLocationQuery = {
  __typename?: "Query";
  getLocation: {
    __typename?: "Locations";
    location_id: string;
    alias?: string | null;
    name: string;
    description?: string | null;
    phone?: string | null;
    preferred_member: boolean;
    organization_id: string;
    todays_operating_hours: string;
    open_now: boolean;
    location_role: string;
    location_status: string;
    preferred_timeslots?: { __typename?: "PreferredTimeSlotsType"; weekday_text: Array<string> } | null;
    address: {
      __typename: "WebCynergyAddresses";
      address_id: string;
      city: string;
      state: string;
      zip: string;
      address_line_1: string;
      address_line_2?: string | null;
      nickname?: string | null;
      formatted_address?: string | null;
      type: string;
      longitude?: number | null;
      latitude?: number | null;
      is_default: boolean;
      place_id?: string | null;
    };
    meta_data?: { __typename?: "MetaDataType"; priority?: number | null; rating?: number | null } | null;
  };
};

export const AgentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Agents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentCoreFragmentFragment, unknown>;
export const AgentAlternativesFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentAlternativesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agent_class_alternatives" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classification_number" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "agent_alternatives" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gene" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
                      { kind: "Field", name: { kind: "Name", value: "gene" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AgentCoreFragment" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "suitability" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "nus" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Agents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentAlternativesFragmentFragment, unknown>;
export const GenotypeCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenotypeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
          { kind: "Field", name: { kind: "Name", value: "gene" } },
          { kind: "Field", name: { kind: "Name", value: "encoding" } },
          { kind: "Field", name: { kind: "Name", value: "mechanism" } },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GenotypeCoreFragmentFragment, unknown>;
export const AgentClassificationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentClassificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgentClassifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "classification_number" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentClassificationCoreFragmentFragment, unknown>;
export const AgentResistanceFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentResistanceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "GenotypeCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "resistant_to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AgentCoreFragment" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "agent_class_resistance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "class_resistance_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AgentClassificationCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exceptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "agent_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenotypeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
          { kind: "Field", name: { kind: "Name", value: "gene" } },
          { kind: "Field", name: { kind: "Name", value: "encoding" } },
          { kind: "Field", name: { kind: "Name", value: "mechanism" } },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Agents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentClassificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgentClassifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "classification_number" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentResistanceFragmentFragment, unknown>;
export const WebStoreCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebStoreCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebStores" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "isLocal" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebStoreCoreFragmentFragment, unknown>;
export const ProductCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductCoreFragmentFragment, unknown>;
export const ProductCardFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CatalogProductResult" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "store" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "WebStoreCoreFragment" } },
                { kind: "Field", name: { kind: "Name", value: "distance" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "service_id" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      { kind: "Field", name: { kind: "Name", value: "height" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "entry_id" } },
                { kind: "Field", name: { kind: "Name", value: "product_code" } },
                { kind: "Field", name: { kind: "Name", value: "unit_price" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebStoreCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebStores" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "isLocal" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductCardFragmentFragment, unknown>;
export const CriteriaFormResultFlagCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaFormResultFlagCoreFragmentFragment, unknown>;
export const CriteriaFormResultFlagItemCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlagItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_codes" } },
          { kind: "Field", name: { kind: "Name", value: "applies_to" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaFormResultFlagItemCoreFragmentFragment, unknown>;
export const FlagCardFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FlagCardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "diagnoses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "hex" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "flags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlagItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_codes" } },
          { kind: "Field", name: { kind: "Name", value: "applies_to" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlagCardFragmentFragment, unknown>;
export const CriteriaFormPatientFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormPatientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "full_name" } },
                      { kind: "Field", name: { kind: "Name", value: "dob" } },
                      { kind: "Field", name: { kind: "Name", value: "age" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaFormPatientFragmentFragment, unknown>;
export const Icd10CoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Icd10CoreFragmentFragment, unknown>;
export const OrderHeaderFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderHeaderFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "diagnosis_codes" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CoreFragment" } }] },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requisition" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "flags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
                { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
                { kind: "Field", name: { kind: "Name", value: "display" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reports" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "report_id" } },
                { kind: "Field", name: { kind: "Name", value: "request_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "presented_form" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "content_type" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderHeaderFragmentFragment, unknown>;
export const DemographicsCoreFragmentAltFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DemographicsCoreFragmentAltFragment, unknown>;
export const PatientDemographicFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientDemographicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientDemographicFragmentFragment, unknown>;
export const AttachmentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attachments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
          { kind: "Field", name: { kind: "Name", value: "content_type" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "pages" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachmentCoreFragmentFragment, unknown>;
export const OrderDocumentsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderDocumentsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reports" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "report_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "presented_form" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttachmentCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requisition" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttachmentCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attachments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
          { kind: "Field", name: { kind: "Name", value: "content_type" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "pages" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDocumentsFragmentFragment, unknown>;
export const LayoutGridCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutGridCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GridLayoutProperties" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "xs" } },
          { kind: "Field", name: { kind: "Name", value: "sm" } },
          { kind: "Field", name: { kind: "Name", value: "md" } },
          { kind: "Field", name: { kind: "Name", value: "lg" } },
          { kind: "Field", name: { kind: "Name", value: "xl" } },
          { kind: "Field", name: { kind: "Name", value: "xxl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LayoutGridCoreFragmentFragment, unknown>;
export const LayoutConfigurationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutConfigurationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LayoutConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "column" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LayoutGridCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutGridCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GridLayoutProperties" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "xs" } },
          { kind: "Field", name: { kind: "Name", value: "sm" } },
          { kind: "Field", name: { kind: "Name", value: "md" } },
          { kind: "Field", name: { kind: "Name", value: "lg" } },
          { kind: "Field", name: { kind: "Name", value: "xl" } },
          { kind: "Field", name: { kind: "Name", value: "xxl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LayoutConfigurationCoreFragmentFragment, unknown>;
export const LayoutPositionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutPositionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LayoutPosition" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LayoutPositionCoreFragmentFragment, unknown>;
export const PageLayoutConfigurationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageLayoutConfigurationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ComponentLayoutConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "column" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LayoutGridCoreFragment" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "component" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "position" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LayoutPositionCoreFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "props" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutGridCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GridLayoutProperties" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "xs" } },
          { kind: "Field", name: { kind: "Name", value: "sm" } },
          { kind: "Field", name: { kind: "Name", value: "md" } },
          { kind: "Field", name: { kind: "Name", value: "lg" } },
          { kind: "Field", name: { kind: "Name", value: "xl" } },
          { kind: "Field", name: { kind: "Name", value: "xxl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutPositionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LayoutPosition" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageLayoutConfigurationCoreFragmentFragment, unknown>;
export const QuantityCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuantityCoreFragmentFragment, unknown>;
export const RatioCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RatioCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ratio" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "ratio_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numerator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "denominator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RatioCoreFragmentFragment, unknown>;
export const TagCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "tag_id" } },
          { kind: "Field", name: { kind: "Name", value: "tag" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "icon_url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagCoreFragmentFragment, unknown>;
export const IdentifierCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdentifierCoreFragmentFragment, unknown>;
export const ResourceReferenceCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "References" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceReferenceCoreFragmentFragment, unknown>;
export const Icd10CodeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CodeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Icd10CodeFragmentFragment, unknown>;
export const TaskCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskCoreFragmentFragment, unknown>;
export const TaskStepCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskStepCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TaskSteps" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "step_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskStepCoreFragmentFragment, unknown>;
export const QuestionnaireCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireCoreFragmentFragment, unknown>;
export const QuestionnaireItemCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireItemCoreFragmentFragment, unknown>;
export const QuestionnaireResponseCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireResponseCoreFragmentFragment, unknown>;
export const QuestionnaireAnswersCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "answer_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_attachment" } },
          { kind: "Field", name: { kind: "Name", value: "answer_string" } },
          { kind: "Field", name: { kind: "Name", value: "answer_uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_option" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "option_id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireAnswersCoreFragmentFragment, unknown>;
export const QuestionnaireEnableWhenCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireEnableWhenCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireEnableWhen" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "enable_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireEnableWhenCoreFragmentFragment, unknown>;
export const QuestionnaireAnswerOptionsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswerOptions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "option_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "initial_selected" } },
          { kind: "Field", name: { kind: "Name", value: "option_coding" } },
          { kind: "Field", name: { kind: "Name", value: "option_date" } },
          { kind: "Field", name: { kind: "Name", value: "option_time" } },
          { kind: "Field", name: { kind: "Name", value: "option_integer" } },
          { kind: "Field", name: { kind: "Name", value: "option_string" } },
          { kind: "Field", name: { kind: "Name", value: "option_boolean" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "option_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireAnswerOptionsCoreFragmentFragment, unknown>;
export const QuestionnaireAbxStatisticsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireABXStatisticsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "answer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "question" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "item_id" } },
                      { kind: "Field", name: { kind: "Name", value: "link_id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answer_range" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "range_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "low" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "high" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionnaireAbxStatisticsFragmentFragment, unknown>;
export const NotificationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationCoreFragmentFragment, unknown>;
export const MessageCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Messages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "message_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "is_trashed" } },
          { kind: "Field", name: { kind: "Name", value: "is_starred" } },
          { kind: "Field", name: { kind: "Name", value: "attachment" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageCoreFragmentFragment, unknown>;
export const CynergyAccountCoreFragmentAltFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CynergyAccountCoreFragmentAltFragment, unknown>;
export const CynergyAccountCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CynergyAccountCoreFragmentFragment, unknown>;
export const DemographicsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DemographicsCoreFragmentFragment, unknown>;
export const UserCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCoreFragmentFragment, unknown>;
export const UserCoreFragmentAltFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCoreFragmentAltFragment, unknown>;
export const PatientCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientCoreFragmentFragment, unknown>;
export const LocationPatientCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationPatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LocationPatients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "full_name" } },
                            { kind: "Field", name: { kind: "Name", value: "dob" } },
                            { kind: "Field", name: { kind: "Name", value: "age" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationPatientCoreFragmentFragment, unknown>;
export const DependentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DependentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Dependents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "parent_patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "parent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dependent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DependentCoreFragmentFragment, unknown>;
export const UserEventsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserEventsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserEventData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "link" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserEventsCoreFragmentFragment, unknown>;
export const GroupCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Groups" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "group_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "membership" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupCoreFragmentFragment, unknown>;
export const TwilioFactorCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwilioFactorCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwilioFactor" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "sid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "verified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwilioFactorCoreFragmentFragment, unknown>;
export const TwoFactorAuthenticationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorAuthentication" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "sms_number" } },
          { kind: "Field", name: { kind: "Name", value: "sms_verified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoFactorAuthenticationCoreFragmentFragment, unknown>;
export const TwoFactorTotpCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorTOTPCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorTotp" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "qr_uri" } },
          { kind: "Field", name: { kind: "Name", value: "secret" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoFactorTotpCoreFragmentFragment, unknown>;
export const TwoFactorPushCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorPushCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorPush" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoFactorPushCoreFragmentFragment, unknown>;
export const StaffCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Staffs" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffCoreFragmentFragment, unknown>;
export const StaffAssignmentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffAssignmentCoreFragmentFragment, unknown>;
export const PractitionerCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PractitionerCoreFragmentFragment, unknown>;
export const PractitionerAffiliationsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAffiliationsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "location_affiliations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PractitionerAffiliationsFragmentFragment, unknown>;
export const PractitionerAssignmentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PractitionerAssignmentCoreFragmentFragment, unknown>;
export const PractitionerQualificationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerQualificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerQualifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "qualification_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "credential" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
          { kind: "Field", name: { kind: "Name", value: "is_verified" } },
          { kind: "Field", name: { kind: "Name", value: "verified_on" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PractitionerQualificationCoreFragmentFragment, unknown>;
export const PractitionerSignatureCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerSignatureCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerSignatures" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "signature_id" } },
          { kind: "Field", name: { kind: "Name", value: "signature_format" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "when" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PractitionerSignatureCoreFragmentFragment, unknown>;
export const TaxonomiesCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaxonomiesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Taxonomies" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "taxonomy_id" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "primary" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "group" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaxonomiesCoreFragmentFragment, unknown>;
export const RecurrencePatternCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecurrencePatternCoreFragmentFragment, unknown>;
export const RecurrencePatternWeeklyCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternWeeklyCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WeeklyRecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "days" } },
          { kind: "Field", name: { kind: "Name", value: "every_day" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecurrencePatternWeeklyCoreFragmentFragment, unknown>;
export const RecurrencePatternMonthlyCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternMonthlyCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MonthlyRecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "day_of_month" } },
          { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
          { kind: "Field", name: { kind: "Name", value: "week_of_month" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecurrencePatternMonthlyCoreFragmentFragment, unknown>;
export const EventCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Events" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "event_date" } },
          { kind: "Field", name: { kind: "Name", value: "all_day_event" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventCoreFragmentFragment, unknown>;
export const EventSeriesCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventSeriesCoreFragmentFragment, unknown>;
export const EncounterCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EncounterCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Encounters" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "encounter_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "class" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "service_type" } },
          { kind: "Field", name: { kind: "Name", value: "subject_status" } },
          { kind: "Field", name: { kind: "Name", value: "planned_start_date" } },
          { kind: "Field", name: { kind: "Name", value: "planned_end_date" } },
          { kind: "Field", name: { kind: "Name", value: "diet_preference" } },
          { kind: "Field", name: { kind: "Name", value: "special_arrangement" } },
          { kind: "Field", name: { kind: "Name", value: "special_courtesy" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EncounterCoreFragmentFragment, unknown>;
export const EncounterReasonsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EncounterReasonsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EncounterReasons" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reason_code" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EncounterReasonsCoreFragmentFragment, unknown>;
export const EncounterParticipantsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EncounterParticipantsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EncounterParticipants" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EncounterParticipantsCoreFragmentFragment, unknown>;
export const EncounterAdmissionsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EncounterAdmissionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EncounterAdmissions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "admit_source" } },
          { kind: "Field", name: { kind: "Name", value: "discharge_disposition" } },
          { kind: "Field", name: { kind: "Name", value: "readmission" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EncounterAdmissionsCoreFragmentFragment, unknown>;
export const WebCartCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCarts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_holder" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebCartCoreFragmentFragment, unknown>;
export const WebCartSummaryCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartSummaryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartSummaries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "subtotal" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          { kind: "Field", name: { kind: "Name", value: "surcharge" } },
          { kind: "Field", name: { kind: "Name", value: "item_count" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebCartSummaryCoreFragmentFragment, unknown>;
export const WebCartItemCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "productCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebCartItemCoreFragmentFragment, unknown>;
export const CartItemsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CartItemsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCarts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartItemCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "productCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CartItemsFragmentFragment, unknown>;
export const UserTimelineFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserTimelineFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TimelineEntry" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "resource" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "extras" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "meta" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserTimelineFragmentFragment, unknown>;
export const FeedItemFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "elementType" } },
          { kind: "Field", name: { kind: "Name", value: "publishDate" } },
          { kind: "Field", name: { kind: "Name", value: "relativePublishedDate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedItemFragmentFragment, unknown>;
export const FeedElementCollectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedElementCollectionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedElementCollectionObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "count" } },
          { kind: "Field", name: { kind: "Name", value: "currentPage" } },
          { kind: "Field", name: { kind: "Name", value: "totalPages" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedElementCollectionFragmentFragment, unknown>;
export const LinkCapabilityObjectFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkCapabilityObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LinkCapabilityObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "urlName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkCapabilityObjectFragmentFragment, unknown>;
export const FeedItemCapabilityFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedItemCapabilityFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedElementCapabilitiesObject" } },
      selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] },
    },
  ],
} as unknown as DocumentNode<FeedItemCapabilityFragmentFragment, unknown>;
export const MessageSegmentLinkFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentLinkFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentLinkObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageSegmentLinkFragmentFragment, unknown>;
export const PaymentProfileCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentProfileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "profile_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "user_id" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "authnet_payment_profile_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "card_type" } },
          { kind: "Field", name: { kind: "Name", value: "last_four_of_card" } },
          { kind: "Field", name: { kind: "Name", value: "billing_address" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "expiration" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "is_active" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentProfileCoreFragmentFragment, unknown>;
export const AddressCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "address_id" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "place_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressCoreFragmentFragment, unknown>;
export const ContactCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Contacts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "authorized_access" } },
          { kind: "Field", name: { kind: "Name", value: "contact_type" } },
          { kind: "Field", name: { kind: "Name", value: "contact_relation_type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactCoreFragmentFragment, unknown>;
export const ContactDetailsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetailsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_detail_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactDetailsCoreFragmentFragment, unknown>;
export const ContactPointCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactPointCoreFragmentFragment, unknown>;
export const ContactInformationFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInformationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "ContactDetailsCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "telecom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetailsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_detail_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactInformationFragmentFragment, unknown>;
export const OrganizationsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_role" } },
          { kind: "Field", name: { kind: "Name", value: "organization_type" } },
          { kind: "Field", name: { kind: "Name", value: "safety_precautions" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationsCoreFragmentFragment, unknown>;
export const LocationsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationsCoreFragmentFragment, unknown>;
export const LocationOperatingHoursFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationOperatingHoursFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "preferred_timeslots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "weekday_text" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "periods" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "open" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "day" } },
                            { kind: "Field", name: { kind: "Name", value: "time" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "close" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "day" } },
                            { kind: "Field", name: { kind: "Name", value: "time" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationOperatingHoursFragmentFragment, unknown>;
export const AppointmentServiceTypesFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentServiceTypesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AppointmentServiceTypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "type_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentServiceTypesFragmentFragment, unknown>;
export const ProductCategoriesCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCategoriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ProductCategories" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "category_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "number_of_products" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductCategoriesCoreFragmentFragment, unknown>;
export const ProductCatalogItemsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCatalogItemsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ProductCatalogItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductCatalogItemsCoreFragmentFragment, unknown>;
export const ProductCatalogCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCatalogCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ProductCatalogs" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "catalog_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "number_of_categories" } },
          { kind: "Field", name: { kind: "Name", value: "number_of_products" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductCatalogCoreFragmentFragment, unknown>;
export const PriceBookCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBooks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "book_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceBookCoreFragmentFragment, unknown>;
export const WebStoreCategoryDefinitionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebStoreCategoryDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebStoreCategoryDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebStoreCategoryDefinitionCoreFragmentFragment, unknown>;
export const UserProductBundleCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
          { kind: "Field", name: { kind: "Name", value: "account_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "is_shared" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserProductBundleCoreFragmentFragment, unknown>;
export const HealthcareServiceLocationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServiceLocations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_location_id" } },
          { kind: "Field", name: { kind: "Name", value: "distance" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HealthcareServiceLocationCoreFragmentFragment, unknown>;
export const DiagnosticServiceCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "subtitle" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiagnosticServiceCoreFragmentFragment, unknown>;
export const ObservationDefinitionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObservationDefinitionCoreFragmentFragment, unknown>;
export const ObservationDefinitionComponentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationDefinitionComponentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationDefinitionComponents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "component_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObservationDefinitionComponentCoreFragmentFragment, unknown>;
export const DiagnosticServiceBiomarkersFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticServiceBiomarkersFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "biomarkers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ObservationDefinitionCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ObservationDefinitionCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "components" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ObservationDefinitionComponentCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationDefinitionComponentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationDefinitionComponents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "component_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiagnosticServiceBiomarkersFragmentFragment, unknown>;
export const CriteriaCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Criteria" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "criteria_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "reference_url" } },
          { kind: "Field", name: { kind: "Name", value: "citations" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaCoreFragmentFragment, unknown>;
export const CriteriaDefinitionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaDefinitionCoreFragmentFragment, unknown>;
export const CriteriaItemCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icd10" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "hex" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaItemCoreFragmentFragment, unknown>;
export const CriteriaRuleCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaRuleCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaRules" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "rule_id" } },
          { kind: "Field", name: { kind: "Name", value: "statement" } },
          { kind: "Field", name: { kind: "Name", value: "required_behavior" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaRuleCoreFragmentFragment, unknown>;
export const CriteriaFormResultCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResults" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "result_id" } },
          { kind: "Field", name: { kind: "Name", value: "passed" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaFormResultCoreFragmentFragment, unknown>;
export const CarePlanCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CarePlanCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CarePlans" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_plan_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CarePlanCoreFragmentFragment, unknown>;
export const CareTeamCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CareTeamCoreFragmentFragment, unknown>;
export const CareTeamMemberCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamMemberCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeamMembers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "member_id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CareTeamMemberCoreFragmentFragment, unknown>;
export const DetectedIssueCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DetectedIssueCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DetectedIssues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "detail" } },
          { kind: "Field", name: { kind: "Name", value: "identified_at" } },
          { kind: "Field", name: { kind: "Name", value: "mitigation_action" } },
          { kind: "Field", name: { kind: "Name", value: "mitigation_date" } },
          { kind: "Field", name: { kind: "Name", value: "reference_uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DetectedIssueCoreFragmentFragment, unknown>;
export const ConditionsCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConditionsCoreFragmentFragment, unknown>;
export const ConditionAssessmentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionAssessmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "impression_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "change_pattern" } },
          { kind: "Field", name: { kind: "Name", value: "numeric_rating" } },
          { kind: "Field", name: { kind: "Name", value: "protocol" } },
          { kind: "Field", name: { kind: "Name", value: "assessment_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConditionAssessmentCoreFragmentFragment, unknown>;
export const ClinicalNoteCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClinicalNoteCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalNotes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "note_id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClinicalNoteCoreFragmentFragment, unknown>;
export const MedicationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MedicationCoreFragmentFragment, unknown>;
export const MedicationUsageCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MedicationUsageCoreFragmentFragment, unknown>;
export const MedicationCoreFragmentAltFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MedicationCoreFragmentAltFragment, unknown>;
export const PeriodCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PeriodCoreFragmentFragment, unknown>;
export const MedicationUsageCoreFragmentAltFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MedicationUsageCoreFragmentAltFragment, unknown>;
export const DiagnosticReportCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticReportCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticReports" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "report_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "conclusion_code" } },
          { kind: "Field", name: { kind: "Name", value: "issued" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiagnosticReportCoreFragmentFragment, unknown>;
export const ObservationCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Observations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "observation_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "target_type" } },
          { kind: "Field", name: { kind: "Name", value: "interpretation" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObservationCoreFragmentFragment, unknown>;
export const ObservationFlagCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ObservationFlagCoreFragmentFragment, unknown>;
export const SpecimenDefinitionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpecimenDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpecimenDefinitions" } },
      selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition_id" } }] },
    },
  ],
} as unknown as DocumentNode<SpecimenDefinitionCoreFragmentFragment, unknown>;
export const SpecimenDefinitionCollectionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpecimenDefinitionCollectionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SpecimenDefinitionCollections" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "collection_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_preparation" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "method" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "text" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "specimen_type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpecimenDefinitionCollectionCoreFragmentFragment, unknown>;
export const LoincCodeCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LoincCodeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoincCodes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "class_type" } },
          { kind: "Field", name: { kind: "Name", value: "order_observation" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoincCodeCoreFragmentFragment, unknown>;
export const OrderCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderCoreFragmentFragment, unknown>;
export const OrderLineItemCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderLineItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderLineItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "net_total" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderLineItemCoreFragmentFragment, unknown>;
export const ServiceRequestCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceRequestCoreFragmentFragment, unknown>;
export const FileCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "etag" } },
          { kind: "Field", name: { kind: "Name", value: "lastModified" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileCoreFragmentFragment, unknown>;
export const FileMetaDataFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileMetaDataFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketMetaData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "Fileextension" } },
          { kind: "Field", name: { kind: "Name", value: "Filename" } },
          { kind: "Field", name: { kind: "Name", value: "Folder" } },
          { kind: "Field", name: { kind: "Name", value: "Isstarred" } },
          { kind: "Field", name: { kind: "Name", value: "Istrashed" } },
          { kind: "Field", name: { kind: "Name", value: "Label" } },
          { kind: "Field", name: { kind: "Name", value: "Lastaccessed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileMetaDataFragmentFragment, unknown>;
export const FileBucketFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileBucketFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Bucket" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "prefix" } },
                { kind: "Field", name: { kind: "Name", value: "lastModified" } },
                { kind: "Field", name: { kind: "Name", value: "etag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileBucketFragmentFragment, unknown>;
export const DocumentReferenceCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DocumentReferences" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "content_type" } },
          { kind: "Field", name: { kind: "Name", value: "document_status" } },
          { kind: "Field", name: { kind: "Name", value: "security_tag" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentReferenceCoreFragmentFragment, unknown>;
export const UserCollectionCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCollectionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Collections" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "collection_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCollectionCoreFragmentFragment, unknown>;
export const CollectionEntryCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionEntryCoreFragmentFragment, unknown>;
export const GoogleGeocodeCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GoogleGeocodeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GoogleGeocodingResponseType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "results" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address_components" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "long_name" } },
                      { kind: "Field", name: { kind: "Name", value: "short_name" } },
                      { kind: "Field", name: { kind: "Name", value: "types" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                { kind: "Field", name: { kind: "Name", value: "types" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "geometry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "lat" } },
                            { kind: "Field", name: { kind: "Name", value: "lng" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "error_message" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GoogleGeocodeCoreFragmentFragment, unknown>;
export const GoogleGeocodingCoordinateFragmentsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GoogleGeocodingCoordinateFragments" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GoogleGeocodingResponseType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "results" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "geometry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "lat" } },
                            { kind: "Field", name: { kind: "Name", value: "lng" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GoogleGeocodingCoordinateFragmentsFragment, unknown>;
export const CoverageCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoverageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Coverages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "payor_name" } },
          { kind: "Field", name: { kind: "Name", value: "payor_external_id" } },
          { kind: "Field", name: { kind: "Name", value: "policy_number" } },
          { kind: "Field", name: { kind: "Name", value: "plan_type" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_first_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_last_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_dob" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_relationship_to_patient" } },
          { kind: "Field", name: { kind: "Name", value: "is_archived" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoverageCoreFragmentFragment, unknown>;
export const UserProductBundleItemCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "pricebook_entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "store_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserProductBundleItemCoreFragmentFragment, unknown>;
export const HealthcareServiceCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HealthcareServiceCoreFragmentFragment, unknown>;
export const AttributeValuesCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributeValuesCoreFragmentFragment, unknown>;
export const AttributeCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributeCoreFragmentFragment, unknown>;
export const PriceBookEntryCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceBookEntryCoreFragmentFragment, unknown>;
export const UserProductBundleItemDetailsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price_entry" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PriceBookEntryCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "store" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "store_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "location_id" } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "pricebook_entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "store_id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserProductBundleItemDetailsFragmentFragment, unknown>;
export const AppointmentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentCoreFragmentFragment, unknown>;
export const UpcomingAppointmentTileFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpcomingAppointmentTileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "service_types" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type_id" } },
                { kind: "Field", name: { kind: "Name", value: "service_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpcomingAppointmentTileFragmentFragment, unknown>;
export const CartCheckoutItemsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CartCheckoutItemsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCarts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "WebCartItemCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "family" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "store" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "store_id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "productCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CartCheckoutItemsFragmentFragment, unknown>;
export const WebCartBookingRequestCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartBookingRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                { kind: "Field", name: { kind: "Name", value: "alias" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "address_id" } },
                      { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slot" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slot_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebCartBookingRequestCoreFragmentFragment, unknown>;
export const CartBookingRequestsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CartBookingRequestsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCarts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "booking_requests" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartBookingRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                { kind: "Field", name: { kind: "Name", value: "alias" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "address_id" } },
                      { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slot" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slot_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CartBookingRequestsFragmentFragment, unknown>;
export const MessageBodyObjectFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodyObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "isRichText" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageBodyObjectFragmentFragment, unknown>;
export const MessageSegmentTextFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentTextFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageSegmentTextFragmentFragment, unknown>;
export const MessageSegmentMarkupBeginFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "altText" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageSegmentMarkupBeginFragmentFragment, unknown>;
export const MessageSegmentMarkupEndFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageSegmentMarkupEndFragmentFragment, unknown>;
export const MessageBodySegmentFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodySegmentFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "messageSegments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentTextFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentLinkObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", alias: { kind: "Name", value: "linkUrl" }, name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentTextFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "altText" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageBodySegmentFragmentFragment, unknown>;
export const FeedBundleCapabilityFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedBundleCapabilityFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedBundleCapabilityObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundleType" } },
          { kind: "Field", name: { kind: "Name", value: "totalElements" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedBundleCapabilityFragmentFragment, unknown>;
export const TrackedChangeBundleCapabilityFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackedChangeBundleCapabilityFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeBundleCapabilityObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundleType" } },
          { kind: "Field", name: { kind: "Name", value: "totalElements" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackedChangeBundleCapabilityFragmentFragment, unknown>;
export const TrackedChangeItemFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackedChangeItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "fieldName" } },
          { kind: "Field", name: { kind: "Name", value: "newValue" } },
          { kind: "Field", name: { kind: "Name", value: "oldValue" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackedChangeItemFragmentFragment, unknown>;
export const FeedItemBodyFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedItemBodyFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "elementType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "header" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodyObjectFragment" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodySegmentFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "body" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodyObjectFragment" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodySegmentFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "capabilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bundle" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "FeedBundleCapabilityFragment" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeBundleCapabilityObject" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "TrackedChangeBundleCapabilityFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "changes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TrackedChangeItemFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentTextFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "altText" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodyObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "isRichText" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodySegmentFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "messageSegments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentTextFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentLinkObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", alias: { kind: "Name", value: "linkUrl" }, name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedBundleCapabilityFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedBundleCapabilityObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundleType" } },
          { kind: "Field", name: { kind: "Name", value: "totalElements" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackedChangeBundleCapabilityFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeBundleCapabilityObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundleType" } },
          { kind: "Field", name: { kind: "Name", value: "totalElements" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackedChangeItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "fieldName" } },
          { kind: "Field", name: { kind: "Name", value: "newValue" } },
          { kind: "Field", name: { kind: "Name", value: "oldValue" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedItemBodyFragmentFragment, unknown>;
export const FeedActorObjectFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedActorObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedActorObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedActorObjectFragmentFragment, unknown>;
export const FeedItemHeaderFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedItemHeaderFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "elementType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "actor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FeedActorObjectFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "header" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodyObjectFragment" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodySegmentFragment" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentTextFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "altText" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedActorObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedActorObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodyObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "isRichText" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodySegmentFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "messageSegments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentTextFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentLinkObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", alias: { kind: "Name", value: "linkUrl" }, name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedItemHeaderFragmentFragment, unknown>;
export const ContactManageFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactManageFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "ContactDetailsCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "telecom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetailsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_detail_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactManageFragmentFragment, unknown>;
export const DiagnosisCodeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosisCodeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "is_starred" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiagnosisCodeFragmentFragment, unknown>;
export const OrderAgentCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderAgentCoreFragmentFragment, unknown>;
export const OrderAgentActorCoreFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentActorCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgentActor" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "organization_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderAgentActorCoreFragmentFragment, unknown>;
export const OrderAgentsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "actor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentActorCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentActorCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgentActor" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "organization_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderAgentsFragmentFragment, unknown>;
export const PatientOrderDemographicsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientOrderDemographicsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                      { kind: "Field", name: { kind: "Name", value: "first_name" } },
                      { kind: "Field", name: { kind: "Name", value: "last_name" } },
                      { kind: "Field", name: { kind: "Name", value: "full_name" } },
                      { kind: "Field", name: { kind: "Name", value: "dob" } },
                      { kind: "Field", name: { kind: "Name", value: "age" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientOrderDemographicsFragmentFragment, unknown>;
export const ConditionCardFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionCardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "classification" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConditionCardFragmentFragment, unknown>;
export const CriteriaPrescriptionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaPrescriptions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResults" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "prescriptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "medication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                      { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CriteriaPrescriptionsFragment, unknown>;
export const OrderedServicesColumnDocument = {
  __meta__: { hash: "ab7b1395dc56234489e2350d318e5db0465c2790" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderedServicesColumn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllServiceRequests" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "report_id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presented_form" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                            { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
                            { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
                            { kind: "Field", name: { kind: "Name", value: "display" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "performer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                            { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderedServicesColumnQuery, OrderedServicesColumnQueryVariables>;
export const SetupTwoFactorProfileDocument = {
  __meta__: { hash: "da13316edbf062a976c00213375bd22891d49700" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetupTwoFactorProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "profile" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SetupTwoFactorProfileInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setupTwoFactorProfile" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "profile" }, value: { kind: "Variable", name: { kind: "Name", value: "profile" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "factor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorPush" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorPushCoreFragment" } }],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorTotp" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorTOTPCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorAuthentication" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "sms_number" } },
          { kind: "Field", name: { kind: "Name", value: "sms_verified" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorPushCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorPush" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorTOTPCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorTotp" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "qr_uri" } },
          { kind: "Field", name: { kind: "Name", value: "secret" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetupTwoFactorProfileMutation, SetupTwoFactorProfileMutationVariables>;
export const DisableTwoFactorAuthenticationDocument = {
  __meta__: { hash: "80cdf2cb405d2139d2c698c6c8de352377206284" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DisableTwoFactorAuthentication" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "disableTwoFactorAuthentication" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorAuthentication" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "sms_number" } },
          { kind: "Field", name: { kind: "Name", value: "sms_verified" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisableTwoFactorAuthenticationMutation, DisableTwoFactorAuthenticationMutationVariables>;
export const VerifyTwilioFactorDocument = {
  __meta__: { hash: "0d5446570d67998b8bcf758a11ceb01ab049699b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifyTwilioFactor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "factor" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FactorVerifyInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyTwilioFactor" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "factor" }, value: { kind: "Variable", name: { kind: "Name", value: "factor" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sid" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyTwilioFactorMutation, VerifyTwilioFactorMutationVariables>;
export const CreateTwilioChallengeDocument = {
  __meta__: { hash: "a7706e60f40666110201fa1fafb0cdc4d189c15e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTwilioChallenge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "challenge" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ChallengeCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTwilioChallenge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "challenge" },
                value: { kind: "Variable", name: { kind: "Name", value: "challenge" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sid" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTwilioChallengeMutation, CreateTwilioChallengeMutationVariables>;
export const SendSmsVerificationCodeDocument = {
  __meta__: { hash: "8466302106fae6b24eca0a15941cbb488f22f0c8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendSMSVerificationCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "verificationPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "VerificationCodeRequest" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendSmsVerificationCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "verificationPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "verificationPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sid" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendSmsVerificationCodeMutation, SendSmsVerificationCodeMutationVariables>;
export const VerifySmsVerificationCodeDocument = {
  __meta__: { hash: "c944f0dfcb289dc96c3856fc88d0c33947e41292" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifySmsVerificationCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "VerificationCheckInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifySmsVerificationCode" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sid" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifySmsVerificationCodeMutation, VerifySmsVerificationCodeMutationVariables>;
export const UpdateUserProfileDocument = {
  __meta__: { hash: "7a8950ec46b1588939bccedf15013b49817057f1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "profile" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CynergyProfileUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserProfile" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "profile" }, value: { kind: "Variable", name: { kind: "Name", value: "profile" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ChangeUserPasswordDocument = {
  __meta__: { hash: "af21c135f4246b6f63c6814357652989c97ed5a8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ChangeUserPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "change" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ChangeUserPasswordInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeUserPassword" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "change" }, value: { kind: "Variable", name: { kind: "Name", value: "change" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const ManageUserAddressDocument = {
  __meta__: { hash: "66806a269d864b7f191368e9e84a7878fcf7892a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageUserAddress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "addressData" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserAddressInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageUserAddress" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "addressData" },
                value: { kind: "Variable", name: { kind: "Name", value: "addressData" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "action" }, value: { kind: "Variable", name: { kind: "Name", value: "action" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "token" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                      { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "address_id" } },
                            { kind: "Field", name: { kind: "Name", value: "nickname" } },
                            { kind: "Field", name: { kind: "Name", value: "use" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
                            { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip" } },
                            { kind: "Field", name: { kind: "Name", value: "is_default" } },
                            { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageUserAddressMutation, ManageUserAddressMutationVariables>;
export const ManageUserContactsDocument = {
  __meta__: { hash: "e7359e8a13953ea6d16f5e38726919d899064a1b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageUserContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactData" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserContactData" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageUserContacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactData" },
                value: { kind: "Variable", name: { kind: "Name", value: "contactData" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "action" }, value: { kind: "Variable", name: { kind: "Name", value: "action" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Contacts" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "nickname" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_relation_type" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_type" } },
                            { kind: "Field", name: { kind: "Name", value: "authorized_access" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageUserContactsMutation, ManageUserContactsMutationVariables>;
export const ManageUserDependentsDocument = {
  __meta__: { hash: "2f268ef72c429a93079d80e6aac31a3a563957e9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageUserDependents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dependentData" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserDependentData" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageUserDependents" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "action" }, value: { kind: "Variable", name: { kind: "Name", value: "action" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dependentData" },
                value: { kind: "Variable", name: { kind: "Name", value: "dependentData" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dependents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageUserDependentsMutation, ManageUserDependentsMutationVariables>;
export const CreatePaymentProfileDocument = {
  __meta__: { hash: "3dc6a9123fbe7baab31998e9cbb1010b8cb8704a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePaymentProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isDefault" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "billingAddress" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BillingAddressType" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cardDetails" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreditCardDetailsType" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPaymentProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "isDefault" },
                value: { kind: "Variable", name: { kind: "Name", value: "isDefault" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "billingAddress" },
                value: { kind: "Variable", name: { kind: "Name", value: "billingAddress" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardDetails" },
                value: { kind: "Variable", name: { kind: "Name", value: "cardDetails" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaymentProfileCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentProfileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "profile_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "user_id" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "authnet_payment_profile_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "card_type" } },
          { kind: "Field", name: { kind: "Name", value: "last_four_of_card" } },
          { kind: "Field", name: { kind: "Name", value: "billing_address" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "expiration" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "is_active" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaymentProfileMutation, CreatePaymentProfileMutationVariables>;
export const UpdatePaymentProfileDocument = {
  __meta__: { hash: "b777f8b9e198151bfa40f1f25f676574d1ca2712" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdatePaymentProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentProfileId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isDefault" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "billingAddress" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BillingAddressType" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cardDetails" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateCreditCardType" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePaymentProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentProfileID" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentProfileId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isDefault" },
                value: { kind: "Variable", name: { kind: "Name", value: "isDefault" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "billingAddress" },
                value: { kind: "Variable", name: { kind: "Name", value: "billingAddress" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardDetails" },
                value: { kind: "Variable", name: { kind: "Name", value: "cardDetails" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaymentProfileCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentProfileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "profile_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "user_id" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "authnet_payment_profile_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "card_type" } },
          { kind: "Field", name: { kind: "Name", value: "last_four_of_card" } },
          { kind: "Field", name: { kind: "Name", value: "billing_address" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "expiration" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "is_active" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePaymentProfileMutation, UpdatePaymentProfileMutationVariables>;
export const DeletePaymentProfileDocument = {
  __meta__: { hash: "d5f4b98523324d199cfda201808b9ff16fc89316" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePaymentProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentProfileId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePaymentProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentProfileID" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentProfileId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePaymentProfileMutation, DeletePaymentProfileMutationVariables>;
export const DeleteUserAccountDocument = {
  __meta__: { hash: "5f7e8a238e968c1f951b6d9b20df95a40a3c0f5a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUserAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "force" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUserAccount" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "force" }, value: { kind: "Variable", name: { kind: "Name", value: "force" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;
export const UpdateAppointmentRequestDocument = {
  __meta__: { hash: "f42440363db9f8dc91332271e4a50a10204506c8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAppointmentRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "request" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AppointmentUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAppointmentRequest" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "request" }, value: { kind: "Variable", name: { kind: "Name", value: "request" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>;
export const CancelAppointmentRequestDocument = {
  __meta__: { hash: "fbeb642875dcf33635fb0d7769f6a8136fe2cab4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelAppointmentRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "request" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AppointmentCancelInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelAppointmentRequest" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "request" }, value: { kind: "Variable", name: { kind: "Name", value: "request" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;
export const AddToCartDocument = {
  __meta__: { hash: "0703f67abcfeff1398e454c8d42d2a9a550d9dd0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddToCart" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "item" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "WebCartItemCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addToCart" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "item" }, value: { kind: "Variable", name: { kind: "Name", value: "item" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartItemCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "productCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddToCartMutation, AddToCartMutationVariables>;
export const RemoveFromCartDocument = {
  __meta__: { hash: "a06c2e4dd22a6f483df1b04de9d5101bf243d990" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveFromCart" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "items" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "WebCartItemDeleteInput" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFromCart" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "items" }, value: { kind: "Variable", name: { kind: "Name", value: "items" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "WebCartCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "booking_requests" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartSummaryCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCarts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_holder" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartBookingRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                { kind: "Field", name: { kind: "Name", value: "alias" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "address_id" } },
                      { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slot" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slot_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartSummaryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartSummaries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "subtotal" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          { kind: "Field", name: { kind: "Name", value: "surcharge" } },
          { kind: "Field", name: { kind: "Name", value: "item_count" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveFromCartMutation, RemoveFromCartMutationVariables>;
export const ClearCartDocument = {
  __meta__: { hash: "5502640e529e44ec6e4b36ca904b2c949fd43391" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClearCart" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearCart" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClearCartMutation, ClearCartMutationVariables>;
export const CheckoutCartDocument = {
  __meta__: { hash: "8047f29d4f90194071d338c1aa9cee0cd8eea6a4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CheckoutCart" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "checkout" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CartCheckoutInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkoutCart" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "checkout" }, value: { kind: "Variable", name: { kind: "Name", value: "checkout" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appointments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service_types" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "service" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckoutCartMutation, CheckoutCartMutationVariables>;
export const CreateTreatmentPlanDocument = {
  __meta__: { hash: "7bd43ff9fb11b90ffc0a4603c9cd82110763a452" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTreatmentPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentPlanCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTreatmentPlan" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "CarePlanCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "body_site" } },
                      { kind: "Field", name: { kind: "Name", value: "verification_status" } },
                      { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
                      { kind: "Field", name: { kind: "Name", value: "severity" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
                      { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
                      { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
                      { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
                      { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "care_team" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "members" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamMemberCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "period" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CarePlanCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CarePlans" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_plan_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamMemberCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeamMembers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "member_id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTreatmentPlanMutation, CreateTreatmentPlanMutationVariables>;
export const CreateConditionsAssessmentDocument = {
  __meta__: { hash: "a9fb76de8e6c7209789f4d7193d116bd89aaed55" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateConditionsAssessment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressionCreateInput" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newSymptoms" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SymptomsCreateInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "taskId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createConditionsAssessment" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newSymptoms" },
                value: { kind: "Variable", name: { kind: "Name", value: "newSymptoms" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "taskId" }, value: { kind: "Variable", name: { kind: "Name", value: "taskId" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionAssessmentCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionAssessmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "impression_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "change_pattern" } },
          { kind: "Field", name: { kind: "Name", value: "numeric_rating" } },
          { kind: "Field", name: { kind: "Name", value: "protocol" } },
          { kind: "Field", name: { kind: "Name", value: "assessment_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateConditionsAssessmentMutation, CreateConditionsAssessmentMutationVariables>;
export const CreateMedicalConditionDocument = {
  __meta__: { hash: "42a0a2f6ed74b5fa1ef4324bb28ccefbe67b638c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateMedicalCondition" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ConditionCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createMedicalCondition" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMedicalConditionMutation, CreateMedicalConditionMutationVariables>;
export const DeleteMedicalConditionDocument = {
  __meta__: { hash: "cd1d9fea8cba1a6ac793bed2cf619e6ab501e73d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteMedicalCondition" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "conditionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMedicalCondition" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "conditionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "conditionId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMedicalConditionMutation, DeleteMedicalConditionMutationVariables>;
export const UpdateMedicalConditionDocument = {
  __meta__: { hash: "295568888b2925d9dac8a51cc81dc8266d16b9b1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMedicalCondition" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ConditionUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMedicalCondition" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMedicalConditionMutation, UpdateMedicalConditionMutationVariables>;
export const AddClinicalNoteToPatientDocument = {
  __meta__: { hash: "c0dcf4a425475b40c70bedfcebde1ca21e6de692" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddClinicalNoteToPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ClinicalNoteCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addClinicalNoteToPatient" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClinicalNoteCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                      { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "open_now" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meta_data" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "rating" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "location_role" } },
                      { kind: "Field", name: { kind: "Name", value: "location_status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClinicalNoteCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalNotes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "note_id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddClinicalNoteToPatientMutation, AddClinicalNoteToPatientMutationVariables>;
export const DeleteClinicalNoteDocument = {
  __meta__: { hash: "e7b2e4456a05b510dc8fe8bde4930f7ee4cc7cc1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteClinicalNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "noteId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteClinicalNote" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "noteID" }, value: { kind: "Variable", name: { kind: "Name", value: "noteId" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClinicalNoteMutation, DeleteClinicalNoteMutationVariables>;
export const AddToCollectionDocument = {
  __meta__: { hash: "817761feea4f0dc17a512271bd783a83bab9b84a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddToCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "collection" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AddToCollectionInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addToCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collection" },
                value: { kind: "Variable", name: { kind: "Name", value: "collection" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionEntryCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddToCollectionMutation, AddToCollectionMutationVariables>;
export const RemoveFromCollectionDocument = {
  __meta__: { hash: "13617b12e0dcc70d96b768f202fc0e0026798b09" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveFromCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "entry" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RemoveFromCollectionInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFromCollection" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "entry" }, value: { kind: "Variable", name: { kind: "Name", value: "entry" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveFromCollectionMutation, RemoveFromCollectionMutationVariables>;
export const ConfirmEmailDocument = {
  __meta__: { hash: "d6dca52027930516e995733485a51ed396132c98" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "validationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cynergyId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "validationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "validationId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cynergyId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cynergyId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const UpsertCoverageDocument = {
  __meta__: { hash: "b41e7271b8a1769605901e3996ebad88546acf7c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertCoverage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CoverageUpsertInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertCoverage" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CoverageCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoverageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Coverages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "payor_name" } },
          { kind: "Field", name: { kind: "Name", value: "payor_external_id" } },
          { kind: "Field", name: { kind: "Name", value: "policy_number" } },
          { kind: "Field", name: { kind: "Name", value: "plan_type" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_first_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_last_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_dob" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_relationship_to_patient" } },
          { kind: "Field", name: { kind: "Name", value: "is_archived" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertCoverageMutation, UpsertCoverageMutationVariables>;
export const ArchiveCoverageDocument = {
  __meta__: { hash: "6e0856a283c52dcb3f9038e71fb827c7d984d27e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ArchiveCoverage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CoverageArchiveInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveCoverage" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CoverageCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoverageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Coverages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "payor_name" } },
          { kind: "Field", name: { kind: "Name", value: "payor_external_id" } },
          { kind: "Field", name: { kind: "Name", value: "policy_number" } },
          { kind: "Field", name: { kind: "Name", value: "plan_type" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_first_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_last_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_dob" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_relationship_to_patient" } },
          { kind: "Field", name: { kind: "Name", value: "is_archived" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveCoverageMutation, ArchiveCoverageMutationVariables>;
export const RestoreCoverageDocument = {
  __meta__: { hash: "bf3253e5f56b6474f91f1143ee7e90cc244a1254" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RestoreCoverage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CoverageRestoreInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "restoreCoverage" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CoverageCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoverageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Coverages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "payor_name" } },
          { kind: "Field", name: { kind: "Name", value: "payor_external_id" } },
          { kind: "Field", name: { kind: "Name", value: "policy_number" } },
          { kind: "Field", name: { kind: "Name", value: "plan_type" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_first_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_last_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_dob" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_relationship_to_patient" } },
          { kind: "Field", name: { kind: "Name", value: "is_archived" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestoreCoverageMutation, RestoreCoverageMutationVariables>;
export const SubmitCriteriaResultsDocument = {
  __meta__: { hash: "e7ad7c7b1c422cf192203566ad2b9f4facdc98d4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitCriteriaResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SubmitCriteriaFormResult" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitCriteriaResults" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "result_id" } },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
                { kind: "Field", name: { kind: "Name", value: "created_by" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "prescriptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                            { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flagged_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "diagnoses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hex" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "criteria" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "performer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "employee" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "demographics" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlagItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_codes" } },
          { kind: "Field", name: { kind: "Name", value: "applies_to" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitCriteriaResultsMutation, SubmitCriteriaResultsMutationVariables>;
export const UploadPatientDocumentsDocument = {
  __meta__: { hash: "f97f487d8b59983dce06b3966b9ab93f991a708f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadPatientDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UploadPatientDocumentsInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadPatientDocuments" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "patientDocumentId" } },
                { kind: "Field", name: { kind: "Name", value: "patientId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "currentUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "versions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "patientDocumentVersionId" } },
                      { kind: "Field", name: { kind: "Name", value: "sequence" } },
                      { kind: "Field", name: { kind: "Name", value: "uploadedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadPatientDocumentsMutation, UploadPatientDocumentsMutationVariables>;
export const RemovePatientDocumentDocument = {
  __meta__: { hash: "8820574ecea627d28584296c724e5aea149914eb" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemovePatientDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientDocumentId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removePatientDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientDocumentId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientDocumentId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemovePatientDocumentMutation, RemovePatientDocumentMutationVariables>;
export const MergeDuplicateRecordsDocument = {
  __meta__: { hash: "dd3b04f821aa8ac47ca20d3e08fc6313216e81f0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MergeDuplicateRecords" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "request" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RecordMergeRequestInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeRecords" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "request" }, value: { kind: "Variable", name: { kind: "Name", value: "request" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "mergedRecordIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MergeDuplicateRecordsMutation, MergeDuplicateRecordsMutationVariables>;
export const CreateEmployeeDocument = {
  __meta__: { hash: "ce692f46321e947e2fe3b08b1c965fca11e4ce96" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "employee" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignmentCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createEmployee" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "employee" }, value: { kind: "Variable", name: { kind: "Name", value: "employee" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "StaffAssignmentCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = {
  __meta__: { hash: "08de6395957f9d2e264bd1fc2bd8eb87121aaba0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "employee" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignmentUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateEmployee" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "employee" }, value: { kind: "Variable", name: { kind: "Name", value: "employee" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "StaffAssignmentCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = {
  __meta__: { hash: "2a535ac101bed5f321e52b4127a187bd9897f686" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "employee" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "EmployeeAssignmentReleaseInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEmployee" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "employee" }, value: { kind: "Variable", name: { kind: "Name", value: "employee" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const RegisterStaffUserDocument = {
  __meta__: { hash: "228b3f1bb3cedcd8a7055b19c2cec181f11b5798" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterStaffUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LocationStaffCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerLocationStaff" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registerPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "StaffAssignmentCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterStaffUserMutation, RegisterStaffUserMutationVariables>;
export const ChangeEmployeePasswordDocument = {
  __meta__: { hash: "a2bf1591cc513352ab9df15c15e548b5519aef35" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ChangeEmployeePassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "assignmentId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeEmployeePassword" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "password" }, value: { kind: "Variable", name: { kind: "Name", value: "password" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "assignmentId" },
                value: { kind: "Variable", name: { kind: "Name", value: "assignmentId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeEmployeePasswordMutation, ChangeEmployeePasswordMutationVariables>;
export const ToggleSupervisorRoleDocument = {
  __meta__: { hash: "c4687281a4dde8f95a4c8a123102a0910c8a9ebc" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleSupervisorRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ToggleSupervisorRoleInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "toggleSupervisorRole" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "cynergyId" } },
                { kind: "Field", name: { kind: "Name", value: "isSupervisor" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ToggleSupervisorRoleMutation, ToggleSupervisorRoleMutationVariables>;
export const ModifyOccurrenceDocument = {
  __meta__: { hash: "a094d97e3b4ce3103534ef44e0f4ebe925c32831" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ModifyOccurrence" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "occurrence" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SeriesOccurrenceUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSeriesOccurrence" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "occurrence" },
                value: { kind: "Variable", name: { kind: "Name", value: "occurrence" } },
              },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "EventCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Events" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "event_date" } },
          { kind: "Field", name: { kind: "Name", value: "all_day_event" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModifyOccurrenceMutation, ModifyOccurrenceMutationVariables>;
export const UpdateEventSeriesDocument = {
  __meta__: { hash: "421f9071ddefa7bf280d2ba68e0be4b93eca0e89" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEventSeries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "series" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "EventSeriesUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateEventSeries" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "series" }, value: { kind: "Variable", name: { kind: "Name", value: "series" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "EventSeriesCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pattern" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEventSeriesMutation, UpdateEventSeriesMutationVariables>;
export const DeactivateEventSeriesDocument = {
  __meta__: { hash: "172eda98946758933b26c7cb793ef51d2f2f6691" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeactivateEventSeries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "series" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "EventSeriesDeactivateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deactivateEventSeries" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "series" }, value: { kind: "Variable", name: { kind: "Name", value: "series" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "series_id" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeactivateEventSeriesMutation, DeactivateEventSeriesMutationVariables>;
export const DeactivateEventSeriesBatchDocument = {
  __meta__: { hash: "43dadf9e95cd5a4abf70204564fa1d833ffbddc3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeactivateEventSeriesBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "series" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "EventSeriesBulkDeactivateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deactivateEventSeriesBatch" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "series" }, value: { kind: "Variable", name: { kind: "Name", value: "series" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "deactivatedCount" } },
                { kind: "Field", name: { kind: "Name", value: "failedSeriesIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeactivateEventSeriesBatchMutation, DeactivateEventSeriesBatchMutationVariables>;
export const CreateQuestionnaireFormDocument = {
  __meta__: { hash: "4ec4f0b25006fed5389d4b29bb5b59741bca0f11" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateQuestionnaireForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireFormCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createQuestionnaireForm" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateQuestionnaireFormMutation, CreateQuestionnaireFormMutationVariables>;
export const CreateQuestionnaireItemsDocument = {
  __meta__: { hash: "67207330e5db37583fc5811147a466f385b2d54e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateQuestionnaireItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireQuestionCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createQuestionnaireItems" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer_options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabled_when" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "enable_id" } },
                            { kind: "Field", name: { kind: "Name", value: "link_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswerOptions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "option_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "initial_selected" } },
          { kind: "Field", name: { kind: "Name", value: "option_coding" } },
          { kind: "Field", name: { kind: "Name", value: "option_date" } },
          { kind: "Field", name: { kind: "Name", value: "option_time" } },
          { kind: "Field", name: { kind: "Name", value: "option_integer" } },
          { kind: "Field", name: { kind: "Name", value: "option_string" } },
          { kind: "Field", name: { kind: "Name", value: "option_boolean" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "option_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateQuestionnaireItemsMutation, CreateQuestionnaireItemsMutationVariables>;
export const CreateQuestionnaireResponseDocument = {
  __meta__: { hash: "282f5e5cec09d30ebc3b985d1f51e74dac88cdee" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateQuestionnaireResponse" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponseCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createQuestionnaireResponse" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "question" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "answer_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_attachment" } },
          { kind: "Field", name: { kind: "Name", value: "answer_string" } },
          { kind: "Field", name: { kind: "Name", value: "answer_uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_option" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "option_id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateQuestionnaireResponseMutation, CreateQuestionnaireResponseMutationVariables>;
export const UpdateQuestionnaireResponseDocument = {
  __meta__: { hash: "f5a9c67efee498b397a235e06ef9654a51d0cd00" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateQuestionnaireResponse" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponseUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateQuestionnaireResponse" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "answer_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_attachment" } },
          { kind: "Field", name: { kind: "Name", value: "answer_string" } },
          { kind: "Field", name: { kind: "Name", value: "answer_uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_option" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "option_id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateQuestionnaireResponseMutation, UpdateQuestionnaireResponseMutationVariables>;
export const UploadFilesDocument = {
  __meta__: { hash: "af473b8c1c40e57cff63e67dda9a2cce49911d6f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "files" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Upload" } } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "folder" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadFiles" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "files" }, value: { kind: "Variable", name: { kind: "Name", value: "files" } } },
              { kind: "Argument", name: { kind: "Name", value: "folder" }, value: { kind: "Variable", name: { kind: "Name", value: "folder" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "paths" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadFilesMutation, UploadFilesMutationVariables>;
export const UpdateProfilePhotoDocument = {
  __meta__: { hash: "aaab80d119baf8a2616a7fcd8108155e06236153" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProfilePhoto" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Upload" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfilePhoto" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "file" }, value: { kind: "Variable", name: { kind: "Name", value: "file" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "token" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                      { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "photo" } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProfilePhotoMutation, UpdateProfilePhotoMutationVariables>;
export const CreateNewFolderDocument = {
  __meta__: { hash: "d06e4f3e4a7416600c8553a87cb48ff476012ebd" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateNewFolder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "path" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createNewFolder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "path" }, value: { kind: "Variable", name: { kind: "Name", value: "path" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNewFolderMutation, CreateNewFolderMutationVariables>;
export const ManageFolderDocument = {
  __meta__: { hash: "73d3a92df5c7f4e85b41e01f8d5cbd6a8246b489" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageFolder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AppActions" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "folder" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newFolder" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "moveFolder" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "foldersToDelete" } },
          type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageFolder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "action" }, value: { kind: "Variable", name: { kind: "Name", value: "action" } } },
              { kind: "Argument", name: { kind: "Name", value: "folder" }, value: { kind: "Variable", name: { kind: "Name", value: "folder" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newFolder" },
                value: { kind: "Variable", name: { kind: "Name", value: "newFolder" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "moveFolder" },
                value: { kind: "Variable", name: { kind: "Name", value: "moveFolder" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "foldersToDelete" },
                value: { kind: "Variable", name: { kind: "Name", value: "foldersToDelete" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paths" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "folder" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "files" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "FileCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileMetaDataFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "etag" } },
          { kind: "Field", name: { kind: "Name", value: "lastModified" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileMetaDataFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketMetaData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "Fileextension" } },
          { kind: "Field", name: { kind: "Name", value: "Filename" } },
          { kind: "Field", name: { kind: "Name", value: "Folder" } },
          { kind: "Field", name: { kind: "Name", value: "Isstarred" } },
          { kind: "Field", name: { kind: "Name", value: "Istrashed" } },
          { kind: "Field", name: { kind: "Name", value: "Label" } },
          { kind: "Field", name: { kind: "Name", value: "Lastaccessed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageFolderMutation, ManageFolderMutationVariables>;
export const ManageFilesDocument = {
  __meta__: { hash: "148c98379d809312f4d29e34b4f9f4ef36742b45" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fileNames" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "label" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isStarred" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isTrashed" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageFiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "fileNames" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "label" }, value: { kind: "Variable", name: { kind: "Name", value: "label" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isStarred" },
                value: { kind: "Variable", name: { kind: "Name", value: "isStarred" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isTrashed" },
                value: { kind: "Variable", name: { kind: "Name", value: "isTrashed" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "newName" }, value: { kind: "Variable", name: { kind: "Name", value: "newName" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paths" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "folder" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "files" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "FileCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileMetaDataFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "etag" } },
          { kind: "Field", name: { kind: "Name", value: "lastModified" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileMetaDataFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketMetaData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "Fileextension" } },
          { kind: "Field", name: { kind: "Name", value: "Filename" } },
          { kind: "Field", name: { kind: "Name", value: "Folder" } },
          { kind: "Field", name: { kind: "Name", value: "Isstarred" } },
          { kind: "Field", name: { kind: "Name", value: "Istrashed" } },
          { kind: "Field", name: { kind: "Name", value: "Label" } },
          { kind: "Field", name: { kind: "Name", value: "Lastaccessed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageFilesMutation, ManageFilesMutationVariables>;
export const MoveFilesDocument = {
  __meta__: { hash: "d9831d45e905b06ce0c1e1db90caa204daa8918b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MoveFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paths" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "folder" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "moveFiles" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "paths" }, value: { kind: "Variable", name: { kind: "Name", value: "paths" } } },
              { kind: "Argument", name: { kind: "Name", value: "folder" }, value: { kind: "Variable", name: { kind: "Name", value: "folder" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paths" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "folder" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "files" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "FileCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileMetaDataFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "etag" } },
          { kind: "Field", name: { kind: "Name", value: "lastModified" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileMetaDataFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketMetaData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "Fileextension" } },
          { kind: "Field", name: { kind: "Name", value: "Filename" } },
          { kind: "Field", name: { kind: "Name", value: "Folder" } },
          { kind: "Field", name: { kind: "Name", value: "Isstarred" } },
          { kind: "Field", name: { kind: "Name", value: "Istrashed" } },
          { kind: "Field", name: { kind: "Name", value: "Label" } },
          { kind: "Field", name: { kind: "Name", value: "Lastaccessed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoveFilesMutation, MoveFilesMutationVariables>;
export const DeleteFilesDocument = {
  __meta__: { hash: "f79b3df38e957886cef42f0c9832fdd652b9ec3f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fileNames" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "fileNames" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const ManageSharedFileDocument = {
  __meta__: { hash: "c6f404e311ef3d63b21210367efff30aff575cac" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageSharedFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sourcePath" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AppActions" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageSharedFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sourcePath" },
                value: { kind: "Variable", name: { kind: "Name", value: "sourcePath" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "action" }, value: { kind: "Variable", name: { kind: "Name", value: "action" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageSharedFileMutation, ManageSharedFileMutationVariables>;
export const GetPresignedUploadUrlDocument = {
  __meta__: { hash: "1dedd1403997d2b02874c5ea9f93bf750f0804cd" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GetPresignedUploadUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MinioS3DestinationInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPresignedUploadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPresignedUploadUrlMutation, GetPresignedUploadUrlMutationVariables>;
export const GetPresignedRequestUrlDocument = {
  __meta__: { hash: "c392878ff328d24c11182f55416181755ae53836" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GetPresignedRequestUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MinioS3DestinationInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPresignedRequestUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPresignedRequestUrlMutation, GetPresignedRequestUrlMutationVariables>;
export const GetReportUrlDocument = {
  __meta__: { hash: "b6b80544091f760c2357bb0c06088d075fb42850" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GetReportUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reportId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReportUrl" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "reportId" }, value: { kind: "Variable", name: { kind: "Name", value: "reportId" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReportUrlMutation, GetReportUrlMutationVariables>;
export const PasswordResetRequestDocument = {
  __meta__: { hash: "972436569abc6d8d015014849ac75f0065a05407" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PasswordResetRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reset" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RequestPasswordResetInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestPasswordReset" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "reset" }, value: { kind: "Variable", name: { kind: "Name", value: "reset" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PasswordResetRequestMutation, PasswordResetRequestMutationVariables>;
export const ResetPasswordDocument = {
  __meta__: { hash: "7a9ae2b573e3f980b7a83c8e84a26da2f03b1969" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResetPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resetPassword" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "password" }, value: { kind: "Variable", name: { kind: "Name", value: "password" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const AcceptOnboardingInviteDocument = {
  __meta__: { hash: "860b0ab587cba4f0c7c336594b36c50357f372f9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AcceptOnboardingInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "invitePayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AcceptOnboardingInviteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptOnboardingInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitePayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "invitePayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptOnboardingInviteMutation, AcceptOnboardingInviteMutationVariables>;
export const RegisterLocationPatientMutationDocument = {
  __meta__: { hash: "cf0300bf83612416b9f548fb5726ea83a8c2362c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterLocationPatientMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LocationPatientCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerLocationPatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registerPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationPatientCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationPatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LocationPatients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "full_name" } },
                            { kind: "Field", name: { kind: "Name", value: "dob" } },
                            { kind: "Field", name: { kind: "Name", value: "age" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterLocationPatientMutationMutation, RegisterLocationPatientMutationMutationVariables>;
export const RemoveLocationPatientDocument = {
  __meta__: { hash: "7b1e64c9047bc324b32ec309fec37d0ddf6fb0ab" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveLocationPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeLocationPatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationPatientCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationPatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LocationPatients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "full_name" } },
                            { kind: "Field", name: { kind: "Name", value: "dob" } },
                            { kind: "Field", name: { kind: "Name", value: "age" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveLocationPatientMutation, RemoveLocationPatientMutationVariables>;
export const RestoreLocationPatientDocument = {
  __meta__: { hash: "5cfbfe38cc72d844617e0e4098a59b3852e010af" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RestoreLocationPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "restoreLocationPatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationPatientCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationPatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LocationPatients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "full_name" } },
                            { kind: "Field", name: { kind: "Name", value: "dob" } },
                            { kind: "Field", name: { kind: "Name", value: "age" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestoreLocationPatientMutation, RestoreLocationPatientMutationVariables>;
export const AssignPatientRoomDocument = {
  __meta__: { hash: "c0b65bcce9796df97717553955b3bcb856d37d78" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AssignPatientRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "assignPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AssignPatientRoomInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignPatientRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assignPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "assignPayload" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignPatientRoomMutation, AssignPatientRoomMutationVariables>;
export const LoginDocument = {
  __meta__: { hash: "8477827a8f2445511b7e08c0fa644fc7df99ac34" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Login" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "loginPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoginRequest" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "login" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "loginPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "loginPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "token" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                      { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                      { kind: "Field", name: { kind: "Name", value: "cynergyId" } },
                      { kind: "Field", name: { kind: "Name", value: "practitionerId" } },
                      { kind: "Field", name: { kind: "Name", value: "staffRelationId" } },
                      { kind: "Field", name: { kind: "Name", value: "organizationId" } },
                      { kind: "Field", name: { kind: "Name", value: "locationId" } },
                      { kind: "Field", name: { kind: "Name", value: "locationName" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availableLocations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alias" } }] },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "userType" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "initials" } },
                      { kind: "Field", name: { kind: "Name", value: "authnetProfileId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                            { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip" } },
                            { kind: "Field", name: { kind: "Name", value: "formattedAddress" } },
                            { kind: "Field", name: { kind: "Name", value: "placeId" } },
                            { kind: "Field", name: { kind: "Name", value: "isDefault" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "defaultPage" } },
                      { kind: "Field", name: { kind: "Name", value: "firstLogin" } },
                      { kind: "Field", name: { kind: "Name", value: "twoFactorEnabled" } },
                      { kind: "Field", name: { kind: "Name", value: "twoFactorMethod" } },
                      { kind: "Field", name: { kind: "Name", value: "photo" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const AddBulkPatientMedicationsDocument = {
  __meta__: { hash: "b9f0d6d6817dc748db6aa218e90ea8dd295420b6" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddBulkPatientMedications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "medicationPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AddPatientMedicationInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addBulkPatientMedications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "medicationPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "medicationPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragmentAlt" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddBulkPatientMedicationsMutation, AddBulkPatientMedicationsMutationVariables>;
export const UpdateMedicationDocument = {
  __meta__: { hash: "2783d4cd4f416bd0d95c3863f1037a13cdab4476" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMedication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "updatePayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PatientMedicationUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePatientMedication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "updatePayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total_volume" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RatioCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RatioCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ratio" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "ratio_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numerator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "denominator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMedicationMutation, UpdateMedicationMutationVariables>;
export const DeleteMedicationUsageDocument = {
  __meta__: { hash: "a57d7268e7849ae14959c78b90e1b9ca76a8e245" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteMedicationUsage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "usageId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMedicationUsage" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "usageId" }, value: { kind: "Variable", name: { kind: "Name", value: "usageId" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMedicationUsageMutation, DeleteMedicationUsageMutationVariables>;
export const UpdateUserMessageDocument = {
  __meta__: { hash: "adeab0da6d12f21371534e052c5bea266329054f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserMessage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "updatePayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MessageUpdatePayload" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "messageIDs" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserMessages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "updatePayload" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "messageIDs" },
                value: { kind: "Variable", name: { kind: "Name", value: "messageIDs" } },
              },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Messages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "message_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "is_trashed" } },
          { kind: "Field", name: { kind: "Name", value: "is_starred" } },
          { kind: "Field", name: { kind: "Name", value: "attachment" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMessageMutation, UpdateUserMessageMutationVariables>;
export const ReadUserNotificationDocument = {
  __meta__: { hash: "f3eb4869828a768f654d2255e83073e22dce1ad8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReadUserNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notificationID" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "readUserNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "notificationID" },
                value: { kind: "Variable", name: { kind: "Name", value: "notificationID" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReadUserNotificationMutation, ReadUserNotificationMutationVariables>;
export const UpdateUserNotificationDocument = {
  __meta__: { hash: "c7d317649302cf322c101349b1cd5a8cad1e47ea" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "updatePayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NotificationUpdatePayload" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notificationIds" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "updatePayload" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notificationIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "notificationIds" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserNotificationMutation, UpdateUserNotificationMutationVariables>;
export const SendOnboardingInviteDocument = {
  __meta__: { hash: "9f7acc3f539ae687b2a44e71ec7178f7e9e4e57b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendOnboardingInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "invitePayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OnboardingInviteCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendOnboardingInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitePayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "invitePayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "invite_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendOnboardingInviteMutation, SendOnboardingInviteMutationVariables>;
export const UpdateOrderBillingDocument = {
  __meta__: { hash: "87770fb3399b1f049a2c32fda2c96b56bbdbe288" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrderBilling" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_coverage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "payor_name" } },
                      { kind: "Field", name: { kind: "Name", value: "policy_number" } },
                      { kind: "Field", name: { kind: "Name", value: "plan_type" } },
                      { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOrderBillingMutation, UpdateOrderBillingMutationVariables>;
export const SubmitOrderRequestDocument = {
  __meta__: { hash: "ef886d3b18ac04f0c47f111d95806f4e95add37c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitOrderRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SubmitOrderRequestInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitOrderRequest" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitOrderRequestMutation, SubmitOrderRequestMutationVariables>;
export const UpdateOrderDocument = {
  __meta__: { hash: "8868a7eb3c368369e47188d64e13dc8d2f905acb" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactInformationFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "line_items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderLineItemCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "order_id" } },
                      { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetailsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_detail_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInformationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "ContactDetailsCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "telecom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderLineItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderLineItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "net_total" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const ManageOrderLineItemsDocument = {
  __meta__: { hash: "a302ad498f6b59bea69887935f493f91558d00a1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderLineItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "line_items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "OrderLineItemCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "request" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "service" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "service_id" } }] },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "location_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                  { kind: "Field", name: { kind: "Name", value: "phone" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderLineItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderLineItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "net_total" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderLineItemsMutation, ManageOrderLineItemsMutationVariables>;
export const ManageOrderContactsDocument = {
  __meta__: { hash: "1f03a35c5dac4f56bb9810155b84df83ad9edad4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactInformationFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetailsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_detail_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInformationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "ContactDetailsCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "telecom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderContactsMutation, ManageOrderContactsMutationVariables>;
export const ManageOrderDiagnosisCodesDocument = {
  __meta__: { hash: "83447a84c5674fc07a38c70cc3154367fa0d5419" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderDiagnosisCodes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CodeFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CodeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderDiagnosisCodesMutation, ManageOrderDiagnosisCodesMutationVariables>;
export const ManageOrderSpecimenDocument = {
  __meta__: { hash: "59cc6f77ef328eceb9f7518480b08d3897fdc32b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderSpecimen" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderSpecimenMutation, ManageOrderSpecimenMutationVariables>;
export const ManageOrderProviderDocument = {
  __meta__: { hash: "b152f904e89cbb466707e8061e8429ef0909b75e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_id" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "practitioner" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                            { kind: "Field", name: { kind: "Name", value: "npi" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signature" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                            { kind: "Field", name: { kind: "Name", value: "signature_format" } },
                            { kind: "Field", name: { kind: "Name", value: "signed_by" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderProviderMutation, ManageOrderProviderMutationVariables>;
export const ManageOrderRecurrenceDocument = {
  __meta__: { hash: "0d60f896fba334c73602b4d54cf86a17e10b8bf1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderRecurrence" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "series" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "EventSeriesCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderRecurrenceMutation, ManageOrderRecurrenceMutationVariables>;
export const ManageOrderAgentsDocument = {
  __meta__: { hash: "5a17980ab106f6746467b7bc94b53c97494f6cf0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageOrderAgents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageOrderAgentsMutation, ManageOrderAgentsMutationVariables>;
export const RemoveOrderLineItemsDocument = {
  __meta__: { hash: "87a54dd1064cabcb04e9b7d792bf80dc4d22866e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveOrderLineItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "line_items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderLineItemCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderLineItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderLineItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "net_total" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveOrderLineItemsMutation, RemoveOrderLineItemsMutationVariables>;
export const CancelOrderDocument = {
  __meta__: { hash: "e23a1cb14d8f306195f9f54d2609e720796bb527" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const CancelOrderBatchDocument = {
  __meta__: { hash: "7243281aa04d37727bd6d88127b80c1b7a03ba6f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelOrderBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "batch" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderBulkDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelOrderBatch" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "batch" }, value: { kind: "Variable", name: { kind: "Name", value: "batch" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelOrderBatchMutation, CancelOrderBatchMutationVariables>;
export const DeleteOrderDocument = {
  __meta__: { hash: "efe7290c1b7837e02faf5fb4aaa0d98da5fa299f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "order" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const DeleteOrderBatchDocument = {
  __meta__: { hash: "ae80e048748725336f2dd952d01c383985ed9e2c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteOrderBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "batch" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderBulkDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOrderBatch" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "batch" }, value: { kind: "Variable", name: { kind: "Name", value: "batch" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOrderBatchMutation, DeleteOrderBatchMutationVariables>;
export const ProcessOrderPaymentDocument = {
  __meta__: { hash: "188e46f6321e12d35e8e20b37f4d96f14850bd3d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProcessOrderPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentMethod" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CheckoutPaymentMethodInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "processOrderPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentMethod" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentMethod" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProcessOrderPaymentMutation, ProcessOrderPaymentMutationVariables>;
export const MergeOrdersDocument = {
  __meta__: { hash: "8be78d5f63ffdedfd2898428702fcd11c778ac76" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MergeOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "merge" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderMergeInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeOrders" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "merge" }, value: { kind: "Variable", name: { kind: "Name", value: "merge" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MergeOrdersMutation, MergeOrdersMutationVariables>;
export const RegisterPractitionerDocument = {
  __meta__: { hash: "496e0014aac20b3585bf022b8610b1c05a198d55" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterPractitioner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PractitionerRegisterInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerPractitioner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registerPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taxonomies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TaxonomiesCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "qualifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerQualificationCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaxonomiesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Taxonomies" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "taxonomy_id" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "primary" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "group" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerQualificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerQualifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "qualification_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "credential" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
          { kind: "Field", name: { kind: "Name", value: "is_verified" } },
          { kind: "Field", name: { kind: "Name", value: "verified_on" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterPractitionerMutation, RegisterPractitionerMutationVariables>;
export const UploadPractitionerSignatureDocument = {
  __meta__: { hash: "de4c27080605e19909d76271c7e7cc429622e151" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadPractitionerSignature" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "signature" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UploadPractitionerSignatureInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadPractitionerSignature" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "signature" },
                value: { kind: "Variable", name: { kind: "Name", value: "signature" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerSignatureCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "who" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      { kind: "Field", name: { kind: "Name", value: "npi" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerSignatureCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerSignatures" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "signature_id" } },
          { kind: "Field", name: { kind: "Name", value: "signature_format" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "when" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadPractitionerSignatureMutation, UploadPractitionerSignatureMutationVariables>;
export const DeletePractitionerSignatureDocument = {
  __meta__: { hash: "6126b0abda11d194cffca35009564b9b1e1b4740" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePractitionerSignature" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "signature" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PractitionerSignatureDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePractitionerSignature" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "signature" },
                value: { kind: "Variable", name: { kind: "Name", value: "signature" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePractitionerSignatureMutation, DeletePractitionerSignatureMutationVariables>;
export const DeletePractitionerDocument = {
  __meta__: { hash: "3817dcce89b1503d37afcb0ef57dcc7150dc236f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePractitioner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PractitionerDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePractitioner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deletePayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "payload" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePractitionerMutation, DeletePractitionerMutationVariables>;
export const CreateUserProductBundleDocument = {
  __meta__: { hash: "8dfb50fb88fb7ce089d0b2895a0a2b9330d83ee8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateUserProductBundle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundle" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUserProductBundle" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "bundle" }, value: { kind: "Variable", name: { kind: "Name", value: "bundle" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bundle_id" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserProductBundleMutation, CreateUserProductBundleMutationVariables>;
export const UpdateUserProductBundleDocument = {
  __meta__: { hash: "79568870c8278d10151aa08165f620323efaacf7" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserProductBundle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundle" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserProductBundle" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "bundle" }, value: { kind: "Variable", name: { kind: "Name", value: "bundle" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bundle_id" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserProductBundleMutation, UpdateUserProductBundleMutationVariables>;
export const ManageUserProductBundleItemsDocument = {
  __meta__: { hash: "201f4ecaca647f0819ae5c12aa3b2f4596c7a7a8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageUserProductBundleItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "items" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItemManageInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageUserProductBundleItems" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "items" }, value: { kind: "Variable", name: { kind: "Name", value: "items" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bundle_id" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageUserProductBundleItemsMutation, ManageUserProductBundleItemsMutationVariables>;
export const DeleteUserProductBundleDocument = {
  __meta__: { hash: "dd040b44a804f0d1f9f7fc10d6000f655fc99acc" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUserProductBundle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundle" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUserProductBundle" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "bundle" }, value: { kind: "Variable", name: { kind: "Name", value: "bundle" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserProductBundleMutation, DeleteUserProductBundleMutationVariables>;
export const DeleteUserProductBundleBatchDocument = {
  __meta__: { hash: "1e05aad3d947d1727f19fbe8f81e6eda966f99f1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUserProductBundleBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundle" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleBulkDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUserProductBundleBatch" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "bundle" }, value: { kind: "Variable", name: { kind: "Name", value: "bundle" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserProductBundleBatchMutation, DeleteUserProductBundleBatchMutationVariables>;
export const ManageUserProductBundleSharesDocument = {
  __meta__: { hash: "3f68a56eb16fa227961f1ed76b117e15a85b6bf0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageUserProductBundleShares" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shares" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleShareManageInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageUserProductBundleShares" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "shares" }, value: { kind: "Variable", name: { kind: "Name", value: "shares" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "is_shared" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageUserProductBundleSharesMutation, ManageUserProductBundleSharesMutationVariables>;
export const ShareUserProductBundleWithGroupsDocument = {
  __meta__: { hash: "d80d306a735dd726f71156e952a2087fa50ab855" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ShareUserProductBundleWithGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "shares" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleGroupShareCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shareUserProductBundleWithGroups" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "shares" }, value: { kind: "Variable", name: { kind: "Name", value: "shares" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
                { kind: "Field", name: { kind: "Name", value: "is_shared" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShareUserProductBundleWithGroupsMutation, ShareUserProductBundleWithGroupsMutationVariables>;
export const UserRegisterDocument = {
  __meta__: { hash: "75cc0755d90d6298a62e13d796c64b8c94dc1f65" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UserRegister" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RegisterUserInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userRegister" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registerPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserRegisterMutation, UserRegisterMutationVariables>;
export const OrgRegisterDocument = {
  __meta__: { hash: "82f8a4b9b2477ae1c4145ad9bde32ccab4fc2c7e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgRegister" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RegisterUserInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userRegister" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registerPayload" },
                value: { kind: "Variable", name: { kind: "Name", value: "registerPayload" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgRegisterMutation, OrgRegisterMutationVariables>;
export const SendoutRequisitionEmailsDocument = {
  __meta__: { hash: "67eb0054446f7241016ed17164381b008daad3a7" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendoutRequisitionEmails" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendoutRequisitionEmails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendoutRequisitionEmailsMutation, SendoutRequisitionEmailsMutationVariables>;
export const CreateRecurrencePatternDocument = {
  __meta__: { hash: "d4528cbb5821eae10ed10cfbfdca3691a9d42e65" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecurrencePattern" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pattern" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatternCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createRecurrencePattern" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "pattern" }, value: { kind: "Variable", name: { kind: "Name", value: "pattern" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRecurrencePatternMutation, CreateRecurrencePatternMutationVariables>;
export const CreateTaskDocument = {
  __meta__: { hash: "b7f3d5fb87454b2239ad7903266f21a4f25cff31" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TaskCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTask" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TaskCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>;
export const DeleteTaskDocument = {
  __meta__: { hash: "e4ce851160f5551e2fe7d9a0df3a74681707f278" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TaskDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTask" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const UpdateTaskDocument = {
  __meta__: { hash: "75f7b23db77b3aba543e27bc08b84fbdca32e2f3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TaskUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTask" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TaskCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTaskStepDocument = {
  __meta__: { hash: "f1056f53e8c765b7cb28943f1b54ce52378ad733" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTaskStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "payload" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TaskStepUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTaskStep" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "payload" }, value: { kind: "Variable", name: { kind: "Name", value: "payload" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TaskStepCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "task" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TaskCoreFragment" } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskStepCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TaskSteps" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "step_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskStepMutation, UpdateTaskStepMutationVariables>;
export const GetTwoFactorProfileDocument = {
  __meta__: { hash: "8037fd92dcbc1d55c62136f51a850fb6505bb294" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTwoFactorProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTwoFactorProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "factor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorPush" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorPushCoreFragment" } }],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorTotp" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TwoFactorTOTPCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorAuthenticationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorAuthentication" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "enabled" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "sms_number" } },
          { kind: "Field", name: { kind: "Name", value: "sms_verified" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorPushCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorPush" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TwoFactorTOTPCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TwoFactorTotp" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "two_factor_id" } },
          { kind: "Field", name: { kind: "Name", value: "qr_uri" } },
          { kind: "Field", name: { kind: "Name", value: "secret" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTwoFactorProfileQuery, GetTwoFactorProfileQueryVariables>;
export const GetAllCynergyUsersDocument = {
  __meta__: { hash: "e58a007c5b6166ec1e5afd83c8672fb87b23afa5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllCynergyUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllCynergyUsers" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllCynergyUsersQuery, GetAllCynergyUsersQueryVariables>;
export const GetPaginatedCynergyUsersDocument = {
  __meta__: { hash: "7f00a8eb46b05016a4ce3e6bd3efa9a181a34928" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedCynergyUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedCynergyUsers" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedCynergyUsersQuery, GetPaginatedCynergyUsersQueryVariables>;
export const GetUserAccountDocument = {
  __meta__: { hash: "81037a526fbf230a3c540d50b7e4bcacf85b3f00" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userType" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserTypes" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserAccount" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AddressCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contacts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "nickname" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "authorized_access" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_type" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_relation_type" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "actor" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "userType" },
                            value: { kind: "Variable", name: { kind: "Name", value: "userType" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "dependents" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "primary_provider" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "practitioner_id" } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "address_id" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "place_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserAccountQuery, GetUserAccountQueryVariables>;
export const GetPatientDocument = {
  __meta__: { hash: "52852309dcdcb3f5e2fb43bfc4cf8cea75994930" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPatient" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dependents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientQuery, GetPatientQueryVariables>;
export const GetPatientDetailsDocument = {
  __meta__: { hash: "f5b855560e1c43c50d4175e123fd791638fe9cd7" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPatient" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primary_provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>;
export const GetPatientDemographicsDocument = {
  __meta__: { hash: "07d65bc083ca4015fc6025fed50c3cb6fe132a88" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientDemographics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPatient" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientDemographicsQuery, GetPatientDemographicsQueryVariables>;
export const GetPatientSubscriberDocument = {
  __meta__: { hash: "048b736b5081e1674da4f0fd60035a8a51da68c7" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientSubscriber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPatient" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "dob" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "address_id" } },
                            { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
                            { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip" } },
                            { kind: "Field", name: { kind: "Name", value: "is_default" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientSubscriberQuery, GetPatientSubscriberQueryVariables>;
export const GetAppointmentSlotsDocument = {
  __meta__: { hash: "d026fd26e26be8076d4120f7c8a910b558587436" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAppointmentSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "resource" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AppointmentResourceAvailability" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "horizon" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "AppointmentAvailabilityHorizon" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAppointmentSlots" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "resource" }, value: { kind: "Variable", name: { kind: "Name", value: "resource" } } },
              { kind: "Argument", name: { kind: "Name", value: "horizon" }, value: { kind: "Variable", name: { kind: "Name", value: "horizon" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slot_id" } },
                { kind: "Field", name: { kind: "Name", value: "service_type" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppointmentSlotsQuery, GetAppointmentSlotsQueryVariables>;
export const GetAppointmentDetailsDocument = {
  __meta__: { hash: "03b7c173458b0cb4f1a8cd72ea8ea5530dcbba51" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAppointmentDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAppointment" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "service_types" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentServiceTypesFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_id" } },
                      { kind: "Field", name: { kind: "Name", value: "balance" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "line_items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
                            { kind: "Field", name: { kind: "Name", value: "net_total" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "request" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "request_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "service_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "code" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requisition" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "title" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                  { kind: "Field", name: { kind: "Name", value: "size" } },
                                  { kind: "Field", name: { kind: "Name", value: "content_type" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "address_id" } },
                            { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
                            { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient_instruction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concept" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "concept_id" } },
                            { kind: "Field", name: { kind: "Name", value: "text" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentServiceTypesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AppointmentServiceTypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "type_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppointmentDetailsQuery, GetAppointmentDetailsQueryVariables>;
export const GetPaginatedAppointmentsDocument = {
  __meta__: { hash: "310cd7b9e54d9745a2acb4f13e30ecc86b91e0a8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedAppointments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedAppointments" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PatientDemographicFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service_types" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentServiceTypesFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "order_id" } },
                            { kind: "Field", name: { kind: "Name", value: "balance" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "address_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
                                  { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "state" } },
                                  { kind: "Field", name: { kind: "Name", value: "zip" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientDemographicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentServiceTypesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AppointmentServiceTypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "type_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedAppointmentsQuery, GetPaginatedAppointmentsQueryVariables>;
export const AppointmentsFeedDocument = {
  __meta__: { hash: "7d19205c8534eb02e8cd4abdee7f2eafc1cde9f4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AppointmentsFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "appointmentList" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service_types" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AppointmentServiceTypesFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Appointments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "appointment_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "patient_name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_start" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_end" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppointmentServiceTypesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AppointmentServiceTypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "type_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentsFeedQuery, AppointmentsFeedQueryVariables>;
export const CartDocument = {
  __meta__: { hash: "fbe68f3f374eeff08dad89a28ac6ac072433adeb" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Cart" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cart" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "WebCartCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "WebCartItemCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "family" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "store" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "location_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "booking_requests" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "WebCartSummaryCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCarts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_holder" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "productCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartBookingRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartBookingRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                { kind: "Field", name: { kind: "Name", value: "alias" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "address_id" } },
                      { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slot" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slot_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebCartSummaryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCartSummaries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "cart_id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "subtotal" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
          { kind: "Field", name: { kind: "Name", value: "surcharge" } },
          { kind: "Field", name: { kind: "Name", value: "item_count" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CartQuery, CartQueryVariables>;
export const GetCarePlanDocument = {
  __meta__: { hash: "6dd8703bdb356f5f6a0e8078908858fcb53fce5c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCarePlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCarePlan" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "CarePlanCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "care_team" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                      { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "hex" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "period" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "period_id" } },
                      { kind: "Field", name: { kind: "Name", value: "start" } },
                      { kind: "Field", name: { kind: "Name", value: "end" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CarePlanCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CarePlans" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_plan_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCarePlanQuery, GetCarePlanQueryVariables>;
export const GetCareTeamDocument = {
  __meta__: { hash: "0309490f1b837e781219631c813bafffe4017725" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCareTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCareTeam" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "managing_organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_type" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamMemberCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Contacts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "authorized_access" } },
          { kind: "Field", name: { kind: "Name", value: "contact_type" } },
          { kind: "Field", name: { kind: "Name", value: "contact_relation_type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamMemberCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeamMembers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "member_id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCareTeamQuery, GetCareTeamQueryVariables>;
export const GetPatientConditionDocument = {
  __meta__: { hash: "3c1bf799cfcedd4d9e8d6e3d89079dc6a9b844c5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientCondition" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPatientCondition" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                      { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "hex" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treatment_plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "care_plan_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assessments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionAssessmentCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionAssessmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "impression_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "change_pattern" } },
          { kind: "Field", name: { kind: "Name", value: "numeric_rating" } },
          { kind: "Field", name: { kind: "Name", value: "protocol" } },
          { kind: "Field", name: { kind: "Name", value: "assessment_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientConditionQuery, GetPatientConditionQueryVariables>;
export const GetAllCarePlansDocument = {
  __meta__: { hash: "09f633d1a27626ed9332f4db59c7c2ca4226849a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllCarePlans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllCarePlans" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "care_plan_id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllCarePlansQuery, GetAllCarePlansQueryVariables>;
export const GetPaginatedCarePlansDocument = {
  __meta__: { hash: "6af3bca4a6e4b63856597ee27e3ba5deed38efdb" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedCarePlans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedCarePlans" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "demographics" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CarePlanCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "body_site" } },
                            { kind: "Field", name: { kind: "Name", value: "verification_status" } },
                            { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
                            { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
                            { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
                            { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
                            { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "care_team" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "members" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CareTeamMemberCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CarePlanCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CarePlans" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_plan_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CareTeamMemberCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeamMembers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "member_id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedCarePlansQuery, GetPaginatedCarePlansQueryVariables>;
export const GetAllPatientConditionsDocument = {
  __meta__: { hash: "08b0f9c860d9e419ab9f2531a723d1d352c215da" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllPatientConditions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllPatientConditions" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                      { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "hex" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assessments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionAssessmentCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treatment_medications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionAssessmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "impression_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "change_pattern" } },
          { kind: "Field", name: { kind: "Name", value: "numeric_rating" } },
          { kind: "Field", name: { kind: "Name", value: "protocol" } },
          { kind: "Field", name: { kind: "Name", value: "assessment_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllPatientConditionsQuery, GetAllPatientConditionsQueryVariables>;
export const GetAllConditionAssessmentsDocument = {
  __meta__: { hash: "2ee6134815484bfea7df420f675ebec50d8b864e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllConditionAssessments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllConditionAssessments" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ConditionAssessmentCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "problem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionAssessmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "impression_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "change_pattern" } },
          { kind: "Field", name: { kind: "Name", value: "numeric_rating" } },
          { kind: "Field", name: { kind: "Name", value: "protocol" } },
          { kind: "Field", name: { kind: "Name", value: "assessment_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllConditionAssessmentsQuery, GetAllConditionAssessmentsQueryVariables>;
export const GetAllClinicalNotesDocument = {
  __meta__: { hash: "a743d307cd2589c1abb69209ae9ebafa72d54532" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllClinicalNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllClinicalNotes" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "note_id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "authored" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                      { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "open_now" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meta_data" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "rating" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "location_role" } },
                      { kind: "Field", name: { kind: "Name", value: "location_status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllClinicalNotesQuery, GetAllClinicalNotesQueryVariables>;
export const GetClinicalNoteDocument = {
  __meta__: { hash: "5f5e5660ec987772ff497fdecdf3f7c00a628927" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClinicalNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClinicalNote" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ClinicalNoteCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                      { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "open_now" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meta_data" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "rating" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "location_role" } },
                      { kind: "Field", name: { kind: "Name", value: "location_status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClinicalNoteCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalNotes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "note_id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClinicalNoteQuery, GetClinicalNoteQueryVariables>;
export const GetPaginatedConditionAssessmentsDocument = {
  __meta__: { hash: "bac1843ee16cdc13c110a6446e437b28109e3660" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedConditionAssessments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedConditionAssessments" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ConditionAssessmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "problem" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "classification" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                                  { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "hex" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionAssessmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ClinicalImpressions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "impression_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "change_pattern" } },
          { kind: "Field", name: { kind: "Name", value: "numeric_rating" } },
          { kind: "Field", name: { kind: "Name", value: "protocol" } },
          { kind: "Field", name: { kind: "Name", value: "assessment_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedConditionAssessmentsQuery, GetPaginatedConditionAssessmentsQueryVariables>;
export const GetPatientCoveragesDocument = {
  __meta__: { hash: "c02131f21197422a49ff4f056a980daea487eda8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientCoverages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedCoverages" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CoverageCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoverageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Coverages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "payor_name" } },
          { kind: "Field", name: { kind: "Name", value: "payor_external_id" } },
          { kind: "Field", name: { kind: "Name", value: "policy_number" } },
          { kind: "Field", name: { kind: "Name", value: "plan_type" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_first_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_last_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_dob" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_relationship_to_patient" } },
          { kind: "Field", name: { kind: "Name", value: "is_archived" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientCoveragesQuery, GetPatientCoveragesQueryVariables>;
export const GetCoverageDocument = {
  __meta__: { hash: "eff91fd4967b01ebc668def07095fa69e9eab98f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCoverage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "coverageId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCoverage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coverageId" },
                value: { kind: "Variable", name: { kind: "Name", value: "coverageId" } },
              },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CoverageCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoverageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Coverages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "payor_name" } },
          { kind: "Field", name: { kind: "Name", value: "payor_external_id" } },
          { kind: "Field", name: { kind: "Name", value: "policy_number" } },
          { kind: "Field", name: { kind: "Name", value: "plan_type" } },
          { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_first_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_last_name" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_dob" } },
          { kind: "Field", name: { kind: "Name", value: "subscriber_relationship_to_patient" } },
          { kind: "Field", name: { kind: "Name", value: "is_archived" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCoverageQuery, GetCoverageQueryVariables>;
export const GetOrgPayorsDocument = {
  __meta__: { hash: "9bc4e7ca5e55f11e595e4616a8eabe107db1df3b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrgPayors" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedCoverages" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "payor_name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrgPayorsQuery, GetOrgPayorsQueryVariables>;
export const GetCoverageAuditsDocument = {
  __meta__: { hash: "ac1b120e3a3adfdad7e022126ce9984fe7d1c8f2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCoverageAudits" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "coverageId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCoverageAudits" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coverageId" },
                value: { kind: "Variable", name: { kind: "Name", value: "coverageId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "audit_id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "created_by" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCoverageAuditsQuery, GetCoverageAuditsQueryVariables>;
export const GetSymptomAssessmentDocument = {
  __meta__: { hash: "591d3f5c4ec7a4bbd7fc390b8348a921e6012882" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSymptomAssessment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSymptomAssessment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "assessedOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "results" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "statement" } },
                      { kind: "Field", name: { kind: "Name", value: "confidence" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "indicators" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "icd10Code" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "item" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaItemCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "criteria" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icd10" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "hex" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Criteria" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "criteria_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "reference_url" } },
          { kind: "Field", name: { kind: "Name", value: "citations" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSymptomAssessmentQuery, GetSymptomAssessmentQueryVariables>;
export const GetAllCriteriaFormResultsDocument = {
  __meta__: { hash: "96a003044fa5000be0ad829abed49c40ed14feef" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllCriteriaFormResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllCriteriaFormResults" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "result_id" } },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "criteria" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "publisher" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flagged_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                      { kind: "Field", name: { kind: "Name", value: "syndrome" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllCriteriaFormResultsQuery, GetAllCriteriaFormResultsQueryVariables>;
export const GetCriteriaFormResultDocument = {
  __meta__: { hash: "a6f58b70452faa64f269926d3347d91080523242" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCriteriaFormResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCriteriaFormResult" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "result_id" } },
                { kind: "Field", name: { kind: "Name", value: "passed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flagged_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "diagnoses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hex" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "criteria" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "prescriptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "performer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "employee" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "demographics" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "note" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "annotation_id" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created_by" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlagItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_codes" } },
          { kind: "Field", name: { kind: "Name", value: "applies_to" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCriteriaFormResultQuery, GetCriteriaFormResultQueryVariables>;
export const GetPaginatedCriteriaFormResultsDocument = {
  __meta__: { hash: "2ba405dcef00d94f7692cdb28d3f5de34c7f32c8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedCriteriaFormResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedCriteriaFormResults" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "result_id" } },
                      { kind: "Field", name: { kind: "Name", value: "passed" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prescriptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medication" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flagged_by" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flags" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "diagnoses" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "hex" } },
                                  { kind: "Field", name: { kind: "Name", value: "note" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "created_at" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "criteria" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "performer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "employee" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "demographics" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "syndrome" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaFormResultFlagItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaFormResultFlagItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_codes" } },
          { kind: "Field", name: { kind: "Name", value: "applies_to" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CriteriaDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CriteriaDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedCriteriaFormResultsQuery, GetPaginatedCriteriaFormResultsQueryVariables>;
export const LabObservationStatsDocument = {
  __meta__: { hash: "23aa23502e652c571f76ded465b20cf813983c16" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabObservationStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labObservationStats" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "target_type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabObservationStatsQuery, LabObservationStatsQueryVariables>;
export const GetPaginatedLabObservationsDocument = {
  __meta__: { hash: "67b05272234195251dac49c6f7712262204057b8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedLabObservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedLabObservations" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ObservationCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PatientCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "members" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "observation_id" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "target_type" } },
                            { kind: "Field", name: { kind: "Name", value: "interpretation" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "based_on" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "requisition" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "report" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "report_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "presented_form" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttachmentCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Observations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "observation_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "target_type" } },
          { kind: "Field", name: { kind: "Name", value: "interpretation" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attachments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
          { kind: "Field", name: { kind: "Name", value: "content_type" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "pages" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedLabObservationsQuery, GetPaginatedLabObservationsQueryVariables>;
export const GetDiagnosticReportDocument = {
  __meta__: { hash: "41117dedf5b86bcc8c52111efba6a51f38fade52" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDiagnosticReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDiagnosticReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "DiagnosticReportCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "presented_form" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ObservationFlagCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticReportCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticReports" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "report_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "conclusion_code" } },
          { kind: "Field", name: { kind: "Name", value: "issued" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationFlagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationFlags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "flag_id" } },
          { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDiagnosticReportQuery, GetDiagnosticReportQueryVariables>;
export const GetDiagnosticReportAttachmentDocument = {
  __meta__: { hash: "e3d2bc3adb66c03d3f23532a04f20f35ed10700b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDiagnosticReportAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDiagnosticReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "report_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "presented_form" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDiagnosticReportAttachmentQuery, GetDiagnosticReportAttachmentQueryVariables>;
export const PatientDocumentsDocument = {
  __meta__: { hash: "33c6daf675842d14dd0059fb02591e85017a0081" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PatientDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeDeleted" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDocuments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeDeleted" },
                value: { kind: "Variable", name: { kind: "Name", value: "includeDeleted" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "patientDocumentId" } },
                { kind: "Field", name: { kind: "Name", value: "patientId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "locationId" } },
                { kind: "Field", name: { kind: "Name", value: "currentUrl" } },
                { kind: "Field", name: { kind: "Name", value: "uploadedBy" } },
                { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
                { kind: "Field", name: { kind: "Name", value: "deletedBy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "versions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "patientDocumentVersionId" } },
                      { kind: "Field", name: { kind: "Name", value: "sequence" } },
                      { kind: "Field", name: { kind: "Name", value: "uploadedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "uploadedBy" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientDocumentsQuery, PatientDocumentsQueryVariables>;
export const GetEmployeeDocument = {
  __meta__: { hash: "f837d813515e749789d8eca0640e50adf6a7d662" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEmployee" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "StaffAssignmentCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "company" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrganizationsCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "StaffCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identity" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "phone" } },
                                  { kind: "Field", name: { kind: "Name", value: "username" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_role" } },
          { kind: "Field", name: { kind: "Name", value: "organization_type" } },
          { kind: "Field", name: { kind: "Name", value: "safety_precautions" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Staffs" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetPaginatedEmployeesDocument = {
  __meta__: { hash: "c74d25e7982e4e2bae370b40c632400723a58af4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedEmployees" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedEmployees" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "StaffAssignmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "company" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrganizationsCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "StaffCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "email" } },
                                        { kind: "Field", name: { kind: "Name", value: "phone" } },
                                        { kind: "Field", name: { kind: "Name", value: "username" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_role" } },
          { kind: "Field", name: { kind: "Name", value: "organization_type" } },
          { kind: "Field", name: { kind: "Name", value: "safety_precautions" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Staffs" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedEmployeesQuery, GetPaginatedEmployeesQueryVariables>;
export const EmployeesFeedDocument = {
  __meta__: { hash: "0ba6f3baee50527a3005fb733e1ff69a234f201a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EmployeesFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employeesFeed" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "StaffAssignmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "company" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrganizationsCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "StaffCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "account" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "account_id" } }],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "email" } },
                                        { kind: "Field", name: { kind: "Name", value: "phone" } },
                                        { kind: "Field", name: { kind: "Name", value: "username" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_role" } },
          { kind: "Field", name: { kind: "Name", value: "organization_type" } },
          { kind: "Field", name: { kind: "Name", value: "safety_precautions" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Staffs" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeesFeedQuery, EmployeesFeedQueryVariables>;
export const GetAllEncountersDocument = {
  __meta__: { hash: "79aa720219f89b377780c5a2c32636920b423627" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllEncounters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllEncounters" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Encounters" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "EncounterCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "diagnosis" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "condition" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CoreFragment" } }],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ConditionsCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EncounterCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Encounters" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "encounter_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "class" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "service_type" } },
          { kind: "Field", name: { kind: "Name", value: "subject_status" } },
          { kind: "Field", name: { kind: "Name", value: "planned_start_date" } },
          { kind: "Field", name: { kind: "Name", value: "planned_end_date" } },
          { kind: "Field", name: { kind: "Name", value: "diet_preference" } },
          { kind: "Field", name: { kind: "Name", value: "special_arrangement" } },
          { kind: "Field", name: { kind: "Name", value: "special_courtesy" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConditionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Conditions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "condition_id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "body_site" } },
          { kind: "Field", name: { kind: "Name", value: "verification_status" } },
          { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
          { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllEncountersQuery, GetAllEncountersQueryVariables>;
export const GetEventDocument = {
  __meta__: { hash: "9412872e1f6c09fef7a70c9544bb9c9031f6afd9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEvent" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "EventCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Events" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "event_date" } },
          { kind: "Field", name: { kind: "Name", value: "all_day_event" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEventQuery, GetEventQueryVariables>;
export const GetEventSeriesDocument = {
  __meta__: { hash: "e80b61d75b6798808fb11489f2782750ca9ed27f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEventSeries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEventSeries" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "EventSeriesCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pattern" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weekly" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternWeeklyCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "monthly" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternMonthlyCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternWeeklyCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WeeklyRecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "days" } },
          { kind: "Field", name: { kind: "Name", value: "every_day" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternMonthlyCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MonthlyRecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "day_of_month" } },
          { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
          { kind: "Field", name: { kind: "Name", value: "week_of_month" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEventSeriesQuery, GetEventSeriesQueryVariables>;
export const GetAllEventsDocument = {
  __meta__: { hash: "c340722719e6650b8c38540bdeaafff7598b5543" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllEvents" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "event_id" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllEventsQuery, GetAllEventsQueryVariables>;
export const GetQuestionnaireDocument = {
  __meta__: { hash: "9a112099a3f1d69bfe981c7699fbf0cef57de589" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetQuestionnaire" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getQuestionnaire" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "questions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer_options" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled_when" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireEnableWhenCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswerOptions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "option_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "initial_selected" } },
          { kind: "Field", name: { kind: "Name", value: "option_coding" } },
          { kind: "Field", name: { kind: "Name", value: "option_date" } },
          { kind: "Field", name: { kind: "Name", value: "option_time" } },
          { kind: "Field", name: { kind: "Name", value: "option_integer" } },
          { kind: "Field", name: { kind: "Name", value: "option_string" } },
          { kind: "Field", name: { kind: "Name", value: "option_boolean" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "option_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireEnableWhenCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireEnableWhen" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "enable_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetQuestionnaireQuery, GetQuestionnaireQueryVariables>;
export const GetAllQuestionnairesDocument = {
  __meta__: { hash: "647d7b77c7f1417e3e2f33981a1fda02cb6f5a34" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllQuestionnaires" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllQuestionnaires" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "responses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "response_id" } },
                            { kind: "Field", name: { kind: "Name", value: "authored" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllQuestionnairesQuery, GetAllQuestionnairesQueryVariables>;
export const GetQuestionnaireResponseDocument = {
  __meta__: { hash: "8da3762b2a6ce5316bbecc925849742bf8c9ac65" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetQuestionnaireResponse" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getQuestionnaireResponse" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "questionnaire" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "questions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "question" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "answer_options" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "answer_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_attachment" } },
          { kind: "Field", name: { kind: "Name", value: "answer_string" } },
          { kind: "Field", name: { kind: "Name", value: "answer_uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_option" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "option_id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswerOptions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "option_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "initial_selected" } },
          { kind: "Field", name: { kind: "Name", value: "option_coding" } },
          { kind: "Field", name: { kind: "Name", value: "option_date" } },
          { kind: "Field", name: { kind: "Name", value: "option_time" } },
          { kind: "Field", name: { kind: "Name", value: "option_integer" } },
          { kind: "Field", name: { kind: "Name", value: "option_string" } },
          { kind: "Field", name: { kind: "Name", value: "option_boolean" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "option_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetQuestionnaireResponseQuery, GetQuestionnaireResponseQueryVariables>;
export const GetAllQuestionnaireItemsDocument = {
  __meta__: { hash: "96a8bed886eb73b7d0cb15e910ff42c1c1522442" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllQuestionnaireItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllQuestionnaireItems" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "questionnaire" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabled_when" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireEnableWhenCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer_options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireEnableWhenCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireEnableWhen" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "enable_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswerOptionsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswerOptions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "option_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "initial_selected" } },
          { kind: "Field", name: { kind: "Name", value: "option_coding" } },
          { kind: "Field", name: { kind: "Name", value: "option_date" } },
          { kind: "Field", name: { kind: "Name", value: "option_time" } },
          { kind: "Field", name: { kind: "Name", value: "option_integer" } },
          { kind: "Field", name: { kind: "Name", value: "option_string" } },
          { kind: "Field", name: { kind: "Name", value: "option_boolean" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "option_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllQuestionnaireItemsQuery, GetAllQuestionnaireItemsQueryVariables>;
export const GetAllQuestionnaireResponsesDocument = {
  __meta__: { hash: "f4e88bb603763faa489439e1d04e93194afce9d9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllQuestionnaireResponses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllQuestionnaireResponses" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "question" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "answer_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_attachment" } },
          { kind: "Field", name: { kind: "Name", value: "answer_string" } },
          { kind: "Field", name: { kind: "Name", value: "answer_uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_option" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "option_id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllQuestionnaireResponsesQuery, GetAllQuestionnaireResponsesQueryVariables>;
export const GetQuestionnaireResponseStatisticsDocument = {
  __meta__: { hash: "66511fd84a7f99493d19a9b2e88ba6731a376dcd" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetQuestionnaireResponseStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllQuestionnaireResponses" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireABXStatisticsFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireABXStatisticsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "answer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "question" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "item_id" } },
                      { kind: "Field", name: { kind: "Name", value: "link_id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answer_range" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "range_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "low" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "high" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetQuestionnaireResponseStatisticsQuery, GetQuestionnaireResponseStatisticsQueryVariables>;
export const GetPaginatedQuestionnairesDocument = {
  __meta__: { hash: "24a1b557482358ad8671210e64d8eb9e8029bd3c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedQuestionnaires" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedQuestionnaires" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "responses" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "response_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "authored" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "created_at" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Questionnaires" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "publisher" } },
          { kind: "Field", name: { kind: "Name", value: "publish_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subject_type" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
          { kind: "Field", name: { kind: "Name", value: "last_review_date" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedQuestionnairesQuery, GetPaginatedQuestionnairesQueryVariables>;
export const GetPaginatedQuestionnaireResponsesDocument = {
  __meta__: { hash: "874f5e94ae4267c50066d584008f7ff8401a147b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedQuestionnaireResponses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedQuestionnaireResponses" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "question" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuestionnaireItemCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireResponseCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireResponses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "response_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "authored" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaire" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "questionnaire_number" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireAnswersCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireAnswers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "answer_id" } },
          { kind: "Field", name: { kind: "Name", value: "answer_decimal" } },
          { kind: "Field", name: { kind: "Name", value: "answer_date" } },
          { kind: "Field", name: { kind: "Name", value: "answer_time" } },
          { kind: "Field", name: { kind: "Name", value: "answer_integer" } },
          { kind: "Field", name: { kind: "Name", value: "answer_boolean" } },
          { kind: "Field", name: { kind: "Name", value: "answer_coding" } },
          { kind: "Field", name: { kind: "Name", value: "answer_attachment" } },
          { kind: "Field", name: { kind: "Name", value: "answer_string" } },
          { kind: "Field", name: { kind: "Name", value: "answer_uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_option" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "option_id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_range" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "high" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "low" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer_quantity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "system" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionnaireItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuestionnaireItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "item_id" } },
          { kind: "Field", name: { kind: "Name", value: "link_id" } },
          { kind: "Field", name: { kind: "Name", value: "item_type" } },
          { kind: "Field", name: { kind: "Name", value: "input_type" } },
          { kind: "Field", name: { kind: "Name", value: "response_label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "appearance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "column" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "xs" } },
                      { kind: "Field", name: { kind: "Name", value: "sm" } },
                      { kind: "Field", name: { kind: "Name", value: "md" } },
                      { kind: "Field", name: { kind: "Name", value: "lg" } },
                      { kind: "Field", name: { kind: "Name", value: "xl" } },
                      { kind: "Field", name: { kind: "Name", value: "xxl" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "answer_constraint" } },
          { kind: "Field", name: { kind: "Name", value: "disabled_display" } },
          { kind: "Field", name: { kind: "Name", value: "enable_behavior" } },
          { kind: "Field", name: { kind: "Name", value: "max_length" } },
          { kind: "Field", name: { kind: "Name", value: "ready_only" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "repeats" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "first_login" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "demographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedQuestionnaireResponsesQuery, GetPaginatedQuestionnaireResponsesQueryVariables>;
export const ExploreDirectoryFilesDocument = {
  __meta__: { hash: "442bb78ac59822dd2b9299e15dc6f40f877cd456" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ExploreDirectoryFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recursive" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "folder" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exploreDirectoryFiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recursive" },
                value: { kind: "Variable", name: { kind: "Name", value: "recursive" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "folder" }, value: { kind: "Variable", name: { kind: "Name", value: "folder" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paths" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "FileBucketFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "files" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "FileCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileMetaDataFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileBucketFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Bucket" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "prefix" } },
                { kind: "Field", name: { kind: "Name", value: "lastModified" } },
                { kind: "Field", name: { kind: "Name", value: "etag" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "etag" } },
          { kind: "Field", name: { kind: "Name", value: "lastModified" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileMetaDataFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "BucketMetaData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "Fileextension" } },
          { kind: "Field", name: { kind: "Name", value: "Filename" } },
          { kind: "Field", name: { kind: "Name", value: "Folder" } },
          { kind: "Field", name: { kind: "Name", value: "Isstarred" } },
          { kind: "Field", name: { kind: "Name", value: "Istrashed" } },
          { kind: "Field", name: { kind: "Name", value: "Label" } },
          { kind: "Field", name: { kind: "Name", value: "Lastaccessed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExploreDirectoryFilesQuery, ExploreDirectoryFilesQueryVariables>;
export const GeneResistanceBreakdownDocument = {
  __meta__: { hash: "328d96ec52d674354c1b02a3933f786f77b391be" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GeneResistanceBreakdown" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getResistantGene" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AgentResistanceFragment" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AgentAlternativesFragment" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenotypeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
          { kind: "Field", name: { kind: "Name", value: "gene" } },
          { kind: "Field", name: { kind: "Name", value: "encoding" } },
          { kind: "Field", name: { kind: "Name", value: "mechanism" } },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Agents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentClassificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AgentClassifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "classification_number" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentResistanceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "GenotypeCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "resistant_to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AgentCoreFragment" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "agent_class_resistance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "class_resistance_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AgentClassificationCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exceptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "agent_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgentAlternativesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Genotypes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "agent_class_alternatives" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "classification_number" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "agent_alternatives" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gene" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
                      { kind: "Field", name: { kind: "Name", value: "gene" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AgentCoreFragment" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "suitability" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                { kind: "Field", name: { kind: "Name", value: "nus" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GeneResistanceBreakdownQuery, GeneResistanceBreakdownQueryVariables>;
export const GetOnboardingInviteDocument = {
  __meta__: { hash: "79687c5410e9a6365be899c8ea24c06fbd720fb6" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOnboardingInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "inviteId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOnboardingInvite" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "inviteId" }, value: { kind: "Variable", name: { kind: "Name", value: "inviteId" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "invite_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "expiration_date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "dob" } },
                      { kind: "Field", name: { kind: "Name", value: "first_name" } },
                      { kind: "Field", name: { kind: "Name", value: "last_name" } },
                      { kind: "Field", name: { kind: "Name", value: "sex" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "from" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "address_id" } },
                            { kind: "Field", name: { kind: "Name", value: "use" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "postal_code" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lines" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "line_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "line" } },
                                  { kind: "Field", name: { kind: "Name", value: "order" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOnboardingInviteQuery, GetOnboardingInviteQueryVariables>;
export const FindLocationDocument = {
  __meta__: { hash: "d38a3e3f55da7436a555056ac42e47e745358032" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FindLocation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLocation" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindLocationQuery, FindLocationQueryVariables>;
export const DownloadCsvLocationPatientsReportDocument = {
  __meta__: { hash: "51ff2447a90be81a2677cc6bdd0b2565c3e16e97" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadCSVLocationPatientsReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadCSVLocationPatientsReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadCsvLocationPatientsReportQuery, DownloadCsvLocationPatientsReportQueryVariables>;
export const GetPaginatedLocationPatientsDocument = {
  __meta__: { hash: "ebf752d944316a52039c4f4201938a02e561a9a0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedLocationPatients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedLocationPatients" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "addresses" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "address_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "room" } },
                                              { kind: "Field", name: { kind: "Name", value: "city" } },
                                              { kind: "Field", name: { kind: "Name", value: "state" } },
                                              { kind: "Field", name: { kind: "Name", value: "postal_code" } },
                                              { kind: "Field", name: { kind: "Name", value: "nickname" } },
                                              { kind: "Field", name: { kind: "Name", value: "type" } },
                                              { kind: "Field", name: { kind: "Name", value: "use" } },
                                              { kind: "Field", name: { kind: "Name", value: "display" } },
                                              { kind: "Field", name: { kind: "Name", value: "district" } },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "lines" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "line_id" } },
                                                    { kind: "Field", name: { kind: "Name", value: "line" } },
                                                    { kind: "Field", name: { kind: "Name", value: "order" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedLocationPatientsQuery, GetPaginatedLocationPatientsQueryVariables>;
export const LocationPatientsFeedDocument = {
  __meta__: { hash: "ab3abc31bb0a9824d6ef02ce3acbdfa79f2e7161" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LocationPatientsFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "locationPatientsFeed" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } }],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationPatientsFeedQuery, LocationPatientsFeedQueryVariables>;
export const GetAllLocationPatientsDocument = {
  __meta__: { hash: "6c885bf68763d48340c72b5a76784a3fec41f584" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllLocationPatients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllLocationPatients" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllLocationPatientsQuery, GetAllLocationPatientsQueryVariables>;
export const GetLocationPatientDocument = {
  __meta__: { hash: "5f50c30cbeaa352680677290f131f8debd8ac914" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLocationPatient" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identity" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medications" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                            { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                            { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "adherence" } },
                            { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
                            { kind: "Field", name: { kind: "Name", value: "administration_method" } },
                            { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
                            { kind: "Field", name: { kind: "Name", value: "timing_display" } },
                            { kind: "Field", name: { kind: "Name", value: "effective" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "effective_period" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "period_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "start" } },
                                  { kind: "Field", name: { kind: "Name", value: "end" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reason" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "category" } },
                                  { kind: "Field", name: { kind: "Name", value: "body_site" } },
                                  { kind: "Field", name: { kind: "Name", value: "verification_status" } },
                                  { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
                                  { kind: "Field", name: { kind: "Name", value: "severity" } },
                                  { kind: "Field", name: { kind: "Name", value: "note" } },
                                  { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
                                  { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
                                  { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
                                  { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
                                  { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medication" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "code" } },
                                  { kind: "Field", name: { kind: "Name", value: "dose_form" } },
                                  { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "detected_issues" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "issue_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                        { kind: "Field", name: { kind: "Name", value: "category" } },
                                        { kind: "Field", name: { kind: "Name", value: "severity" } },
                                        { kind: "Field", name: { kind: "Name", value: "detail" } },
                                        { kind: "Field", name: { kind: "Name", value: "identified_at" } },
                                        { kind: "Field", name: { kind: "Name", value: "mitigation_action" } },
                                        { kind: "Field", name: { kind: "Name", value: "mitigation_date" } },
                                        { kind: "Field", name: { kind: "Name", value: "reference_uri" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "total_volume" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "ratio_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "numerator" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "unit" } },
                                              { kind: "Field", name: { kind: "Name", value: "code" } },
                                              { kind: "Field", name: { kind: "Name", value: "system" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "denominator" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "unit" } },
                                              { kind: "Field", name: { kind: "Name", value: "code" } },
                                              { kind: "Field", name: { kind: "Name", value: "system" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "last_contact" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLocationPatientQuery, GetLocationPatientQueryVariables>;
export const GetLocationAddressesDocument = {
  __meta__: { hash: "2ec7b9c46f265f19ef71f2de3bdad9680125569f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationAddresses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLocationAddresses" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AddressCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "address_id" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "place_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLocationAddressesQuery, GetLocationAddressesQueryVariables>;
export const FindFdaMedicationsDocument = {
  __meta__: { hash: "2df2dd9fde1c8c03ecef99891f2a10ea67f8e6e6" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FindFDAMedications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "findFDAMedications" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DrugProducts" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "product_id" } },
                      { kind: "Field", name: { kind: "Name", value: "drug_name" } },
                      { kind: "Field", name: { kind: "Name", value: "active_ingredient" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resistant_genotypes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
                            { kind: "Field", name: { kind: "Name", value: "gene" } },
                            { kind: "Field", name: { kind: "Name", value: "encoding" } },
                            { kind: "Field", name: { kind: "Name", value: "mechanism" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindFdaMedicationsQuery, FindFdaMedicationsQueryVariables>;
export const FindFdaMedicationsWithDetailsDocument = {
  __meta__: { hash: "3e987d9b320958cebb157c90c57e7db45ebb2965" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FindFDAMedicationsWithDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "strictSearch" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "findFDAMedicationsWithDetails" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "strictSearch" },
                value: { kind: "Variable", name: { kind: "Name", value: "strictSearch" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DrugProducts" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "drug_name" } },
                      { kind: "Field", name: { kind: "Name", value: "form" } },
                      { kind: "Field", name: { kind: "Name", value: "active_ingredient" } },
                      { kind: "Field", name: { kind: "Name", value: "strength" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindFdaMedicationsWithDetailsQuery, FindFdaMedicationsWithDetailsQueryVariables>;
export const GetAllDetailedMedicationUsagesDocument = {
  __meta__: { hash: "2d9e101a89329d0d9cdf753c8cfd4ac2517ae5f3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllDetailedMedicationUsages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllDetailedMedicationUsages" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "patient_id" } }] },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "body_site" } },
                            { kind: "Field", name: { kind: "Name", value: "verification_status" } },
                            { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
                            { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
                            { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
                            { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
                            { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total_volume" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RatioCoreFragment" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "detected_issues" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "issue_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "category" } },
                                  { kind: "Field", name: { kind: "Name", value: "severity" } },
                                  { kind: "Field", name: { kind: "Name", value: "detail" } },
                                  { kind: "Field", name: { kind: "Name", value: "identified_at" } },
                                  { kind: "Field", name: { kind: "Name", value: "mitigation_action" } },
                                  { kind: "Field", name: { kind: "Name", value: "mitigation_date" } },
                                  { kind: "Field", name: { kind: "Name", value: "reference_uri" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RatioCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ratio" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "ratio_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numerator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "denominator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllDetailedMedicationUsagesQuery, GetAllDetailedMedicationUsagesQueryVariables>;
export const GetDetailedMedicationUsageDocument = {
  __meta__: { hash: "63f061813942b2015cf352c83acfccb792618b02" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDetailedMedicationUsage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDetailedMedicationUsage" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prescriber" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "body_site" } },
                            { kind: "Field", name: { kind: "Name", value: "verification_status" } },
                            { kind: "Field", name: { kind: "Name", value: "clinical_status" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
                            { kind: "Field", name: { kind: "Name", value: "abatement_date_string" } },
                            { kind: "Field", name: { kind: "Name", value: "abatement_date_time" } },
                            { kind: "Field", name: { kind: "Name", value: "onset_date_string" } },
                            { kind: "Field", name: { kind: "Name", value: "onset_date_time" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "classification" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total_volume" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RatioCoreFragment" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "detected_issues" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "issue_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "category" } },
                                  { kind: "Field", name: { kind: "Name", value: "severity" } },
                                  { kind: "Field", name: { kind: "Name", value: "detail" } },
                                  { kind: "Field", name: { kind: "Name", value: "identified_at" } },
                                  { kind: "Field", name: { kind: "Name", value: "mitigation_action" } },
                                  { kind: "Field", name: { kind: "Name", value: "mitigation_date" } },
                                  { kind: "Field", name: { kind: "Name", value: "reference_uri" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuantityCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quantity" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period_id" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RatioCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ratio" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "ratio_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "numerator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "denominator" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "QuantityCoreFragment" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDetailedMedicationUsageQuery, GetDetailedMedicationUsageQueryVariables>;
export const GetAllLocationPrescriptionsDocument = {
  __meta__: { hash: "d8ab00f55c3152b5a306509fa19a5df79f4ff33b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllLocationPrescriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllLocationPrescriptions" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "medication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                      { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ndc_information" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "product_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resistant_genotypes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "gene" } },
                                  { kind: "Field", name: { kind: "Name", value: "genotype_id" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "derived_from" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "result_id" } },
                      { kind: "Field", name: { kind: "Name", value: "passed" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllLocationPrescriptionsQuery, GetAllLocationPrescriptionsQueryVariables>;
export const GetPaginatedPrescriptionsDocument = {
  __meta__: { hash: "81cba3d49b699fe2cf71a2ea1d548233677825dc" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedPrescriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedPrescriptions" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" } },
                      { kind: "Field", name: { kind: "Name", value: "expired" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragmentAlt" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prescriber" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "taxonomies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TaxonomiesCoreFragment" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "condition_id" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "recorded_date" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "classification" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaxonomiesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Taxonomies" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "taxonomy_id" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "primary" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "group" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedPrescriptionsQuery, GetPaginatedPrescriptionsQueryVariables>;
export const PaginatedPrescriptionsListDocument = {
  __meta__: { hash: "20d84da11efa6c0566df90cd02c09368687da71d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PaginatedPrescriptionsList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "paginatedPrescriptionList" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "days_left" } },
                      { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
                      { kind: "Field", name: { kind: "Name", value: "timing_display" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragmentAlt" } }],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                      { kind: "Field", name: { kind: "Name", value: "is_archived" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaginatedPrescriptionsListQuery, PaginatedPrescriptionsListQueryVariables>;
export const PatientMedicationsListDocument = {
  __meta__: { hash: "2ead0e9420933fa860e4549b5ea72db3a0bd4eb4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PatientMedicationsList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "paginatedPrescriptionList" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationCoreFragmentAlt" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total_volume" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "ratio_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "numerator" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "quantity_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                        { kind: "Field", name: { kind: "Name", value: "unit" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "detected_issues" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "issue_id" } },
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "DetectedIssueCoreFragment" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Medications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "medication_id" } },
          { kind: "Field", name: { kind: "Name", value: "brand_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "dose_form" } },
          { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DetectedIssueCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DetectedIssues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          { kind: "Field", name: { kind: "Name", value: "detail" } },
          { kind: "Field", name: { kind: "Name", value: "identified_at" } },
          { kind: "Field", name: { kind: "Name", value: "mitigation_action" } },
          { kind: "Field", name: { kind: "Name", value: "mitigation_date" } },
          { kind: "Field", name: { kind: "Name", value: "reference_uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientMedicationsListQuery, PatientMedicationsListQueryVariables>;
export const GetLocationPrescriptionCountsDocument = {
  __meta__: { hash: "0eb5033086a8d1694724ba13173d202c10a0da29" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationPrescriptionCounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllLocationPrescriptions" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "derived_from" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "result_id" } },
                      { kind: "Field", name: { kind: "Name", value: "passed" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLocationPrescriptionCountsQuery, GetLocationPrescriptionCountsQueryVariables>;
export const GetAllUserMessagesDocument = {
  __meta__: { hash: "7be35345de51df705c9504b6a751c335de5675aa" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllUserMessages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllUserMessages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Messages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "message_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "is_trashed" } },
          { kind: "Field", name: { kind: "Name", value: "is_starred" } },
          { kind: "Field", name: { kind: "Name", value: "attachment" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllUserMessagesQuery, GetAllUserMessagesQueryVariables>;
export const GetUnreadUserNotificationsDocument = {
  __meta__: { hash: "e52a4feb02ce7588f1005964cea85c4e50981a50" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUnreadUserNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isRead" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUnreadUserNotifications" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "isRead" }, value: { kind: "Variable", name: { kind: "Name", value: "isRead" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUnreadUserNotificationsQuery, GetUnreadUserNotificationsQueryVariables>;
export const GetUserNotificationsDocument = {
  __meta__: { hash: "b0b28c9255e4cb2e2e9031b2e85f4db0b763e6a5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserNotifications" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const GetOrderBillingDocument = {
  __meta__: { hash: "1eca82b00328d9169f57f6646e91749412611083" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrderBilling" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "patient_id" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_coverage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "coverage_id" } },
                      { kind: "Field", name: { kind: "Name", value: "payor_name" } },
                      { kind: "Field", name: { kind: "Name", value: "policy_number" } },
                      { kind: "Field", name: { kind: "Name", value: "plan_type" } },
                      { kind: "Field", name: { kind: "Name", value: "coverage_order" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderBillingQuery, GetOrderBillingQueryVariables>;
export const GetServiceRequestDocument = {
  __meta__: { hash: "803b6faa79bc0129d5c845a614d761be494b90b0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetServiceRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getServiceRequest" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DiagnosticReportCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticReportCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticReports" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "report_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "conclusion_code" } },
          { kind: "Field", name: { kind: "Name", value: "issued" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetServiceRequestQuery, GetServiceRequestQueryVariables>;
export const GetAllServiceRequestsDocument = {
  __meta__: { hash: "a0664d8e4139b60b2e1ad963dbdee9d69aa19c82" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllServiceRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllServiceRequests" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "performer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                            { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllServiceRequestsQuery, GetAllServiceRequestsQueryVariables>;
export const GetPaginatedServiceRequestsDocument = {
  __meta__: { hash: "505de74c63220610f78f0e6660d6b75d658faca5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedServiceRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedServiceRequests" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requisition" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "performer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                  { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "location_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reports" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "report_id" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "presented_form" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flags" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
                                  { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
                                  { kind: "Field", name: { kind: "Name", value: "display" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedServiceRequestsQuery, GetPaginatedServiceRequestsQueryVariables>;
export const GetOrderDocument = {
  __meta__: { hash: "6110bef8cc1704c168b663fee8e7b987c0a6aaa9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "series" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "EventSeriesCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pattern" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrderSpecimenDocument = {
  __meta__: { hash: "7ba0302aeda9f14e78c7fae5b10bcff0954fa86d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrderSpecimen" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderSpecimenQuery, GetOrderSpecimenQueryVariables>;
export const OrderDetailsDocument = {
  __meta__: { hash: "74c695d20eb66f95b83c2cc502c442b744facb3a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CodeFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactInformationFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PatientCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "actor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "OrderAgentActorCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "series" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "EventSeriesCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pattern" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "report_id" } },
                      { kind: "Field", name: { kind: "Name", value: "request_id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presented_form" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttachmentCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttachmentCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                      { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
                      { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
                      { kind: "Field", name: { kind: "Name", value: "display" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetailsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_detail_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "purpose" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CodeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInformationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "ContactDetailsCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "telecom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "agent_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderAgentActorCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderAgentActor" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "organization_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "location_id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CareTeams" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "care_team_id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attachments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
          { kind: "Field", name: { kind: "Name", value: "content_type" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "pages" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDetailsQuery, OrderDetailsQueryVariables>;
export const OrderRequisitionDocumentDocument = {
  __meta__: { hash: "d876f001e763225355c7dbb15fe1558f7c5a02d0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderRequisitionDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrderDetails" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "content_type" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                            { kind: "Field", name: { kind: "Name", value: "data" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderRequisitionDocumentQuery, OrderRequisitionDocumentQueryVariables>;
export const OrderRequisitionDataDocument = {
  __meta__: { hash: "41cd3f081f9793f5b63e430a4b98f8a73bfcc44d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderRequisitionData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrderDetails" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requests" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "request_id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PatientCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "dob" } },
                                  { kind: "Field", name: { kind: "Name", value: "sex" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requisition" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "reference_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_id" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "practitioner" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                            { kind: "Field", name: { kind: "Name", value: "npi" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signature" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "icd11_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "hex" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Patients" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "patient_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "user_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderRequisitionDataQuery, OrderRequisitionDataQueryVariables>;
export const OrderTimelineDocument = {
  __meta__: { hash: "d306157e256dfa530ab60f10f1c75be7f476edd8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderTimeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderTimelineQuery, OrderTimelineQueryVariables>;
export const OrderDiagnosisCodesDocument = {
  __meta__: { hash: "b205eed9275b6ac34f97ae31ecffeaf8a223ac1a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderDiagnosisCodes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "patient_id" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "line_items" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "line_item_id" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CodeFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CodeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDiagnosisCodesQuery, OrderDiagnosisCodesQueryVariables>;
export const GetPaginatedOrderItemsDocument = {
  __meta__: { hash: "beadf66cae2dc7c5486aa9a3467a52dc7ad75375" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedOrderItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedOrderItems" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "OrderLineItemCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "request" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "service" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "service_id" } }] },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "location_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                  { kind: "Field", name: { kind: "Name", value: "phone" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderLineItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderLineItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "net_total" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedOrderItemsQuery, GetPaginatedOrderItemsQueryVariables>;
export const OrderNotesFeedDocument = {
  __meta__: { hash: "dd921612e169767c73319a2f0f4cda7972a669fa" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderNotesFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedOrderNotes" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "annotation_id" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "author" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderNotesFeedQuery, OrderNotesFeedQueryVariables>;
export const GetCompletedPatientOrdersDocument = {
  __meta__: { hash: "72b389a462506c4e7aed89764cc2038d58b443aa" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompletedPatientOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedOrders" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requests" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "request_id" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reports" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "report_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "code" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "result" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "observation_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "code" } },
                                        { kind: "Field", name: { kind: "Name", value: "interpretation" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flags" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
                                        { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
                                        { kind: "Field", name: { kind: "Name", value: "display" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "observation" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "observation_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "interpretation" } },
                                              { kind: "Field", name: { kind: "Name", value: "code" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompletedPatientOrdersQuery, GetCompletedPatientOrdersQueryVariables>;
export const GetPaginatedOrdersDocument = {
  __meta__: { hash: "f1ac310236d797609c3fe7075ead62bb7de7d38b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedOrders" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "addresses" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "address_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "room" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requisition" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "DocumentReferenceCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                  { kind: "Field", name: { kind: "Name", value: "title" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "flag_id" } },
                            { kind: "Field", name: { kind: "Name", value: "hl7_code" } },
                            { kind: "Field", name: { kind: "Name", value: "alert_priority" } },
                            { kind: "Field", name: { kind: "Name", value: "display" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requests" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "request_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reports" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "report_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "code" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "presented_form" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "url" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DocumentReferences" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "content_type" } },
          { kind: "Field", name: { kind: "Name", value: "document_status" } },
          { kind: "Field", name: { kind: "Name", value: "security_tag" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedOrdersQuery, GetPaginatedOrdersQueryVariables>;
export const OrderStatisticsDocument = {
  __meta__: { hash: "e45faaada544fcc061c9eb3907d030840d8a6cd3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "parameters" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OrderStatisticsInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderStatistics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "parameters" },
                value: { kind: "Variable", name: { kind: "Name", value: "parameters" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "field" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stats" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderStatisticsQuery, OrderStatisticsQueryVariables>;
export const GetOrderSignatureDocument = {
  __meta__: { hash: "fabce7b621d1cb61d4bec528474ca41456d2548c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrderSignature" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrderSignature" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order_id" } },
                { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "practitioner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      { kind: "Field", name: { kind: "Name", value: "npi" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                      { kind: "Field", name: { kind: "Name", value: "signature_format" } },
                      { kind: "Field", name: { kind: "Name", value: "signed_by" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderSignatureQuery, GetOrderSignatureQueryVariables>;
export const DownloadCsvOrdersReportDocument = {
  __meta__: { hash: "930feaa0d32e2e0981adab4eb66ee85b05a5a5d9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadCSVOrdersReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadCSVOrdersReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadCsvOrdersReportQuery, DownloadCsvOrdersReportQueryVariables>;
export const RecurringOrdersDocument = {
  __meta__: { hash: "a9d1d8eb6df4696c828fc685bd67c71e7631b248" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RecurringOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedRecurringOrders" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_id" } },
                      { kind: "Field", name: { kind: "Name", value: "series_id" } },
                      { kind: "Field", name: { kind: "Name", value: "event_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "subject_name" } },
                      { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
                      { kind: "Field", name: { kind: "Name", value: "next_scheduled_date" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "recurs" } },
                      { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                        { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                        { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                        { kind: "Field", name: { kind: "Name", value: "dob" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "series_id" } },
                            { kind: "Field", name: { kind: "Name", value: "start_time" } },
                            { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pattern" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "text" } },
                                  { kind: "Field", name: { kind: "Name", value: "start_date" } },
                                  { kind: "Field", name: { kind: "Name", value: "end_date" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecurringOrdersQuery, RecurringOrdersQueryVariables>;
export const GetRecentOrdersDocument = {
  __meta__: { hash: "5cfcd3001682d241adc91cb6a508644c91b388e6" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecentOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllOrders" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order_id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
                { kind: "Field", name: { kind: "Name", value: "subject_name" } },
                { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>;
export const GetOrderLineItemDocument = {
  __meta__: { hash: "52c87be4eb8a6dc6f29adaf77b50426fbe21d362" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrderLineItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrderLineItem" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderLineItemCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order_id" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "request" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderLineItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OrderLineItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "net_total" } },
          { kind: "Field", name: { kind: "Name", value: "tax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderLineItemQuery, GetOrderLineItemQueryVariables>;
export const GetOrderRenewalSourceDocument = {
  __meta__: { hash: "0a9ff3602bd15dabf0a7690bcf4e371f9cd95fc9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrderRenewalSource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OrderCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "patient_id" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosis_codes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ICD10CodeFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "line_items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "line_item_id" } },
                      { kind: "Field", name: { kind: "Name", value: "store_id" } },
                      { kind: "Field", name: { kind: "Name", value: "pricebook_entry_id" } },
                      { kind: "Field", name: { kind: "Name", value: "type_code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "request" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceRequestCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "service" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "service_id" } }] },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "location_id" } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "order_id" } },
                      { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "practitioner" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                            { kind: "Field", name: { kind: "Name", value: "npi" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signature" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "signature_id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "series" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "EventSeriesCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pattern" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "weekly" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternWeeklyCoreFragment" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "monthly" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecurrencePatternMonthlyCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Orders" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "order_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "recurs" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "event_id" } },
          { kind: "Field", name: { kind: "Name", value: "is_series_source" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_date" } },
          { kind: "Field", name: { kind: "Name", value: "fulfilled_at" } },
          { kind: "Field", name: { kind: "Name", value: "requested_collection_date" } },
          { kind: "Field", name: { kind: "Name", value: "is_reviewed" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ICD10CodeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ICD10" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceRequestCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceRequests" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "request_id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "intent" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "occurrence" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventSeriesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "EventSeries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "series_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_time" } },
          { kind: "Field", name: { kind: "Name", value: "end_time" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "start_date" } },
          { kind: "Field", name: { kind: "Name", value: "end_date" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternWeeklyCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WeeklyRecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "days" } },
          { kind: "Field", name: { kind: "Name", value: "every_day" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecurrencePatternMonthlyCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MonthlyRecurrencePatterns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "pattern_id" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "day_of_month" } },
          { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
          { kind: "Field", name: { kind: "Name", value: "week_of_month" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderRenewalSourceQuery, GetOrderRenewalSourceQueryVariables>;
export const GetOrganizationDocument = {
  __meta__: { hash: "7b74ae1b688d07b321d7989b353a368c3db00eb1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOneOrganization" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organizations" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "owner" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetPractitionerLocationPrescriptionsDocument = {
  __meta__: { hash: "bc0c817399f8ea3cf9aa77880f39a8a8706795b8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPractitionerLocationPrescriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPractitioner" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contextual_affiliation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prescriptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medication" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "dose_form" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                            { kind: "Field", name: { kind: "Name", value: "expired" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPractitionerLocationPrescriptionsQuery, GetPractitionerLocationPrescriptionsQueryVariables>;
export const GetPractitionerDocument = {
  __meta__: { hash: "12b52b5cfe4f6d571369c4beca06e077b6d7091e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPractitioner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPractitioner" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "qualifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerQualificationCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taxonomies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TaxonomiesCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "account_activated" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contextual_affiliation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "affiliation_id" } },
                      { kind: "Field", name: { kind: "Name", value: "location_id" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee_assignment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerQualificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerQualifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "qualification_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "credential" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
          { kind: "Field", name: { kind: "Name", value: "is_verified" } },
          { kind: "Field", name: { kind: "Name", value: "verified_on" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaxonomiesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Taxonomies" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "taxonomy_id" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "primary" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "group" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPractitionerQuery, GetPractitionerQueryVariables>;
export const GetPractitionerDemographicsDocument = {
  __meta__: { hash: "e6b1b32ac042164cad9babeb408893dba1564958" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPractitionerDemographics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPractitioner" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPractitionerDemographicsQuery, GetPractitionerDemographicsQueryVariables>;
export const GetPaginatedPractitionersDocument = {
  __meta__: { hash: "dc8538ecdae363918a2d857549b323a813111b28" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedPractitioners" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedPractitioners" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contacts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualifications" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerQualificationCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contextual_affiliation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "affiliation_id" } },
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            { kind: "Field", name: { kind: "Name", value: "role" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "employee_assignment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "title" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerQualificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerQualifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "qualification_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "credential" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
          { kind: "Field", name: { kind: "Name", value: "is_verified" } },
          { kind: "Field", name: { kind: "Name", value: "verified_on" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedPractitionersQuery, GetPaginatedPractitionersQueryVariables>;
export const DownloadCsvPractitionersReportDocument = {
  __meta__: { hash: "cf04e151c4a1429e873d35d80d61e277b39b567c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadCSVPractitionersReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadCSVPractitionersReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadCsvPractitionersReportQuery, DownloadCsvPractitionersReportQueryVariables>;
export const GetPaginatedEmployeeAssignmentsDocument = {
  __meta__: { hash: "2e7027292f6154c6a6ca2a0ec61de05e95fe1951" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedEmployeeAssignments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedStaffAssignments" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "account" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "account_id" } }],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" } }],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CynergyAccountCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CynergyUsers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "validated" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedEmployeeAssignmentsQuery, GetPaginatedEmployeeAssignmentsQueryVariables>;
export const NpiLookupDocument = {
  __meta__: { hash: "f56df159444a8e6a1736f93ab8ca42b33aeebbde" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NpiLookup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NpiRegistrySearchTerm" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "npiLookup" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "search" }, value: { kind: "Variable", name: { kind: "Name", value: "search" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "npi" } },
                { kind: "Field", name: { kind: "Name", value: "registration_date" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "first_name" } },
                      { kind: "Field", name: { kind: "Name", value: "last_name" } },
                      { kind: "Field", name: { kind: "Name", value: "credential" } },
                      { kind: "Field", name: { kind: "Name", value: "sole_proprietor" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "prefix" } },
                      { kind: "Field", name: { kind: "Name", value: "suffix" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NpiLookupQuery, NpiLookupQueryVariables>;
export const NpiExistsDocument = {
  __meta__: { hash: "edd7ef73759de13b2b64ce1b06fabf11180794ca" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NpiExists" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "NpiRegistrySearchTerm" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "npiLookup" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "search" }, value: { kind: "Variable", name: { kind: "Name", value: "search" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "npi" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taxonomies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "primary" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "demographics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "first_name" } },
                      { kind: "Field", name: { kind: "Name", value: "last_name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NpiExistsQuery, NpiExistsQueryVariables>;
export const PractitionersFeedDocument = {
  __meta__: { hash: "a8dca1f88ca099923326f338a7b85d6333f155ff" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PractitionersFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "practitionersFeed" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contacts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ContactPointCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualifications" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerQualificationCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Practitioners" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "registration_authority_id" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "affiliation_date" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactPointCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContactPoints" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "contact_point_id" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "rank" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerQualificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerQualifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "qualification_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", name: { kind: "Name", value: "credential" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "license" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
          { kind: "Field", name: { kind: "Name", value: "is_verified" } },
          { kind: "Field", name: { kind: "Name", value: "verified_on" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PractitionersFeedQuery, PractitionersFeedQueryVariables>;
export const GetPaginatedPractitionerPrescriptionsDocument = {
  __meta__: { hash: "11f2d1e783e8e640aeb16c0fb4cc224b4f7b5f81" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedPractitionerPrescriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedPractitioners" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contextual_affiliation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "prescriptions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "medication" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                        { kind: "Field", name: { kind: "Name", value: "medication_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "brand_name" } },
                                        { kind: "Field", name: { kind: "Name", value: "dose_form" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "usage_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "expired" } },
                                  { kind: "Field", name: { kind: "Name", value: "notes" } },
                                  { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PeriodCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Periods" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "period_id" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MedicationUsageCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MedicationUsages" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "usage_id" } },
          { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
          { kind: "Field", alias: { kind: "Name", value: "usage_status" }, name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "adherence" } },
          { kind: "Field", name: { kind: "Name", value: "date_asserted" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dosage_instruction" } },
          { kind: "Field", name: { kind: "Name", value: "administration_method" } },
          { kind: "Field", name: { kind: "Name", value: "administration_timing" } },
          { kind: "Field", name: { kind: "Name", value: "timing_display" } },
          { kind: "Field", name: { kind: "Name", value: "effective" } },
          { kind: "Field", name: { kind: "Name", value: "days_left" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "effective_period" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PeriodCoreFragment" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedPractitionerPrescriptionsQuery, GetPaginatedPractitionerPrescriptionsQueryVariables>;
export const GetPractitionerSignatureDocument = {
  __meta__: { hash: "1eed74682e080dd655871cafa48dc921f3f7e41d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPractitionerSignature" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPractitionerSignature" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerSignatureCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "who" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "practitioner_id" } },
                      { kind: "Field", name: { kind: "Name", value: "npi" } },
                      { kind: "Field", name: { kind: "Name", value: "prefix" } },
                      { kind: "Field", name: { kind: "Name", value: "suffix" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "demographics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            { kind: "Field", name: { kind: "Name", value: "full_name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerSignatureCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PractitionerSignatures" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "signature_id" } },
          { kind: "Field", name: { kind: "Name", value: "signature_format" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "when" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPractitionerSignatureQuery, GetPractitionerSignatureQueryVariables>;
export const GetUserProductBundleDocument = {
  __meta__: { hash: "a292d630194d67b3344cf6267b56dd60e61ef5c3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserProductBundle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundleId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserProductBundle" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "bundleId" }, value: { kind: "Variable", name: { kind: "Name", value: "bundleId" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "pricebook_entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "store_id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
          { kind: "Field", name: { kind: "Name", value: "account_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "is_shared" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price_entry" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PriceBookEntryCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "store" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "store_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "location_id" } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserProductBundleQuery, GetUserProductBundleQueryVariables>;
export const GetAllUserProductBundlesDocument = {
  __meta__: { hash: "32b9bb0eea501923499ea851c449f40006e265a1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllUserProductBundles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "scope" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "RecordAccessScope" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllUserProductBundles" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "scope" }, value: { kind: "Variable", name: { kind: "Name", value: "scope" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
          { kind: "Field", name: { kind: "Name", value: "account_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "is_shared" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllUserProductBundlesQuery, GetAllUserProductBundlesQueryVariables>;
export const GetPaginatedUserProductBundlesDocument = {
  __meta__: { hash: "bbedaecd4ff17d9ef8694b1af6beffa08f2b6b55" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedUserProductBundles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "scope" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "RecordAccessScope" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedUserProductBundles" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "scope" }, value: { kind: "Variable", name: { kind: "Name", value: "scope" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "pricebook_entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "store_id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
          { kind: "Field", name: { kind: "Name", value: "account_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "is_shared" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price_entry" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PriceBookEntryCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "store" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "store_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "location_id" } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedUserProductBundlesQuery, GetPaginatedUserProductBundlesQueryVariables>;
export const UserProductBundlesFeedDocument = {
  __meta__: { hash: "1ff600ad7ac078745e9673bf37ddff2dab0513a2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserProductBundlesFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "scope" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "RecordAccessScope" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userProductBundlesFeed" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "scope" }, value: { kind: "Variable", name: { kind: "Name", value: "scope" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_item_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "pricebook_entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "store_id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
          { kind: "Field", name: { kind: "Name", value: "account_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "is_shared" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProductBundleItemDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserProductBundleItems" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "UserProductBundleItemCoreFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeCoreFragment" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "price_entry" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PriceBookEntryCoreFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "store" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "store_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "location_id" } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserProductBundlesFeedQuery, UserProductBundlesFeedQueryVariables>;
export const GetUserProductBundleSharesDocument = {
  __meta__: { hash: "e8d1e3148f95233331dcd26a74fb048068458ee3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserProductBundleShares" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundleId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserProductBundleShares" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "bundleId" }, value: { kind: "Variable", name: { kind: "Name", value: "bundleId" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bundle_id" } },
                { kind: "Field", name: { kind: "Name", value: "share_id" } },
                { kind: "Field", name: { kind: "Name", value: "account_id" } },
                { kind: "Field", name: { kind: "Name", value: "group_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "group" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "group_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "account_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserProductBundleSharesQuery, GetUserProductBundleSharesQueryVariables>;
export const GetProductDocument = {
  __meta__: { hash: "1cefde6a566629c74cdbc6b0ad00d99eb2c44463" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getProduct" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      { kind: "Field", name: { kind: "Name", value: "height" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductQuery, GetProductQueryVariables>;
export const GetAllProductsDocument = {
  __meta__: { hash: "ad2c5b53ff5cbd7467e16dcc5d80b3bb3a9596f7" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllProducts" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const GetPaginatedProductsDocument = {
  __meta__: { hash: "e78e7bfae26303f93b1b2c538ab860950684de5e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedProducts" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>;
export const ProductResourceDocument = {
  __meta__: { hash: "c227fb7a04c0cd37b7f7802341354ebde3954f0e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProductResource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productResource" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "family" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "service_id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service_identifier" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductResourceQuery, ProductResourceQueryVariables>;
export const GetAllProductResourcesDocument = {
  __meta__: { hash: "07e5f34a2f631b68666e38353b784f6b953d296f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllProductResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllProductResources" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllProductResourcesQuery, GetAllProductResourcesQueryVariables>;
export const CatalogProductsDocument = {
  __meta__: { hash: "05f505c393ec0b29822b6fbe8603720f57349ff9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CatalogProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "distance" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DistanceInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "CommerceProductFamily" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "CatalogProductSearchBy" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "catalogProducts" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "distance" }, value: { kind: "Variable", name: { kind: "Name", value: "distance" } } },
              { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "Variable", name: { kind: "Name", value: "type" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "is_starred" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "store" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "store_id" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "distance" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "location_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "attribute" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "values" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PriceBookEntryCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CatalogProductsQuery, CatalogProductsQueryVariables>;
export const ProductServiceLocationsDocument = {
  __meta__: { hash: "f37fb6905ed1a367cee9cb109dca177be3072332" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProductServiceLocations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "distance" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DistanceInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productServiceLocations" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "distance" }, value: { kind: "Variable", name: { kind: "Name", value: "distance" } } },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "store" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "distance" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "location_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "address_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
                                        { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                        { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "product_id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "entry_id" } },
                            { kind: "Field", name: { kind: "Name", value: "unit_price" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductServiceLocationsQuery, ProductServiceLocationsQueryVariables>;
export const GetStoreProductDocument = {
  __meta__: { hash: "61d29c58d024543f6e594e66bf3b14bc087919fc" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetStoreProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "productCode" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "storeCode" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getStoreProduct" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "productCode" },
                value: { kind: "Variable", name: { kind: "Name", value: "productCode" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "storeCode" },
                value: { kind: "Variable", name: { kind: "Name", value: "storeCode" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ProductCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TagCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "attachment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "store" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PriceBookEntryCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeValuesCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AttributeValues" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "value_id" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Products" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "family" } },
          { kind: "Field", name: { kind: "Name", value: "isInCart" }, directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }] },
          {
            kind: "Field",
            name: { kind: "Name", value: "isWishListed" },
            directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Attributes" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "attribute_id" } },
          { kind: "Field", name: { kind: "Name", value: "attribute" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AttributeValuesCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TagCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tags" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "tag_id" } },
          { kind: "Field", name: { kind: "Name", value: "tag" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "icon_url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceBookEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PriceBookEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "product_code" } },
          { kind: "Field", name: { kind: "Name", value: "unit_price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetStoreProductQuery, GetStoreProductQueryVariables>;
export const DownloadDailyLabReportDocument = {
  __meta__: { hash: "6df072e7e1e1cdb8356c825131bd598394680d92" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadDailyLabReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ReportSummaryInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadDailyLabReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadDailyLabReportQuery, DownloadDailyLabReportQueryVariables>;
export const DownloadBulkOrderResultsReportDocument = {
  __meta__: { hash: "8a8da991c954bd1c824d4e5876d0521e69bda59f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadBulkOrderResultsReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BulkOrderResultsExportInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadBulkOrderResultsReport" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } },
            ],
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadBulkOrderResultsReportQuery, DownloadBulkOrderResultsReportQueryVariables>;
export const GetAllIcd10CodesDocument = {
  __meta__: { hash: "c414e58f91cdc0575daa3487ef71fe3c071cf98d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllICD10Codes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllICD10Codes" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllIcd10CodesQuery, GetAllIcd10CodesQueryVariables>;
export const GetPaginatedIcd10CodesDocument = {
  __meta__: { hash: "98cd50ef6e474c063e4d659fef5533287ee6b32d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedICD10Codes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedICD10Codes" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                      { kind: "Field", name: { kind: "Name", value: "is_starred" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedIcd10CodesQuery, GetPaginatedIcd10CodesQueryVariables>;
export const GroupedIcd10CodeListDocument = {
  __meta__: { hash: "058581e3063cc87d88da822e8c52ff08d72f1de7" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GroupedICD10CodeList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subjectPatientId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "groupSizeLimit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getGroupedICD10Codes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectPatientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subjectPatientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "groupSizeLimit" },
                value: { kind: "Variable", name: { kind: "Name", value: "groupSizeLimit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "favorites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "codes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "is_starred" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recentDiagnosis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "codes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "icd10_code" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "is_starred" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupedIcd10CodeListQuery, GroupedIcd10CodeListQueryVariables>;
export const PreviewRecurrenceScheduleDocument = {
  __meta__: { hash: "41f2c879625986af67df92fb2b7a50a1fcf0ca58" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PreviewRecurrenceSchedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recurrence" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RecurrencePatternCreateInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "count" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "previewRecurrenceSchedule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recurrence" },
                value: { kind: "Variable", name: { kind: "Name", value: "recurrence" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "dates" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewRecurrenceScheduleQuery, PreviewRecurrenceScheduleQueryVariables>;
export const PreviewRenewalWindowDocument = {
  __meta__: { hash: "863de7eccff5a6d87ba285d278a15d2aa717c47f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PreviewRenewalWindow" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patternId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "previewRenewalWindow" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patternId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patternId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewRenewalWindowQuery, PreviewRenewalWindowQueryVariables>;
export const GetHealthcareServiceDocument = {
  __meta__: { hash: "234bf7d79c4c6637a7412247ca2ab8a1aaceefc2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHealthcareService" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getHealthcareService" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "service_identifier" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHealthcareServiceQuery, GetHealthcareServiceQueryVariables>;
export const GetPaginatedHealthcareServicesDocument = {
  __meta__: { hash: "c39ae575ecc2e70a99dd2a6b99ebb322c17c95f5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedHealthcareServices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedHealthcareServices" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } },
                                  { kind: "Field", name: { kind: "Name", value: "alias" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "organization_id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "alias" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service_identifier" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServiceLocations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_location_id" } },
          { kind: "Field", name: { kind: "Name", value: "distance" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedHealthcareServicesQuery, GetPaginatedHealthcareServicesQueryVariables>;
export const GetHealthcareServiceLocationDocument = {
  __meta__: { hash: "b386768c3f45e6700c33c52e675434ac49ba1025" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHealthcareServiceLocation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getHealthcareServiceLocation" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "service" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AddressCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServiceLocations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_location_id" } },
          { kind: "Field", name: { kind: "Name", value: "distance" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "address_id" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "place_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHealthcareServiceLocationQuery, GetHealthcareServiceLocationQueryVariables>;
export const GetAllHealthcareServiceLocationsDocument = {
  __meta__: { hash: "d339beee3c8d5f080239d7195d545a35c7940cff" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllHealthcareServiceLocations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllHealthcareServiceLocations" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "service" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServiceLocations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_location_id" } },
          { kind: "Field", name: { kind: "Name", value: "distance" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllHealthcareServiceLocationsQuery, GetAllHealthcareServiceLocationsQueryVariables>;
export const GetHealthcareServiceLocationsDocument = {
  __meta__: { hash: "b7731b414398ba85da4bf6adc6b55c147efbf2f3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHealthcareServiceLocations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "distance" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DistanceInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getHealthcareServiceLocations" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "distance" }, value: { kind: "Variable", name: { kind: "Name", value: "distance" } } },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "HealthcareServiceCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AddressCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceLocationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServiceLocations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_location_id" } },
          { kind: "Field", name: { kind: "Name", value: "distance" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HealthcareServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HealthcareServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "speciality" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "address_id" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "place_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHealthcareServiceLocationsQuery, GetHealthcareServiceLocationsQueryVariables>;
export const GetDiagnosticServiceDocument = {
  __meta__: { hash: "b77321f605f5d22efbbf0b8b5c08715d1aea70a3" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDiagnosticService" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDiagnosticService" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DiagnosticServiceCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticServiceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "subtitle" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDiagnosticServiceQuery, GetDiagnosticServiceQueryVariables>;
export const DiagnosticServiceBiomarkersDocument = {
  __meta__: { hash: "9b66ed0cb118c9ea51fa7ee41b8c22b54424db05" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DiagnosticServiceBiomarkers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDiagnosticService" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DiagnosticServiceBiomarkersFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationDefinitionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationDefinitions" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "definition_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ObservationDefinitionComponentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ObservationDefinitionComponents" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "component_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DiagnosticServiceBiomarkersFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DiagnosticServices" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "service_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "biomarkers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "ObservationDefinitionCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ObservationDefinitionCoreFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "components" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ObservationDefinitionComponentCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiagnosticServiceBiomarkersQuery, DiagnosticServiceBiomarkersQueryVariables>;
export const GetLayoutSettingDocument = {
  __meta__: { hash: "38fd2207bcb7041fb29beae16520906f6ff7d50d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLayoutSetting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "applicationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLayoutSetting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "applicationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "applicationId" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "layout_setting_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "setting_id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layouts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "layout" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PageLayoutConfigurationCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutGridCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GridLayoutProperties" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "xs" } },
          { kind: "Field", name: { kind: "Name", value: "sm" } },
          { kind: "Field", name: { kind: "Name", value: "md" } },
          { kind: "Field", name: { kind: "Name", value: "lg" } },
          { kind: "Field", name: { kind: "Name", value: "xl" } },
          { kind: "Field", name: { kind: "Name", value: "xxl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LayoutPositionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LayoutPosition" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageLayoutConfigurationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ComponentLayoutConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "column" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LayoutGridCoreFragment" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "component" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "position" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LayoutPositionCoreFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "props" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLayoutSettingQuery, GetLayoutSettingQueryVariables>;
export const SignatureAuditsDocument = {
  __meta__: { hash: "c8abe4a04167e8050f9427fcec14ac412a9a985b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SignatureAudits" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "practitionerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureAudits" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "practitionerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "practitionerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "auditId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdBy" } },
                { kind: "Field", name: { kind: "Name", value: "actorCynergyId" } },
                { kind: "Field", name: { kind: "Name", value: "cynergyId" } },
                { kind: "Field", name: { kind: "Name", value: "referenceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SignatureAuditsQuery, SignatureAuditsQueryVariables>;
export const SiteCategoriesDocument = {
  __meta__: { hash: "6f1e36cff7c92cc2911f1f4a5b74b65307e5bcae" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SiteCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "catalogCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "definition_id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteCategoriesQuery, SiteCategoriesQueryVariables>;
export const GetTaskCountDocument = {
  __meta__: { hash: "04625e415e926455bec53bf5ac238197702de22d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTaskCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTaskCount" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskCountQuery, GetTaskCountQueryVariables>;
export const GetTaskStatisticsDocument = {
  __meta__: { hash: "537695201c39885167e7528f67b80a9f12015743" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTaskStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTaskStatistics" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                { kind: "Field", name: { kind: "Name", value: "new_tasks" } },
                { kind: "Field", name: { kind: "Name", value: "open_tasks" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled_tasks" } },
                { kind: "Field", name: { kind: "Name", value: "completed_tasks" } },
                { kind: "Field", name: { kind: "Name", value: "completion_percentage" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>;
export const GetTaskDocument = {
  __meta__: { hash: "7d9edc092c54b83530b62e08d131423005e08005" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTask" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TaskCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requested_period" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "start" } },
                      { kind: "Field", name: { kind: "Name", value: "end" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "steps" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "TaskStepCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "focus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ResourceReferenceCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identifier" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "based_on" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ResourceReferenceCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requested_period" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "period_id" } },
                      { kind: "Field", name: { kind: "Name", value: "start" } },
                      { kind: "Field", name: { kind: "Name", value: "end" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskStepCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TaskSteps" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "step_id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "References" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskQuery, GetTaskQueryVariables>;
export const GetAllTasksDocument = {
  __meta__: { hash: "c4d55e29788e112a1acb8c0eefc988e717847a82" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllTasks" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TaskCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requested_period" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "start" } },
                      { kind: "Field", name: { kind: "Name", value: "end" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "demographics" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "employee" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "StaffCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "demographics" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                              { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "based_on" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ResourceReferenceCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requested_period" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "period_id" } },
                      { kind: "Field", name: { kind: "Name", value: "start" } },
                      { kind: "Field", name: { kind: "Name", value: "end" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Staffs" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "References" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllTasksQuery, GetAllTasksQueryVariables>;
export const GetPaginatedTasksDocument = {
  __meta__: { hash: "f6b56365da4eafd14c0b55540ffa8d15c8b76898" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaginatedTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedTasks" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "TaskCoreFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requested_period" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "start" } },
                            { kind: "Field", name: { kind: "Name", value: "end" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "patient_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "UserCoreFragmentAlt" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "demographics" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assignee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "employee" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "staff_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "user_id" } },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "demographics" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                                                    { kind: "Field", name: { kind: "Name", value: "full_name" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "based_on" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ResourceReferenceCoreFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identifier" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IdentifierCoreFragment" } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requested_period" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "period_id" } },
                            { kind: "Field", name: { kind: "Name", value: "start" } },
                            { kind: "Field", name: { kind: "Name", value: "end" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Tasks" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "task_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "business_status" } },
          { kind: "Field", name: { kind: "Name", value: "status_reason" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "link" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "do_not_perform" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_function" } },
          { kind: "Field", name: { kind: "Name", value: "assignee_role" } },
          { kind: "Field", name: { kind: "Name", value: "last_modified" } },
          { kind: "Field", name: { kind: "Name", value: "started_at" } },
          { kind: "Field", name: { kind: "Name", value: "completed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Users" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "user_id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PractitionerAssignmentCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StaffAssignments" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
          { kind: "Field", name: { kind: "Name", value: "staff_id" } },
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "hire_date" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "References" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentifierCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identifiers" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "identifier_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "use" } },
          { kind: "Field", name: { kind: "Name", value: "system" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaginatedTasksQuery, GetPaginatedTasksQueryVariables>;
export const GetUserTestHistoryNonReportingDocument = {
  __meta__: { hash: "4fde77c32de1a9f0b39a581577c39225a51010e4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserTestHistoryNonReporting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "testCode" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserTestHistoryNonReporting" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "testCode" }, value: { kind: "Variable", name: { kind: "Name", value: "testCode" } } },
              { kind: "Argument", name: { kind: "Name", value: "userId" }, value: { kind: "Variable", name: { kind: "Name", value: "userId" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "observation_id" } },
                { kind: "Field", name: { kind: "Name", value: "test_name" } },
                { kind: "Field", name: { kind: "Name", value: "test_code" } },
                { kind: "Field", name: { kind: "Name", value: "flag" } },
                { kind: "Field", name: { kind: "Name", value: "result_value" } },
                { kind: "Field", name: { kind: "Name", value: "result_created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserTestHistoryNonReportingQuery, GetUserTestHistoryNonReportingQueryVariables>;
export const UserTimelineDocument = {
  __meta__: { hash: "e952a007bfd58985a1d54c2a792e1e8de3ce5029" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserTimeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userTimeline" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserTimelineFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserTimelineFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TimelineEntry" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "resource" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "extras" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "meta" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserTimelineQuery, UserTimelineQueryVariables>;
export const GetFeedItemsDocument = {
  __meta__: { hash: "6861d6d16d4e912629e6b4974043cfae6ca47739" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFeedItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "parameters" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FeedElementSearchArgs" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaginatedFeedItems" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "parameters" },
                value: { kind: "Variable", name: { kind: "Name", value: "parameters" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "currentPage" } },
                { kind: "Field", name: { kind: "Name", value: "totalPages" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "elements" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "FeedItemFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "actor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FeedActorObjectFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "header" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodyObjectFragment" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "messageSegments" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentTextFragment" } }],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentLinkObject" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", alias: { kind: "Name", value: "linkUrl" }, name: { kind: "Name", value: "url" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" } }],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "body" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodyObjectFragment" } },
                            { kind: "FragmentSpread", name: { kind: "Name", value: "MessageBodySegmentFragment" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capabilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bundle" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "FeedBundleCapabilityFragment" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeBundleCapabilityObject" } },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "changes" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TrackedChangeItemFragment" } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentTextFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "altText" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "htmlTag" } },
          { kind: "Field", name: { kind: "Name", value: "markupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "elementType" } },
          { kind: "Field", name: { kind: "Name", value: "publishDate" } },
          { kind: "Field", name: { kind: "Name", value: "relativePublishedDate" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedActorObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedActorObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodyObjectFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "isRichText" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MessageBodySegmentFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageBodyObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "messageSegments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentTextObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentTextFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentLinkObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", alias: { kind: "Name", value: "linkUrl" }, name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupBeginObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupBeginFragment" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageSegmentMarkupEndObject" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MessageSegmentMarkupEndFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeedBundleCapabilityFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeedBundleCapabilityObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "bundleType" } },
          { kind: "Field", name: { kind: "Name", value: "totalElements" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackedChangeItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrackedChangeItemObject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "fieldName" } },
          { kind: "Field", name: { kind: "Name", value: "newValue" } },
          { kind: "Field", name: { kind: "Name", value: "oldValue" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeedItemsQuery, GetFeedItemsQueryVariables>;
export const UserSessionDocument = {
  __meta__: { hash: "fbf0e816e376d8ae631d05a792ea25cd3c8220d4" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserSession" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "UserSession" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "session" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "cynergyId" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                      { kind: "Field", name: { kind: "Name", value: "roleId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "staffRelationId" } },
                      { kind: "Field", name: { kind: "Name", value: "organizationId" } },
                      { kind: "Field", name: { kind: "Name", value: "locationId" } },
                      { kind: "Field", name: { kind: "Name", value: "locationName" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availableLocations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "assignment_id" } },
                            { kind: "Field", name: { kind: "Name", value: "location_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alias" } }] },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "userType" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "authnetProfileId" } },
                      { kind: "Field", name: { kind: "Name", value: "practitionerId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "paymentProfiles" },
                        directives: [{ kind: "Directive", name: { kind: "Name", value: "client" } }],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaymentProfileCoreFragment" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                            { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip" } },
                            { kind: "Field", name: { kind: "Name", value: "formattedAddress" } },
                            { kind: "Field", name: { kind: "Name", value: "placeId" } },
                            { kind: "Field", name: { kind: "Name", value: "isDefault" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "defaultPage" } },
                      { kind: "Field", name: { kind: "Name", value: "firstLogin" } },
                      { kind: "Field", name: { kind: "Name", value: "twoFactorEnabled" } },
                      { kind: "Field", name: { kind: "Name", value: "twoFactorMethod" } },
                      { kind: "Field", name: { kind: "Name", value: "photo" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentProfileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "profile_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "user_id" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "authnet_payment_profile_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "card_type" } },
          { kind: "Field", name: { kind: "Name", value: "last_four_of_card" } },
          { kind: "Field", name: { kind: "Name", value: "billing_address" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "expiration" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "is_active" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSessionQuery, UserSessionQueryVariables>;
export const UserSessionIpDocument = {
  __meta__: { hash: "7a2cedcbd4d16ce7387705fe1c530800e1710102" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserSessionIP" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "UserSessionIP" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "region" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "zip" } },
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lng" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSessionIpQuery, UserSessionIpQueryVariables>;
export const GetUserDemographicsDocument = {
  __meta__: { hash: "fda87cc629ba19b3530c4ce6c19da134ec1780e0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserDemographics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserDemographics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DemographicsCoreFragmentAlt" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DemographicsCoreFragmentAlt" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Demographics" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "full_name" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "prefix" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } },
          { kind: "Field", name: { kind: "Name", value: "middle_name" } },
          { kind: "Field", name: { kind: "Name", value: "age" } },
          { kind: "Field", name: { kind: "Name", value: "deceased" } },
          { kind: "Field", name: { kind: "Name", value: "dob" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
          { kind: "Field", name: { kind: "Name", value: "marital_status" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          { kind: "Field", name: { kind: "Name", value: "race" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserDemographicsQuery, GetUserDemographicsQueryVariables>;
export const UserEventsDocument = {
  __meta__: { hash: "a1441c250d029e9108d71446136897a386704ac9" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserEvents" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllUserEvents" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserEventsCoreFragment" } }] },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserEventsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "UserEventData" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "link" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserEventsQuery, UserEventsQueryVariables>;
export const GetUserDuplicatesDocument = {
  __meta__: { hash: "504626e9d0eb569529cb966b6780a25491a2dc54" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserDuplicates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCynergyUser" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "cynergy_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "potential_duplicates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "entry_id" } },
                      { kind: "Field", name: { kind: "Name", value: "record_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserDuplicatesQuery, GetUserDuplicatesQueryVariables>;
export const PaymentProfilesDocument = {
  __meta__: { hash: "36f3fb30ab546762fab1845cfd75b483d4ce3d46" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PaymentProfiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortingArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaginationArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllPaymentProfiles" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "Variable", name: { kind: "Name", value: "sort" } } },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaymentProfileCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentProfileCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PaymentProfiles" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "profile_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "user_id" } }] },
          },
          { kind: "Field", name: { kind: "Name", value: "authnet_payment_profile_id" } },
          { kind: "Field", name: { kind: "Name", value: "first_name" } },
          { kind: "Field", name: { kind: "Name", value: "last_name" } },
          { kind: "Field", name: { kind: "Name", value: "card_type" } },
          { kind: "Field", name: { kind: "Name", value: "last_four_of_card" } },
          { kind: "Field", name: { kind: "Name", value: "billing_address" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "expiration" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "is_active" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentProfilesQuery, PaymentProfilesQueryVariables>;
export const UserCollectionDocument = {
  __meta__: { hash: "28078a576d533de8c441d9c961c980f8ab408748" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "QueryOptionsInputType" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserCollection" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
              { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "UserCollectionCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionEntryCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserCollectionCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Collections" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "collection_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCollectionQuery, UserCollectionQueryVariables>;
export const UserCollectionEntriesDocument = {
  __meta__: { hash: "1f1b7e2d0bebea570e40d586899deb9ca2aff878" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserCollectionEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCollectionEntries" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "CollectionEntryCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ResourceReferenceCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEntryCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionEntries" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "entry_id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceReferenceCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "References" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "reference_id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "display" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCollectionEntriesQuery, UserCollectionEntriesQueryVariables>;
export const NewNotificationDocument = {
  __meta__: { hash: "e89eab88aa6a44a7d1883ec9d0c8da7f4b93d7cc" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "NewNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "topics" } },
          type: {
            kind: "NonNullType",
            type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "newNotification" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "topics" }, value: { kind: "Variable", name: { kind: "Name", value: "topics" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewNotificationSubscription, NewNotificationSubscriptionVariables>;
export const NotificationSubscriptionsDocument = {
  __meta__: { hash: "610288b150236f4b98ef8f4709e16e051b949455" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "NotificationSubscriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cynergyId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notificationSubscriptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cynergyId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cynergyId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NotificationCoreFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Notifications" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "is_read" } },
          { kind: "Field", name: { kind: "Name", value: "notification_id" } },
          { kind: "Field", name: { kind: "Name", value: "notification_title" } },
          { kind: "Field", name: { kind: "Name", value: "notification_body" } },
          { kind: "Field", name: { kind: "Name", value: "notification_data" } },
          { kind: "Field", name: { kind: "Name", value: "notification_category" } },
          { kind: "Field", name: { kind: "Name", value: "notification_link" } },
          { kind: "Field", name: { kind: "Name", value: "link_label" } },
          { kind: "Field", name: { kind: "Name", value: "notification_priority" } },
          { kind: "Field", name: { kind: "Name", value: "from_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_cynergy_id" } },
          { kind: "Field", name: { kind: "Name", value: "ref_id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationSubscriptionsSubscription, NotificationSubscriptionsSubscriptionVariables>;
export const TimelineSubscriptionDocument = {
  __meta__: { hash: "d71bd4d49f6c567c476dcae56b3f241ffbfc5464" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "TimelineSubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cynergyId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "locationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timelineSubscription" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cynergyId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cynergyId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "locationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserTimelineFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserTimelineFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TimelineEntry" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "resource" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "extras" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "meta" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimelineSubscriptionSubscription, TimelineSubscriptionSubscriptionVariables>;
export const ServiceLocationDocument = {
  __meta__: { hash: "6b27c74fce040f7fae0705c5e548cc71a4b5ac0e" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ServiceLocation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "searchBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchByArgs" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLocation" },
            arguments: [
              { kind: "Argument", name: { kind: "Name", value: "searchBy" }, value: { kind: "Variable", name: { kind: "Name", value: "searchBy" } } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "LocationsCoreFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preferred_timeslots" },
                  selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "weekday_text" } }] },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "AddressCoreFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Locations" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "location_id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferred_member" } },
          { kind: "Field", name: { kind: "Name", value: "organization_id" } },
          { kind: "Field", name: { kind: "Name", value: "todays_operating_hours" } },
          { kind: "Field", name: { kind: "Name", value: "open_now" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "meta_data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "location_role" } },
          { kind: "Field", name: { kind: "Name", value: "location_status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressCoreFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebCynergyAddresses" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "address_id" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_1" } },
          { kind: "Field", name: { kind: "Name", value: "address_line_2" } },
          { kind: "Field", name: { kind: "Name", value: "nickname" } },
          { kind: "Field", name: { kind: "Name", value: "formatted_address" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "is_default" } },
          { kind: "Field", name: { kind: "Name", value: "place_id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceLocationQuery, ServiceLocationQueryVariables>;
